export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type ComparisonsBlockFragmentFragment = { __typename?: 'Comparisons', showLeftContent?: boolean | null, leftContent?: any | null, secondaryComparison?: any | null, primaryComparison?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null };

export type CtaBlockFragmentFragment = { __typename?: 'Cta', title?: string | null, id?: string | null, blockName?: string | null, blockType?: string | null, ctaContent?: string | null, button?: { __typename?: 'Cta_Button', buttonType?: Cta_Button_ButtonType | null, link?: { __typename?: 'Link', type?: Link_Type | null, label?: string | null, url?: string | null, reference?: { __typename?: 'Link_Reference_Relationship', relationTo?: Link_Reference_RelationTo | null, value?: { __typename?: 'Article', slug?: string | null, categories?: Array<{ __typename?: 'Category', slug?: string | null }> | null } | { __typename?: 'LeadForm', slug?: string | null } | { __typename?: 'Page', slug?: string | null } | { __typename?: 'Service', slug?: string | null } | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null };

export type CtaButtonBlockFragmentFragment = { __typename?: 'CtaButton', buttonType?: CtaButton_ButtonType | null, content?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, link?: { __typename?: 'Link', type?: Link_Type | null, label?: string | null, url?: string | null, reference?: { __typename?: 'Link_Reference_Relationship', relationTo?: Link_Reference_RelationTo | null, value?: { __typename?: 'Article', slug?: string | null, categories?: Array<{ __typename?: 'Category', slug?: string | null }> | null } | { __typename?: 'LeadForm', slug?: string | null } | { __typename?: 'Page', slug?: string | null } | { __typename?: 'Service', slug?: string | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null };

export type LeadFormBlockFragmentFragment = { __typename?: 'LeadFormBlock', id?: string | null, blockName?: string | null, blockType?: string | null, leadForm?: { __typename?: 'LeadForm', id: string, slug?: string | null } | null };

export type SpacerBlockFragmentFragment = { __typename?: 'Spacer', height?: number | null, id?: string | null, blockName?: string | null, blockType?: string | null };

export type StickyImageScrollBlockFragmentFragment = { __typename?: 'StickyImageScroll', id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, items?: Array<{ __typename?: 'StickyImageScroll_Items', content?: any | null, showImageNode?: boolean | null, imageNode?: { __typename?: 'StickyImageScroll_Items_ImageNode', x?: number | null, y?: number | null, icon?: string | null } | null }> | null };

export type AnimatedTextBlockFragmentFragment = { __typename?: 'AnimatedTextBlock', text?: string | null, value?: number | null, id?: string | null, blockName?: string | null, blockType?: string | null };

export type ArticlesScrollerBlockFragmentFragment = { __typename?: 'ArticlesScroller', method?: ArticlesScroller_Method | null, id?: string | null, blockName?: string | null, blockType?: string | null, categories?: Array<{ __typename?: 'Category', id: string }> | null, tags?: Array<{ __typename?: 'Tag', id: string }> | null, articles?: Array<{ __typename?: 'Article', id: string, slug?: string | null }> | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null };

export type BackgroundWithBlockFragmentFragment = { __typename?: 'BackgroundWithBlock', backgroundColor?: BackgroundWithBlock_BackgroundColor | null, containerWidth?: BackgroundWithBlock_ContainerWidth | null, hasBackgroundGridImage?: boolean | null, showBackgroundImage?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, backgroundWithBlocks?: Array<{ __typename?: 'Columns', id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, settings?: { __typename?: 'Columns_Settings', verticalAlignment?: Columns_Settings_VerticalAlignment | null, columnGapSize?: Columns_Settings_ColumnGapSize | null, flipOnMobile?: boolean | null } | null, columns?: Array<{ __typename?: 'Columns_Columns', id?: string | null, columnWidth?: Columns_Columns_ColumnWidth | null, blocks?: Array<{ __typename?: 'AnimatedTextBlock', text?: string | null, value?: number | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'CardWithBlocks', color?: CardWithBlocks_Color | null, hasBorder?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, blocks?: Array<{ __typename?: 'Content', content?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'FormBlock', id?: string | null, blockName?: string | null, blockType?: string | null, form?: { __typename?: 'Form', id: string, title: string, submitButtonLabel?: string | null, confirmationType?: Form_ConfirmationType | null, confirmationMessage?: any | null, updatedAt?: any | null, createdAt?: any | null, fields?: Array<{ __typename?: 'Checkbox', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueBoolean?: boolean | null } | { __typename?: 'Email', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Message', message?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Number', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueNumber?: number | null } | { __typename?: 'Select', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Select_Options', label?: string | null, value?: string | null, id?: string | null }> | null } | { __typename?: 'Text', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Textarea', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Toggle', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Toggle_Options', label?: string | null, value?: string | null, id?: string | null }> | null }> | null, redirect?: { __typename?: 'Form_Redirect', url?: string | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Image', caption?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, imageSize?: Image_ImageSize | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Lists', id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, list?: Array<{ __typename?: 'Lists_List', color?: Lists_List_Color | null, title?: string | null, id?: string | null, items?: Array<{ __typename?: 'Lists_List_Items', id?: string | null, content?: string | null }> | null }> | null }> | null } | { __typename?: 'Content', content?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Faq', id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, faqs?: Array<{ __typename?: 'Faq_Faqs', id?: string | null, question?: string | null, answer?: any | null }> | null } | { __typename?: 'FormBlock', id?: string | null, blockName?: string | null, blockType?: string | null, form?: { __typename?: 'Form', id: string, title: string, submitButtonLabel?: string | null, confirmationType?: Form_ConfirmationType | null, confirmationMessage?: any | null, updatedAt?: any | null, createdAt?: any | null, fields?: Array<{ __typename?: 'Checkbox', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueBoolean?: boolean | null } | { __typename?: 'Email', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Message', message?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Number', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueNumber?: number | null } | { __typename?: 'Select', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Select_Options', label?: string | null, value?: string | null, id?: string | null }> | null } | { __typename?: 'Text', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Textarea', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Toggle', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Toggle_Options', label?: string | null, value?: string | null, id?: string | null }> | null }> | null, redirect?: { __typename?: 'Form_Redirect', url?: string | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Image', caption?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, imageSize?: Image_ImageSize | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'SliderWithBlocks', type?: SliderWithBlocks_Type | null, paginationType?: SliderWithBlocks_PaginationType | null, autoScrollEnabled?: boolean | null, autoScrollSpeed?: number | null, id?: string | null, blockName?: string | null, blockType?: string | null, slidesToShow?: { __typename?: 'SliderWithBlocks_SlidesToShow', desktop?: number | null, tablet?: number | null, mobile?: number | null } | null, sliderWithBlocks: Array<{ __typename?: 'CardWithBlocks', color?: CardWithBlocks_Color | null, hasBorder?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, blocks?: Array<{ __typename?: 'Content', content?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'FormBlock', id?: string | null, blockName?: string | null, blockType?: string | null, form?: { __typename?: 'Form', id: string, title: string, submitButtonLabel?: string | null, confirmationType?: Form_ConfirmationType | null, confirmationMessage?: any | null, updatedAt?: any | null, createdAt?: any | null, fields?: Array<{ __typename?: 'Checkbox', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueBoolean?: boolean | null } | { __typename?: 'Email', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Message', message?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Number', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueNumber?: number | null } | { __typename?: 'Select', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Select_Options', label?: string | null, value?: string | null, id?: string | null }> | null } | { __typename?: 'Text', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Textarea', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Toggle', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Toggle_Options', label?: string | null, value?: string | null, id?: string | null }> | null }> | null, redirect?: { __typename?: 'Form_Redirect', url?: string | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Image', caption?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, imageSize?: Image_ImageSize | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Lists', id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, list?: Array<{ __typename?: 'Lists_List', color?: Lists_List_Color | null, title?: string | null, id?: string | null, items?: Array<{ __typename?: 'Lists_List_Items', id?: string | null, content?: string | null }> | null }> | null }> | null } | { __typename?: 'Content', content?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Image', caption?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, imageSize?: Image_ImageSize | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null }> } | { __typename?: 'Spacer', height?: number | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'VerticalSlider', autoScrollEnabled?: boolean | null, autoScrollSpeed?: number | null, id?: string | null, blockName?: string | null, blockType?: string | null, slides: Array<{ __typename?: 'CardWithBlocks', color?: CardWithBlocks_Color | null, hasBorder?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, blocks?: Array<{ __typename?: 'Content', content?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'FormBlock', id?: string | null, blockName?: string | null, blockType?: string | null, form?: { __typename?: 'Form', id: string, title: string, submitButtonLabel?: string | null, confirmationType?: Form_ConfirmationType | null, confirmationMessage?: any | null, updatedAt?: any | null, createdAt?: any | null, fields?: Array<{ __typename?: 'Checkbox', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueBoolean?: boolean | null } | { __typename?: 'Email', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Message', message?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Number', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueNumber?: number | null } | { __typename?: 'Select', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Select_Options', label?: string | null, value?: string | null, id?: string | null }> | null } | { __typename?: 'Text', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Textarea', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Toggle', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Toggle_Options', label?: string | null, value?: string | null, id?: string | null }> | null }> | null, redirect?: { __typename?: 'Form_Redirect', url?: string | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Image', caption?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, imageSize?: Image_ImageSize | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Lists', id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, list?: Array<{ __typename?: 'Lists_List', color?: Lists_List_Color | null, title?: string | null, id?: string | null, items?: Array<{ __typename?: 'Lists_List_Items', id?: string | null, content?: string | null }> | null }> | null }> | null }>, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null }> | null }> | null } | { __typename?: 'Content', content?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'ServicesScroller', id?: string | null, blockName?: string | null, blockType?: string | null, serviceScrollerMethod?: ServicesScroller_Method | null, services?: Array<{ __typename?: 'Service', id: string, slug?: string | null }> | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'SliderWithBlocks', type?: SliderWithBlocks_Type | null, paginationType?: SliderWithBlocks_PaginationType | null, autoScrollEnabled?: boolean | null, autoScrollSpeed?: number | null, id?: string | null, blockName?: string | null, blockType?: string | null, slidesToShow?: { __typename?: 'SliderWithBlocks_SlidesToShow', desktop?: number | null, tablet?: number | null, mobile?: number | null } | null, sliderWithBlocks: Array<{ __typename?: 'CardWithBlocks', color?: CardWithBlocks_Color | null, hasBorder?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, blocks?: Array<{ __typename?: 'Content', content?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'FormBlock', id?: string | null, blockName?: string | null, blockType?: string | null, form?: { __typename?: 'Form', id: string, title: string, submitButtonLabel?: string | null, confirmationType?: Form_ConfirmationType | null, confirmationMessage?: any | null, updatedAt?: any | null, createdAt?: any | null, fields?: Array<{ __typename?: 'Checkbox', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueBoolean?: boolean | null } | { __typename?: 'Email', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Message', message?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Number', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueNumber?: number | null } | { __typename?: 'Select', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Select_Options', label?: string | null, value?: string | null, id?: string | null }> | null } | { __typename?: 'Text', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Textarea', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Toggle', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Toggle_Options', label?: string | null, value?: string | null, id?: string | null }> | null }> | null, redirect?: { __typename?: 'Form_Redirect', url?: string | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Image', caption?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, imageSize?: Image_ImageSize | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Lists', id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, list?: Array<{ __typename?: 'Lists_List', color?: Lists_List_Color | null, title?: string | null, id?: string | null, items?: Array<{ __typename?: 'Lists_List_Items', id?: string | null, content?: string | null }> | null }> | null }> | null } | { __typename?: 'Content', content?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Image', caption?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, imageSize?: Image_ImageSize | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null }> }> | null, backgroundImage?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null };

export type CardWithBlocksFragmentFragment = { __typename?: 'CardWithBlocks', color?: CardWithBlocks_Color | null, hasBorder?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, blocks?: Array<{ __typename?: 'Content', content?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'FormBlock', id?: string | null, blockName?: string | null, blockType?: string | null, form?: { __typename?: 'Form', id: string, title: string, submitButtonLabel?: string | null, confirmationType?: Form_ConfirmationType | null, confirmationMessage?: any | null, updatedAt?: any | null, createdAt?: any | null, fields?: Array<{ __typename?: 'Checkbox', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueBoolean?: boolean | null } | { __typename?: 'Email', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Message', message?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Number', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueNumber?: number | null } | { __typename?: 'Select', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Select_Options', label?: string | null, value?: string | null, id?: string | null }> | null } | { __typename?: 'Text', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Textarea', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Toggle', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Toggle_Options', label?: string | null, value?: string | null, id?: string | null }> | null }> | null, redirect?: { __typename?: 'Form_Redirect', url?: string | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Image', caption?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, imageSize?: Image_ImageSize | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Lists', id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, list?: Array<{ __typename?: 'Lists_List', color?: Lists_List_Color | null, title?: string | null, id?: string | null, items?: Array<{ __typename?: 'Lists_List_Items', id?: string | null, content?: string | null }> | null }> | null }> | null };

export type ColumnsBlockFragmentFragment = { __typename?: 'Columns', id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, settings?: { __typename?: 'Columns_Settings', verticalAlignment?: Columns_Settings_VerticalAlignment | null, columnGapSize?: Columns_Settings_ColumnGapSize | null, flipOnMobile?: boolean | null } | null, columns?: Array<{ __typename?: 'Columns_Columns', id?: string | null, columnWidth?: Columns_Columns_ColumnWidth | null, blocks?: Array<{ __typename?: 'AnimatedTextBlock', text?: string | null, value?: number | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'CardWithBlocks', color?: CardWithBlocks_Color | null, hasBorder?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, blocks?: Array<{ __typename?: 'Content', content?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'FormBlock', id?: string | null, blockName?: string | null, blockType?: string | null, form?: { __typename?: 'Form', id: string, title: string, submitButtonLabel?: string | null, confirmationType?: Form_ConfirmationType | null, confirmationMessage?: any | null, updatedAt?: any | null, createdAt?: any | null, fields?: Array<{ __typename?: 'Checkbox', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueBoolean?: boolean | null } | { __typename?: 'Email', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Message', message?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Number', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueNumber?: number | null } | { __typename?: 'Select', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Select_Options', label?: string | null, value?: string | null, id?: string | null }> | null } | { __typename?: 'Text', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Textarea', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Toggle', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Toggle_Options', label?: string | null, value?: string | null, id?: string | null }> | null }> | null, redirect?: { __typename?: 'Form_Redirect', url?: string | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Image', caption?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, imageSize?: Image_ImageSize | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Lists', id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, list?: Array<{ __typename?: 'Lists_List', color?: Lists_List_Color | null, title?: string | null, id?: string | null, items?: Array<{ __typename?: 'Lists_List_Items', id?: string | null, content?: string | null }> | null }> | null }> | null } | { __typename?: 'Content', content?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Faq', id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, faqs?: Array<{ __typename?: 'Faq_Faqs', id?: string | null, question?: string | null, answer?: any | null }> | null } | { __typename?: 'FormBlock', id?: string | null, blockName?: string | null, blockType?: string | null, form?: { __typename?: 'Form', id: string, title: string, submitButtonLabel?: string | null, confirmationType?: Form_ConfirmationType | null, confirmationMessage?: any | null, updatedAt?: any | null, createdAt?: any | null, fields?: Array<{ __typename?: 'Checkbox', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueBoolean?: boolean | null } | { __typename?: 'Email', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Message', message?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Number', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueNumber?: number | null } | { __typename?: 'Select', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Select_Options', label?: string | null, value?: string | null, id?: string | null }> | null } | { __typename?: 'Text', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Textarea', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Toggle', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Toggle_Options', label?: string | null, value?: string | null, id?: string | null }> | null }> | null, redirect?: { __typename?: 'Form_Redirect', url?: string | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Image', caption?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, imageSize?: Image_ImageSize | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'SliderWithBlocks', type?: SliderWithBlocks_Type | null, paginationType?: SliderWithBlocks_PaginationType | null, autoScrollEnabled?: boolean | null, autoScrollSpeed?: number | null, id?: string | null, blockName?: string | null, blockType?: string | null, slidesToShow?: { __typename?: 'SliderWithBlocks_SlidesToShow', desktop?: number | null, tablet?: number | null, mobile?: number | null } | null, sliderWithBlocks: Array<{ __typename?: 'CardWithBlocks', color?: CardWithBlocks_Color | null, hasBorder?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, blocks?: Array<{ __typename?: 'Content', content?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'FormBlock', id?: string | null, blockName?: string | null, blockType?: string | null, form?: { __typename?: 'Form', id: string, title: string, submitButtonLabel?: string | null, confirmationType?: Form_ConfirmationType | null, confirmationMessage?: any | null, updatedAt?: any | null, createdAt?: any | null, fields?: Array<{ __typename?: 'Checkbox', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueBoolean?: boolean | null } | { __typename?: 'Email', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Message', message?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Number', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueNumber?: number | null } | { __typename?: 'Select', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Select_Options', label?: string | null, value?: string | null, id?: string | null }> | null } | { __typename?: 'Text', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Textarea', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Toggle', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Toggle_Options', label?: string | null, value?: string | null, id?: string | null }> | null }> | null, redirect?: { __typename?: 'Form_Redirect', url?: string | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Image', caption?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, imageSize?: Image_ImageSize | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Lists', id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, list?: Array<{ __typename?: 'Lists_List', color?: Lists_List_Color | null, title?: string | null, id?: string | null, items?: Array<{ __typename?: 'Lists_List_Items', id?: string | null, content?: string | null }> | null }> | null }> | null } | { __typename?: 'Content', content?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Image', caption?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, imageSize?: Image_ImageSize | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null }> } | { __typename?: 'Spacer', height?: number | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'VerticalSlider', autoScrollEnabled?: boolean | null, autoScrollSpeed?: number | null, id?: string | null, blockName?: string | null, blockType?: string | null, slides: Array<{ __typename?: 'CardWithBlocks', color?: CardWithBlocks_Color | null, hasBorder?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, blocks?: Array<{ __typename?: 'Content', content?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'FormBlock', id?: string | null, blockName?: string | null, blockType?: string | null, form?: { __typename?: 'Form', id: string, title: string, submitButtonLabel?: string | null, confirmationType?: Form_ConfirmationType | null, confirmationMessage?: any | null, updatedAt?: any | null, createdAt?: any | null, fields?: Array<{ __typename?: 'Checkbox', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueBoolean?: boolean | null } | { __typename?: 'Email', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Message', message?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Number', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueNumber?: number | null } | { __typename?: 'Select', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Select_Options', label?: string | null, value?: string | null, id?: string | null }> | null } | { __typename?: 'Text', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Textarea', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Toggle', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Toggle_Options', label?: string | null, value?: string | null, id?: string | null }> | null }> | null, redirect?: { __typename?: 'Form_Redirect', url?: string | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Image', caption?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, imageSize?: Image_ImageSize | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Lists', id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, list?: Array<{ __typename?: 'Lists_List', color?: Lists_List_Color | null, title?: string | null, id?: string | null, items?: Array<{ __typename?: 'Lists_List_Items', id?: string | null, content?: string | null }> | null }> | null }> | null }>, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null }> | null }> | null };

export type ContentBlockFragmentFragment = { __typename?: 'Content', content?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null };

export type FaqBlockFragmentFragment = { __typename?: 'Faq', id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, faqs?: Array<{ __typename?: 'Faq_Faqs', id?: string | null, question?: string | null, answer?: any | null }> | null };

export type FormBlockFragmentFragment = { __typename?: 'FormBlock', id?: string | null, blockName?: string | null, blockType?: string | null, form?: { __typename?: 'Form', id: string, title: string, submitButtonLabel?: string | null, confirmationType?: Form_ConfirmationType | null, confirmationMessage?: any | null, updatedAt?: any | null, createdAt?: any | null, fields?: Array<{ __typename?: 'Checkbox', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueBoolean?: boolean | null } | { __typename?: 'Email', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Message', message?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Number', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueNumber?: number | null } | { __typename?: 'Select', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Select_Options', label?: string | null, value?: string | null, id?: string | null }> | null } | { __typename?: 'Text', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Textarea', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Toggle', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Toggle_Options', label?: string | null, value?: string | null, id?: string | null }> | null }> | null, redirect?: { __typename?: 'Form_Redirect', url?: string | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null };

export type ImageBlockFragmentFragment = { __typename?: 'Image', caption?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, imageSize?: Image_ImageSize | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null };

export type ListsBlockFragmentFragment = { __typename?: 'Lists', id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, list?: Array<{ __typename?: 'Lists_List', color?: Lists_List_Color | null, title?: string | null, id?: string | null, items?: Array<{ __typename?: 'Lists_List_Items', id?: string | null, content?: string | null }> | null }> | null };

export type ServicesScrollerBlockFragmentFragment = { __typename?: 'ServicesScroller', id?: string | null, blockName?: string | null, blockType?: string | null, serviceScrollerMethod?: ServicesScroller_Method | null, services?: Array<{ __typename?: 'Service', id: string, slug?: string | null }> | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null };

export type SliderWithBlocksFragmentFragment = { __typename?: 'SliderWithBlocks', type?: SliderWithBlocks_Type | null, paginationType?: SliderWithBlocks_PaginationType | null, autoScrollEnabled?: boolean | null, autoScrollSpeed?: number | null, id?: string | null, blockName?: string | null, blockType?: string | null, slidesToShow?: { __typename?: 'SliderWithBlocks_SlidesToShow', desktop?: number | null, tablet?: number | null, mobile?: number | null } | null, sliderWithBlocks: Array<{ __typename?: 'CardWithBlocks', color?: CardWithBlocks_Color | null, hasBorder?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, blocks?: Array<{ __typename?: 'Content', content?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'FormBlock', id?: string | null, blockName?: string | null, blockType?: string | null, form?: { __typename?: 'Form', id: string, title: string, submitButtonLabel?: string | null, confirmationType?: Form_ConfirmationType | null, confirmationMessage?: any | null, updatedAt?: any | null, createdAt?: any | null, fields?: Array<{ __typename?: 'Checkbox', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueBoolean?: boolean | null } | { __typename?: 'Email', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Message', message?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Number', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueNumber?: number | null } | { __typename?: 'Select', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Select_Options', label?: string | null, value?: string | null, id?: string | null }> | null } | { __typename?: 'Text', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Textarea', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Toggle', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Toggle_Options', label?: string | null, value?: string | null, id?: string | null }> | null }> | null, redirect?: { __typename?: 'Form_Redirect', url?: string | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Image', caption?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, imageSize?: Image_ImageSize | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Lists', id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, list?: Array<{ __typename?: 'Lists_List', color?: Lists_List_Color | null, title?: string | null, id?: string | null, items?: Array<{ __typename?: 'Lists_List_Items', id?: string | null, content?: string | null }> | null }> | null }> | null } | { __typename?: 'Content', content?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Image', caption?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, imageSize?: Image_ImageSize | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null }> };

export type VerticalSliderBlockFragmentFragment = { __typename?: 'VerticalSlider', autoScrollEnabled?: boolean | null, autoScrollSpeed?: number | null, id?: string | null, blockName?: string | null, blockType?: string | null, slides: Array<{ __typename?: 'CardWithBlocks', color?: CardWithBlocks_Color | null, hasBorder?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, blocks?: Array<{ __typename?: 'Content', content?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'FormBlock', id?: string | null, blockName?: string | null, blockType?: string | null, form?: { __typename?: 'Form', id: string, title: string, submitButtonLabel?: string | null, confirmationType?: Form_ConfirmationType | null, confirmationMessage?: any | null, updatedAt?: any | null, createdAt?: any | null, fields?: Array<{ __typename?: 'Checkbox', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueBoolean?: boolean | null } | { __typename?: 'Email', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Message', message?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Number', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueNumber?: number | null } | { __typename?: 'Select', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Select_Options', label?: string | null, value?: string | null, id?: string | null }> | null } | { __typename?: 'Text', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Textarea', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Toggle', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Toggle_Options', label?: string | null, value?: string | null, id?: string | null }> | null }> | null, redirect?: { __typename?: 'Form_Redirect', url?: string | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Image', caption?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, imageSize?: Image_ImageSize | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Lists', id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, list?: Array<{ __typename?: 'Lists_List', color?: Lists_List_Color | null, title?: string | null, id?: string | null, items?: Array<{ __typename?: 'Lists_List_Items', id?: string | null, content?: string | null }> | null }> | null }> | null }>, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null };

export type BlockSettingsFieldFragmentFragment = { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null };

export type FormFieldFragmentFragment = { __typename?: 'Form', id: string, title: string, submitButtonLabel?: string | null, confirmationType?: Form_ConfirmationType | null, confirmationMessage?: any | null, updatedAt?: any | null, createdAt?: any | null, fields?: Array<{ __typename?: 'Checkbox', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueBoolean?: boolean | null } | { __typename?: 'Email', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Message', message?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Number', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueNumber?: number | null } | { __typename?: 'Select', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Select_Options', label?: string | null, value?: string | null, id?: string | null }> | null } | { __typename?: 'Text', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Textarea', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Toggle', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Toggle_Options', label?: string | null, value?: string | null, id?: string | null }> | null }> | null, redirect?: { __typename?: 'Form_Redirect', url?: string | null } | null };

export type LinkFieldFragmentFragment = { __typename?: 'Link', type?: Link_Type | null, label?: string | null, url?: string | null, reference?: { __typename?: 'Link_Reference_Relationship', relationTo?: Link_Reference_RelationTo | null, value?: { __typename?: 'Article', slug?: string | null, categories?: Array<{ __typename?: 'Category', slug?: string | null }> | null } | { __typename?: 'LeadForm', slug?: string | null } | { __typename?: 'Page', slug?: string | null } | { __typename?: 'Service', slug?: string | null } | null } | null };

export type MediaFieldFragmentFragment = { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null };

export type CreateFormSubmissionMutationVariables = Exact<{
  data: MutationFormSubmissionInput;
  draft?: InputMaybe<Scalars['Boolean']>;
}>;


export type CreateFormSubmissionMutation = { __typename?: 'Mutation', createFormSubmission?: { __typename?: 'FormSubmission', id: string } | null };

export type CreateEpcCheckFormSubmissionMutationVariables = Exact<{
  data: MutationEpcCheckFormSubmissionInput;
}>;


export type CreateEpcCheckFormSubmissionMutation = { __typename?: 'Mutation', createEpcCheckFormSubmission?: { __typename?: 'EpcCheckFormSubmission', id: string } | null };

export type CreateNewsletterSubscriberMutationVariables = Exact<{
  data: MutationNewsletterSubscriberInput;
  draft?: InputMaybe<Scalars['Boolean']>;
}>;


export type CreateNewsletterSubscriberMutation = { __typename?: 'Mutation', createNewsletterSubscriber?: { __typename?: 'NewsletterSubscriber', id: string } | null };

export type ArticleQueryVariables = Exact<{
  draft?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<Article_Where>;
}>;


export type ArticleQuery = { __typename?: 'Query', Articles?: { __typename?: 'Articles', docs?: Array<{ __typename?: 'Article', id: string, title?: string | null, slug?: string | null, publishedAt?: any | null, timeToRead?: number | null, updatedAt?: any | null, createdAt?: any | null, _status?: Article__Status | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, layout?: Array<{ __typename?: 'Columns', id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, settings?: { __typename?: 'Columns_Settings', verticalAlignment?: Columns_Settings_VerticalAlignment | null, columnGapSize?: Columns_Settings_ColumnGapSize | null, flipOnMobile?: boolean | null } | null, columns?: Array<{ __typename?: 'Columns_Columns', id?: string | null, columnWidth?: Columns_Columns_ColumnWidth | null, blocks?: Array<{ __typename?: 'AnimatedTextBlock', text?: string | null, value?: number | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'CardWithBlocks', color?: CardWithBlocks_Color | null, hasBorder?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, blocks?: Array<{ __typename?: 'Content', content?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'FormBlock', id?: string | null, blockName?: string | null, blockType?: string | null, form?: { __typename?: 'Form', id: string, title: string, submitButtonLabel?: string | null, confirmationType?: Form_ConfirmationType | null, confirmationMessage?: any | null, updatedAt?: any | null, createdAt?: any | null, fields?: Array<{ __typename?: 'Checkbox', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueBoolean?: boolean | null } | { __typename?: 'Email', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Message', message?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Number', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueNumber?: number | null } | { __typename?: 'Select', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Select_Options', label?: string | null, value?: string | null, id?: string | null }> | null } | { __typename?: 'Text', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Textarea', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Toggle', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Toggle_Options', label?: string | null, value?: string | null, id?: string | null }> | null }> | null, redirect?: { __typename?: 'Form_Redirect', url?: string | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Image', caption?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, imageSize?: Image_ImageSize | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Lists', id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, list?: Array<{ __typename?: 'Lists_List', color?: Lists_List_Color | null, title?: string | null, id?: string | null, items?: Array<{ __typename?: 'Lists_List_Items', id?: string | null, content?: string | null }> | null }> | null }> | null } | { __typename?: 'Content', content?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Faq', id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, faqs?: Array<{ __typename?: 'Faq_Faqs', id?: string | null, question?: string | null, answer?: any | null }> | null } | { __typename?: 'FormBlock', id?: string | null, blockName?: string | null, blockType?: string | null, form?: { __typename?: 'Form', id: string, title: string, submitButtonLabel?: string | null, confirmationType?: Form_ConfirmationType | null, confirmationMessage?: any | null, updatedAt?: any | null, createdAt?: any | null, fields?: Array<{ __typename?: 'Checkbox', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueBoolean?: boolean | null } | { __typename?: 'Email', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Message', message?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Number', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueNumber?: number | null } | { __typename?: 'Select', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Select_Options', label?: string | null, value?: string | null, id?: string | null }> | null } | { __typename?: 'Text', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Textarea', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Toggle', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Toggle_Options', label?: string | null, value?: string | null, id?: string | null }> | null }> | null, redirect?: { __typename?: 'Form_Redirect', url?: string | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Image', caption?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, imageSize?: Image_ImageSize | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'SliderWithBlocks', type?: SliderWithBlocks_Type | null, paginationType?: SliderWithBlocks_PaginationType | null, autoScrollEnabled?: boolean | null, autoScrollSpeed?: number | null, id?: string | null, blockName?: string | null, blockType?: string | null, slidesToShow?: { __typename?: 'SliderWithBlocks_SlidesToShow', desktop?: number | null, tablet?: number | null, mobile?: number | null } | null, sliderWithBlocks: Array<{ __typename?: 'CardWithBlocks', color?: CardWithBlocks_Color | null, hasBorder?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, blocks?: Array<{ __typename?: 'Content', content?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'FormBlock', id?: string | null, blockName?: string | null, blockType?: string | null, form?: { __typename?: 'Form', id: string, title: string, submitButtonLabel?: string | null, confirmationType?: Form_ConfirmationType | null, confirmationMessage?: any | null, updatedAt?: any | null, createdAt?: any | null, fields?: Array<{ __typename?: 'Checkbox', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueBoolean?: boolean | null } | { __typename?: 'Email', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Message', message?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Number', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueNumber?: number | null } | { __typename?: 'Select', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Select_Options', label?: string | null, value?: string | null, id?: string | null }> | null } | { __typename?: 'Text', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Textarea', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Toggle', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Toggle_Options', label?: string | null, value?: string | null, id?: string | null }> | null }> | null, redirect?: { __typename?: 'Form_Redirect', url?: string | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Image', caption?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, imageSize?: Image_ImageSize | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Lists', id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, list?: Array<{ __typename?: 'Lists_List', color?: Lists_List_Color | null, title?: string | null, id?: string | null, items?: Array<{ __typename?: 'Lists_List_Items', id?: string | null, content?: string | null }> | null }> | null }> | null } | { __typename?: 'Content', content?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Image', caption?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, imageSize?: Image_ImageSize | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null }> } | { __typename?: 'Spacer', height?: number | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'VerticalSlider', autoScrollEnabled?: boolean | null, autoScrollSpeed?: number | null, id?: string | null, blockName?: string | null, blockType?: string | null, slides: Array<{ __typename?: 'CardWithBlocks', color?: CardWithBlocks_Color | null, hasBorder?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, blocks?: Array<{ __typename?: 'Content', content?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'FormBlock', id?: string | null, blockName?: string | null, blockType?: string | null, form?: { __typename?: 'Form', id: string, title: string, submitButtonLabel?: string | null, confirmationType?: Form_ConfirmationType | null, confirmationMessage?: any | null, updatedAt?: any | null, createdAt?: any | null, fields?: Array<{ __typename?: 'Checkbox', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueBoolean?: boolean | null } | { __typename?: 'Email', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Message', message?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Number', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueNumber?: number | null } | { __typename?: 'Select', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Select_Options', label?: string | null, value?: string | null, id?: string | null }> | null } | { __typename?: 'Text', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Textarea', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Toggle', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Toggle_Options', label?: string | null, value?: string | null, id?: string | null }> | null }> | null, redirect?: { __typename?: 'Form_Redirect', url?: string | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Image', caption?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, imageSize?: Image_ImageSize | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Lists', id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, list?: Array<{ __typename?: 'Lists_List', color?: Lists_List_Color | null, title?: string | null, id?: string | null, items?: Array<{ __typename?: 'Lists_List_Items', id?: string | null, content?: string | null }> | null }> | null }> | null }>, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null }> | null }> | null } | { __typename?: 'Content', content?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Cta', title?: string | null, id?: string | null, blockName?: string | null, blockType?: string | null, ctaContent?: string | null, button?: { __typename?: 'Cta_Button', buttonType?: Cta_Button_ButtonType | null, link?: { __typename?: 'Link', type?: Link_Type | null, label?: string | null, url?: string | null, reference?: { __typename?: 'Link_Reference_Relationship', relationTo?: Link_Reference_RelationTo | null, value?: { __typename?: 'Article', slug?: string | null, categories?: Array<{ __typename?: 'Category', slug?: string | null }> | null } | { __typename?: 'LeadForm', slug?: string | null } | { __typename?: 'Page', slug?: string | null } | { __typename?: 'Service', slug?: string | null } | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Image', caption?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, imageSize?: Image_ImageSize | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null }> | null, meta?: { __typename?: 'Article_Meta', title?: string | null, description?: string | null } | null, author?: { __typename?: 'User', id: string, fullName?: string | null } | null, categories?: Array<{ __typename?: 'Category', id: string, title: string }> | null, tags?: Array<{ __typename?: 'Tag', id: string, title: string }> | null } | null> | null } | null };

export type ArticlesQueryVariables = Exact<{
  draft?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<Article_Where>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  pagination?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<Scalars['String']>;
}>;


export type ArticlesQuery = { __typename?: 'Query', Articles?: { __typename?: 'Articles', hasNextPage?: boolean | null, hasPrevPage?: boolean | null, limit?: number | null, nextPage?: number | null, offset?: number | null, page?: number | null, pagingCounter?: number | null, prevPage?: number | null, totalDocs?: number | null, totalPages?: number | null, docs?: Array<{ __typename?: 'Article', id: string, title?: string | null, slug?: string | null, publishedAt?: any | null, timeToRead?: number | null, excerpt?: string | null, updatedAt?: any | null, createdAt?: any | null, _status?: Article__Status | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, author?: { __typename?: 'User', id: string, fullName?: string | null } | null, categories?: Array<{ __typename?: 'Category', id: string, slug?: string | null, title: string }> | null, tags?: Array<{ __typename?: 'Tag', id: string, title: string }> | null } | null> | null } | null };

export type CategoriesQueryVariables = Exact<{
  draft?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<Category_Where>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  pagination?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<Scalars['String']>;
}>;


export type CategoriesQuery = { __typename?: 'Query', Categories?: { __typename?: 'Categories', hasNextPage?: boolean | null, hasPrevPage?: boolean | null, limit?: number | null, nextPage?: number | null, offset?: number | null, page?: number | null, pagingCounter?: number | null, prevPage?: number | null, totalDocs?: number | null, totalPages?: number | null, docs?: Array<{ __typename?: 'Category', id: string, title: string, slug?: string | null, featuredCategory?: boolean | null, description: string, updatedAt?: any | null, createdAt?: any | null } | null> | null } | null };

export type CtaBannerQueryVariables = Exact<{
  draft?: InputMaybe<Scalars['Boolean']>;
}>;


export type CtaBannerQuery = { __typename?: 'Query', CtaBanner?: { __typename?: 'CtaBanner', enableTrustWidget?: boolean | null, title: string, description?: string | null, createdAt?: any | null, updatedAt?: any | null, buttons?: Array<{ __typename?: 'CtaBanner_Buttons', buttonType?: CtaBanner_Buttons_ButtonType | null, link?: { __typename?: 'Link', type?: Link_Type | null, label?: string | null, url?: string | null, reference?: { __typename?: 'Link_Reference_Relationship', relationTo?: Link_Reference_RelationTo | null, value?: { __typename?: 'Article', slug?: string | null, categories?: Array<{ __typename?: 'Category', slug?: string | null }> | null } | { __typename?: 'LeadForm', slug?: string | null } | { __typename?: 'Page', slug?: string | null } | { __typename?: 'Service', slug?: string | null } | null } | null } | null }> | null } | null };

export type FooterMenuQueryVariables = Exact<{
  draft?: InputMaybe<Scalars['Boolean']>;
}>;


export type FooterMenuQuery = { __typename?: 'Query', FooterMenu?: { __typename?: 'FooterMenu', updatedAt?: any | null, createdAt?: any | null, menuGroups?: Array<{ __typename?: 'FooterMenu_MenuGroups', title?: string | null, id?: string | null, links?: Array<{ __typename?: 'FooterMenu_MenuGroups_Links', id?: string | null, link?: { __typename?: 'Link', type?: Link_Type | null, label?: string | null, url?: string | null, reference?: { __typename?: 'Link_Reference_Relationship', relationTo?: Link_Reference_RelationTo | null, value?: { __typename?: 'Article', slug?: string | null, categories?: Array<{ __typename?: 'Category', slug?: string | null }> | null } | { __typename?: 'LeadForm', slug?: string | null } | { __typename?: 'Page', slug?: string | null } | { __typename?: 'Service', slug?: string | null } | null } | null } | null }> | null }> | null } | null, SocialMedia?: { __typename?: 'SocialMedia', facebook?: string | null, instagram?: string | null, updatedAt?: any | null, createdAt?: any | null } | null };

export type HeaderMenuQueryVariables = Exact<{
  draft?: InputMaybe<Scalars['Boolean']>;
}>;


export type HeaderMenuQuery = { __typename?: 'Query', HeaderMenu?: { __typename?: 'HeaderMenu', updatedAt?: any | null, createdAt?: any | null, links?: Array<{ __typename?: 'HeaderMenu_Links', subMenuEnabled?: boolean | null, id?: string | null, link?: { __typename?: 'Link', type?: Link_Type | null, label?: string | null, url?: string | null, reference?: { __typename?: 'Link_Reference_Relationship', relationTo?: Link_Reference_RelationTo | null, value?: { __typename?: 'Article', slug?: string | null, categories?: Array<{ __typename?: 'Category', slug?: string | null }> | null } | { __typename?: 'LeadForm', slug?: string | null } | { __typename?: 'Page', slug?: string | null } | { __typename?: 'Service', slug?: string | null } | null } | null } | null, subMenu?: { __typename?: 'HeaderMenu_Links_SubMenu', title?: string | null, ctaEnabled?: boolean | null, links?: Array<{ __typename?: 'HeaderMenu_Links_SubMenu_Links', excerpt?: string | null, id?: string | null, link?: { __typename?: 'Link', type?: Link_Type | null, label?: string | null, url?: string | null, reference?: { __typename?: 'Link_Reference_Relationship', relationTo?: Link_Reference_RelationTo | null, value?: { __typename?: 'Article', slug?: string | null, categories?: Array<{ __typename?: 'Category', slug?: string | null }> | null } | { __typename?: 'LeadForm', slug?: string | null } | { __typename?: 'Page', slug?: string | null } | { __typename?: 'Service', slug?: string | null } | null } | null } | null }> | null, cta?: { __typename?: 'HeaderMenu_Links_SubMenu_Cta', title?: string | null, description?: string | null, tagText?: string | null, tagColor?: HeaderMenu_Links_SubMenu_Cta_TagColor | null, link?: { __typename?: 'Link', type?: Link_Type | null, label?: string | null, url?: string | null, reference?: { __typename?: 'Link_Reference_Relationship', relationTo?: Link_Reference_RelationTo | null, value?: { __typename?: 'Article', slug?: string | null, categories?: Array<{ __typename?: 'Category', slug?: string | null }> | null } | { __typename?: 'LeadForm', slug?: string | null } | { __typename?: 'Page', slug?: string | null } | { __typename?: 'Service', slug?: string | null } | null } | null } | null } | null } | null }> | null } | null };

export type LandingPagesQueryVariables = Exact<{
  draft?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<LandingPage_Where>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
}>;


export type LandingPagesQuery = { __typename?: 'Query', LandingPages?: { __typename?: 'LandingPages', docs?: Array<{ __typename?: 'LandingPage', id: string, title?: string | null, description?: any | null, slug?: string | null, updatedAt?: any | null, createdAt?: any | null, titleSettings?: { __typename?: 'Page_TitleSettings', boldStartIndex?: number | null, boldEndIndex?: number | null } | null, header?: { __typename?: 'LandingPage_Header', type?: LandingPage_Header_Type | null, beforeFeaturedFormContent?: any | null, wrapInBackground?: boolean | null, showRatingWidget?: boolean | null, featuredForm?: { __typename?: 'Form', id: string, title: string, submitButtonLabel?: string | null, confirmationType?: Form_ConfirmationType | null, confirmationMessage?: any | null, updatedAt?: any | null, createdAt?: any | null, fields?: Array<{ __typename?: 'Checkbox', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueBoolean?: boolean | null } | { __typename?: 'Email', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Message', message?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Number', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueNumber?: number | null } | { __typename?: 'Select', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Select_Options', label?: string | null, value?: string | null, id?: string | null }> | null } | { __typename?: 'Text', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Textarea', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Toggle', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Toggle_Options', label?: string | null, value?: string | null, id?: string | null }> | null }> | null, redirect?: { __typename?: 'Form_Redirect', url?: string | null } | null } | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null } | null, layout?: { __typename?: 'LandingPage_Layout', blocks?: Array<{ __typename?: 'AnimatedTextBlock', text?: string | null, value?: number | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'ArticlesScroller', method?: ArticlesScroller_Method | null, id?: string | null, blockName?: string | null, blockType?: string | null, categories?: Array<{ __typename?: 'Category', id: string }> | null, tags?: Array<{ __typename?: 'Tag', id: string }> | null, articles?: Array<{ __typename?: 'Article', id: string, slug?: string | null }> | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'BackgroundWithBlock', backgroundColor?: BackgroundWithBlock_BackgroundColor | null, containerWidth?: BackgroundWithBlock_ContainerWidth | null, hasBackgroundGridImage?: boolean | null, showBackgroundImage?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, backgroundWithBlocks?: Array<{ __typename?: 'Columns', id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, settings?: { __typename?: 'Columns_Settings', verticalAlignment?: Columns_Settings_VerticalAlignment | null, columnGapSize?: Columns_Settings_ColumnGapSize | null, flipOnMobile?: boolean | null } | null, columns?: Array<{ __typename?: 'Columns_Columns', id?: string | null, columnWidth?: Columns_Columns_ColumnWidth | null, blocks?: Array<{ __typename?: 'AnimatedTextBlock', text?: string | null, value?: number | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'CardWithBlocks', color?: CardWithBlocks_Color | null, hasBorder?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, blocks?: Array<{ __typename?: 'Content', content?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'FormBlock', id?: string | null, blockName?: string | null, blockType?: string | null, form?: { __typename?: 'Form', id: string, title: string, submitButtonLabel?: string | null, confirmationType?: Form_ConfirmationType | null, confirmationMessage?: any | null, updatedAt?: any | null, createdAt?: any | null, fields?: Array<{ __typename?: 'Checkbox', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueBoolean?: boolean | null } | { __typename?: 'Email', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Message', message?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Number', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueNumber?: number | null } | { __typename?: 'Select', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Select_Options', label?: string | null, value?: string | null, id?: string | null }> | null } | { __typename?: 'Text', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Textarea', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Toggle', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Toggle_Options', label?: string | null, value?: string | null, id?: string | null }> | null }> | null, redirect?: { __typename?: 'Form_Redirect', url?: string | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Image', caption?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, imageSize?: Image_ImageSize | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Lists', id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, list?: Array<{ __typename?: 'Lists_List', color?: Lists_List_Color | null, title?: string | null, id?: string | null, items?: Array<{ __typename?: 'Lists_List_Items', id?: string | null, content?: string | null }> | null }> | null }> | null } | { __typename?: 'Content', content?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Faq', id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, faqs?: Array<{ __typename?: 'Faq_Faqs', id?: string | null, question?: string | null, answer?: any | null }> | null } | { __typename?: 'FormBlock', id?: string | null, blockName?: string | null, blockType?: string | null, form?: { __typename?: 'Form', id: string, title: string, submitButtonLabel?: string | null, confirmationType?: Form_ConfirmationType | null, confirmationMessage?: any | null, updatedAt?: any | null, createdAt?: any | null, fields?: Array<{ __typename?: 'Checkbox', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueBoolean?: boolean | null } | { __typename?: 'Email', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Message', message?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Number', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueNumber?: number | null } | { __typename?: 'Select', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Select_Options', label?: string | null, value?: string | null, id?: string | null }> | null } | { __typename?: 'Text', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Textarea', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Toggle', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Toggle_Options', label?: string | null, value?: string | null, id?: string | null }> | null }> | null, redirect?: { __typename?: 'Form_Redirect', url?: string | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Image', caption?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, imageSize?: Image_ImageSize | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'SliderWithBlocks', type?: SliderWithBlocks_Type | null, paginationType?: SliderWithBlocks_PaginationType | null, autoScrollEnabled?: boolean | null, autoScrollSpeed?: number | null, id?: string | null, blockName?: string | null, blockType?: string | null, slidesToShow?: { __typename?: 'SliderWithBlocks_SlidesToShow', desktop?: number | null, tablet?: number | null, mobile?: number | null } | null, sliderWithBlocks: Array<{ __typename?: 'CardWithBlocks', color?: CardWithBlocks_Color | null, hasBorder?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, blocks?: Array<{ __typename?: 'Content', content?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'FormBlock', id?: string | null, blockName?: string | null, blockType?: string | null, form?: { __typename?: 'Form', id: string, title: string, submitButtonLabel?: string | null, confirmationType?: Form_ConfirmationType | null, confirmationMessage?: any | null, updatedAt?: any | null, createdAt?: any | null, fields?: Array<{ __typename?: 'Checkbox', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueBoolean?: boolean | null } | { __typename?: 'Email', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Message', message?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Number', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueNumber?: number | null } | { __typename?: 'Select', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Select_Options', label?: string | null, value?: string | null, id?: string | null }> | null } | { __typename?: 'Text', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Textarea', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Toggle', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Toggle_Options', label?: string | null, value?: string | null, id?: string | null }> | null }> | null, redirect?: { __typename?: 'Form_Redirect', url?: string | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Image', caption?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, imageSize?: Image_ImageSize | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Lists', id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, list?: Array<{ __typename?: 'Lists_List', color?: Lists_List_Color | null, title?: string | null, id?: string | null, items?: Array<{ __typename?: 'Lists_List_Items', id?: string | null, content?: string | null }> | null }> | null }> | null } | { __typename?: 'Content', content?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Image', caption?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, imageSize?: Image_ImageSize | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null }> } | { __typename?: 'Spacer', height?: number | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'VerticalSlider', autoScrollEnabled?: boolean | null, autoScrollSpeed?: number | null, id?: string | null, blockName?: string | null, blockType?: string | null, slides: Array<{ __typename?: 'CardWithBlocks', color?: CardWithBlocks_Color | null, hasBorder?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, blocks?: Array<{ __typename?: 'Content', content?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'FormBlock', id?: string | null, blockName?: string | null, blockType?: string | null, form?: { __typename?: 'Form', id: string, title: string, submitButtonLabel?: string | null, confirmationType?: Form_ConfirmationType | null, confirmationMessage?: any | null, updatedAt?: any | null, createdAt?: any | null, fields?: Array<{ __typename?: 'Checkbox', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueBoolean?: boolean | null } | { __typename?: 'Email', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Message', message?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Number', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueNumber?: number | null } | { __typename?: 'Select', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Select_Options', label?: string | null, value?: string | null, id?: string | null }> | null } | { __typename?: 'Text', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Textarea', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Toggle', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Toggle_Options', label?: string | null, value?: string | null, id?: string | null }> | null }> | null, redirect?: { __typename?: 'Form_Redirect', url?: string | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Image', caption?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, imageSize?: Image_ImageSize | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Lists', id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, list?: Array<{ __typename?: 'Lists_List', color?: Lists_List_Color | null, title?: string | null, id?: string | null, items?: Array<{ __typename?: 'Lists_List_Items', id?: string | null, content?: string | null }> | null }> | null }> | null }>, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null }> | null }> | null } | { __typename?: 'Content', content?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'ServicesScroller', id?: string | null, blockName?: string | null, blockType?: string | null, serviceScrollerMethod?: ServicesScroller_Method | null, services?: Array<{ __typename?: 'Service', id: string, slug?: string | null }> | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'SliderWithBlocks', type?: SliderWithBlocks_Type | null, paginationType?: SliderWithBlocks_PaginationType | null, autoScrollEnabled?: boolean | null, autoScrollSpeed?: number | null, id?: string | null, blockName?: string | null, blockType?: string | null, slidesToShow?: { __typename?: 'SliderWithBlocks_SlidesToShow', desktop?: number | null, tablet?: number | null, mobile?: number | null } | null, sliderWithBlocks: Array<{ __typename?: 'CardWithBlocks', color?: CardWithBlocks_Color | null, hasBorder?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, blocks?: Array<{ __typename?: 'Content', content?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'FormBlock', id?: string | null, blockName?: string | null, blockType?: string | null, form?: { __typename?: 'Form', id: string, title: string, submitButtonLabel?: string | null, confirmationType?: Form_ConfirmationType | null, confirmationMessage?: any | null, updatedAt?: any | null, createdAt?: any | null, fields?: Array<{ __typename?: 'Checkbox', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueBoolean?: boolean | null } | { __typename?: 'Email', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Message', message?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Number', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueNumber?: number | null } | { __typename?: 'Select', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Select_Options', label?: string | null, value?: string | null, id?: string | null }> | null } | { __typename?: 'Text', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Textarea', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Toggle', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Toggle_Options', label?: string | null, value?: string | null, id?: string | null }> | null }> | null, redirect?: { __typename?: 'Form_Redirect', url?: string | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Image', caption?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, imageSize?: Image_ImageSize | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Lists', id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, list?: Array<{ __typename?: 'Lists_List', color?: Lists_List_Color | null, title?: string | null, id?: string | null, items?: Array<{ __typename?: 'Lists_List_Items', id?: string | null, content?: string | null }> | null }> | null }> | null } | { __typename?: 'Content', content?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Image', caption?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, imageSize?: Image_ImageSize | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null }> }> | null, backgroundImage?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'CardWithBlocks', color?: CardWithBlocks_Color | null, hasBorder?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, blocks?: Array<{ __typename?: 'Content', content?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'FormBlock', id?: string | null, blockName?: string | null, blockType?: string | null, form?: { __typename?: 'Form', id: string, title: string, submitButtonLabel?: string | null, confirmationType?: Form_ConfirmationType | null, confirmationMessage?: any | null, updatedAt?: any | null, createdAt?: any | null, fields?: Array<{ __typename?: 'Checkbox', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueBoolean?: boolean | null } | { __typename?: 'Email', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Message', message?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Number', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueNumber?: number | null } | { __typename?: 'Select', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Select_Options', label?: string | null, value?: string | null, id?: string | null }> | null } | { __typename?: 'Text', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Textarea', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Toggle', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Toggle_Options', label?: string | null, value?: string | null, id?: string | null }> | null }> | null, redirect?: { __typename?: 'Form_Redirect', url?: string | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Image', caption?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, imageSize?: Image_ImageSize | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Lists', id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, list?: Array<{ __typename?: 'Lists_List', color?: Lists_List_Color | null, title?: string | null, id?: string | null, items?: Array<{ __typename?: 'Lists_List_Items', id?: string | null, content?: string | null }> | null }> | null }> | null } | { __typename?: 'Columns', id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, settings?: { __typename?: 'Columns_Settings', verticalAlignment?: Columns_Settings_VerticalAlignment | null, columnGapSize?: Columns_Settings_ColumnGapSize | null, flipOnMobile?: boolean | null } | null, columns?: Array<{ __typename?: 'Columns_Columns', id?: string | null, columnWidth?: Columns_Columns_ColumnWidth | null, blocks?: Array<{ __typename?: 'AnimatedTextBlock', text?: string | null, value?: number | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'CardWithBlocks', color?: CardWithBlocks_Color | null, hasBorder?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, blocks?: Array<{ __typename?: 'Content', content?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'FormBlock', id?: string | null, blockName?: string | null, blockType?: string | null, form?: { __typename?: 'Form', id: string, title: string, submitButtonLabel?: string | null, confirmationType?: Form_ConfirmationType | null, confirmationMessage?: any | null, updatedAt?: any | null, createdAt?: any | null, fields?: Array<{ __typename?: 'Checkbox', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueBoolean?: boolean | null } | { __typename?: 'Email', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Message', message?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Number', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueNumber?: number | null } | { __typename?: 'Select', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Select_Options', label?: string | null, value?: string | null, id?: string | null }> | null } | { __typename?: 'Text', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Textarea', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Toggle', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Toggle_Options', label?: string | null, value?: string | null, id?: string | null }> | null }> | null, redirect?: { __typename?: 'Form_Redirect', url?: string | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Image', caption?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, imageSize?: Image_ImageSize | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Lists', id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, list?: Array<{ __typename?: 'Lists_List', color?: Lists_List_Color | null, title?: string | null, id?: string | null, items?: Array<{ __typename?: 'Lists_List_Items', id?: string | null, content?: string | null }> | null }> | null }> | null } | { __typename?: 'Content', content?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Faq', id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, faqs?: Array<{ __typename?: 'Faq_Faqs', id?: string | null, question?: string | null, answer?: any | null }> | null } | { __typename?: 'FormBlock', id?: string | null, blockName?: string | null, blockType?: string | null, form?: { __typename?: 'Form', id: string, title: string, submitButtonLabel?: string | null, confirmationType?: Form_ConfirmationType | null, confirmationMessage?: any | null, updatedAt?: any | null, createdAt?: any | null, fields?: Array<{ __typename?: 'Checkbox', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueBoolean?: boolean | null } | { __typename?: 'Email', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Message', message?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Number', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueNumber?: number | null } | { __typename?: 'Select', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Select_Options', label?: string | null, value?: string | null, id?: string | null }> | null } | { __typename?: 'Text', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Textarea', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Toggle', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Toggle_Options', label?: string | null, value?: string | null, id?: string | null }> | null }> | null, redirect?: { __typename?: 'Form_Redirect', url?: string | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Image', caption?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, imageSize?: Image_ImageSize | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'SliderWithBlocks', type?: SliderWithBlocks_Type | null, paginationType?: SliderWithBlocks_PaginationType | null, autoScrollEnabled?: boolean | null, autoScrollSpeed?: number | null, id?: string | null, blockName?: string | null, blockType?: string | null, slidesToShow?: { __typename?: 'SliderWithBlocks_SlidesToShow', desktop?: number | null, tablet?: number | null, mobile?: number | null } | null, sliderWithBlocks: Array<{ __typename?: 'CardWithBlocks', color?: CardWithBlocks_Color | null, hasBorder?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, blocks?: Array<{ __typename?: 'Content', content?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'FormBlock', id?: string | null, blockName?: string | null, blockType?: string | null, form?: { __typename?: 'Form', id: string, title: string, submitButtonLabel?: string | null, confirmationType?: Form_ConfirmationType | null, confirmationMessage?: any | null, updatedAt?: any | null, createdAt?: any | null, fields?: Array<{ __typename?: 'Checkbox', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueBoolean?: boolean | null } | { __typename?: 'Email', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Message', message?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Number', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueNumber?: number | null } | { __typename?: 'Select', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Select_Options', label?: string | null, value?: string | null, id?: string | null }> | null } | { __typename?: 'Text', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Textarea', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Toggle', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Toggle_Options', label?: string | null, value?: string | null, id?: string | null }> | null }> | null, redirect?: { __typename?: 'Form_Redirect', url?: string | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Image', caption?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, imageSize?: Image_ImageSize | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Lists', id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, list?: Array<{ __typename?: 'Lists_List', color?: Lists_List_Color | null, title?: string | null, id?: string | null, items?: Array<{ __typename?: 'Lists_List_Items', id?: string | null, content?: string | null }> | null }> | null }> | null } | { __typename?: 'Content', content?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Image', caption?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, imageSize?: Image_ImageSize | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null }> } | { __typename?: 'Spacer', height?: number | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'VerticalSlider', autoScrollEnabled?: boolean | null, autoScrollSpeed?: number | null, id?: string | null, blockName?: string | null, blockType?: string | null, slides: Array<{ __typename?: 'CardWithBlocks', color?: CardWithBlocks_Color | null, hasBorder?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, blocks?: Array<{ __typename?: 'Content', content?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'FormBlock', id?: string | null, blockName?: string | null, blockType?: string | null, form?: { __typename?: 'Form', id: string, title: string, submitButtonLabel?: string | null, confirmationType?: Form_ConfirmationType | null, confirmationMessage?: any | null, updatedAt?: any | null, createdAt?: any | null, fields?: Array<{ __typename?: 'Checkbox', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueBoolean?: boolean | null } | { __typename?: 'Email', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Message', message?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Number', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueNumber?: number | null } | { __typename?: 'Select', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Select_Options', label?: string | null, value?: string | null, id?: string | null }> | null } | { __typename?: 'Text', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Textarea', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Toggle', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Toggle_Options', label?: string | null, value?: string | null, id?: string | null }> | null }> | null, redirect?: { __typename?: 'Form_Redirect', url?: string | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Image', caption?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, imageSize?: Image_ImageSize | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Lists', id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, list?: Array<{ __typename?: 'Lists_List', color?: Lists_List_Color | null, title?: string | null, id?: string | null, items?: Array<{ __typename?: 'Lists_List_Items', id?: string | null, content?: string | null }> | null }> | null }> | null }>, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null }> | null }> | null } | { __typename?: 'Comparisons', showLeftContent?: boolean | null, leftContent?: any | null, secondaryComparison?: any | null, primaryComparison?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Content', content?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Cta', title?: string | null, id?: string | null, blockName?: string | null, blockType?: string | null, ctaContent?: string | null, button?: { __typename?: 'Cta_Button', buttonType?: Cta_Button_ButtonType | null, link?: { __typename?: 'Link', type?: Link_Type | null, label?: string | null, url?: string | null, reference?: { __typename?: 'Link_Reference_Relationship', relationTo?: Link_Reference_RelationTo | null, value?: { __typename?: 'Article', slug?: string | null, categories?: Array<{ __typename?: 'Category', slug?: string | null }> | null } | { __typename?: 'LeadForm', slug?: string | null } | { __typename?: 'Page', slug?: string | null } | { __typename?: 'Service', slug?: string | null } | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'CtaButton', buttonType?: CtaButton_ButtonType | null, content?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, link?: { __typename?: 'Link', type?: Link_Type | null, label?: string | null, url?: string | null, reference?: { __typename?: 'Link_Reference_Relationship', relationTo?: Link_Reference_RelationTo | null, value?: { __typename?: 'Article', slug?: string | null, categories?: Array<{ __typename?: 'Category', slug?: string | null }> | null } | { __typename?: 'LeadForm', slug?: string | null } | { __typename?: 'Page', slug?: string | null } | { __typename?: 'Service', slug?: string | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Faq', id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, faqs?: Array<{ __typename?: 'Faq_Faqs', id?: string | null, question?: string | null, answer?: any | null }> | null } | { __typename?: 'FormBlock', id?: string | null, blockName?: string | null, blockType?: string | null, form?: { __typename?: 'Form', id: string, title: string, submitButtonLabel?: string | null, confirmationType?: Form_ConfirmationType | null, confirmationMessage?: any | null, updatedAt?: any | null, createdAt?: any | null, fields?: Array<{ __typename?: 'Checkbox', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueBoolean?: boolean | null } | { __typename?: 'Email', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Message', message?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Number', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueNumber?: number | null } | { __typename?: 'Select', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Select_Options', label?: string | null, value?: string | null, id?: string | null }> | null } | { __typename?: 'Text', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Textarea', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Toggle', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Toggle_Options', label?: string | null, value?: string | null, id?: string | null }> | null }> | null, redirect?: { __typename?: 'Form_Redirect', url?: string | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Image', caption?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, imageSize?: Image_ImageSize | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'LeadFormBlock', id?: string | null, blockName?: string | null, blockType?: string | null, leadForm?: { __typename?: 'LeadForm', id: string, slug?: string | null } | null } | { __typename?: 'Lists', id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, list?: Array<{ __typename?: 'Lists_List', color?: Lists_List_Color | null, title?: string | null, id?: string | null, items?: Array<{ __typename?: 'Lists_List_Items', id?: string | null, content?: string | null }> | null }> | null } | { __typename?: 'ServicesScroller', id?: string | null, blockName?: string | null, blockType?: string | null, serviceScrollerMethod?: ServicesScroller_Method | null, services?: Array<{ __typename?: 'Service', id: string, slug?: string | null }> | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'SliderWithBlocks', type?: SliderWithBlocks_Type | null, paginationType?: SliderWithBlocks_PaginationType | null, autoScrollEnabled?: boolean | null, autoScrollSpeed?: number | null, id?: string | null, blockName?: string | null, blockType?: string | null, slidesToShow?: { __typename?: 'SliderWithBlocks_SlidesToShow', desktop?: number | null, tablet?: number | null, mobile?: number | null } | null, sliderWithBlocks: Array<{ __typename?: 'CardWithBlocks', color?: CardWithBlocks_Color | null, hasBorder?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, blocks?: Array<{ __typename?: 'Content', content?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'FormBlock', id?: string | null, blockName?: string | null, blockType?: string | null, form?: { __typename?: 'Form', id: string, title: string, submitButtonLabel?: string | null, confirmationType?: Form_ConfirmationType | null, confirmationMessage?: any | null, updatedAt?: any | null, createdAt?: any | null, fields?: Array<{ __typename?: 'Checkbox', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueBoolean?: boolean | null } | { __typename?: 'Email', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Message', message?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Number', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueNumber?: number | null } | { __typename?: 'Select', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Select_Options', label?: string | null, value?: string | null, id?: string | null }> | null } | { __typename?: 'Text', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Textarea', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Toggle', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Toggle_Options', label?: string | null, value?: string | null, id?: string | null }> | null }> | null, redirect?: { __typename?: 'Form_Redirect', url?: string | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Image', caption?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, imageSize?: Image_ImageSize | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Lists', id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, list?: Array<{ __typename?: 'Lists_List', color?: Lists_List_Color | null, title?: string | null, id?: string | null, items?: Array<{ __typename?: 'Lists_List_Items', id?: string | null, content?: string | null }> | null }> | null }> | null } | { __typename?: 'Content', content?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Image', caption?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, imageSize?: Image_ImageSize | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null }> } | { __typename?: 'Spacer', height?: number | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'StickyImageScroll', id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, items?: Array<{ __typename?: 'StickyImageScroll_Items', content?: any | null, showImageNode?: boolean | null, imageNode?: { __typename?: 'StickyImageScroll_Items_ImageNode', x?: number | null, y?: number | null, icon?: string | null } | null }> | null } | { __typename?: 'VerticalSlider', autoScrollEnabled?: boolean | null, autoScrollSpeed?: number | null, id?: string | null, blockName?: string | null, blockType?: string | null, slides: Array<{ __typename?: 'CardWithBlocks', color?: CardWithBlocks_Color | null, hasBorder?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, blocks?: Array<{ __typename?: 'Content', content?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'FormBlock', id?: string | null, blockName?: string | null, blockType?: string | null, form?: { __typename?: 'Form', id: string, title: string, submitButtonLabel?: string | null, confirmationType?: Form_ConfirmationType | null, confirmationMessage?: any | null, updatedAt?: any | null, createdAt?: any | null, fields?: Array<{ __typename?: 'Checkbox', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueBoolean?: boolean | null } | { __typename?: 'Email', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Message', message?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Number', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueNumber?: number | null } | { __typename?: 'Select', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Select_Options', label?: string | null, value?: string | null, id?: string | null }> | null } | { __typename?: 'Text', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Textarea', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Toggle', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Toggle_Options', label?: string | null, value?: string | null, id?: string | null }> | null }> | null, redirect?: { __typename?: 'Form_Redirect', url?: string | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Image', caption?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, imageSize?: Image_ImageSize | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Lists', id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, list?: Array<{ __typename?: 'Lists_List', color?: Lists_List_Color | null, title?: string | null, id?: string | null, items?: Array<{ __typename?: 'Lists_List_Items', id?: string | null, content?: string | null }> | null }> | null }> | null }>, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null }> | null } | null, meta?: { __typename?: 'LandingPage_Meta', title?: string | null, description?: string | null, noIndex?: boolean | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null } | null } | null> | null } | null };

export type LandingTumblersQueryVariables = Exact<{
  draft?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<LandingTumbler_Where>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
}>;


export type LandingTumblersQuery = { __typename?: 'Query', LandingTumblers?: { __typename?: 'LandingTumblers', docs?: Array<{ __typename?: 'LandingTumbler', id: string, title?: string | null, slug?: string | null, selectedLandingPageSlug?: string | null, updatedAt?: any | null, createdAt?: any | null, meta?: { __typename?: 'LandingTumbler_Meta', title?: string | null, description?: string | null, noIndex?: boolean | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null } | null } | null> | null } | null };

export type LeadFormQueryVariables = Exact<{
  draft?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<LeadForm_Where>;
}>;


export type LeadFormQuery = { __typename?: 'Query', LeadForms?: { __typename?: 'LeadForms', docs?: Array<{ __typename?: 'LeadForm', id: string, slug?: string | null, updatedAt?: any | null, createdAt?: any | null } | null> | null } | null };

export type PagesQueryVariables = Exact<{
  draft?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<Page_Where>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
}>;


export type PagesQuery = { __typename?: 'Query', Pages?: { __typename?: 'Pages', docs?: Array<{ __typename?: 'Page', id: string, title?: string | null, description?: any | null, isArticle?: boolean | null, slug?: string | null, updatedAt?: any | null, createdAt?: any | null, titleSettings?: { __typename?: 'Page_TitleSettings', boldStartIndex?: number | null, boldEndIndex?: number | null } | null, header?: { __typename?: 'Page_Header', type?: Page_Header_Type | null, beforeFeaturedFormContent?: any | null, wrapInBackground?: boolean | null, showLookingForForm?: boolean | null, showRatingWidget?: boolean | null, featuredForm?: { __typename?: 'Form', id: string, title: string, submitButtonLabel?: string | null, confirmationType?: Form_ConfirmationType | null, confirmationMessage?: any | null, updatedAt?: any | null, createdAt?: any | null, fields?: Array<{ __typename?: 'Checkbox', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueBoolean?: boolean | null } | { __typename?: 'Email', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Message', message?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Number', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueNumber?: number | null } | { __typename?: 'Select', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Select_Options', label?: string | null, value?: string | null, id?: string | null }> | null } | { __typename?: 'Text', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Textarea', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Toggle', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Toggle_Options', label?: string | null, value?: string | null, id?: string | null }> | null }> | null, redirect?: { __typename?: 'Form_Redirect', url?: string | null } | null } | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null } | null, layout?: { __typename?: 'Page_Layout', blocks?: Array<{ __typename?: 'AnimatedTextBlock', text?: string | null, value?: number | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'ArticlesScroller', method?: ArticlesScroller_Method | null, id?: string | null, blockName?: string | null, blockType?: string | null, categories?: Array<{ __typename?: 'Category', id: string }> | null, tags?: Array<{ __typename?: 'Tag', id: string }> | null, articles?: Array<{ __typename?: 'Article', id: string, slug?: string | null }> | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'BackgroundWithBlock', backgroundColor?: BackgroundWithBlock_BackgroundColor | null, containerWidth?: BackgroundWithBlock_ContainerWidth | null, hasBackgroundGridImage?: boolean | null, showBackgroundImage?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, backgroundWithBlocks?: Array<{ __typename?: 'Columns', id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, settings?: { __typename?: 'Columns_Settings', verticalAlignment?: Columns_Settings_VerticalAlignment | null, columnGapSize?: Columns_Settings_ColumnGapSize | null, flipOnMobile?: boolean | null } | null, columns?: Array<{ __typename?: 'Columns_Columns', id?: string | null, columnWidth?: Columns_Columns_ColumnWidth | null, blocks?: Array<{ __typename?: 'AnimatedTextBlock', text?: string | null, value?: number | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'CardWithBlocks', color?: CardWithBlocks_Color | null, hasBorder?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, blocks?: Array<{ __typename?: 'Content', content?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'FormBlock', id?: string | null, blockName?: string | null, blockType?: string | null, form?: { __typename?: 'Form', id: string, title: string, submitButtonLabel?: string | null, confirmationType?: Form_ConfirmationType | null, confirmationMessage?: any | null, updatedAt?: any | null, createdAt?: any | null, fields?: Array<{ __typename?: 'Checkbox', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueBoolean?: boolean | null } | { __typename?: 'Email', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Message', message?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Number', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueNumber?: number | null } | { __typename?: 'Select', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Select_Options', label?: string | null, value?: string | null, id?: string | null }> | null } | { __typename?: 'Text', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Textarea', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Toggle', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Toggle_Options', label?: string | null, value?: string | null, id?: string | null }> | null }> | null, redirect?: { __typename?: 'Form_Redirect', url?: string | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Image', caption?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, imageSize?: Image_ImageSize | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Lists', id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, list?: Array<{ __typename?: 'Lists_List', color?: Lists_List_Color | null, title?: string | null, id?: string | null, items?: Array<{ __typename?: 'Lists_List_Items', id?: string | null, content?: string | null }> | null }> | null }> | null } | { __typename?: 'Content', content?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Faq', id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, faqs?: Array<{ __typename?: 'Faq_Faqs', id?: string | null, question?: string | null, answer?: any | null }> | null } | { __typename?: 'FormBlock', id?: string | null, blockName?: string | null, blockType?: string | null, form?: { __typename?: 'Form', id: string, title: string, submitButtonLabel?: string | null, confirmationType?: Form_ConfirmationType | null, confirmationMessage?: any | null, updatedAt?: any | null, createdAt?: any | null, fields?: Array<{ __typename?: 'Checkbox', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueBoolean?: boolean | null } | { __typename?: 'Email', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Message', message?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Number', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueNumber?: number | null } | { __typename?: 'Select', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Select_Options', label?: string | null, value?: string | null, id?: string | null }> | null } | { __typename?: 'Text', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Textarea', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Toggle', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Toggle_Options', label?: string | null, value?: string | null, id?: string | null }> | null }> | null, redirect?: { __typename?: 'Form_Redirect', url?: string | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Image', caption?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, imageSize?: Image_ImageSize | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'SliderWithBlocks', type?: SliderWithBlocks_Type | null, paginationType?: SliderWithBlocks_PaginationType | null, autoScrollEnabled?: boolean | null, autoScrollSpeed?: number | null, id?: string | null, blockName?: string | null, blockType?: string | null, slidesToShow?: { __typename?: 'SliderWithBlocks_SlidesToShow', desktop?: number | null, tablet?: number | null, mobile?: number | null } | null, sliderWithBlocks: Array<{ __typename?: 'CardWithBlocks', color?: CardWithBlocks_Color | null, hasBorder?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, blocks?: Array<{ __typename?: 'Content', content?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'FormBlock', id?: string | null, blockName?: string | null, blockType?: string | null, form?: { __typename?: 'Form', id: string, title: string, submitButtonLabel?: string | null, confirmationType?: Form_ConfirmationType | null, confirmationMessage?: any | null, updatedAt?: any | null, createdAt?: any | null, fields?: Array<{ __typename?: 'Checkbox', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueBoolean?: boolean | null } | { __typename?: 'Email', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Message', message?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Number', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueNumber?: number | null } | { __typename?: 'Select', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Select_Options', label?: string | null, value?: string | null, id?: string | null }> | null } | { __typename?: 'Text', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Textarea', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Toggle', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Toggle_Options', label?: string | null, value?: string | null, id?: string | null }> | null }> | null, redirect?: { __typename?: 'Form_Redirect', url?: string | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Image', caption?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, imageSize?: Image_ImageSize | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Lists', id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, list?: Array<{ __typename?: 'Lists_List', color?: Lists_List_Color | null, title?: string | null, id?: string | null, items?: Array<{ __typename?: 'Lists_List_Items', id?: string | null, content?: string | null }> | null }> | null }> | null } | { __typename?: 'Content', content?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Image', caption?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, imageSize?: Image_ImageSize | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null }> } | { __typename?: 'Spacer', height?: number | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'VerticalSlider', autoScrollEnabled?: boolean | null, autoScrollSpeed?: number | null, id?: string | null, blockName?: string | null, blockType?: string | null, slides: Array<{ __typename?: 'CardWithBlocks', color?: CardWithBlocks_Color | null, hasBorder?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, blocks?: Array<{ __typename?: 'Content', content?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'FormBlock', id?: string | null, blockName?: string | null, blockType?: string | null, form?: { __typename?: 'Form', id: string, title: string, submitButtonLabel?: string | null, confirmationType?: Form_ConfirmationType | null, confirmationMessage?: any | null, updatedAt?: any | null, createdAt?: any | null, fields?: Array<{ __typename?: 'Checkbox', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueBoolean?: boolean | null } | { __typename?: 'Email', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Message', message?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Number', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueNumber?: number | null } | { __typename?: 'Select', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Select_Options', label?: string | null, value?: string | null, id?: string | null }> | null } | { __typename?: 'Text', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Textarea', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Toggle', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Toggle_Options', label?: string | null, value?: string | null, id?: string | null }> | null }> | null, redirect?: { __typename?: 'Form_Redirect', url?: string | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Image', caption?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, imageSize?: Image_ImageSize | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Lists', id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, list?: Array<{ __typename?: 'Lists_List', color?: Lists_List_Color | null, title?: string | null, id?: string | null, items?: Array<{ __typename?: 'Lists_List_Items', id?: string | null, content?: string | null }> | null }> | null }> | null }>, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null }> | null }> | null } | { __typename?: 'Content', content?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'ServicesScroller', id?: string | null, blockName?: string | null, blockType?: string | null, serviceScrollerMethod?: ServicesScroller_Method | null, services?: Array<{ __typename?: 'Service', id: string, slug?: string | null }> | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'SliderWithBlocks', type?: SliderWithBlocks_Type | null, paginationType?: SliderWithBlocks_PaginationType | null, autoScrollEnabled?: boolean | null, autoScrollSpeed?: number | null, id?: string | null, blockName?: string | null, blockType?: string | null, slidesToShow?: { __typename?: 'SliderWithBlocks_SlidesToShow', desktop?: number | null, tablet?: number | null, mobile?: number | null } | null, sliderWithBlocks: Array<{ __typename?: 'CardWithBlocks', color?: CardWithBlocks_Color | null, hasBorder?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, blocks?: Array<{ __typename?: 'Content', content?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'FormBlock', id?: string | null, blockName?: string | null, blockType?: string | null, form?: { __typename?: 'Form', id: string, title: string, submitButtonLabel?: string | null, confirmationType?: Form_ConfirmationType | null, confirmationMessage?: any | null, updatedAt?: any | null, createdAt?: any | null, fields?: Array<{ __typename?: 'Checkbox', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueBoolean?: boolean | null } | { __typename?: 'Email', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Message', message?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Number', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueNumber?: number | null } | { __typename?: 'Select', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Select_Options', label?: string | null, value?: string | null, id?: string | null }> | null } | { __typename?: 'Text', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Textarea', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Toggle', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Toggle_Options', label?: string | null, value?: string | null, id?: string | null }> | null }> | null, redirect?: { __typename?: 'Form_Redirect', url?: string | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Image', caption?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, imageSize?: Image_ImageSize | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Lists', id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, list?: Array<{ __typename?: 'Lists_List', color?: Lists_List_Color | null, title?: string | null, id?: string | null, items?: Array<{ __typename?: 'Lists_List_Items', id?: string | null, content?: string | null }> | null }> | null }> | null } | { __typename?: 'Content', content?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Image', caption?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, imageSize?: Image_ImageSize | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null }> }> | null, backgroundImage?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'CardWithBlocks', color?: CardWithBlocks_Color | null, hasBorder?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, blocks?: Array<{ __typename?: 'Content', content?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'FormBlock', id?: string | null, blockName?: string | null, blockType?: string | null, form?: { __typename?: 'Form', id: string, title: string, submitButtonLabel?: string | null, confirmationType?: Form_ConfirmationType | null, confirmationMessage?: any | null, updatedAt?: any | null, createdAt?: any | null, fields?: Array<{ __typename?: 'Checkbox', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueBoolean?: boolean | null } | { __typename?: 'Email', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Message', message?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Number', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueNumber?: number | null } | { __typename?: 'Select', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Select_Options', label?: string | null, value?: string | null, id?: string | null }> | null } | { __typename?: 'Text', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Textarea', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Toggle', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Toggle_Options', label?: string | null, value?: string | null, id?: string | null }> | null }> | null, redirect?: { __typename?: 'Form_Redirect', url?: string | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Image', caption?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, imageSize?: Image_ImageSize | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Lists', id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, list?: Array<{ __typename?: 'Lists_List', color?: Lists_List_Color | null, title?: string | null, id?: string | null, items?: Array<{ __typename?: 'Lists_List_Items', id?: string | null, content?: string | null }> | null }> | null }> | null } | { __typename?: 'Columns', id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, settings?: { __typename?: 'Columns_Settings', verticalAlignment?: Columns_Settings_VerticalAlignment | null, columnGapSize?: Columns_Settings_ColumnGapSize | null, flipOnMobile?: boolean | null } | null, columns?: Array<{ __typename?: 'Columns_Columns', id?: string | null, columnWidth?: Columns_Columns_ColumnWidth | null, blocks?: Array<{ __typename?: 'AnimatedTextBlock', text?: string | null, value?: number | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'CardWithBlocks', color?: CardWithBlocks_Color | null, hasBorder?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, blocks?: Array<{ __typename?: 'Content', content?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'FormBlock', id?: string | null, blockName?: string | null, blockType?: string | null, form?: { __typename?: 'Form', id: string, title: string, submitButtonLabel?: string | null, confirmationType?: Form_ConfirmationType | null, confirmationMessage?: any | null, updatedAt?: any | null, createdAt?: any | null, fields?: Array<{ __typename?: 'Checkbox', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueBoolean?: boolean | null } | { __typename?: 'Email', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Message', message?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Number', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueNumber?: number | null } | { __typename?: 'Select', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Select_Options', label?: string | null, value?: string | null, id?: string | null }> | null } | { __typename?: 'Text', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Textarea', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Toggle', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Toggle_Options', label?: string | null, value?: string | null, id?: string | null }> | null }> | null, redirect?: { __typename?: 'Form_Redirect', url?: string | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Image', caption?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, imageSize?: Image_ImageSize | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Lists', id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, list?: Array<{ __typename?: 'Lists_List', color?: Lists_List_Color | null, title?: string | null, id?: string | null, items?: Array<{ __typename?: 'Lists_List_Items', id?: string | null, content?: string | null }> | null }> | null }> | null } | { __typename?: 'Content', content?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Faq', id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, faqs?: Array<{ __typename?: 'Faq_Faqs', id?: string | null, question?: string | null, answer?: any | null }> | null } | { __typename?: 'FormBlock', id?: string | null, blockName?: string | null, blockType?: string | null, form?: { __typename?: 'Form', id: string, title: string, submitButtonLabel?: string | null, confirmationType?: Form_ConfirmationType | null, confirmationMessage?: any | null, updatedAt?: any | null, createdAt?: any | null, fields?: Array<{ __typename?: 'Checkbox', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueBoolean?: boolean | null } | { __typename?: 'Email', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Message', message?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Number', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueNumber?: number | null } | { __typename?: 'Select', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Select_Options', label?: string | null, value?: string | null, id?: string | null }> | null } | { __typename?: 'Text', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Textarea', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Toggle', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Toggle_Options', label?: string | null, value?: string | null, id?: string | null }> | null }> | null, redirect?: { __typename?: 'Form_Redirect', url?: string | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Image', caption?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, imageSize?: Image_ImageSize | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'SliderWithBlocks', type?: SliderWithBlocks_Type | null, paginationType?: SliderWithBlocks_PaginationType | null, autoScrollEnabled?: boolean | null, autoScrollSpeed?: number | null, id?: string | null, blockName?: string | null, blockType?: string | null, slidesToShow?: { __typename?: 'SliderWithBlocks_SlidesToShow', desktop?: number | null, tablet?: number | null, mobile?: number | null } | null, sliderWithBlocks: Array<{ __typename?: 'CardWithBlocks', color?: CardWithBlocks_Color | null, hasBorder?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, blocks?: Array<{ __typename?: 'Content', content?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'FormBlock', id?: string | null, blockName?: string | null, blockType?: string | null, form?: { __typename?: 'Form', id: string, title: string, submitButtonLabel?: string | null, confirmationType?: Form_ConfirmationType | null, confirmationMessage?: any | null, updatedAt?: any | null, createdAt?: any | null, fields?: Array<{ __typename?: 'Checkbox', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueBoolean?: boolean | null } | { __typename?: 'Email', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Message', message?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Number', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueNumber?: number | null } | { __typename?: 'Select', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Select_Options', label?: string | null, value?: string | null, id?: string | null }> | null } | { __typename?: 'Text', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Textarea', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Toggle', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Toggle_Options', label?: string | null, value?: string | null, id?: string | null }> | null }> | null, redirect?: { __typename?: 'Form_Redirect', url?: string | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Image', caption?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, imageSize?: Image_ImageSize | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Lists', id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, list?: Array<{ __typename?: 'Lists_List', color?: Lists_List_Color | null, title?: string | null, id?: string | null, items?: Array<{ __typename?: 'Lists_List_Items', id?: string | null, content?: string | null }> | null }> | null }> | null } | { __typename?: 'Content', content?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Image', caption?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, imageSize?: Image_ImageSize | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null }> } | { __typename?: 'Spacer', height?: number | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'VerticalSlider', autoScrollEnabled?: boolean | null, autoScrollSpeed?: number | null, id?: string | null, blockName?: string | null, blockType?: string | null, slides: Array<{ __typename?: 'CardWithBlocks', color?: CardWithBlocks_Color | null, hasBorder?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, blocks?: Array<{ __typename?: 'Content', content?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'FormBlock', id?: string | null, blockName?: string | null, blockType?: string | null, form?: { __typename?: 'Form', id: string, title: string, submitButtonLabel?: string | null, confirmationType?: Form_ConfirmationType | null, confirmationMessage?: any | null, updatedAt?: any | null, createdAt?: any | null, fields?: Array<{ __typename?: 'Checkbox', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueBoolean?: boolean | null } | { __typename?: 'Email', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Message', message?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Number', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueNumber?: number | null } | { __typename?: 'Select', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Select_Options', label?: string | null, value?: string | null, id?: string | null }> | null } | { __typename?: 'Text', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Textarea', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Toggle', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Toggle_Options', label?: string | null, value?: string | null, id?: string | null }> | null }> | null, redirect?: { __typename?: 'Form_Redirect', url?: string | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Image', caption?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, imageSize?: Image_ImageSize | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Lists', id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, list?: Array<{ __typename?: 'Lists_List', color?: Lists_List_Color | null, title?: string | null, id?: string | null, items?: Array<{ __typename?: 'Lists_List_Items', id?: string | null, content?: string | null }> | null }> | null }> | null }>, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null }> | null }> | null } | { __typename?: 'Comparisons', showLeftContent?: boolean | null, leftContent?: any | null, secondaryComparison?: any | null, primaryComparison?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Content', content?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Cta', title?: string | null, id?: string | null, blockName?: string | null, blockType?: string | null, ctaContent?: string | null, button?: { __typename?: 'Cta_Button', buttonType?: Cta_Button_ButtonType | null, link?: { __typename?: 'Link', type?: Link_Type | null, label?: string | null, url?: string | null, reference?: { __typename?: 'Link_Reference_Relationship', relationTo?: Link_Reference_RelationTo | null, value?: { __typename?: 'Article', slug?: string | null, categories?: Array<{ __typename?: 'Category', slug?: string | null }> | null } | { __typename?: 'LeadForm', slug?: string | null } | { __typename?: 'Page', slug?: string | null } | { __typename?: 'Service', slug?: string | null } | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'CtaButton', buttonType?: CtaButton_ButtonType | null, content?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, link?: { __typename?: 'Link', type?: Link_Type | null, label?: string | null, url?: string | null, reference?: { __typename?: 'Link_Reference_Relationship', relationTo?: Link_Reference_RelationTo | null, value?: { __typename?: 'Article', slug?: string | null, categories?: Array<{ __typename?: 'Category', slug?: string | null }> | null } | { __typename?: 'LeadForm', slug?: string | null } | { __typename?: 'Page', slug?: string | null } | { __typename?: 'Service', slug?: string | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Faq', id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, faqs?: Array<{ __typename?: 'Faq_Faqs', id?: string | null, question?: string | null, answer?: any | null }> | null } | { __typename?: 'FormBlock', id?: string | null, blockName?: string | null, blockType?: string | null, form?: { __typename?: 'Form', id: string, title: string, submitButtonLabel?: string | null, confirmationType?: Form_ConfirmationType | null, confirmationMessage?: any | null, updatedAt?: any | null, createdAt?: any | null, fields?: Array<{ __typename?: 'Checkbox', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueBoolean?: boolean | null } | { __typename?: 'Email', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Message', message?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Number', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueNumber?: number | null } | { __typename?: 'Select', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Select_Options', label?: string | null, value?: string | null, id?: string | null }> | null } | { __typename?: 'Text', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Textarea', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Toggle', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Toggle_Options', label?: string | null, value?: string | null, id?: string | null }> | null }> | null, redirect?: { __typename?: 'Form_Redirect', url?: string | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Image', caption?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, imageSize?: Image_ImageSize | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'LeadFormBlock', id?: string | null, blockName?: string | null, blockType?: string | null, leadForm?: { __typename?: 'LeadForm', id: string, slug?: string | null } | null } | { __typename?: 'Lists', id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, list?: Array<{ __typename?: 'Lists_List', color?: Lists_List_Color | null, title?: string | null, id?: string | null, items?: Array<{ __typename?: 'Lists_List_Items', id?: string | null, content?: string | null }> | null }> | null } | { __typename?: 'ServicesScroller', id?: string | null, blockName?: string | null, blockType?: string | null, serviceScrollerMethod?: ServicesScroller_Method | null, services?: Array<{ __typename?: 'Service', id: string, slug?: string | null }> | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'SliderWithBlocks', type?: SliderWithBlocks_Type | null, paginationType?: SliderWithBlocks_PaginationType | null, autoScrollEnabled?: boolean | null, autoScrollSpeed?: number | null, id?: string | null, blockName?: string | null, blockType?: string | null, slidesToShow?: { __typename?: 'SliderWithBlocks_SlidesToShow', desktop?: number | null, tablet?: number | null, mobile?: number | null } | null, sliderWithBlocks: Array<{ __typename?: 'CardWithBlocks', color?: CardWithBlocks_Color | null, hasBorder?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, blocks?: Array<{ __typename?: 'Content', content?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'FormBlock', id?: string | null, blockName?: string | null, blockType?: string | null, form?: { __typename?: 'Form', id: string, title: string, submitButtonLabel?: string | null, confirmationType?: Form_ConfirmationType | null, confirmationMessage?: any | null, updatedAt?: any | null, createdAt?: any | null, fields?: Array<{ __typename?: 'Checkbox', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueBoolean?: boolean | null } | { __typename?: 'Email', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Message', message?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Number', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueNumber?: number | null } | { __typename?: 'Select', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Select_Options', label?: string | null, value?: string | null, id?: string | null }> | null } | { __typename?: 'Text', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Textarea', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Toggle', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Toggle_Options', label?: string | null, value?: string | null, id?: string | null }> | null }> | null, redirect?: { __typename?: 'Form_Redirect', url?: string | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Image', caption?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, imageSize?: Image_ImageSize | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Lists', id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, list?: Array<{ __typename?: 'Lists_List', color?: Lists_List_Color | null, title?: string | null, id?: string | null, items?: Array<{ __typename?: 'Lists_List_Items', id?: string | null, content?: string | null }> | null }> | null }> | null } | { __typename?: 'Content', content?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Image', caption?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, imageSize?: Image_ImageSize | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null }> } | { __typename?: 'Spacer', height?: number | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'StickyImageScroll', id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, items?: Array<{ __typename?: 'StickyImageScroll_Items', content?: any | null, showImageNode?: boolean | null, imageNode?: { __typename?: 'StickyImageScroll_Items_ImageNode', x?: number | null, y?: number | null, icon?: string | null } | null }> | null } | { __typename?: 'VerticalSlider', autoScrollEnabled?: boolean | null, autoScrollSpeed?: number | null, id?: string | null, blockName?: string | null, blockType?: string | null, slides: Array<{ __typename?: 'CardWithBlocks', color?: CardWithBlocks_Color | null, hasBorder?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, blocks?: Array<{ __typename?: 'Content', content?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'FormBlock', id?: string | null, blockName?: string | null, blockType?: string | null, form?: { __typename?: 'Form', id: string, title: string, submitButtonLabel?: string | null, confirmationType?: Form_ConfirmationType | null, confirmationMessage?: any | null, updatedAt?: any | null, createdAt?: any | null, fields?: Array<{ __typename?: 'Checkbox', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueBoolean?: boolean | null } | { __typename?: 'Email', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Message', message?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Number', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueNumber?: number | null } | { __typename?: 'Select', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Select_Options', label?: string | null, value?: string | null, id?: string | null }> | null } | { __typename?: 'Text', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Textarea', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Toggle', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Toggle_Options', label?: string | null, value?: string | null, id?: string | null }> | null }> | null, redirect?: { __typename?: 'Form_Redirect', url?: string | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Image', caption?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, imageSize?: Image_ImageSize | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Lists', id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, list?: Array<{ __typename?: 'Lists_List', color?: Lists_List_Color | null, title?: string | null, id?: string | null, items?: Array<{ __typename?: 'Lists_List_Items', id?: string | null, content?: string | null }> | null }> | null }> | null }>, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null }> | null } | null, meta?: { __typename?: 'Page_Meta', title?: string | null, description?: string | null, noIndex?: boolean | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null } | null } | null> | null } | null };

export type ServiceQueryVariables = Exact<{
  draft?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<Service_Where>;
}>;


export type ServiceQuery = { __typename?: 'Query', Services?: { __typename?: 'Services', docs?: Array<{ __typename?: 'Service', id: string, title?: string | null, description?: any | null, slug?: string | null, updatedAt?: any | null, createdAt?: any | null, showGetAQuoteSideDrawer?: boolean | null, titleSettings?: { __typename?: 'Page_TitleSettings', boldStartIndex?: number | null, boldEndIndex?: number | null } | null, header?: { __typename?: 'Service_Header', type?: Service_Header_Type | null, beforeFeaturedFormContent?: any | null, showLookingForForm?: boolean | null, showRatingWidget?: boolean | null, featuredForm?: { __typename?: 'Form', id: string, title: string, submitButtonLabel?: string | null, confirmationType?: Form_ConfirmationType | null, confirmationMessage?: any | null, updatedAt?: any | null, createdAt?: any | null, fields?: Array<{ __typename?: 'Checkbox', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueBoolean?: boolean | null } | { __typename?: 'Email', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Message', message?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Number', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueNumber?: number | null } | { __typename?: 'Select', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Select_Options', label?: string | null, value?: string | null, id?: string | null }> | null } | { __typename?: 'Text', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Textarea', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Toggle', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Toggle_Options', label?: string | null, value?: string | null, id?: string | null }> | null }> | null, redirect?: { __typename?: 'Form_Redirect', url?: string | null } | null } | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null } | null, layout?: { __typename?: 'Service_Layout', blocks?: Array<{ __typename?: 'AnimatedTextBlock', text?: string | null, value?: number | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'ArticlesScroller', method?: ArticlesScroller_Method | null, id?: string | null, blockName?: string | null, blockType?: string | null, categories?: Array<{ __typename?: 'Category', id: string }> | null, tags?: Array<{ __typename?: 'Tag', id: string }> | null, articles?: Array<{ __typename?: 'Article', id: string, slug?: string | null }> | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'BackgroundWithBlock', backgroundColor?: BackgroundWithBlock_BackgroundColor | null, containerWidth?: BackgroundWithBlock_ContainerWidth | null, hasBackgroundGridImage?: boolean | null, showBackgroundImage?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, backgroundWithBlocks?: Array<{ __typename?: 'Columns', id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, settings?: { __typename?: 'Columns_Settings', verticalAlignment?: Columns_Settings_VerticalAlignment | null, columnGapSize?: Columns_Settings_ColumnGapSize | null, flipOnMobile?: boolean | null } | null, columns?: Array<{ __typename?: 'Columns_Columns', id?: string | null, columnWidth?: Columns_Columns_ColumnWidth | null, blocks?: Array<{ __typename?: 'AnimatedTextBlock', text?: string | null, value?: number | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'CardWithBlocks', color?: CardWithBlocks_Color | null, hasBorder?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, blocks?: Array<{ __typename?: 'Content', content?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'FormBlock', id?: string | null, blockName?: string | null, blockType?: string | null, form?: { __typename?: 'Form', id: string, title: string, submitButtonLabel?: string | null, confirmationType?: Form_ConfirmationType | null, confirmationMessage?: any | null, updatedAt?: any | null, createdAt?: any | null, fields?: Array<{ __typename?: 'Checkbox', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueBoolean?: boolean | null } | { __typename?: 'Email', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Message', message?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Number', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueNumber?: number | null } | { __typename?: 'Select', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Select_Options', label?: string | null, value?: string | null, id?: string | null }> | null } | { __typename?: 'Text', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Textarea', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Toggle', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Toggle_Options', label?: string | null, value?: string | null, id?: string | null }> | null }> | null, redirect?: { __typename?: 'Form_Redirect', url?: string | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Image', caption?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, imageSize?: Image_ImageSize | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Lists', id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, list?: Array<{ __typename?: 'Lists_List', color?: Lists_List_Color | null, title?: string | null, id?: string | null, items?: Array<{ __typename?: 'Lists_List_Items', id?: string | null, content?: string | null }> | null }> | null }> | null } | { __typename?: 'Content', content?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Faq', id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, faqs?: Array<{ __typename?: 'Faq_Faqs', id?: string | null, question?: string | null, answer?: any | null }> | null } | { __typename?: 'FormBlock', id?: string | null, blockName?: string | null, blockType?: string | null, form?: { __typename?: 'Form', id: string, title: string, submitButtonLabel?: string | null, confirmationType?: Form_ConfirmationType | null, confirmationMessage?: any | null, updatedAt?: any | null, createdAt?: any | null, fields?: Array<{ __typename?: 'Checkbox', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueBoolean?: boolean | null } | { __typename?: 'Email', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Message', message?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Number', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueNumber?: number | null } | { __typename?: 'Select', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Select_Options', label?: string | null, value?: string | null, id?: string | null }> | null } | { __typename?: 'Text', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Textarea', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Toggle', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Toggle_Options', label?: string | null, value?: string | null, id?: string | null }> | null }> | null, redirect?: { __typename?: 'Form_Redirect', url?: string | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Image', caption?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, imageSize?: Image_ImageSize | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'SliderWithBlocks', type?: SliderWithBlocks_Type | null, paginationType?: SliderWithBlocks_PaginationType | null, autoScrollEnabled?: boolean | null, autoScrollSpeed?: number | null, id?: string | null, blockName?: string | null, blockType?: string | null, slidesToShow?: { __typename?: 'SliderWithBlocks_SlidesToShow', desktop?: number | null, tablet?: number | null, mobile?: number | null } | null, sliderWithBlocks: Array<{ __typename?: 'CardWithBlocks', color?: CardWithBlocks_Color | null, hasBorder?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, blocks?: Array<{ __typename?: 'Content', content?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'FormBlock', id?: string | null, blockName?: string | null, blockType?: string | null, form?: { __typename?: 'Form', id: string, title: string, submitButtonLabel?: string | null, confirmationType?: Form_ConfirmationType | null, confirmationMessage?: any | null, updatedAt?: any | null, createdAt?: any | null, fields?: Array<{ __typename?: 'Checkbox', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueBoolean?: boolean | null } | { __typename?: 'Email', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Message', message?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Number', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueNumber?: number | null } | { __typename?: 'Select', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Select_Options', label?: string | null, value?: string | null, id?: string | null }> | null } | { __typename?: 'Text', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Textarea', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Toggle', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Toggle_Options', label?: string | null, value?: string | null, id?: string | null }> | null }> | null, redirect?: { __typename?: 'Form_Redirect', url?: string | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Image', caption?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, imageSize?: Image_ImageSize | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Lists', id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, list?: Array<{ __typename?: 'Lists_List', color?: Lists_List_Color | null, title?: string | null, id?: string | null, items?: Array<{ __typename?: 'Lists_List_Items', id?: string | null, content?: string | null }> | null }> | null }> | null } | { __typename?: 'Content', content?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Image', caption?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, imageSize?: Image_ImageSize | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null }> } | { __typename?: 'Spacer', height?: number | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'VerticalSlider', autoScrollEnabled?: boolean | null, autoScrollSpeed?: number | null, id?: string | null, blockName?: string | null, blockType?: string | null, slides: Array<{ __typename?: 'CardWithBlocks', color?: CardWithBlocks_Color | null, hasBorder?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, blocks?: Array<{ __typename?: 'Content', content?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'FormBlock', id?: string | null, blockName?: string | null, blockType?: string | null, form?: { __typename?: 'Form', id: string, title: string, submitButtonLabel?: string | null, confirmationType?: Form_ConfirmationType | null, confirmationMessage?: any | null, updatedAt?: any | null, createdAt?: any | null, fields?: Array<{ __typename?: 'Checkbox', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueBoolean?: boolean | null } | { __typename?: 'Email', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Message', message?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Number', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueNumber?: number | null } | { __typename?: 'Select', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Select_Options', label?: string | null, value?: string | null, id?: string | null }> | null } | { __typename?: 'Text', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Textarea', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Toggle', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Toggle_Options', label?: string | null, value?: string | null, id?: string | null }> | null }> | null, redirect?: { __typename?: 'Form_Redirect', url?: string | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Image', caption?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, imageSize?: Image_ImageSize | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Lists', id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, list?: Array<{ __typename?: 'Lists_List', color?: Lists_List_Color | null, title?: string | null, id?: string | null, items?: Array<{ __typename?: 'Lists_List_Items', id?: string | null, content?: string | null }> | null }> | null }> | null }>, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null }> | null }> | null } | { __typename?: 'Content', content?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'ServicesScroller', id?: string | null, blockName?: string | null, blockType?: string | null, serviceScrollerMethod?: ServicesScroller_Method | null, services?: Array<{ __typename?: 'Service', id: string, slug?: string | null }> | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'SliderWithBlocks', type?: SliderWithBlocks_Type | null, paginationType?: SliderWithBlocks_PaginationType | null, autoScrollEnabled?: boolean | null, autoScrollSpeed?: number | null, id?: string | null, blockName?: string | null, blockType?: string | null, slidesToShow?: { __typename?: 'SliderWithBlocks_SlidesToShow', desktop?: number | null, tablet?: number | null, mobile?: number | null } | null, sliderWithBlocks: Array<{ __typename?: 'CardWithBlocks', color?: CardWithBlocks_Color | null, hasBorder?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, blocks?: Array<{ __typename?: 'Content', content?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'FormBlock', id?: string | null, blockName?: string | null, blockType?: string | null, form?: { __typename?: 'Form', id: string, title: string, submitButtonLabel?: string | null, confirmationType?: Form_ConfirmationType | null, confirmationMessage?: any | null, updatedAt?: any | null, createdAt?: any | null, fields?: Array<{ __typename?: 'Checkbox', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueBoolean?: boolean | null } | { __typename?: 'Email', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Message', message?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Number', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueNumber?: number | null } | { __typename?: 'Select', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Select_Options', label?: string | null, value?: string | null, id?: string | null }> | null } | { __typename?: 'Text', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Textarea', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Toggle', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Toggle_Options', label?: string | null, value?: string | null, id?: string | null }> | null }> | null, redirect?: { __typename?: 'Form_Redirect', url?: string | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Image', caption?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, imageSize?: Image_ImageSize | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Lists', id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, list?: Array<{ __typename?: 'Lists_List', color?: Lists_List_Color | null, title?: string | null, id?: string | null, items?: Array<{ __typename?: 'Lists_List_Items', id?: string | null, content?: string | null }> | null }> | null }> | null } | { __typename?: 'Content', content?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Image', caption?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, imageSize?: Image_ImageSize | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null }> }> | null, backgroundImage?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'CardWithBlocks', color?: CardWithBlocks_Color | null, hasBorder?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, blocks?: Array<{ __typename?: 'Content', content?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'FormBlock', id?: string | null, blockName?: string | null, blockType?: string | null, form?: { __typename?: 'Form', id: string, title: string, submitButtonLabel?: string | null, confirmationType?: Form_ConfirmationType | null, confirmationMessage?: any | null, updatedAt?: any | null, createdAt?: any | null, fields?: Array<{ __typename?: 'Checkbox', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueBoolean?: boolean | null } | { __typename?: 'Email', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Message', message?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Number', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueNumber?: number | null } | { __typename?: 'Select', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Select_Options', label?: string | null, value?: string | null, id?: string | null }> | null } | { __typename?: 'Text', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Textarea', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Toggle', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Toggle_Options', label?: string | null, value?: string | null, id?: string | null }> | null }> | null, redirect?: { __typename?: 'Form_Redirect', url?: string | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Image', caption?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, imageSize?: Image_ImageSize | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Lists', id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, list?: Array<{ __typename?: 'Lists_List', color?: Lists_List_Color | null, title?: string | null, id?: string | null, items?: Array<{ __typename?: 'Lists_List_Items', id?: string | null, content?: string | null }> | null }> | null }> | null } | { __typename?: 'Columns', id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, settings?: { __typename?: 'Columns_Settings', verticalAlignment?: Columns_Settings_VerticalAlignment | null, columnGapSize?: Columns_Settings_ColumnGapSize | null, flipOnMobile?: boolean | null } | null, columns?: Array<{ __typename?: 'Columns_Columns', id?: string | null, columnWidth?: Columns_Columns_ColumnWidth | null, blocks?: Array<{ __typename?: 'AnimatedTextBlock', text?: string | null, value?: number | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'CardWithBlocks', color?: CardWithBlocks_Color | null, hasBorder?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, blocks?: Array<{ __typename?: 'Content', content?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'FormBlock', id?: string | null, blockName?: string | null, blockType?: string | null, form?: { __typename?: 'Form', id: string, title: string, submitButtonLabel?: string | null, confirmationType?: Form_ConfirmationType | null, confirmationMessage?: any | null, updatedAt?: any | null, createdAt?: any | null, fields?: Array<{ __typename?: 'Checkbox', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueBoolean?: boolean | null } | { __typename?: 'Email', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Message', message?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Number', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueNumber?: number | null } | { __typename?: 'Select', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Select_Options', label?: string | null, value?: string | null, id?: string | null }> | null } | { __typename?: 'Text', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Textarea', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Toggle', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Toggle_Options', label?: string | null, value?: string | null, id?: string | null }> | null }> | null, redirect?: { __typename?: 'Form_Redirect', url?: string | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Image', caption?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, imageSize?: Image_ImageSize | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Lists', id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, list?: Array<{ __typename?: 'Lists_List', color?: Lists_List_Color | null, title?: string | null, id?: string | null, items?: Array<{ __typename?: 'Lists_List_Items', id?: string | null, content?: string | null }> | null }> | null }> | null } | { __typename?: 'Content', content?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Faq', id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, faqs?: Array<{ __typename?: 'Faq_Faqs', id?: string | null, question?: string | null, answer?: any | null }> | null } | { __typename?: 'FormBlock', id?: string | null, blockName?: string | null, blockType?: string | null, form?: { __typename?: 'Form', id: string, title: string, submitButtonLabel?: string | null, confirmationType?: Form_ConfirmationType | null, confirmationMessage?: any | null, updatedAt?: any | null, createdAt?: any | null, fields?: Array<{ __typename?: 'Checkbox', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueBoolean?: boolean | null } | { __typename?: 'Email', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Message', message?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Number', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueNumber?: number | null } | { __typename?: 'Select', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Select_Options', label?: string | null, value?: string | null, id?: string | null }> | null } | { __typename?: 'Text', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Textarea', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Toggle', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Toggle_Options', label?: string | null, value?: string | null, id?: string | null }> | null }> | null, redirect?: { __typename?: 'Form_Redirect', url?: string | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Image', caption?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, imageSize?: Image_ImageSize | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'SliderWithBlocks', type?: SliderWithBlocks_Type | null, paginationType?: SliderWithBlocks_PaginationType | null, autoScrollEnabled?: boolean | null, autoScrollSpeed?: number | null, id?: string | null, blockName?: string | null, blockType?: string | null, slidesToShow?: { __typename?: 'SliderWithBlocks_SlidesToShow', desktop?: number | null, tablet?: number | null, mobile?: number | null } | null, sliderWithBlocks: Array<{ __typename?: 'CardWithBlocks', color?: CardWithBlocks_Color | null, hasBorder?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, blocks?: Array<{ __typename?: 'Content', content?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'FormBlock', id?: string | null, blockName?: string | null, blockType?: string | null, form?: { __typename?: 'Form', id: string, title: string, submitButtonLabel?: string | null, confirmationType?: Form_ConfirmationType | null, confirmationMessage?: any | null, updatedAt?: any | null, createdAt?: any | null, fields?: Array<{ __typename?: 'Checkbox', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueBoolean?: boolean | null } | { __typename?: 'Email', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Message', message?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Number', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueNumber?: number | null } | { __typename?: 'Select', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Select_Options', label?: string | null, value?: string | null, id?: string | null }> | null } | { __typename?: 'Text', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Textarea', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Toggle', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Toggle_Options', label?: string | null, value?: string | null, id?: string | null }> | null }> | null, redirect?: { __typename?: 'Form_Redirect', url?: string | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Image', caption?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, imageSize?: Image_ImageSize | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Lists', id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, list?: Array<{ __typename?: 'Lists_List', color?: Lists_List_Color | null, title?: string | null, id?: string | null, items?: Array<{ __typename?: 'Lists_List_Items', id?: string | null, content?: string | null }> | null }> | null }> | null } | { __typename?: 'Content', content?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Image', caption?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, imageSize?: Image_ImageSize | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null }> } | { __typename?: 'Spacer', height?: number | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'VerticalSlider', autoScrollEnabled?: boolean | null, autoScrollSpeed?: number | null, id?: string | null, blockName?: string | null, blockType?: string | null, slides: Array<{ __typename?: 'CardWithBlocks', color?: CardWithBlocks_Color | null, hasBorder?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, blocks?: Array<{ __typename?: 'Content', content?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'FormBlock', id?: string | null, blockName?: string | null, blockType?: string | null, form?: { __typename?: 'Form', id: string, title: string, submitButtonLabel?: string | null, confirmationType?: Form_ConfirmationType | null, confirmationMessage?: any | null, updatedAt?: any | null, createdAt?: any | null, fields?: Array<{ __typename?: 'Checkbox', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueBoolean?: boolean | null } | { __typename?: 'Email', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Message', message?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Number', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueNumber?: number | null } | { __typename?: 'Select', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Select_Options', label?: string | null, value?: string | null, id?: string | null }> | null } | { __typename?: 'Text', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Textarea', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Toggle', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Toggle_Options', label?: string | null, value?: string | null, id?: string | null }> | null }> | null, redirect?: { __typename?: 'Form_Redirect', url?: string | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Image', caption?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, imageSize?: Image_ImageSize | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Lists', id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, list?: Array<{ __typename?: 'Lists_List', color?: Lists_List_Color | null, title?: string | null, id?: string | null, items?: Array<{ __typename?: 'Lists_List_Items', id?: string | null, content?: string | null }> | null }> | null }> | null }>, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null }> | null }> | null } | { __typename?: 'Comparisons', showLeftContent?: boolean | null, leftContent?: any | null, secondaryComparison?: any | null, primaryComparison?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Content', content?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Cta', title?: string | null, id?: string | null, blockName?: string | null, blockType?: string | null, ctaContent?: string | null, button?: { __typename?: 'Cta_Button', buttonType?: Cta_Button_ButtonType | null, link?: { __typename?: 'Link', type?: Link_Type | null, label?: string | null, url?: string | null, reference?: { __typename?: 'Link_Reference_Relationship', relationTo?: Link_Reference_RelationTo | null, value?: { __typename?: 'Article', slug?: string | null, categories?: Array<{ __typename?: 'Category', slug?: string | null }> | null } | { __typename?: 'LeadForm', slug?: string | null } | { __typename?: 'Page', slug?: string | null } | { __typename?: 'Service', slug?: string | null } | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'CtaButton', buttonType?: CtaButton_ButtonType | null, content?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, link?: { __typename?: 'Link', type?: Link_Type | null, label?: string | null, url?: string | null, reference?: { __typename?: 'Link_Reference_Relationship', relationTo?: Link_Reference_RelationTo | null, value?: { __typename?: 'Article', slug?: string | null, categories?: Array<{ __typename?: 'Category', slug?: string | null }> | null } | { __typename?: 'LeadForm', slug?: string | null } | { __typename?: 'Page', slug?: string | null } | { __typename?: 'Service', slug?: string | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Faq', id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, faqs?: Array<{ __typename?: 'Faq_Faqs', id?: string | null, question?: string | null, answer?: any | null }> | null } | { __typename?: 'FormBlock', id?: string | null, blockName?: string | null, blockType?: string | null, form?: { __typename?: 'Form', id: string, title: string, submitButtonLabel?: string | null, confirmationType?: Form_ConfirmationType | null, confirmationMessage?: any | null, updatedAt?: any | null, createdAt?: any | null, fields?: Array<{ __typename?: 'Checkbox', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueBoolean?: boolean | null } | { __typename?: 'Email', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Message', message?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Number', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueNumber?: number | null } | { __typename?: 'Select', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Select_Options', label?: string | null, value?: string | null, id?: string | null }> | null } | { __typename?: 'Text', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Textarea', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Toggle', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Toggle_Options', label?: string | null, value?: string | null, id?: string | null }> | null }> | null, redirect?: { __typename?: 'Form_Redirect', url?: string | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Image', caption?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, imageSize?: Image_ImageSize | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'LeadFormBlock', id?: string | null, blockName?: string | null, blockType?: string | null, leadForm?: { __typename?: 'LeadForm', id: string, slug?: string | null } | null } | { __typename?: 'Lists', id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, list?: Array<{ __typename?: 'Lists_List', color?: Lists_List_Color | null, title?: string | null, id?: string | null, items?: Array<{ __typename?: 'Lists_List_Items', id?: string | null, content?: string | null }> | null }> | null } | { __typename?: 'SliderWithBlocks', type?: SliderWithBlocks_Type | null, paginationType?: SliderWithBlocks_PaginationType | null, autoScrollEnabled?: boolean | null, autoScrollSpeed?: number | null, id?: string | null, blockName?: string | null, blockType?: string | null, slidesToShow?: { __typename?: 'SliderWithBlocks_SlidesToShow', desktop?: number | null, tablet?: number | null, mobile?: number | null } | null, sliderWithBlocks: Array<{ __typename?: 'CardWithBlocks', color?: CardWithBlocks_Color | null, hasBorder?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, blocks?: Array<{ __typename?: 'Content', content?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'FormBlock', id?: string | null, blockName?: string | null, blockType?: string | null, form?: { __typename?: 'Form', id: string, title: string, submitButtonLabel?: string | null, confirmationType?: Form_ConfirmationType | null, confirmationMessage?: any | null, updatedAt?: any | null, createdAt?: any | null, fields?: Array<{ __typename?: 'Checkbox', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueBoolean?: boolean | null } | { __typename?: 'Email', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Message', message?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Number', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueNumber?: number | null } | { __typename?: 'Select', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Select_Options', label?: string | null, value?: string | null, id?: string | null }> | null } | { __typename?: 'Text', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Textarea', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Toggle', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Toggle_Options', label?: string | null, value?: string | null, id?: string | null }> | null }> | null, redirect?: { __typename?: 'Form_Redirect', url?: string | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Image', caption?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, imageSize?: Image_ImageSize | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Lists', id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, list?: Array<{ __typename?: 'Lists_List', color?: Lists_List_Color | null, title?: string | null, id?: string | null, items?: Array<{ __typename?: 'Lists_List_Items', id?: string | null, content?: string | null }> | null }> | null }> | null } | { __typename?: 'Content', content?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Image', caption?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, imageSize?: Image_ImageSize | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null }> } | { __typename?: 'Spacer', height?: number | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'VerticalSlider', autoScrollEnabled?: boolean | null, autoScrollSpeed?: number | null, id?: string | null, blockName?: string | null, blockType?: string | null, slides: Array<{ __typename?: 'CardWithBlocks', color?: CardWithBlocks_Color | null, hasBorder?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, blocks?: Array<{ __typename?: 'Content', content?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'FormBlock', id?: string | null, blockName?: string | null, blockType?: string | null, form?: { __typename?: 'Form', id: string, title: string, submitButtonLabel?: string | null, confirmationType?: Form_ConfirmationType | null, confirmationMessage?: any | null, updatedAt?: any | null, createdAt?: any | null, fields?: Array<{ __typename?: 'Checkbox', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueBoolean?: boolean | null } | { __typename?: 'Email', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Message', message?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Number', name: string, label?: string | null, width?: number | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, defaultValueNumber?: number | null } | { __typename?: 'Select', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Select_Options', label?: string | null, value?: string | null, id?: string | null }> | null } | { __typename?: 'Text', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Textarea', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null } | { __typename?: 'Toggle', name: string, label?: string | null, width?: number | null, defaultValue?: string | null, required?: boolean | null, id?: string | null, blockName?: string | null, blockType?: string | null, options?: Array<{ __typename?: 'Toggle_Options', label?: string | null, value?: string | null, id?: string | null }> | null }> | null, redirect?: { __typename?: 'Form_Redirect', url?: string | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Image', caption?: any | null, id?: string | null, blockName?: string | null, blockType?: string | null, imageSize?: Image_ImageSize | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null } | { __typename?: 'Lists', id?: string | null, blockName?: string | null, blockType?: string | null, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null, list?: Array<{ __typename?: 'Lists_List', color?: Lists_List_Color | null, title?: string | null, id?: string | null, items?: Array<{ __typename?: 'Lists_List_Items', id?: string | null, content?: string | null }> | null }> | null }> | null }>, blockSettings?: { __typename?: 'BlockSettings', margin?: { __typename?: 'BlockSettings_Margin', marginBottom?: BlockSettings_Margin_MarginBottom | null } | null, padding?: { __typename?: 'BlockSettings_Padding', paddingBottom?: BlockSettings_Padding_PaddingBottom | null, paddingLeft?: BlockSettings_Padding_PaddingLeft | null, paddingRight?: BlockSettings_Padding_PaddingRight | null, paddingTop?: BlockSettings_Padding_PaddingTop | null } | null } | null }> | null } | null, meta?: { __typename?: 'Service_Meta', title?: string | null, description?: string | null, noIndex?: boolean | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null } | null } | null> | null } | null };

export type ServicesQueryVariables = Exact<{
  where?: InputMaybe<Service_Where>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['String']>;
}>;


export type ServicesQuery = { __typename?: 'Query', Services?: { __typename?: 'Services', docs?: Array<{ __typename?: 'Service', id: string, title?: string | null, description?: any | null, excerpt?: string | null, shortTitle?: string | null, slug?: string | null, updatedAt?: any | null, createdAt?: any | null, header?: { __typename?: 'Service_Header', type?: Service_Header_Type | null, image?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null } | null, featuredImage?: { __typename?: 'Media', id: string, alt: string, updatedAt?: any | null, createdAt?: any | null, url?: string | null, filename?: string | null, mimeType?: string | null, filesize?: number | null, width?: number | null, height?: number | null, focalX?: number | null, focalY?: number | null, sizes?: { __typename?: 'Media_Sizes', card?: { __typename?: 'Media_Sizes_Card', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null, feature?: { __typename?: 'Media_Sizes_Feature', url?: string | null, width?: number | null, height?: number | null, mimeType?: string | null, filesize?: number | null, filename?: string | null } | null } | null } | null } | null> | null } | null };

export type SocialMediaQueryVariables = Exact<{
  draft?: InputMaybe<Scalars['Boolean']>;
}>;


export type SocialMediaQuery = { __typename?: 'Query', SocialMedia?: { __typename?: 'SocialMedia', facebook?: string | null, instagram?: string | null, updatedAt?: any | null, createdAt?: any | null } | null };

export type TagsQueryVariables = Exact<{
  draft?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<Tag_Where>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  pagination?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<Scalars['String']>;
}>;


export type TagsQuery = { __typename?: 'Query', Tags?: { __typename?: 'Tags', hasNextPage?: boolean | null, hasPrevPage?: boolean | null, limit?: number | null, nextPage?: number | null, offset?: number | null, page?: number | null, pagingCounter?: number | null, prevPage?: number | null, totalDocs?: number | null, totalPages?: number | null, docs?: Array<{ __typename?: 'Tag', id: string, title: string, updatedAt?: any | null, createdAt?: any | null } | null> | null } | null };

/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
  EmailAddress: any;
  JSON: any;
  JSONObject: any;
};

export type Access = {
  __typename?: 'Access';
  article?: Maybe<ArticleAccess>;
  canAccessAdmin: Scalars['Boolean'];
  category?: Maybe<CategoryAccess>;
  cta_banner?: Maybe<Cta_BannerAccess>;
  epc_check_form_submission?: Maybe<Epc_Check_Form_SubmissionAccess>;
  footer_menu?: Maybe<Footer_MenuAccess>;
  form_submissions?: Maybe<Form_SubmissionsAccess>;
  forms?: Maybe<FormsAccess>;
  header_menu?: Maybe<Header_MenuAccess>;
  hidden_blocks?: Maybe<Hidden_BlocksAccess>;
  landing_page?: Maybe<Landing_PageAccess>;
  landing_tumbler?: Maybe<Landing_TumblerAccess>;
  lead_form?: Maybe<Lead_FormAccess>;
  media?: Maybe<MediaAccess>;
  newsletter_subscriber?: Maybe<Newsletter_SubscriberAccess>;
  page?: Maybe<PageAccess>;
  payload_locked_documents?: Maybe<Payload_Locked_DocumentsAccess>;
  payload_preferences?: Maybe<Payload_PreferencesAccess>;
  service?: Maybe<ServiceAccess>;
  social_media?: Maybe<Social_MediaAccess>;
  tag?: Maybe<TagAccess>;
  user?: Maybe<UserAccess>;
};

export type AnimatedTextBlock = {
  __typename?: 'AnimatedTextBlock';
  blockName?: Maybe<Scalars['String']>;
  blockType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
};

export type Article = {
  __typename?: 'Article';
  _status?: Maybe<Article__Status>;
  author?: Maybe<User>;
  categories?: Maybe<Array<Category>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  excerpt?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  image?: Maybe<Media>;
  layout?: Maybe<Array<Article_Layout>>;
  meta?: Maybe<Article_Meta>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  slug?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Tag>>;
  timeToRead?: Maybe<Scalars['Float']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ArticleCreateAccess = {
  __typename?: 'ArticleCreateAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type ArticleCreateDocAccess = {
  __typename?: 'ArticleCreateDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type ArticleDeleteAccess = {
  __typename?: 'ArticleDeleteAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type ArticleDeleteDocAccess = {
  __typename?: 'ArticleDeleteDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type ArticleDocAccessFields = {
  __typename?: 'ArticleDocAccessFields';
  _status?: Maybe<ArticleDocAccessFields__Status>;
  author?: Maybe<ArticleDocAccessFields_Author>;
  categories?: Maybe<ArticleDocAccessFields_Categories>;
  createdAt?: Maybe<ArticleDocAccessFields_CreatedAt>;
  excerpt?: Maybe<ArticleDocAccessFields_Excerpt>;
  image?: Maybe<ArticleDocAccessFields_Image>;
  layout?: Maybe<ArticleDocAccessFields_Layout>;
  meta?: Maybe<ArticleDocAccessFields_Meta>;
  publishedAt?: Maybe<ArticleDocAccessFields_PublishedAt>;
  slug?: Maybe<ArticleDocAccessFields_Slug>;
  tags?: Maybe<ArticleDocAccessFields_Tags>;
  title?: Maybe<ArticleDocAccessFields_Title>;
  updatedAt?: Maybe<ArticleDocAccessFields_UpdatedAt>;
};

export type ArticleDocAccessFields__Status = {
  __typename?: 'ArticleDocAccessFields__status';
  create?: Maybe<ArticleDocAccessFields__Status_Create>;
  delete?: Maybe<ArticleDocAccessFields__Status_Delete>;
  read?: Maybe<ArticleDocAccessFields__Status_Read>;
  update?: Maybe<ArticleDocAccessFields__Status_Update>;
};

export type ArticleDocAccessFields__Status_Create = {
  __typename?: 'ArticleDocAccessFields__status_Create';
  permission: Scalars['Boolean'];
};

export type ArticleDocAccessFields__Status_Delete = {
  __typename?: 'ArticleDocAccessFields__status_Delete';
  permission: Scalars['Boolean'];
};

export type ArticleDocAccessFields__Status_Read = {
  __typename?: 'ArticleDocAccessFields__status_Read';
  permission: Scalars['Boolean'];
};

export type ArticleDocAccessFields__Status_Update = {
  __typename?: 'ArticleDocAccessFields__status_Update';
  permission: Scalars['Boolean'];
};

export type ArticleDocAccessFields_Author = {
  __typename?: 'ArticleDocAccessFields_author';
  create?: Maybe<ArticleDocAccessFields_Author_Create>;
  delete?: Maybe<ArticleDocAccessFields_Author_Delete>;
  read?: Maybe<ArticleDocAccessFields_Author_Read>;
  update?: Maybe<ArticleDocAccessFields_Author_Update>;
};

export type ArticleDocAccessFields_Author_Create = {
  __typename?: 'ArticleDocAccessFields_author_Create';
  permission: Scalars['Boolean'];
};

export type ArticleDocAccessFields_Author_Delete = {
  __typename?: 'ArticleDocAccessFields_author_Delete';
  permission: Scalars['Boolean'];
};

export type ArticleDocAccessFields_Author_Read = {
  __typename?: 'ArticleDocAccessFields_author_Read';
  permission: Scalars['Boolean'];
};

export type ArticleDocAccessFields_Author_Update = {
  __typename?: 'ArticleDocAccessFields_author_Update';
  permission: Scalars['Boolean'];
};

export type ArticleDocAccessFields_Categories = {
  __typename?: 'ArticleDocAccessFields_categories';
  create?: Maybe<ArticleDocAccessFields_Categories_Create>;
  delete?: Maybe<ArticleDocAccessFields_Categories_Delete>;
  read?: Maybe<ArticleDocAccessFields_Categories_Read>;
  update?: Maybe<ArticleDocAccessFields_Categories_Update>;
};

export type ArticleDocAccessFields_Categories_Create = {
  __typename?: 'ArticleDocAccessFields_categories_Create';
  permission: Scalars['Boolean'];
};

export type ArticleDocAccessFields_Categories_Delete = {
  __typename?: 'ArticleDocAccessFields_categories_Delete';
  permission: Scalars['Boolean'];
};

export type ArticleDocAccessFields_Categories_Read = {
  __typename?: 'ArticleDocAccessFields_categories_Read';
  permission: Scalars['Boolean'];
};

export type ArticleDocAccessFields_Categories_Update = {
  __typename?: 'ArticleDocAccessFields_categories_Update';
  permission: Scalars['Boolean'];
};

export type ArticleDocAccessFields_CreatedAt = {
  __typename?: 'ArticleDocAccessFields_createdAt';
  create?: Maybe<ArticleDocAccessFields_CreatedAt_Create>;
  delete?: Maybe<ArticleDocAccessFields_CreatedAt_Delete>;
  read?: Maybe<ArticleDocAccessFields_CreatedAt_Read>;
  update?: Maybe<ArticleDocAccessFields_CreatedAt_Update>;
};

export type ArticleDocAccessFields_CreatedAt_Create = {
  __typename?: 'ArticleDocAccessFields_createdAt_Create';
  permission: Scalars['Boolean'];
};

export type ArticleDocAccessFields_CreatedAt_Delete = {
  __typename?: 'ArticleDocAccessFields_createdAt_Delete';
  permission: Scalars['Boolean'];
};

export type ArticleDocAccessFields_CreatedAt_Read = {
  __typename?: 'ArticleDocAccessFields_createdAt_Read';
  permission: Scalars['Boolean'];
};

export type ArticleDocAccessFields_CreatedAt_Update = {
  __typename?: 'ArticleDocAccessFields_createdAt_Update';
  permission: Scalars['Boolean'];
};

export type ArticleDocAccessFields_Excerpt = {
  __typename?: 'ArticleDocAccessFields_excerpt';
  create?: Maybe<ArticleDocAccessFields_Excerpt_Create>;
  delete?: Maybe<ArticleDocAccessFields_Excerpt_Delete>;
  read?: Maybe<ArticleDocAccessFields_Excerpt_Read>;
  update?: Maybe<ArticleDocAccessFields_Excerpt_Update>;
};

export type ArticleDocAccessFields_Excerpt_Create = {
  __typename?: 'ArticleDocAccessFields_excerpt_Create';
  permission: Scalars['Boolean'];
};

export type ArticleDocAccessFields_Excerpt_Delete = {
  __typename?: 'ArticleDocAccessFields_excerpt_Delete';
  permission: Scalars['Boolean'];
};

export type ArticleDocAccessFields_Excerpt_Read = {
  __typename?: 'ArticleDocAccessFields_excerpt_Read';
  permission: Scalars['Boolean'];
};

export type ArticleDocAccessFields_Excerpt_Update = {
  __typename?: 'ArticleDocAccessFields_excerpt_Update';
  permission: Scalars['Boolean'];
};

export type ArticleDocAccessFields_Image = {
  __typename?: 'ArticleDocAccessFields_image';
  create?: Maybe<ArticleDocAccessFields_Image_Create>;
  delete?: Maybe<ArticleDocAccessFields_Image_Delete>;
  read?: Maybe<ArticleDocAccessFields_Image_Read>;
  update?: Maybe<ArticleDocAccessFields_Image_Update>;
};

export type ArticleDocAccessFields_Image_Create = {
  __typename?: 'ArticleDocAccessFields_image_Create';
  permission: Scalars['Boolean'];
};

export type ArticleDocAccessFields_Image_Delete = {
  __typename?: 'ArticleDocAccessFields_image_Delete';
  permission: Scalars['Boolean'];
};

export type ArticleDocAccessFields_Image_Read = {
  __typename?: 'ArticleDocAccessFields_image_Read';
  permission: Scalars['Boolean'];
};

export type ArticleDocAccessFields_Image_Update = {
  __typename?: 'ArticleDocAccessFields_image_Update';
  permission: Scalars['Boolean'];
};

export type ArticleDocAccessFields_Layout = {
  __typename?: 'ArticleDocAccessFields_layout';
  create?: Maybe<ArticleDocAccessFields_Layout_Create>;
  delete?: Maybe<ArticleDocAccessFields_Layout_Delete>;
  read?: Maybe<ArticleDocAccessFields_Layout_Read>;
  update?: Maybe<ArticleDocAccessFields_Layout_Update>;
};

export type ArticleDocAccessFields_Layout_Create = {
  __typename?: 'ArticleDocAccessFields_layout_Create';
  permission: Scalars['Boolean'];
};

export type ArticleDocAccessFields_Layout_Delete = {
  __typename?: 'ArticleDocAccessFields_layout_Delete';
  permission: Scalars['Boolean'];
};

export type ArticleDocAccessFields_Layout_Read = {
  __typename?: 'ArticleDocAccessFields_layout_Read';
  permission: Scalars['Boolean'];
};

export type ArticleDocAccessFields_Layout_Update = {
  __typename?: 'ArticleDocAccessFields_layout_Update';
  permission: Scalars['Boolean'];
};

export type ArticleDocAccessFields_Meta = {
  __typename?: 'ArticleDocAccessFields_meta';
  create?: Maybe<ArticleDocAccessFields_Meta_Create>;
  delete?: Maybe<ArticleDocAccessFields_Meta_Delete>;
  fields?: Maybe<ArticleDocAccessFields_Meta_Fields>;
  read?: Maybe<ArticleDocAccessFields_Meta_Read>;
  update?: Maybe<ArticleDocAccessFields_Meta_Update>;
};

export type ArticleDocAccessFields_Meta_Create = {
  __typename?: 'ArticleDocAccessFields_meta_Create';
  permission: Scalars['Boolean'];
};

export type ArticleDocAccessFields_Meta_Delete = {
  __typename?: 'ArticleDocAccessFields_meta_Delete';
  permission: Scalars['Boolean'];
};

export type ArticleDocAccessFields_Meta_Fields = {
  __typename?: 'ArticleDocAccessFields_meta_Fields';
  description?: Maybe<ArticleDocAccessFields_Meta_Description>;
  image?: Maybe<ArticleDocAccessFields_Meta_Image>;
  noIndex?: Maybe<ArticleDocAccessFields_Meta_NoIndex>;
  title?: Maybe<ArticleDocAccessFields_Meta_Title>;
};

export type ArticleDocAccessFields_Meta_Read = {
  __typename?: 'ArticleDocAccessFields_meta_Read';
  permission: Scalars['Boolean'];
};

export type ArticleDocAccessFields_Meta_Update = {
  __typename?: 'ArticleDocAccessFields_meta_Update';
  permission: Scalars['Boolean'];
};

export type ArticleDocAccessFields_Meta_Description = {
  __typename?: 'ArticleDocAccessFields_meta_description';
  create?: Maybe<ArticleDocAccessFields_Meta_Description_Create>;
  delete?: Maybe<ArticleDocAccessFields_Meta_Description_Delete>;
  read?: Maybe<ArticleDocAccessFields_Meta_Description_Read>;
  update?: Maybe<ArticleDocAccessFields_Meta_Description_Update>;
};

export type ArticleDocAccessFields_Meta_Description_Create = {
  __typename?: 'ArticleDocAccessFields_meta_description_Create';
  permission: Scalars['Boolean'];
};

export type ArticleDocAccessFields_Meta_Description_Delete = {
  __typename?: 'ArticleDocAccessFields_meta_description_Delete';
  permission: Scalars['Boolean'];
};

export type ArticleDocAccessFields_Meta_Description_Read = {
  __typename?: 'ArticleDocAccessFields_meta_description_Read';
  permission: Scalars['Boolean'];
};

export type ArticleDocAccessFields_Meta_Description_Update = {
  __typename?: 'ArticleDocAccessFields_meta_description_Update';
  permission: Scalars['Boolean'];
};

export type ArticleDocAccessFields_Meta_Image = {
  __typename?: 'ArticleDocAccessFields_meta_image';
  create?: Maybe<ArticleDocAccessFields_Meta_Image_Create>;
  delete?: Maybe<ArticleDocAccessFields_Meta_Image_Delete>;
  read?: Maybe<ArticleDocAccessFields_Meta_Image_Read>;
  update?: Maybe<ArticleDocAccessFields_Meta_Image_Update>;
};

export type ArticleDocAccessFields_Meta_Image_Create = {
  __typename?: 'ArticleDocAccessFields_meta_image_Create';
  permission: Scalars['Boolean'];
};

export type ArticleDocAccessFields_Meta_Image_Delete = {
  __typename?: 'ArticleDocAccessFields_meta_image_Delete';
  permission: Scalars['Boolean'];
};

export type ArticleDocAccessFields_Meta_Image_Read = {
  __typename?: 'ArticleDocAccessFields_meta_image_Read';
  permission: Scalars['Boolean'];
};

export type ArticleDocAccessFields_Meta_Image_Update = {
  __typename?: 'ArticleDocAccessFields_meta_image_Update';
  permission: Scalars['Boolean'];
};

export type ArticleDocAccessFields_Meta_NoIndex = {
  __typename?: 'ArticleDocAccessFields_meta_noIndex';
  create?: Maybe<ArticleDocAccessFields_Meta_NoIndex_Create>;
  delete?: Maybe<ArticleDocAccessFields_Meta_NoIndex_Delete>;
  read?: Maybe<ArticleDocAccessFields_Meta_NoIndex_Read>;
  update?: Maybe<ArticleDocAccessFields_Meta_NoIndex_Update>;
};

export type ArticleDocAccessFields_Meta_NoIndex_Create = {
  __typename?: 'ArticleDocAccessFields_meta_noIndex_Create';
  permission: Scalars['Boolean'];
};

export type ArticleDocAccessFields_Meta_NoIndex_Delete = {
  __typename?: 'ArticleDocAccessFields_meta_noIndex_Delete';
  permission: Scalars['Boolean'];
};

export type ArticleDocAccessFields_Meta_NoIndex_Read = {
  __typename?: 'ArticleDocAccessFields_meta_noIndex_Read';
  permission: Scalars['Boolean'];
};

export type ArticleDocAccessFields_Meta_NoIndex_Update = {
  __typename?: 'ArticleDocAccessFields_meta_noIndex_Update';
  permission: Scalars['Boolean'];
};

export type ArticleDocAccessFields_Meta_Title = {
  __typename?: 'ArticleDocAccessFields_meta_title';
  create?: Maybe<ArticleDocAccessFields_Meta_Title_Create>;
  delete?: Maybe<ArticleDocAccessFields_Meta_Title_Delete>;
  read?: Maybe<ArticleDocAccessFields_Meta_Title_Read>;
  update?: Maybe<ArticleDocAccessFields_Meta_Title_Update>;
};

export type ArticleDocAccessFields_Meta_Title_Create = {
  __typename?: 'ArticleDocAccessFields_meta_title_Create';
  permission: Scalars['Boolean'];
};

export type ArticleDocAccessFields_Meta_Title_Delete = {
  __typename?: 'ArticleDocAccessFields_meta_title_Delete';
  permission: Scalars['Boolean'];
};

export type ArticleDocAccessFields_Meta_Title_Read = {
  __typename?: 'ArticleDocAccessFields_meta_title_Read';
  permission: Scalars['Boolean'];
};

export type ArticleDocAccessFields_Meta_Title_Update = {
  __typename?: 'ArticleDocAccessFields_meta_title_Update';
  permission: Scalars['Boolean'];
};

export type ArticleDocAccessFields_PublishedAt = {
  __typename?: 'ArticleDocAccessFields_publishedAt';
  create?: Maybe<ArticleDocAccessFields_PublishedAt_Create>;
  delete?: Maybe<ArticleDocAccessFields_PublishedAt_Delete>;
  read?: Maybe<ArticleDocAccessFields_PublishedAt_Read>;
  update?: Maybe<ArticleDocAccessFields_PublishedAt_Update>;
};

export type ArticleDocAccessFields_PublishedAt_Create = {
  __typename?: 'ArticleDocAccessFields_publishedAt_Create';
  permission: Scalars['Boolean'];
};

export type ArticleDocAccessFields_PublishedAt_Delete = {
  __typename?: 'ArticleDocAccessFields_publishedAt_Delete';
  permission: Scalars['Boolean'];
};

export type ArticleDocAccessFields_PublishedAt_Read = {
  __typename?: 'ArticleDocAccessFields_publishedAt_Read';
  permission: Scalars['Boolean'];
};

export type ArticleDocAccessFields_PublishedAt_Update = {
  __typename?: 'ArticleDocAccessFields_publishedAt_Update';
  permission: Scalars['Boolean'];
};

export type ArticleDocAccessFields_Slug = {
  __typename?: 'ArticleDocAccessFields_slug';
  create?: Maybe<ArticleDocAccessFields_Slug_Create>;
  delete?: Maybe<ArticleDocAccessFields_Slug_Delete>;
  read?: Maybe<ArticleDocAccessFields_Slug_Read>;
  update?: Maybe<ArticleDocAccessFields_Slug_Update>;
};

export type ArticleDocAccessFields_Slug_Create = {
  __typename?: 'ArticleDocAccessFields_slug_Create';
  permission: Scalars['Boolean'];
};

export type ArticleDocAccessFields_Slug_Delete = {
  __typename?: 'ArticleDocAccessFields_slug_Delete';
  permission: Scalars['Boolean'];
};

export type ArticleDocAccessFields_Slug_Read = {
  __typename?: 'ArticleDocAccessFields_slug_Read';
  permission: Scalars['Boolean'];
};

export type ArticleDocAccessFields_Slug_Update = {
  __typename?: 'ArticleDocAccessFields_slug_Update';
  permission: Scalars['Boolean'];
};

export type ArticleDocAccessFields_Tags = {
  __typename?: 'ArticleDocAccessFields_tags';
  create?: Maybe<ArticleDocAccessFields_Tags_Create>;
  delete?: Maybe<ArticleDocAccessFields_Tags_Delete>;
  read?: Maybe<ArticleDocAccessFields_Tags_Read>;
  update?: Maybe<ArticleDocAccessFields_Tags_Update>;
};

export type ArticleDocAccessFields_Tags_Create = {
  __typename?: 'ArticleDocAccessFields_tags_Create';
  permission: Scalars['Boolean'];
};

export type ArticleDocAccessFields_Tags_Delete = {
  __typename?: 'ArticleDocAccessFields_tags_Delete';
  permission: Scalars['Boolean'];
};

export type ArticleDocAccessFields_Tags_Read = {
  __typename?: 'ArticleDocAccessFields_tags_Read';
  permission: Scalars['Boolean'];
};

export type ArticleDocAccessFields_Tags_Update = {
  __typename?: 'ArticleDocAccessFields_tags_Update';
  permission: Scalars['Boolean'];
};

export type ArticleDocAccessFields_Title = {
  __typename?: 'ArticleDocAccessFields_title';
  create?: Maybe<ArticleDocAccessFields_Title_Create>;
  delete?: Maybe<ArticleDocAccessFields_Title_Delete>;
  read?: Maybe<ArticleDocAccessFields_Title_Read>;
  update?: Maybe<ArticleDocAccessFields_Title_Update>;
};

export type ArticleDocAccessFields_Title_Create = {
  __typename?: 'ArticleDocAccessFields_title_Create';
  permission: Scalars['Boolean'];
};

export type ArticleDocAccessFields_Title_Delete = {
  __typename?: 'ArticleDocAccessFields_title_Delete';
  permission: Scalars['Boolean'];
};

export type ArticleDocAccessFields_Title_Read = {
  __typename?: 'ArticleDocAccessFields_title_Read';
  permission: Scalars['Boolean'];
};

export type ArticleDocAccessFields_Title_Update = {
  __typename?: 'ArticleDocAccessFields_title_Update';
  permission: Scalars['Boolean'];
};

export type ArticleDocAccessFields_UpdatedAt = {
  __typename?: 'ArticleDocAccessFields_updatedAt';
  create?: Maybe<ArticleDocAccessFields_UpdatedAt_Create>;
  delete?: Maybe<ArticleDocAccessFields_UpdatedAt_Delete>;
  read?: Maybe<ArticleDocAccessFields_UpdatedAt_Read>;
  update?: Maybe<ArticleDocAccessFields_UpdatedAt_Update>;
};

export type ArticleDocAccessFields_UpdatedAt_Create = {
  __typename?: 'ArticleDocAccessFields_updatedAt_Create';
  permission: Scalars['Boolean'];
};

export type ArticleDocAccessFields_UpdatedAt_Delete = {
  __typename?: 'ArticleDocAccessFields_updatedAt_Delete';
  permission: Scalars['Boolean'];
};

export type ArticleDocAccessFields_UpdatedAt_Read = {
  __typename?: 'ArticleDocAccessFields_updatedAt_Read';
  permission: Scalars['Boolean'];
};

export type ArticleDocAccessFields_UpdatedAt_Update = {
  __typename?: 'ArticleDocAccessFields_updatedAt_Update';
  permission: Scalars['Boolean'];
};

export type ArticleFields = {
  __typename?: 'ArticleFields';
  _status?: Maybe<ArticleFields__Status>;
  author?: Maybe<ArticleFields_Author>;
  categories?: Maybe<ArticleFields_Categories>;
  createdAt?: Maybe<ArticleFields_CreatedAt>;
  excerpt?: Maybe<ArticleFields_Excerpt>;
  image?: Maybe<ArticleFields_Image>;
  layout?: Maybe<ArticleFields_Layout>;
  meta?: Maybe<ArticleFields_Meta>;
  publishedAt?: Maybe<ArticleFields_PublishedAt>;
  slug?: Maybe<ArticleFields_Slug>;
  tags?: Maybe<ArticleFields_Tags>;
  title?: Maybe<ArticleFields_Title>;
  updatedAt?: Maybe<ArticleFields_UpdatedAt>;
};

export type ArticleFields__Status = {
  __typename?: 'ArticleFields__status';
  create?: Maybe<ArticleFields__Status_Create>;
  delete?: Maybe<ArticleFields__Status_Delete>;
  read?: Maybe<ArticleFields__Status_Read>;
  update?: Maybe<ArticleFields__Status_Update>;
};

export type ArticleFields__Status_Create = {
  __typename?: 'ArticleFields__status_Create';
  permission: Scalars['Boolean'];
};

export type ArticleFields__Status_Delete = {
  __typename?: 'ArticleFields__status_Delete';
  permission: Scalars['Boolean'];
};

export type ArticleFields__Status_Read = {
  __typename?: 'ArticleFields__status_Read';
  permission: Scalars['Boolean'];
};

export type ArticleFields__Status_Update = {
  __typename?: 'ArticleFields__status_Update';
  permission: Scalars['Boolean'];
};

export type ArticleFields_Author = {
  __typename?: 'ArticleFields_author';
  create?: Maybe<ArticleFields_Author_Create>;
  delete?: Maybe<ArticleFields_Author_Delete>;
  read?: Maybe<ArticleFields_Author_Read>;
  update?: Maybe<ArticleFields_Author_Update>;
};

export type ArticleFields_Author_Create = {
  __typename?: 'ArticleFields_author_Create';
  permission: Scalars['Boolean'];
};

export type ArticleFields_Author_Delete = {
  __typename?: 'ArticleFields_author_Delete';
  permission: Scalars['Boolean'];
};

export type ArticleFields_Author_Read = {
  __typename?: 'ArticleFields_author_Read';
  permission: Scalars['Boolean'];
};

export type ArticleFields_Author_Update = {
  __typename?: 'ArticleFields_author_Update';
  permission: Scalars['Boolean'];
};

export type ArticleFields_Categories = {
  __typename?: 'ArticleFields_categories';
  create?: Maybe<ArticleFields_Categories_Create>;
  delete?: Maybe<ArticleFields_Categories_Delete>;
  read?: Maybe<ArticleFields_Categories_Read>;
  update?: Maybe<ArticleFields_Categories_Update>;
};

export type ArticleFields_Categories_Create = {
  __typename?: 'ArticleFields_categories_Create';
  permission: Scalars['Boolean'];
};

export type ArticleFields_Categories_Delete = {
  __typename?: 'ArticleFields_categories_Delete';
  permission: Scalars['Boolean'];
};

export type ArticleFields_Categories_Read = {
  __typename?: 'ArticleFields_categories_Read';
  permission: Scalars['Boolean'];
};

export type ArticleFields_Categories_Update = {
  __typename?: 'ArticleFields_categories_Update';
  permission: Scalars['Boolean'];
};

export type ArticleFields_CreatedAt = {
  __typename?: 'ArticleFields_createdAt';
  create?: Maybe<ArticleFields_CreatedAt_Create>;
  delete?: Maybe<ArticleFields_CreatedAt_Delete>;
  read?: Maybe<ArticleFields_CreatedAt_Read>;
  update?: Maybe<ArticleFields_CreatedAt_Update>;
};

export type ArticleFields_CreatedAt_Create = {
  __typename?: 'ArticleFields_createdAt_Create';
  permission: Scalars['Boolean'];
};

export type ArticleFields_CreatedAt_Delete = {
  __typename?: 'ArticleFields_createdAt_Delete';
  permission: Scalars['Boolean'];
};

export type ArticleFields_CreatedAt_Read = {
  __typename?: 'ArticleFields_createdAt_Read';
  permission: Scalars['Boolean'];
};

export type ArticleFields_CreatedAt_Update = {
  __typename?: 'ArticleFields_createdAt_Update';
  permission: Scalars['Boolean'];
};

export type ArticleFields_Excerpt = {
  __typename?: 'ArticleFields_excerpt';
  create?: Maybe<ArticleFields_Excerpt_Create>;
  delete?: Maybe<ArticleFields_Excerpt_Delete>;
  read?: Maybe<ArticleFields_Excerpt_Read>;
  update?: Maybe<ArticleFields_Excerpt_Update>;
};

export type ArticleFields_Excerpt_Create = {
  __typename?: 'ArticleFields_excerpt_Create';
  permission: Scalars['Boolean'];
};

export type ArticleFields_Excerpt_Delete = {
  __typename?: 'ArticleFields_excerpt_Delete';
  permission: Scalars['Boolean'];
};

export type ArticleFields_Excerpt_Read = {
  __typename?: 'ArticleFields_excerpt_Read';
  permission: Scalars['Boolean'];
};

export type ArticleFields_Excerpt_Update = {
  __typename?: 'ArticleFields_excerpt_Update';
  permission: Scalars['Boolean'];
};

export type ArticleFields_Image = {
  __typename?: 'ArticleFields_image';
  create?: Maybe<ArticleFields_Image_Create>;
  delete?: Maybe<ArticleFields_Image_Delete>;
  read?: Maybe<ArticleFields_Image_Read>;
  update?: Maybe<ArticleFields_Image_Update>;
};

export type ArticleFields_Image_Create = {
  __typename?: 'ArticleFields_image_Create';
  permission: Scalars['Boolean'];
};

export type ArticleFields_Image_Delete = {
  __typename?: 'ArticleFields_image_Delete';
  permission: Scalars['Boolean'];
};

export type ArticleFields_Image_Read = {
  __typename?: 'ArticleFields_image_Read';
  permission: Scalars['Boolean'];
};

export type ArticleFields_Image_Update = {
  __typename?: 'ArticleFields_image_Update';
  permission: Scalars['Boolean'];
};

export type ArticleFields_Layout = {
  __typename?: 'ArticleFields_layout';
  create?: Maybe<ArticleFields_Layout_Create>;
  delete?: Maybe<ArticleFields_Layout_Delete>;
  read?: Maybe<ArticleFields_Layout_Read>;
  update?: Maybe<ArticleFields_Layout_Update>;
};

export type ArticleFields_Layout_Create = {
  __typename?: 'ArticleFields_layout_Create';
  permission: Scalars['Boolean'];
};

export type ArticleFields_Layout_Delete = {
  __typename?: 'ArticleFields_layout_Delete';
  permission: Scalars['Boolean'];
};

export type ArticleFields_Layout_Read = {
  __typename?: 'ArticleFields_layout_Read';
  permission: Scalars['Boolean'];
};

export type ArticleFields_Layout_Update = {
  __typename?: 'ArticleFields_layout_Update';
  permission: Scalars['Boolean'];
};

export type ArticleFields_Meta = {
  __typename?: 'ArticleFields_meta';
  create?: Maybe<ArticleFields_Meta_Create>;
  delete?: Maybe<ArticleFields_Meta_Delete>;
  fields?: Maybe<ArticleFields_Meta_Fields>;
  read?: Maybe<ArticleFields_Meta_Read>;
  update?: Maybe<ArticleFields_Meta_Update>;
};

export type ArticleFields_Meta_Create = {
  __typename?: 'ArticleFields_meta_Create';
  permission: Scalars['Boolean'];
};

export type ArticleFields_Meta_Delete = {
  __typename?: 'ArticleFields_meta_Delete';
  permission: Scalars['Boolean'];
};

export type ArticleFields_Meta_Fields = {
  __typename?: 'ArticleFields_meta_Fields';
  description?: Maybe<ArticleFields_Meta_Description>;
  image?: Maybe<ArticleFields_Meta_Image>;
  noIndex?: Maybe<ArticleFields_Meta_NoIndex>;
  title?: Maybe<ArticleFields_Meta_Title>;
};

export type ArticleFields_Meta_Read = {
  __typename?: 'ArticleFields_meta_Read';
  permission: Scalars['Boolean'];
};

export type ArticleFields_Meta_Update = {
  __typename?: 'ArticleFields_meta_Update';
  permission: Scalars['Boolean'];
};

export type ArticleFields_Meta_Description = {
  __typename?: 'ArticleFields_meta_description';
  create?: Maybe<ArticleFields_Meta_Description_Create>;
  delete?: Maybe<ArticleFields_Meta_Description_Delete>;
  read?: Maybe<ArticleFields_Meta_Description_Read>;
  update?: Maybe<ArticleFields_Meta_Description_Update>;
};

export type ArticleFields_Meta_Description_Create = {
  __typename?: 'ArticleFields_meta_description_Create';
  permission: Scalars['Boolean'];
};

export type ArticleFields_Meta_Description_Delete = {
  __typename?: 'ArticleFields_meta_description_Delete';
  permission: Scalars['Boolean'];
};

export type ArticleFields_Meta_Description_Read = {
  __typename?: 'ArticleFields_meta_description_Read';
  permission: Scalars['Boolean'];
};

export type ArticleFields_Meta_Description_Update = {
  __typename?: 'ArticleFields_meta_description_Update';
  permission: Scalars['Boolean'];
};

export type ArticleFields_Meta_Image = {
  __typename?: 'ArticleFields_meta_image';
  create?: Maybe<ArticleFields_Meta_Image_Create>;
  delete?: Maybe<ArticleFields_Meta_Image_Delete>;
  read?: Maybe<ArticleFields_Meta_Image_Read>;
  update?: Maybe<ArticleFields_Meta_Image_Update>;
};

export type ArticleFields_Meta_Image_Create = {
  __typename?: 'ArticleFields_meta_image_Create';
  permission: Scalars['Boolean'];
};

export type ArticleFields_Meta_Image_Delete = {
  __typename?: 'ArticleFields_meta_image_Delete';
  permission: Scalars['Boolean'];
};

export type ArticleFields_Meta_Image_Read = {
  __typename?: 'ArticleFields_meta_image_Read';
  permission: Scalars['Boolean'];
};

export type ArticleFields_Meta_Image_Update = {
  __typename?: 'ArticleFields_meta_image_Update';
  permission: Scalars['Boolean'];
};

export type ArticleFields_Meta_NoIndex = {
  __typename?: 'ArticleFields_meta_noIndex';
  create?: Maybe<ArticleFields_Meta_NoIndex_Create>;
  delete?: Maybe<ArticleFields_Meta_NoIndex_Delete>;
  read?: Maybe<ArticleFields_Meta_NoIndex_Read>;
  update?: Maybe<ArticleFields_Meta_NoIndex_Update>;
};

export type ArticleFields_Meta_NoIndex_Create = {
  __typename?: 'ArticleFields_meta_noIndex_Create';
  permission: Scalars['Boolean'];
};

export type ArticleFields_Meta_NoIndex_Delete = {
  __typename?: 'ArticleFields_meta_noIndex_Delete';
  permission: Scalars['Boolean'];
};

export type ArticleFields_Meta_NoIndex_Read = {
  __typename?: 'ArticleFields_meta_noIndex_Read';
  permission: Scalars['Boolean'];
};

export type ArticleFields_Meta_NoIndex_Update = {
  __typename?: 'ArticleFields_meta_noIndex_Update';
  permission: Scalars['Boolean'];
};

export type ArticleFields_Meta_Title = {
  __typename?: 'ArticleFields_meta_title';
  create?: Maybe<ArticleFields_Meta_Title_Create>;
  delete?: Maybe<ArticleFields_Meta_Title_Delete>;
  read?: Maybe<ArticleFields_Meta_Title_Read>;
  update?: Maybe<ArticleFields_Meta_Title_Update>;
};

export type ArticleFields_Meta_Title_Create = {
  __typename?: 'ArticleFields_meta_title_Create';
  permission: Scalars['Boolean'];
};

export type ArticleFields_Meta_Title_Delete = {
  __typename?: 'ArticleFields_meta_title_Delete';
  permission: Scalars['Boolean'];
};

export type ArticleFields_Meta_Title_Read = {
  __typename?: 'ArticleFields_meta_title_Read';
  permission: Scalars['Boolean'];
};

export type ArticleFields_Meta_Title_Update = {
  __typename?: 'ArticleFields_meta_title_Update';
  permission: Scalars['Boolean'];
};

export type ArticleFields_PublishedAt = {
  __typename?: 'ArticleFields_publishedAt';
  create?: Maybe<ArticleFields_PublishedAt_Create>;
  delete?: Maybe<ArticleFields_PublishedAt_Delete>;
  read?: Maybe<ArticleFields_PublishedAt_Read>;
  update?: Maybe<ArticleFields_PublishedAt_Update>;
};

export type ArticleFields_PublishedAt_Create = {
  __typename?: 'ArticleFields_publishedAt_Create';
  permission: Scalars['Boolean'];
};

export type ArticleFields_PublishedAt_Delete = {
  __typename?: 'ArticleFields_publishedAt_Delete';
  permission: Scalars['Boolean'];
};

export type ArticleFields_PublishedAt_Read = {
  __typename?: 'ArticleFields_publishedAt_Read';
  permission: Scalars['Boolean'];
};

export type ArticleFields_PublishedAt_Update = {
  __typename?: 'ArticleFields_publishedAt_Update';
  permission: Scalars['Boolean'];
};

export type ArticleFields_Slug = {
  __typename?: 'ArticleFields_slug';
  create?: Maybe<ArticleFields_Slug_Create>;
  delete?: Maybe<ArticleFields_Slug_Delete>;
  read?: Maybe<ArticleFields_Slug_Read>;
  update?: Maybe<ArticleFields_Slug_Update>;
};

export type ArticleFields_Slug_Create = {
  __typename?: 'ArticleFields_slug_Create';
  permission: Scalars['Boolean'];
};

export type ArticleFields_Slug_Delete = {
  __typename?: 'ArticleFields_slug_Delete';
  permission: Scalars['Boolean'];
};

export type ArticleFields_Slug_Read = {
  __typename?: 'ArticleFields_slug_Read';
  permission: Scalars['Boolean'];
};

export type ArticleFields_Slug_Update = {
  __typename?: 'ArticleFields_slug_Update';
  permission: Scalars['Boolean'];
};

export type ArticleFields_Tags = {
  __typename?: 'ArticleFields_tags';
  create?: Maybe<ArticleFields_Tags_Create>;
  delete?: Maybe<ArticleFields_Tags_Delete>;
  read?: Maybe<ArticleFields_Tags_Read>;
  update?: Maybe<ArticleFields_Tags_Update>;
};

export type ArticleFields_Tags_Create = {
  __typename?: 'ArticleFields_tags_Create';
  permission: Scalars['Boolean'];
};

export type ArticleFields_Tags_Delete = {
  __typename?: 'ArticleFields_tags_Delete';
  permission: Scalars['Boolean'];
};

export type ArticleFields_Tags_Read = {
  __typename?: 'ArticleFields_tags_Read';
  permission: Scalars['Boolean'];
};

export type ArticleFields_Tags_Update = {
  __typename?: 'ArticleFields_tags_Update';
  permission: Scalars['Boolean'];
};

export type ArticleFields_Title = {
  __typename?: 'ArticleFields_title';
  create?: Maybe<ArticleFields_Title_Create>;
  delete?: Maybe<ArticleFields_Title_Delete>;
  read?: Maybe<ArticleFields_Title_Read>;
  update?: Maybe<ArticleFields_Title_Update>;
};

export type ArticleFields_Title_Create = {
  __typename?: 'ArticleFields_title_Create';
  permission: Scalars['Boolean'];
};

export type ArticleFields_Title_Delete = {
  __typename?: 'ArticleFields_title_Delete';
  permission: Scalars['Boolean'];
};

export type ArticleFields_Title_Read = {
  __typename?: 'ArticleFields_title_Read';
  permission: Scalars['Boolean'];
};

export type ArticleFields_Title_Update = {
  __typename?: 'ArticleFields_title_Update';
  permission: Scalars['Boolean'];
};

export type ArticleFields_UpdatedAt = {
  __typename?: 'ArticleFields_updatedAt';
  create?: Maybe<ArticleFields_UpdatedAt_Create>;
  delete?: Maybe<ArticleFields_UpdatedAt_Delete>;
  read?: Maybe<ArticleFields_UpdatedAt_Read>;
  update?: Maybe<ArticleFields_UpdatedAt_Update>;
};

export type ArticleFields_UpdatedAt_Create = {
  __typename?: 'ArticleFields_updatedAt_Create';
  permission: Scalars['Boolean'];
};

export type ArticleFields_UpdatedAt_Delete = {
  __typename?: 'ArticleFields_updatedAt_Delete';
  permission: Scalars['Boolean'];
};

export type ArticleFields_UpdatedAt_Read = {
  __typename?: 'ArticleFields_updatedAt_Read';
  permission: Scalars['Boolean'];
};

export type ArticleFields_UpdatedAt_Update = {
  __typename?: 'ArticleFields_updatedAt_Update';
  permission: Scalars['Boolean'];
};

export type ArticleReadAccess = {
  __typename?: 'ArticleReadAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type ArticleReadDocAccess = {
  __typename?: 'ArticleReadDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type ArticleReadVersionsAccess = {
  __typename?: 'ArticleReadVersionsAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type ArticleReadVersionsDocAccess = {
  __typename?: 'ArticleReadVersionsDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type ArticleUpdateAccess = {
  __typename?: 'ArticleUpdateAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type ArticleUpdateDocAccess = {
  __typename?: 'ArticleUpdateDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export enum ArticleUpdate__Status_MutationInput {
  Draft = 'draft',
  Published = 'published'
}

export type ArticleVersion = {
  __typename?: 'ArticleVersion';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  latest?: Maybe<Scalars['Boolean']>;
  parent?: Maybe<Article>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  version?: Maybe<ArticleVersion_Version>;
};


export type ArticleVersionParentArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
};

export type ArticleVersion_Version = {
  __typename?: 'ArticleVersion_Version';
  _status?: Maybe<ArticleVersion_Version__Status>;
  author?: Maybe<User>;
  categories?: Maybe<Array<Category>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  excerpt?: Maybe<Scalars['String']>;
  image?: Maybe<Media>;
  layout?: Maybe<Array<ArticleVersion_Version_Layout>>;
  meta?: Maybe<ArticleVersion_Version_Meta>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  slug?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Tag>>;
  timeToRead?: Maybe<Scalars['Float']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ArticleVersion_Version_Layout = Columns | Content | Cta | Image;

export type ArticleVersion_Version_Meta = {
  __typename?: 'ArticleVersion_Version_Meta';
  description?: Maybe<Scalars['String']>;
  image?: Maybe<Media>;
  noIndex?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
};

export enum ArticleVersion_Version__Status {
  Draft = 'draft',
  Published = 'published'
}

export type Article_Layout = Columns | Content | Cta | Image;

export type Article_Meta = {
  __typename?: 'Article_Meta';
  description?: Maybe<Scalars['String']>;
  image?: Maybe<Media>;
  noIndex?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
};

export enum Article__Status {
  Draft = 'draft',
  Published = 'published'
}

export enum Article__Status_Input {
  Draft = 'draft',
  Published = 'published'
}

export enum Article__Status_MutationInput {
  Draft = 'draft',
  Published = 'published'
}

export type Article__Status_Operator = {
  all?: InputMaybe<Array<InputMaybe<Article__Status_Input>>>;
  equals?: InputMaybe<Article__Status_Input>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Article__Status_Input>>>;
  not_equals?: InputMaybe<Article__Status_Input>;
  not_in?: InputMaybe<Array<InputMaybe<Article__Status_Input>>>;
};

export type Article_Author_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  equals?: InputMaybe<Scalars['JSON']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  not_equals?: InputMaybe<Scalars['JSON']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type Article_Categories_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  equals?: InputMaybe<Scalars['JSON']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  not_equals?: InputMaybe<Scalars['JSON']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type Article_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type Article_Excerpt_Operator = {
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
};

export type Article_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Article_Image_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  equals?: InputMaybe<Scalars['JSON']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  not_equals?: InputMaybe<Scalars['JSON']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type Article_Meta__Description_Operator = {
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
};

export type Article_Meta__Image_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  equals?: InputMaybe<Scalars['JSON']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  not_equals?: InputMaybe<Scalars['JSON']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type Article_Meta__NoIndex_Operator = {
  equals?: InputMaybe<Scalars['Boolean']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  not_equals?: InputMaybe<Scalars['Boolean']>;
};

export type Article_Meta__Title_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Article_PublishedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type Article_Slug_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Article_Tags_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  equals?: InputMaybe<Scalars['JSON']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  not_equals?: InputMaybe<Scalars['JSON']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type Article_Title_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Article_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type Article_Where = {
  AND?: InputMaybe<Array<InputMaybe<Article_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Article_Where_Or>>>;
  _status?: InputMaybe<Article__Status_Operator>;
  author?: InputMaybe<Article_Author_Operator>;
  categories?: InputMaybe<Article_Categories_Operator>;
  createdAt?: InputMaybe<Article_CreatedAt_Operator>;
  excerpt?: InputMaybe<Article_Excerpt_Operator>;
  id?: InputMaybe<Article_Id_Operator>;
  image?: InputMaybe<Article_Image_Operator>;
  meta__description?: InputMaybe<Article_Meta__Description_Operator>;
  meta__image?: InputMaybe<Article_Meta__Image_Operator>;
  meta__noIndex?: InputMaybe<Article_Meta__NoIndex_Operator>;
  meta__title?: InputMaybe<Article_Meta__Title_Operator>;
  publishedAt?: InputMaybe<Article_PublishedAt_Operator>;
  slug?: InputMaybe<Article_Slug_Operator>;
  tags?: InputMaybe<Article_Tags_Operator>;
  title?: InputMaybe<Article_Title_Operator>;
  updatedAt?: InputMaybe<Article_UpdatedAt_Operator>;
};

export type Article_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<Article_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Article_Where_Or>>>;
  _status?: InputMaybe<Article__Status_Operator>;
  author?: InputMaybe<Article_Author_Operator>;
  categories?: InputMaybe<Article_Categories_Operator>;
  createdAt?: InputMaybe<Article_CreatedAt_Operator>;
  excerpt?: InputMaybe<Article_Excerpt_Operator>;
  id?: InputMaybe<Article_Id_Operator>;
  image?: InputMaybe<Article_Image_Operator>;
  meta__description?: InputMaybe<Article_Meta__Description_Operator>;
  meta__image?: InputMaybe<Article_Meta__Image_Operator>;
  meta__noIndex?: InputMaybe<Article_Meta__NoIndex_Operator>;
  meta__title?: InputMaybe<Article_Meta__Title_Operator>;
  publishedAt?: InputMaybe<Article_PublishedAt_Operator>;
  slug?: InputMaybe<Article_Slug_Operator>;
  tags?: InputMaybe<Article_Tags_Operator>;
  title?: InputMaybe<Article_Title_Operator>;
  updatedAt?: InputMaybe<Article_UpdatedAt_Operator>;
};

export type Article_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<Article_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Article_Where_Or>>>;
  _status?: InputMaybe<Article__Status_Operator>;
  author?: InputMaybe<Article_Author_Operator>;
  categories?: InputMaybe<Article_Categories_Operator>;
  createdAt?: InputMaybe<Article_CreatedAt_Operator>;
  excerpt?: InputMaybe<Article_Excerpt_Operator>;
  id?: InputMaybe<Article_Id_Operator>;
  image?: InputMaybe<Article_Image_Operator>;
  meta__description?: InputMaybe<Article_Meta__Description_Operator>;
  meta__image?: InputMaybe<Article_Meta__Image_Operator>;
  meta__noIndex?: InputMaybe<Article_Meta__NoIndex_Operator>;
  meta__title?: InputMaybe<Article_Meta__Title_Operator>;
  publishedAt?: InputMaybe<Article_PublishedAt_Operator>;
  slug?: InputMaybe<Article_Slug_Operator>;
  tags?: InputMaybe<Article_Tags_Operator>;
  title?: InputMaybe<Article_Title_Operator>;
  updatedAt?: InputMaybe<Article_UpdatedAt_Operator>;
};

export type Articles = {
  __typename?: 'Articles';
  docs?: Maybe<Array<Maybe<Article>>>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPrevPage?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  nextPage?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  pagingCounter?: Maybe<Scalars['Int']>;
  prevPage?: Maybe<Scalars['Int']>;
  totalDocs?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
};

export type ArticlesScroller = {
  __typename?: 'ArticlesScroller';
  articles?: Maybe<Array<Article>>;
  blockName?: Maybe<Scalars['String']>;
  blockSettings?: Maybe<BlockSettings>;
  blockType?: Maybe<Scalars['String']>;
  categories?: Maybe<Array<Category>>;
  id?: Maybe<Scalars['String']>;
  method?: Maybe<ArticlesScroller_Method>;
  tags?: Maybe<Array<Tag>>;
};


export type ArticlesScrollerArticlesArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
};

export enum ArticlesScroller_Method {
  Latest = 'latest',
  Manual = 'manual'
}

export type BackgroundWithBlock = {
  __typename?: 'BackgroundWithBlock';
  backgroundColor?: Maybe<BackgroundWithBlock_BackgroundColor>;
  backgroundImage?: Maybe<Media>;
  blockName?: Maybe<Scalars['String']>;
  blockSettings?: Maybe<BlockSettings>;
  blockType?: Maybe<Scalars['String']>;
  blocks?: Maybe<Array<BackgroundWithBlock_Blocks>>;
  containerWidth?: Maybe<BackgroundWithBlock_ContainerWidth>;
  hasBackgroundGridImage?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  showBackgroundImage?: Maybe<Scalars['Boolean']>;
};

export type BackgroundWithBlock_Blocks = Columns | Content | ServicesScroller | SliderWithBlocks;

export enum BackgroundWithBlock_BackgroundColor {
  Light = 'light',
  Primary = 'primary'
}

export enum BackgroundWithBlock_ContainerWidth {
  Full = 'full',
  Large = 'large'
}

export type BlockSettings = {
  __typename?: 'BlockSettings';
  margin?: Maybe<BlockSettings_Margin>;
  padding?: Maybe<BlockSettings_Padding>;
};

export type BlockSettings_Margin = {
  __typename?: 'BlockSettings_Margin';
  marginBottom?: Maybe<BlockSettings_Margin_MarginBottom>;
};

export enum BlockSettings_Margin_MarginBottom {
  ExtraLarge = 'extraLarge',
  Large = 'large',
  Medium = 'medium',
  None = 'none',
  Small = 'small'
}

export type BlockSettings_Padding = {
  __typename?: 'BlockSettings_Padding';
  paddingBottom?: Maybe<BlockSettings_Padding_PaddingBottom>;
  paddingLeft?: Maybe<BlockSettings_Padding_PaddingLeft>;
  paddingRight?: Maybe<BlockSettings_Padding_PaddingRight>;
  paddingTop?: Maybe<BlockSettings_Padding_PaddingTop>;
};

export enum BlockSettings_Padding_PaddingBottom {
  Large = 'large',
  Medium = 'medium',
  None = 'none',
  Small = 'small'
}

export enum BlockSettings_Padding_PaddingLeft {
  Large = 'large',
  Medium = 'medium',
  None = 'none',
  Small = 'small'
}

export enum BlockSettings_Padding_PaddingRight {
  Large = 'large',
  Medium = 'medium',
  None = 'none',
  Small = 'small'
}

export enum BlockSettings_Padding_PaddingTop {
  Large = 'large',
  Medium = 'medium',
  None = 'none',
  Small = 'small'
}

export type ButtonLink = {
  __typename?: 'ButtonLink';
  blockName?: Maybe<Scalars['String']>;
  blockType?: Maybe<Scalars['String']>;
  buttonType?: Maybe<ButtonLink_ButtonType>;
  icon?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isLargeButton?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  reference?: Maybe<ButtonLink_Reference_Relationship>;
  type?: Maybe<ButtonLink_Type>;
  url?: Maybe<Scalars['String']>;
};


export type ButtonLinkReferenceArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
};

export type ButtonLink_Reference = Article | LeadForm | Page | Service;

export enum ButtonLink_Reference_RelationTo {
  Article = 'article',
  LeadForm = 'lead_form',
  Page = 'page',
  Service = 'service'
}

export type ButtonLink_Reference_Relationship = {
  __typename?: 'ButtonLink_Reference_Relationship';
  relationTo?: Maybe<ButtonLink_Reference_RelationTo>;
  value?: Maybe<ButtonLink_Reference>;
};

export enum ButtonLink_ButtonType {
  Link = 'link',
  Primary = 'primary',
  Secondary = 'secondary'
}

export enum ButtonLink_Type {
  External = 'external',
  Internal = 'internal'
}

export type CardWithBlocks = {
  __typename?: 'CardWithBlocks';
  blockName?: Maybe<Scalars['String']>;
  blockSettings?: Maybe<BlockSettings>;
  blockType?: Maybe<Scalars['String']>;
  blocks?: Maybe<Array<CardWithBlocks_Blocks>>;
  color?: Maybe<CardWithBlocks_Color>;
  hasBorder?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
};

export type CardWithBlocks_Blocks = Content | FormBlock | Image | Lists;

export enum CardWithBlocks_Color {
  Dark = 'dark',
  Light = 'light',
  Secondary = 'secondary',
  White = 'white'
}

export type Categories = {
  __typename?: 'Categories';
  docs?: Maybe<Array<Maybe<Category>>>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPrevPage?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  nextPage?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  pagingCounter?: Maybe<Scalars['Int']>;
  prevPage?: Maybe<Scalars['Int']>;
  totalDocs?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
};

export type Category = {
  __typename?: 'Category';
  createdAt?: Maybe<Scalars['DateTime']>;
  description: Scalars['String'];
  featuredCategory?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  slug?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CategoryCreateAccess = {
  __typename?: 'CategoryCreateAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type CategoryCreateDocAccess = {
  __typename?: 'CategoryCreateDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type CategoryDeleteAccess = {
  __typename?: 'CategoryDeleteAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type CategoryDeleteDocAccess = {
  __typename?: 'CategoryDeleteDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type CategoryDocAccessFields = {
  __typename?: 'CategoryDocAccessFields';
  createdAt?: Maybe<CategoryDocAccessFields_CreatedAt>;
  description?: Maybe<CategoryDocAccessFields_Description>;
  featuredCategory?: Maybe<CategoryDocAccessFields_FeaturedCategory>;
  slug?: Maybe<CategoryDocAccessFields_Slug>;
  title?: Maybe<CategoryDocAccessFields_Title>;
  updatedAt?: Maybe<CategoryDocAccessFields_UpdatedAt>;
};

export type CategoryDocAccessFields_CreatedAt = {
  __typename?: 'CategoryDocAccessFields_createdAt';
  create?: Maybe<CategoryDocAccessFields_CreatedAt_Create>;
  delete?: Maybe<CategoryDocAccessFields_CreatedAt_Delete>;
  read?: Maybe<CategoryDocAccessFields_CreatedAt_Read>;
  update?: Maybe<CategoryDocAccessFields_CreatedAt_Update>;
};

export type CategoryDocAccessFields_CreatedAt_Create = {
  __typename?: 'CategoryDocAccessFields_createdAt_Create';
  permission: Scalars['Boolean'];
};

export type CategoryDocAccessFields_CreatedAt_Delete = {
  __typename?: 'CategoryDocAccessFields_createdAt_Delete';
  permission: Scalars['Boolean'];
};

export type CategoryDocAccessFields_CreatedAt_Read = {
  __typename?: 'CategoryDocAccessFields_createdAt_Read';
  permission: Scalars['Boolean'];
};

export type CategoryDocAccessFields_CreatedAt_Update = {
  __typename?: 'CategoryDocAccessFields_createdAt_Update';
  permission: Scalars['Boolean'];
};

export type CategoryDocAccessFields_Description = {
  __typename?: 'CategoryDocAccessFields_description';
  create?: Maybe<CategoryDocAccessFields_Description_Create>;
  delete?: Maybe<CategoryDocAccessFields_Description_Delete>;
  read?: Maybe<CategoryDocAccessFields_Description_Read>;
  update?: Maybe<CategoryDocAccessFields_Description_Update>;
};

export type CategoryDocAccessFields_Description_Create = {
  __typename?: 'CategoryDocAccessFields_description_Create';
  permission: Scalars['Boolean'];
};

export type CategoryDocAccessFields_Description_Delete = {
  __typename?: 'CategoryDocAccessFields_description_Delete';
  permission: Scalars['Boolean'];
};

export type CategoryDocAccessFields_Description_Read = {
  __typename?: 'CategoryDocAccessFields_description_Read';
  permission: Scalars['Boolean'];
};

export type CategoryDocAccessFields_Description_Update = {
  __typename?: 'CategoryDocAccessFields_description_Update';
  permission: Scalars['Boolean'];
};

export type CategoryDocAccessFields_FeaturedCategory = {
  __typename?: 'CategoryDocAccessFields_featuredCategory';
  create?: Maybe<CategoryDocAccessFields_FeaturedCategory_Create>;
  delete?: Maybe<CategoryDocAccessFields_FeaturedCategory_Delete>;
  read?: Maybe<CategoryDocAccessFields_FeaturedCategory_Read>;
  update?: Maybe<CategoryDocAccessFields_FeaturedCategory_Update>;
};

export type CategoryDocAccessFields_FeaturedCategory_Create = {
  __typename?: 'CategoryDocAccessFields_featuredCategory_Create';
  permission: Scalars['Boolean'];
};

export type CategoryDocAccessFields_FeaturedCategory_Delete = {
  __typename?: 'CategoryDocAccessFields_featuredCategory_Delete';
  permission: Scalars['Boolean'];
};

export type CategoryDocAccessFields_FeaturedCategory_Read = {
  __typename?: 'CategoryDocAccessFields_featuredCategory_Read';
  permission: Scalars['Boolean'];
};

export type CategoryDocAccessFields_FeaturedCategory_Update = {
  __typename?: 'CategoryDocAccessFields_featuredCategory_Update';
  permission: Scalars['Boolean'];
};

export type CategoryDocAccessFields_Slug = {
  __typename?: 'CategoryDocAccessFields_slug';
  create?: Maybe<CategoryDocAccessFields_Slug_Create>;
  delete?: Maybe<CategoryDocAccessFields_Slug_Delete>;
  read?: Maybe<CategoryDocAccessFields_Slug_Read>;
  update?: Maybe<CategoryDocAccessFields_Slug_Update>;
};

export type CategoryDocAccessFields_Slug_Create = {
  __typename?: 'CategoryDocAccessFields_slug_Create';
  permission: Scalars['Boolean'];
};

export type CategoryDocAccessFields_Slug_Delete = {
  __typename?: 'CategoryDocAccessFields_slug_Delete';
  permission: Scalars['Boolean'];
};

export type CategoryDocAccessFields_Slug_Read = {
  __typename?: 'CategoryDocAccessFields_slug_Read';
  permission: Scalars['Boolean'];
};

export type CategoryDocAccessFields_Slug_Update = {
  __typename?: 'CategoryDocAccessFields_slug_Update';
  permission: Scalars['Boolean'];
};

export type CategoryDocAccessFields_Title = {
  __typename?: 'CategoryDocAccessFields_title';
  create?: Maybe<CategoryDocAccessFields_Title_Create>;
  delete?: Maybe<CategoryDocAccessFields_Title_Delete>;
  read?: Maybe<CategoryDocAccessFields_Title_Read>;
  update?: Maybe<CategoryDocAccessFields_Title_Update>;
};

export type CategoryDocAccessFields_Title_Create = {
  __typename?: 'CategoryDocAccessFields_title_Create';
  permission: Scalars['Boolean'];
};

export type CategoryDocAccessFields_Title_Delete = {
  __typename?: 'CategoryDocAccessFields_title_Delete';
  permission: Scalars['Boolean'];
};

export type CategoryDocAccessFields_Title_Read = {
  __typename?: 'CategoryDocAccessFields_title_Read';
  permission: Scalars['Boolean'];
};

export type CategoryDocAccessFields_Title_Update = {
  __typename?: 'CategoryDocAccessFields_title_Update';
  permission: Scalars['Boolean'];
};

export type CategoryDocAccessFields_UpdatedAt = {
  __typename?: 'CategoryDocAccessFields_updatedAt';
  create?: Maybe<CategoryDocAccessFields_UpdatedAt_Create>;
  delete?: Maybe<CategoryDocAccessFields_UpdatedAt_Delete>;
  read?: Maybe<CategoryDocAccessFields_UpdatedAt_Read>;
  update?: Maybe<CategoryDocAccessFields_UpdatedAt_Update>;
};

export type CategoryDocAccessFields_UpdatedAt_Create = {
  __typename?: 'CategoryDocAccessFields_updatedAt_Create';
  permission: Scalars['Boolean'];
};

export type CategoryDocAccessFields_UpdatedAt_Delete = {
  __typename?: 'CategoryDocAccessFields_updatedAt_Delete';
  permission: Scalars['Boolean'];
};

export type CategoryDocAccessFields_UpdatedAt_Read = {
  __typename?: 'CategoryDocAccessFields_updatedAt_Read';
  permission: Scalars['Boolean'];
};

export type CategoryDocAccessFields_UpdatedAt_Update = {
  __typename?: 'CategoryDocAccessFields_updatedAt_Update';
  permission: Scalars['Boolean'];
};

export type CategoryFields = {
  __typename?: 'CategoryFields';
  createdAt?: Maybe<CategoryFields_CreatedAt>;
  description?: Maybe<CategoryFields_Description>;
  featuredCategory?: Maybe<CategoryFields_FeaturedCategory>;
  slug?: Maybe<CategoryFields_Slug>;
  title?: Maybe<CategoryFields_Title>;
  updatedAt?: Maybe<CategoryFields_UpdatedAt>;
};

export type CategoryFields_CreatedAt = {
  __typename?: 'CategoryFields_createdAt';
  create?: Maybe<CategoryFields_CreatedAt_Create>;
  delete?: Maybe<CategoryFields_CreatedAt_Delete>;
  read?: Maybe<CategoryFields_CreatedAt_Read>;
  update?: Maybe<CategoryFields_CreatedAt_Update>;
};

export type CategoryFields_CreatedAt_Create = {
  __typename?: 'CategoryFields_createdAt_Create';
  permission: Scalars['Boolean'];
};

export type CategoryFields_CreatedAt_Delete = {
  __typename?: 'CategoryFields_createdAt_Delete';
  permission: Scalars['Boolean'];
};

export type CategoryFields_CreatedAt_Read = {
  __typename?: 'CategoryFields_createdAt_Read';
  permission: Scalars['Boolean'];
};

export type CategoryFields_CreatedAt_Update = {
  __typename?: 'CategoryFields_createdAt_Update';
  permission: Scalars['Boolean'];
};

export type CategoryFields_Description = {
  __typename?: 'CategoryFields_description';
  create?: Maybe<CategoryFields_Description_Create>;
  delete?: Maybe<CategoryFields_Description_Delete>;
  read?: Maybe<CategoryFields_Description_Read>;
  update?: Maybe<CategoryFields_Description_Update>;
};

export type CategoryFields_Description_Create = {
  __typename?: 'CategoryFields_description_Create';
  permission: Scalars['Boolean'];
};

export type CategoryFields_Description_Delete = {
  __typename?: 'CategoryFields_description_Delete';
  permission: Scalars['Boolean'];
};

export type CategoryFields_Description_Read = {
  __typename?: 'CategoryFields_description_Read';
  permission: Scalars['Boolean'];
};

export type CategoryFields_Description_Update = {
  __typename?: 'CategoryFields_description_Update';
  permission: Scalars['Boolean'];
};

export type CategoryFields_FeaturedCategory = {
  __typename?: 'CategoryFields_featuredCategory';
  create?: Maybe<CategoryFields_FeaturedCategory_Create>;
  delete?: Maybe<CategoryFields_FeaturedCategory_Delete>;
  read?: Maybe<CategoryFields_FeaturedCategory_Read>;
  update?: Maybe<CategoryFields_FeaturedCategory_Update>;
};

export type CategoryFields_FeaturedCategory_Create = {
  __typename?: 'CategoryFields_featuredCategory_Create';
  permission: Scalars['Boolean'];
};

export type CategoryFields_FeaturedCategory_Delete = {
  __typename?: 'CategoryFields_featuredCategory_Delete';
  permission: Scalars['Boolean'];
};

export type CategoryFields_FeaturedCategory_Read = {
  __typename?: 'CategoryFields_featuredCategory_Read';
  permission: Scalars['Boolean'];
};

export type CategoryFields_FeaturedCategory_Update = {
  __typename?: 'CategoryFields_featuredCategory_Update';
  permission: Scalars['Boolean'];
};

export type CategoryFields_Slug = {
  __typename?: 'CategoryFields_slug';
  create?: Maybe<CategoryFields_Slug_Create>;
  delete?: Maybe<CategoryFields_Slug_Delete>;
  read?: Maybe<CategoryFields_Slug_Read>;
  update?: Maybe<CategoryFields_Slug_Update>;
};

export type CategoryFields_Slug_Create = {
  __typename?: 'CategoryFields_slug_Create';
  permission: Scalars['Boolean'];
};

export type CategoryFields_Slug_Delete = {
  __typename?: 'CategoryFields_slug_Delete';
  permission: Scalars['Boolean'];
};

export type CategoryFields_Slug_Read = {
  __typename?: 'CategoryFields_slug_Read';
  permission: Scalars['Boolean'];
};

export type CategoryFields_Slug_Update = {
  __typename?: 'CategoryFields_slug_Update';
  permission: Scalars['Boolean'];
};

export type CategoryFields_Title = {
  __typename?: 'CategoryFields_title';
  create?: Maybe<CategoryFields_Title_Create>;
  delete?: Maybe<CategoryFields_Title_Delete>;
  read?: Maybe<CategoryFields_Title_Read>;
  update?: Maybe<CategoryFields_Title_Update>;
};

export type CategoryFields_Title_Create = {
  __typename?: 'CategoryFields_title_Create';
  permission: Scalars['Boolean'];
};

export type CategoryFields_Title_Delete = {
  __typename?: 'CategoryFields_title_Delete';
  permission: Scalars['Boolean'];
};

export type CategoryFields_Title_Read = {
  __typename?: 'CategoryFields_title_Read';
  permission: Scalars['Boolean'];
};

export type CategoryFields_Title_Update = {
  __typename?: 'CategoryFields_title_Update';
  permission: Scalars['Boolean'];
};

export type CategoryFields_UpdatedAt = {
  __typename?: 'CategoryFields_updatedAt';
  create?: Maybe<CategoryFields_UpdatedAt_Create>;
  delete?: Maybe<CategoryFields_UpdatedAt_Delete>;
  read?: Maybe<CategoryFields_UpdatedAt_Read>;
  update?: Maybe<CategoryFields_UpdatedAt_Update>;
};

export type CategoryFields_UpdatedAt_Create = {
  __typename?: 'CategoryFields_updatedAt_Create';
  permission: Scalars['Boolean'];
};

export type CategoryFields_UpdatedAt_Delete = {
  __typename?: 'CategoryFields_updatedAt_Delete';
  permission: Scalars['Boolean'];
};

export type CategoryFields_UpdatedAt_Read = {
  __typename?: 'CategoryFields_updatedAt_Read';
  permission: Scalars['Boolean'];
};

export type CategoryFields_UpdatedAt_Update = {
  __typename?: 'CategoryFields_updatedAt_Update';
  permission: Scalars['Boolean'];
};

export type CategoryReadAccess = {
  __typename?: 'CategoryReadAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type CategoryReadDocAccess = {
  __typename?: 'CategoryReadDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type CategoryUpdateAccess = {
  __typename?: 'CategoryUpdateAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type CategoryUpdateDocAccess = {
  __typename?: 'CategoryUpdateDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type Category_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type Category_Description_Operator = {
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
};

export type Category_FeaturedCategory_Operator = {
  equals?: InputMaybe<Scalars['Boolean']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  not_equals?: InputMaybe<Scalars['Boolean']>;
};

export type Category_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Category_Slug_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Category_Title_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Category_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type Category_Where = {
  AND?: InputMaybe<Array<InputMaybe<Category_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Category_Where_Or>>>;
  createdAt?: InputMaybe<Category_CreatedAt_Operator>;
  description?: InputMaybe<Category_Description_Operator>;
  featuredCategory?: InputMaybe<Category_FeaturedCategory_Operator>;
  id?: InputMaybe<Category_Id_Operator>;
  slug?: InputMaybe<Category_Slug_Operator>;
  title?: InputMaybe<Category_Title_Operator>;
  updatedAt?: InputMaybe<Category_UpdatedAt_Operator>;
};

export type Category_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<Category_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Category_Where_Or>>>;
  createdAt?: InputMaybe<Category_CreatedAt_Operator>;
  description?: InputMaybe<Category_Description_Operator>;
  featuredCategory?: InputMaybe<Category_FeaturedCategory_Operator>;
  id?: InputMaybe<Category_Id_Operator>;
  slug?: InputMaybe<Category_Slug_Operator>;
  title?: InputMaybe<Category_Title_Operator>;
  updatedAt?: InputMaybe<Category_UpdatedAt_Operator>;
};

export type Category_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<Category_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Category_Where_Or>>>;
  createdAt?: InputMaybe<Category_CreatedAt_Operator>;
  description?: InputMaybe<Category_Description_Operator>;
  featuredCategory?: InputMaybe<Category_FeaturedCategory_Operator>;
  id?: InputMaybe<Category_Id_Operator>;
  slug?: InputMaybe<Category_Slug_Operator>;
  title?: InputMaybe<Category_Title_Operator>;
  updatedAt?: InputMaybe<Category_UpdatedAt_Operator>;
};

export type Checkbox = {
  __typename?: 'Checkbox';
  blockName?: Maybe<Scalars['String']>;
  blockType?: Maybe<Scalars['String']>;
  defaultValue?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  required?: Maybe<Scalars['Boolean']>;
  width?: Maybe<Scalars['Float']>;
};

export type Columns = {
  __typename?: 'Columns';
  blockName?: Maybe<Scalars['String']>;
  blockSettings?: Maybe<BlockSettings>;
  blockType?: Maybe<Scalars['String']>;
  columns?: Maybe<Array<Columns_Columns>>;
  id?: Maybe<Scalars['String']>;
  settings?: Maybe<Columns_Settings>;
};

export type Columns_Columns = {
  __typename?: 'Columns_Columns';
  blocks?: Maybe<Array<Columns_Columns_Blocks>>;
  columnWidth?: Maybe<Columns_Columns_ColumnWidth>;
  id?: Maybe<Scalars['String']>;
};

export type Columns_Columns_Blocks = AnimatedTextBlock | CardWithBlocks | Content | Faq | FormBlock | Image | SliderWithBlocks | Spacer | VerticalSlider;

export enum Columns_Columns_ColumnWidth {
  Full = 'full',
  Half = 'half',
  Quarter = 'quarter',
  Third = 'third',
  TwoThirds = 'twoThirds'
}

export type Columns_Settings = {
  __typename?: 'Columns_Settings';
  columnGapSize?: Maybe<Columns_Settings_ColumnGapSize>;
  flipOnMobile?: Maybe<Scalars['Boolean']>;
  verticalAlignment?: Maybe<Columns_Settings_VerticalAlignment>;
};

export enum Columns_Settings_ColumnGapSize {
  Large = 'large',
  Medium = 'medium',
  Small = 'small'
}

export enum Columns_Settings_VerticalAlignment {
  Bottom = 'bottom',
  Middle = 'middle',
  Top = 'top'
}

export type Comparisons = {
  __typename?: 'Comparisons';
  blockName?: Maybe<Scalars['String']>;
  blockType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  leftContent?: Maybe<Scalars['JSON']>;
  primaryComparison?: Maybe<Scalars['JSON']>;
  secondaryComparison?: Maybe<Scalars['JSON']>;
  showLeftContent?: Maybe<Scalars['Boolean']>;
};


export type ComparisonsLeftContentArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};


export type ComparisonsPrimaryComparisonArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};


export type ComparisonsSecondaryComparisonArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};

export type Content = {
  __typename?: 'Content';
  blockName?: Maybe<Scalars['String']>;
  blockSettings?: Maybe<BlockSettings>;
  blockType?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['JSON']>;
  id?: Maybe<Scalars['String']>;
};


export type ContentContentArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};

export type Countdown = {
  __typename?: 'Countdown';
  blockName?: Maybe<Scalars['String']>;
  blockType?: Maybe<Scalars['String']>;
  color?: Maybe<Countdown_Color>;
  date?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
};

export enum Countdown_Color {
  Primary = 'primary',
  White = 'white'
}

export type Cta = {
  __typename?: 'Cta';
  blockName?: Maybe<Scalars['String']>;
  blockSettings?: Maybe<BlockSettings>;
  blockType?: Maybe<Scalars['String']>;
  button?: Maybe<Cta_Button>;
  content?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type CtaBanner = {
  __typename?: 'CtaBanner';
  buttons?: Maybe<Array<CtaBanner_Buttons>>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  enableTrustWidget?: Maybe<Scalars['Boolean']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CtaBannerDocAccessFields = {
  __typename?: 'CtaBannerDocAccessFields';
  buttons?: Maybe<CtaBannerDocAccessFields_Buttons>;
  createdAt?: Maybe<CtaBannerDocAccessFields_CreatedAt>;
  description?: Maybe<CtaBannerDocAccessFields_Description>;
  enableTrustWidget?: Maybe<CtaBannerDocAccessFields_EnableTrustWidget>;
  title?: Maybe<CtaBannerDocAccessFields_Title>;
  updatedAt?: Maybe<CtaBannerDocAccessFields_UpdatedAt>;
};

export type CtaBannerDocAccessFields_Buttons = {
  __typename?: 'CtaBannerDocAccessFields_buttons';
  create?: Maybe<CtaBannerDocAccessFields_Buttons_Create>;
  delete?: Maybe<CtaBannerDocAccessFields_Buttons_Delete>;
  fields?: Maybe<CtaBannerDocAccessFields_Buttons_Fields>;
  read?: Maybe<CtaBannerDocAccessFields_Buttons_Read>;
  update?: Maybe<CtaBannerDocAccessFields_Buttons_Update>;
};

export type CtaBannerDocAccessFields_Buttons_Create = {
  __typename?: 'CtaBannerDocAccessFields_buttons_Create';
  permission: Scalars['Boolean'];
};

export type CtaBannerDocAccessFields_Buttons_Delete = {
  __typename?: 'CtaBannerDocAccessFields_buttons_Delete';
  permission: Scalars['Boolean'];
};

export type CtaBannerDocAccessFields_Buttons_Fields = {
  __typename?: 'CtaBannerDocAccessFields_buttons_Fields';
  buttonType?: Maybe<CtaBannerDocAccessFields_Buttons_ButtonType>;
  id?: Maybe<CtaBannerDocAccessFields_Buttons_Id>;
  link?: Maybe<CtaBannerDocAccessFields_Buttons_Link>;
};

export type CtaBannerDocAccessFields_Buttons_Read = {
  __typename?: 'CtaBannerDocAccessFields_buttons_Read';
  permission: Scalars['Boolean'];
};

export type CtaBannerDocAccessFields_Buttons_Update = {
  __typename?: 'CtaBannerDocAccessFields_buttons_Update';
  permission: Scalars['Boolean'];
};

export type CtaBannerDocAccessFields_Buttons_ButtonType = {
  __typename?: 'CtaBannerDocAccessFields_buttons_buttonType';
  create?: Maybe<CtaBannerDocAccessFields_Buttons_ButtonType_Create>;
  delete?: Maybe<CtaBannerDocAccessFields_Buttons_ButtonType_Delete>;
  read?: Maybe<CtaBannerDocAccessFields_Buttons_ButtonType_Read>;
  update?: Maybe<CtaBannerDocAccessFields_Buttons_ButtonType_Update>;
};

export type CtaBannerDocAccessFields_Buttons_ButtonType_Create = {
  __typename?: 'CtaBannerDocAccessFields_buttons_buttonType_Create';
  permission: Scalars['Boolean'];
};

export type CtaBannerDocAccessFields_Buttons_ButtonType_Delete = {
  __typename?: 'CtaBannerDocAccessFields_buttons_buttonType_Delete';
  permission: Scalars['Boolean'];
};

export type CtaBannerDocAccessFields_Buttons_ButtonType_Read = {
  __typename?: 'CtaBannerDocAccessFields_buttons_buttonType_Read';
  permission: Scalars['Boolean'];
};

export type CtaBannerDocAccessFields_Buttons_ButtonType_Update = {
  __typename?: 'CtaBannerDocAccessFields_buttons_buttonType_Update';
  permission: Scalars['Boolean'];
};

export type CtaBannerDocAccessFields_Buttons_Id = {
  __typename?: 'CtaBannerDocAccessFields_buttons_id';
  create?: Maybe<CtaBannerDocAccessFields_Buttons_Id_Create>;
  delete?: Maybe<CtaBannerDocAccessFields_Buttons_Id_Delete>;
  read?: Maybe<CtaBannerDocAccessFields_Buttons_Id_Read>;
  update?: Maybe<CtaBannerDocAccessFields_Buttons_Id_Update>;
};

export type CtaBannerDocAccessFields_Buttons_Id_Create = {
  __typename?: 'CtaBannerDocAccessFields_buttons_id_Create';
  permission: Scalars['Boolean'];
};

export type CtaBannerDocAccessFields_Buttons_Id_Delete = {
  __typename?: 'CtaBannerDocAccessFields_buttons_id_Delete';
  permission: Scalars['Boolean'];
};

export type CtaBannerDocAccessFields_Buttons_Id_Read = {
  __typename?: 'CtaBannerDocAccessFields_buttons_id_Read';
  permission: Scalars['Boolean'];
};

export type CtaBannerDocAccessFields_Buttons_Id_Update = {
  __typename?: 'CtaBannerDocAccessFields_buttons_id_Update';
  permission: Scalars['Boolean'];
};

export type CtaBannerDocAccessFields_Buttons_Link = {
  __typename?: 'CtaBannerDocAccessFields_buttons_link';
  create?: Maybe<CtaBannerDocAccessFields_Buttons_Link_Create>;
  delete?: Maybe<CtaBannerDocAccessFields_Buttons_Link_Delete>;
  fields?: Maybe<CtaBannerDocAccessFields_Buttons_Link_Fields>;
  read?: Maybe<CtaBannerDocAccessFields_Buttons_Link_Read>;
  update?: Maybe<CtaBannerDocAccessFields_Buttons_Link_Update>;
};

export type CtaBannerDocAccessFields_Buttons_Link_Create = {
  __typename?: 'CtaBannerDocAccessFields_buttons_link_Create';
  permission: Scalars['Boolean'];
};

export type CtaBannerDocAccessFields_Buttons_Link_Delete = {
  __typename?: 'CtaBannerDocAccessFields_buttons_link_Delete';
  permission: Scalars['Boolean'];
};

export type CtaBannerDocAccessFields_Buttons_Link_Fields = {
  __typename?: 'CtaBannerDocAccessFields_buttons_link_Fields';
  label?: Maybe<CtaBannerDocAccessFields_Buttons_Link_Label>;
  reference?: Maybe<CtaBannerDocAccessFields_Buttons_Link_Reference>;
  type?: Maybe<CtaBannerDocAccessFields_Buttons_Link_Type>;
  url?: Maybe<CtaBannerDocAccessFields_Buttons_Link_Url>;
};

export type CtaBannerDocAccessFields_Buttons_Link_Read = {
  __typename?: 'CtaBannerDocAccessFields_buttons_link_Read';
  permission: Scalars['Boolean'];
};

export type CtaBannerDocAccessFields_Buttons_Link_Update = {
  __typename?: 'CtaBannerDocAccessFields_buttons_link_Update';
  permission: Scalars['Boolean'];
};

export type CtaBannerDocAccessFields_Buttons_Link_Label = {
  __typename?: 'CtaBannerDocAccessFields_buttons_link_label';
  create?: Maybe<CtaBannerDocAccessFields_Buttons_Link_Label_Create>;
  delete?: Maybe<CtaBannerDocAccessFields_Buttons_Link_Label_Delete>;
  read?: Maybe<CtaBannerDocAccessFields_Buttons_Link_Label_Read>;
  update?: Maybe<CtaBannerDocAccessFields_Buttons_Link_Label_Update>;
};

export type CtaBannerDocAccessFields_Buttons_Link_Label_Create = {
  __typename?: 'CtaBannerDocAccessFields_buttons_link_label_Create';
  permission: Scalars['Boolean'];
};

export type CtaBannerDocAccessFields_Buttons_Link_Label_Delete = {
  __typename?: 'CtaBannerDocAccessFields_buttons_link_label_Delete';
  permission: Scalars['Boolean'];
};

export type CtaBannerDocAccessFields_Buttons_Link_Label_Read = {
  __typename?: 'CtaBannerDocAccessFields_buttons_link_label_Read';
  permission: Scalars['Boolean'];
};

export type CtaBannerDocAccessFields_Buttons_Link_Label_Update = {
  __typename?: 'CtaBannerDocAccessFields_buttons_link_label_Update';
  permission: Scalars['Boolean'];
};

export type CtaBannerDocAccessFields_Buttons_Link_Reference = {
  __typename?: 'CtaBannerDocAccessFields_buttons_link_reference';
  create?: Maybe<CtaBannerDocAccessFields_Buttons_Link_Reference_Create>;
  delete?: Maybe<CtaBannerDocAccessFields_Buttons_Link_Reference_Delete>;
  read?: Maybe<CtaBannerDocAccessFields_Buttons_Link_Reference_Read>;
  update?: Maybe<CtaBannerDocAccessFields_Buttons_Link_Reference_Update>;
};

export type CtaBannerDocAccessFields_Buttons_Link_Reference_Create = {
  __typename?: 'CtaBannerDocAccessFields_buttons_link_reference_Create';
  permission: Scalars['Boolean'];
};

export type CtaBannerDocAccessFields_Buttons_Link_Reference_Delete = {
  __typename?: 'CtaBannerDocAccessFields_buttons_link_reference_Delete';
  permission: Scalars['Boolean'];
};

export type CtaBannerDocAccessFields_Buttons_Link_Reference_Read = {
  __typename?: 'CtaBannerDocAccessFields_buttons_link_reference_Read';
  permission: Scalars['Boolean'];
};

export type CtaBannerDocAccessFields_Buttons_Link_Reference_Update = {
  __typename?: 'CtaBannerDocAccessFields_buttons_link_reference_Update';
  permission: Scalars['Boolean'];
};

export type CtaBannerDocAccessFields_Buttons_Link_Type = {
  __typename?: 'CtaBannerDocAccessFields_buttons_link_type';
  create?: Maybe<CtaBannerDocAccessFields_Buttons_Link_Type_Create>;
  delete?: Maybe<CtaBannerDocAccessFields_Buttons_Link_Type_Delete>;
  read?: Maybe<CtaBannerDocAccessFields_Buttons_Link_Type_Read>;
  update?: Maybe<CtaBannerDocAccessFields_Buttons_Link_Type_Update>;
};

export type CtaBannerDocAccessFields_Buttons_Link_Type_Create = {
  __typename?: 'CtaBannerDocAccessFields_buttons_link_type_Create';
  permission: Scalars['Boolean'];
};

export type CtaBannerDocAccessFields_Buttons_Link_Type_Delete = {
  __typename?: 'CtaBannerDocAccessFields_buttons_link_type_Delete';
  permission: Scalars['Boolean'];
};

export type CtaBannerDocAccessFields_Buttons_Link_Type_Read = {
  __typename?: 'CtaBannerDocAccessFields_buttons_link_type_Read';
  permission: Scalars['Boolean'];
};

export type CtaBannerDocAccessFields_Buttons_Link_Type_Update = {
  __typename?: 'CtaBannerDocAccessFields_buttons_link_type_Update';
  permission: Scalars['Boolean'];
};

export type CtaBannerDocAccessFields_Buttons_Link_Url = {
  __typename?: 'CtaBannerDocAccessFields_buttons_link_url';
  create?: Maybe<CtaBannerDocAccessFields_Buttons_Link_Url_Create>;
  delete?: Maybe<CtaBannerDocAccessFields_Buttons_Link_Url_Delete>;
  read?: Maybe<CtaBannerDocAccessFields_Buttons_Link_Url_Read>;
  update?: Maybe<CtaBannerDocAccessFields_Buttons_Link_Url_Update>;
};

export type CtaBannerDocAccessFields_Buttons_Link_Url_Create = {
  __typename?: 'CtaBannerDocAccessFields_buttons_link_url_Create';
  permission: Scalars['Boolean'];
};

export type CtaBannerDocAccessFields_Buttons_Link_Url_Delete = {
  __typename?: 'CtaBannerDocAccessFields_buttons_link_url_Delete';
  permission: Scalars['Boolean'];
};

export type CtaBannerDocAccessFields_Buttons_Link_Url_Read = {
  __typename?: 'CtaBannerDocAccessFields_buttons_link_url_Read';
  permission: Scalars['Boolean'];
};

export type CtaBannerDocAccessFields_Buttons_Link_Url_Update = {
  __typename?: 'CtaBannerDocAccessFields_buttons_link_url_Update';
  permission: Scalars['Boolean'];
};

export type CtaBannerDocAccessFields_CreatedAt = {
  __typename?: 'CtaBannerDocAccessFields_createdAt';
  create?: Maybe<CtaBannerDocAccessFields_CreatedAt_Create>;
  delete?: Maybe<CtaBannerDocAccessFields_CreatedAt_Delete>;
  read?: Maybe<CtaBannerDocAccessFields_CreatedAt_Read>;
  update?: Maybe<CtaBannerDocAccessFields_CreatedAt_Update>;
};

export type CtaBannerDocAccessFields_CreatedAt_Create = {
  __typename?: 'CtaBannerDocAccessFields_createdAt_Create';
  permission: Scalars['Boolean'];
};

export type CtaBannerDocAccessFields_CreatedAt_Delete = {
  __typename?: 'CtaBannerDocAccessFields_createdAt_Delete';
  permission: Scalars['Boolean'];
};

export type CtaBannerDocAccessFields_CreatedAt_Read = {
  __typename?: 'CtaBannerDocAccessFields_createdAt_Read';
  permission: Scalars['Boolean'];
};

export type CtaBannerDocAccessFields_CreatedAt_Update = {
  __typename?: 'CtaBannerDocAccessFields_createdAt_Update';
  permission: Scalars['Boolean'];
};

export type CtaBannerDocAccessFields_Description = {
  __typename?: 'CtaBannerDocAccessFields_description';
  create?: Maybe<CtaBannerDocAccessFields_Description_Create>;
  delete?: Maybe<CtaBannerDocAccessFields_Description_Delete>;
  read?: Maybe<CtaBannerDocAccessFields_Description_Read>;
  update?: Maybe<CtaBannerDocAccessFields_Description_Update>;
};

export type CtaBannerDocAccessFields_Description_Create = {
  __typename?: 'CtaBannerDocAccessFields_description_Create';
  permission: Scalars['Boolean'];
};

export type CtaBannerDocAccessFields_Description_Delete = {
  __typename?: 'CtaBannerDocAccessFields_description_Delete';
  permission: Scalars['Boolean'];
};

export type CtaBannerDocAccessFields_Description_Read = {
  __typename?: 'CtaBannerDocAccessFields_description_Read';
  permission: Scalars['Boolean'];
};

export type CtaBannerDocAccessFields_Description_Update = {
  __typename?: 'CtaBannerDocAccessFields_description_Update';
  permission: Scalars['Boolean'];
};

export type CtaBannerDocAccessFields_EnableTrustWidget = {
  __typename?: 'CtaBannerDocAccessFields_enableTrustWidget';
  create?: Maybe<CtaBannerDocAccessFields_EnableTrustWidget_Create>;
  delete?: Maybe<CtaBannerDocAccessFields_EnableTrustWidget_Delete>;
  read?: Maybe<CtaBannerDocAccessFields_EnableTrustWidget_Read>;
  update?: Maybe<CtaBannerDocAccessFields_EnableTrustWidget_Update>;
};

export type CtaBannerDocAccessFields_EnableTrustWidget_Create = {
  __typename?: 'CtaBannerDocAccessFields_enableTrustWidget_Create';
  permission: Scalars['Boolean'];
};

export type CtaBannerDocAccessFields_EnableTrustWidget_Delete = {
  __typename?: 'CtaBannerDocAccessFields_enableTrustWidget_Delete';
  permission: Scalars['Boolean'];
};

export type CtaBannerDocAccessFields_EnableTrustWidget_Read = {
  __typename?: 'CtaBannerDocAccessFields_enableTrustWidget_Read';
  permission: Scalars['Boolean'];
};

export type CtaBannerDocAccessFields_EnableTrustWidget_Update = {
  __typename?: 'CtaBannerDocAccessFields_enableTrustWidget_Update';
  permission: Scalars['Boolean'];
};

export type CtaBannerDocAccessFields_Title = {
  __typename?: 'CtaBannerDocAccessFields_title';
  create?: Maybe<CtaBannerDocAccessFields_Title_Create>;
  delete?: Maybe<CtaBannerDocAccessFields_Title_Delete>;
  read?: Maybe<CtaBannerDocAccessFields_Title_Read>;
  update?: Maybe<CtaBannerDocAccessFields_Title_Update>;
};

export type CtaBannerDocAccessFields_Title_Create = {
  __typename?: 'CtaBannerDocAccessFields_title_Create';
  permission: Scalars['Boolean'];
};

export type CtaBannerDocAccessFields_Title_Delete = {
  __typename?: 'CtaBannerDocAccessFields_title_Delete';
  permission: Scalars['Boolean'];
};

export type CtaBannerDocAccessFields_Title_Read = {
  __typename?: 'CtaBannerDocAccessFields_title_Read';
  permission: Scalars['Boolean'];
};

export type CtaBannerDocAccessFields_Title_Update = {
  __typename?: 'CtaBannerDocAccessFields_title_Update';
  permission: Scalars['Boolean'];
};

export type CtaBannerDocAccessFields_UpdatedAt = {
  __typename?: 'CtaBannerDocAccessFields_updatedAt';
  create?: Maybe<CtaBannerDocAccessFields_UpdatedAt_Create>;
  delete?: Maybe<CtaBannerDocAccessFields_UpdatedAt_Delete>;
  read?: Maybe<CtaBannerDocAccessFields_UpdatedAt_Read>;
  update?: Maybe<CtaBannerDocAccessFields_UpdatedAt_Update>;
};

export type CtaBannerDocAccessFields_UpdatedAt_Create = {
  __typename?: 'CtaBannerDocAccessFields_updatedAt_Create';
  permission: Scalars['Boolean'];
};

export type CtaBannerDocAccessFields_UpdatedAt_Delete = {
  __typename?: 'CtaBannerDocAccessFields_updatedAt_Delete';
  permission: Scalars['Boolean'];
};

export type CtaBannerDocAccessFields_UpdatedAt_Read = {
  __typename?: 'CtaBannerDocAccessFields_updatedAt_Read';
  permission: Scalars['Boolean'];
};

export type CtaBannerDocAccessFields_UpdatedAt_Update = {
  __typename?: 'CtaBannerDocAccessFields_updatedAt_Update';
  permission: Scalars['Boolean'];
};

export type CtaBannerFields = {
  __typename?: 'CtaBannerFields';
  buttons?: Maybe<CtaBannerFields_Buttons>;
  createdAt?: Maybe<CtaBannerFields_CreatedAt>;
  description?: Maybe<CtaBannerFields_Description>;
  enableTrustWidget?: Maybe<CtaBannerFields_EnableTrustWidget>;
  title?: Maybe<CtaBannerFields_Title>;
  updatedAt?: Maybe<CtaBannerFields_UpdatedAt>;
};

export type CtaBannerFields_Buttons = {
  __typename?: 'CtaBannerFields_buttons';
  create?: Maybe<CtaBannerFields_Buttons_Create>;
  delete?: Maybe<CtaBannerFields_Buttons_Delete>;
  fields?: Maybe<CtaBannerFields_Buttons_Fields>;
  read?: Maybe<CtaBannerFields_Buttons_Read>;
  update?: Maybe<CtaBannerFields_Buttons_Update>;
};

export type CtaBannerFields_Buttons_Create = {
  __typename?: 'CtaBannerFields_buttons_Create';
  permission: Scalars['Boolean'];
};

export type CtaBannerFields_Buttons_Delete = {
  __typename?: 'CtaBannerFields_buttons_Delete';
  permission: Scalars['Boolean'];
};

export type CtaBannerFields_Buttons_Fields = {
  __typename?: 'CtaBannerFields_buttons_Fields';
  buttonType?: Maybe<CtaBannerFields_Buttons_ButtonType>;
  id?: Maybe<CtaBannerFields_Buttons_Id>;
  link?: Maybe<CtaBannerFields_Buttons_Link>;
};

export type CtaBannerFields_Buttons_Read = {
  __typename?: 'CtaBannerFields_buttons_Read';
  permission: Scalars['Boolean'];
};

export type CtaBannerFields_Buttons_Update = {
  __typename?: 'CtaBannerFields_buttons_Update';
  permission: Scalars['Boolean'];
};

export type CtaBannerFields_Buttons_ButtonType = {
  __typename?: 'CtaBannerFields_buttons_buttonType';
  create?: Maybe<CtaBannerFields_Buttons_ButtonType_Create>;
  delete?: Maybe<CtaBannerFields_Buttons_ButtonType_Delete>;
  read?: Maybe<CtaBannerFields_Buttons_ButtonType_Read>;
  update?: Maybe<CtaBannerFields_Buttons_ButtonType_Update>;
};

export type CtaBannerFields_Buttons_ButtonType_Create = {
  __typename?: 'CtaBannerFields_buttons_buttonType_Create';
  permission: Scalars['Boolean'];
};

export type CtaBannerFields_Buttons_ButtonType_Delete = {
  __typename?: 'CtaBannerFields_buttons_buttonType_Delete';
  permission: Scalars['Boolean'];
};

export type CtaBannerFields_Buttons_ButtonType_Read = {
  __typename?: 'CtaBannerFields_buttons_buttonType_Read';
  permission: Scalars['Boolean'];
};

export type CtaBannerFields_Buttons_ButtonType_Update = {
  __typename?: 'CtaBannerFields_buttons_buttonType_Update';
  permission: Scalars['Boolean'];
};

export type CtaBannerFields_Buttons_Id = {
  __typename?: 'CtaBannerFields_buttons_id';
  create?: Maybe<CtaBannerFields_Buttons_Id_Create>;
  delete?: Maybe<CtaBannerFields_Buttons_Id_Delete>;
  read?: Maybe<CtaBannerFields_Buttons_Id_Read>;
  update?: Maybe<CtaBannerFields_Buttons_Id_Update>;
};

export type CtaBannerFields_Buttons_Id_Create = {
  __typename?: 'CtaBannerFields_buttons_id_Create';
  permission: Scalars['Boolean'];
};

export type CtaBannerFields_Buttons_Id_Delete = {
  __typename?: 'CtaBannerFields_buttons_id_Delete';
  permission: Scalars['Boolean'];
};

export type CtaBannerFields_Buttons_Id_Read = {
  __typename?: 'CtaBannerFields_buttons_id_Read';
  permission: Scalars['Boolean'];
};

export type CtaBannerFields_Buttons_Id_Update = {
  __typename?: 'CtaBannerFields_buttons_id_Update';
  permission: Scalars['Boolean'];
};

export type CtaBannerFields_Buttons_Link = {
  __typename?: 'CtaBannerFields_buttons_link';
  create?: Maybe<CtaBannerFields_Buttons_Link_Create>;
  delete?: Maybe<CtaBannerFields_Buttons_Link_Delete>;
  fields?: Maybe<CtaBannerFields_Buttons_Link_Fields>;
  read?: Maybe<CtaBannerFields_Buttons_Link_Read>;
  update?: Maybe<CtaBannerFields_Buttons_Link_Update>;
};

export type CtaBannerFields_Buttons_Link_Create = {
  __typename?: 'CtaBannerFields_buttons_link_Create';
  permission: Scalars['Boolean'];
};

export type CtaBannerFields_Buttons_Link_Delete = {
  __typename?: 'CtaBannerFields_buttons_link_Delete';
  permission: Scalars['Boolean'];
};

export type CtaBannerFields_Buttons_Link_Fields = {
  __typename?: 'CtaBannerFields_buttons_link_Fields';
  label?: Maybe<CtaBannerFields_Buttons_Link_Label>;
  reference?: Maybe<CtaBannerFields_Buttons_Link_Reference>;
  type?: Maybe<CtaBannerFields_Buttons_Link_Type>;
  url?: Maybe<CtaBannerFields_Buttons_Link_Url>;
};

export type CtaBannerFields_Buttons_Link_Read = {
  __typename?: 'CtaBannerFields_buttons_link_Read';
  permission: Scalars['Boolean'];
};

export type CtaBannerFields_Buttons_Link_Update = {
  __typename?: 'CtaBannerFields_buttons_link_Update';
  permission: Scalars['Boolean'];
};

export type CtaBannerFields_Buttons_Link_Label = {
  __typename?: 'CtaBannerFields_buttons_link_label';
  create?: Maybe<CtaBannerFields_Buttons_Link_Label_Create>;
  delete?: Maybe<CtaBannerFields_Buttons_Link_Label_Delete>;
  read?: Maybe<CtaBannerFields_Buttons_Link_Label_Read>;
  update?: Maybe<CtaBannerFields_Buttons_Link_Label_Update>;
};

export type CtaBannerFields_Buttons_Link_Label_Create = {
  __typename?: 'CtaBannerFields_buttons_link_label_Create';
  permission: Scalars['Boolean'];
};

export type CtaBannerFields_Buttons_Link_Label_Delete = {
  __typename?: 'CtaBannerFields_buttons_link_label_Delete';
  permission: Scalars['Boolean'];
};

export type CtaBannerFields_Buttons_Link_Label_Read = {
  __typename?: 'CtaBannerFields_buttons_link_label_Read';
  permission: Scalars['Boolean'];
};

export type CtaBannerFields_Buttons_Link_Label_Update = {
  __typename?: 'CtaBannerFields_buttons_link_label_Update';
  permission: Scalars['Boolean'];
};

export type CtaBannerFields_Buttons_Link_Reference = {
  __typename?: 'CtaBannerFields_buttons_link_reference';
  create?: Maybe<CtaBannerFields_Buttons_Link_Reference_Create>;
  delete?: Maybe<CtaBannerFields_Buttons_Link_Reference_Delete>;
  read?: Maybe<CtaBannerFields_Buttons_Link_Reference_Read>;
  update?: Maybe<CtaBannerFields_Buttons_Link_Reference_Update>;
};

export type CtaBannerFields_Buttons_Link_Reference_Create = {
  __typename?: 'CtaBannerFields_buttons_link_reference_Create';
  permission: Scalars['Boolean'];
};

export type CtaBannerFields_Buttons_Link_Reference_Delete = {
  __typename?: 'CtaBannerFields_buttons_link_reference_Delete';
  permission: Scalars['Boolean'];
};

export type CtaBannerFields_Buttons_Link_Reference_Read = {
  __typename?: 'CtaBannerFields_buttons_link_reference_Read';
  permission: Scalars['Boolean'];
};

export type CtaBannerFields_Buttons_Link_Reference_Update = {
  __typename?: 'CtaBannerFields_buttons_link_reference_Update';
  permission: Scalars['Boolean'];
};

export type CtaBannerFields_Buttons_Link_Type = {
  __typename?: 'CtaBannerFields_buttons_link_type';
  create?: Maybe<CtaBannerFields_Buttons_Link_Type_Create>;
  delete?: Maybe<CtaBannerFields_Buttons_Link_Type_Delete>;
  read?: Maybe<CtaBannerFields_Buttons_Link_Type_Read>;
  update?: Maybe<CtaBannerFields_Buttons_Link_Type_Update>;
};

export type CtaBannerFields_Buttons_Link_Type_Create = {
  __typename?: 'CtaBannerFields_buttons_link_type_Create';
  permission: Scalars['Boolean'];
};

export type CtaBannerFields_Buttons_Link_Type_Delete = {
  __typename?: 'CtaBannerFields_buttons_link_type_Delete';
  permission: Scalars['Boolean'];
};

export type CtaBannerFields_Buttons_Link_Type_Read = {
  __typename?: 'CtaBannerFields_buttons_link_type_Read';
  permission: Scalars['Boolean'];
};

export type CtaBannerFields_Buttons_Link_Type_Update = {
  __typename?: 'CtaBannerFields_buttons_link_type_Update';
  permission: Scalars['Boolean'];
};

export type CtaBannerFields_Buttons_Link_Url = {
  __typename?: 'CtaBannerFields_buttons_link_url';
  create?: Maybe<CtaBannerFields_Buttons_Link_Url_Create>;
  delete?: Maybe<CtaBannerFields_Buttons_Link_Url_Delete>;
  read?: Maybe<CtaBannerFields_Buttons_Link_Url_Read>;
  update?: Maybe<CtaBannerFields_Buttons_Link_Url_Update>;
};

export type CtaBannerFields_Buttons_Link_Url_Create = {
  __typename?: 'CtaBannerFields_buttons_link_url_Create';
  permission: Scalars['Boolean'];
};

export type CtaBannerFields_Buttons_Link_Url_Delete = {
  __typename?: 'CtaBannerFields_buttons_link_url_Delete';
  permission: Scalars['Boolean'];
};

export type CtaBannerFields_Buttons_Link_Url_Read = {
  __typename?: 'CtaBannerFields_buttons_link_url_Read';
  permission: Scalars['Boolean'];
};

export type CtaBannerFields_Buttons_Link_Url_Update = {
  __typename?: 'CtaBannerFields_buttons_link_url_Update';
  permission: Scalars['Boolean'];
};

export type CtaBannerFields_CreatedAt = {
  __typename?: 'CtaBannerFields_createdAt';
  create?: Maybe<CtaBannerFields_CreatedAt_Create>;
  delete?: Maybe<CtaBannerFields_CreatedAt_Delete>;
  read?: Maybe<CtaBannerFields_CreatedAt_Read>;
  update?: Maybe<CtaBannerFields_CreatedAt_Update>;
};

export type CtaBannerFields_CreatedAt_Create = {
  __typename?: 'CtaBannerFields_createdAt_Create';
  permission: Scalars['Boolean'];
};

export type CtaBannerFields_CreatedAt_Delete = {
  __typename?: 'CtaBannerFields_createdAt_Delete';
  permission: Scalars['Boolean'];
};

export type CtaBannerFields_CreatedAt_Read = {
  __typename?: 'CtaBannerFields_createdAt_Read';
  permission: Scalars['Boolean'];
};

export type CtaBannerFields_CreatedAt_Update = {
  __typename?: 'CtaBannerFields_createdAt_Update';
  permission: Scalars['Boolean'];
};

export type CtaBannerFields_Description = {
  __typename?: 'CtaBannerFields_description';
  create?: Maybe<CtaBannerFields_Description_Create>;
  delete?: Maybe<CtaBannerFields_Description_Delete>;
  read?: Maybe<CtaBannerFields_Description_Read>;
  update?: Maybe<CtaBannerFields_Description_Update>;
};

export type CtaBannerFields_Description_Create = {
  __typename?: 'CtaBannerFields_description_Create';
  permission: Scalars['Boolean'];
};

export type CtaBannerFields_Description_Delete = {
  __typename?: 'CtaBannerFields_description_Delete';
  permission: Scalars['Boolean'];
};

export type CtaBannerFields_Description_Read = {
  __typename?: 'CtaBannerFields_description_Read';
  permission: Scalars['Boolean'];
};

export type CtaBannerFields_Description_Update = {
  __typename?: 'CtaBannerFields_description_Update';
  permission: Scalars['Boolean'];
};

export type CtaBannerFields_EnableTrustWidget = {
  __typename?: 'CtaBannerFields_enableTrustWidget';
  create?: Maybe<CtaBannerFields_EnableTrustWidget_Create>;
  delete?: Maybe<CtaBannerFields_EnableTrustWidget_Delete>;
  read?: Maybe<CtaBannerFields_EnableTrustWidget_Read>;
  update?: Maybe<CtaBannerFields_EnableTrustWidget_Update>;
};

export type CtaBannerFields_EnableTrustWidget_Create = {
  __typename?: 'CtaBannerFields_enableTrustWidget_Create';
  permission: Scalars['Boolean'];
};

export type CtaBannerFields_EnableTrustWidget_Delete = {
  __typename?: 'CtaBannerFields_enableTrustWidget_Delete';
  permission: Scalars['Boolean'];
};

export type CtaBannerFields_EnableTrustWidget_Read = {
  __typename?: 'CtaBannerFields_enableTrustWidget_Read';
  permission: Scalars['Boolean'];
};

export type CtaBannerFields_EnableTrustWidget_Update = {
  __typename?: 'CtaBannerFields_enableTrustWidget_Update';
  permission: Scalars['Boolean'];
};

export type CtaBannerFields_Title = {
  __typename?: 'CtaBannerFields_title';
  create?: Maybe<CtaBannerFields_Title_Create>;
  delete?: Maybe<CtaBannerFields_Title_Delete>;
  read?: Maybe<CtaBannerFields_Title_Read>;
  update?: Maybe<CtaBannerFields_Title_Update>;
};

export type CtaBannerFields_Title_Create = {
  __typename?: 'CtaBannerFields_title_Create';
  permission: Scalars['Boolean'];
};

export type CtaBannerFields_Title_Delete = {
  __typename?: 'CtaBannerFields_title_Delete';
  permission: Scalars['Boolean'];
};

export type CtaBannerFields_Title_Read = {
  __typename?: 'CtaBannerFields_title_Read';
  permission: Scalars['Boolean'];
};

export type CtaBannerFields_Title_Update = {
  __typename?: 'CtaBannerFields_title_Update';
  permission: Scalars['Boolean'];
};

export type CtaBannerFields_UpdatedAt = {
  __typename?: 'CtaBannerFields_updatedAt';
  create?: Maybe<CtaBannerFields_UpdatedAt_Create>;
  delete?: Maybe<CtaBannerFields_UpdatedAt_Delete>;
  read?: Maybe<CtaBannerFields_UpdatedAt_Read>;
  update?: Maybe<CtaBannerFields_UpdatedAt_Update>;
};

export type CtaBannerFields_UpdatedAt_Create = {
  __typename?: 'CtaBannerFields_updatedAt_Create';
  permission: Scalars['Boolean'];
};

export type CtaBannerFields_UpdatedAt_Delete = {
  __typename?: 'CtaBannerFields_updatedAt_Delete';
  permission: Scalars['Boolean'];
};

export type CtaBannerFields_UpdatedAt_Read = {
  __typename?: 'CtaBannerFields_updatedAt_Read';
  permission: Scalars['Boolean'];
};

export type CtaBannerFields_UpdatedAt_Update = {
  __typename?: 'CtaBannerFields_updatedAt_Update';
  permission: Scalars['Boolean'];
};

export type CtaBannerReadAccess = {
  __typename?: 'CtaBannerReadAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type CtaBannerReadDocAccess = {
  __typename?: 'CtaBannerReadDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type CtaBannerUpdateAccess = {
  __typename?: 'CtaBannerUpdateAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type CtaBannerUpdateDocAccess = {
  __typename?: 'CtaBannerUpdateDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type CtaBanner_Buttons = {
  __typename?: 'CtaBanner_Buttons';
  buttonType?: Maybe<CtaBanner_Buttons_ButtonType>;
  id?: Maybe<Scalars['String']>;
  link?: Maybe<Link>;
};

export type CtaBanner_Buttons_Link_ReferenceRelationshipInput = {
  relationTo?: InputMaybe<CtaBanner_Buttons_Link_ReferenceRelationshipInputRelationTo>;
  value?: InputMaybe<Scalars['JSON']>;
};

export enum CtaBanner_Buttons_Link_ReferenceRelationshipInputRelationTo {
  Article = 'article',
  LeadForm = 'lead_form',
  Page = 'page',
  Service = 'service'
}

export enum CtaBanner_Buttons_ButtonType {
  Primary = 'primary',
  Secondary = 'secondary'
}

export type CtaButton = {
  __typename?: 'CtaButton';
  blockName?: Maybe<Scalars['String']>;
  blockSettings?: Maybe<BlockSettings>;
  blockType?: Maybe<Scalars['String']>;
  buttonType?: Maybe<CtaButton_ButtonType>;
  content?: Maybe<Scalars['JSON']>;
  id?: Maybe<Scalars['String']>;
  link?: Maybe<Link>;
};


export type CtaButtonContentArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};

export enum CtaButton_ButtonType {
  Primary = 'primary',
  Secondary = 'secondary'
}

export type Cta_Button = {
  __typename?: 'Cta_Button';
  buttonType?: Maybe<Cta_Button_ButtonType>;
  link?: Maybe<Link>;
};

export enum Cta_Button_ButtonType {
  Primary = 'primary',
  Secondary = 'secondary'
}

export type CustomerReview = {
  __typename?: 'CustomerReview';
  blockName?: Maybe<Scalars['String']>;
  blockType?: Maybe<Scalars['String']>;
  customerImage?: Maybe<Media>;
  customerName?: Maybe<Scalars['String']>;
  customerReview?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

export type DynamicGreeting = {
  __typename?: 'DynamicGreeting';
  blockName?: Maybe<Scalars['String']>;
  blockType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

export type Email = {
  __typename?: 'Email';
  blockName?: Maybe<Scalars['String']>;
  blockType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  required?: Maybe<Scalars['Boolean']>;
  width?: Maybe<Scalars['Float']>;
};

export type EpcCheckFormSubmission = {
  __typename?: 'EpcCheckFormSubmission';
  address?: Maybe<EpcCheckFormSubmission_Address>;
  converted?: Maybe<Scalars['Boolean']>;
  convertedLeadId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  currentEpcRating: Scalars['Float'];
  email: Scalars['String'];
  id: Scalars['String'];
  potentialEpcRating: Scalars['Float'];
  recommendations?: Maybe<Array<Maybe<Scalars['String']>>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type EpcCheckFormSubmissionCreateAccess = {
  __typename?: 'EpcCheckFormSubmissionCreateAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type EpcCheckFormSubmissionCreateDocAccess = {
  __typename?: 'EpcCheckFormSubmissionCreateDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type EpcCheckFormSubmissionDeleteAccess = {
  __typename?: 'EpcCheckFormSubmissionDeleteAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type EpcCheckFormSubmissionDeleteDocAccess = {
  __typename?: 'EpcCheckFormSubmissionDeleteDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type EpcCheckFormSubmissionDocAccessFields = {
  __typename?: 'EpcCheckFormSubmissionDocAccessFields';
  address?: Maybe<EpcCheckFormSubmissionDocAccessFields_Address>;
  converted?: Maybe<EpcCheckFormSubmissionDocAccessFields_Converted>;
  convertedLeadId?: Maybe<EpcCheckFormSubmissionDocAccessFields_ConvertedLeadId>;
  createdAt?: Maybe<EpcCheckFormSubmissionDocAccessFields_CreatedAt>;
  currentEpcRating?: Maybe<EpcCheckFormSubmissionDocAccessFields_CurrentEpcRating>;
  email?: Maybe<EpcCheckFormSubmissionDocAccessFields_Email>;
  potentialEpcRating?: Maybe<EpcCheckFormSubmissionDocAccessFields_PotentialEpcRating>;
  recommendations?: Maybe<EpcCheckFormSubmissionDocAccessFields_Recommendations>;
  updatedAt?: Maybe<EpcCheckFormSubmissionDocAccessFields_UpdatedAt>;
};

export type EpcCheckFormSubmissionDocAccessFields_Address = {
  __typename?: 'EpcCheckFormSubmissionDocAccessFields_address';
  create?: Maybe<EpcCheckFormSubmissionDocAccessFields_Address_Create>;
  delete?: Maybe<EpcCheckFormSubmissionDocAccessFields_Address_Delete>;
  fields?: Maybe<EpcCheckFormSubmissionDocAccessFields_Address_Fields>;
  read?: Maybe<EpcCheckFormSubmissionDocAccessFields_Address_Read>;
  update?: Maybe<EpcCheckFormSubmissionDocAccessFields_Address_Update>;
};

export type EpcCheckFormSubmissionDocAccessFields_Address_Create = {
  __typename?: 'EpcCheckFormSubmissionDocAccessFields_address_Create';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionDocAccessFields_Address_Delete = {
  __typename?: 'EpcCheckFormSubmissionDocAccessFields_address_Delete';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionDocAccessFields_Address_Fields = {
  __typename?: 'EpcCheckFormSubmissionDocAccessFields_address_Fields';
  address1?: Maybe<EpcCheckFormSubmissionDocAccessFields_Address_Address1>;
  address2?: Maybe<EpcCheckFormSubmissionDocAccessFields_Address_Address2>;
  address3?: Maybe<EpcCheckFormSubmissionDocAccessFields_Address_Address3>;
  localAuthorityLabel?: Maybe<EpcCheckFormSubmissionDocAccessFields_Address_LocalAuthorityLabel>;
  postcode?: Maybe<EpcCheckFormSubmissionDocAccessFields_Address_Postcode>;
  posttown?: Maybe<EpcCheckFormSubmissionDocAccessFields_Address_Posttown>;
};

export type EpcCheckFormSubmissionDocAccessFields_Address_Read = {
  __typename?: 'EpcCheckFormSubmissionDocAccessFields_address_Read';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionDocAccessFields_Address_Update = {
  __typename?: 'EpcCheckFormSubmissionDocAccessFields_address_Update';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionDocAccessFields_Address_Address1 = {
  __typename?: 'EpcCheckFormSubmissionDocAccessFields_address_address1';
  create?: Maybe<EpcCheckFormSubmissionDocAccessFields_Address_Address1_Create>;
  delete?: Maybe<EpcCheckFormSubmissionDocAccessFields_Address_Address1_Delete>;
  read?: Maybe<EpcCheckFormSubmissionDocAccessFields_Address_Address1_Read>;
  update?: Maybe<EpcCheckFormSubmissionDocAccessFields_Address_Address1_Update>;
};

export type EpcCheckFormSubmissionDocAccessFields_Address_Address1_Create = {
  __typename?: 'EpcCheckFormSubmissionDocAccessFields_address_address1_Create';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionDocAccessFields_Address_Address1_Delete = {
  __typename?: 'EpcCheckFormSubmissionDocAccessFields_address_address1_Delete';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionDocAccessFields_Address_Address1_Read = {
  __typename?: 'EpcCheckFormSubmissionDocAccessFields_address_address1_Read';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionDocAccessFields_Address_Address1_Update = {
  __typename?: 'EpcCheckFormSubmissionDocAccessFields_address_address1_Update';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionDocAccessFields_Address_Address2 = {
  __typename?: 'EpcCheckFormSubmissionDocAccessFields_address_address2';
  create?: Maybe<EpcCheckFormSubmissionDocAccessFields_Address_Address2_Create>;
  delete?: Maybe<EpcCheckFormSubmissionDocAccessFields_Address_Address2_Delete>;
  read?: Maybe<EpcCheckFormSubmissionDocAccessFields_Address_Address2_Read>;
  update?: Maybe<EpcCheckFormSubmissionDocAccessFields_Address_Address2_Update>;
};

export type EpcCheckFormSubmissionDocAccessFields_Address_Address2_Create = {
  __typename?: 'EpcCheckFormSubmissionDocAccessFields_address_address2_Create';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionDocAccessFields_Address_Address2_Delete = {
  __typename?: 'EpcCheckFormSubmissionDocAccessFields_address_address2_Delete';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionDocAccessFields_Address_Address2_Read = {
  __typename?: 'EpcCheckFormSubmissionDocAccessFields_address_address2_Read';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionDocAccessFields_Address_Address2_Update = {
  __typename?: 'EpcCheckFormSubmissionDocAccessFields_address_address2_Update';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionDocAccessFields_Address_Address3 = {
  __typename?: 'EpcCheckFormSubmissionDocAccessFields_address_address3';
  create?: Maybe<EpcCheckFormSubmissionDocAccessFields_Address_Address3_Create>;
  delete?: Maybe<EpcCheckFormSubmissionDocAccessFields_Address_Address3_Delete>;
  read?: Maybe<EpcCheckFormSubmissionDocAccessFields_Address_Address3_Read>;
  update?: Maybe<EpcCheckFormSubmissionDocAccessFields_Address_Address3_Update>;
};

export type EpcCheckFormSubmissionDocAccessFields_Address_Address3_Create = {
  __typename?: 'EpcCheckFormSubmissionDocAccessFields_address_address3_Create';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionDocAccessFields_Address_Address3_Delete = {
  __typename?: 'EpcCheckFormSubmissionDocAccessFields_address_address3_Delete';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionDocAccessFields_Address_Address3_Read = {
  __typename?: 'EpcCheckFormSubmissionDocAccessFields_address_address3_Read';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionDocAccessFields_Address_Address3_Update = {
  __typename?: 'EpcCheckFormSubmissionDocAccessFields_address_address3_Update';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionDocAccessFields_Address_LocalAuthorityLabel = {
  __typename?: 'EpcCheckFormSubmissionDocAccessFields_address_localAuthorityLabel';
  create?: Maybe<EpcCheckFormSubmissionDocAccessFields_Address_LocalAuthorityLabel_Create>;
  delete?: Maybe<EpcCheckFormSubmissionDocAccessFields_Address_LocalAuthorityLabel_Delete>;
  read?: Maybe<EpcCheckFormSubmissionDocAccessFields_Address_LocalAuthorityLabel_Read>;
  update?: Maybe<EpcCheckFormSubmissionDocAccessFields_Address_LocalAuthorityLabel_Update>;
};

export type EpcCheckFormSubmissionDocAccessFields_Address_LocalAuthorityLabel_Create = {
  __typename?: 'EpcCheckFormSubmissionDocAccessFields_address_localAuthorityLabel_Create';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionDocAccessFields_Address_LocalAuthorityLabel_Delete = {
  __typename?: 'EpcCheckFormSubmissionDocAccessFields_address_localAuthorityLabel_Delete';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionDocAccessFields_Address_LocalAuthorityLabel_Read = {
  __typename?: 'EpcCheckFormSubmissionDocAccessFields_address_localAuthorityLabel_Read';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionDocAccessFields_Address_LocalAuthorityLabel_Update = {
  __typename?: 'EpcCheckFormSubmissionDocAccessFields_address_localAuthorityLabel_Update';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionDocAccessFields_Address_Postcode = {
  __typename?: 'EpcCheckFormSubmissionDocAccessFields_address_postcode';
  create?: Maybe<EpcCheckFormSubmissionDocAccessFields_Address_Postcode_Create>;
  delete?: Maybe<EpcCheckFormSubmissionDocAccessFields_Address_Postcode_Delete>;
  read?: Maybe<EpcCheckFormSubmissionDocAccessFields_Address_Postcode_Read>;
  update?: Maybe<EpcCheckFormSubmissionDocAccessFields_Address_Postcode_Update>;
};

export type EpcCheckFormSubmissionDocAccessFields_Address_Postcode_Create = {
  __typename?: 'EpcCheckFormSubmissionDocAccessFields_address_postcode_Create';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionDocAccessFields_Address_Postcode_Delete = {
  __typename?: 'EpcCheckFormSubmissionDocAccessFields_address_postcode_Delete';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionDocAccessFields_Address_Postcode_Read = {
  __typename?: 'EpcCheckFormSubmissionDocAccessFields_address_postcode_Read';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionDocAccessFields_Address_Postcode_Update = {
  __typename?: 'EpcCheckFormSubmissionDocAccessFields_address_postcode_Update';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionDocAccessFields_Address_Posttown = {
  __typename?: 'EpcCheckFormSubmissionDocAccessFields_address_posttown';
  create?: Maybe<EpcCheckFormSubmissionDocAccessFields_Address_Posttown_Create>;
  delete?: Maybe<EpcCheckFormSubmissionDocAccessFields_Address_Posttown_Delete>;
  read?: Maybe<EpcCheckFormSubmissionDocAccessFields_Address_Posttown_Read>;
  update?: Maybe<EpcCheckFormSubmissionDocAccessFields_Address_Posttown_Update>;
};

export type EpcCheckFormSubmissionDocAccessFields_Address_Posttown_Create = {
  __typename?: 'EpcCheckFormSubmissionDocAccessFields_address_posttown_Create';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionDocAccessFields_Address_Posttown_Delete = {
  __typename?: 'EpcCheckFormSubmissionDocAccessFields_address_posttown_Delete';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionDocAccessFields_Address_Posttown_Read = {
  __typename?: 'EpcCheckFormSubmissionDocAccessFields_address_posttown_Read';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionDocAccessFields_Address_Posttown_Update = {
  __typename?: 'EpcCheckFormSubmissionDocAccessFields_address_posttown_Update';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionDocAccessFields_Converted = {
  __typename?: 'EpcCheckFormSubmissionDocAccessFields_converted';
  create?: Maybe<EpcCheckFormSubmissionDocAccessFields_Converted_Create>;
  delete?: Maybe<EpcCheckFormSubmissionDocAccessFields_Converted_Delete>;
  read?: Maybe<EpcCheckFormSubmissionDocAccessFields_Converted_Read>;
  update?: Maybe<EpcCheckFormSubmissionDocAccessFields_Converted_Update>;
};

export type EpcCheckFormSubmissionDocAccessFields_ConvertedLeadId = {
  __typename?: 'EpcCheckFormSubmissionDocAccessFields_convertedLeadId';
  create?: Maybe<EpcCheckFormSubmissionDocAccessFields_ConvertedLeadId_Create>;
  delete?: Maybe<EpcCheckFormSubmissionDocAccessFields_ConvertedLeadId_Delete>;
  read?: Maybe<EpcCheckFormSubmissionDocAccessFields_ConvertedLeadId_Read>;
  update?: Maybe<EpcCheckFormSubmissionDocAccessFields_ConvertedLeadId_Update>;
};

export type EpcCheckFormSubmissionDocAccessFields_ConvertedLeadId_Create = {
  __typename?: 'EpcCheckFormSubmissionDocAccessFields_convertedLeadId_Create';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionDocAccessFields_ConvertedLeadId_Delete = {
  __typename?: 'EpcCheckFormSubmissionDocAccessFields_convertedLeadId_Delete';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionDocAccessFields_ConvertedLeadId_Read = {
  __typename?: 'EpcCheckFormSubmissionDocAccessFields_convertedLeadId_Read';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionDocAccessFields_ConvertedLeadId_Update = {
  __typename?: 'EpcCheckFormSubmissionDocAccessFields_convertedLeadId_Update';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionDocAccessFields_Converted_Create = {
  __typename?: 'EpcCheckFormSubmissionDocAccessFields_converted_Create';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionDocAccessFields_Converted_Delete = {
  __typename?: 'EpcCheckFormSubmissionDocAccessFields_converted_Delete';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionDocAccessFields_Converted_Read = {
  __typename?: 'EpcCheckFormSubmissionDocAccessFields_converted_Read';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionDocAccessFields_Converted_Update = {
  __typename?: 'EpcCheckFormSubmissionDocAccessFields_converted_Update';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionDocAccessFields_CreatedAt = {
  __typename?: 'EpcCheckFormSubmissionDocAccessFields_createdAt';
  create?: Maybe<EpcCheckFormSubmissionDocAccessFields_CreatedAt_Create>;
  delete?: Maybe<EpcCheckFormSubmissionDocAccessFields_CreatedAt_Delete>;
  read?: Maybe<EpcCheckFormSubmissionDocAccessFields_CreatedAt_Read>;
  update?: Maybe<EpcCheckFormSubmissionDocAccessFields_CreatedAt_Update>;
};

export type EpcCheckFormSubmissionDocAccessFields_CreatedAt_Create = {
  __typename?: 'EpcCheckFormSubmissionDocAccessFields_createdAt_Create';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionDocAccessFields_CreatedAt_Delete = {
  __typename?: 'EpcCheckFormSubmissionDocAccessFields_createdAt_Delete';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionDocAccessFields_CreatedAt_Read = {
  __typename?: 'EpcCheckFormSubmissionDocAccessFields_createdAt_Read';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionDocAccessFields_CreatedAt_Update = {
  __typename?: 'EpcCheckFormSubmissionDocAccessFields_createdAt_Update';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionDocAccessFields_CurrentEpcRating = {
  __typename?: 'EpcCheckFormSubmissionDocAccessFields_currentEpcRating';
  create?: Maybe<EpcCheckFormSubmissionDocAccessFields_CurrentEpcRating_Create>;
  delete?: Maybe<EpcCheckFormSubmissionDocAccessFields_CurrentEpcRating_Delete>;
  read?: Maybe<EpcCheckFormSubmissionDocAccessFields_CurrentEpcRating_Read>;
  update?: Maybe<EpcCheckFormSubmissionDocAccessFields_CurrentEpcRating_Update>;
};

export type EpcCheckFormSubmissionDocAccessFields_CurrentEpcRating_Create = {
  __typename?: 'EpcCheckFormSubmissionDocAccessFields_currentEpcRating_Create';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionDocAccessFields_CurrentEpcRating_Delete = {
  __typename?: 'EpcCheckFormSubmissionDocAccessFields_currentEpcRating_Delete';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionDocAccessFields_CurrentEpcRating_Read = {
  __typename?: 'EpcCheckFormSubmissionDocAccessFields_currentEpcRating_Read';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionDocAccessFields_CurrentEpcRating_Update = {
  __typename?: 'EpcCheckFormSubmissionDocAccessFields_currentEpcRating_Update';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionDocAccessFields_Email = {
  __typename?: 'EpcCheckFormSubmissionDocAccessFields_email';
  create?: Maybe<EpcCheckFormSubmissionDocAccessFields_Email_Create>;
  delete?: Maybe<EpcCheckFormSubmissionDocAccessFields_Email_Delete>;
  read?: Maybe<EpcCheckFormSubmissionDocAccessFields_Email_Read>;
  update?: Maybe<EpcCheckFormSubmissionDocAccessFields_Email_Update>;
};

export type EpcCheckFormSubmissionDocAccessFields_Email_Create = {
  __typename?: 'EpcCheckFormSubmissionDocAccessFields_email_Create';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionDocAccessFields_Email_Delete = {
  __typename?: 'EpcCheckFormSubmissionDocAccessFields_email_Delete';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionDocAccessFields_Email_Read = {
  __typename?: 'EpcCheckFormSubmissionDocAccessFields_email_Read';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionDocAccessFields_Email_Update = {
  __typename?: 'EpcCheckFormSubmissionDocAccessFields_email_Update';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionDocAccessFields_PotentialEpcRating = {
  __typename?: 'EpcCheckFormSubmissionDocAccessFields_potentialEpcRating';
  create?: Maybe<EpcCheckFormSubmissionDocAccessFields_PotentialEpcRating_Create>;
  delete?: Maybe<EpcCheckFormSubmissionDocAccessFields_PotentialEpcRating_Delete>;
  read?: Maybe<EpcCheckFormSubmissionDocAccessFields_PotentialEpcRating_Read>;
  update?: Maybe<EpcCheckFormSubmissionDocAccessFields_PotentialEpcRating_Update>;
};

export type EpcCheckFormSubmissionDocAccessFields_PotentialEpcRating_Create = {
  __typename?: 'EpcCheckFormSubmissionDocAccessFields_potentialEpcRating_Create';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionDocAccessFields_PotentialEpcRating_Delete = {
  __typename?: 'EpcCheckFormSubmissionDocAccessFields_potentialEpcRating_Delete';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionDocAccessFields_PotentialEpcRating_Read = {
  __typename?: 'EpcCheckFormSubmissionDocAccessFields_potentialEpcRating_Read';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionDocAccessFields_PotentialEpcRating_Update = {
  __typename?: 'EpcCheckFormSubmissionDocAccessFields_potentialEpcRating_Update';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionDocAccessFields_Recommendations = {
  __typename?: 'EpcCheckFormSubmissionDocAccessFields_recommendations';
  create?: Maybe<EpcCheckFormSubmissionDocAccessFields_Recommendations_Create>;
  delete?: Maybe<EpcCheckFormSubmissionDocAccessFields_Recommendations_Delete>;
  read?: Maybe<EpcCheckFormSubmissionDocAccessFields_Recommendations_Read>;
  update?: Maybe<EpcCheckFormSubmissionDocAccessFields_Recommendations_Update>;
};

export type EpcCheckFormSubmissionDocAccessFields_Recommendations_Create = {
  __typename?: 'EpcCheckFormSubmissionDocAccessFields_recommendations_Create';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionDocAccessFields_Recommendations_Delete = {
  __typename?: 'EpcCheckFormSubmissionDocAccessFields_recommendations_Delete';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionDocAccessFields_Recommendations_Read = {
  __typename?: 'EpcCheckFormSubmissionDocAccessFields_recommendations_Read';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionDocAccessFields_Recommendations_Update = {
  __typename?: 'EpcCheckFormSubmissionDocAccessFields_recommendations_Update';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionDocAccessFields_UpdatedAt = {
  __typename?: 'EpcCheckFormSubmissionDocAccessFields_updatedAt';
  create?: Maybe<EpcCheckFormSubmissionDocAccessFields_UpdatedAt_Create>;
  delete?: Maybe<EpcCheckFormSubmissionDocAccessFields_UpdatedAt_Delete>;
  read?: Maybe<EpcCheckFormSubmissionDocAccessFields_UpdatedAt_Read>;
  update?: Maybe<EpcCheckFormSubmissionDocAccessFields_UpdatedAt_Update>;
};

export type EpcCheckFormSubmissionDocAccessFields_UpdatedAt_Create = {
  __typename?: 'EpcCheckFormSubmissionDocAccessFields_updatedAt_Create';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionDocAccessFields_UpdatedAt_Delete = {
  __typename?: 'EpcCheckFormSubmissionDocAccessFields_updatedAt_Delete';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionDocAccessFields_UpdatedAt_Read = {
  __typename?: 'EpcCheckFormSubmissionDocAccessFields_updatedAt_Read';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionDocAccessFields_UpdatedAt_Update = {
  __typename?: 'EpcCheckFormSubmissionDocAccessFields_updatedAt_Update';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionFields = {
  __typename?: 'EpcCheckFormSubmissionFields';
  address?: Maybe<EpcCheckFormSubmissionFields_Address>;
  converted?: Maybe<EpcCheckFormSubmissionFields_Converted>;
  convertedLeadId?: Maybe<EpcCheckFormSubmissionFields_ConvertedLeadId>;
  createdAt?: Maybe<EpcCheckFormSubmissionFields_CreatedAt>;
  currentEpcRating?: Maybe<EpcCheckFormSubmissionFields_CurrentEpcRating>;
  email?: Maybe<EpcCheckFormSubmissionFields_Email>;
  potentialEpcRating?: Maybe<EpcCheckFormSubmissionFields_PotentialEpcRating>;
  recommendations?: Maybe<EpcCheckFormSubmissionFields_Recommendations>;
  updatedAt?: Maybe<EpcCheckFormSubmissionFields_UpdatedAt>;
};

export type EpcCheckFormSubmissionFields_Address = {
  __typename?: 'EpcCheckFormSubmissionFields_address';
  create?: Maybe<EpcCheckFormSubmissionFields_Address_Create>;
  delete?: Maybe<EpcCheckFormSubmissionFields_Address_Delete>;
  fields?: Maybe<EpcCheckFormSubmissionFields_Address_Fields>;
  read?: Maybe<EpcCheckFormSubmissionFields_Address_Read>;
  update?: Maybe<EpcCheckFormSubmissionFields_Address_Update>;
};

export type EpcCheckFormSubmissionFields_Address_Create = {
  __typename?: 'EpcCheckFormSubmissionFields_address_Create';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionFields_Address_Delete = {
  __typename?: 'EpcCheckFormSubmissionFields_address_Delete';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionFields_Address_Fields = {
  __typename?: 'EpcCheckFormSubmissionFields_address_Fields';
  address1?: Maybe<EpcCheckFormSubmissionFields_Address_Address1>;
  address2?: Maybe<EpcCheckFormSubmissionFields_Address_Address2>;
  address3?: Maybe<EpcCheckFormSubmissionFields_Address_Address3>;
  localAuthorityLabel?: Maybe<EpcCheckFormSubmissionFields_Address_LocalAuthorityLabel>;
  postcode?: Maybe<EpcCheckFormSubmissionFields_Address_Postcode>;
  posttown?: Maybe<EpcCheckFormSubmissionFields_Address_Posttown>;
};

export type EpcCheckFormSubmissionFields_Address_Read = {
  __typename?: 'EpcCheckFormSubmissionFields_address_Read';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionFields_Address_Update = {
  __typename?: 'EpcCheckFormSubmissionFields_address_Update';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionFields_Address_Address1 = {
  __typename?: 'EpcCheckFormSubmissionFields_address_address1';
  create?: Maybe<EpcCheckFormSubmissionFields_Address_Address1_Create>;
  delete?: Maybe<EpcCheckFormSubmissionFields_Address_Address1_Delete>;
  read?: Maybe<EpcCheckFormSubmissionFields_Address_Address1_Read>;
  update?: Maybe<EpcCheckFormSubmissionFields_Address_Address1_Update>;
};

export type EpcCheckFormSubmissionFields_Address_Address1_Create = {
  __typename?: 'EpcCheckFormSubmissionFields_address_address1_Create';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionFields_Address_Address1_Delete = {
  __typename?: 'EpcCheckFormSubmissionFields_address_address1_Delete';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionFields_Address_Address1_Read = {
  __typename?: 'EpcCheckFormSubmissionFields_address_address1_Read';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionFields_Address_Address1_Update = {
  __typename?: 'EpcCheckFormSubmissionFields_address_address1_Update';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionFields_Address_Address2 = {
  __typename?: 'EpcCheckFormSubmissionFields_address_address2';
  create?: Maybe<EpcCheckFormSubmissionFields_Address_Address2_Create>;
  delete?: Maybe<EpcCheckFormSubmissionFields_Address_Address2_Delete>;
  read?: Maybe<EpcCheckFormSubmissionFields_Address_Address2_Read>;
  update?: Maybe<EpcCheckFormSubmissionFields_Address_Address2_Update>;
};

export type EpcCheckFormSubmissionFields_Address_Address2_Create = {
  __typename?: 'EpcCheckFormSubmissionFields_address_address2_Create';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionFields_Address_Address2_Delete = {
  __typename?: 'EpcCheckFormSubmissionFields_address_address2_Delete';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionFields_Address_Address2_Read = {
  __typename?: 'EpcCheckFormSubmissionFields_address_address2_Read';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionFields_Address_Address2_Update = {
  __typename?: 'EpcCheckFormSubmissionFields_address_address2_Update';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionFields_Address_Address3 = {
  __typename?: 'EpcCheckFormSubmissionFields_address_address3';
  create?: Maybe<EpcCheckFormSubmissionFields_Address_Address3_Create>;
  delete?: Maybe<EpcCheckFormSubmissionFields_Address_Address3_Delete>;
  read?: Maybe<EpcCheckFormSubmissionFields_Address_Address3_Read>;
  update?: Maybe<EpcCheckFormSubmissionFields_Address_Address3_Update>;
};

export type EpcCheckFormSubmissionFields_Address_Address3_Create = {
  __typename?: 'EpcCheckFormSubmissionFields_address_address3_Create';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionFields_Address_Address3_Delete = {
  __typename?: 'EpcCheckFormSubmissionFields_address_address3_Delete';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionFields_Address_Address3_Read = {
  __typename?: 'EpcCheckFormSubmissionFields_address_address3_Read';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionFields_Address_Address3_Update = {
  __typename?: 'EpcCheckFormSubmissionFields_address_address3_Update';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionFields_Address_LocalAuthorityLabel = {
  __typename?: 'EpcCheckFormSubmissionFields_address_localAuthorityLabel';
  create?: Maybe<EpcCheckFormSubmissionFields_Address_LocalAuthorityLabel_Create>;
  delete?: Maybe<EpcCheckFormSubmissionFields_Address_LocalAuthorityLabel_Delete>;
  read?: Maybe<EpcCheckFormSubmissionFields_Address_LocalAuthorityLabel_Read>;
  update?: Maybe<EpcCheckFormSubmissionFields_Address_LocalAuthorityLabel_Update>;
};

export type EpcCheckFormSubmissionFields_Address_LocalAuthorityLabel_Create = {
  __typename?: 'EpcCheckFormSubmissionFields_address_localAuthorityLabel_Create';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionFields_Address_LocalAuthorityLabel_Delete = {
  __typename?: 'EpcCheckFormSubmissionFields_address_localAuthorityLabel_Delete';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionFields_Address_LocalAuthorityLabel_Read = {
  __typename?: 'EpcCheckFormSubmissionFields_address_localAuthorityLabel_Read';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionFields_Address_LocalAuthorityLabel_Update = {
  __typename?: 'EpcCheckFormSubmissionFields_address_localAuthorityLabel_Update';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionFields_Address_Postcode = {
  __typename?: 'EpcCheckFormSubmissionFields_address_postcode';
  create?: Maybe<EpcCheckFormSubmissionFields_Address_Postcode_Create>;
  delete?: Maybe<EpcCheckFormSubmissionFields_Address_Postcode_Delete>;
  read?: Maybe<EpcCheckFormSubmissionFields_Address_Postcode_Read>;
  update?: Maybe<EpcCheckFormSubmissionFields_Address_Postcode_Update>;
};

export type EpcCheckFormSubmissionFields_Address_Postcode_Create = {
  __typename?: 'EpcCheckFormSubmissionFields_address_postcode_Create';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionFields_Address_Postcode_Delete = {
  __typename?: 'EpcCheckFormSubmissionFields_address_postcode_Delete';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionFields_Address_Postcode_Read = {
  __typename?: 'EpcCheckFormSubmissionFields_address_postcode_Read';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionFields_Address_Postcode_Update = {
  __typename?: 'EpcCheckFormSubmissionFields_address_postcode_Update';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionFields_Address_Posttown = {
  __typename?: 'EpcCheckFormSubmissionFields_address_posttown';
  create?: Maybe<EpcCheckFormSubmissionFields_Address_Posttown_Create>;
  delete?: Maybe<EpcCheckFormSubmissionFields_Address_Posttown_Delete>;
  read?: Maybe<EpcCheckFormSubmissionFields_Address_Posttown_Read>;
  update?: Maybe<EpcCheckFormSubmissionFields_Address_Posttown_Update>;
};

export type EpcCheckFormSubmissionFields_Address_Posttown_Create = {
  __typename?: 'EpcCheckFormSubmissionFields_address_posttown_Create';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionFields_Address_Posttown_Delete = {
  __typename?: 'EpcCheckFormSubmissionFields_address_posttown_Delete';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionFields_Address_Posttown_Read = {
  __typename?: 'EpcCheckFormSubmissionFields_address_posttown_Read';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionFields_Address_Posttown_Update = {
  __typename?: 'EpcCheckFormSubmissionFields_address_posttown_Update';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionFields_Converted = {
  __typename?: 'EpcCheckFormSubmissionFields_converted';
  create?: Maybe<EpcCheckFormSubmissionFields_Converted_Create>;
  delete?: Maybe<EpcCheckFormSubmissionFields_Converted_Delete>;
  read?: Maybe<EpcCheckFormSubmissionFields_Converted_Read>;
  update?: Maybe<EpcCheckFormSubmissionFields_Converted_Update>;
};

export type EpcCheckFormSubmissionFields_ConvertedLeadId = {
  __typename?: 'EpcCheckFormSubmissionFields_convertedLeadId';
  create?: Maybe<EpcCheckFormSubmissionFields_ConvertedLeadId_Create>;
  delete?: Maybe<EpcCheckFormSubmissionFields_ConvertedLeadId_Delete>;
  read?: Maybe<EpcCheckFormSubmissionFields_ConvertedLeadId_Read>;
  update?: Maybe<EpcCheckFormSubmissionFields_ConvertedLeadId_Update>;
};

export type EpcCheckFormSubmissionFields_ConvertedLeadId_Create = {
  __typename?: 'EpcCheckFormSubmissionFields_convertedLeadId_Create';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionFields_ConvertedLeadId_Delete = {
  __typename?: 'EpcCheckFormSubmissionFields_convertedLeadId_Delete';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionFields_ConvertedLeadId_Read = {
  __typename?: 'EpcCheckFormSubmissionFields_convertedLeadId_Read';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionFields_ConvertedLeadId_Update = {
  __typename?: 'EpcCheckFormSubmissionFields_convertedLeadId_Update';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionFields_Converted_Create = {
  __typename?: 'EpcCheckFormSubmissionFields_converted_Create';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionFields_Converted_Delete = {
  __typename?: 'EpcCheckFormSubmissionFields_converted_Delete';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionFields_Converted_Read = {
  __typename?: 'EpcCheckFormSubmissionFields_converted_Read';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionFields_Converted_Update = {
  __typename?: 'EpcCheckFormSubmissionFields_converted_Update';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionFields_CreatedAt = {
  __typename?: 'EpcCheckFormSubmissionFields_createdAt';
  create?: Maybe<EpcCheckFormSubmissionFields_CreatedAt_Create>;
  delete?: Maybe<EpcCheckFormSubmissionFields_CreatedAt_Delete>;
  read?: Maybe<EpcCheckFormSubmissionFields_CreatedAt_Read>;
  update?: Maybe<EpcCheckFormSubmissionFields_CreatedAt_Update>;
};

export type EpcCheckFormSubmissionFields_CreatedAt_Create = {
  __typename?: 'EpcCheckFormSubmissionFields_createdAt_Create';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionFields_CreatedAt_Delete = {
  __typename?: 'EpcCheckFormSubmissionFields_createdAt_Delete';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionFields_CreatedAt_Read = {
  __typename?: 'EpcCheckFormSubmissionFields_createdAt_Read';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionFields_CreatedAt_Update = {
  __typename?: 'EpcCheckFormSubmissionFields_createdAt_Update';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionFields_CurrentEpcRating = {
  __typename?: 'EpcCheckFormSubmissionFields_currentEpcRating';
  create?: Maybe<EpcCheckFormSubmissionFields_CurrentEpcRating_Create>;
  delete?: Maybe<EpcCheckFormSubmissionFields_CurrentEpcRating_Delete>;
  read?: Maybe<EpcCheckFormSubmissionFields_CurrentEpcRating_Read>;
  update?: Maybe<EpcCheckFormSubmissionFields_CurrentEpcRating_Update>;
};

export type EpcCheckFormSubmissionFields_CurrentEpcRating_Create = {
  __typename?: 'EpcCheckFormSubmissionFields_currentEpcRating_Create';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionFields_CurrentEpcRating_Delete = {
  __typename?: 'EpcCheckFormSubmissionFields_currentEpcRating_Delete';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionFields_CurrentEpcRating_Read = {
  __typename?: 'EpcCheckFormSubmissionFields_currentEpcRating_Read';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionFields_CurrentEpcRating_Update = {
  __typename?: 'EpcCheckFormSubmissionFields_currentEpcRating_Update';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionFields_Email = {
  __typename?: 'EpcCheckFormSubmissionFields_email';
  create?: Maybe<EpcCheckFormSubmissionFields_Email_Create>;
  delete?: Maybe<EpcCheckFormSubmissionFields_Email_Delete>;
  read?: Maybe<EpcCheckFormSubmissionFields_Email_Read>;
  update?: Maybe<EpcCheckFormSubmissionFields_Email_Update>;
};

export type EpcCheckFormSubmissionFields_Email_Create = {
  __typename?: 'EpcCheckFormSubmissionFields_email_Create';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionFields_Email_Delete = {
  __typename?: 'EpcCheckFormSubmissionFields_email_Delete';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionFields_Email_Read = {
  __typename?: 'EpcCheckFormSubmissionFields_email_Read';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionFields_Email_Update = {
  __typename?: 'EpcCheckFormSubmissionFields_email_Update';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionFields_PotentialEpcRating = {
  __typename?: 'EpcCheckFormSubmissionFields_potentialEpcRating';
  create?: Maybe<EpcCheckFormSubmissionFields_PotentialEpcRating_Create>;
  delete?: Maybe<EpcCheckFormSubmissionFields_PotentialEpcRating_Delete>;
  read?: Maybe<EpcCheckFormSubmissionFields_PotentialEpcRating_Read>;
  update?: Maybe<EpcCheckFormSubmissionFields_PotentialEpcRating_Update>;
};

export type EpcCheckFormSubmissionFields_PotentialEpcRating_Create = {
  __typename?: 'EpcCheckFormSubmissionFields_potentialEpcRating_Create';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionFields_PotentialEpcRating_Delete = {
  __typename?: 'EpcCheckFormSubmissionFields_potentialEpcRating_Delete';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionFields_PotentialEpcRating_Read = {
  __typename?: 'EpcCheckFormSubmissionFields_potentialEpcRating_Read';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionFields_PotentialEpcRating_Update = {
  __typename?: 'EpcCheckFormSubmissionFields_potentialEpcRating_Update';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionFields_Recommendations = {
  __typename?: 'EpcCheckFormSubmissionFields_recommendations';
  create?: Maybe<EpcCheckFormSubmissionFields_Recommendations_Create>;
  delete?: Maybe<EpcCheckFormSubmissionFields_Recommendations_Delete>;
  read?: Maybe<EpcCheckFormSubmissionFields_Recommendations_Read>;
  update?: Maybe<EpcCheckFormSubmissionFields_Recommendations_Update>;
};

export type EpcCheckFormSubmissionFields_Recommendations_Create = {
  __typename?: 'EpcCheckFormSubmissionFields_recommendations_Create';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionFields_Recommendations_Delete = {
  __typename?: 'EpcCheckFormSubmissionFields_recommendations_Delete';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionFields_Recommendations_Read = {
  __typename?: 'EpcCheckFormSubmissionFields_recommendations_Read';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionFields_Recommendations_Update = {
  __typename?: 'EpcCheckFormSubmissionFields_recommendations_Update';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionFields_UpdatedAt = {
  __typename?: 'EpcCheckFormSubmissionFields_updatedAt';
  create?: Maybe<EpcCheckFormSubmissionFields_UpdatedAt_Create>;
  delete?: Maybe<EpcCheckFormSubmissionFields_UpdatedAt_Delete>;
  read?: Maybe<EpcCheckFormSubmissionFields_UpdatedAt_Read>;
  update?: Maybe<EpcCheckFormSubmissionFields_UpdatedAt_Update>;
};

export type EpcCheckFormSubmissionFields_UpdatedAt_Create = {
  __typename?: 'EpcCheckFormSubmissionFields_updatedAt_Create';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionFields_UpdatedAt_Delete = {
  __typename?: 'EpcCheckFormSubmissionFields_updatedAt_Delete';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionFields_UpdatedAt_Read = {
  __typename?: 'EpcCheckFormSubmissionFields_updatedAt_Read';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionFields_UpdatedAt_Update = {
  __typename?: 'EpcCheckFormSubmissionFields_updatedAt_Update';
  permission: Scalars['Boolean'];
};

export type EpcCheckFormSubmissionReadAccess = {
  __typename?: 'EpcCheckFormSubmissionReadAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type EpcCheckFormSubmissionReadDocAccess = {
  __typename?: 'EpcCheckFormSubmissionReadDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type EpcCheckFormSubmissionUpdateAccess = {
  __typename?: 'EpcCheckFormSubmissionUpdateAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type EpcCheckFormSubmissionUpdateDocAccess = {
  __typename?: 'EpcCheckFormSubmissionUpdateDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type EpcCheckFormSubmission_Address = {
  __typename?: 'EpcCheckFormSubmission_Address';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  address3?: Maybe<Scalars['String']>;
  localAuthorityLabel?: Maybe<Scalars['String']>;
  postcode?: Maybe<Scalars['String']>;
  posttown?: Maybe<Scalars['String']>;
};

export type EpcCheckFormSubmission_Address__Address1_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type EpcCheckFormSubmission_Address__Address2_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type EpcCheckFormSubmission_Address__Address3_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type EpcCheckFormSubmission_Address__LocalAuthorityLabel_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type EpcCheckFormSubmission_Address__Postcode_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type EpcCheckFormSubmission_Address__Posttown_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type EpcCheckFormSubmission_ConvertedLeadId_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type EpcCheckFormSubmission_Converted_Operator = {
  equals?: InputMaybe<Scalars['Boolean']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  not_equals?: InputMaybe<Scalars['Boolean']>;
};

export type EpcCheckFormSubmission_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type EpcCheckFormSubmission_CurrentEpcRating_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type EpcCheckFormSubmission_Email_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type EpcCheckFormSubmission_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type EpcCheckFormSubmission_PotentialEpcRating_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type EpcCheckFormSubmission_Recommendations_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type EpcCheckFormSubmission_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type EpcCheckFormSubmission_Where = {
  AND?: InputMaybe<Array<InputMaybe<EpcCheckFormSubmission_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<EpcCheckFormSubmission_Where_Or>>>;
  address__address1?: InputMaybe<EpcCheckFormSubmission_Address__Address1_Operator>;
  address__address2?: InputMaybe<EpcCheckFormSubmission_Address__Address2_Operator>;
  address__address3?: InputMaybe<EpcCheckFormSubmission_Address__Address3_Operator>;
  address__localAuthorityLabel?: InputMaybe<EpcCheckFormSubmission_Address__LocalAuthorityLabel_Operator>;
  address__postcode?: InputMaybe<EpcCheckFormSubmission_Address__Postcode_Operator>;
  address__posttown?: InputMaybe<EpcCheckFormSubmission_Address__Posttown_Operator>;
  converted?: InputMaybe<EpcCheckFormSubmission_Converted_Operator>;
  convertedLeadId?: InputMaybe<EpcCheckFormSubmission_ConvertedLeadId_Operator>;
  createdAt?: InputMaybe<EpcCheckFormSubmission_CreatedAt_Operator>;
  currentEpcRating?: InputMaybe<EpcCheckFormSubmission_CurrentEpcRating_Operator>;
  email?: InputMaybe<EpcCheckFormSubmission_Email_Operator>;
  id?: InputMaybe<EpcCheckFormSubmission_Id_Operator>;
  potentialEpcRating?: InputMaybe<EpcCheckFormSubmission_PotentialEpcRating_Operator>;
  recommendations?: InputMaybe<EpcCheckFormSubmission_Recommendations_Operator>;
  updatedAt?: InputMaybe<EpcCheckFormSubmission_UpdatedAt_Operator>;
};

export type EpcCheckFormSubmission_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<EpcCheckFormSubmission_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<EpcCheckFormSubmission_Where_Or>>>;
  address__address1?: InputMaybe<EpcCheckFormSubmission_Address__Address1_Operator>;
  address__address2?: InputMaybe<EpcCheckFormSubmission_Address__Address2_Operator>;
  address__address3?: InputMaybe<EpcCheckFormSubmission_Address__Address3_Operator>;
  address__localAuthorityLabel?: InputMaybe<EpcCheckFormSubmission_Address__LocalAuthorityLabel_Operator>;
  address__postcode?: InputMaybe<EpcCheckFormSubmission_Address__Postcode_Operator>;
  address__posttown?: InputMaybe<EpcCheckFormSubmission_Address__Posttown_Operator>;
  converted?: InputMaybe<EpcCheckFormSubmission_Converted_Operator>;
  convertedLeadId?: InputMaybe<EpcCheckFormSubmission_ConvertedLeadId_Operator>;
  createdAt?: InputMaybe<EpcCheckFormSubmission_CreatedAt_Operator>;
  currentEpcRating?: InputMaybe<EpcCheckFormSubmission_CurrentEpcRating_Operator>;
  email?: InputMaybe<EpcCheckFormSubmission_Email_Operator>;
  id?: InputMaybe<EpcCheckFormSubmission_Id_Operator>;
  potentialEpcRating?: InputMaybe<EpcCheckFormSubmission_PotentialEpcRating_Operator>;
  recommendations?: InputMaybe<EpcCheckFormSubmission_Recommendations_Operator>;
  updatedAt?: InputMaybe<EpcCheckFormSubmission_UpdatedAt_Operator>;
};

export type EpcCheckFormSubmission_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<EpcCheckFormSubmission_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<EpcCheckFormSubmission_Where_Or>>>;
  address__address1?: InputMaybe<EpcCheckFormSubmission_Address__Address1_Operator>;
  address__address2?: InputMaybe<EpcCheckFormSubmission_Address__Address2_Operator>;
  address__address3?: InputMaybe<EpcCheckFormSubmission_Address__Address3_Operator>;
  address__localAuthorityLabel?: InputMaybe<EpcCheckFormSubmission_Address__LocalAuthorityLabel_Operator>;
  address__postcode?: InputMaybe<EpcCheckFormSubmission_Address__Postcode_Operator>;
  address__posttown?: InputMaybe<EpcCheckFormSubmission_Address__Posttown_Operator>;
  converted?: InputMaybe<EpcCheckFormSubmission_Converted_Operator>;
  convertedLeadId?: InputMaybe<EpcCheckFormSubmission_ConvertedLeadId_Operator>;
  createdAt?: InputMaybe<EpcCheckFormSubmission_CreatedAt_Operator>;
  currentEpcRating?: InputMaybe<EpcCheckFormSubmission_CurrentEpcRating_Operator>;
  email?: InputMaybe<EpcCheckFormSubmission_Email_Operator>;
  id?: InputMaybe<EpcCheckFormSubmission_Id_Operator>;
  potentialEpcRating?: InputMaybe<EpcCheckFormSubmission_PotentialEpcRating_Operator>;
  recommendations?: InputMaybe<EpcCheckFormSubmission_Recommendations_Operator>;
  updatedAt?: InputMaybe<EpcCheckFormSubmission_UpdatedAt_Operator>;
};

export type EpcCheckFormSubmissions = {
  __typename?: 'EpcCheckFormSubmissions';
  docs?: Maybe<Array<Maybe<EpcCheckFormSubmission>>>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPrevPage?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  nextPage?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  pagingCounter?: Maybe<Scalars['Int']>;
  prevPage?: Maybe<Scalars['Int']>;
  totalDocs?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
};

export type Faq = {
  __typename?: 'Faq';
  blockName?: Maybe<Scalars['String']>;
  blockSettings?: Maybe<BlockSettings>;
  blockType?: Maybe<Scalars['String']>;
  faqs?: Maybe<Array<Faq_Faqs>>;
  id?: Maybe<Scalars['String']>;
};

export type Faq_Faqs = {
  __typename?: 'Faq_Faqs';
  answer?: Maybe<Scalars['JSON']>;
  id?: Maybe<Scalars['String']>;
  question?: Maybe<Scalars['String']>;
};


export type Faq_FaqsAnswerArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};

export type FooterMenu = {
  __typename?: 'FooterMenu';
  createdAt?: Maybe<Scalars['DateTime']>;
  menuGroups?: Maybe<Array<FooterMenu_MenuGroups>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FooterMenuDocAccessFields = {
  __typename?: 'FooterMenuDocAccessFields';
  createdAt?: Maybe<FooterMenuDocAccessFields_CreatedAt>;
  menuGroups?: Maybe<FooterMenuDocAccessFields_MenuGroups>;
  updatedAt?: Maybe<FooterMenuDocAccessFields_UpdatedAt>;
};

export type FooterMenuDocAccessFields_CreatedAt = {
  __typename?: 'FooterMenuDocAccessFields_createdAt';
  create?: Maybe<FooterMenuDocAccessFields_CreatedAt_Create>;
  delete?: Maybe<FooterMenuDocAccessFields_CreatedAt_Delete>;
  read?: Maybe<FooterMenuDocAccessFields_CreatedAt_Read>;
  update?: Maybe<FooterMenuDocAccessFields_CreatedAt_Update>;
};

export type FooterMenuDocAccessFields_CreatedAt_Create = {
  __typename?: 'FooterMenuDocAccessFields_createdAt_Create';
  permission: Scalars['Boolean'];
};

export type FooterMenuDocAccessFields_CreatedAt_Delete = {
  __typename?: 'FooterMenuDocAccessFields_createdAt_Delete';
  permission: Scalars['Boolean'];
};

export type FooterMenuDocAccessFields_CreatedAt_Read = {
  __typename?: 'FooterMenuDocAccessFields_createdAt_Read';
  permission: Scalars['Boolean'];
};

export type FooterMenuDocAccessFields_CreatedAt_Update = {
  __typename?: 'FooterMenuDocAccessFields_createdAt_Update';
  permission: Scalars['Boolean'];
};

export type FooterMenuDocAccessFields_MenuGroups = {
  __typename?: 'FooterMenuDocAccessFields_menuGroups';
  create?: Maybe<FooterMenuDocAccessFields_MenuGroups_Create>;
  delete?: Maybe<FooterMenuDocAccessFields_MenuGroups_Delete>;
  fields?: Maybe<FooterMenuDocAccessFields_MenuGroups_Fields>;
  read?: Maybe<FooterMenuDocAccessFields_MenuGroups_Read>;
  update?: Maybe<FooterMenuDocAccessFields_MenuGroups_Update>;
};

export type FooterMenuDocAccessFields_MenuGroups_Create = {
  __typename?: 'FooterMenuDocAccessFields_menuGroups_Create';
  permission: Scalars['Boolean'];
};

export type FooterMenuDocAccessFields_MenuGroups_Delete = {
  __typename?: 'FooterMenuDocAccessFields_menuGroups_Delete';
  permission: Scalars['Boolean'];
};

export type FooterMenuDocAccessFields_MenuGroups_Fields = {
  __typename?: 'FooterMenuDocAccessFields_menuGroups_Fields';
  id?: Maybe<FooterMenuDocAccessFields_MenuGroups_Id>;
  links?: Maybe<FooterMenuDocAccessFields_MenuGroups_Links>;
  title?: Maybe<FooterMenuDocAccessFields_MenuGroups_Title>;
};

export type FooterMenuDocAccessFields_MenuGroups_Read = {
  __typename?: 'FooterMenuDocAccessFields_menuGroups_Read';
  permission: Scalars['Boolean'];
};

export type FooterMenuDocAccessFields_MenuGroups_Update = {
  __typename?: 'FooterMenuDocAccessFields_menuGroups_Update';
  permission: Scalars['Boolean'];
};

export type FooterMenuDocAccessFields_MenuGroups_Id = {
  __typename?: 'FooterMenuDocAccessFields_menuGroups_id';
  create?: Maybe<FooterMenuDocAccessFields_MenuGroups_Id_Create>;
  delete?: Maybe<FooterMenuDocAccessFields_MenuGroups_Id_Delete>;
  read?: Maybe<FooterMenuDocAccessFields_MenuGroups_Id_Read>;
  update?: Maybe<FooterMenuDocAccessFields_MenuGroups_Id_Update>;
};

export type FooterMenuDocAccessFields_MenuGroups_Id_Create = {
  __typename?: 'FooterMenuDocAccessFields_menuGroups_id_Create';
  permission: Scalars['Boolean'];
};

export type FooterMenuDocAccessFields_MenuGroups_Id_Delete = {
  __typename?: 'FooterMenuDocAccessFields_menuGroups_id_Delete';
  permission: Scalars['Boolean'];
};

export type FooterMenuDocAccessFields_MenuGroups_Id_Read = {
  __typename?: 'FooterMenuDocAccessFields_menuGroups_id_Read';
  permission: Scalars['Boolean'];
};

export type FooterMenuDocAccessFields_MenuGroups_Id_Update = {
  __typename?: 'FooterMenuDocAccessFields_menuGroups_id_Update';
  permission: Scalars['Boolean'];
};

export type FooterMenuDocAccessFields_MenuGroups_Links = {
  __typename?: 'FooterMenuDocAccessFields_menuGroups_links';
  create?: Maybe<FooterMenuDocAccessFields_MenuGroups_Links_Create>;
  delete?: Maybe<FooterMenuDocAccessFields_MenuGroups_Links_Delete>;
  fields?: Maybe<FooterMenuDocAccessFields_MenuGroups_Links_Fields>;
  read?: Maybe<FooterMenuDocAccessFields_MenuGroups_Links_Read>;
  update?: Maybe<FooterMenuDocAccessFields_MenuGroups_Links_Update>;
};

export type FooterMenuDocAccessFields_MenuGroups_Links_Create = {
  __typename?: 'FooterMenuDocAccessFields_menuGroups_links_Create';
  permission: Scalars['Boolean'];
};

export type FooterMenuDocAccessFields_MenuGroups_Links_Delete = {
  __typename?: 'FooterMenuDocAccessFields_menuGroups_links_Delete';
  permission: Scalars['Boolean'];
};

export type FooterMenuDocAccessFields_MenuGroups_Links_Fields = {
  __typename?: 'FooterMenuDocAccessFields_menuGroups_links_Fields';
  id?: Maybe<FooterMenuDocAccessFields_MenuGroups_Links_Id>;
  link?: Maybe<FooterMenuDocAccessFields_MenuGroups_Links_Link>;
};

export type FooterMenuDocAccessFields_MenuGroups_Links_Read = {
  __typename?: 'FooterMenuDocAccessFields_menuGroups_links_Read';
  permission: Scalars['Boolean'];
};

export type FooterMenuDocAccessFields_MenuGroups_Links_Update = {
  __typename?: 'FooterMenuDocAccessFields_menuGroups_links_Update';
  permission: Scalars['Boolean'];
};

export type FooterMenuDocAccessFields_MenuGroups_Links_Id = {
  __typename?: 'FooterMenuDocAccessFields_menuGroups_links_id';
  create?: Maybe<FooterMenuDocAccessFields_MenuGroups_Links_Id_Create>;
  delete?: Maybe<FooterMenuDocAccessFields_MenuGroups_Links_Id_Delete>;
  read?: Maybe<FooterMenuDocAccessFields_MenuGroups_Links_Id_Read>;
  update?: Maybe<FooterMenuDocAccessFields_MenuGroups_Links_Id_Update>;
};

export type FooterMenuDocAccessFields_MenuGroups_Links_Id_Create = {
  __typename?: 'FooterMenuDocAccessFields_menuGroups_links_id_Create';
  permission: Scalars['Boolean'];
};

export type FooterMenuDocAccessFields_MenuGroups_Links_Id_Delete = {
  __typename?: 'FooterMenuDocAccessFields_menuGroups_links_id_Delete';
  permission: Scalars['Boolean'];
};

export type FooterMenuDocAccessFields_MenuGroups_Links_Id_Read = {
  __typename?: 'FooterMenuDocAccessFields_menuGroups_links_id_Read';
  permission: Scalars['Boolean'];
};

export type FooterMenuDocAccessFields_MenuGroups_Links_Id_Update = {
  __typename?: 'FooterMenuDocAccessFields_menuGroups_links_id_Update';
  permission: Scalars['Boolean'];
};

export type FooterMenuDocAccessFields_MenuGroups_Links_Link = {
  __typename?: 'FooterMenuDocAccessFields_menuGroups_links_link';
  create?: Maybe<FooterMenuDocAccessFields_MenuGroups_Links_Link_Create>;
  delete?: Maybe<FooterMenuDocAccessFields_MenuGroups_Links_Link_Delete>;
  fields?: Maybe<FooterMenuDocAccessFields_MenuGroups_Links_Link_Fields>;
  read?: Maybe<FooterMenuDocAccessFields_MenuGroups_Links_Link_Read>;
  update?: Maybe<FooterMenuDocAccessFields_MenuGroups_Links_Link_Update>;
};

export type FooterMenuDocAccessFields_MenuGroups_Links_Link_Create = {
  __typename?: 'FooterMenuDocAccessFields_menuGroups_links_link_Create';
  permission: Scalars['Boolean'];
};

export type FooterMenuDocAccessFields_MenuGroups_Links_Link_Delete = {
  __typename?: 'FooterMenuDocAccessFields_menuGroups_links_link_Delete';
  permission: Scalars['Boolean'];
};

export type FooterMenuDocAccessFields_MenuGroups_Links_Link_Fields = {
  __typename?: 'FooterMenuDocAccessFields_menuGroups_links_link_Fields';
  label?: Maybe<FooterMenuDocAccessFields_MenuGroups_Links_Link_Label>;
  reference?: Maybe<FooterMenuDocAccessFields_MenuGroups_Links_Link_Reference>;
  type?: Maybe<FooterMenuDocAccessFields_MenuGroups_Links_Link_Type>;
  url?: Maybe<FooterMenuDocAccessFields_MenuGroups_Links_Link_Url>;
};

export type FooterMenuDocAccessFields_MenuGroups_Links_Link_Read = {
  __typename?: 'FooterMenuDocAccessFields_menuGroups_links_link_Read';
  permission: Scalars['Boolean'];
};

export type FooterMenuDocAccessFields_MenuGroups_Links_Link_Update = {
  __typename?: 'FooterMenuDocAccessFields_menuGroups_links_link_Update';
  permission: Scalars['Boolean'];
};

export type FooterMenuDocAccessFields_MenuGroups_Links_Link_Label = {
  __typename?: 'FooterMenuDocAccessFields_menuGroups_links_link_label';
  create?: Maybe<FooterMenuDocAccessFields_MenuGroups_Links_Link_Label_Create>;
  delete?: Maybe<FooterMenuDocAccessFields_MenuGroups_Links_Link_Label_Delete>;
  read?: Maybe<FooterMenuDocAccessFields_MenuGroups_Links_Link_Label_Read>;
  update?: Maybe<FooterMenuDocAccessFields_MenuGroups_Links_Link_Label_Update>;
};

export type FooterMenuDocAccessFields_MenuGroups_Links_Link_Label_Create = {
  __typename?: 'FooterMenuDocAccessFields_menuGroups_links_link_label_Create';
  permission: Scalars['Boolean'];
};

export type FooterMenuDocAccessFields_MenuGroups_Links_Link_Label_Delete = {
  __typename?: 'FooterMenuDocAccessFields_menuGroups_links_link_label_Delete';
  permission: Scalars['Boolean'];
};

export type FooterMenuDocAccessFields_MenuGroups_Links_Link_Label_Read = {
  __typename?: 'FooterMenuDocAccessFields_menuGroups_links_link_label_Read';
  permission: Scalars['Boolean'];
};

export type FooterMenuDocAccessFields_MenuGroups_Links_Link_Label_Update = {
  __typename?: 'FooterMenuDocAccessFields_menuGroups_links_link_label_Update';
  permission: Scalars['Boolean'];
};

export type FooterMenuDocAccessFields_MenuGroups_Links_Link_Reference = {
  __typename?: 'FooterMenuDocAccessFields_menuGroups_links_link_reference';
  create?: Maybe<FooterMenuDocAccessFields_MenuGroups_Links_Link_Reference_Create>;
  delete?: Maybe<FooterMenuDocAccessFields_MenuGroups_Links_Link_Reference_Delete>;
  read?: Maybe<FooterMenuDocAccessFields_MenuGroups_Links_Link_Reference_Read>;
  update?: Maybe<FooterMenuDocAccessFields_MenuGroups_Links_Link_Reference_Update>;
};

export type FooterMenuDocAccessFields_MenuGroups_Links_Link_Reference_Create = {
  __typename?: 'FooterMenuDocAccessFields_menuGroups_links_link_reference_Create';
  permission: Scalars['Boolean'];
};

export type FooterMenuDocAccessFields_MenuGroups_Links_Link_Reference_Delete = {
  __typename?: 'FooterMenuDocAccessFields_menuGroups_links_link_reference_Delete';
  permission: Scalars['Boolean'];
};

export type FooterMenuDocAccessFields_MenuGroups_Links_Link_Reference_Read = {
  __typename?: 'FooterMenuDocAccessFields_menuGroups_links_link_reference_Read';
  permission: Scalars['Boolean'];
};

export type FooterMenuDocAccessFields_MenuGroups_Links_Link_Reference_Update = {
  __typename?: 'FooterMenuDocAccessFields_menuGroups_links_link_reference_Update';
  permission: Scalars['Boolean'];
};

export type FooterMenuDocAccessFields_MenuGroups_Links_Link_Type = {
  __typename?: 'FooterMenuDocAccessFields_menuGroups_links_link_type';
  create?: Maybe<FooterMenuDocAccessFields_MenuGroups_Links_Link_Type_Create>;
  delete?: Maybe<FooterMenuDocAccessFields_MenuGroups_Links_Link_Type_Delete>;
  read?: Maybe<FooterMenuDocAccessFields_MenuGroups_Links_Link_Type_Read>;
  update?: Maybe<FooterMenuDocAccessFields_MenuGroups_Links_Link_Type_Update>;
};

export type FooterMenuDocAccessFields_MenuGroups_Links_Link_Type_Create = {
  __typename?: 'FooterMenuDocAccessFields_menuGroups_links_link_type_Create';
  permission: Scalars['Boolean'];
};

export type FooterMenuDocAccessFields_MenuGroups_Links_Link_Type_Delete = {
  __typename?: 'FooterMenuDocAccessFields_menuGroups_links_link_type_Delete';
  permission: Scalars['Boolean'];
};

export type FooterMenuDocAccessFields_MenuGroups_Links_Link_Type_Read = {
  __typename?: 'FooterMenuDocAccessFields_menuGroups_links_link_type_Read';
  permission: Scalars['Boolean'];
};

export type FooterMenuDocAccessFields_MenuGroups_Links_Link_Type_Update = {
  __typename?: 'FooterMenuDocAccessFields_menuGroups_links_link_type_Update';
  permission: Scalars['Boolean'];
};

export type FooterMenuDocAccessFields_MenuGroups_Links_Link_Url = {
  __typename?: 'FooterMenuDocAccessFields_menuGroups_links_link_url';
  create?: Maybe<FooterMenuDocAccessFields_MenuGroups_Links_Link_Url_Create>;
  delete?: Maybe<FooterMenuDocAccessFields_MenuGroups_Links_Link_Url_Delete>;
  read?: Maybe<FooterMenuDocAccessFields_MenuGroups_Links_Link_Url_Read>;
  update?: Maybe<FooterMenuDocAccessFields_MenuGroups_Links_Link_Url_Update>;
};

export type FooterMenuDocAccessFields_MenuGroups_Links_Link_Url_Create = {
  __typename?: 'FooterMenuDocAccessFields_menuGroups_links_link_url_Create';
  permission: Scalars['Boolean'];
};

export type FooterMenuDocAccessFields_MenuGroups_Links_Link_Url_Delete = {
  __typename?: 'FooterMenuDocAccessFields_menuGroups_links_link_url_Delete';
  permission: Scalars['Boolean'];
};

export type FooterMenuDocAccessFields_MenuGroups_Links_Link_Url_Read = {
  __typename?: 'FooterMenuDocAccessFields_menuGroups_links_link_url_Read';
  permission: Scalars['Boolean'];
};

export type FooterMenuDocAccessFields_MenuGroups_Links_Link_Url_Update = {
  __typename?: 'FooterMenuDocAccessFields_menuGroups_links_link_url_Update';
  permission: Scalars['Boolean'];
};

export type FooterMenuDocAccessFields_MenuGroups_Title = {
  __typename?: 'FooterMenuDocAccessFields_menuGroups_title';
  create?: Maybe<FooterMenuDocAccessFields_MenuGroups_Title_Create>;
  delete?: Maybe<FooterMenuDocAccessFields_MenuGroups_Title_Delete>;
  read?: Maybe<FooterMenuDocAccessFields_MenuGroups_Title_Read>;
  update?: Maybe<FooterMenuDocAccessFields_MenuGroups_Title_Update>;
};

export type FooterMenuDocAccessFields_MenuGroups_Title_Create = {
  __typename?: 'FooterMenuDocAccessFields_menuGroups_title_Create';
  permission: Scalars['Boolean'];
};

export type FooterMenuDocAccessFields_MenuGroups_Title_Delete = {
  __typename?: 'FooterMenuDocAccessFields_menuGroups_title_Delete';
  permission: Scalars['Boolean'];
};

export type FooterMenuDocAccessFields_MenuGroups_Title_Read = {
  __typename?: 'FooterMenuDocAccessFields_menuGroups_title_Read';
  permission: Scalars['Boolean'];
};

export type FooterMenuDocAccessFields_MenuGroups_Title_Update = {
  __typename?: 'FooterMenuDocAccessFields_menuGroups_title_Update';
  permission: Scalars['Boolean'];
};

export type FooterMenuDocAccessFields_UpdatedAt = {
  __typename?: 'FooterMenuDocAccessFields_updatedAt';
  create?: Maybe<FooterMenuDocAccessFields_UpdatedAt_Create>;
  delete?: Maybe<FooterMenuDocAccessFields_UpdatedAt_Delete>;
  read?: Maybe<FooterMenuDocAccessFields_UpdatedAt_Read>;
  update?: Maybe<FooterMenuDocAccessFields_UpdatedAt_Update>;
};

export type FooterMenuDocAccessFields_UpdatedAt_Create = {
  __typename?: 'FooterMenuDocAccessFields_updatedAt_Create';
  permission: Scalars['Boolean'];
};

export type FooterMenuDocAccessFields_UpdatedAt_Delete = {
  __typename?: 'FooterMenuDocAccessFields_updatedAt_Delete';
  permission: Scalars['Boolean'];
};

export type FooterMenuDocAccessFields_UpdatedAt_Read = {
  __typename?: 'FooterMenuDocAccessFields_updatedAt_Read';
  permission: Scalars['Boolean'];
};

export type FooterMenuDocAccessFields_UpdatedAt_Update = {
  __typename?: 'FooterMenuDocAccessFields_updatedAt_Update';
  permission: Scalars['Boolean'];
};

export type FooterMenuFields = {
  __typename?: 'FooterMenuFields';
  createdAt?: Maybe<FooterMenuFields_CreatedAt>;
  menuGroups?: Maybe<FooterMenuFields_MenuGroups>;
  updatedAt?: Maybe<FooterMenuFields_UpdatedAt>;
};

export type FooterMenuFields_CreatedAt = {
  __typename?: 'FooterMenuFields_createdAt';
  create?: Maybe<FooterMenuFields_CreatedAt_Create>;
  delete?: Maybe<FooterMenuFields_CreatedAt_Delete>;
  read?: Maybe<FooterMenuFields_CreatedAt_Read>;
  update?: Maybe<FooterMenuFields_CreatedAt_Update>;
};

export type FooterMenuFields_CreatedAt_Create = {
  __typename?: 'FooterMenuFields_createdAt_Create';
  permission: Scalars['Boolean'];
};

export type FooterMenuFields_CreatedAt_Delete = {
  __typename?: 'FooterMenuFields_createdAt_Delete';
  permission: Scalars['Boolean'];
};

export type FooterMenuFields_CreatedAt_Read = {
  __typename?: 'FooterMenuFields_createdAt_Read';
  permission: Scalars['Boolean'];
};

export type FooterMenuFields_CreatedAt_Update = {
  __typename?: 'FooterMenuFields_createdAt_Update';
  permission: Scalars['Boolean'];
};

export type FooterMenuFields_MenuGroups = {
  __typename?: 'FooterMenuFields_menuGroups';
  create?: Maybe<FooterMenuFields_MenuGroups_Create>;
  delete?: Maybe<FooterMenuFields_MenuGroups_Delete>;
  fields?: Maybe<FooterMenuFields_MenuGroups_Fields>;
  read?: Maybe<FooterMenuFields_MenuGroups_Read>;
  update?: Maybe<FooterMenuFields_MenuGroups_Update>;
};

export type FooterMenuFields_MenuGroups_Create = {
  __typename?: 'FooterMenuFields_menuGroups_Create';
  permission: Scalars['Boolean'];
};

export type FooterMenuFields_MenuGroups_Delete = {
  __typename?: 'FooterMenuFields_menuGroups_Delete';
  permission: Scalars['Boolean'];
};

export type FooterMenuFields_MenuGroups_Fields = {
  __typename?: 'FooterMenuFields_menuGroups_Fields';
  id?: Maybe<FooterMenuFields_MenuGroups_Id>;
  links?: Maybe<FooterMenuFields_MenuGroups_Links>;
  title?: Maybe<FooterMenuFields_MenuGroups_Title>;
};

export type FooterMenuFields_MenuGroups_Read = {
  __typename?: 'FooterMenuFields_menuGroups_Read';
  permission: Scalars['Boolean'];
};

export type FooterMenuFields_MenuGroups_Update = {
  __typename?: 'FooterMenuFields_menuGroups_Update';
  permission: Scalars['Boolean'];
};

export type FooterMenuFields_MenuGroups_Id = {
  __typename?: 'FooterMenuFields_menuGroups_id';
  create?: Maybe<FooterMenuFields_MenuGroups_Id_Create>;
  delete?: Maybe<FooterMenuFields_MenuGroups_Id_Delete>;
  read?: Maybe<FooterMenuFields_MenuGroups_Id_Read>;
  update?: Maybe<FooterMenuFields_MenuGroups_Id_Update>;
};

export type FooterMenuFields_MenuGroups_Id_Create = {
  __typename?: 'FooterMenuFields_menuGroups_id_Create';
  permission: Scalars['Boolean'];
};

export type FooterMenuFields_MenuGroups_Id_Delete = {
  __typename?: 'FooterMenuFields_menuGroups_id_Delete';
  permission: Scalars['Boolean'];
};

export type FooterMenuFields_MenuGroups_Id_Read = {
  __typename?: 'FooterMenuFields_menuGroups_id_Read';
  permission: Scalars['Boolean'];
};

export type FooterMenuFields_MenuGroups_Id_Update = {
  __typename?: 'FooterMenuFields_menuGroups_id_Update';
  permission: Scalars['Boolean'];
};

export type FooterMenuFields_MenuGroups_Links = {
  __typename?: 'FooterMenuFields_menuGroups_links';
  create?: Maybe<FooterMenuFields_MenuGroups_Links_Create>;
  delete?: Maybe<FooterMenuFields_MenuGroups_Links_Delete>;
  fields?: Maybe<FooterMenuFields_MenuGroups_Links_Fields>;
  read?: Maybe<FooterMenuFields_MenuGroups_Links_Read>;
  update?: Maybe<FooterMenuFields_MenuGroups_Links_Update>;
};

export type FooterMenuFields_MenuGroups_Links_Create = {
  __typename?: 'FooterMenuFields_menuGroups_links_Create';
  permission: Scalars['Boolean'];
};

export type FooterMenuFields_MenuGroups_Links_Delete = {
  __typename?: 'FooterMenuFields_menuGroups_links_Delete';
  permission: Scalars['Boolean'];
};

export type FooterMenuFields_MenuGroups_Links_Fields = {
  __typename?: 'FooterMenuFields_menuGroups_links_Fields';
  id?: Maybe<FooterMenuFields_MenuGroups_Links_Id>;
  link?: Maybe<FooterMenuFields_MenuGroups_Links_Link>;
};

export type FooterMenuFields_MenuGroups_Links_Read = {
  __typename?: 'FooterMenuFields_menuGroups_links_Read';
  permission: Scalars['Boolean'];
};

export type FooterMenuFields_MenuGroups_Links_Update = {
  __typename?: 'FooterMenuFields_menuGroups_links_Update';
  permission: Scalars['Boolean'];
};

export type FooterMenuFields_MenuGroups_Links_Id = {
  __typename?: 'FooterMenuFields_menuGroups_links_id';
  create?: Maybe<FooterMenuFields_MenuGroups_Links_Id_Create>;
  delete?: Maybe<FooterMenuFields_MenuGroups_Links_Id_Delete>;
  read?: Maybe<FooterMenuFields_MenuGroups_Links_Id_Read>;
  update?: Maybe<FooterMenuFields_MenuGroups_Links_Id_Update>;
};

export type FooterMenuFields_MenuGroups_Links_Id_Create = {
  __typename?: 'FooterMenuFields_menuGroups_links_id_Create';
  permission: Scalars['Boolean'];
};

export type FooterMenuFields_MenuGroups_Links_Id_Delete = {
  __typename?: 'FooterMenuFields_menuGroups_links_id_Delete';
  permission: Scalars['Boolean'];
};

export type FooterMenuFields_MenuGroups_Links_Id_Read = {
  __typename?: 'FooterMenuFields_menuGroups_links_id_Read';
  permission: Scalars['Boolean'];
};

export type FooterMenuFields_MenuGroups_Links_Id_Update = {
  __typename?: 'FooterMenuFields_menuGroups_links_id_Update';
  permission: Scalars['Boolean'];
};

export type FooterMenuFields_MenuGroups_Links_Link = {
  __typename?: 'FooterMenuFields_menuGroups_links_link';
  create?: Maybe<FooterMenuFields_MenuGroups_Links_Link_Create>;
  delete?: Maybe<FooterMenuFields_MenuGroups_Links_Link_Delete>;
  fields?: Maybe<FooterMenuFields_MenuGroups_Links_Link_Fields>;
  read?: Maybe<FooterMenuFields_MenuGroups_Links_Link_Read>;
  update?: Maybe<FooterMenuFields_MenuGroups_Links_Link_Update>;
};

export type FooterMenuFields_MenuGroups_Links_Link_Create = {
  __typename?: 'FooterMenuFields_menuGroups_links_link_Create';
  permission: Scalars['Boolean'];
};

export type FooterMenuFields_MenuGroups_Links_Link_Delete = {
  __typename?: 'FooterMenuFields_menuGroups_links_link_Delete';
  permission: Scalars['Boolean'];
};

export type FooterMenuFields_MenuGroups_Links_Link_Fields = {
  __typename?: 'FooterMenuFields_menuGroups_links_link_Fields';
  label?: Maybe<FooterMenuFields_MenuGroups_Links_Link_Label>;
  reference?: Maybe<FooterMenuFields_MenuGroups_Links_Link_Reference>;
  type?: Maybe<FooterMenuFields_MenuGroups_Links_Link_Type>;
  url?: Maybe<FooterMenuFields_MenuGroups_Links_Link_Url>;
};

export type FooterMenuFields_MenuGroups_Links_Link_Read = {
  __typename?: 'FooterMenuFields_menuGroups_links_link_Read';
  permission: Scalars['Boolean'];
};

export type FooterMenuFields_MenuGroups_Links_Link_Update = {
  __typename?: 'FooterMenuFields_menuGroups_links_link_Update';
  permission: Scalars['Boolean'];
};

export type FooterMenuFields_MenuGroups_Links_Link_Label = {
  __typename?: 'FooterMenuFields_menuGroups_links_link_label';
  create?: Maybe<FooterMenuFields_MenuGroups_Links_Link_Label_Create>;
  delete?: Maybe<FooterMenuFields_MenuGroups_Links_Link_Label_Delete>;
  read?: Maybe<FooterMenuFields_MenuGroups_Links_Link_Label_Read>;
  update?: Maybe<FooterMenuFields_MenuGroups_Links_Link_Label_Update>;
};

export type FooterMenuFields_MenuGroups_Links_Link_Label_Create = {
  __typename?: 'FooterMenuFields_menuGroups_links_link_label_Create';
  permission: Scalars['Boolean'];
};

export type FooterMenuFields_MenuGroups_Links_Link_Label_Delete = {
  __typename?: 'FooterMenuFields_menuGroups_links_link_label_Delete';
  permission: Scalars['Boolean'];
};

export type FooterMenuFields_MenuGroups_Links_Link_Label_Read = {
  __typename?: 'FooterMenuFields_menuGroups_links_link_label_Read';
  permission: Scalars['Boolean'];
};

export type FooterMenuFields_MenuGroups_Links_Link_Label_Update = {
  __typename?: 'FooterMenuFields_menuGroups_links_link_label_Update';
  permission: Scalars['Boolean'];
};

export type FooterMenuFields_MenuGroups_Links_Link_Reference = {
  __typename?: 'FooterMenuFields_menuGroups_links_link_reference';
  create?: Maybe<FooterMenuFields_MenuGroups_Links_Link_Reference_Create>;
  delete?: Maybe<FooterMenuFields_MenuGroups_Links_Link_Reference_Delete>;
  read?: Maybe<FooterMenuFields_MenuGroups_Links_Link_Reference_Read>;
  update?: Maybe<FooterMenuFields_MenuGroups_Links_Link_Reference_Update>;
};

export type FooterMenuFields_MenuGroups_Links_Link_Reference_Create = {
  __typename?: 'FooterMenuFields_menuGroups_links_link_reference_Create';
  permission: Scalars['Boolean'];
};

export type FooterMenuFields_MenuGroups_Links_Link_Reference_Delete = {
  __typename?: 'FooterMenuFields_menuGroups_links_link_reference_Delete';
  permission: Scalars['Boolean'];
};

export type FooterMenuFields_MenuGroups_Links_Link_Reference_Read = {
  __typename?: 'FooterMenuFields_menuGroups_links_link_reference_Read';
  permission: Scalars['Boolean'];
};

export type FooterMenuFields_MenuGroups_Links_Link_Reference_Update = {
  __typename?: 'FooterMenuFields_menuGroups_links_link_reference_Update';
  permission: Scalars['Boolean'];
};

export type FooterMenuFields_MenuGroups_Links_Link_Type = {
  __typename?: 'FooterMenuFields_menuGroups_links_link_type';
  create?: Maybe<FooterMenuFields_MenuGroups_Links_Link_Type_Create>;
  delete?: Maybe<FooterMenuFields_MenuGroups_Links_Link_Type_Delete>;
  read?: Maybe<FooterMenuFields_MenuGroups_Links_Link_Type_Read>;
  update?: Maybe<FooterMenuFields_MenuGroups_Links_Link_Type_Update>;
};

export type FooterMenuFields_MenuGroups_Links_Link_Type_Create = {
  __typename?: 'FooterMenuFields_menuGroups_links_link_type_Create';
  permission: Scalars['Boolean'];
};

export type FooterMenuFields_MenuGroups_Links_Link_Type_Delete = {
  __typename?: 'FooterMenuFields_menuGroups_links_link_type_Delete';
  permission: Scalars['Boolean'];
};

export type FooterMenuFields_MenuGroups_Links_Link_Type_Read = {
  __typename?: 'FooterMenuFields_menuGroups_links_link_type_Read';
  permission: Scalars['Boolean'];
};

export type FooterMenuFields_MenuGroups_Links_Link_Type_Update = {
  __typename?: 'FooterMenuFields_menuGroups_links_link_type_Update';
  permission: Scalars['Boolean'];
};

export type FooterMenuFields_MenuGroups_Links_Link_Url = {
  __typename?: 'FooterMenuFields_menuGroups_links_link_url';
  create?: Maybe<FooterMenuFields_MenuGroups_Links_Link_Url_Create>;
  delete?: Maybe<FooterMenuFields_MenuGroups_Links_Link_Url_Delete>;
  read?: Maybe<FooterMenuFields_MenuGroups_Links_Link_Url_Read>;
  update?: Maybe<FooterMenuFields_MenuGroups_Links_Link_Url_Update>;
};

export type FooterMenuFields_MenuGroups_Links_Link_Url_Create = {
  __typename?: 'FooterMenuFields_menuGroups_links_link_url_Create';
  permission: Scalars['Boolean'];
};

export type FooterMenuFields_MenuGroups_Links_Link_Url_Delete = {
  __typename?: 'FooterMenuFields_menuGroups_links_link_url_Delete';
  permission: Scalars['Boolean'];
};

export type FooterMenuFields_MenuGroups_Links_Link_Url_Read = {
  __typename?: 'FooterMenuFields_menuGroups_links_link_url_Read';
  permission: Scalars['Boolean'];
};

export type FooterMenuFields_MenuGroups_Links_Link_Url_Update = {
  __typename?: 'FooterMenuFields_menuGroups_links_link_url_Update';
  permission: Scalars['Boolean'];
};

export type FooterMenuFields_MenuGroups_Title = {
  __typename?: 'FooterMenuFields_menuGroups_title';
  create?: Maybe<FooterMenuFields_MenuGroups_Title_Create>;
  delete?: Maybe<FooterMenuFields_MenuGroups_Title_Delete>;
  read?: Maybe<FooterMenuFields_MenuGroups_Title_Read>;
  update?: Maybe<FooterMenuFields_MenuGroups_Title_Update>;
};

export type FooterMenuFields_MenuGroups_Title_Create = {
  __typename?: 'FooterMenuFields_menuGroups_title_Create';
  permission: Scalars['Boolean'];
};

export type FooterMenuFields_MenuGroups_Title_Delete = {
  __typename?: 'FooterMenuFields_menuGroups_title_Delete';
  permission: Scalars['Boolean'];
};

export type FooterMenuFields_MenuGroups_Title_Read = {
  __typename?: 'FooterMenuFields_menuGroups_title_Read';
  permission: Scalars['Boolean'];
};

export type FooterMenuFields_MenuGroups_Title_Update = {
  __typename?: 'FooterMenuFields_menuGroups_title_Update';
  permission: Scalars['Boolean'];
};

export type FooterMenuFields_UpdatedAt = {
  __typename?: 'FooterMenuFields_updatedAt';
  create?: Maybe<FooterMenuFields_UpdatedAt_Create>;
  delete?: Maybe<FooterMenuFields_UpdatedAt_Delete>;
  read?: Maybe<FooterMenuFields_UpdatedAt_Read>;
  update?: Maybe<FooterMenuFields_UpdatedAt_Update>;
};

export type FooterMenuFields_UpdatedAt_Create = {
  __typename?: 'FooterMenuFields_updatedAt_Create';
  permission: Scalars['Boolean'];
};

export type FooterMenuFields_UpdatedAt_Delete = {
  __typename?: 'FooterMenuFields_updatedAt_Delete';
  permission: Scalars['Boolean'];
};

export type FooterMenuFields_UpdatedAt_Read = {
  __typename?: 'FooterMenuFields_updatedAt_Read';
  permission: Scalars['Boolean'];
};

export type FooterMenuFields_UpdatedAt_Update = {
  __typename?: 'FooterMenuFields_updatedAt_Update';
  permission: Scalars['Boolean'];
};

export type FooterMenuReadAccess = {
  __typename?: 'FooterMenuReadAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type FooterMenuReadDocAccess = {
  __typename?: 'FooterMenuReadDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type FooterMenuUpdateAccess = {
  __typename?: 'FooterMenuUpdateAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type FooterMenuUpdateDocAccess = {
  __typename?: 'FooterMenuUpdateDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type FooterMenu_MenuGroups = {
  __typename?: 'FooterMenu_MenuGroups';
  id?: Maybe<Scalars['String']>;
  links?: Maybe<Array<FooterMenu_MenuGroups_Links>>;
  title?: Maybe<Scalars['String']>;
};

export type FooterMenu_MenuGroups_Links = {
  __typename?: 'FooterMenu_MenuGroups_Links';
  id?: Maybe<Scalars['String']>;
  link?: Maybe<Link>;
};

export type FooterMenu_MenuGroups_Links_Link_ReferenceRelationshipInput = {
  relationTo?: InputMaybe<FooterMenu_MenuGroups_Links_Link_ReferenceRelationshipInputRelationTo>;
  value?: InputMaybe<Scalars['JSON']>;
};

export enum FooterMenu_MenuGroups_Links_Link_ReferenceRelationshipInputRelationTo {
  Article = 'article',
  LeadForm = 'lead_form',
  Page = 'page',
  Service = 'service'
}

export type Form = {
  __typename?: 'Form';
  confirmationMessage?: Maybe<Scalars['JSON']>;
  confirmationType?: Maybe<Form_ConfirmationType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  emails?: Maybe<Array<Form_Emails>>;
  fields?: Maybe<Array<Form_Fields>>;
  id: Scalars['String'];
  redirect?: Maybe<Form_Redirect>;
  submitButtonLabel?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type FormConfirmationMessageArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};

export type FormBlock = {
  __typename?: 'FormBlock';
  blockName?: Maybe<Scalars['String']>;
  blockSettings?: Maybe<BlockSettings>;
  blockType?: Maybe<Scalars['String']>;
  form?: Maybe<Form>;
  id?: Maybe<Scalars['String']>;
};

export type FormSubmission = {
  __typename?: 'FormSubmission';
  createdAt?: Maybe<Scalars['DateTime']>;
  form: Form;
  id: Scalars['String'];
  submissionData?: Maybe<Array<FormSubmission_SubmissionData>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type FormSubmission_SubmissionData = {
  __typename?: 'FormSubmission_SubmissionData';
  field?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type FormSubmission_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type FormSubmission_Form_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  equals?: InputMaybe<Scalars['JSON']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  not_equals?: InputMaybe<Scalars['JSON']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type FormSubmission_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type FormSubmission_SubmissionData__Field_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type FormSubmission_SubmissionData__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type FormSubmission_SubmissionData__Value_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type FormSubmission_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type FormSubmission_Where = {
  AND?: InputMaybe<Array<InputMaybe<FormSubmission_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<FormSubmission_Where_Or>>>;
  createdAt?: InputMaybe<FormSubmission_CreatedAt_Operator>;
  form?: InputMaybe<FormSubmission_Form_Operator>;
  id?: InputMaybe<FormSubmission_Id_Operator>;
  submissionData__field?: InputMaybe<FormSubmission_SubmissionData__Field_Operator>;
  submissionData__id?: InputMaybe<FormSubmission_SubmissionData__Id_Operator>;
  submissionData__value?: InputMaybe<FormSubmission_SubmissionData__Value_Operator>;
  updatedAt?: InputMaybe<FormSubmission_UpdatedAt_Operator>;
};

export type FormSubmission_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<FormSubmission_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<FormSubmission_Where_Or>>>;
  createdAt?: InputMaybe<FormSubmission_CreatedAt_Operator>;
  form?: InputMaybe<FormSubmission_Form_Operator>;
  id?: InputMaybe<FormSubmission_Id_Operator>;
  submissionData__field?: InputMaybe<FormSubmission_SubmissionData__Field_Operator>;
  submissionData__id?: InputMaybe<FormSubmission_SubmissionData__Id_Operator>;
  submissionData__value?: InputMaybe<FormSubmission_SubmissionData__Value_Operator>;
  updatedAt?: InputMaybe<FormSubmission_UpdatedAt_Operator>;
};

export type FormSubmission_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<FormSubmission_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<FormSubmission_Where_Or>>>;
  createdAt?: InputMaybe<FormSubmission_CreatedAt_Operator>;
  form?: InputMaybe<FormSubmission_Form_Operator>;
  id?: InputMaybe<FormSubmission_Id_Operator>;
  submissionData__field?: InputMaybe<FormSubmission_SubmissionData__Field_Operator>;
  submissionData__id?: InputMaybe<FormSubmission_SubmissionData__Id_Operator>;
  submissionData__value?: InputMaybe<FormSubmission_SubmissionData__Value_Operator>;
  updatedAt?: InputMaybe<FormSubmission_UpdatedAt_Operator>;
};

export type FormSubmissions = {
  __typename?: 'FormSubmissions';
  docs?: Maybe<Array<Maybe<FormSubmission>>>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPrevPage?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  nextPage?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  pagingCounter?: Maybe<Scalars['Int']>;
  prevPage?: Maybe<Scalars['Int']>;
  totalDocs?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
};

export type FormSubmissionsCreateAccess = {
  __typename?: 'FormSubmissionsCreateAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type FormSubmissionsCreateDocAccess = {
  __typename?: 'FormSubmissionsCreateDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type FormSubmissionsDeleteAccess = {
  __typename?: 'FormSubmissionsDeleteAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type FormSubmissionsDeleteDocAccess = {
  __typename?: 'FormSubmissionsDeleteDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type FormSubmissionsDocAccessFields = {
  __typename?: 'FormSubmissionsDocAccessFields';
  createdAt?: Maybe<FormSubmissionsDocAccessFields_CreatedAt>;
  form?: Maybe<FormSubmissionsDocAccessFields_Form>;
  submissionData?: Maybe<FormSubmissionsDocAccessFields_SubmissionData>;
  updatedAt?: Maybe<FormSubmissionsDocAccessFields_UpdatedAt>;
};

export type FormSubmissionsDocAccessFields_CreatedAt = {
  __typename?: 'FormSubmissionsDocAccessFields_createdAt';
  create?: Maybe<FormSubmissionsDocAccessFields_CreatedAt_Create>;
  delete?: Maybe<FormSubmissionsDocAccessFields_CreatedAt_Delete>;
  read?: Maybe<FormSubmissionsDocAccessFields_CreatedAt_Read>;
  update?: Maybe<FormSubmissionsDocAccessFields_CreatedAt_Update>;
};

export type FormSubmissionsDocAccessFields_CreatedAt_Create = {
  __typename?: 'FormSubmissionsDocAccessFields_createdAt_Create';
  permission: Scalars['Boolean'];
};

export type FormSubmissionsDocAccessFields_CreatedAt_Delete = {
  __typename?: 'FormSubmissionsDocAccessFields_createdAt_Delete';
  permission: Scalars['Boolean'];
};

export type FormSubmissionsDocAccessFields_CreatedAt_Read = {
  __typename?: 'FormSubmissionsDocAccessFields_createdAt_Read';
  permission: Scalars['Boolean'];
};

export type FormSubmissionsDocAccessFields_CreatedAt_Update = {
  __typename?: 'FormSubmissionsDocAccessFields_createdAt_Update';
  permission: Scalars['Boolean'];
};

export type FormSubmissionsDocAccessFields_Form = {
  __typename?: 'FormSubmissionsDocAccessFields_form';
  create?: Maybe<FormSubmissionsDocAccessFields_Form_Create>;
  delete?: Maybe<FormSubmissionsDocAccessFields_Form_Delete>;
  read?: Maybe<FormSubmissionsDocAccessFields_Form_Read>;
  update?: Maybe<FormSubmissionsDocAccessFields_Form_Update>;
};

export type FormSubmissionsDocAccessFields_Form_Create = {
  __typename?: 'FormSubmissionsDocAccessFields_form_Create';
  permission: Scalars['Boolean'];
};

export type FormSubmissionsDocAccessFields_Form_Delete = {
  __typename?: 'FormSubmissionsDocAccessFields_form_Delete';
  permission: Scalars['Boolean'];
};

export type FormSubmissionsDocAccessFields_Form_Read = {
  __typename?: 'FormSubmissionsDocAccessFields_form_Read';
  permission: Scalars['Boolean'];
};

export type FormSubmissionsDocAccessFields_Form_Update = {
  __typename?: 'FormSubmissionsDocAccessFields_form_Update';
  permission: Scalars['Boolean'];
};

export type FormSubmissionsDocAccessFields_SubmissionData = {
  __typename?: 'FormSubmissionsDocAccessFields_submissionData';
  create?: Maybe<FormSubmissionsDocAccessFields_SubmissionData_Create>;
  delete?: Maybe<FormSubmissionsDocAccessFields_SubmissionData_Delete>;
  fields?: Maybe<FormSubmissionsDocAccessFields_SubmissionData_Fields>;
  read?: Maybe<FormSubmissionsDocAccessFields_SubmissionData_Read>;
  update?: Maybe<FormSubmissionsDocAccessFields_SubmissionData_Update>;
};

export type FormSubmissionsDocAccessFields_SubmissionData_Create = {
  __typename?: 'FormSubmissionsDocAccessFields_submissionData_Create';
  permission: Scalars['Boolean'];
};

export type FormSubmissionsDocAccessFields_SubmissionData_Delete = {
  __typename?: 'FormSubmissionsDocAccessFields_submissionData_Delete';
  permission: Scalars['Boolean'];
};

export type FormSubmissionsDocAccessFields_SubmissionData_Fields = {
  __typename?: 'FormSubmissionsDocAccessFields_submissionData_Fields';
  field?: Maybe<FormSubmissionsDocAccessFields_SubmissionData_Field>;
  id?: Maybe<FormSubmissionsDocAccessFields_SubmissionData_Id>;
  value?: Maybe<FormSubmissionsDocAccessFields_SubmissionData_Value>;
};

export type FormSubmissionsDocAccessFields_SubmissionData_Read = {
  __typename?: 'FormSubmissionsDocAccessFields_submissionData_Read';
  permission: Scalars['Boolean'];
};

export type FormSubmissionsDocAccessFields_SubmissionData_Update = {
  __typename?: 'FormSubmissionsDocAccessFields_submissionData_Update';
  permission: Scalars['Boolean'];
};

export type FormSubmissionsDocAccessFields_SubmissionData_Field = {
  __typename?: 'FormSubmissionsDocAccessFields_submissionData_field';
  create?: Maybe<FormSubmissionsDocAccessFields_SubmissionData_Field_Create>;
  delete?: Maybe<FormSubmissionsDocAccessFields_SubmissionData_Field_Delete>;
  read?: Maybe<FormSubmissionsDocAccessFields_SubmissionData_Field_Read>;
  update?: Maybe<FormSubmissionsDocAccessFields_SubmissionData_Field_Update>;
};

export type FormSubmissionsDocAccessFields_SubmissionData_Field_Create = {
  __typename?: 'FormSubmissionsDocAccessFields_submissionData_field_Create';
  permission: Scalars['Boolean'];
};

export type FormSubmissionsDocAccessFields_SubmissionData_Field_Delete = {
  __typename?: 'FormSubmissionsDocAccessFields_submissionData_field_Delete';
  permission: Scalars['Boolean'];
};

export type FormSubmissionsDocAccessFields_SubmissionData_Field_Read = {
  __typename?: 'FormSubmissionsDocAccessFields_submissionData_field_Read';
  permission: Scalars['Boolean'];
};

export type FormSubmissionsDocAccessFields_SubmissionData_Field_Update = {
  __typename?: 'FormSubmissionsDocAccessFields_submissionData_field_Update';
  permission: Scalars['Boolean'];
};

export type FormSubmissionsDocAccessFields_SubmissionData_Id = {
  __typename?: 'FormSubmissionsDocAccessFields_submissionData_id';
  create?: Maybe<FormSubmissionsDocAccessFields_SubmissionData_Id_Create>;
  delete?: Maybe<FormSubmissionsDocAccessFields_SubmissionData_Id_Delete>;
  read?: Maybe<FormSubmissionsDocAccessFields_SubmissionData_Id_Read>;
  update?: Maybe<FormSubmissionsDocAccessFields_SubmissionData_Id_Update>;
};

export type FormSubmissionsDocAccessFields_SubmissionData_Id_Create = {
  __typename?: 'FormSubmissionsDocAccessFields_submissionData_id_Create';
  permission: Scalars['Boolean'];
};

export type FormSubmissionsDocAccessFields_SubmissionData_Id_Delete = {
  __typename?: 'FormSubmissionsDocAccessFields_submissionData_id_Delete';
  permission: Scalars['Boolean'];
};

export type FormSubmissionsDocAccessFields_SubmissionData_Id_Read = {
  __typename?: 'FormSubmissionsDocAccessFields_submissionData_id_Read';
  permission: Scalars['Boolean'];
};

export type FormSubmissionsDocAccessFields_SubmissionData_Id_Update = {
  __typename?: 'FormSubmissionsDocAccessFields_submissionData_id_Update';
  permission: Scalars['Boolean'];
};

export type FormSubmissionsDocAccessFields_SubmissionData_Value = {
  __typename?: 'FormSubmissionsDocAccessFields_submissionData_value';
  create?: Maybe<FormSubmissionsDocAccessFields_SubmissionData_Value_Create>;
  delete?: Maybe<FormSubmissionsDocAccessFields_SubmissionData_Value_Delete>;
  read?: Maybe<FormSubmissionsDocAccessFields_SubmissionData_Value_Read>;
  update?: Maybe<FormSubmissionsDocAccessFields_SubmissionData_Value_Update>;
};

export type FormSubmissionsDocAccessFields_SubmissionData_Value_Create = {
  __typename?: 'FormSubmissionsDocAccessFields_submissionData_value_Create';
  permission: Scalars['Boolean'];
};

export type FormSubmissionsDocAccessFields_SubmissionData_Value_Delete = {
  __typename?: 'FormSubmissionsDocAccessFields_submissionData_value_Delete';
  permission: Scalars['Boolean'];
};

export type FormSubmissionsDocAccessFields_SubmissionData_Value_Read = {
  __typename?: 'FormSubmissionsDocAccessFields_submissionData_value_Read';
  permission: Scalars['Boolean'];
};

export type FormSubmissionsDocAccessFields_SubmissionData_Value_Update = {
  __typename?: 'FormSubmissionsDocAccessFields_submissionData_value_Update';
  permission: Scalars['Boolean'];
};

export type FormSubmissionsDocAccessFields_UpdatedAt = {
  __typename?: 'FormSubmissionsDocAccessFields_updatedAt';
  create?: Maybe<FormSubmissionsDocAccessFields_UpdatedAt_Create>;
  delete?: Maybe<FormSubmissionsDocAccessFields_UpdatedAt_Delete>;
  read?: Maybe<FormSubmissionsDocAccessFields_UpdatedAt_Read>;
  update?: Maybe<FormSubmissionsDocAccessFields_UpdatedAt_Update>;
};

export type FormSubmissionsDocAccessFields_UpdatedAt_Create = {
  __typename?: 'FormSubmissionsDocAccessFields_updatedAt_Create';
  permission: Scalars['Boolean'];
};

export type FormSubmissionsDocAccessFields_UpdatedAt_Delete = {
  __typename?: 'FormSubmissionsDocAccessFields_updatedAt_Delete';
  permission: Scalars['Boolean'];
};

export type FormSubmissionsDocAccessFields_UpdatedAt_Read = {
  __typename?: 'FormSubmissionsDocAccessFields_updatedAt_Read';
  permission: Scalars['Boolean'];
};

export type FormSubmissionsDocAccessFields_UpdatedAt_Update = {
  __typename?: 'FormSubmissionsDocAccessFields_updatedAt_Update';
  permission: Scalars['Boolean'];
};

export type FormSubmissionsFields = {
  __typename?: 'FormSubmissionsFields';
  createdAt?: Maybe<FormSubmissionsFields_CreatedAt>;
  form?: Maybe<FormSubmissionsFields_Form>;
  submissionData?: Maybe<FormSubmissionsFields_SubmissionData>;
  updatedAt?: Maybe<FormSubmissionsFields_UpdatedAt>;
};

export type FormSubmissionsFields_CreatedAt = {
  __typename?: 'FormSubmissionsFields_createdAt';
  create?: Maybe<FormSubmissionsFields_CreatedAt_Create>;
  delete?: Maybe<FormSubmissionsFields_CreatedAt_Delete>;
  read?: Maybe<FormSubmissionsFields_CreatedAt_Read>;
  update?: Maybe<FormSubmissionsFields_CreatedAt_Update>;
};

export type FormSubmissionsFields_CreatedAt_Create = {
  __typename?: 'FormSubmissionsFields_createdAt_Create';
  permission: Scalars['Boolean'];
};

export type FormSubmissionsFields_CreatedAt_Delete = {
  __typename?: 'FormSubmissionsFields_createdAt_Delete';
  permission: Scalars['Boolean'];
};

export type FormSubmissionsFields_CreatedAt_Read = {
  __typename?: 'FormSubmissionsFields_createdAt_Read';
  permission: Scalars['Boolean'];
};

export type FormSubmissionsFields_CreatedAt_Update = {
  __typename?: 'FormSubmissionsFields_createdAt_Update';
  permission: Scalars['Boolean'];
};

export type FormSubmissionsFields_Form = {
  __typename?: 'FormSubmissionsFields_form';
  create?: Maybe<FormSubmissionsFields_Form_Create>;
  delete?: Maybe<FormSubmissionsFields_Form_Delete>;
  read?: Maybe<FormSubmissionsFields_Form_Read>;
  update?: Maybe<FormSubmissionsFields_Form_Update>;
};

export type FormSubmissionsFields_Form_Create = {
  __typename?: 'FormSubmissionsFields_form_Create';
  permission: Scalars['Boolean'];
};

export type FormSubmissionsFields_Form_Delete = {
  __typename?: 'FormSubmissionsFields_form_Delete';
  permission: Scalars['Boolean'];
};

export type FormSubmissionsFields_Form_Read = {
  __typename?: 'FormSubmissionsFields_form_Read';
  permission: Scalars['Boolean'];
};

export type FormSubmissionsFields_Form_Update = {
  __typename?: 'FormSubmissionsFields_form_Update';
  permission: Scalars['Boolean'];
};

export type FormSubmissionsFields_SubmissionData = {
  __typename?: 'FormSubmissionsFields_submissionData';
  create?: Maybe<FormSubmissionsFields_SubmissionData_Create>;
  delete?: Maybe<FormSubmissionsFields_SubmissionData_Delete>;
  fields?: Maybe<FormSubmissionsFields_SubmissionData_Fields>;
  read?: Maybe<FormSubmissionsFields_SubmissionData_Read>;
  update?: Maybe<FormSubmissionsFields_SubmissionData_Update>;
};

export type FormSubmissionsFields_SubmissionData_Create = {
  __typename?: 'FormSubmissionsFields_submissionData_Create';
  permission: Scalars['Boolean'];
};

export type FormSubmissionsFields_SubmissionData_Delete = {
  __typename?: 'FormSubmissionsFields_submissionData_Delete';
  permission: Scalars['Boolean'];
};

export type FormSubmissionsFields_SubmissionData_Fields = {
  __typename?: 'FormSubmissionsFields_submissionData_Fields';
  field?: Maybe<FormSubmissionsFields_SubmissionData_Field>;
  id?: Maybe<FormSubmissionsFields_SubmissionData_Id>;
  value?: Maybe<FormSubmissionsFields_SubmissionData_Value>;
};

export type FormSubmissionsFields_SubmissionData_Read = {
  __typename?: 'FormSubmissionsFields_submissionData_Read';
  permission: Scalars['Boolean'];
};

export type FormSubmissionsFields_SubmissionData_Update = {
  __typename?: 'FormSubmissionsFields_submissionData_Update';
  permission: Scalars['Boolean'];
};

export type FormSubmissionsFields_SubmissionData_Field = {
  __typename?: 'FormSubmissionsFields_submissionData_field';
  create?: Maybe<FormSubmissionsFields_SubmissionData_Field_Create>;
  delete?: Maybe<FormSubmissionsFields_SubmissionData_Field_Delete>;
  read?: Maybe<FormSubmissionsFields_SubmissionData_Field_Read>;
  update?: Maybe<FormSubmissionsFields_SubmissionData_Field_Update>;
};

export type FormSubmissionsFields_SubmissionData_Field_Create = {
  __typename?: 'FormSubmissionsFields_submissionData_field_Create';
  permission: Scalars['Boolean'];
};

export type FormSubmissionsFields_SubmissionData_Field_Delete = {
  __typename?: 'FormSubmissionsFields_submissionData_field_Delete';
  permission: Scalars['Boolean'];
};

export type FormSubmissionsFields_SubmissionData_Field_Read = {
  __typename?: 'FormSubmissionsFields_submissionData_field_Read';
  permission: Scalars['Boolean'];
};

export type FormSubmissionsFields_SubmissionData_Field_Update = {
  __typename?: 'FormSubmissionsFields_submissionData_field_Update';
  permission: Scalars['Boolean'];
};

export type FormSubmissionsFields_SubmissionData_Id = {
  __typename?: 'FormSubmissionsFields_submissionData_id';
  create?: Maybe<FormSubmissionsFields_SubmissionData_Id_Create>;
  delete?: Maybe<FormSubmissionsFields_SubmissionData_Id_Delete>;
  read?: Maybe<FormSubmissionsFields_SubmissionData_Id_Read>;
  update?: Maybe<FormSubmissionsFields_SubmissionData_Id_Update>;
};

export type FormSubmissionsFields_SubmissionData_Id_Create = {
  __typename?: 'FormSubmissionsFields_submissionData_id_Create';
  permission: Scalars['Boolean'];
};

export type FormSubmissionsFields_SubmissionData_Id_Delete = {
  __typename?: 'FormSubmissionsFields_submissionData_id_Delete';
  permission: Scalars['Boolean'];
};

export type FormSubmissionsFields_SubmissionData_Id_Read = {
  __typename?: 'FormSubmissionsFields_submissionData_id_Read';
  permission: Scalars['Boolean'];
};

export type FormSubmissionsFields_SubmissionData_Id_Update = {
  __typename?: 'FormSubmissionsFields_submissionData_id_Update';
  permission: Scalars['Boolean'];
};

export type FormSubmissionsFields_SubmissionData_Value = {
  __typename?: 'FormSubmissionsFields_submissionData_value';
  create?: Maybe<FormSubmissionsFields_SubmissionData_Value_Create>;
  delete?: Maybe<FormSubmissionsFields_SubmissionData_Value_Delete>;
  read?: Maybe<FormSubmissionsFields_SubmissionData_Value_Read>;
  update?: Maybe<FormSubmissionsFields_SubmissionData_Value_Update>;
};

export type FormSubmissionsFields_SubmissionData_Value_Create = {
  __typename?: 'FormSubmissionsFields_submissionData_value_Create';
  permission: Scalars['Boolean'];
};

export type FormSubmissionsFields_SubmissionData_Value_Delete = {
  __typename?: 'FormSubmissionsFields_submissionData_value_Delete';
  permission: Scalars['Boolean'];
};

export type FormSubmissionsFields_SubmissionData_Value_Read = {
  __typename?: 'FormSubmissionsFields_submissionData_value_Read';
  permission: Scalars['Boolean'];
};

export type FormSubmissionsFields_SubmissionData_Value_Update = {
  __typename?: 'FormSubmissionsFields_submissionData_value_Update';
  permission: Scalars['Boolean'];
};

export type FormSubmissionsFields_UpdatedAt = {
  __typename?: 'FormSubmissionsFields_updatedAt';
  create?: Maybe<FormSubmissionsFields_UpdatedAt_Create>;
  delete?: Maybe<FormSubmissionsFields_UpdatedAt_Delete>;
  read?: Maybe<FormSubmissionsFields_UpdatedAt_Read>;
  update?: Maybe<FormSubmissionsFields_UpdatedAt_Update>;
};

export type FormSubmissionsFields_UpdatedAt_Create = {
  __typename?: 'FormSubmissionsFields_updatedAt_Create';
  permission: Scalars['Boolean'];
};

export type FormSubmissionsFields_UpdatedAt_Delete = {
  __typename?: 'FormSubmissionsFields_updatedAt_Delete';
  permission: Scalars['Boolean'];
};

export type FormSubmissionsFields_UpdatedAt_Read = {
  __typename?: 'FormSubmissionsFields_updatedAt_Read';
  permission: Scalars['Boolean'];
};

export type FormSubmissionsFields_UpdatedAt_Update = {
  __typename?: 'FormSubmissionsFields_updatedAt_Update';
  permission: Scalars['Boolean'];
};

export type FormSubmissionsReadAccess = {
  __typename?: 'FormSubmissionsReadAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type FormSubmissionsReadDocAccess = {
  __typename?: 'FormSubmissionsReadDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type FormSubmissionsUpdateAccess = {
  __typename?: 'FormSubmissionsUpdateAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type FormSubmissionsUpdateDocAccess = {
  __typename?: 'FormSubmissionsUpdateDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type Form_Emails = {
  __typename?: 'Form_Emails';
  bcc?: Maybe<Scalars['String']>;
  cc?: Maybe<Scalars['String']>;
  emailFrom?: Maybe<Scalars['String']>;
  emailTo?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['JSON']>;
  replyTo?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
};


export type Form_EmailsMessageArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};

export type Form_Fields = Checkbox | Email | Message | Number | Select | Text | Textarea | Toggle;

export type Form_Redirect = {
  __typename?: 'Form_Redirect';
  url?: Maybe<Scalars['String']>;
};

export type Form_ConfirmationMessage_Operator = {
  contains?: InputMaybe<Scalars['JSON']>;
  equals?: InputMaybe<Scalars['JSON']>;
  like?: InputMaybe<Scalars['JSON']>;
  not_equals?: InputMaybe<Scalars['JSON']>;
};

export enum Form_ConfirmationType {
  Message = 'message',
  Redirect = 'redirect'
}

export enum Form_ConfirmationType_Input {
  Message = 'message',
  Redirect = 'redirect'
}

export type Form_ConfirmationType_Operator = {
  contains?: InputMaybe<Form_ConfirmationType_Input>;
  equals?: InputMaybe<Form_ConfirmationType_Input>;
  exists?: InputMaybe<Scalars['Boolean']>;
  like?: InputMaybe<Form_ConfirmationType_Input>;
  not_equals?: InputMaybe<Form_ConfirmationType_Input>;
};

export type Form_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type Form_Emails__Bcc_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Form_Emails__Cc_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Form_Emails__EmailFrom_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Form_Emails__EmailTo_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Form_Emails__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Form_Emails__Message_Operator = {
  contains?: InputMaybe<Scalars['JSON']>;
  equals?: InputMaybe<Scalars['JSON']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  like?: InputMaybe<Scalars['JSON']>;
  not_equals?: InputMaybe<Scalars['JSON']>;
};

export type Form_Emails__ReplyTo_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Form_Emails__Subject_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Form_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Form_Redirect__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Form_SubmitButtonLabel_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Form_Title_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Form_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type Form_Where = {
  AND?: InputMaybe<Array<InputMaybe<Form_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Form_Where_Or>>>;
  confirmationMessage?: InputMaybe<Form_ConfirmationMessage_Operator>;
  confirmationType?: InputMaybe<Form_ConfirmationType_Operator>;
  createdAt?: InputMaybe<Form_CreatedAt_Operator>;
  emails__bcc?: InputMaybe<Form_Emails__Bcc_Operator>;
  emails__cc?: InputMaybe<Form_Emails__Cc_Operator>;
  emails__emailFrom?: InputMaybe<Form_Emails__EmailFrom_Operator>;
  emails__emailTo?: InputMaybe<Form_Emails__EmailTo_Operator>;
  emails__id?: InputMaybe<Form_Emails__Id_Operator>;
  emails__message?: InputMaybe<Form_Emails__Message_Operator>;
  emails__replyTo?: InputMaybe<Form_Emails__ReplyTo_Operator>;
  emails__subject?: InputMaybe<Form_Emails__Subject_Operator>;
  id?: InputMaybe<Form_Id_Operator>;
  redirect__url?: InputMaybe<Form_Redirect__Url_Operator>;
  submitButtonLabel?: InputMaybe<Form_SubmitButtonLabel_Operator>;
  title?: InputMaybe<Form_Title_Operator>;
  updatedAt?: InputMaybe<Form_UpdatedAt_Operator>;
};

export type Form_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<Form_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Form_Where_Or>>>;
  confirmationMessage?: InputMaybe<Form_ConfirmationMessage_Operator>;
  confirmationType?: InputMaybe<Form_ConfirmationType_Operator>;
  createdAt?: InputMaybe<Form_CreatedAt_Operator>;
  emails__bcc?: InputMaybe<Form_Emails__Bcc_Operator>;
  emails__cc?: InputMaybe<Form_Emails__Cc_Operator>;
  emails__emailFrom?: InputMaybe<Form_Emails__EmailFrom_Operator>;
  emails__emailTo?: InputMaybe<Form_Emails__EmailTo_Operator>;
  emails__id?: InputMaybe<Form_Emails__Id_Operator>;
  emails__message?: InputMaybe<Form_Emails__Message_Operator>;
  emails__replyTo?: InputMaybe<Form_Emails__ReplyTo_Operator>;
  emails__subject?: InputMaybe<Form_Emails__Subject_Operator>;
  id?: InputMaybe<Form_Id_Operator>;
  redirect__url?: InputMaybe<Form_Redirect__Url_Operator>;
  submitButtonLabel?: InputMaybe<Form_SubmitButtonLabel_Operator>;
  title?: InputMaybe<Form_Title_Operator>;
  updatedAt?: InputMaybe<Form_UpdatedAt_Operator>;
};

export type Form_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<Form_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Form_Where_Or>>>;
  confirmationMessage?: InputMaybe<Form_ConfirmationMessage_Operator>;
  confirmationType?: InputMaybe<Form_ConfirmationType_Operator>;
  createdAt?: InputMaybe<Form_CreatedAt_Operator>;
  emails__bcc?: InputMaybe<Form_Emails__Bcc_Operator>;
  emails__cc?: InputMaybe<Form_Emails__Cc_Operator>;
  emails__emailFrom?: InputMaybe<Form_Emails__EmailFrom_Operator>;
  emails__emailTo?: InputMaybe<Form_Emails__EmailTo_Operator>;
  emails__id?: InputMaybe<Form_Emails__Id_Operator>;
  emails__message?: InputMaybe<Form_Emails__Message_Operator>;
  emails__replyTo?: InputMaybe<Form_Emails__ReplyTo_Operator>;
  emails__subject?: InputMaybe<Form_Emails__Subject_Operator>;
  id?: InputMaybe<Form_Id_Operator>;
  redirect__url?: InputMaybe<Form_Redirect__Url_Operator>;
  submitButtonLabel?: InputMaybe<Form_SubmitButtonLabel_Operator>;
  title?: InputMaybe<Form_Title_Operator>;
  updatedAt?: InputMaybe<Form_UpdatedAt_Operator>;
};

export type Forms = {
  __typename?: 'Forms';
  docs?: Maybe<Array<Maybe<Form>>>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPrevPage?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  nextPage?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  pagingCounter?: Maybe<Scalars['Int']>;
  prevPage?: Maybe<Scalars['Int']>;
  totalDocs?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
};

export type FormsCreateAccess = {
  __typename?: 'FormsCreateAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type FormsCreateDocAccess = {
  __typename?: 'FormsCreateDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type FormsDeleteAccess = {
  __typename?: 'FormsDeleteAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type FormsDeleteDocAccess = {
  __typename?: 'FormsDeleteDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type FormsDocAccessFields = {
  __typename?: 'FormsDocAccessFields';
  confirmationMessage?: Maybe<FormsDocAccessFields_ConfirmationMessage>;
  confirmationType?: Maybe<FormsDocAccessFields_ConfirmationType>;
  createdAt?: Maybe<FormsDocAccessFields_CreatedAt>;
  emails?: Maybe<FormsDocAccessFields_Emails>;
  fields?: Maybe<FormsDocAccessFields_Fields>;
  redirect?: Maybe<FormsDocAccessFields_Redirect>;
  submitButtonLabel?: Maybe<FormsDocAccessFields_SubmitButtonLabel>;
  title?: Maybe<FormsDocAccessFields_Title>;
  updatedAt?: Maybe<FormsDocAccessFields_UpdatedAt>;
};

export type FormsDocAccessFields_ConfirmationMessage = {
  __typename?: 'FormsDocAccessFields_confirmationMessage';
  create?: Maybe<FormsDocAccessFields_ConfirmationMessage_Create>;
  delete?: Maybe<FormsDocAccessFields_ConfirmationMessage_Delete>;
  read?: Maybe<FormsDocAccessFields_ConfirmationMessage_Read>;
  update?: Maybe<FormsDocAccessFields_ConfirmationMessage_Update>;
};

export type FormsDocAccessFields_ConfirmationMessage_Create = {
  __typename?: 'FormsDocAccessFields_confirmationMessage_Create';
  permission: Scalars['Boolean'];
};

export type FormsDocAccessFields_ConfirmationMessage_Delete = {
  __typename?: 'FormsDocAccessFields_confirmationMessage_Delete';
  permission: Scalars['Boolean'];
};

export type FormsDocAccessFields_ConfirmationMessage_Read = {
  __typename?: 'FormsDocAccessFields_confirmationMessage_Read';
  permission: Scalars['Boolean'];
};

export type FormsDocAccessFields_ConfirmationMessage_Update = {
  __typename?: 'FormsDocAccessFields_confirmationMessage_Update';
  permission: Scalars['Boolean'];
};

export type FormsDocAccessFields_ConfirmationType = {
  __typename?: 'FormsDocAccessFields_confirmationType';
  create?: Maybe<FormsDocAccessFields_ConfirmationType_Create>;
  delete?: Maybe<FormsDocAccessFields_ConfirmationType_Delete>;
  read?: Maybe<FormsDocAccessFields_ConfirmationType_Read>;
  update?: Maybe<FormsDocAccessFields_ConfirmationType_Update>;
};

export type FormsDocAccessFields_ConfirmationType_Create = {
  __typename?: 'FormsDocAccessFields_confirmationType_Create';
  permission: Scalars['Boolean'];
};

export type FormsDocAccessFields_ConfirmationType_Delete = {
  __typename?: 'FormsDocAccessFields_confirmationType_Delete';
  permission: Scalars['Boolean'];
};

export type FormsDocAccessFields_ConfirmationType_Read = {
  __typename?: 'FormsDocAccessFields_confirmationType_Read';
  permission: Scalars['Boolean'];
};

export type FormsDocAccessFields_ConfirmationType_Update = {
  __typename?: 'FormsDocAccessFields_confirmationType_Update';
  permission: Scalars['Boolean'];
};

export type FormsDocAccessFields_CreatedAt = {
  __typename?: 'FormsDocAccessFields_createdAt';
  create?: Maybe<FormsDocAccessFields_CreatedAt_Create>;
  delete?: Maybe<FormsDocAccessFields_CreatedAt_Delete>;
  read?: Maybe<FormsDocAccessFields_CreatedAt_Read>;
  update?: Maybe<FormsDocAccessFields_CreatedAt_Update>;
};

export type FormsDocAccessFields_CreatedAt_Create = {
  __typename?: 'FormsDocAccessFields_createdAt_Create';
  permission: Scalars['Boolean'];
};

export type FormsDocAccessFields_CreatedAt_Delete = {
  __typename?: 'FormsDocAccessFields_createdAt_Delete';
  permission: Scalars['Boolean'];
};

export type FormsDocAccessFields_CreatedAt_Read = {
  __typename?: 'FormsDocAccessFields_createdAt_Read';
  permission: Scalars['Boolean'];
};

export type FormsDocAccessFields_CreatedAt_Update = {
  __typename?: 'FormsDocAccessFields_createdAt_Update';
  permission: Scalars['Boolean'];
};

export type FormsDocAccessFields_Emails = {
  __typename?: 'FormsDocAccessFields_emails';
  create?: Maybe<FormsDocAccessFields_Emails_Create>;
  delete?: Maybe<FormsDocAccessFields_Emails_Delete>;
  fields?: Maybe<FormsDocAccessFields_Emails_Fields>;
  read?: Maybe<FormsDocAccessFields_Emails_Read>;
  update?: Maybe<FormsDocAccessFields_Emails_Update>;
};

export type FormsDocAccessFields_Emails_Create = {
  __typename?: 'FormsDocAccessFields_emails_Create';
  permission: Scalars['Boolean'];
};

export type FormsDocAccessFields_Emails_Delete = {
  __typename?: 'FormsDocAccessFields_emails_Delete';
  permission: Scalars['Boolean'];
};

export type FormsDocAccessFields_Emails_Fields = {
  __typename?: 'FormsDocAccessFields_emails_Fields';
  bcc?: Maybe<FormsDocAccessFields_Emails_Bcc>;
  cc?: Maybe<FormsDocAccessFields_Emails_Cc>;
  emailFrom?: Maybe<FormsDocAccessFields_Emails_EmailFrom>;
  emailTo?: Maybe<FormsDocAccessFields_Emails_EmailTo>;
  id?: Maybe<FormsDocAccessFields_Emails_Id>;
  message?: Maybe<FormsDocAccessFields_Emails_Message>;
  replyTo?: Maybe<FormsDocAccessFields_Emails_ReplyTo>;
  subject?: Maybe<FormsDocAccessFields_Emails_Subject>;
};

export type FormsDocAccessFields_Emails_Read = {
  __typename?: 'FormsDocAccessFields_emails_Read';
  permission: Scalars['Boolean'];
};

export type FormsDocAccessFields_Emails_Update = {
  __typename?: 'FormsDocAccessFields_emails_Update';
  permission: Scalars['Boolean'];
};

export type FormsDocAccessFields_Emails_Bcc = {
  __typename?: 'FormsDocAccessFields_emails_bcc';
  create?: Maybe<FormsDocAccessFields_Emails_Bcc_Create>;
  delete?: Maybe<FormsDocAccessFields_Emails_Bcc_Delete>;
  read?: Maybe<FormsDocAccessFields_Emails_Bcc_Read>;
  update?: Maybe<FormsDocAccessFields_Emails_Bcc_Update>;
};

export type FormsDocAccessFields_Emails_Bcc_Create = {
  __typename?: 'FormsDocAccessFields_emails_bcc_Create';
  permission: Scalars['Boolean'];
};

export type FormsDocAccessFields_Emails_Bcc_Delete = {
  __typename?: 'FormsDocAccessFields_emails_bcc_Delete';
  permission: Scalars['Boolean'];
};

export type FormsDocAccessFields_Emails_Bcc_Read = {
  __typename?: 'FormsDocAccessFields_emails_bcc_Read';
  permission: Scalars['Boolean'];
};

export type FormsDocAccessFields_Emails_Bcc_Update = {
  __typename?: 'FormsDocAccessFields_emails_bcc_Update';
  permission: Scalars['Boolean'];
};

export type FormsDocAccessFields_Emails_Cc = {
  __typename?: 'FormsDocAccessFields_emails_cc';
  create?: Maybe<FormsDocAccessFields_Emails_Cc_Create>;
  delete?: Maybe<FormsDocAccessFields_Emails_Cc_Delete>;
  read?: Maybe<FormsDocAccessFields_Emails_Cc_Read>;
  update?: Maybe<FormsDocAccessFields_Emails_Cc_Update>;
};

export type FormsDocAccessFields_Emails_Cc_Create = {
  __typename?: 'FormsDocAccessFields_emails_cc_Create';
  permission: Scalars['Boolean'];
};

export type FormsDocAccessFields_Emails_Cc_Delete = {
  __typename?: 'FormsDocAccessFields_emails_cc_Delete';
  permission: Scalars['Boolean'];
};

export type FormsDocAccessFields_Emails_Cc_Read = {
  __typename?: 'FormsDocAccessFields_emails_cc_Read';
  permission: Scalars['Boolean'];
};

export type FormsDocAccessFields_Emails_Cc_Update = {
  __typename?: 'FormsDocAccessFields_emails_cc_Update';
  permission: Scalars['Boolean'];
};

export type FormsDocAccessFields_Emails_EmailFrom = {
  __typename?: 'FormsDocAccessFields_emails_emailFrom';
  create?: Maybe<FormsDocAccessFields_Emails_EmailFrom_Create>;
  delete?: Maybe<FormsDocAccessFields_Emails_EmailFrom_Delete>;
  read?: Maybe<FormsDocAccessFields_Emails_EmailFrom_Read>;
  update?: Maybe<FormsDocAccessFields_Emails_EmailFrom_Update>;
};

export type FormsDocAccessFields_Emails_EmailFrom_Create = {
  __typename?: 'FormsDocAccessFields_emails_emailFrom_Create';
  permission: Scalars['Boolean'];
};

export type FormsDocAccessFields_Emails_EmailFrom_Delete = {
  __typename?: 'FormsDocAccessFields_emails_emailFrom_Delete';
  permission: Scalars['Boolean'];
};

export type FormsDocAccessFields_Emails_EmailFrom_Read = {
  __typename?: 'FormsDocAccessFields_emails_emailFrom_Read';
  permission: Scalars['Boolean'];
};

export type FormsDocAccessFields_Emails_EmailFrom_Update = {
  __typename?: 'FormsDocAccessFields_emails_emailFrom_Update';
  permission: Scalars['Boolean'];
};

export type FormsDocAccessFields_Emails_EmailTo = {
  __typename?: 'FormsDocAccessFields_emails_emailTo';
  create?: Maybe<FormsDocAccessFields_Emails_EmailTo_Create>;
  delete?: Maybe<FormsDocAccessFields_Emails_EmailTo_Delete>;
  read?: Maybe<FormsDocAccessFields_Emails_EmailTo_Read>;
  update?: Maybe<FormsDocAccessFields_Emails_EmailTo_Update>;
};

export type FormsDocAccessFields_Emails_EmailTo_Create = {
  __typename?: 'FormsDocAccessFields_emails_emailTo_Create';
  permission: Scalars['Boolean'];
};

export type FormsDocAccessFields_Emails_EmailTo_Delete = {
  __typename?: 'FormsDocAccessFields_emails_emailTo_Delete';
  permission: Scalars['Boolean'];
};

export type FormsDocAccessFields_Emails_EmailTo_Read = {
  __typename?: 'FormsDocAccessFields_emails_emailTo_Read';
  permission: Scalars['Boolean'];
};

export type FormsDocAccessFields_Emails_EmailTo_Update = {
  __typename?: 'FormsDocAccessFields_emails_emailTo_Update';
  permission: Scalars['Boolean'];
};

export type FormsDocAccessFields_Emails_Id = {
  __typename?: 'FormsDocAccessFields_emails_id';
  create?: Maybe<FormsDocAccessFields_Emails_Id_Create>;
  delete?: Maybe<FormsDocAccessFields_Emails_Id_Delete>;
  read?: Maybe<FormsDocAccessFields_Emails_Id_Read>;
  update?: Maybe<FormsDocAccessFields_Emails_Id_Update>;
};

export type FormsDocAccessFields_Emails_Id_Create = {
  __typename?: 'FormsDocAccessFields_emails_id_Create';
  permission: Scalars['Boolean'];
};

export type FormsDocAccessFields_Emails_Id_Delete = {
  __typename?: 'FormsDocAccessFields_emails_id_Delete';
  permission: Scalars['Boolean'];
};

export type FormsDocAccessFields_Emails_Id_Read = {
  __typename?: 'FormsDocAccessFields_emails_id_Read';
  permission: Scalars['Boolean'];
};

export type FormsDocAccessFields_Emails_Id_Update = {
  __typename?: 'FormsDocAccessFields_emails_id_Update';
  permission: Scalars['Boolean'];
};

export type FormsDocAccessFields_Emails_Message = {
  __typename?: 'FormsDocAccessFields_emails_message';
  create?: Maybe<FormsDocAccessFields_Emails_Message_Create>;
  delete?: Maybe<FormsDocAccessFields_Emails_Message_Delete>;
  read?: Maybe<FormsDocAccessFields_Emails_Message_Read>;
  update?: Maybe<FormsDocAccessFields_Emails_Message_Update>;
};

export type FormsDocAccessFields_Emails_Message_Create = {
  __typename?: 'FormsDocAccessFields_emails_message_Create';
  permission: Scalars['Boolean'];
};

export type FormsDocAccessFields_Emails_Message_Delete = {
  __typename?: 'FormsDocAccessFields_emails_message_Delete';
  permission: Scalars['Boolean'];
};

export type FormsDocAccessFields_Emails_Message_Read = {
  __typename?: 'FormsDocAccessFields_emails_message_Read';
  permission: Scalars['Boolean'];
};

export type FormsDocAccessFields_Emails_Message_Update = {
  __typename?: 'FormsDocAccessFields_emails_message_Update';
  permission: Scalars['Boolean'];
};

export type FormsDocAccessFields_Emails_ReplyTo = {
  __typename?: 'FormsDocAccessFields_emails_replyTo';
  create?: Maybe<FormsDocAccessFields_Emails_ReplyTo_Create>;
  delete?: Maybe<FormsDocAccessFields_Emails_ReplyTo_Delete>;
  read?: Maybe<FormsDocAccessFields_Emails_ReplyTo_Read>;
  update?: Maybe<FormsDocAccessFields_Emails_ReplyTo_Update>;
};

export type FormsDocAccessFields_Emails_ReplyTo_Create = {
  __typename?: 'FormsDocAccessFields_emails_replyTo_Create';
  permission: Scalars['Boolean'];
};

export type FormsDocAccessFields_Emails_ReplyTo_Delete = {
  __typename?: 'FormsDocAccessFields_emails_replyTo_Delete';
  permission: Scalars['Boolean'];
};

export type FormsDocAccessFields_Emails_ReplyTo_Read = {
  __typename?: 'FormsDocAccessFields_emails_replyTo_Read';
  permission: Scalars['Boolean'];
};

export type FormsDocAccessFields_Emails_ReplyTo_Update = {
  __typename?: 'FormsDocAccessFields_emails_replyTo_Update';
  permission: Scalars['Boolean'];
};

export type FormsDocAccessFields_Emails_Subject = {
  __typename?: 'FormsDocAccessFields_emails_subject';
  create?: Maybe<FormsDocAccessFields_Emails_Subject_Create>;
  delete?: Maybe<FormsDocAccessFields_Emails_Subject_Delete>;
  read?: Maybe<FormsDocAccessFields_Emails_Subject_Read>;
  update?: Maybe<FormsDocAccessFields_Emails_Subject_Update>;
};

export type FormsDocAccessFields_Emails_Subject_Create = {
  __typename?: 'FormsDocAccessFields_emails_subject_Create';
  permission: Scalars['Boolean'];
};

export type FormsDocAccessFields_Emails_Subject_Delete = {
  __typename?: 'FormsDocAccessFields_emails_subject_Delete';
  permission: Scalars['Boolean'];
};

export type FormsDocAccessFields_Emails_Subject_Read = {
  __typename?: 'FormsDocAccessFields_emails_subject_Read';
  permission: Scalars['Boolean'];
};

export type FormsDocAccessFields_Emails_Subject_Update = {
  __typename?: 'FormsDocAccessFields_emails_subject_Update';
  permission: Scalars['Boolean'];
};

export type FormsDocAccessFields_Fields = {
  __typename?: 'FormsDocAccessFields_fields';
  create?: Maybe<FormsDocAccessFields_Fields_Create>;
  delete?: Maybe<FormsDocAccessFields_Fields_Delete>;
  read?: Maybe<FormsDocAccessFields_Fields_Read>;
  update?: Maybe<FormsDocAccessFields_Fields_Update>;
};

export type FormsDocAccessFields_Fields_Create = {
  __typename?: 'FormsDocAccessFields_fields_Create';
  permission: Scalars['Boolean'];
};

export type FormsDocAccessFields_Fields_Delete = {
  __typename?: 'FormsDocAccessFields_fields_Delete';
  permission: Scalars['Boolean'];
};

export type FormsDocAccessFields_Fields_Read = {
  __typename?: 'FormsDocAccessFields_fields_Read';
  permission: Scalars['Boolean'];
};

export type FormsDocAccessFields_Fields_Update = {
  __typename?: 'FormsDocAccessFields_fields_Update';
  permission: Scalars['Boolean'];
};

export type FormsDocAccessFields_Redirect = {
  __typename?: 'FormsDocAccessFields_redirect';
  create?: Maybe<FormsDocAccessFields_Redirect_Create>;
  delete?: Maybe<FormsDocAccessFields_Redirect_Delete>;
  fields?: Maybe<FormsDocAccessFields_Redirect_Fields>;
  read?: Maybe<FormsDocAccessFields_Redirect_Read>;
  update?: Maybe<FormsDocAccessFields_Redirect_Update>;
};

export type FormsDocAccessFields_Redirect_Create = {
  __typename?: 'FormsDocAccessFields_redirect_Create';
  permission: Scalars['Boolean'];
};

export type FormsDocAccessFields_Redirect_Delete = {
  __typename?: 'FormsDocAccessFields_redirect_Delete';
  permission: Scalars['Boolean'];
};

export type FormsDocAccessFields_Redirect_Fields = {
  __typename?: 'FormsDocAccessFields_redirect_Fields';
  url?: Maybe<FormsDocAccessFields_Redirect_Url>;
};

export type FormsDocAccessFields_Redirect_Read = {
  __typename?: 'FormsDocAccessFields_redirect_Read';
  permission: Scalars['Boolean'];
};

export type FormsDocAccessFields_Redirect_Update = {
  __typename?: 'FormsDocAccessFields_redirect_Update';
  permission: Scalars['Boolean'];
};

export type FormsDocAccessFields_Redirect_Url = {
  __typename?: 'FormsDocAccessFields_redirect_url';
  create?: Maybe<FormsDocAccessFields_Redirect_Url_Create>;
  delete?: Maybe<FormsDocAccessFields_Redirect_Url_Delete>;
  read?: Maybe<FormsDocAccessFields_Redirect_Url_Read>;
  update?: Maybe<FormsDocAccessFields_Redirect_Url_Update>;
};

export type FormsDocAccessFields_Redirect_Url_Create = {
  __typename?: 'FormsDocAccessFields_redirect_url_Create';
  permission: Scalars['Boolean'];
};

export type FormsDocAccessFields_Redirect_Url_Delete = {
  __typename?: 'FormsDocAccessFields_redirect_url_Delete';
  permission: Scalars['Boolean'];
};

export type FormsDocAccessFields_Redirect_Url_Read = {
  __typename?: 'FormsDocAccessFields_redirect_url_Read';
  permission: Scalars['Boolean'];
};

export type FormsDocAccessFields_Redirect_Url_Update = {
  __typename?: 'FormsDocAccessFields_redirect_url_Update';
  permission: Scalars['Boolean'];
};

export type FormsDocAccessFields_SubmitButtonLabel = {
  __typename?: 'FormsDocAccessFields_submitButtonLabel';
  create?: Maybe<FormsDocAccessFields_SubmitButtonLabel_Create>;
  delete?: Maybe<FormsDocAccessFields_SubmitButtonLabel_Delete>;
  read?: Maybe<FormsDocAccessFields_SubmitButtonLabel_Read>;
  update?: Maybe<FormsDocAccessFields_SubmitButtonLabel_Update>;
};

export type FormsDocAccessFields_SubmitButtonLabel_Create = {
  __typename?: 'FormsDocAccessFields_submitButtonLabel_Create';
  permission: Scalars['Boolean'];
};

export type FormsDocAccessFields_SubmitButtonLabel_Delete = {
  __typename?: 'FormsDocAccessFields_submitButtonLabel_Delete';
  permission: Scalars['Boolean'];
};

export type FormsDocAccessFields_SubmitButtonLabel_Read = {
  __typename?: 'FormsDocAccessFields_submitButtonLabel_Read';
  permission: Scalars['Boolean'];
};

export type FormsDocAccessFields_SubmitButtonLabel_Update = {
  __typename?: 'FormsDocAccessFields_submitButtonLabel_Update';
  permission: Scalars['Boolean'];
};

export type FormsDocAccessFields_Title = {
  __typename?: 'FormsDocAccessFields_title';
  create?: Maybe<FormsDocAccessFields_Title_Create>;
  delete?: Maybe<FormsDocAccessFields_Title_Delete>;
  read?: Maybe<FormsDocAccessFields_Title_Read>;
  update?: Maybe<FormsDocAccessFields_Title_Update>;
};

export type FormsDocAccessFields_Title_Create = {
  __typename?: 'FormsDocAccessFields_title_Create';
  permission: Scalars['Boolean'];
};

export type FormsDocAccessFields_Title_Delete = {
  __typename?: 'FormsDocAccessFields_title_Delete';
  permission: Scalars['Boolean'];
};

export type FormsDocAccessFields_Title_Read = {
  __typename?: 'FormsDocAccessFields_title_Read';
  permission: Scalars['Boolean'];
};

export type FormsDocAccessFields_Title_Update = {
  __typename?: 'FormsDocAccessFields_title_Update';
  permission: Scalars['Boolean'];
};

export type FormsDocAccessFields_UpdatedAt = {
  __typename?: 'FormsDocAccessFields_updatedAt';
  create?: Maybe<FormsDocAccessFields_UpdatedAt_Create>;
  delete?: Maybe<FormsDocAccessFields_UpdatedAt_Delete>;
  read?: Maybe<FormsDocAccessFields_UpdatedAt_Read>;
  update?: Maybe<FormsDocAccessFields_UpdatedAt_Update>;
};

export type FormsDocAccessFields_UpdatedAt_Create = {
  __typename?: 'FormsDocAccessFields_updatedAt_Create';
  permission: Scalars['Boolean'];
};

export type FormsDocAccessFields_UpdatedAt_Delete = {
  __typename?: 'FormsDocAccessFields_updatedAt_Delete';
  permission: Scalars['Boolean'];
};

export type FormsDocAccessFields_UpdatedAt_Read = {
  __typename?: 'FormsDocAccessFields_updatedAt_Read';
  permission: Scalars['Boolean'];
};

export type FormsDocAccessFields_UpdatedAt_Update = {
  __typename?: 'FormsDocAccessFields_updatedAt_Update';
  permission: Scalars['Boolean'];
};

export type FormsFields = {
  __typename?: 'FormsFields';
  confirmationMessage?: Maybe<FormsFields_ConfirmationMessage>;
  confirmationType?: Maybe<FormsFields_ConfirmationType>;
  createdAt?: Maybe<FormsFields_CreatedAt>;
  emails?: Maybe<FormsFields_Emails>;
  fields?: Maybe<FormsFields_Fields>;
  redirect?: Maybe<FormsFields_Redirect>;
  submitButtonLabel?: Maybe<FormsFields_SubmitButtonLabel>;
  title?: Maybe<FormsFields_Title>;
  updatedAt?: Maybe<FormsFields_UpdatedAt>;
};

export type FormsFields_ConfirmationMessage = {
  __typename?: 'FormsFields_confirmationMessage';
  create?: Maybe<FormsFields_ConfirmationMessage_Create>;
  delete?: Maybe<FormsFields_ConfirmationMessage_Delete>;
  read?: Maybe<FormsFields_ConfirmationMessage_Read>;
  update?: Maybe<FormsFields_ConfirmationMessage_Update>;
};

export type FormsFields_ConfirmationMessage_Create = {
  __typename?: 'FormsFields_confirmationMessage_Create';
  permission: Scalars['Boolean'];
};

export type FormsFields_ConfirmationMessage_Delete = {
  __typename?: 'FormsFields_confirmationMessage_Delete';
  permission: Scalars['Boolean'];
};

export type FormsFields_ConfirmationMessage_Read = {
  __typename?: 'FormsFields_confirmationMessage_Read';
  permission: Scalars['Boolean'];
};

export type FormsFields_ConfirmationMessage_Update = {
  __typename?: 'FormsFields_confirmationMessage_Update';
  permission: Scalars['Boolean'];
};

export type FormsFields_ConfirmationType = {
  __typename?: 'FormsFields_confirmationType';
  create?: Maybe<FormsFields_ConfirmationType_Create>;
  delete?: Maybe<FormsFields_ConfirmationType_Delete>;
  read?: Maybe<FormsFields_ConfirmationType_Read>;
  update?: Maybe<FormsFields_ConfirmationType_Update>;
};

export type FormsFields_ConfirmationType_Create = {
  __typename?: 'FormsFields_confirmationType_Create';
  permission: Scalars['Boolean'];
};

export type FormsFields_ConfirmationType_Delete = {
  __typename?: 'FormsFields_confirmationType_Delete';
  permission: Scalars['Boolean'];
};

export type FormsFields_ConfirmationType_Read = {
  __typename?: 'FormsFields_confirmationType_Read';
  permission: Scalars['Boolean'];
};

export type FormsFields_ConfirmationType_Update = {
  __typename?: 'FormsFields_confirmationType_Update';
  permission: Scalars['Boolean'];
};

export type FormsFields_CreatedAt = {
  __typename?: 'FormsFields_createdAt';
  create?: Maybe<FormsFields_CreatedAt_Create>;
  delete?: Maybe<FormsFields_CreatedAt_Delete>;
  read?: Maybe<FormsFields_CreatedAt_Read>;
  update?: Maybe<FormsFields_CreatedAt_Update>;
};

export type FormsFields_CreatedAt_Create = {
  __typename?: 'FormsFields_createdAt_Create';
  permission: Scalars['Boolean'];
};

export type FormsFields_CreatedAt_Delete = {
  __typename?: 'FormsFields_createdAt_Delete';
  permission: Scalars['Boolean'];
};

export type FormsFields_CreatedAt_Read = {
  __typename?: 'FormsFields_createdAt_Read';
  permission: Scalars['Boolean'];
};

export type FormsFields_CreatedAt_Update = {
  __typename?: 'FormsFields_createdAt_Update';
  permission: Scalars['Boolean'];
};

export type FormsFields_Emails = {
  __typename?: 'FormsFields_emails';
  create?: Maybe<FormsFields_Emails_Create>;
  delete?: Maybe<FormsFields_Emails_Delete>;
  fields?: Maybe<FormsFields_Emails_Fields>;
  read?: Maybe<FormsFields_Emails_Read>;
  update?: Maybe<FormsFields_Emails_Update>;
};

export type FormsFields_Emails_Create = {
  __typename?: 'FormsFields_emails_Create';
  permission: Scalars['Boolean'];
};

export type FormsFields_Emails_Delete = {
  __typename?: 'FormsFields_emails_Delete';
  permission: Scalars['Boolean'];
};

export type FormsFields_Emails_Fields = {
  __typename?: 'FormsFields_emails_Fields';
  bcc?: Maybe<FormsFields_Emails_Bcc>;
  cc?: Maybe<FormsFields_Emails_Cc>;
  emailFrom?: Maybe<FormsFields_Emails_EmailFrom>;
  emailTo?: Maybe<FormsFields_Emails_EmailTo>;
  id?: Maybe<FormsFields_Emails_Id>;
  message?: Maybe<FormsFields_Emails_Message>;
  replyTo?: Maybe<FormsFields_Emails_ReplyTo>;
  subject?: Maybe<FormsFields_Emails_Subject>;
};

export type FormsFields_Emails_Read = {
  __typename?: 'FormsFields_emails_Read';
  permission: Scalars['Boolean'];
};

export type FormsFields_Emails_Update = {
  __typename?: 'FormsFields_emails_Update';
  permission: Scalars['Boolean'];
};

export type FormsFields_Emails_Bcc = {
  __typename?: 'FormsFields_emails_bcc';
  create?: Maybe<FormsFields_Emails_Bcc_Create>;
  delete?: Maybe<FormsFields_Emails_Bcc_Delete>;
  read?: Maybe<FormsFields_Emails_Bcc_Read>;
  update?: Maybe<FormsFields_Emails_Bcc_Update>;
};

export type FormsFields_Emails_Bcc_Create = {
  __typename?: 'FormsFields_emails_bcc_Create';
  permission: Scalars['Boolean'];
};

export type FormsFields_Emails_Bcc_Delete = {
  __typename?: 'FormsFields_emails_bcc_Delete';
  permission: Scalars['Boolean'];
};

export type FormsFields_Emails_Bcc_Read = {
  __typename?: 'FormsFields_emails_bcc_Read';
  permission: Scalars['Boolean'];
};

export type FormsFields_Emails_Bcc_Update = {
  __typename?: 'FormsFields_emails_bcc_Update';
  permission: Scalars['Boolean'];
};

export type FormsFields_Emails_Cc = {
  __typename?: 'FormsFields_emails_cc';
  create?: Maybe<FormsFields_Emails_Cc_Create>;
  delete?: Maybe<FormsFields_Emails_Cc_Delete>;
  read?: Maybe<FormsFields_Emails_Cc_Read>;
  update?: Maybe<FormsFields_Emails_Cc_Update>;
};

export type FormsFields_Emails_Cc_Create = {
  __typename?: 'FormsFields_emails_cc_Create';
  permission: Scalars['Boolean'];
};

export type FormsFields_Emails_Cc_Delete = {
  __typename?: 'FormsFields_emails_cc_Delete';
  permission: Scalars['Boolean'];
};

export type FormsFields_Emails_Cc_Read = {
  __typename?: 'FormsFields_emails_cc_Read';
  permission: Scalars['Boolean'];
};

export type FormsFields_Emails_Cc_Update = {
  __typename?: 'FormsFields_emails_cc_Update';
  permission: Scalars['Boolean'];
};

export type FormsFields_Emails_EmailFrom = {
  __typename?: 'FormsFields_emails_emailFrom';
  create?: Maybe<FormsFields_Emails_EmailFrom_Create>;
  delete?: Maybe<FormsFields_Emails_EmailFrom_Delete>;
  read?: Maybe<FormsFields_Emails_EmailFrom_Read>;
  update?: Maybe<FormsFields_Emails_EmailFrom_Update>;
};

export type FormsFields_Emails_EmailFrom_Create = {
  __typename?: 'FormsFields_emails_emailFrom_Create';
  permission: Scalars['Boolean'];
};

export type FormsFields_Emails_EmailFrom_Delete = {
  __typename?: 'FormsFields_emails_emailFrom_Delete';
  permission: Scalars['Boolean'];
};

export type FormsFields_Emails_EmailFrom_Read = {
  __typename?: 'FormsFields_emails_emailFrom_Read';
  permission: Scalars['Boolean'];
};

export type FormsFields_Emails_EmailFrom_Update = {
  __typename?: 'FormsFields_emails_emailFrom_Update';
  permission: Scalars['Boolean'];
};

export type FormsFields_Emails_EmailTo = {
  __typename?: 'FormsFields_emails_emailTo';
  create?: Maybe<FormsFields_Emails_EmailTo_Create>;
  delete?: Maybe<FormsFields_Emails_EmailTo_Delete>;
  read?: Maybe<FormsFields_Emails_EmailTo_Read>;
  update?: Maybe<FormsFields_Emails_EmailTo_Update>;
};

export type FormsFields_Emails_EmailTo_Create = {
  __typename?: 'FormsFields_emails_emailTo_Create';
  permission: Scalars['Boolean'];
};

export type FormsFields_Emails_EmailTo_Delete = {
  __typename?: 'FormsFields_emails_emailTo_Delete';
  permission: Scalars['Boolean'];
};

export type FormsFields_Emails_EmailTo_Read = {
  __typename?: 'FormsFields_emails_emailTo_Read';
  permission: Scalars['Boolean'];
};

export type FormsFields_Emails_EmailTo_Update = {
  __typename?: 'FormsFields_emails_emailTo_Update';
  permission: Scalars['Boolean'];
};

export type FormsFields_Emails_Id = {
  __typename?: 'FormsFields_emails_id';
  create?: Maybe<FormsFields_Emails_Id_Create>;
  delete?: Maybe<FormsFields_Emails_Id_Delete>;
  read?: Maybe<FormsFields_Emails_Id_Read>;
  update?: Maybe<FormsFields_Emails_Id_Update>;
};

export type FormsFields_Emails_Id_Create = {
  __typename?: 'FormsFields_emails_id_Create';
  permission: Scalars['Boolean'];
};

export type FormsFields_Emails_Id_Delete = {
  __typename?: 'FormsFields_emails_id_Delete';
  permission: Scalars['Boolean'];
};

export type FormsFields_Emails_Id_Read = {
  __typename?: 'FormsFields_emails_id_Read';
  permission: Scalars['Boolean'];
};

export type FormsFields_Emails_Id_Update = {
  __typename?: 'FormsFields_emails_id_Update';
  permission: Scalars['Boolean'];
};

export type FormsFields_Emails_Message = {
  __typename?: 'FormsFields_emails_message';
  create?: Maybe<FormsFields_Emails_Message_Create>;
  delete?: Maybe<FormsFields_Emails_Message_Delete>;
  read?: Maybe<FormsFields_Emails_Message_Read>;
  update?: Maybe<FormsFields_Emails_Message_Update>;
};

export type FormsFields_Emails_Message_Create = {
  __typename?: 'FormsFields_emails_message_Create';
  permission: Scalars['Boolean'];
};

export type FormsFields_Emails_Message_Delete = {
  __typename?: 'FormsFields_emails_message_Delete';
  permission: Scalars['Boolean'];
};

export type FormsFields_Emails_Message_Read = {
  __typename?: 'FormsFields_emails_message_Read';
  permission: Scalars['Boolean'];
};

export type FormsFields_Emails_Message_Update = {
  __typename?: 'FormsFields_emails_message_Update';
  permission: Scalars['Boolean'];
};

export type FormsFields_Emails_ReplyTo = {
  __typename?: 'FormsFields_emails_replyTo';
  create?: Maybe<FormsFields_Emails_ReplyTo_Create>;
  delete?: Maybe<FormsFields_Emails_ReplyTo_Delete>;
  read?: Maybe<FormsFields_Emails_ReplyTo_Read>;
  update?: Maybe<FormsFields_Emails_ReplyTo_Update>;
};

export type FormsFields_Emails_ReplyTo_Create = {
  __typename?: 'FormsFields_emails_replyTo_Create';
  permission: Scalars['Boolean'];
};

export type FormsFields_Emails_ReplyTo_Delete = {
  __typename?: 'FormsFields_emails_replyTo_Delete';
  permission: Scalars['Boolean'];
};

export type FormsFields_Emails_ReplyTo_Read = {
  __typename?: 'FormsFields_emails_replyTo_Read';
  permission: Scalars['Boolean'];
};

export type FormsFields_Emails_ReplyTo_Update = {
  __typename?: 'FormsFields_emails_replyTo_Update';
  permission: Scalars['Boolean'];
};

export type FormsFields_Emails_Subject = {
  __typename?: 'FormsFields_emails_subject';
  create?: Maybe<FormsFields_Emails_Subject_Create>;
  delete?: Maybe<FormsFields_Emails_Subject_Delete>;
  read?: Maybe<FormsFields_Emails_Subject_Read>;
  update?: Maybe<FormsFields_Emails_Subject_Update>;
};

export type FormsFields_Emails_Subject_Create = {
  __typename?: 'FormsFields_emails_subject_Create';
  permission: Scalars['Boolean'];
};

export type FormsFields_Emails_Subject_Delete = {
  __typename?: 'FormsFields_emails_subject_Delete';
  permission: Scalars['Boolean'];
};

export type FormsFields_Emails_Subject_Read = {
  __typename?: 'FormsFields_emails_subject_Read';
  permission: Scalars['Boolean'];
};

export type FormsFields_Emails_Subject_Update = {
  __typename?: 'FormsFields_emails_subject_Update';
  permission: Scalars['Boolean'];
};

export type FormsFields_Fields = {
  __typename?: 'FormsFields_fields';
  create?: Maybe<FormsFields_Fields_Create>;
  delete?: Maybe<FormsFields_Fields_Delete>;
  read?: Maybe<FormsFields_Fields_Read>;
  update?: Maybe<FormsFields_Fields_Update>;
};

export type FormsFields_Fields_Create = {
  __typename?: 'FormsFields_fields_Create';
  permission: Scalars['Boolean'];
};

export type FormsFields_Fields_Delete = {
  __typename?: 'FormsFields_fields_Delete';
  permission: Scalars['Boolean'];
};

export type FormsFields_Fields_Read = {
  __typename?: 'FormsFields_fields_Read';
  permission: Scalars['Boolean'];
};

export type FormsFields_Fields_Update = {
  __typename?: 'FormsFields_fields_Update';
  permission: Scalars['Boolean'];
};

export type FormsFields_Redirect = {
  __typename?: 'FormsFields_redirect';
  create?: Maybe<FormsFields_Redirect_Create>;
  delete?: Maybe<FormsFields_Redirect_Delete>;
  fields?: Maybe<FormsFields_Redirect_Fields>;
  read?: Maybe<FormsFields_Redirect_Read>;
  update?: Maybe<FormsFields_Redirect_Update>;
};

export type FormsFields_Redirect_Create = {
  __typename?: 'FormsFields_redirect_Create';
  permission: Scalars['Boolean'];
};

export type FormsFields_Redirect_Delete = {
  __typename?: 'FormsFields_redirect_Delete';
  permission: Scalars['Boolean'];
};

export type FormsFields_Redirect_Fields = {
  __typename?: 'FormsFields_redirect_Fields';
  url?: Maybe<FormsFields_Redirect_Url>;
};

export type FormsFields_Redirect_Read = {
  __typename?: 'FormsFields_redirect_Read';
  permission: Scalars['Boolean'];
};

export type FormsFields_Redirect_Update = {
  __typename?: 'FormsFields_redirect_Update';
  permission: Scalars['Boolean'];
};

export type FormsFields_Redirect_Url = {
  __typename?: 'FormsFields_redirect_url';
  create?: Maybe<FormsFields_Redirect_Url_Create>;
  delete?: Maybe<FormsFields_Redirect_Url_Delete>;
  read?: Maybe<FormsFields_Redirect_Url_Read>;
  update?: Maybe<FormsFields_Redirect_Url_Update>;
};

export type FormsFields_Redirect_Url_Create = {
  __typename?: 'FormsFields_redirect_url_Create';
  permission: Scalars['Boolean'];
};

export type FormsFields_Redirect_Url_Delete = {
  __typename?: 'FormsFields_redirect_url_Delete';
  permission: Scalars['Boolean'];
};

export type FormsFields_Redirect_Url_Read = {
  __typename?: 'FormsFields_redirect_url_Read';
  permission: Scalars['Boolean'];
};

export type FormsFields_Redirect_Url_Update = {
  __typename?: 'FormsFields_redirect_url_Update';
  permission: Scalars['Boolean'];
};

export type FormsFields_SubmitButtonLabel = {
  __typename?: 'FormsFields_submitButtonLabel';
  create?: Maybe<FormsFields_SubmitButtonLabel_Create>;
  delete?: Maybe<FormsFields_SubmitButtonLabel_Delete>;
  read?: Maybe<FormsFields_SubmitButtonLabel_Read>;
  update?: Maybe<FormsFields_SubmitButtonLabel_Update>;
};

export type FormsFields_SubmitButtonLabel_Create = {
  __typename?: 'FormsFields_submitButtonLabel_Create';
  permission: Scalars['Boolean'];
};

export type FormsFields_SubmitButtonLabel_Delete = {
  __typename?: 'FormsFields_submitButtonLabel_Delete';
  permission: Scalars['Boolean'];
};

export type FormsFields_SubmitButtonLabel_Read = {
  __typename?: 'FormsFields_submitButtonLabel_Read';
  permission: Scalars['Boolean'];
};

export type FormsFields_SubmitButtonLabel_Update = {
  __typename?: 'FormsFields_submitButtonLabel_Update';
  permission: Scalars['Boolean'];
};

export type FormsFields_Title = {
  __typename?: 'FormsFields_title';
  create?: Maybe<FormsFields_Title_Create>;
  delete?: Maybe<FormsFields_Title_Delete>;
  read?: Maybe<FormsFields_Title_Read>;
  update?: Maybe<FormsFields_Title_Update>;
};

export type FormsFields_Title_Create = {
  __typename?: 'FormsFields_title_Create';
  permission: Scalars['Boolean'];
};

export type FormsFields_Title_Delete = {
  __typename?: 'FormsFields_title_Delete';
  permission: Scalars['Boolean'];
};

export type FormsFields_Title_Read = {
  __typename?: 'FormsFields_title_Read';
  permission: Scalars['Boolean'];
};

export type FormsFields_Title_Update = {
  __typename?: 'FormsFields_title_Update';
  permission: Scalars['Boolean'];
};

export type FormsFields_UpdatedAt = {
  __typename?: 'FormsFields_updatedAt';
  create?: Maybe<FormsFields_UpdatedAt_Create>;
  delete?: Maybe<FormsFields_UpdatedAt_Delete>;
  read?: Maybe<FormsFields_UpdatedAt_Read>;
  update?: Maybe<FormsFields_UpdatedAt_Update>;
};

export type FormsFields_UpdatedAt_Create = {
  __typename?: 'FormsFields_updatedAt_Create';
  permission: Scalars['Boolean'];
};

export type FormsFields_UpdatedAt_Delete = {
  __typename?: 'FormsFields_updatedAt_Delete';
  permission: Scalars['Boolean'];
};

export type FormsFields_UpdatedAt_Read = {
  __typename?: 'FormsFields_updatedAt_Read';
  permission: Scalars['Boolean'];
};

export type FormsFields_UpdatedAt_Update = {
  __typename?: 'FormsFields_updatedAt_Update';
  permission: Scalars['Boolean'];
};

export type FormsReadAccess = {
  __typename?: 'FormsReadAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type FormsReadDocAccess = {
  __typename?: 'FormsReadDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type FormsUpdateAccess = {
  __typename?: 'FormsUpdateAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type FormsUpdateDocAccess = {
  __typename?: 'FormsUpdateDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type HeaderMenu = {
  __typename?: 'HeaderMenu';
  createdAt?: Maybe<Scalars['DateTime']>;
  links?: Maybe<Array<HeaderMenu_Links>>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type HeaderMenuDocAccessFields = {
  __typename?: 'HeaderMenuDocAccessFields';
  createdAt?: Maybe<HeaderMenuDocAccessFields_CreatedAt>;
  links?: Maybe<HeaderMenuDocAccessFields_Links>;
  updatedAt?: Maybe<HeaderMenuDocAccessFields_UpdatedAt>;
};

export type HeaderMenuDocAccessFields_CreatedAt = {
  __typename?: 'HeaderMenuDocAccessFields_createdAt';
  create?: Maybe<HeaderMenuDocAccessFields_CreatedAt_Create>;
  delete?: Maybe<HeaderMenuDocAccessFields_CreatedAt_Delete>;
  read?: Maybe<HeaderMenuDocAccessFields_CreatedAt_Read>;
  update?: Maybe<HeaderMenuDocAccessFields_CreatedAt_Update>;
};

export type HeaderMenuDocAccessFields_CreatedAt_Create = {
  __typename?: 'HeaderMenuDocAccessFields_createdAt_Create';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_CreatedAt_Delete = {
  __typename?: 'HeaderMenuDocAccessFields_createdAt_Delete';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_CreatedAt_Read = {
  __typename?: 'HeaderMenuDocAccessFields_createdAt_Read';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_CreatedAt_Update = {
  __typename?: 'HeaderMenuDocAccessFields_createdAt_Update';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links = {
  __typename?: 'HeaderMenuDocAccessFields_links';
  create?: Maybe<HeaderMenuDocAccessFields_Links_Create>;
  delete?: Maybe<HeaderMenuDocAccessFields_Links_Delete>;
  fields?: Maybe<HeaderMenuDocAccessFields_Links_Fields>;
  read?: Maybe<HeaderMenuDocAccessFields_Links_Read>;
  update?: Maybe<HeaderMenuDocAccessFields_Links_Update>;
};

export type HeaderMenuDocAccessFields_Links_Create = {
  __typename?: 'HeaderMenuDocAccessFields_links_Create';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_Delete = {
  __typename?: 'HeaderMenuDocAccessFields_links_Delete';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_Fields = {
  __typename?: 'HeaderMenuDocAccessFields_links_Fields';
  id?: Maybe<HeaderMenuDocAccessFields_Links_Id>;
  link?: Maybe<HeaderMenuDocAccessFields_Links_Link>;
  subMenu?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu>;
  subMenuEnabled?: Maybe<HeaderMenuDocAccessFields_Links_SubMenuEnabled>;
};

export type HeaderMenuDocAccessFields_Links_Read = {
  __typename?: 'HeaderMenuDocAccessFields_links_Read';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_Update = {
  __typename?: 'HeaderMenuDocAccessFields_links_Update';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_Id = {
  __typename?: 'HeaderMenuDocAccessFields_links_id';
  create?: Maybe<HeaderMenuDocAccessFields_Links_Id_Create>;
  delete?: Maybe<HeaderMenuDocAccessFields_Links_Id_Delete>;
  read?: Maybe<HeaderMenuDocAccessFields_Links_Id_Read>;
  update?: Maybe<HeaderMenuDocAccessFields_Links_Id_Update>;
};

export type HeaderMenuDocAccessFields_Links_Id_Create = {
  __typename?: 'HeaderMenuDocAccessFields_links_id_Create';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_Id_Delete = {
  __typename?: 'HeaderMenuDocAccessFields_links_id_Delete';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_Id_Read = {
  __typename?: 'HeaderMenuDocAccessFields_links_id_Read';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_Id_Update = {
  __typename?: 'HeaderMenuDocAccessFields_links_id_Update';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_Link = {
  __typename?: 'HeaderMenuDocAccessFields_links_link';
  create?: Maybe<HeaderMenuDocAccessFields_Links_Link_Create>;
  delete?: Maybe<HeaderMenuDocAccessFields_Links_Link_Delete>;
  fields?: Maybe<HeaderMenuDocAccessFields_Links_Link_Fields>;
  read?: Maybe<HeaderMenuDocAccessFields_Links_Link_Read>;
  update?: Maybe<HeaderMenuDocAccessFields_Links_Link_Update>;
};

export type HeaderMenuDocAccessFields_Links_Link_Create = {
  __typename?: 'HeaderMenuDocAccessFields_links_link_Create';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_Link_Delete = {
  __typename?: 'HeaderMenuDocAccessFields_links_link_Delete';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_Link_Fields = {
  __typename?: 'HeaderMenuDocAccessFields_links_link_Fields';
  label?: Maybe<HeaderMenuDocAccessFields_Links_Link_Label>;
  reference?: Maybe<HeaderMenuDocAccessFields_Links_Link_Reference>;
  type?: Maybe<HeaderMenuDocAccessFields_Links_Link_Type>;
  url?: Maybe<HeaderMenuDocAccessFields_Links_Link_Url>;
};

export type HeaderMenuDocAccessFields_Links_Link_Read = {
  __typename?: 'HeaderMenuDocAccessFields_links_link_Read';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_Link_Update = {
  __typename?: 'HeaderMenuDocAccessFields_links_link_Update';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_Link_Label = {
  __typename?: 'HeaderMenuDocAccessFields_links_link_label';
  create?: Maybe<HeaderMenuDocAccessFields_Links_Link_Label_Create>;
  delete?: Maybe<HeaderMenuDocAccessFields_Links_Link_Label_Delete>;
  read?: Maybe<HeaderMenuDocAccessFields_Links_Link_Label_Read>;
  update?: Maybe<HeaderMenuDocAccessFields_Links_Link_Label_Update>;
};

export type HeaderMenuDocAccessFields_Links_Link_Label_Create = {
  __typename?: 'HeaderMenuDocAccessFields_links_link_label_Create';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_Link_Label_Delete = {
  __typename?: 'HeaderMenuDocAccessFields_links_link_label_Delete';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_Link_Label_Read = {
  __typename?: 'HeaderMenuDocAccessFields_links_link_label_Read';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_Link_Label_Update = {
  __typename?: 'HeaderMenuDocAccessFields_links_link_label_Update';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_Link_Reference = {
  __typename?: 'HeaderMenuDocAccessFields_links_link_reference';
  create?: Maybe<HeaderMenuDocAccessFields_Links_Link_Reference_Create>;
  delete?: Maybe<HeaderMenuDocAccessFields_Links_Link_Reference_Delete>;
  read?: Maybe<HeaderMenuDocAccessFields_Links_Link_Reference_Read>;
  update?: Maybe<HeaderMenuDocAccessFields_Links_Link_Reference_Update>;
};

export type HeaderMenuDocAccessFields_Links_Link_Reference_Create = {
  __typename?: 'HeaderMenuDocAccessFields_links_link_reference_Create';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_Link_Reference_Delete = {
  __typename?: 'HeaderMenuDocAccessFields_links_link_reference_Delete';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_Link_Reference_Read = {
  __typename?: 'HeaderMenuDocAccessFields_links_link_reference_Read';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_Link_Reference_Update = {
  __typename?: 'HeaderMenuDocAccessFields_links_link_reference_Update';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_Link_Type = {
  __typename?: 'HeaderMenuDocAccessFields_links_link_type';
  create?: Maybe<HeaderMenuDocAccessFields_Links_Link_Type_Create>;
  delete?: Maybe<HeaderMenuDocAccessFields_Links_Link_Type_Delete>;
  read?: Maybe<HeaderMenuDocAccessFields_Links_Link_Type_Read>;
  update?: Maybe<HeaderMenuDocAccessFields_Links_Link_Type_Update>;
};

export type HeaderMenuDocAccessFields_Links_Link_Type_Create = {
  __typename?: 'HeaderMenuDocAccessFields_links_link_type_Create';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_Link_Type_Delete = {
  __typename?: 'HeaderMenuDocAccessFields_links_link_type_Delete';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_Link_Type_Read = {
  __typename?: 'HeaderMenuDocAccessFields_links_link_type_Read';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_Link_Type_Update = {
  __typename?: 'HeaderMenuDocAccessFields_links_link_type_Update';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_Link_Url = {
  __typename?: 'HeaderMenuDocAccessFields_links_link_url';
  create?: Maybe<HeaderMenuDocAccessFields_Links_Link_Url_Create>;
  delete?: Maybe<HeaderMenuDocAccessFields_Links_Link_Url_Delete>;
  read?: Maybe<HeaderMenuDocAccessFields_Links_Link_Url_Read>;
  update?: Maybe<HeaderMenuDocAccessFields_Links_Link_Url_Update>;
};

export type HeaderMenuDocAccessFields_Links_Link_Url_Create = {
  __typename?: 'HeaderMenuDocAccessFields_links_link_url_Create';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_Link_Url_Delete = {
  __typename?: 'HeaderMenuDocAccessFields_links_link_url_Delete';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_Link_Url_Read = {
  __typename?: 'HeaderMenuDocAccessFields_links_link_url_Read';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_Link_Url_Update = {
  __typename?: 'HeaderMenuDocAccessFields_links_link_url_Update';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenu = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu';
  create?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Create>;
  delete?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Delete>;
  fields?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Fields>;
  read?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Read>;
  update?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Update>;
};

export type HeaderMenuDocAccessFields_Links_SubMenuEnabled = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenuEnabled';
  create?: Maybe<HeaderMenuDocAccessFields_Links_SubMenuEnabled_Create>;
  delete?: Maybe<HeaderMenuDocAccessFields_Links_SubMenuEnabled_Delete>;
  read?: Maybe<HeaderMenuDocAccessFields_Links_SubMenuEnabled_Read>;
  update?: Maybe<HeaderMenuDocAccessFields_Links_SubMenuEnabled_Update>;
};

export type HeaderMenuDocAccessFields_Links_SubMenuEnabled_Create = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenuEnabled_Create';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenuEnabled_Delete = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenuEnabled_Delete';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenuEnabled_Read = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenuEnabled_Read';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenuEnabled_Update = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenuEnabled_Update';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Create = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_Create';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Delete = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_Delete';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Fields = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_Fields';
  cta?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Cta>;
  ctaEnabled?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_CtaEnabled>;
  links?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Links>;
  title?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Title>;
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Read = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_Read';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Update = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_Update';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Cta = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_cta';
  create?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Cta_Create>;
  delete?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Cta_Delete>;
  fields?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Cta_Fields>;
  read?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Cta_Read>;
  update?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Cta_Update>;
};

export type HeaderMenuDocAccessFields_Links_SubMenu_CtaEnabled = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_ctaEnabled';
  create?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_CtaEnabled_Create>;
  delete?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_CtaEnabled_Delete>;
  read?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_CtaEnabled_Read>;
  update?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_CtaEnabled_Update>;
};

export type HeaderMenuDocAccessFields_Links_SubMenu_CtaEnabled_Create = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_ctaEnabled_Create';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenu_CtaEnabled_Delete = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_ctaEnabled_Delete';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenu_CtaEnabled_Read = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_ctaEnabled_Read';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenu_CtaEnabled_Update = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_ctaEnabled_Update';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Cta_Create = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_cta_Create';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Cta_Delete = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_cta_Delete';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Cta_Fields = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_cta_Fields';
  description?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Cta_Description>;
  link?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Cta_Link>;
  tagColor?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Cta_TagColor>;
  tagText?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Cta_TagText>;
  title?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Cta_Title>;
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Cta_Read = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_cta_Read';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Cta_Update = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_cta_Update';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Cta_Description = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_cta_description';
  create?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Cta_Description_Create>;
  delete?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Cta_Description_Delete>;
  read?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Cta_Description_Read>;
  update?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Cta_Description_Update>;
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Cta_Description_Create = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_cta_description_Create';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Cta_Description_Delete = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_cta_description_Delete';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Cta_Description_Read = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_cta_description_Read';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Cta_Description_Update = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_cta_description_Update';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Cta_Link = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_cta_link';
  create?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Cta_Link_Create>;
  delete?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Cta_Link_Delete>;
  fields?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Cta_Link_Fields>;
  read?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Cta_Link_Read>;
  update?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Cta_Link_Update>;
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Cta_Link_Create = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_cta_link_Create';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Cta_Link_Delete = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_cta_link_Delete';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Cta_Link_Fields = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_cta_link_Fields';
  reference?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Cta_Link_Reference>;
  type?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Cta_Link_Type>;
  url?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Cta_Link_Url>;
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Cta_Link_Read = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_cta_link_Read';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Cta_Link_Update = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_cta_link_Update';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Cta_Link_Reference = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_cta_link_reference';
  create?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Cta_Link_Reference_Create>;
  delete?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Cta_Link_Reference_Delete>;
  read?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Cta_Link_Reference_Read>;
  update?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Cta_Link_Reference_Update>;
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Cta_Link_Reference_Create = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_cta_link_reference_Create';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Cta_Link_Reference_Delete = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_cta_link_reference_Delete';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Cta_Link_Reference_Read = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_cta_link_reference_Read';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Cta_Link_Reference_Update = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_cta_link_reference_Update';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Cta_Link_Type = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_cta_link_type';
  create?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Cta_Link_Type_Create>;
  delete?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Cta_Link_Type_Delete>;
  read?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Cta_Link_Type_Read>;
  update?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Cta_Link_Type_Update>;
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Cta_Link_Type_Create = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_cta_link_type_Create';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Cta_Link_Type_Delete = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_cta_link_type_Delete';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Cta_Link_Type_Read = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_cta_link_type_Read';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Cta_Link_Type_Update = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_cta_link_type_Update';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Cta_Link_Url = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_cta_link_url';
  create?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Cta_Link_Url_Create>;
  delete?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Cta_Link_Url_Delete>;
  read?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Cta_Link_Url_Read>;
  update?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Cta_Link_Url_Update>;
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Cta_Link_Url_Create = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_cta_link_url_Create';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Cta_Link_Url_Delete = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_cta_link_url_Delete';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Cta_Link_Url_Read = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_cta_link_url_Read';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Cta_Link_Url_Update = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_cta_link_url_Update';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Cta_TagColor = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_cta_tagColor';
  create?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Cta_TagColor_Create>;
  delete?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Cta_TagColor_Delete>;
  read?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Cta_TagColor_Read>;
  update?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Cta_TagColor_Update>;
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Cta_TagColor_Create = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_cta_tagColor_Create';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Cta_TagColor_Delete = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_cta_tagColor_Delete';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Cta_TagColor_Read = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_cta_tagColor_Read';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Cta_TagColor_Update = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_cta_tagColor_Update';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Cta_TagText = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_cta_tagText';
  create?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Cta_TagText_Create>;
  delete?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Cta_TagText_Delete>;
  read?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Cta_TagText_Read>;
  update?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Cta_TagText_Update>;
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Cta_TagText_Create = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_cta_tagText_Create';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Cta_TagText_Delete = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_cta_tagText_Delete';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Cta_TagText_Read = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_cta_tagText_Read';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Cta_TagText_Update = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_cta_tagText_Update';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Cta_Title = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_cta_title';
  create?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Cta_Title_Create>;
  delete?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Cta_Title_Delete>;
  read?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Cta_Title_Read>;
  update?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Cta_Title_Update>;
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Cta_Title_Create = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_cta_title_Create';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Cta_Title_Delete = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_cta_title_Delete';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Cta_Title_Read = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_cta_title_Read';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Cta_Title_Update = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_cta_title_Update';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Links = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_links';
  create?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Links_Create>;
  delete?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Links_Delete>;
  fields?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Links_Fields>;
  read?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Links_Read>;
  update?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Links_Update>;
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Links_Create = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_links_Create';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Links_Delete = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_links_Delete';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Links_Fields = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_links_Fields';
  excerpt?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Links_Excerpt>;
  id?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Links_Id>;
  link?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Links_Link>;
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Links_Read = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_links_Read';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Links_Update = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_links_Update';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Links_Excerpt = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_links_excerpt';
  create?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Links_Excerpt_Create>;
  delete?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Links_Excerpt_Delete>;
  read?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Links_Excerpt_Read>;
  update?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Links_Excerpt_Update>;
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Links_Excerpt_Create = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_links_excerpt_Create';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Links_Excerpt_Delete = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_links_excerpt_Delete';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Links_Excerpt_Read = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_links_excerpt_Read';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Links_Excerpt_Update = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_links_excerpt_Update';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Links_Id = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_links_id';
  create?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Links_Id_Create>;
  delete?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Links_Id_Delete>;
  read?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Links_Id_Read>;
  update?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Links_Id_Update>;
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Links_Id_Create = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_links_id_Create';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Links_Id_Delete = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_links_id_Delete';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Links_Id_Read = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_links_id_Read';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Links_Id_Update = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_links_id_Update';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Links_Link = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_links_link';
  create?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Links_Link_Create>;
  delete?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Links_Link_Delete>;
  fields?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Links_Link_Fields>;
  read?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Links_Link_Read>;
  update?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Links_Link_Update>;
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Links_Link_Create = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_links_link_Create';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Links_Link_Delete = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_links_link_Delete';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Links_Link_Fields = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_links_link_Fields';
  label?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Links_Link_Label>;
  reference?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Links_Link_Reference>;
  type?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Links_Link_Type>;
  url?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Links_Link_Url>;
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Links_Link_Read = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_links_link_Read';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Links_Link_Update = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_links_link_Update';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Links_Link_Label = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_links_link_label';
  create?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Links_Link_Label_Create>;
  delete?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Links_Link_Label_Delete>;
  read?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Links_Link_Label_Read>;
  update?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Links_Link_Label_Update>;
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Links_Link_Label_Create = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_links_link_label_Create';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Links_Link_Label_Delete = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_links_link_label_Delete';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Links_Link_Label_Read = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_links_link_label_Read';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Links_Link_Label_Update = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_links_link_label_Update';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Links_Link_Reference = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_links_link_reference';
  create?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Links_Link_Reference_Create>;
  delete?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Links_Link_Reference_Delete>;
  read?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Links_Link_Reference_Read>;
  update?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Links_Link_Reference_Update>;
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Links_Link_Reference_Create = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_links_link_reference_Create';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Links_Link_Reference_Delete = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_links_link_reference_Delete';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Links_Link_Reference_Read = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_links_link_reference_Read';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Links_Link_Reference_Update = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_links_link_reference_Update';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Links_Link_Type = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_links_link_type';
  create?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Links_Link_Type_Create>;
  delete?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Links_Link_Type_Delete>;
  read?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Links_Link_Type_Read>;
  update?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Links_Link_Type_Update>;
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Links_Link_Type_Create = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_links_link_type_Create';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Links_Link_Type_Delete = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_links_link_type_Delete';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Links_Link_Type_Read = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_links_link_type_Read';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Links_Link_Type_Update = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_links_link_type_Update';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Links_Link_Url = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_links_link_url';
  create?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Links_Link_Url_Create>;
  delete?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Links_Link_Url_Delete>;
  read?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Links_Link_Url_Read>;
  update?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Links_Link_Url_Update>;
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Links_Link_Url_Create = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_links_link_url_Create';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Links_Link_Url_Delete = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_links_link_url_Delete';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Links_Link_Url_Read = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_links_link_url_Read';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Links_Link_Url_Update = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_links_link_url_Update';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Title = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_title';
  create?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Title_Create>;
  delete?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Title_Delete>;
  read?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Title_Read>;
  update?: Maybe<HeaderMenuDocAccessFields_Links_SubMenu_Title_Update>;
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Title_Create = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_title_Create';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Title_Delete = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_title_Delete';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Title_Read = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_title_Read';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_Links_SubMenu_Title_Update = {
  __typename?: 'HeaderMenuDocAccessFields_links_subMenu_title_Update';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_UpdatedAt = {
  __typename?: 'HeaderMenuDocAccessFields_updatedAt';
  create?: Maybe<HeaderMenuDocAccessFields_UpdatedAt_Create>;
  delete?: Maybe<HeaderMenuDocAccessFields_UpdatedAt_Delete>;
  read?: Maybe<HeaderMenuDocAccessFields_UpdatedAt_Read>;
  update?: Maybe<HeaderMenuDocAccessFields_UpdatedAt_Update>;
};

export type HeaderMenuDocAccessFields_UpdatedAt_Create = {
  __typename?: 'HeaderMenuDocAccessFields_updatedAt_Create';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_UpdatedAt_Delete = {
  __typename?: 'HeaderMenuDocAccessFields_updatedAt_Delete';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_UpdatedAt_Read = {
  __typename?: 'HeaderMenuDocAccessFields_updatedAt_Read';
  permission: Scalars['Boolean'];
};

export type HeaderMenuDocAccessFields_UpdatedAt_Update = {
  __typename?: 'HeaderMenuDocAccessFields_updatedAt_Update';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields = {
  __typename?: 'HeaderMenuFields';
  createdAt?: Maybe<HeaderMenuFields_CreatedAt>;
  links?: Maybe<HeaderMenuFields_Links>;
  updatedAt?: Maybe<HeaderMenuFields_UpdatedAt>;
};

export type HeaderMenuFields_CreatedAt = {
  __typename?: 'HeaderMenuFields_createdAt';
  create?: Maybe<HeaderMenuFields_CreatedAt_Create>;
  delete?: Maybe<HeaderMenuFields_CreatedAt_Delete>;
  read?: Maybe<HeaderMenuFields_CreatedAt_Read>;
  update?: Maybe<HeaderMenuFields_CreatedAt_Update>;
};

export type HeaderMenuFields_CreatedAt_Create = {
  __typename?: 'HeaderMenuFields_createdAt_Create';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_CreatedAt_Delete = {
  __typename?: 'HeaderMenuFields_createdAt_Delete';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_CreatedAt_Read = {
  __typename?: 'HeaderMenuFields_createdAt_Read';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_CreatedAt_Update = {
  __typename?: 'HeaderMenuFields_createdAt_Update';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links = {
  __typename?: 'HeaderMenuFields_links';
  create?: Maybe<HeaderMenuFields_Links_Create>;
  delete?: Maybe<HeaderMenuFields_Links_Delete>;
  fields?: Maybe<HeaderMenuFields_Links_Fields>;
  read?: Maybe<HeaderMenuFields_Links_Read>;
  update?: Maybe<HeaderMenuFields_Links_Update>;
};

export type HeaderMenuFields_Links_Create = {
  __typename?: 'HeaderMenuFields_links_Create';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_Delete = {
  __typename?: 'HeaderMenuFields_links_Delete';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_Fields = {
  __typename?: 'HeaderMenuFields_links_Fields';
  id?: Maybe<HeaderMenuFields_Links_Id>;
  link?: Maybe<HeaderMenuFields_Links_Link>;
  subMenu?: Maybe<HeaderMenuFields_Links_SubMenu>;
  subMenuEnabled?: Maybe<HeaderMenuFields_Links_SubMenuEnabled>;
};

export type HeaderMenuFields_Links_Read = {
  __typename?: 'HeaderMenuFields_links_Read';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_Update = {
  __typename?: 'HeaderMenuFields_links_Update';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_Id = {
  __typename?: 'HeaderMenuFields_links_id';
  create?: Maybe<HeaderMenuFields_Links_Id_Create>;
  delete?: Maybe<HeaderMenuFields_Links_Id_Delete>;
  read?: Maybe<HeaderMenuFields_Links_Id_Read>;
  update?: Maybe<HeaderMenuFields_Links_Id_Update>;
};

export type HeaderMenuFields_Links_Id_Create = {
  __typename?: 'HeaderMenuFields_links_id_Create';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_Id_Delete = {
  __typename?: 'HeaderMenuFields_links_id_Delete';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_Id_Read = {
  __typename?: 'HeaderMenuFields_links_id_Read';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_Id_Update = {
  __typename?: 'HeaderMenuFields_links_id_Update';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_Link = {
  __typename?: 'HeaderMenuFields_links_link';
  create?: Maybe<HeaderMenuFields_Links_Link_Create>;
  delete?: Maybe<HeaderMenuFields_Links_Link_Delete>;
  fields?: Maybe<HeaderMenuFields_Links_Link_Fields>;
  read?: Maybe<HeaderMenuFields_Links_Link_Read>;
  update?: Maybe<HeaderMenuFields_Links_Link_Update>;
};

export type HeaderMenuFields_Links_Link_Create = {
  __typename?: 'HeaderMenuFields_links_link_Create';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_Link_Delete = {
  __typename?: 'HeaderMenuFields_links_link_Delete';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_Link_Fields = {
  __typename?: 'HeaderMenuFields_links_link_Fields';
  label?: Maybe<HeaderMenuFields_Links_Link_Label>;
  reference?: Maybe<HeaderMenuFields_Links_Link_Reference>;
  type?: Maybe<HeaderMenuFields_Links_Link_Type>;
  url?: Maybe<HeaderMenuFields_Links_Link_Url>;
};

export type HeaderMenuFields_Links_Link_Read = {
  __typename?: 'HeaderMenuFields_links_link_Read';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_Link_Update = {
  __typename?: 'HeaderMenuFields_links_link_Update';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_Link_Label = {
  __typename?: 'HeaderMenuFields_links_link_label';
  create?: Maybe<HeaderMenuFields_Links_Link_Label_Create>;
  delete?: Maybe<HeaderMenuFields_Links_Link_Label_Delete>;
  read?: Maybe<HeaderMenuFields_Links_Link_Label_Read>;
  update?: Maybe<HeaderMenuFields_Links_Link_Label_Update>;
};

export type HeaderMenuFields_Links_Link_Label_Create = {
  __typename?: 'HeaderMenuFields_links_link_label_Create';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_Link_Label_Delete = {
  __typename?: 'HeaderMenuFields_links_link_label_Delete';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_Link_Label_Read = {
  __typename?: 'HeaderMenuFields_links_link_label_Read';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_Link_Label_Update = {
  __typename?: 'HeaderMenuFields_links_link_label_Update';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_Link_Reference = {
  __typename?: 'HeaderMenuFields_links_link_reference';
  create?: Maybe<HeaderMenuFields_Links_Link_Reference_Create>;
  delete?: Maybe<HeaderMenuFields_Links_Link_Reference_Delete>;
  read?: Maybe<HeaderMenuFields_Links_Link_Reference_Read>;
  update?: Maybe<HeaderMenuFields_Links_Link_Reference_Update>;
};

export type HeaderMenuFields_Links_Link_Reference_Create = {
  __typename?: 'HeaderMenuFields_links_link_reference_Create';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_Link_Reference_Delete = {
  __typename?: 'HeaderMenuFields_links_link_reference_Delete';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_Link_Reference_Read = {
  __typename?: 'HeaderMenuFields_links_link_reference_Read';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_Link_Reference_Update = {
  __typename?: 'HeaderMenuFields_links_link_reference_Update';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_Link_Type = {
  __typename?: 'HeaderMenuFields_links_link_type';
  create?: Maybe<HeaderMenuFields_Links_Link_Type_Create>;
  delete?: Maybe<HeaderMenuFields_Links_Link_Type_Delete>;
  read?: Maybe<HeaderMenuFields_Links_Link_Type_Read>;
  update?: Maybe<HeaderMenuFields_Links_Link_Type_Update>;
};

export type HeaderMenuFields_Links_Link_Type_Create = {
  __typename?: 'HeaderMenuFields_links_link_type_Create';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_Link_Type_Delete = {
  __typename?: 'HeaderMenuFields_links_link_type_Delete';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_Link_Type_Read = {
  __typename?: 'HeaderMenuFields_links_link_type_Read';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_Link_Type_Update = {
  __typename?: 'HeaderMenuFields_links_link_type_Update';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_Link_Url = {
  __typename?: 'HeaderMenuFields_links_link_url';
  create?: Maybe<HeaderMenuFields_Links_Link_Url_Create>;
  delete?: Maybe<HeaderMenuFields_Links_Link_Url_Delete>;
  read?: Maybe<HeaderMenuFields_Links_Link_Url_Read>;
  update?: Maybe<HeaderMenuFields_Links_Link_Url_Update>;
};

export type HeaderMenuFields_Links_Link_Url_Create = {
  __typename?: 'HeaderMenuFields_links_link_url_Create';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_Link_Url_Delete = {
  __typename?: 'HeaderMenuFields_links_link_url_Delete';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_Link_Url_Read = {
  __typename?: 'HeaderMenuFields_links_link_url_Read';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_Link_Url_Update = {
  __typename?: 'HeaderMenuFields_links_link_url_Update';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenu = {
  __typename?: 'HeaderMenuFields_links_subMenu';
  create?: Maybe<HeaderMenuFields_Links_SubMenu_Create>;
  delete?: Maybe<HeaderMenuFields_Links_SubMenu_Delete>;
  fields?: Maybe<HeaderMenuFields_Links_SubMenu_Fields>;
  read?: Maybe<HeaderMenuFields_Links_SubMenu_Read>;
  update?: Maybe<HeaderMenuFields_Links_SubMenu_Update>;
};

export type HeaderMenuFields_Links_SubMenuEnabled = {
  __typename?: 'HeaderMenuFields_links_subMenuEnabled';
  create?: Maybe<HeaderMenuFields_Links_SubMenuEnabled_Create>;
  delete?: Maybe<HeaderMenuFields_Links_SubMenuEnabled_Delete>;
  read?: Maybe<HeaderMenuFields_Links_SubMenuEnabled_Read>;
  update?: Maybe<HeaderMenuFields_Links_SubMenuEnabled_Update>;
};

export type HeaderMenuFields_Links_SubMenuEnabled_Create = {
  __typename?: 'HeaderMenuFields_links_subMenuEnabled_Create';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenuEnabled_Delete = {
  __typename?: 'HeaderMenuFields_links_subMenuEnabled_Delete';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenuEnabled_Read = {
  __typename?: 'HeaderMenuFields_links_subMenuEnabled_Read';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenuEnabled_Update = {
  __typename?: 'HeaderMenuFields_links_subMenuEnabled_Update';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenu_Create = {
  __typename?: 'HeaderMenuFields_links_subMenu_Create';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenu_Delete = {
  __typename?: 'HeaderMenuFields_links_subMenu_Delete';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenu_Fields = {
  __typename?: 'HeaderMenuFields_links_subMenu_Fields';
  cta?: Maybe<HeaderMenuFields_Links_SubMenu_Cta>;
  ctaEnabled?: Maybe<HeaderMenuFields_Links_SubMenu_CtaEnabled>;
  links?: Maybe<HeaderMenuFields_Links_SubMenu_Links>;
  title?: Maybe<HeaderMenuFields_Links_SubMenu_Title>;
};

export type HeaderMenuFields_Links_SubMenu_Read = {
  __typename?: 'HeaderMenuFields_links_subMenu_Read';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenu_Update = {
  __typename?: 'HeaderMenuFields_links_subMenu_Update';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenu_Cta = {
  __typename?: 'HeaderMenuFields_links_subMenu_cta';
  create?: Maybe<HeaderMenuFields_Links_SubMenu_Cta_Create>;
  delete?: Maybe<HeaderMenuFields_Links_SubMenu_Cta_Delete>;
  fields?: Maybe<HeaderMenuFields_Links_SubMenu_Cta_Fields>;
  read?: Maybe<HeaderMenuFields_Links_SubMenu_Cta_Read>;
  update?: Maybe<HeaderMenuFields_Links_SubMenu_Cta_Update>;
};

export type HeaderMenuFields_Links_SubMenu_CtaEnabled = {
  __typename?: 'HeaderMenuFields_links_subMenu_ctaEnabled';
  create?: Maybe<HeaderMenuFields_Links_SubMenu_CtaEnabled_Create>;
  delete?: Maybe<HeaderMenuFields_Links_SubMenu_CtaEnabled_Delete>;
  read?: Maybe<HeaderMenuFields_Links_SubMenu_CtaEnabled_Read>;
  update?: Maybe<HeaderMenuFields_Links_SubMenu_CtaEnabled_Update>;
};

export type HeaderMenuFields_Links_SubMenu_CtaEnabled_Create = {
  __typename?: 'HeaderMenuFields_links_subMenu_ctaEnabled_Create';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenu_CtaEnabled_Delete = {
  __typename?: 'HeaderMenuFields_links_subMenu_ctaEnabled_Delete';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenu_CtaEnabled_Read = {
  __typename?: 'HeaderMenuFields_links_subMenu_ctaEnabled_Read';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenu_CtaEnabled_Update = {
  __typename?: 'HeaderMenuFields_links_subMenu_ctaEnabled_Update';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenu_Cta_Create = {
  __typename?: 'HeaderMenuFields_links_subMenu_cta_Create';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenu_Cta_Delete = {
  __typename?: 'HeaderMenuFields_links_subMenu_cta_Delete';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenu_Cta_Fields = {
  __typename?: 'HeaderMenuFields_links_subMenu_cta_Fields';
  description?: Maybe<HeaderMenuFields_Links_SubMenu_Cta_Description>;
  link?: Maybe<HeaderMenuFields_Links_SubMenu_Cta_Link>;
  tagColor?: Maybe<HeaderMenuFields_Links_SubMenu_Cta_TagColor>;
  tagText?: Maybe<HeaderMenuFields_Links_SubMenu_Cta_TagText>;
  title?: Maybe<HeaderMenuFields_Links_SubMenu_Cta_Title>;
};

export type HeaderMenuFields_Links_SubMenu_Cta_Read = {
  __typename?: 'HeaderMenuFields_links_subMenu_cta_Read';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenu_Cta_Update = {
  __typename?: 'HeaderMenuFields_links_subMenu_cta_Update';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenu_Cta_Description = {
  __typename?: 'HeaderMenuFields_links_subMenu_cta_description';
  create?: Maybe<HeaderMenuFields_Links_SubMenu_Cta_Description_Create>;
  delete?: Maybe<HeaderMenuFields_Links_SubMenu_Cta_Description_Delete>;
  read?: Maybe<HeaderMenuFields_Links_SubMenu_Cta_Description_Read>;
  update?: Maybe<HeaderMenuFields_Links_SubMenu_Cta_Description_Update>;
};

export type HeaderMenuFields_Links_SubMenu_Cta_Description_Create = {
  __typename?: 'HeaderMenuFields_links_subMenu_cta_description_Create';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenu_Cta_Description_Delete = {
  __typename?: 'HeaderMenuFields_links_subMenu_cta_description_Delete';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenu_Cta_Description_Read = {
  __typename?: 'HeaderMenuFields_links_subMenu_cta_description_Read';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenu_Cta_Description_Update = {
  __typename?: 'HeaderMenuFields_links_subMenu_cta_description_Update';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenu_Cta_Link = {
  __typename?: 'HeaderMenuFields_links_subMenu_cta_link';
  create?: Maybe<HeaderMenuFields_Links_SubMenu_Cta_Link_Create>;
  delete?: Maybe<HeaderMenuFields_Links_SubMenu_Cta_Link_Delete>;
  fields?: Maybe<HeaderMenuFields_Links_SubMenu_Cta_Link_Fields>;
  read?: Maybe<HeaderMenuFields_Links_SubMenu_Cta_Link_Read>;
  update?: Maybe<HeaderMenuFields_Links_SubMenu_Cta_Link_Update>;
};

export type HeaderMenuFields_Links_SubMenu_Cta_Link_Create = {
  __typename?: 'HeaderMenuFields_links_subMenu_cta_link_Create';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenu_Cta_Link_Delete = {
  __typename?: 'HeaderMenuFields_links_subMenu_cta_link_Delete';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenu_Cta_Link_Fields = {
  __typename?: 'HeaderMenuFields_links_subMenu_cta_link_Fields';
  reference?: Maybe<HeaderMenuFields_Links_SubMenu_Cta_Link_Reference>;
  type?: Maybe<HeaderMenuFields_Links_SubMenu_Cta_Link_Type>;
  url?: Maybe<HeaderMenuFields_Links_SubMenu_Cta_Link_Url>;
};

export type HeaderMenuFields_Links_SubMenu_Cta_Link_Read = {
  __typename?: 'HeaderMenuFields_links_subMenu_cta_link_Read';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenu_Cta_Link_Update = {
  __typename?: 'HeaderMenuFields_links_subMenu_cta_link_Update';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenu_Cta_Link_Reference = {
  __typename?: 'HeaderMenuFields_links_subMenu_cta_link_reference';
  create?: Maybe<HeaderMenuFields_Links_SubMenu_Cta_Link_Reference_Create>;
  delete?: Maybe<HeaderMenuFields_Links_SubMenu_Cta_Link_Reference_Delete>;
  read?: Maybe<HeaderMenuFields_Links_SubMenu_Cta_Link_Reference_Read>;
  update?: Maybe<HeaderMenuFields_Links_SubMenu_Cta_Link_Reference_Update>;
};

export type HeaderMenuFields_Links_SubMenu_Cta_Link_Reference_Create = {
  __typename?: 'HeaderMenuFields_links_subMenu_cta_link_reference_Create';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenu_Cta_Link_Reference_Delete = {
  __typename?: 'HeaderMenuFields_links_subMenu_cta_link_reference_Delete';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenu_Cta_Link_Reference_Read = {
  __typename?: 'HeaderMenuFields_links_subMenu_cta_link_reference_Read';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenu_Cta_Link_Reference_Update = {
  __typename?: 'HeaderMenuFields_links_subMenu_cta_link_reference_Update';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenu_Cta_Link_Type = {
  __typename?: 'HeaderMenuFields_links_subMenu_cta_link_type';
  create?: Maybe<HeaderMenuFields_Links_SubMenu_Cta_Link_Type_Create>;
  delete?: Maybe<HeaderMenuFields_Links_SubMenu_Cta_Link_Type_Delete>;
  read?: Maybe<HeaderMenuFields_Links_SubMenu_Cta_Link_Type_Read>;
  update?: Maybe<HeaderMenuFields_Links_SubMenu_Cta_Link_Type_Update>;
};

export type HeaderMenuFields_Links_SubMenu_Cta_Link_Type_Create = {
  __typename?: 'HeaderMenuFields_links_subMenu_cta_link_type_Create';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenu_Cta_Link_Type_Delete = {
  __typename?: 'HeaderMenuFields_links_subMenu_cta_link_type_Delete';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenu_Cta_Link_Type_Read = {
  __typename?: 'HeaderMenuFields_links_subMenu_cta_link_type_Read';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenu_Cta_Link_Type_Update = {
  __typename?: 'HeaderMenuFields_links_subMenu_cta_link_type_Update';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenu_Cta_Link_Url = {
  __typename?: 'HeaderMenuFields_links_subMenu_cta_link_url';
  create?: Maybe<HeaderMenuFields_Links_SubMenu_Cta_Link_Url_Create>;
  delete?: Maybe<HeaderMenuFields_Links_SubMenu_Cta_Link_Url_Delete>;
  read?: Maybe<HeaderMenuFields_Links_SubMenu_Cta_Link_Url_Read>;
  update?: Maybe<HeaderMenuFields_Links_SubMenu_Cta_Link_Url_Update>;
};

export type HeaderMenuFields_Links_SubMenu_Cta_Link_Url_Create = {
  __typename?: 'HeaderMenuFields_links_subMenu_cta_link_url_Create';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenu_Cta_Link_Url_Delete = {
  __typename?: 'HeaderMenuFields_links_subMenu_cta_link_url_Delete';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenu_Cta_Link_Url_Read = {
  __typename?: 'HeaderMenuFields_links_subMenu_cta_link_url_Read';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenu_Cta_Link_Url_Update = {
  __typename?: 'HeaderMenuFields_links_subMenu_cta_link_url_Update';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenu_Cta_TagColor = {
  __typename?: 'HeaderMenuFields_links_subMenu_cta_tagColor';
  create?: Maybe<HeaderMenuFields_Links_SubMenu_Cta_TagColor_Create>;
  delete?: Maybe<HeaderMenuFields_Links_SubMenu_Cta_TagColor_Delete>;
  read?: Maybe<HeaderMenuFields_Links_SubMenu_Cta_TagColor_Read>;
  update?: Maybe<HeaderMenuFields_Links_SubMenu_Cta_TagColor_Update>;
};

export type HeaderMenuFields_Links_SubMenu_Cta_TagColor_Create = {
  __typename?: 'HeaderMenuFields_links_subMenu_cta_tagColor_Create';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenu_Cta_TagColor_Delete = {
  __typename?: 'HeaderMenuFields_links_subMenu_cta_tagColor_Delete';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenu_Cta_TagColor_Read = {
  __typename?: 'HeaderMenuFields_links_subMenu_cta_tagColor_Read';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenu_Cta_TagColor_Update = {
  __typename?: 'HeaderMenuFields_links_subMenu_cta_tagColor_Update';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenu_Cta_TagText = {
  __typename?: 'HeaderMenuFields_links_subMenu_cta_tagText';
  create?: Maybe<HeaderMenuFields_Links_SubMenu_Cta_TagText_Create>;
  delete?: Maybe<HeaderMenuFields_Links_SubMenu_Cta_TagText_Delete>;
  read?: Maybe<HeaderMenuFields_Links_SubMenu_Cta_TagText_Read>;
  update?: Maybe<HeaderMenuFields_Links_SubMenu_Cta_TagText_Update>;
};

export type HeaderMenuFields_Links_SubMenu_Cta_TagText_Create = {
  __typename?: 'HeaderMenuFields_links_subMenu_cta_tagText_Create';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenu_Cta_TagText_Delete = {
  __typename?: 'HeaderMenuFields_links_subMenu_cta_tagText_Delete';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenu_Cta_TagText_Read = {
  __typename?: 'HeaderMenuFields_links_subMenu_cta_tagText_Read';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenu_Cta_TagText_Update = {
  __typename?: 'HeaderMenuFields_links_subMenu_cta_tagText_Update';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenu_Cta_Title = {
  __typename?: 'HeaderMenuFields_links_subMenu_cta_title';
  create?: Maybe<HeaderMenuFields_Links_SubMenu_Cta_Title_Create>;
  delete?: Maybe<HeaderMenuFields_Links_SubMenu_Cta_Title_Delete>;
  read?: Maybe<HeaderMenuFields_Links_SubMenu_Cta_Title_Read>;
  update?: Maybe<HeaderMenuFields_Links_SubMenu_Cta_Title_Update>;
};

export type HeaderMenuFields_Links_SubMenu_Cta_Title_Create = {
  __typename?: 'HeaderMenuFields_links_subMenu_cta_title_Create';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenu_Cta_Title_Delete = {
  __typename?: 'HeaderMenuFields_links_subMenu_cta_title_Delete';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenu_Cta_Title_Read = {
  __typename?: 'HeaderMenuFields_links_subMenu_cta_title_Read';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenu_Cta_Title_Update = {
  __typename?: 'HeaderMenuFields_links_subMenu_cta_title_Update';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenu_Links = {
  __typename?: 'HeaderMenuFields_links_subMenu_links';
  create?: Maybe<HeaderMenuFields_Links_SubMenu_Links_Create>;
  delete?: Maybe<HeaderMenuFields_Links_SubMenu_Links_Delete>;
  fields?: Maybe<HeaderMenuFields_Links_SubMenu_Links_Fields>;
  read?: Maybe<HeaderMenuFields_Links_SubMenu_Links_Read>;
  update?: Maybe<HeaderMenuFields_Links_SubMenu_Links_Update>;
};

export type HeaderMenuFields_Links_SubMenu_Links_Create = {
  __typename?: 'HeaderMenuFields_links_subMenu_links_Create';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenu_Links_Delete = {
  __typename?: 'HeaderMenuFields_links_subMenu_links_Delete';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenu_Links_Fields = {
  __typename?: 'HeaderMenuFields_links_subMenu_links_Fields';
  excerpt?: Maybe<HeaderMenuFields_Links_SubMenu_Links_Excerpt>;
  id?: Maybe<HeaderMenuFields_Links_SubMenu_Links_Id>;
  link?: Maybe<HeaderMenuFields_Links_SubMenu_Links_Link>;
};

export type HeaderMenuFields_Links_SubMenu_Links_Read = {
  __typename?: 'HeaderMenuFields_links_subMenu_links_Read';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenu_Links_Update = {
  __typename?: 'HeaderMenuFields_links_subMenu_links_Update';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenu_Links_Excerpt = {
  __typename?: 'HeaderMenuFields_links_subMenu_links_excerpt';
  create?: Maybe<HeaderMenuFields_Links_SubMenu_Links_Excerpt_Create>;
  delete?: Maybe<HeaderMenuFields_Links_SubMenu_Links_Excerpt_Delete>;
  read?: Maybe<HeaderMenuFields_Links_SubMenu_Links_Excerpt_Read>;
  update?: Maybe<HeaderMenuFields_Links_SubMenu_Links_Excerpt_Update>;
};

export type HeaderMenuFields_Links_SubMenu_Links_Excerpt_Create = {
  __typename?: 'HeaderMenuFields_links_subMenu_links_excerpt_Create';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenu_Links_Excerpt_Delete = {
  __typename?: 'HeaderMenuFields_links_subMenu_links_excerpt_Delete';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenu_Links_Excerpt_Read = {
  __typename?: 'HeaderMenuFields_links_subMenu_links_excerpt_Read';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenu_Links_Excerpt_Update = {
  __typename?: 'HeaderMenuFields_links_subMenu_links_excerpt_Update';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenu_Links_Id = {
  __typename?: 'HeaderMenuFields_links_subMenu_links_id';
  create?: Maybe<HeaderMenuFields_Links_SubMenu_Links_Id_Create>;
  delete?: Maybe<HeaderMenuFields_Links_SubMenu_Links_Id_Delete>;
  read?: Maybe<HeaderMenuFields_Links_SubMenu_Links_Id_Read>;
  update?: Maybe<HeaderMenuFields_Links_SubMenu_Links_Id_Update>;
};

export type HeaderMenuFields_Links_SubMenu_Links_Id_Create = {
  __typename?: 'HeaderMenuFields_links_subMenu_links_id_Create';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenu_Links_Id_Delete = {
  __typename?: 'HeaderMenuFields_links_subMenu_links_id_Delete';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenu_Links_Id_Read = {
  __typename?: 'HeaderMenuFields_links_subMenu_links_id_Read';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenu_Links_Id_Update = {
  __typename?: 'HeaderMenuFields_links_subMenu_links_id_Update';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenu_Links_Link = {
  __typename?: 'HeaderMenuFields_links_subMenu_links_link';
  create?: Maybe<HeaderMenuFields_Links_SubMenu_Links_Link_Create>;
  delete?: Maybe<HeaderMenuFields_Links_SubMenu_Links_Link_Delete>;
  fields?: Maybe<HeaderMenuFields_Links_SubMenu_Links_Link_Fields>;
  read?: Maybe<HeaderMenuFields_Links_SubMenu_Links_Link_Read>;
  update?: Maybe<HeaderMenuFields_Links_SubMenu_Links_Link_Update>;
};

export type HeaderMenuFields_Links_SubMenu_Links_Link_Create = {
  __typename?: 'HeaderMenuFields_links_subMenu_links_link_Create';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenu_Links_Link_Delete = {
  __typename?: 'HeaderMenuFields_links_subMenu_links_link_Delete';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenu_Links_Link_Fields = {
  __typename?: 'HeaderMenuFields_links_subMenu_links_link_Fields';
  label?: Maybe<HeaderMenuFields_Links_SubMenu_Links_Link_Label>;
  reference?: Maybe<HeaderMenuFields_Links_SubMenu_Links_Link_Reference>;
  type?: Maybe<HeaderMenuFields_Links_SubMenu_Links_Link_Type>;
  url?: Maybe<HeaderMenuFields_Links_SubMenu_Links_Link_Url>;
};

export type HeaderMenuFields_Links_SubMenu_Links_Link_Read = {
  __typename?: 'HeaderMenuFields_links_subMenu_links_link_Read';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenu_Links_Link_Update = {
  __typename?: 'HeaderMenuFields_links_subMenu_links_link_Update';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenu_Links_Link_Label = {
  __typename?: 'HeaderMenuFields_links_subMenu_links_link_label';
  create?: Maybe<HeaderMenuFields_Links_SubMenu_Links_Link_Label_Create>;
  delete?: Maybe<HeaderMenuFields_Links_SubMenu_Links_Link_Label_Delete>;
  read?: Maybe<HeaderMenuFields_Links_SubMenu_Links_Link_Label_Read>;
  update?: Maybe<HeaderMenuFields_Links_SubMenu_Links_Link_Label_Update>;
};

export type HeaderMenuFields_Links_SubMenu_Links_Link_Label_Create = {
  __typename?: 'HeaderMenuFields_links_subMenu_links_link_label_Create';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenu_Links_Link_Label_Delete = {
  __typename?: 'HeaderMenuFields_links_subMenu_links_link_label_Delete';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenu_Links_Link_Label_Read = {
  __typename?: 'HeaderMenuFields_links_subMenu_links_link_label_Read';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenu_Links_Link_Label_Update = {
  __typename?: 'HeaderMenuFields_links_subMenu_links_link_label_Update';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenu_Links_Link_Reference = {
  __typename?: 'HeaderMenuFields_links_subMenu_links_link_reference';
  create?: Maybe<HeaderMenuFields_Links_SubMenu_Links_Link_Reference_Create>;
  delete?: Maybe<HeaderMenuFields_Links_SubMenu_Links_Link_Reference_Delete>;
  read?: Maybe<HeaderMenuFields_Links_SubMenu_Links_Link_Reference_Read>;
  update?: Maybe<HeaderMenuFields_Links_SubMenu_Links_Link_Reference_Update>;
};

export type HeaderMenuFields_Links_SubMenu_Links_Link_Reference_Create = {
  __typename?: 'HeaderMenuFields_links_subMenu_links_link_reference_Create';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenu_Links_Link_Reference_Delete = {
  __typename?: 'HeaderMenuFields_links_subMenu_links_link_reference_Delete';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenu_Links_Link_Reference_Read = {
  __typename?: 'HeaderMenuFields_links_subMenu_links_link_reference_Read';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenu_Links_Link_Reference_Update = {
  __typename?: 'HeaderMenuFields_links_subMenu_links_link_reference_Update';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenu_Links_Link_Type = {
  __typename?: 'HeaderMenuFields_links_subMenu_links_link_type';
  create?: Maybe<HeaderMenuFields_Links_SubMenu_Links_Link_Type_Create>;
  delete?: Maybe<HeaderMenuFields_Links_SubMenu_Links_Link_Type_Delete>;
  read?: Maybe<HeaderMenuFields_Links_SubMenu_Links_Link_Type_Read>;
  update?: Maybe<HeaderMenuFields_Links_SubMenu_Links_Link_Type_Update>;
};

export type HeaderMenuFields_Links_SubMenu_Links_Link_Type_Create = {
  __typename?: 'HeaderMenuFields_links_subMenu_links_link_type_Create';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenu_Links_Link_Type_Delete = {
  __typename?: 'HeaderMenuFields_links_subMenu_links_link_type_Delete';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenu_Links_Link_Type_Read = {
  __typename?: 'HeaderMenuFields_links_subMenu_links_link_type_Read';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenu_Links_Link_Type_Update = {
  __typename?: 'HeaderMenuFields_links_subMenu_links_link_type_Update';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenu_Links_Link_Url = {
  __typename?: 'HeaderMenuFields_links_subMenu_links_link_url';
  create?: Maybe<HeaderMenuFields_Links_SubMenu_Links_Link_Url_Create>;
  delete?: Maybe<HeaderMenuFields_Links_SubMenu_Links_Link_Url_Delete>;
  read?: Maybe<HeaderMenuFields_Links_SubMenu_Links_Link_Url_Read>;
  update?: Maybe<HeaderMenuFields_Links_SubMenu_Links_Link_Url_Update>;
};

export type HeaderMenuFields_Links_SubMenu_Links_Link_Url_Create = {
  __typename?: 'HeaderMenuFields_links_subMenu_links_link_url_Create';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenu_Links_Link_Url_Delete = {
  __typename?: 'HeaderMenuFields_links_subMenu_links_link_url_Delete';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenu_Links_Link_Url_Read = {
  __typename?: 'HeaderMenuFields_links_subMenu_links_link_url_Read';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenu_Links_Link_Url_Update = {
  __typename?: 'HeaderMenuFields_links_subMenu_links_link_url_Update';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenu_Title = {
  __typename?: 'HeaderMenuFields_links_subMenu_title';
  create?: Maybe<HeaderMenuFields_Links_SubMenu_Title_Create>;
  delete?: Maybe<HeaderMenuFields_Links_SubMenu_Title_Delete>;
  read?: Maybe<HeaderMenuFields_Links_SubMenu_Title_Read>;
  update?: Maybe<HeaderMenuFields_Links_SubMenu_Title_Update>;
};

export type HeaderMenuFields_Links_SubMenu_Title_Create = {
  __typename?: 'HeaderMenuFields_links_subMenu_title_Create';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenu_Title_Delete = {
  __typename?: 'HeaderMenuFields_links_subMenu_title_Delete';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenu_Title_Read = {
  __typename?: 'HeaderMenuFields_links_subMenu_title_Read';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_Links_SubMenu_Title_Update = {
  __typename?: 'HeaderMenuFields_links_subMenu_title_Update';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_UpdatedAt = {
  __typename?: 'HeaderMenuFields_updatedAt';
  create?: Maybe<HeaderMenuFields_UpdatedAt_Create>;
  delete?: Maybe<HeaderMenuFields_UpdatedAt_Delete>;
  read?: Maybe<HeaderMenuFields_UpdatedAt_Read>;
  update?: Maybe<HeaderMenuFields_UpdatedAt_Update>;
};

export type HeaderMenuFields_UpdatedAt_Create = {
  __typename?: 'HeaderMenuFields_updatedAt_Create';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_UpdatedAt_Delete = {
  __typename?: 'HeaderMenuFields_updatedAt_Delete';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_UpdatedAt_Read = {
  __typename?: 'HeaderMenuFields_updatedAt_Read';
  permission: Scalars['Boolean'];
};

export type HeaderMenuFields_UpdatedAt_Update = {
  __typename?: 'HeaderMenuFields_updatedAt_Update';
  permission: Scalars['Boolean'];
};

export type HeaderMenuReadAccess = {
  __typename?: 'HeaderMenuReadAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type HeaderMenuReadDocAccess = {
  __typename?: 'HeaderMenuReadDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type HeaderMenuUpdateAccess = {
  __typename?: 'HeaderMenuUpdateAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type HeaderMenuUpdateDocAccess = {
  __typename?: 'HeaderMenuUpdateDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type HeaderMenu_Links = {
  __typename?: 'HeaderMenu_Links';
  id?: Maybe<Scalars['String']>;
  link?: Maybe<Link>;
  subMenu?: Maybe<HeaderMenu_Links_SubMenu>;
  subMenuEnabled?: Maybe<Scalars['Boolean']>;
};

export type HeaderMenu_Links_Link_ReferenceRelationshipInput = {
  relationTo?: InputMaybe<HeaderMenu_Links_Link_ReferenceRelationshipInputRelationTo>;
  value?: InputMaybe<Scalars['JSON']>;
};

export enum HeaderMenu_Links_Link_ReferenceRelationshipInputRelationTo {
  Article = 'article',
  LeadForm = 'lead_form',
  Page = 'page',
  Service = 'service'
}

export type HeaderMenu_Links_SubMenu = {
  __typename?: 'HeaderMenu_Links_SubMenu';
  cta?: Maybe<HeaderMenu_Links_SubMenu_Cta>;
  ctaEnabled?: Maybe<Scalars['Boolean']>;
  links?: Maybe<Array<HeaderMenu_Links_SubMenu_Links>>;
  title?: Maybe<Scalars['String']>;
};

export type HeaderMenu_Links_SubMenu_Cta = {
  __typename?: 'HeaderMenu_Links_SubMenu_Cta';
  description?: Maybe<Scalars['String']>;
  link?: Maybe<Link>;
  tagColor?: Maybe<HeaderMenu_Links_SubMenu_Cta_TagColor>;
  tagText?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type HeaderMenu_Links_SubMenu_Cta_Link_ReferenceRelationshipInput = {
  relationTo?: InputMaybe<HeaderMenu_Links_SubMenu_Cta_Link_ReferenceRelationshipInputRelationTo>;
  value?: InputMaybe<Scalars['JSON']>;
};

export enum HeaderMenu_Links_SubMenu_Cta_Link_ReferenceRelationshipInputRelationTo {
  Article = 'article',
  LeadForm = 'lead_form',
  Page = 'page',
  Service = 'service'
}

export enum HeaderMenu_Links_SubMenu_Cta_TagColor {
  Primary = 'primary',
  Secondary = 'secondary'
}

export type HeaderMenu_Links_SubMenu_Links = {
  __typename?: 'HeaderMenu_Links_SubMenu_Links';
  excerpt?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  link?: Maybe<Link>;
};

export type HeaderMenu_Links_SubMenu_Links_Link_ReferenceRelationshipInput = {
  relationTo?: InputMaybe<HeaderMenu_Links_SubMenu_Links_Link_ReferenceRelationshipInputRelationTo>;
  value?: InputMaybe<Scalars['JSON']>;
};

export enum HeaderMenu_Links_SubMenu_Links_Link_ReferenceRelationshipInputRelationTo {
  Article = 'article',
  LeadForm = 'lead_form',
  Page = 'page',
  Service = 'service'
}

export type HiddenBlock = {
  __typename?: 'HiddenBlock';
  createdAt?: Maybe<Scalars['DateTime']>;
  layout?: Maybe<HiddenBlock_Layout>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type HiddenBlock_Layout = {
  __typename?: 'HiddenBlock_Layout';
  blocks?: Maybe<Array<HiddenBlock_Layout_Blocks>>;
};

export type HiddenBlock_Layout_Blocks = ButtonLink | Countdown | CustomerReview | DynamicGreeting | Icon | ListWithIcon | RatingWidget;

export type HiddenBlocksDocAccessFields = {
  __typename?: 'HiddenBlocksDocAccessFields';
  createdAt?: Maybe<HiddenBlocksDocAccessFields_CreatedAt>;
  layout?: Maybe<HiddenBlocksDocAccessFields_Layout>;
  updatedAt?: Maybe<HiddenBlocksDocAccessFields_UpdatedAt>;
};

export type HiddenBlocksDocAccessFields_CreatedAt = {
  __typename?: 'HiddenBlocksDocAccessFields_createdAt';
  create?: Maybe<HiddenBlocksDocAccessFields_CreatedAt_Create>;
  delete?: Maybe<HiddenBlocksDocAccessFields_CreatedAt_Delete>;
  read?: Maybe<HiddenBlocksDocAccessFields_CreatedAt_Read>;
  update?: Maybe<HiddenBlocksDocAccessFields_CreatedAt_Update>;
};

export type HiddenBlocksDocAccessFields_CreatedAt_Create = {
  __typename?: 'HiddenBlocksDocAccessFields_createdAt_Create';
  permission: Scalars['Boolean'];
};

export type HiddenBlocksDocAccessFields_CreatedAt_Delete = {
  __typename?: 'HiddenBlocksDocAccessFields_createdAt_Delete';
  permission: Scalars['Boolean'];
};

export type HiddenBlocksDocAccessFields_CreatedAt_Read = {
  __typename?: 'HiddenBlocksDocAccessFields_createdAt_Read';
  permission: Scalars['Boolean'];
};

export type HiddenBlocksDocAccessFields_CreatedAt_Update = {
  __typename?: 'HiddenBlocksDocAccessFields_createdAt_Update';
  permission: Scalars['Boolean'];
};

export type HiddenBlocksDocAccessFields_Layout = {
  __typename?: 'HiddenBlocksDocAccessFields_layout';
  create?: Maybe<HiddenBlocksDocAccessFields_Layout_Create>;
  delete?: Maybe<HiddenBlocksDocAccessFields_Layout_Delete>;
  fields?: Maybe<HiddenBlocksDocAccessFields_Layout_Fields>;
  read?: Maybe<HiddenBlocksDocAccessFields_Layout_Read>;
  update?: Maybe<HiddenBlocksDocAccessFields_Layout_Update>;
};

export type HiddenBlocksDocAccessFields_Layout_Create = {
  __typename?: 'HiddenBlocksDocAccessFields_layout_Create';
  permission: Scalars['Boolean'];
};

export type HiddenBlocksDocAccessFields_Layout_Delete = {
  __typename?: 'HiddenBlocksDocAccessFields_layout_Delete';
  permission: Scalars['Boolean'];
};

export type HiddenBlocksDocAccessFields_Layout_Fields = {
  __typename?: 'HiddenBlocksDocAccessFields_layout_Fields';
  blocks?: Maybe<HiddenBlocksDocAccessFields_Layout_Blocks>;
};

export type HiddenBlocksDocAccessFields_Layout_Read = {
  __typename?: 'HiddenBlocksDocAccessFields_layout_Read';
  permission: Scalars['Boolean'];
};

export type HiddenBlocksDocAccessFields_Layout_Update = {
  __typename?: 'HiddenBlocksDocAccessFields_layout_Update';
  permission: Scalars['Boolean'];
};

export type HiddenBlocksDocAccessFields_Layout_Blocks = {
  __typename?: 'HiddenBlocksDocAccessFields_layout_blocks';
  create?: Maybe<HiddenBlocksDocAccessFields_Layout_Blocks_Create>;
  delete?: Maybe<HiddenBlocksDocAccessFields_Layout_Blocks_Delete>;
  read?: Maybe<HiddenBlocksDocAccessFields_Layout_Blocks_Read>;
  update?: Maybe<HiddenBlocksDocAccessFields_Layout_Blocks_Update>;
};

export type HiddenBlocksDocAccessFields_Layout_Blocks_Create = {
  __typename?: 'HiddenBlocksDocAccessFields_layout_blocks_Create';
  permission: Scalars['Boolean'];
};

export type HiddenBlocksDocAccessFields_Layout_Blocks_Delete = {
  __typename?: 'HiddenBlocksDocAccessFields_layout_blocks_Delete';
  permission: Scalars['Boolean'];
};

export type HiddenBlocksDocAccessFields_Layout_Blocks_Read = {
  __typename?: 'HiddenBlocksDocAccessFields_layout_blocks_Read';
  permission: Scalars['Boolean'];
};

export type HiddenBlocksDocAccessFields_Layout_Blocks_Update = {
  __typename?: 'HiddenBlocksDocAccessFields_layout_blocks_Update';
  permission: Scalars['Boolean'];
};

export type HiddenBlocksDocAccessFields_UpdatedAt = {
  __typename?: 'HiddenBlocksDocAccessFields_updatedAt';
  create?: Maybe<HiddenBlocksDocAccessFields_UpdatedAt_Create>;
  delete?: Maybe<HiddenBlocksDocAccessFields_UpdatedAt_Delete>;
  read?: Maybe<HiddenBlocksDocAccessFields_UpdatedAt_Read>;
  update?: Maybe<HiddenBlocksDocAccessFields_UpdatedAt_Update>;
};

export type HiddenBlocksDocAccessFields_UpdatedAt_Create = {
  __typename?: 'HiddenBlocksDocAccessFields_updatedAt_Create';
  permission: Scalars['Boolean'];
};

export type HiddenBlocksDocAccessFields_UpdatedAt_Delete = {
  __typename?: 'HiddenBlocksDocAccessFields_updatedAt_Delete';
  permission: Scalars['Boolean'];
};

export type HiddenBlocksDocAccessFields_UpdatedAt_Read = {
  __typename?: 'HiddenBlocksDocAccessFields_updatedAt_Read';
  permission: Scalars['Boolean'];
};

export type HiddenBlocksDocAccessFields_UpdatedAt_Update = {
  __typename?: 'HiddenBlocksDocAccessFields_updatedAt_Update';
  permission: Scalars['Boolean'];
};

export type HiddenBlocksFields = {
  __typename?: 'HiddenBlocksFields';
  createdAt?: Maybe<HiddenBlocksFields_CreatedAt>;
  layout?: Maybe<HiddenBlocksFields_Layout>;
  updatedAt?: Maybe<HiddenBlocksFields_UpdatedAt>;
};

export type HiddenBlocksFields_CreatedAt = {
  __typename?: 'HiddenBlocksFields_createdAt';
  create?: Maybe<HiddenBlocksFields_CreatedAt_Create>;
  delete?: Maybe<HiddenBlocksFields_CreatedAt_Delete>;
  read?: Maybe<HiddenBlocksFields_CreatedAt_Read>;
  update?: Maybe<HiddenBlocksFields_CreatedAt_Update>;
};

export type HiddenBlocksFields_CreatedAt_Create = {
  __typename?: 'HiddenBlocksFields_createdAt_Create';
  permission: Scalars['Boolean'];
};

export type HiddenBlocksFields_CreatedAt_Delete = {
  __typename?: 'HiddenBlocksFields_createdAt_Delete';
  permission: Scalars['Boolean'];
};

export type HiddenBlocksFields_CreatedAt_Read = {
  __typename?: 'HiddenBlocksFields_createdAt_Read';
  permission: Scalars['Boolean'];
};

export type HiddenBlocksFields_CreatedAt_Update = {
  __typename?: 'HiddenBlocksFields_createdAt_Update';
  permission: Scalars['Boolean'];
};

export type HiddenBlocksFields_Layout = {
  __typename?: 'HiddenBlocksFields_layout';
  create?: Maybe<HiddenBlocksFields_Layout_Create>;
  delete?: Maybe<HiddenBlocksFields_Layout_Delete>;
  fields?: Maybe<HiddenBlocksFields_Layout_Fields>;
  read?: Maybe<HiddenBlocksFields_Layout_Read>;
  update?: Maybe<HiddenBlocksFields_Layout_Update>;
};

export type HiddenBlocksFields_Layout_Create = {
  __typename?: 'HiddenBlocksFields_layout_Create';
  permission: Scalars['Boolean'];
};

export type HiddenBlocksFields_Layout_Delete = {
  __typename?: 'HiddenBlocksFields_layout_Delete';
  permission: Scalars['Boolean'];
};

export type HiddenBlocksFields_Layout_Fields = {
  __typename?: 'HiddenBlocksFields_layout_Fields';
  blocks?: Maybe<HiddenBlocksFields_Layout_Blocks>;
};

export type HiddenBlocksFields_Layout_Read = {
  __typename?: 'HiddenBlocksFields_layout_Read';
  permission: Scalars['Boolean'];
};

export type HiddenBlocksFields_Layout_Update = {
  __typename?: 'HiddenBlocksFields_layout_Update';
  permission: Scalars['Boolean'];
};

export type HiddenBlocksFields_Layout_Blocks = {
  __typename?: 'HiddenBlocksFields_layout_blocks';
  create?: Maybe<HiddenBlocksFields_Layout_Blocks_Create>;
  delete?: Maybe<HiddenBlocksFields_Layout_Blocks_Delete>;
  read?: Maybe<HiddenBlocksFields_Layout_Blocks_Read>;
  update?: Maybe<HiddenBlocksFields_Layout_Blocks_Update>;
};

export type HiddenBlocksFields_Layout_Blocks_Create = {
  __typename?: 'HiddenBlocksFields_layout_blocks_Create';
  permission: Scalars['Boolean'];
};

export type HiddenBlocksFields_Layout_Blocks_Delete = {
  __typename?: 'HiddenBlocksFields_layout_blocks_Delete';
  permission: Scalars['Boolean'];
};

export type HiddenBlocksFields_Layout_Blocks_Read = {
  __typename?: 'HiddenBlocksFields_layout_blocks_Read';
  permission: Scalars['Boolean'];
};

export type HiddenBlocksFields_Layout_Blocks_Update = {
  __typename?: 'HiddenBlocksFields_layout_blocks_Update';
  permission: Scalars['Boolean'];
};

export type HiddenBlocksFields_UpdatedAt = {
  __typename?: 'HiddenBlocksFields_updatedAt';
  create?: Maybe<HiddenBlocksFields_UpdatedAt_Create>;
  delete?: Maybe<HiddenBlocksFields_UpdatedAt_Delete>;
  read?: Maybe<HiddenBlocksFields_UpdatedAt_Read>;
  update?: Maybe<HiddenBlocksFields_UpdatedAt_Update>;
};

export type HiddenBlocksFields_UpdatedAt_Create = {
  __typename?: 'HiddenBlocksFields_updatedAt_Create';
  permission: Scalars['Boolean'];
};

export type HiddenBlocksFields_UpdatedAt_Delete = {
  __typename?: 'HiddenBlocksFields_updatedAt_Delete';
  permission: Scalars['Boolean'];
};

export type HiddenBlocksFields_UpdatedAt_Read = {
  __typename?: 'HiddenBlocksFields_updatedAt_Read';
  permission: Scalars['Boolean'];
};

export type HiddenBlocksFields_UpdatedAt_Update = {
  __typename?: 'HiddenBlocksFields_updatedAt_Update';
  permission: Scalars['Boolean'];
};

export type HiddenBlocksReadAccess = {
  __typename?: 'HiddenBlocksReadAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type HiddenBlocksReadDocAccess = {
  __typename?: 'HiddenBlocksReadDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type HiddenBlocksUpdateAccess = {
  __typename?: 'HiddenBlocksUpdateAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type HiddenBlocksUpdateDocAccess = {
  __typename?: 'HiddenBlocksUpdateDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type Icon = {
  __typename?: 'Icon';
  blockName?: Maybe<Scalars['String']>;
  blockType?: Maybe<Scalars['String']>;
  color?: Maybe<Icon_Color>;
  icon?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  size?: Maybe<Icon_Size>;
};

export enum Icon_Color {
  Default = 'default',
  Primary = 'primary',
  Secondary = 'secondary'
}

export enum Icon_Size {
  Large = 'large',
  Medium = 'medium',
  Small = 'small'
}

export type Image = {
  __typename?: 'Image';
  blockName?: Maybe<Scalars['String']>;
  blockSettings?: Maybe<BlockSettings>;
  blockType?: Maybe<Scalars['String']>;
  caption?: Maybe<Scalars['JSON']>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<Media>;
  imageSize?: Maybe<Image_ImageSize>;
};


export type ImageCaptionArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};

export enum Image_ImageSize {
  Card = 'card',
  Feature = 'feature',
  Original = 'original'
}

export type LandingPage = {
  __typename?: 'LandingPage';
  _status?: Maybe<LandingPage__Status>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['JSON']>;
  header?: Maybe<LandingPage_Header>;
  id: Scalars['String'];
  layout?: Maybe<LandingPage_Layout>;
  meta?: Maybe<LandingPage_Meta>;
  slug?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  titleSettings?: Maybe<Page_TitleSettings>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type LandingPageDescriptionArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};

export type LandingPageCreateAccess = {
  __typename?: 'LandingPageCreateAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type LandingPageCreateDocAccess = {
  __typename?: 'LandingPageCreateDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type LandingPageDeleteAccess = {
  __typename?: 'LandingPageDeleteAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type LandingPageDeleteDocAccess = {
  __typename?: 'LandingPageDeleteDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type LandingPageDocAccessFields = {
  __typename?: 'LandingPageDocAccessFields';
  _status?: Maybe<LandingPageDocAccessFields__Status>;
  beforeFeaturedFormContent?: Maybe<LandingPageDocAccessFields_BeforeFeaturedFormContent>;
  blocks?: Maybe<LandingPageDocAccessFields_Blocks>;
  createdAt?: Maybe<LandingPageDocAccessFields_CreatedAt>;
  description?: Maybe<LandingPageDocAccessFields_Description>;
  featuredForm?: Maybe<LandingPageDocAccessFields_FeaturedForm>;
  image?: Maybe<LandingPageDocAccessFields_Image>;
  meta?: Maybe<LandingPageDocAccessFields_Meta>;
  showRatingWidget?: Maybe<LandingPageDocAccessFields_ShowRatingWidget>;
  slug?: Maybe<LandingPageDocAccessFields_Slug>;
  title?: Maybe<LandingPageDocAccessFields_Title>;
  titleSettings?: Maybe<LandingPageDocAccessFields_TitleSettings>;
  type?: Maybe<LandingPageDocAccessFields_Type>;
  updatedAt?: Maybe<LandingPageDocAccessFields_UpdatedAt>;
  wrapInBackground?: Maybe<LandingPageDocAccessFields_WrapInBackground>;
};

export type LandingPageDocAccessFields__Status = {
  __typename?: 'LandingPageDocAccessFields__status';
  create?: Maybe<LandingPageDocAccessFields__Status_Create>;
  delete?: Maybe<LandingPageDocAccessFields__Status_Delete>;
  read?: Maybe<LandingPageDocAccessFields__Status_Read>;
  update?: Maybe<LandingPageDocAccessFields__Status_Update>;
};

export type LandingPageDocAccessFields__Status_Create = {
  __typename?: 'LandingPageDocAccessFields__status_Create';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields__Status_Delete = {
  __typename?: 'LandingPageDocAccessFields__status_Delete';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields__Status_Read = {
  __typename?: 'LandingPageDocAccessFields__status_Read';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields__Status_Update = {
  __typename?: 'LandingPageDocAccessFields__status_Update';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields_BeforeFeaturedFormContent = {
  __typename?: 'LandingPageDocAccessFields_beforeFeaturedFormContent';
  create?: Maybe<LandingPageDocAccessFields_BeforeFeaturedFormContent_Create>;
  delete?: Maybe<LandingPageDocAccessFields_BeforeFeaturedFormContent_Delete>;
  read?: Maybe<LandingPageDocAccessFields_BeforeFeaturedFormContent_Read>;
  update?: Maybe<LandingPageDocAccessFields_BeforeFeaturedFormContent_Update>;
};

export type LandingPageDocAccessFields_BeforeFeaturedFormContent_Create = {
  __typename?: 'LandingPageDocAccessFields_beforeFeaturedFormContent_Create';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields_BeforeFeaturedFormContent_Delete = {
  __typename?: 'LandingPageDocAccessFields_beforeFeaturedFormContent_Delete';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields_BeforeFeaturedFormContent_Read = {
  __typename?: 'LandingPageDocAccessFields_beforeFeaturedFormContent_Read';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields_BeforeFeaturedFormContent_Update = {
  __typename?: 'LandingPageDocAccessFields_beforeFeaturedFormContent_Update';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields_Blocks = {
  __typename?: 'LandingPageDocAccessFields_blocks';
  create?: Maybe<LandingPageDocAccessFields_Blocks_Create>;
  delete?: Maybe<LandingPageDocAccessFields_Blocks_Delete>;
  read?: Maybe<LandingPageDocAccessFields_Blocks_Read>;
  update?: Maybe<LandingPageDocAccessFields_Blocks_Update>;
};

export type LandingPageDocAccessFields_Blocks_Create = {
  __typename?: 'LandingPageDocAccessFields_blocks_Create';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields_Blocks_Delete = {
  __typename?: 'LandingPageDocAccessFields_blocks_Delete';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields_Blocks_Read = {
  __typename?: 'LandingPageDocAccessFields_blocks_Read';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields_Blocks_Update = {
  __typename?: 'LandingPageDocAccessFields_blocks_Update';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields_CreatedAt = {
  __typename?: 'LandingPageDocAccessFields_createdAt';
  create?: Maybe<LandingPageDocAccessFields_CreatedAt_Create>;
  delete?: Maybe<LandingPageDocAccessFields_CreatedAt_Delete>;
  read?: Maybe<LandingPageDocAccessFields_CreatedAt_Read>;
  update?: Maybe<LandingPageDocAccessFields_CreatedAt_Update>;
};

export type LandingPageDocAccessFields_CreatedAt_Create = {
  __typename?: 'LandingPageDocAccessFields_createdAt_Create';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields_CreatedAt_Delete = {
  __typename?: 'LandingPageDocAccessFields_createdAt_Delete';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields_CreatedAt_Read = {
  __typename?: 'LandingPageDocAccessFields_createdAt_Read';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields_CreatedAt_Update = {
  __typename?: 'LandingPageDocAccessFields_createdAt_Update';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields_Description = {
  __typename?: 'LandingPageDocAccessFields_description';
  create?: Maybe<LandingPageDocAccessFields_Description_Create>;
  delete?: Maybe<LandingPageDocAccessFields_Description_Delete>;
  read?: Maybe<LandingPageDocAccessFields_Description_Read>;
  update?: Maybe<LandingPageDocAccessFields_Description_Update>;
};

export type LandingPageDocAccessFields_Description_Create = {
  __typename?: 'LandingPageDocAccessFields_description_Create';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields_Description_Delete = {
  __typename?: 'LandingPageDocAccessFields_description_Delete';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields_Description_Read = {
  __typename?: 'LandingPageDocAccessFields_description_Read';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields_Description_Update = {
  __typename?: 'LandingPageDocAccessFields_description_Update';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields_FeaturedForm = {
  __typename?: 'LandingPageDocAccessFields_featuredForm';
  create?: Maybe<LandingPageDocAccessFields_FeaturedForm_Create>;
  delete?: Maybe<LandingPageDocAccessFields_FeaturedForm_Delete>;
  read?: Maybe<LandingPageDocAccessFields_FeaturedForm_Read>;
  update?: Maybe<LandingPageDocAccessFields_FeaturedForm_Update>;
};

export type LandingPageDocAccessFields_FeaturedForm_Create = {
  __typename?: 'LandingPageDocAccessFields_featuredForm_Create';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields_FeaturedForm_Delete = {
  __typename?: 'LandingPageDocAccessFields_featuredForm_Delete';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields_FeaturedForm_Read = {
  __typename?: 'LandingPageDocAccessFields_featuredForm_Read';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields_FeaturedForm_Update = {
  __typename?: 'LandingPageDocAccessFields_featuredForm_Update';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields_Image = {
  __typename?: 'LandingPageDocAccessFields_image';
  create?: Maybe<LandingPageDocAccessFields_Image_Create>;
  delete?: Maybe<LandingPageDocAccessFields_Image_Delete>;
  read?: Maybe<LandingPageDocAccessFields_Image_Read>;
  update?: Maybe<LandingPageDocAccessFields_Image_Update>;
};

export type LandingPageDocAccessFields_Image_Create = {
  __typename?: 'LandingPageDocAccessFields_image_Create';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields_Image_Delete = {
  __typename?: 'LandingPageDocAccessFields_image_Delete';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields_Image_Read = {
  __typename?: 'LandingPageDocAccessFields_image_Read';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields_Image_Update = {
  __typename?: 'LandingPageDocAccessFields_image_Update';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields_Meta = {
  __typename?: 'LandingPageDocAccessFields_meta';
  create?: Maybe<LandingPageDocAccessFields_Meta_Create>;
  delete?: Maybe<LandingPageDocAccessFields_Meta_Delete>;
  fields?: Maybe<LandingPageDocAccessFields_Meta_Fields>;
  read?: Maybe<LandingPageDocAccessFields_Meta_Read>;
  update?: Maybe<LandingPageDocAccessFields_Meta_Update>;
};

export type LandingPageDocAccessFields_Meta_Create = {
  __typename?: 'LandingPageDocAccessFields_meta_Create';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields_Meta_Delete = {
  __typename?: 'LandingPageDocAccessFields_meta_Delete';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields_Meta_Fields = {
  __typename?: 'LandingPageDocAccessFields_meta_Fields';
  description?: Maybe<LandingPageDocAccessFields_Meta_Description>;
  image?: Maybe<LandingPageDocAccessFields_Meta_Image>;
  noIndex?: Maybe<LandingPageDocAccessFields_Meta_NoIndex>;
  title?: Maybe<LandingPageDocAccessFields_Meta_Title>;
};

export type LandingPageDocAccessFields_Meta_Read = {
  __typename?: 'LandingPageDocAccessFields_meta_Read';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields_Meta_Update = {
  __typename?: 'LandingPageDocAccessFields_meta_Update';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields_Meta_Description = {
  __typename?: 'LandingPageDocAccessFields_meta_description';
  create?: Maybe<LandingPageDocAccessFields_Meta_Description_Create>;
  delete?: Maybe<LandingPageDocAccessFields_Meta_Description_Delete>;
  read?: Maybe<LandingPageDocAccessFields_Meta_Description_Read>;
  update?: Maybe<LandingPageDocAccessFields_Meta_Description_Update>;
};

export type LandingPageDocAccessFields_Meta_Description_Create = {
  __typename?: 'LandingPageDocAccessFields_meta_description_Create';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields_Meta_Description_Delete = {
  __typename?: 'LandingPageDocAccessFields_meta_description_Delete';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields_Meta_Description_Read = {
  __typename?: 'LandingPageDocAccessFields_meta_description_Read';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields_Meta_Description_Update = {
  __typename?: 'LandingPageDocAccessFields_meta_description_Update';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields_Meta_Image = {
  __typename?: 'LandingPageDocAccessFields_meta_image';
  create?: Maybe<LandingPageDocAccessFields_Meta_Image_Create>;
  delete?: Maybe<LandingPageDocAccessFields_Meta_Image_Delete>;
  read?: Maybe<LandingPageDocAccessFields_Meta_Image_Read>;
  update?: Maybe<LandingPageDocAccessFields_Meta_Image_Update>;
};

export type LandingPageDocAccessFields_Meta_Image_Create = {
  __typename?: 'LandingPageDocAccessFields_meta_image_Create';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields_Meta_Image_Delete = {
  __typename?: 'LandingPageDocAccessFields_meta_image_Delete';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields_Meta_Image_Read = {
  __typename?: 'LandingPageDocAccessFields_meta_image_Read';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields_Meta_Image_Update = {
  __typename?: 'LandingPageDocAccessFields_meta_image_Update';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields_Meta_NoIndex = {
  __typename?: 'LandingPageDocAccessFields_meta_noIndex';
  create?: Maybe<LandingPageDocAccessFields_Meta_NoIndex_Create>;
  delete?: Maybe<LandingPageDocAccessFields_Meta_NoIndex_Delete>;
  read?: Maybe<LandingPageDocAccessFields_Meta_NoIndex_Read>;
  update?: Maybe<LandingPageDocAccessFields_Meta_NoIndex_Update>;
};

export type LandingPageDocAccessFields_Meta_NoIndex_Create = {
  __typename?: 'LandingPageDocAccessFields_meta_noIndex_Create';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields_Meta_NoIndex_Delete = {
  __typename?: 'LandingPageDocAccessFields_meta_noIndex_Delete';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields_Meta_NoIndex_Read = {
  __typename?: 'LandingPageDocAccessFields_meta_noIndex_Read';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields_Meta_NoIndex_Update = {
  __typename?: 'LandingPageDocAccessFields_meta_noIndex_Update';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields_Meta_Title = {
  __typename?: 'LandingPageDocAccessFields_meta_title';
  create?: Maybe<LandingPageDocAccessFields_Meta_Title_Create>;
  delete?: Maybe<LandingPageDocAccessFields_Meta_Title_Delete>;
  read?: Maybe<LandingPageDocAccessFields_Meta_Title_Read>;
  update?: Maybe<LandingPageDocAccessFields_Meta_Title_Update>;
};

export type LandingPageDocAccessFields_Meta_Title_Create = {
  __typename?: 'LandingPageDocAccessFields_meta_title_Create';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields_Meta_Title_Delete = {
  __typename?: 'LandingPageDocAccessFields_meta_title_Delete';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields_Meta_Title_Read = {
  __typename?: 'LandingPageDocAccessFields_meta_title_Read';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields_Meta_Title_Update = {
  __typename?: 'LandingPageDocAccessFields_meta_title_Update';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields_ShowRatingWidget = {
  __typename?: 'LandingPageDocAccessFields_showRatingWidget';
  create?: Maybe<LandingPageDocAccessFields_ShowRatingWidget_Create>;
  delete?: Maybe<LandingPageDocAccessFields_ShowRatingWidget_Delete>;
  read?: Maybe<LandingPageDocAccessFields_ShowRatingWidget_Read>;
  update?: Maybe<LandingPageDocAccessFields_ShowRatingWidget_Update>;
};

export type LandingPageDocAccessFields_ShowRatingWidget_Create = {
  __typename?: 'LandingPageDocAccessFields_showRatingWidget_Create';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields_ShowRatingWidget_Delete = {
  __typename?: 'LandingPageDocAccessFields_showRatingWidget_Delete';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields_ShowRatingWidget_Read = {
  __typename?: 'LandingPageDocAccessFields_showRatingWidget_Read';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields_ShowRatingWidget_Update = {
  __typename?: 'LandingPageDocAccessFields_showRatingWidget_Update';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields_Slug = {
  __typename?: 'LandingPageDocAccessFields_slug';
  create?: Maybe<LandingPageDocAccessFields_Slug_Create>;
  delete?: Maybe<LandingPageDocAccessFields_Slug_Delete>;
  read?: Maybe<LandingPageDocAccessFields_Slug_Read>;
  update?: Maybe<LandingPageDocAccessFields_Slug_Update>;
};

export type LandingPageDocAccessFields_Slug_Create = {
  __typename?: 'LandingPageDocAccessFields_slug_Create';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields_Slug_Delete = {
  __typename?: 'LandingPageDocAccessFields_slug_Delete';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields_Slug_Read = {
  __typename?: 'LandingPageDocAccessFields_slug_Read';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields_Slug_Update = {
  __typename?: 'LandingPageDocAccessFields_slug_Update';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields_Title = {
  __typename?: 'LandingPageDocAccessFields_title';
  create?: Maybe<LandingPageDocAccessFields_Title_Create>;
  delete?: Maybe<LandingPageDocAccessFields_Title_Delete>;
  read?: Maybe<LandingPageDocAccessFields_Title_Read>;
  update?: Maybe<LandingPageDocAccessFields_Title_Update>;
};

export type LandingPageDocAccessFields_TitleSettings = {
  __typename?: 'LandingPageDocAccessFields_titleSettings';
  create?: Maybe<LandingPageDocAccessFields_TitleSettings_Create>;
  delete?: Maybe<LandingPageDocAccessFields_TitleSettings_Delete>;
  fields?: Maybe<LandingPageDocAccessFields_TitleSettings_Fields>;
  read?: Maybe<LandingPageDocAccessFields_TitleSettings_Read>;
  update?: Maybe<LandingPageDocAccessFields_TitleSettings_Update>;
};

export type LandingPageDocAccessFields_TitleSettings_Create = {
  __typename?: 'LandingPageDocAccessFields_titleSettings_Create';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields_TitleSettings_Delete = {
  __typename?: 'LandingPageDocAccessFields_titleSettings_Delete';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields_TitleSettings_Fields = {
  __typename?: 'LandingPageDocAccessFields_titleSettings_Fields';
  boldEndIndex?: Maybe<LandingPageDocAccessFields_TitleSettings_BoldEndIndex>;
  boldStartIndex?: Maybe<LandingPageDocAccessFields_TitleSettings_BoldStartIndex>;
};

export type LandingPageDocAccessFields_TitleSettings_Read = {
  __typename?: 'LandingPageDocAccessFields_titleSettings_Read';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields_TitleSettings_Update = {
  __typename?: 'LandingPageDocAccessFields_titleSettings_Update';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields_TitleSettings_BoldEndIndex = {
  __typename?: 'LandingPageDocAccessFields_titleSettings_boldEndIndex';
  create?: Maybe<LandingPageDocAccessFields_TitleSettings_BoldEndIndex_Create>;
  delete?: Maybe<LandingPageDocAccessFields_TitleSettings_BoldEndIndex_Delete>;
  read?: Maybe<LandingPageDocAccessFields_TitleSettings_BoldEndIndex_Read>;
  update?: Maybe<LandingPageDocAccessFields_TitleSettings_BoldEndIndex_Update>;
};

export type LandingPageDocAccessFields_TitleSettings_BoldEndIndex_Create = {
  __typename?: 'LandingPageDocAccessFields_titleSettings_boldEndIndex_Create';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields_TitleSettings_BoldEndIndex_Delete = {
  __typename?: 'LandingPageDocAccessFields_titleSettings_boldEndIndex_Delete';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields_TitleSettings_BoldEndIndex_Read = {
  __typename?: 'LandingPageDocAccessFields_titleSettings_boldEndIndex_Read';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields_TitleSettings_BoldEndIndex_Update = {
  __typename?: 'LandingPageDocAccessFields_titleSettings_boldEndIndex_Update';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields_TitleSettings_BoldStartIndex = {
  __typename?: 'LandingPageDocAccessFields_titleSettings_boldStartIndex';
  create?: Maybe<LandingPageDocAccessFields_TitleSettings_BoldStartIndex_Create>;
  delete?: Maybe<LandingPageDocAccessFields_TitleSettings_BoldStartIndex_Delete>;
  read?: Maybe<LandingPageDocAccessFields_TitleSettings_BoldStartIndex_Read>;
  update?: Maybe<LandingPageDocAccessFields_TitleSettings_BoldStartIndex_Update>;
};

export type LandingPageDocAccessFields_TitleSettings_BoldStartIndex_Create = {
  __typename?: 'LandingPageDocAccessFields_titleSettings_boldStartIndex_Create';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields_TitleSettings_BoldStartIndex_Delete = {
  __typename?: 'LandingPageDocAccessFields_titleSettings_boldStartIndex_Delete';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields_TitleSettings_BoldStartIndex_Read = {
  __typename?: 'LandingPageDocAccessFields_titleSettings_boldStartIndex_Read';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields_TitleSettings_BoldStartIndex_Update = {
  __typename?: 'LandingPageDocAccessFields_titleSettings_boldStartIndex_Update';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields_Title_Create = {
  __typename?: 'LandingPageDocAccessFields_title_Create';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields_Title_Delete = {
  __typename?: 'LandingPageDocAccessFields_title_Delete';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields_Title_Read = {
  __typename?: 'LandingPageDocAccessFields_title_Read';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields_Title_Update = {
  __typename?: 'LandingPageDocAccessFields_title_Update';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields_Type = {
  __typename?: 'LandingPageDocAccessFields_type';
  create?: Maybe<LandingPageDocAccessFields_Type_Create>;
  delete?: Maybe<LandingPageDocAccessFields_Type_Delete>;
  read?: Maybe<LandingPageDocAccessFields_Type_Read>;
  update?: Maybe<LandingPageDocAccessFields_Type_Update>;
};

export type LandingPageDocAccessFields_Type_Create = {
  __typename?: 'LandingPageDocAccessFields_type_Create';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields_Type_Delete = {
  __typename?: 'LandingPageDocAccessFields_type_Delete';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields_Type_Read = {
  __typename?: 'LandingPageDocAccessFields_type_Read';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields_Type_Update = {
  __typename?: 'LandingPageDocAccessFields_type_Update';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields_UpdatedAt = {
  __typename?: 'LandingPageDocAccessFields_updatedAt';
  create?: Maybe<LandingPageDocAccessFields_UpdatedAt_Create>;
  delete?: Maybe<LandingPageDocAccessFields_UpdatedAt_Delete>;
  read?: Maybe<LandingPageDocAccessFields_UpdatedAt_Read>;
  update?: Maybe<LandingPageDocAccessFields_UpdatedAt_Update>;
};

export type LandingPageDocAccessFields_UpdatedAt_Create = {
  __typename?: 'LandingPageDocAccessFields_updatedAt_Create';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields_UpdatedAt_Delete = {
  __typename?: 'LandingPageDocAccessFields_updatedAt_Delete';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields_UpdatedAt_Read = {
  __typename?: 'LandingPageDocAccessFields_updatedAt_Read';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields_UpdatedAt_Update = {
  __typename?: 'LandingPageDocAccessFields_updatedAt_Update';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields_WrapInBackground = {
  __typename?: 'LandingPageDocAccessFields_wrapInBackground';
  create?: Maybe<LandingPageDocAccessFields_WrapInBackground_Create>;
  delete?: Maybe<LandingPageDocAccessFields_WrapInBackground_Delete>;
  read?: Maybe<LandingPageDocAccessFields_WrapInBackground_Read>;
  update?: Maybe<LandingPageDocAccessFields_WrapInBackground_Update>;
};

export type LandingPageDocAccessFields_WrapInBackground_Create = {
  __typename?: 'LandingPageDocAccessFields_wrapInBackground_Create';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields_WrapInBackground_Delete = {
  __typename?: 'LandingPageDocAccessFields_wrapInBackground_Delete';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields_WrapInBackground_Read = {
  __typename?: 'LandingPageDocAccessFields_wrapInBackground_Read';
  permission: Scalars['Boolean'];
};

export type LandingPageDocAccessFields_WrapInBackground_Update = {
  __typename?: 'LandingPageDocAccessFields_wrapInBackground_Update';
  permission: Scalars['Boolean'];
};

export type LandingPageFields = {
  __typename?: 'LandingPageFields';
  _status?: Maybe<LandingPageFields__Status>;
  beforeFeaturedFormContent?: Maybe<LandingPageFields_BeforeFeaturedFormContent>;
  blocks?: Maybe<LandingPageFields_Blocks>;
  createdAt?: Maybe<LandingPageFields_CreatedAt>;
  description?: Maybe<LandingPageFields_Description>;
  featuredForm?: Maybe<LandingPageFields_FeaturedForm>;
  image?: Maybe<LandingPageFields_Image>;
  meta?: Maybe<LandingPageFields_Meta>;
  showRatingWidget?: Maybe<LandingPageFields_ShowRatingWidget>;
  slug?: Maybe<LandingPageFields_Slug>;
  title?: Maybe<LandingPageFields_Title>;
  titleSettings?: Maybe<LandingPageFields_TitleSettings>;
  type?: Maybe<LandingPageFields_Type>;
  updatedAt?: Maybe<LandingPageFields_UpdatedAt>;
  wrapInBackground?: Maybe<LandingPageFields_WrapInBackground>;
};

export type LandingPageFields__Status = {
  __typename?: 'LandingPageFields__status';
  create?: Maybe<LandingPageFields__Status_Create>;
  delete?: Maybe<LandingPageFields__Status_Delete>;
  read?: Maybe<LandingPageFields__Status_Read>;
  update?: Maybe<LandingPageFields__Status_Update>;
};

export type LandingPageFields__Status_Create = {
  __typename?: 'LandingPageFields__status_Create';
  permission: Scalars['Boolean'];
};

export type LandingPageFields__Status_Delete = {
  __typename?: 'LandingPageFields__status_Delete';
  permission: Scalars['Boolean'];
};

export type LandingPageFields__Status_Read = {
  __typename?: 'LandingPageFields__status_Read';
  permission: Scalars['Boolean'];
};

export type LandingPageFields__Status_Update = {
  __typename?: 'LandingPageFields__status_Update';
  permission: Scalars['Boolean'];
};

export type LandingPageFields_BeforeFeaturedFormContent = {
  __typename?: 'LandingPageFields_beforeFeaturedFormContent';
  create?: Maybe<LandingPageFields_BeforeFeaturedFormContent_Create>;
  delete?: Maybe<LandingPageFields_BeforeFeaturedFormContent_Delete>;
  read?: Maybe<LandingPageFields_BeforeFeaturedFormContent_Read>;
  update?: Maybe<LandingPageFields_BeforeFeaturedFormContent_Update>;
};

export type LandingPageFields_BeforeFeaturedFormContent_Create = {
  __typename?: 'LandingPageFields_beforeFeaturedFormContent_Create';
  permission: Scalars['Boolean'];
};

export type LandingPageFields_BeforeFeaturedFormContent_Delete = {
  __typename?: 'LandingPageFields_beforeFeaturedFormContent_Delete';
  permission: Scalars['Boolean'];
};

export type LandingPageFields_BeforeFeaturedFormContent_Read = {
  __typename?: 'LandingPageFields_beforeFeaturedFormContent_Read';
  permission: Scalars['Boolean'];
};

export type LandingPageFields_BeforeFeaturedFormContent_Update = {
  __typename?: 'LandingPageFields_beforeFeaturedFormContent_Update';
  permission: Scalars['Boolean'];
};

export type LandingPageFields_Blocks = {
  __typename?: 'LandingPageFields_blocks';
  create?: Maybe<LandingPageFields_Blocks_Create>;
  delete?: Maybe<LandingPageFields_Blocks_Delete>;
  read?: Maybe<LandingPageFields_Blocks_Read>;
  update?: Maybe<LandingPageFields_Blocks_Update>;
};

export type LandingPageFields_Blocks_Create = {
  __typename?: 'LandingPageFields_blocks_Create';
  permission: Scalars['Boolean'];
};

export type LandingPageFields_Blocks_Delete = {
  __typename?: 'LandingPageFields_blocks_Delete';
  permission: Scalars['Boolean'];
};

export type LandingPageFields_Blocks_Read = {
  __typename?: 'LandingPageFields_blocks_Read';
  permission: Scalars['Boolean'];
};

export type LandingPageFields_Blocks_Update = {
  __typename?: 'LandingPageFields_blocks_Update';
  permission: Scalars['Boolean'];
};

export type LandingPageFields_CreatedAt = {
  __typename?: 'LandingPageFields_createdAt';
  create?: Maybe<LandingPageFields_CreatedAt_Create>;
  delete?: Maybe<LandingPageFields_CreatedAt_Delete>;
  read?: Maybe<LandingPageFields_CreatedAt_Read>;
  update?: Maybe<LandingPageFields_CreatedAt_Update>;
};

export type LandingPageFields_CreatedAt_Create = {
  __typename?: 'LandingPageFields_createdAt_Create';
  permission: Scalars['Boolean'];
};

export type LandingPageFields_CreatedAt_Delete = {
  __typename?: 'LandingPageFields_createdAt_Delete';
  permission: Scalars['Boolean'];
};

export type LandingPageFields_CreatedAt_Read = {
  __typename?: 'LandingPageFields_createdAt_Read';
  permission: Scalars['Boolean'];
};

export type LandingPageFields_CreatedAt_Update = {
  __typename?: 'LandingPageFields_createdAt_Update';
  permission: Scalars['Boolean'];
};

export type LandingPageFields_Description = {
  __typename?: 'LandingPageFields_description';
  create?: Maybe<LandingPageFields_Description_Create>;
  delete?: Maybe<LandingPageFields_Description_Delete>;
  read?: Maybe<LandingPageFields_Description_Read>;
  update?: Maybe<LandingPageFields_Description_Update>;
};

export type LandingPageFields_Description_Create = {
  __typename?: 'LandingPageFields_description_Create';
  permission: Scalars['Boolean'];
};

export type LandingPageFields_Description_Delete = {
  __typename?: 'LandingPageFields_description_Delete';
  permission: Scalars['Boolean'];
};

export type LandingPageFields_Description_Read = {
  __typename?: 'LandingPageFields_description_Read';
  permission: Scalars['Boolean'];
};

export type LandingPageFields_Description_Update = {
  __typename?: 'LandingPageFields_description_Update';
  permission: Scalars['Boolean'];
};

export type LandingPageFields_FeaturedForm = {
  __typename?: 'LandingPageFields_featuredForm';
  create?: Maybe<LandingPageFields_FeaturedForm_Create>;
  delete?: Maybe<LandingPageFields_FeaturedForm_Delete>;
  read?: Maybe<LandingPageFields_FeaturedForm_Read>;
  update?: Maybe<LandingPageFields_FeaturedForm_Update>;
};

export type LandingPageFields_FeaturedForm_Create = {
  __typename?: 'LandingPageFields_featuredForm_Create';
  permission: Scalars['Boolean'];
};

export type LandingPageFields_FeaturedForm_Delete = {
  __typename?: 'LandingPageFields_featuredForm_Delete';
  permission: Scalars['Boolean'];
};

export type LandingPageFields_FeaturedForm_Read = {
  __typename?: 'LandingPageFields_featuredForm_Read';
  permission: Scalars['Boolean'];
};

export type LandingPageFields_FeaturedForm_Update = {
  __typename?: 'LandingPageFields_featuredForm_Update';
  permission: Scalars['Boolean'];
};

export type LandingPageFields_Image = {
  __typename?: 'LandingPageFields_image';
  create?: Maybe<LandingPageFields_Image_Create>;
  delete?: Maybe<LandingPageFields_Image_Delete>;
  read?: Maybe<LandingPageFields_Image_Read>;
  update?: Maybe<LandingPageFields_Image_Update>;
};

export type LandingPageFields_Image_Create = {
  __typename?: 'LandingPageFields_image_Create';
  permission: Scalars['Boolean'];
};

export type LandingPageFields_Image_Delete = {
  __typename?: 'LandingPageFields_image_Delete';
  permission: Scalars['Boolean'];
};

export type LandingPageFields_Image_Read = {
  __typename?: 'LandingPageFields_image_Read';
  permission: Scalars['Boolean'];
};

export type LandingPageFields_Image_Update = {
  __typename?: 'LandingPageFields_image_Update';
  permission: Scalars['Boolean'];
};

export type LandingPageFields_Meta = {
  __typename?: 'LandingPageFields_meta';
  create?: Maybe<LandingPageFields_Meta_Create>;
  delete?: Maybe<LandingPageFields_Meta_Delete>;
  fields?: Maybe<LandingPageFields_Meta_Fields>;
  read?: Maybe<LandingPageFields_Meta_Read>;
  update?: Maybe<LandingPageFields_Meta_Update>;
};

export type LandingPageFields_Meta_Create = {
  __typename?: 'LandingPageFields_meta_Create';
  permission: Scalars['Boolean'];
};

export type LandingPageFields_Meta_Delete = {
  __typename?: 'LandingPageFields_meta_Delete';
  permission: Scalars['Boolean'];
};

export type LandingPageFields_Meta_Fields = {
  __typename?: 'LandingPageFields_meta_Fields';
  description?: Maybe<LandingPageFields_Meta_Description>;
  image?: Maybe<LandingPageFields_Meta_Image>;
  noIndex?: Maybe<LandingPageFields_Meta_NoIndex>;
  title?: Maybe<LandingPageFields_Meta_Title>;
};

export type LandingPageFields_Meta_Read = {
  __typename?: 'LandingPageFields_meta_Read';
  permission: Scalars['Boolean'];
};

export type LandingPageFields_Meta_Update = {
  __typename?: 'LandingPageFields_meta_Update';
  permission: Scalars['Boolean'];
};

export type LandingPageFields_Meta_Description = {
  __typename?: 'LandingPageFields_meta_description';
  create?: Maybe<LandingPageFields_Meta_Description_Create>;
  delete?: Maybe<LandingPageFields_Meta_Description_Delete>;
  read?: Maybe<LandingPageFields_Meta_Description_Read>;
  update?: Maybe<LandingPageFields_Meta_Description_Update>;
};

export type LandingPageFields_Meta_Description_Create = {
  __typename?: 'LandingPageFields_meta_description_Create';
  permission: Scalars['Boolean'];
};

export type LandingPageFields_Meta_Description_Delete = {
  __typename?: 'LandingPageFields_meta_description_Delete';
  permission: Scalars['Boolean'];
};

export type LandingPageFields_Meta_Description_Read = {
  __typename?: 'LandingPageFields_meta_description_Read';
  permission: Scalars['Boolean'];
};

export type LandingPageFields_Meta_Description_Update = {
  __typename?: 'LandingPageFields_meta_description_Update';
  permission: Scalars['Boolean'];
};

export type LandingPageFields_Meta_Image = {
  __typename?: 'LandingPageFields_meta_image';
  create?: Maybe<LandingPageFields_Meta_Image_Create>;
  delete?: Maybe<LandingPageFields_Meta_Image_Delete>;
  read?: Maybe<LandingPageFields_Meta_Image_Read>;
  update?: Maybe<LandingPageFields_Meta_Image_Update>;
};

export type LandingPageFields_Meta_Image_Create = {
  __typename?: 'LandingPageFields_meta_image_Create';
  permission: Scalars['Boolean'];
};

export type LandingPageFields_Meta_Image_Delete = {
  __typename?: 'LandingPageFields_meta_image_Delete';
  permission: Scalars['Boolean'];
};

export type LandingPageFields_Meta_Image_Read = {
  __typename?: 'LandingPageFields_meta_image_Read';
  permission: Scalars['Boolean'];
};

export type LandingPageFields_Meta_Image_Update = {
  __typename?: 'LandingPageFields_meta_image_Update';
  permission: Scalars['Boolean'];
};

export type LandingPageFields_Meta_NoIndex = {
  __typename?: 'LandingPageFields_meta_noIndex';
  create?: Maybe<LandingPageFields_Meta_NoIndex_Create>;
  delete?: Maybe<LandingPageFields_Meta_NoIndex_Delete>;
  read?: Maybe<LandingPageFields_Meta_NoIndex_Read>;
  update?: Maybe<LandingPageFields_Meta_NoIndex_Update>;
};

export type LandingPageFields_Meta_NoIndex_Create = {
  __typename?: 'LandingPageFields_meta_noIndex_Create';
  permission: Scalars['Boolean'];
};

export type LandingPageFields_Meta_NoIndex_Delete = {
  __typename?: 'LandingPageFields_meta_noIndex_Delete';
  permission: Scalars['Boolean'];
};

export type LandingPageFields_Meta_NoIndex_Read = {
  __typename?: 'LandingPageFields_meta_noIndex_Read';
  permission: Scalars['Boolean'];
};

export type LandingPageFields_Meta_NoIndex_Update = {
  __typename?: 'LandingPageFields_meta_noIndex_Update';
  permission: Scalars['Boolean'];
};

export type LandingPageFields_Meta_Title = {
  __typename?: 'LandingPageFields_meta_title';
  create?: Maybe<LandingPageFields_Meta_Title_Create>;
  delete?: Maybe<LandingPageFields_Meta_Title_Delete>;
  read?: Maybe<LandingPageFields_Meta_Title_Read>;
  update?: Maybe<LandingPageFields_Meta_Title_Update>;
};

export type LandingPageFields_Meta_Title_Create = {
  __typename?: 'LandingPageFields_meta_title_Create';
  permission: Scalars['Boolean'];
};

export type LandingPageFields_Meta_Title_Delete = {
  __typename?: 'LandingPageFields_meta_title_Delete';
  permission: Scalars['Boolean'];
};

export type LandingPageFields_Meta_Title_Read = {
  __typename?: 'LandingPageFields_meta_title_Read';
  permission: Scalars['Boolean'];
};

export type LandingPageFields_Meta_Title_Update = {
  __typename?: 'LandingPageFields_meta_title_Update';
  permission: Scalars['Boolean'];
};

export type LandingPageFields_ShowRatingWidget = {
  __typename?: 'LandingPageFields_showRatingWidget';
  create?: Maybe<LandingPageFields_ShowRatingWidget_Create>;
  delete?: Maybe<LandingPageFields_ShowRatingWidget_Delete>;
  read?: Maybe<LandingPageFields_ShowRatingWidget_Read>;
  update?: Maybe<LandingPageFields_ShowRatingWidget_Update>;
};

export type LandingPageFields_ShowRatingWidget_Create = {
  __typename?: 'LandingPageFields_showRatingWidget_Create';
  permission: Scalars['Boolean'];
};

export type LandingPageFields_ShowRatingWidget_Delete = {
  __typename?: 'LandingPageFields_showRatingWidget_Delete';
  permission: Scalars['Boolean'];
};

export type LandingPageFields_ShowRatingWidget_Read = {
  __typename?: 'LandingPageFields_showRatingWidget_Read';
  permission: Scalars['Boolean'];
};

export type LandingPageFields_ShowRatingWidget_Update = {
  __typename?: 'LandingPageFields_showRatingWidget_Update';
  permission: Scalars['Boolean'];
};

export type LandingPageFields_Slug = {
  __typename?: 'LandingPageFields_slug';
  create?: Maybe<LandingPageFields_Slug_Create>;
  delete?: Maybe<LandingPageFields_Slug_Delete>;
  read?: Maybe<LandingPageFields_Slug_Read>;
  update?: Maybe<LandingPageFields_Slug_Update>;
};

export type LandingPageFields_Slug_Create = {
  __typename?: 'LandingPageFields_slug_Create';
  permission: Scalars['Boolean'];
};

export type LandingPageFields_Slug_Delete = {
  __typename?: 'LandingPageFields_slug_Delete';
  permission: Scalars['Boolean'];
};

export type LandingPageFields_Slug_Read = {
  __typename?: 'LandingPageFields_slug_Read';
  permission: Scalars['Boolean'];
};

export type LandingPageFields_Slug_Update = {
  __typename?: 'LandingPageFields_slug_Update';
  permission: Scalars['Boolean'];
};

export type LandingPageFields_Title = {
  __typename?: 'LandingPageFields_title';
  create?: Maybe<LandingPageFields_Title_Create>;
  delete?: Maybe<LandingPageFields_Title_Delete>;
  read?: Maybe<LandingPageFields_Title_Read>;
  update?: Maybe<LandingPageFields_Title_Update>;
};

export type LandingPageFields_TitleSettings = {
  __typename?: 'LandingPageFields_titleSettings';
  create?: Maybe<LandingPageFields_TitleSettings_Create>;
  delete?: Maybe<LandingPageFields_TitleSettings_Delete>;
  fields?: Maybe<LandingPageFields_TitleSettings_Fields>;
  read?: Maybe<LandingPageFields_TitleSettings_Read>;
  update?: Maybe<LandingPageFields_TitleSettings_Update>;
};

export type LandingPageFields_TitleSettings_Create = {
  __typename?: 'LandingPageFields_titleSettings_Create';
  permission: Scalars['Boolean'];
};

export type LandingPageFields_TitleSettings_Delete = {
  __typename?: 'LandingPageFields_titleSettings_Delete';
  permission: Scalars['Boolean'];
};

export type LandingPageFields_TitleSettings_Fields = {
  __typename?: 'LandingPageFields_titleSettings_Fields';
  boldEndIndex?: Maybe<LandingPageFields_TitleSettings_BoldEndIndex>;
  boldStartIndex?: Maybe<LandingPageFields_TitleSettings_BoldStartIndex>;
};

export type LandingPageFields_TitleSettings_Read = {
  __typename?: 'LandingPageFields_titleSettings_Read';
  permission: Scalars['Boolean'];
};

export type LandingPageFields_TitleSettings_Update = {
  __typename?: 'LandingPageFields_titleSettings_Update';
  permission: Scalars['Boolean'];
};

export type LandingPageFields_TitleSettings_BoldEndIndex = {
  __typename?: 'LandingPageFields_titleSettings_boldEndIndex';
  create?: Maybe<LandingPageFields_TitleSettings_BoldEndIndex_Create>;
  delete?: Maybe<LandingPageFields_TitleSettings_BoldEndIndex_Delete>;
  read?: Maybe<LandingPageFields_TitleSettings_BoldEndIndex_Read>;
  update?: Maybe<LandingPageFields_TitleSettings_BoldEndIndex_Update>;
};

export type LandingPageFields_TitleSettings_BoldEndIndex_Create = {
  __typename?: 'LandingPageFields_titleSettings_boldEndIndex_Create';
  permission: Scalars['Boolean'];
};

export type LandingPageFields_TitleSettings_BoldEndIndex_Delete = {
  __typename?: 'LandingPageFields_titleSettings_boldEndIndex_Delete';
  permission: Scalars['Boolean'];
};

export type LandingPageFields_TitleSettings_BoldEndIndex_Read = {
  __typename?: 'LandingPageFields_titleSettings_boldEndIndex_Read';
  permission: Scalars['Boolean'];
};

export type LandingPageFields_TitleSettings_BoldEndIndex_Update = {
  __typename?: 'LandingPageFields_titleSettings_boldEndIndex_Update';
  permission: Scalars['Boolean'];
};

export type LandingPageFields_TitleSettings_BoldStartIndex = {
  __typename?: 'LandingPageFields_titleSettings_boldStartIndex';
  create?: Maybe<LandingPageFields_TitleSettings_BoldStartIndex_Create>;
  delete?: Maybe<LandingPageFields_TitleSettings_BoldStartIndex_Delete>;
  read?: Maybe<LandingPageFields_TitleSettings_BoldStartIndex_Read>;
  update?: Maybe<LandingPageFields_TitleSettings_BoldStartIndex_Update>;
};

export type LandingPageFields_TitleSettings_BoldStartIndex_Create = {
  __typename?: 'LandingPageFields_titleSettings_boldStartIndex_Create';
  permission: Scalars['Boolean'];
};

export type LandingPageFields_TitleSettings_BoldStartIndex_Delete = {
  __typename?: 'LandingPageFields_titleSettings_boldStartIndex_Delete';
  permission: Scalars['Boolean'];
};

export type LandingPageFields_TitleSettings_BoldStartIndex_Read = {
  __typename?: 'LandingPageFields_titleSettings_boldStartIndex_Read';
  permission: Scalars['Boolean'];
};

export type LandingPageFields_TitleSettings_BoldStartIndex_Update = {
  __typename?: 'LandingPageFields_titleSettings_boldStartIndex_Update';
  permission: Scalars['Boolean'];
};

export type LandingPageFields_Title_Create = {
  __typename?: 'LandingPageFields_title_Create';
  permission: Scalars['Boolean'];
};

export type LandingPageFields_Title_Delete = {
  __typename?: 'LandingPageFields_title_Delete';
  permission: Scalars['Boolean'];
};

export type LandingPageFields_Title_Read = {
  __typename?: 'LandingPageFields_title_Read';
  permission: Scalars['Boolean'];
};

export type LandingPageFields_Title_Update = {
  __typename?: 'LandingPageFields_title_Update';
  permission: Scalars['Boolean'];
};

export type LandingPageFields_Type = {
  __typename?: 'LandingPageFields_type';
  create?: Maybe<LandingPageFields_Type_Create>;
  delete?: Maybe<LandingPageFields_Type_Delete>;
  read?: Maybe<LandingPageFields_Type_Read>;
  update?: Maybe<LandingPageFields_Type_Update>;
};

export type LandingPageFields_Type_Create = {
  __typename?: 'LandingPageFields_type_Create';
  permission: Scalars['Boolean'];
};

export type LandingPageFields_Type_Delete = {
  __typename?: 'LandingPageFields_type_Delete';
  permission: Scalars['Boolean'];
};

export type LandingPageFields_Type_Read = {
  __typename?: 'LandingPageFields_type_Read';
  permission: Scalars['Boolean'];
};

export type LandingPageFields_Type_Update = {
  __typename?: 'LandingPageFields_type_Update';
  permission: Scalars['Boolean'];
};

export type LandingPageFields_UpdatedAt = {
  __typename?: 'LandingPageFields_updatedAt';
  create?: Maybe<LandingPageFields_UpdatedAt_Create>;
  delete?: Maybe<LandingPageFields_UpdatedAt_Delete>;
  read?: Maybe<LandingPageFields_UpdatedAt_Read>;
  update?: Maybe<LandingPageFields_UpdatedAt_Update>;
};

export type LandingPageFields_UpdatedAt_Create = {
  __typename?: 'LandingPageFields_updatedAt_Create';
  permission: Scalars['Boolean'];
};

export type LandingPageFields_UpdatedAt_Delete = {
  __typename?: 'LandingPageFields_updatedAt_Delete';
  permission: Scalars['Boolean'];
};

export type LandingPageFields_UpdatedAt_Read = {
  __typename?: 'LandingPageFields_updatedAt_Read';
  permission: Scalars['Boolean'];
};

export type LandingPageFields_UpdatedAt_Update = {
  __typename?: 'LandingPageFields_updatedAt_Update';
  permission: Scalars['Boolean'];
};

export type LandingPageFields_WrapInBackground = {
  __typename?: 'LandingPageFields_wrapInBackground';
  create?: Maybe<LandingPageFields_WrapInBackground_Create>;
  delete?: Maybe<LandingPageFields_WrapInBackground_Delete>;
  read?: Maybe<LandingPageFields_WrapInBackground_Read>;
  update?: Maybe<LandingPageFields_WrapInBackground_Update>;
};

export type LandingPageFields_WrapInBackground_Create = {
  __typename?: 'LandingPageFields_wrapInBackground_Create';
  permission: Scalars['Boolean'];
};

export type LandingPageFields_WrapInBackground_Delete = {
  __typename?: 'LandingPageFields_wrapInBackground_Delete';
  permission: Scalars['Boolean'];
};

export type LandingPageFields_WrapInBackground_Read = {
  __typename?: 'LandingPageFields_wrapInBackground_Read';
  permission: Scalars['Boolean'];
};

export type LandingPageFields_WrapInBackground_Update = {
  __typename?: 'LandingPageFields_wrapInBackground_Update';
  permission: Scalars['Boolean'];
};

export type LandingPageReadAccess = {
  __typename?: 'LandingPageReadAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type LandingPageReadDocAccess = {
  __typename?: 'LandingPageReadDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type LandingPageReadVersionsAccess = {
  __typename?: 'LandingPageReadVersionsAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type LandingPageReadVersionsDocAccess = {
  __typename?: 'LandingPageReadVersionsDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type LandingPageUpdateAccess = {
  __typename?: 'LandingPageUpdateAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type LandingPageUpdateDocAccess = {
  __typename?: 'LandingPageUpdateDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export enum LandingPageUpdate_Header_Type_MutationInput {
  Default = 'default',
  FeaturedForm = 'featuredForm',
  FeaturedImage = 'featuredImage'
}

export enum LandingPageUpdate__Status_MutationInput {
  Draft = 'draft',
  Published = 'published'
}

export type LandingPageVersion = {
  __typename?: 'LandingPageVersion';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  latest?: Maybe<Scalars['Boolean']>;
  parent?: Maybe<LandingPage>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  version?: Maybe<LandingPageVersion_Version>;
};


export type LandingPageVersionParentArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
};

export type LandingPageVersion_Version = {
  __typename?: 'LandingPageVersion_Version';
  _status?: Maybe<LandingPageVersion_Version__Status>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['JSON']>;
  header?: Maybe<LandingPageVersion_Version_Header>;
  layout?: Maybe<LandingPageVersion_Version_Layout>;
  meta?: Maybe<LandingPageVersion_Version_Meta>;
  slug?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  titleSettings?: Maybe<Page_TitleSettings>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type LandingPageVersion_VersionDescriptionArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};

export type LandingPageVersion_Version_Header = {
  __typename?: 'LandingPageVersion_Version_Header';
  beforeFeaturedFormContent?: Maybe<Scalars['JSON']>;
  featuredForm?: Maybe<Form>;
  image?: Maybe<Media>;
  showRatingWidget?: Maybe<Scalars['Boolean']>;
  type?: Maybe<LandingPageVersion_Version_Header_Type>;
  wrapInBackground?: Maybe<Scalars['Boolean']>;
};


export type LandingPageVersion_Version_HeaderBeforeFeaturedFormContentArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};

export enum LandingPageVersion_Version_Header_Type {
  Default = 'default',
  FeaturedForm = 'featuredForm',
  FeaturedImage = 'featuredImage'
}

export type LandingPageVersion_Version_Layout = {
  __typename?: 'LandingPageVersion_Version_Layout';
  blocks?: Maybe<Array<LandingPageVersion_Version_Layout_Blocks>>;
};

export type LandingPageVersion_Version_Layout_Blocks = AnimatedTextBlock | ArticlesScroller | BackgroundWithBlock | CardWithBlocks | Columns | Comparisons | Content | Cta | CtaButton | Faq | FormBlock | Image | LeadFormBlock | Lists | ServicesScroller | SliderWithBlocks | Spacer | StickyImageScroll | VerticalSlider;

export type LandingPageVersion_Version_Meta = {
  __typename?: 'LandingPageVersion_Version_Meta';
  description?: Maybe<Scalars['String']>;
  image?: Maybe<Media>;
  noIndex?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
};

export enum LandingPageVersion_Version__Status {
  Draft = 'draft',
  Published = 'published'
}

export type LandingPage_Header = {
  __typename?: 'LandingPage_Header';
  beforeFeaturedFormContent?: Maybe<Scalars['JSON']>;
  featuredForm?: Maybe<Form>;
  image?: Maybe<Media>;
  showRatingWidget?: Maybe<Scalars['Boolean']>;
  type?: Maybe<LandingPage_Header_Type>;
  wrapInBackground?: Maybe<Scalars['Boolean']>;
};


export type LandingPage_HeaderBeforeFeaturedFormContentArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};

export enum LandingPage_Header_Type {
  Default = 'default',
  FeaturedForm = 'featuredForm',
  FeaturedImage = 'featuredImage'
}

export enum LandingPage_Header_Type_MutationInput {
  Default = 'default',
  FeaturedForm = 'featuredForm',
  FeaturedImage = 'featuredImage'
}

export type LandingPage_Layout = {
  __typename?: 'LandingPage_Layout';
  blocks?: Maybe<Array<LandingPage_Layout_Blocks>>;
};

export type LandingPage_Layout_Blocks = AnimatedTextBlock | ArticlesScroller | BackgroundWithBlock | CardWithBlocks | Columns | Comparisons | Content | Cta | CtaButton | Faq | FormBlock | Image | LeadFormBlock | Lists | ServicesScroller | SliderWithBlocks | Spacer | StickyImageScroll | VerticalSlider;

export type LandingPage_Meta = {
  __typename?: 'LandingPage_Meta';
  description?: Maybe<Scalars['String']>;
  image?: Maybe<Media>;
  noIndex?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
};

export enum LandingPage__Status {
  Draft = 'draft',
  Published = 'published'
}

export enum LandingPage__Status_Input {
  Draft = 'draft',
  Published = 'published'
}

export enum LandingPage__Status_MutationInput {
  Draft = 'draft',
  Published = 'published'
}

export type LandingPage__Status_Operator = {
  all?: InputMaybe<Array<InputMaybe<LandingPage__Status_Input>>>;
  equals?: InputMaybe<LandingPage__Status_Input>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<LandingPage__Status_Input>>>;
  not_equals?: InputMaybe<LandingPage__Status_Input>;
  not_in?: InputMaybe<Array<InputMaybe<LandingPage__Status_Input>>>;
};

export type LandingPage_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type LandingPage_Description_Operator = {
  contains?: InputMaybe<Scalars['JSON']>;
  equals?: InputMaybe<Scalars['JSON']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  like?: InputMaybe<Scalars['JSON']>;
  not_equals?: InputMaybe<Scalars['JSON']>;
};

export type LandingPage_Header__BeforeFeaturedFormContent_Operator = {
  contains?: InputMaybe<Scalars['JSON']>;
  equals?: InputMaybe<Scalars['JSON']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  like?: InputMaybe<Scalars['JSON']>;
  not_equals?: InputMaybe<Scalars['JSON']>;
};

export type LandingPage_Header__FeaturedForm_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  equals?: InputMaybe<Scalars['JSON']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  not_equals?: InputMaybe<Scalars['JSON']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type LandingPage_Header__Image_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  equals?: InputMaybe<Scalars['JSON']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  not_equals?: InputMaybe<Scalars['JSON']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type LandingPage_Header__ShowRatingWidget_Operator = {
  equals?: InputMaybe<Scalars['Boolean']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  not_equals?: InputMaybe<Scalars['Boolean']>;
};

export enum LandingPage_Header__Type_Input {
  Default = 'default',
  FeaturedForm = 'featuredForm',
  FeaturedImage = 'featuredImage'
}

export type LandingPage_Header__Type_Operator = {
  all?: InputMaybe<Array<InputMaybe<LandingPage_Header__Type_Input>>>;
  equals?: InputMaybe<LandingPage_Header__Type_Input>;
  in?: InputMaybe<Array<InputMaybe<LandingPage_Header__Type_Input>>>;
  not_equals?: InputMaybe<LandingPage_Header__Type_Input>;
  not_in?: InputMaybe<Array<InputMaybe<LandingPage_Header__Type_Input>>>;
};

export type LandingPage_Header__WrapInBackground_Operator = {
  equals?: InputMaybe<Scalars['Boolean']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  not_equals?: InputMaybe<Scalars['Boolean']>;
};

export type LandingPage_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LandingPage_Meta__Description_Operator = {
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
};

export type LandingPage_Meta__Image_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  equals?: InputMaybe<Scalars['JSON']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  not_equals?: InputMaybe<Scalars['JSON']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type LandingPage_Meta__NoIndex_Operator = {
  equals?: InputMaybe<Scalars['Boolean']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  not_equals?: InputMaybe<Scalars['Boolean']>;
};

export type LandingPage_Meta__Title_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LandingPage_Slug_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LandingPage_TitleSettings__BoldEndIndex_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LandingPage_TitleSettings__BoldStartIndex_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LandingPage_Title_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LandingPage_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type LandingPage_Where = {
  AND?: InputMaybe<Array<InputMaybe<LandingPage_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<LandingPage_Where_Or>>>;
  _status?: InputMaybe<LandingPage__Status_Operator>;
  createdAt?: InputMaybe<LandingPage_CreatedAt_Operator>;
  description?: InputMaybe<LandingPage_Description_Operator>;
  header__beforeFeaturedFormContent?: InputMaybe<LandingPage_Header__BeforeFeaturedFormContent_Operator>;
  header__featuredForm?: InputMaybe<LandingPage_Header__FeaturedForm_Operator>;
  header__image?: InputMaybe<LandingPage_Header__Image_Operator>;
  header__showRatingWidget?: InputMaybe<LandingPage_Header__ShowRatingWidget_Operator>;
  header__type?: InputMaybe<LandingPage_Header__Type_Operator>;
  header__wrapInBackground?: InputMaybe<LandingPage_Header__WrapInBackground_Operator>;
  id?: InputMaybe<LandingPage_Id_Operator>;
  meta__description?: InputMaybe<LandingPage_Meta__Description_Operator>;
  meta__image?: InputMaybe<LandingPage_Meta__Image_Operator>;
  meta__noIndex?: InputMaybe<LandingPage_Meta__NoIndex_Operator>;
  meta__title?: InputMaybe<LandingPage_Meta__Title_Operator>;
  slug?: InputMaybe<LandingPage_Slug_Operator>;
  title?: InputMaybe<LandingPage_Title_Operator>;
  titleSettings__boldEndIndex?: InputMaybe<LandingPage_TitleSettings__BoldEndIndex_Operator>;
  titleSettings__boldStartIndex?: InputMaybe<LandingPage_TitleSettings__BoldStartIndex_Operator>;
  updatedAt?: InputMaybe<LandingPage_UpdatedAt_Operator>;
};

export type LandingPage_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<LandingPage_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<LandingPage_Where_Or>>>;
  _status?: InputMaybe<LandingPage__Status_Operator>;
  createdAt?: InputMaybe<LandingPage_CreatedAt_Operator>;
  description?: InputMaybe<LandingPage_Description_Operator>;
  header__beforeFeaturedFormContent?: InputMaybe<LandingPage_Header__BeforeFeaturedFormContent_Operator>;
  header__featuredForm?: InputMaybe<LandingPage_Header__FeaturedForm_Operator>;
  header__image?: InputMaybe<LandingPage_Header__Image_Operator>;
  header__showRatingWidget?: InputMaybe<LandingPage_Header__ShowRatingWidget_Operator>;
  header__type?: InputMaybe<LandingPage_Header__Type_Operator>;
  header__wrapInBackground?: InputMaybe<LandingPage_Header__WrapInBackground_Operator>;
  id?: InputMaybe<LandingPage_Id_Operator>;
  meta__description?: InputMaybe<LandingPage_Meta__Description_Operator>;
  meta__image?: InputMaybe<LandingPage_Meta__Image_Operator>;
  meta__noIndex?: InputMaybe<LandingPage_Meta__NoIndex_Operator>;
  meta__title?: InputMaybe<LandingPage_Meta__Title_Operator>;
  slug?: InputMaybe<LandingPage_Slug_Operator>;
  title?: InputMaybe<LandingPage_Title_Operator>;
  titleSettings__boldEndIndex?: InputMaybe<LandingPage_TitleSettings__BoldEndIndex_Operator>;
  titleSettings__boldStartIndex?: InputMaybe<LandingPage_TitleSettings__BoldStartIndex_Operator>;
  updatedAt?: InputMaybe<LandingPage_UpdatedAt_Operator>;
};

export type LandingPage_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<LandingPage_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<LandingPage_Where_Or>>>;
  _status?: InputMaybe<LandingPage__Status_Operator>;
  createdAt?: InputMaybe<LandingPage_CreatedAt_Operator>;
  description?: InputMaybe<LandingPage_Description_Operator>;
  header__beforeFeaturedFormContent?: InputMaybe<LandingPage_Header__BeforeFeaturedFormContent_Operator>;
  header__featuredForm?: InputMaybe<LandingPage_Header__FeaturedForm_Operator>;
  header__image?: InputMaybe<LandingPage_Header__Image_Operator>;
  header__showRatingWidget?: InputMaybe<LandingPage_Header__ShowRatingWidget_Operator>;
  header__type?: InputMaybe<LandingPage_Header__Type_Operator>;
  header__wrapInBackground?: InputMaybe<LandingPage_Header__WrapInBackground_Operator>;
  id?: InputMaybe<LandingPage_Id_Operator>;
  meta__description?: InputMaybe<LandingPage_Meta__Description_Operator>;
  meta__image?: InputMaybe<LandingPage_Meta__Image_Operator>;
  meta__noIndex?: InputMaybe<LandingPage_Meta__NoIndex_Operator>;
  meta__title?: InputMaybe<LandingPage_Meta__Title_Operator>;
  slug?: InputMaybe<LandingPage_Slug_Operator>;
  title?: InputMaybe<LandingPage_Title_Operator>;
  titleSettings__boldEndIndex?: InputMaybe<LandingPage_TitleSettings__BoldEndIndex_Operator>;
  titleSettings__boldStartIndex?: InputMaybe<LandingPage_TitleSettings__BoldStartIndex_Operator>;
  updatedAt?: InputMaybe<LandingPage_UpdatedAt_Operator>;
};

export type LandingPages = {
  __typename?: 'LandingPages';
  docs?: Maybe<Array<Maybe<LandingPage>>>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPrevPage?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  nextPage?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  pagingCounter?: Maybe<Scalars['Int']>;
  prevPage?: Maybe<Scalars['Int']>;
  totalDocs?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
};

export type LandingTumbler = {
  __typename?: 'LandingTumbler';
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  landingPages?: Maybe<Array<LandingTumbler_LandingPages>>;
  meta?: Maybe<LandingTumbler_Meta>;
  selectedLandingPageSlug?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LandingTumblerCreateAccess = {
  __typename?: 'LandingTumblerCreateAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type LandingTumblerCreateDocAccess = {
  __typename?: 'LandingTumblerCreateDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type LandingTumblerDeleteAccess = {
  __typename?: 'LandingTumblerDeleteAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type LandingTumblerDeleteDocAccess = {
  __typename?: 'LandingTumblerDeleteDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type LandingTumblerDocAccessFields = {
  __typename?: 'LandingTumblerDocAccessFields';
  createdAt?: Maybe<LandingTumblerDocAccessFields_CreatedAt>;
  landingPages?: Maybe<LandingTumblerDocAccessFields_LandingPages>;
  meta?: Maybe<LandingTumblerDocAccessFields_Meta>;
  selectedLandingPageSlug?: Maybe<LandingTumblerDocAccessFields_SelectedLandingPageSlug>;
  slug?: Maybe<LandingTumblerDocAccessFields_Slug>;
  title?: Maybe<LandingTumblerDocAccessFields_Title>;
  updatedAt?: Maybe<LandingTumblerDocAccessFields_UpdatedAt>;
};

export type LandingTumblerDocAccessFields_CreatedAt = {
  __typename?: 'LandingTumblerDocAccessFields_createdAt';
  create?: Maybe<LandingTumblerDocAccessFields_CreatedAt_Create>;
  delete?: Maybe<LandingTumblerDocAccessFields_CreatedAt_Delete>;
  read?: Maybe<LandingTumblerDocAccessFields_CreatedAt_Read>;
  update?: Maybe<LandingTumblerDocAccessFields_CreatedAt_Update>;
};

export type LandingTumblerDocAccessFields_CreatedAt_Create = {
  __typename?: 'LandingTumblerDocAccessFields_createdAt_Create';
  permission: Scalars['Boolean'];
};

export type LandingTumblerDocAccessFields_CreatedAt_Delete = {
  __typename?: 'LandingTumblerDocAccessFields_createdAt_Delete';
  permission: Scalars['Boolean'];
};

export type LandingTumblerDocAccessFields_CreatedAt_Read = {
  __typename?: 'LandingTumblerDocAccessFields_createdAt_Read';
  permission: Scalars['Boolean'];
};

export type LandingTumblerDocAccessFields_CreatedAt_Update = {
  __typename?: 'LandingTumblerDocAccessFields_createdAt_Update';
  permission: Scalars['Boolean'];
};

export type LandingTumblerDocAccessFields_LandingPages = {
  __typename?: 'LandingTumblerDocAccessFields_landingPages';
  create?: Maybe<LandingTumblerDocAccessFields_LandingPages_Create>;
  delete?: Maybe<LandingTumblerDocAccessFields_LandingPages_Delete>;
  fields?: Maybe<LandingTumblerDocAccessFields_LandingPages_Fields>;
  read?: Maybe<LandingTumblerDocAccessFields_LandingPages_Read>;
  update?: Maybe<LandingTumblerDocAccessFields_LandingPages_Update>;
};

export type LandingTumblerDocAccessFields_LandingPages_Create = {
  __typename?: 'LandingTumblerDocAccessFields_landingPages_Create';
  permission: Scalars['Boolean'];
};

export type LandingTumblerDocAccessFields_LandingPages_Delete = {
  __typename?: 'LandingTumblerDocAccessFields_landingPages_Delete';
  permission: Scalars['Boolean'];
};

export type LandingTumblerDocAccessFields_LandingPages_Fields = {
  __typename?: 'LandingTumblerDocAccessFields_landingPages_Fields';
  id?: Maybe<LandingTumblerDocAccessFields_LandingPages_Id>;
  landingPage?: Maybe<LandingTumblerDocAccessFields_LandingPages_LandingPage>;
  weight?: Maybe<LandingTumblerDocAccessFields_LandingPages_Weight>;
};

export type LandingTumblerDocAccessFields_LandingPages_Read = {
  __typename?: 'LandingTumblerDocAccessFields_landingPages_Read';
  permission: Scalars['Boolean'];
};

export type LandingTumblerDocAccessFields_LandingPages_Update = {
  __typename?: 'LandingTumblerDocAccessFields_landingPages_Update';
  permission: Scalars['Boolean'];
};

export type LandingTumblerDocAccessFields_LandingPages_Id = {
  __typename?: 'LandingTumblerDocAccessFields_landingPages_id';
  create?: Maybe<LandingTumblerDocAccessFields_LandingPages_Id_Create>;
  delete?: Maybe<LandingTumblerDocAccessFields_LandingPages_Id_Delete>;
  read?: Maybe<LandingTumblerDocAccessFields_LandingPages_Id_Read>;
  update?: Maybe<LandingTumblerDocAccessFields_LandingPages_Id_Update>;
};

export type LandingTumblerDocAccessFields_LandingPages_Id_Create = {
  __typename?: 'LandingTumblerDocAccessFields_landingPages_id_Create';
  permission: Scalars['Boolean'];
};

export type LandingTumblerDocAccessFields_LandingPages_Id_Delete = {
  __typename?: 'LandingTumblerDocAccessFields_landingPages_id_Delete';
  permission: Scalars['Boolean'];
};

export type LandingTumblerDocAccessFields_LandingPages_Id_Read = {
  __typename?: 'LandingTumblerDocAccessFields_landingPages_id_Read';
  permission: Scalars['Boolean'];
};

export type LandingTumblerDocAccessFields_LandingPages_Id_Update = {
  __typename?: 'LandingTumblerDocAccessFields_landingPages_id_Update';
  permission: Scalars['Boolean'];
};

export type LandingTumblerDocAccessFields_LandingPages_LandingPage = {
  __typename?: 'LandingTumblerDocAccessFields_landingPages_landingPage';
  create?: Maybe<LandingTumblerDocAccessFields_LandingPages_LandingPage_Create>;
  delete?: Maybe<LandingTumblerDocAccessFields_LandingPages_LandingPage_Delete>;
  read?: Maybe<LandingTumblerDocAccessFields_LandingPages_LandingPage_Read>;
  update?: Maybe<LandingTumblerDocAccessFields_LandingPages_LandingPage_Update>;
};

export type LandingTumblerDocAccessFields_LandingPages_LandingPage_Create = {
  __typename?: 'LandingTumblerDocAccessFields_landingPages_landingPage_Create';
  permission: Scalars['Boolean'];
};

export type LandingTumblerDocAccessFields_LandingPages_LandingPage_Delete = {
  __typename?: 'LandingTumblerDocAccessFields_landingPages_landingPage_Delete';
  permission: Scalars['Boolean'];
};

export type LandingTumblerDocAccessFields_LandingPages_LandingPage_Read = {
  __typename?: 'LandingTumblerDocAccessFields_landingPages_landingPage_Read';
  permission: Scalars['Boolean'];
};

export type LandingTumblerDocAccessFields_LandingPages_LandingPage_Update = {
  __typename?: 'LandingTumblerDocAccessFields_landingPages_landingPage_Update';
  permission: Scalars['Boolean'];
};

export type LandingTumblerDocAccessFields_LandingPages_Weight = {
  __typename?: 'LandingTumblerDocAccessFields_landingPages_weight';
  create?: Maybe<LandingTumblerDocAccessFields_LandingPages_Weight_Create>;
  delete?: Maybe<LandingTumblerDocAccessFields_LandingPages_Weight_Delete>;
  read?: Maybe<LandingTumblerDocAccessFields_LandingPages_Weight_Read>;
  update?: Maybe<LandingTumblerDocAccessFields_LandingPages_Weight_Update>;
};

export type LandingTumblerDocAccessFields_LandingPages_Weight_Create = {
  __typename?: 'LandingTumblerDocAccessFields_landingPages_weight_Create';
  permission: Scalars['Boolean'];
};

export type LandingTumblerDocAccessFields_LandingPages_Weight_Delete = {
  __typename?: 'LandingTumblerDocAccessFields_landingPages_weight_Delete';
  permission: Scalars['Boolean'];
};

export type LandingTumblerDocAccessFields_LandingPages_Weight_Read = {
  __typename?: 'LandingTumblerDocAccessFields_landingPages_weight_Read';
  permission: Scalars['Boolean'];
};

export type LandingTumblerDocAccessFields_LandingPages_Weight_Update = {
  __typename?: 'LandingTumblerDocAccessFields_landingPages_weight_Update';
  permission: Scalars['Boolean'];
};

export type LandingTumblerDocAccessFields_Meta = {
  __typename?: 'LandingTumblerDocAccessFields_meta';
  create?: Maybe<LandingTumblerDocAccessFields_Meta_Create>;
  delete?: Maybe<LandingTumblerDocAccessFields_Meta_Delete>;
  fields?: Maybe<LandingTumblerDocAccessFields_Meta_Fields>;
  read?: Maybe<LandingTumblerDocAccessFields_Meta_Read>;
  update?: Maybe<LandingTumblerDocAccessFields_Meta_Update>;
};

export type LandingTumblerDocAccessFields_Meta_Create = {
  __typename?: 'LandingTumblerDocAccessFields_meta_Create';
  permission: Scalars['Boolean'];
};

export type LandingTumblerDocAccessFields_Meta_Delete = {
  __typename?: 'LandingTumblerDocAccessFields_meta_Delete';
  permission: Scalars['Boolean'];
};

export type LandingTumblerDocAccessFields_Meta_Fields = {
  __typename?: 'LandingTumblerDocAccessFields_meta_Fields';
  description?: Maybe<LandingTumblerDocAccessFields_Meta_Description>;
  image?: Maybe<LandingTumblerDocAccessFields_Meta_Image>;
  noIndex?: Maybe<LandingTumblerDocAccessFields_Meta_NoIndex>;
  title?: Maybe<LandingTumblerDocAccessFields_Meta_Title>;
};

export type LandingTumblerDocAccessFields_Meta_Read = {
  __typename?: 'LandingTumblerDocAccessFields_meta_Read';
  permission: Scalars['Boolean'];
};

export type LandingTumblerDocAccessFields_Meta_Update = {
  __typename?: 'LandingTumblerDocAccessFields_meta_Update';
  permission: Scalars['Boolean'];
};

export type LandingTumblerDocAccessFields_Meta_Description = {
  __typename?: 'LandingTumblerDocAccessFields_meta_description';
  create?: Maybe<LandingTumblerDocAccessFields_Meta_Description_Create>;
  delete?: Maybe<LandingTumblerDocAccessFields_Meta_Description_Delete>;
  read?: Maybe<LandingTumblerDocAccessFields_Meta_Description_Read>;
  update?: Maybe<LandingTumblerDocAccessFields_Meta_Description_Update>;
};

export type LandingTumblerDocAccessFields_Meta_Description_Create = {
  __typename?: 'LandingTumblerDocAccessFields_meta_description_Create';
  permission: Scalars['Boolean'];
};

export type LandingTumblerDocAccessFields_Meta_Description_Delete = {
  __typename?: 'LandingTumblerDocAccessFields_meta_description_Delete';
  permission: Scalars['Boolean'];
};

export type LandingTumblerDocAccessFields_Meta_Description_Read = {
  __typename?: 'LandingTumblerDocAccessFields_meta_description_Read';
  permission: Scalars['Boolean'];
};

export type LandingTumblerDocAccessFields_Meta_Description_Update = {
  __typename?: 'LandingTumblerDocAccessFields_meta_description_Update';
  permission: Scalars['Boolean'];
};

export type LandingTumblerDocAccessFields_Meta_Image = {
  __typename?: 'LandingTumblerDocAccessFields_meta_image';
  create?: Maybe<LandingTumblerDocAccessFields_Meta_Image_Create>;
  delete?: Maybe<LandingTumblerDocAccessFields_Meta_Image_Delete>;
  read?: Maybe<LandingTumblerDocAccessFields_Meta_Image_Read>;
  update?: Maybe<LandingTumblerDocAccessFields_Meta_Image_Update>;
};

export type LandingTumblerDocAccessFields_Meta_Image_Create = {
  __typename?: 'LandingTumblerDocAccessFields_meta_image_Create';
  permission: Scalars['Boolean'];
};

export type LandingTumblerDocAccessFields_Meta_Image_Delete = {
  __typename?: 'LandingTumblerDocAccessFields_meta_image_Delete';
  permission: Scalars['Boolean'];
};

export type LandingTumblerDocAccessFields_Meta_Image_Read = {
  __typename?: 'LandingTumblerDocAccessFields_meta_image_Read';
  permission: Scalars['Boolean'];
};

export type LandingTumblerDocAccessFields_Meta_Image_Update = {
  __typename?: 'LandingTumblerDocAccessFields_meta_image_Update';
  permission: Scalars['Boolean'];
};

export type LandingTumblerDocAccessFields_Meta_NoIndex = {
  __typename?: 'LandingTumblerDocAccessFields_meta_noIndex';
  create?: Maybe<LandingTumblerDocAccessFields_Meta_NoIndex_Create>;
  delete?: Maybe<LandingTumblerDocAccessFields_Meta_NoIndex_Delete>;
  read?: Maybe<LandingTumblerDocAccessFields_Meta_NoIndex_Read>;
  update?: Maybe<LandingTumblerDocAccessFields_Meta_NoIndex_Update>;
};

export type LandingTumblerDocAccessFields_Meta_NoIndex_Create = {
  __typename?: 'LandingTumblerDocAccessFields_meta_noIndex_Create';
  permission: Scalars['Boolean'];
};

export type LandingTumblerDocAccessFields_Meta_NoIndex_Delete = {
  __typename?: 'LandingTumblerDocAccessFields_meta_noIndex_Delete';
  permission: Scalars['Boolean'];
};

export type LandingTumblerDocAccessFields_Meta_NoIndex_Read = {
  __typename?: 'LandingTumblerDocAccessFields_meta_noIndex_Read';
  permission: Scalars['Boolean'];
};

export type LandingTumblerDocAccessFields_Meta_NoIndex_Update = {
  __typename?: 'LandingTumblerDocAccessFields_meta_noIndex_Update';
  permission: Scalars['Boolean'];
};

export type LandingTumblerDocAccessFields_Meta_Title = {
  __typename?: 'LandingTumblerDocAccessFields_meta_title';
  create?: Maybe<LandingTumblerDocAccessFields_Meta_Title_Create>;
  delete?: Maybe<LandingTumblerDocAccessFields_Meta_Title_Delete>;
  read?: Maybe<LandingTumblerDocAccessFields_Meta_Title_Read>;
  update?: Maybe<LandingTumblerDocAccessFields_Meta_Title_Update>;
};

export type LandingTumblerDocAccessFields_Meta_Title_Create = {
  __typename?: 'LandingTumblerDocAccessFields_meta_title_Create';
  permission: Scalars['Boolean'];
};

export type LandingTumblerDocAccessFields_Meta_Title_Delete = {
  __typename?: 'LandingTumblerDocAccessFields_meta_title_Delete';
  permission: Scalars['Boolean'];
};

export type LandingTumblerDocAccessFields_Meta_Title_Read = {
  __typename?: 'LandingTumblerDocAccessFields_meta_title_Read';
  permission: Scalars['Boolean'];
};

export type LandingTumblerDocAccessFields_Meta_Title_Update = {
  __typename?: 'LandingTumblerDocAccessFields_meta_title_Update';
  permission: Scalars['Boolean'];
};

export type LandingTumblerDocAccessFields_SelectedLandingPageSlug = {
  __typename?: 'LandingTumblerDocAccessFields_selectedLandingPageSlug';
  create?: Maybe<LandingTumblerDocAccessFields_SelectedLandingPageSlug_Create>;
  delete?: Maybe<LandingTumblerDocAccessFields_SelectedLandingPageSlug_Delete>;
  read?: Maybe<LandingTumblerDocAccessFields_SelectedLandingPageSlug_Read>;
  update?: Maybe<LandingTumblerDocAccessFields_SelectedLandingPageSlug_Update>;
};

export type LandingTumblerDocAccessFields_SelectedLandingPageSlug_Create = {
  __typename?: 'LandingTumblerDocAccessFields_selectedLandingPageSlug_Create';
  permission: Scalars['Boolean'];
};

export type LandingTumblerDocAccessFields_SelectedLandingPageSlug_Delete = {
  __typename?: 'LandingTumblerDocAccessFields_selectedLandingPageSlug_Delete';
  permission: Scalars['Boolean'];
};

export type LandingTumblerDocAccessFields_SelectedLandingPageSlug_Read = {
  __typename?: 'LandingTumblerDocAccessFields_selectedLandingPageSlug_Read';
  permission: Scalars['Boolean'];
};

export type LandingTumblerDocAccessFields_SelectedLandingPageSlug_Update = {
  __typename?: 'LandingTumblerDocAccessFields_selectedLandingPageSlug_Update';
  permission: Scalars['Boolean'];
};

export type LandingTumblerDocAccessFields_Slug = {
  __typename?: 'LandingTumblerDocAccessFields_slug';
  create?: Maybe<LandingTumblerDocAccessFields_Slug_Create>;
  delete?: Maybe<LandingTumblerDocAccessFields_Slug_Delete>;
  read?: Maybe<LandingTumblerDocAccessFields_Slug_Read>;
  update?: Maybe<LandingTumblerDocAccessFields_Slug_Update>;
};

export type LandingTumblerDocAccessFields_Slug_Create = {
  __typename?: 'LandingTumblerDocAccessFields_slug_Create';
  permission: Scalars['Boolean'];
};

export type LandingTumblerDocAccessFields_Slug_Delete = {
  __typename?: 'LandingTumblerDocAccessFields_slug_Delete';
  permission: Scalars['Boolean'];
};

export type LandingTumblerDocAccessFields_Slug_Read = {
  __typename?: 'LandingTumblerDocAccessFields_slug_Read';
  permission: Scalars['Boolean'];
};

export type LandingTumblerDocAccessFields_Slug_Update = {
  __typename?: 'LandingTumblerDocAccessFields_slug_Update';
  permission: Scalars['Boolean'];
};

export type LandingTumblerDocAccessFields_Title = {
  __typename?: 'LandingTumblerDocAccessFields_title';
  create?: Maybe<LandingTumblerDocAccessFields_Title_Create>;
  delete?: Maybe<LandingTumblerDocAccessFields_Title_Delete>;
  read?: Maybe<LandingTumblerDocAccessFields_Title_Read>;
  update?: Maybe<LandingTumblerDocAccessFields_Title_Update>;
};

export type LandingTumblerDocAccessFields_Title_Create = {
  __typename?: 'LandingTumblerDocAccessFields_title_Create';
  permission: Scalars['Boolean'];
};

export type LandingTumblerDocAccessFields_Title_Delete = {
  __typename?: 'LandingTumblerDocAccessFields_title_Delete';
  permission: Scalars['Boolean'];
};

export type LandingTumblerDocAccessFields_Title_Read = {
  __typename?: 'LandingTumblerDocAccessFields_title_Read';
  permission: Scalars['Boolean'];
};

export type LandingTumblerDocAccessFields_Title_Update = {
  __typename?: 'LandingTumblerDocAccessFields_title_Update';
  permission: Scalars['Boolean'];
};

export type LandingTumblerDocAccessFields_UpdatedAt = {
  __typename?: 'LandingTumblerDocAccessFields_updatedAt';
  create?: Maybe<LandingTumblerDocAccessFields_UpdatedAt_Create>;
  delete?: Maybe<LandingTumblerDocAccessFields_UpdatedAt_Delete>;
  read?: Maybe<LandingTumblerDocAccessFields_UpdatedAt_Read>;
  update?: Maybe<LandingTumblerDocAccessFields_UpdatedAt_Update>;
};

export type LandingTumblerDocAccessFields_UpdatedAt_Create = {
  __typename?: 'LandingTumblerDocAccessFields_updatedAt_Create';
  permission: Scalars['Boolean'];
};

export type LandingTumblerDocAccessFields_UpdatedAt_Delete = {
  __typename?: 'LandingTumblerDocAccessFields_updatedAt_Delete';
  permission: Scalars['Boolean'];
};

export type LandingTumblerDocAccessFields_UpdatedAt_Read = {
  __typename?: 'LandingTumblerDocAccessFields_updatedAt_Read';
  permission: Scalars['Boolean'];
};

export type LandingTumblerDocAccessFields_UpdatedAt_Update = {
  __typename?: 'LandingTumblerDocAccessFields_updatedAt_Update';
  permission: Scalars['Boolean'];
};

export type LandingTumblerFields = {
  __typename?: 'LandingTumblerFields';
  createdAt?: Maybe<LandingTumblerFields_CreatedAt>;
  landingPages?: Maybe<LandingTumblerFields_LandingPages>;
  meta?: Maybe<LandingTumblerFields_Meta>;
  selectedLandingPageSlug?: Maybe<LandingTumblerFields_SelectedLandingPageSlug>;
  slug?: Maybe<LandingTumblerFields_Slug>;
  title?: Maybe<LandingTumblerFields_Title>;
  updatedAt?: Maybe<LandingTumblerFields_UpdatedAt>;
};

export type LandingTumblerFields_CreatedAt = {
  __typename?: 'LandingTumblerFields_createdAt';
  create?: Maybe<LandingTumblerFields_CreatedAt_Create>;
  delete?: Maybe<LandingTumblerFields_CreatedAt_Delete>;
  read?: Maybe<LandingTumblerFields_CreatedAt_Read>;
  update?: Maybe<LandingTumblerFields_CreatedAt_Update>;
};

export type LandingTumblerFields_CreatedAt_Create = {
  __typename?: 'LandingTumblerFields_createdAt_Create';
  permission: Scalars['Boolean'];
};

export type LandingTumblerFields_CreatedAt_Delete = {
  __typename?: 'LandingTumblerFields_createdAt_Delete';
  permission: Scalars['Boolean'];
};

export type LandingTumblerFields_CreatedAt_Read = {
  __typename?: 'LandingTumblerFields_createdAt_Read';
  permission: Scalars['Boolean'];
};

export type LandingTumblerFields_CreatedAt_Update = {
  __typename?: 'LandingTumblerFields_createdAt_Update';
  permission: Scalars['Boolean'];
};

export type LandingTumblerFields_LandingPages = {
  __typename?: 'LandingTumblerFields_landingPages';
  create?: Maybe<LandingTumblerFields_LandingPages_Create>;
  delete?: Maybe<LandingTumblerFields_LandingPages_Delete>;
  fields?: Maybe<LandingTumblerFields_LandingPages_Fields>;
  read?: Maybe<LandingTumblerFields_LandingPages_Read>;
  update?: Maybe<LandingTumblerFields_LandingPages_Update>;
};

export type LandingTumblerFields_LandingPages_Create = {
  __typename?: 'LandingTumblerFields_landingPages_Create';
  permission: Scalars['Boolean'];
};

export type LandingTumblerFields_LandingPages_Delete = {
  __typename?: 'LandingTumblerFields_landingPages_Delete';
  permission: Scalars['Boolean'];
};

export type LandingTumblerFields_LandingPages_Fields = {
  __typename?: 'LandingTumblerFields_landingPages_Fields';
  id?: Maybe<LandingTumblerFields_LandingPages_Id>;
  landingPage?: Maybe<LandingTumblerFields_LandingPages_LandingPage>;
  weight?: Maybe<LandingTumblerFields_LandingPages_Weight>;
};

export type LandingTumblerFields_LandingPages_Read = {
  __typename?: 'LandingTumblerFields_landingPages_Read';
  permission: Scalars['Boolean'];
};

export type LandingTumblerFields_LandingPages_Update = {
  __typename?: 'LandingTumblerFields_landingPages_Update';
  permission: Scalars['Boolean'];
};

export type LandingTumblerFields_LandingPages_Id = {
  __typename?: 'LandingTumblerFields_landingPages_id';
  create?: Maybe<LandingTumblerFields_LandingPages_Id_Create>;
  delete?: Maybe<LandingTumblerFields_LandingPages_Id_Delete>;
  read?: Maybe<LandingTumblerFields_LandingPages_Id_Read>;
  update?: Maybe<LandingTumblerFields_LandingPages_Id_Update>;
};

export type LandingTumblerFields_LandingPages_Id_Create = {
  __typename?: 'LandingTumblerFields_landingPages_id_Create';
  permission: Scalars['Boolean'];
};

export type LandingTumblerFields_LandingPages_Id_Delete = {
  __typename?: 'LandingTumblerFields_landingPages_id_Delete';
  permission: Scalars['Boolean'];
};

export type LandingTumblerFields_LandingPages_Id_Read = {
  __typename?: 'LandingTumblerFields_landingPages_id_Read';
  permission: Scalars['Boolean'];
};

export type LandingTumblerFields_LandingPages_Id_Update = {
  __typename?: 'LandingTumblerFields_landingPages_id_Update';
  permission: Scalars['Boolean'];
};

export type LandingTumblerFields_LandingPages_LandingPage = {
  __typename?: 'LandingTumblerFields_landingPages_landingPage';
  create?: Maybe<LandingTumblerFields_LandingPages_LandingPage_Create>;
  delete?: Maybe<LandingTumblerFields_LandingPages_LandingPage_Delete>;
  read?: Maybe<LandingTumblerFields_LandingPages_LandingPage_Read>;
  update?: Maybe<LandingTumblerFields_LandingPages_LandingPage_Update>;
};

export type LandingTumblerFields_LandingPages_LandingPage_Create = {
  __typename?: 'LandingTumblerFields_landingPages_landingPage_Create';
  permission: Scalars['Boolean'];
};

export type LandingTumblerFields_LandingPages_LandingPage_Delete = {
  __typename?: 'LandingTumblerFields_landingPages_landingPage_Delete';
  permission: Scalars['Boolean'];
};

export type LandingTumblerFields_LandingPages_LandingPage_Read = {
  __typename?: 'LandingTumblerFields_landingPages_landingPage_Read';
  permission: Scalars['Boolean'];
};

export type LandingTumblerFields_LandingPages_LandingPage_Update = {
  __typename?: 'LandingTumblerFields_landingPages_landingPage_Update';
  permission: Scalars['Boolean'];
};

export type LandingTumblerFields_LandingPages_Weight = {
  __typename?: 'LandingTumblerFields_landingPages_weight';
  create?: Maybe<LandingTumblerFields_LandingPages_Weight_Create>;
  delete?: Maybe<LandingTumblerFields_LandingPages_Weight_Delete>;
  read?: Maybe<LandingTumblerFields_LandingPages_Weight_Read>;
  update?: Maybe<LandingTumblerFields_LandingPages_Weight_Update>;
};

export type LandingTumblerFields_LandingPages_Weight_Create = {
  __typename?: 'LandingTumblerFields_landingPages_weight_Create';
  permission: Scalars['Boolean'];
};

export type LandingTumblerFields_LandingPages_Weight_Delete = {
  __typename?: 'LandingTumblerFields_landingPages_weight_Delete';
  permission: Scalars['Boolean'];
};

export type LandingTumblerFields_LandingPages_Weight_Read = {
  __typename?: 'LandingTumblerFields_landingPages_weight_Read';
  permission: Scalars['Boolean'];
};

export type LandingTumblerFields_LandingPages_Weight_Update = {
  __typename?: 'LandingTumblerFields_landingPages_weight_Update';
  permission: Scalars['Boolean'];
};

export type LandingTumblerFields_Meta = {
  __typename?: 'LandingTumblerFields_meta';
  create?: Maybe<LandingTumblerFields_Meta_Create>;
  delete?: Maybe<LandingTumblerFields_Meta_Delete>;
  fields?: Maybe<LandingTumblerFields_Meta_Fields>;
  read?: Maybe<LandingTumblerFields_Meta_Read>;
  update?: Maybe<LandingTumblerFields_Meta_Update>;
};

export type LandingTumblerFields_Meta_Create = {
  __typename?: 'LandingTumblerFields_meta_Create';
  permission: Scalars['Boolean'];
};

export type LandingTumblerFields_Meta_Delete = {
  __typename?: 'LandingTumblerFields_meta_Delete';
  permission: Scalars['Boolean'];
};

export type LandingTumblerFields_Meta_Fields = {
  __typename?: 'LandingTumblerFields_meta_Fields';
  description?: Maybe<LandingTumblerFields_Meta_Description>;
  image?: Maybe<LandingTumblerFields_Meta_Image>;
  noIndex?: Maybe<LandingTumblerFields_Meta_NoIndex>;
  title?: Maybe<LandingTumblerFields_Meta_Title>;
};

export type LandingTumblerFields_Meta_Read = {
  __typename?: 'LandingTumblerFields_meta_Read';
  permission: Scalars['Boolean'];
};

export type LandingTumblerFields_Meta_Update = {
  __typename?: 'LandingTumblerFields_meta_Update';
  permission: Scalars['Boolean'];
};

export type LandingTumblerFields_Meta_Description = {
  __typename?: 'LandingTumblerFields_meta_description';
  create?: Maybe<LandingTumblerFields_Meta_Description_Create>;
  delete?: Maybe<LandingTumblerFields_Meta_Description_Delete>;
  read?: Maybe<LandingTumblerFields_Meta_Description_Read>;
  update?: Maybe<LandingTumblerFields_Meta_Description_Update>;
};

export type LandingTumblerFields_Meta_Description_Create = {
  __typename?: 'LandingTumblerFields_meta_description_Create';
  permission: Scalars['Boolean'];
};

export type LandingTumblerFields_Meta_Description_Delete = {
  __typename?: 'LandingTumblerFields_meta_description_Delete';
  permission: Scalars['Boolean'];
};

export type LandingTumblerFields_Meta_Description_Read = {
  __typename?: 'LandingTumblerFields_meta_description_Read';
  permission: Scalars['Boolean'];
};

export type LandingTumblerFields_Meta_Description_Update = {
  __typename?: 'LandingTumblerFields_meta_description_Update';
  permission: Scalars['Boolean'];
};

export type LandingTumblerFields_Meta_Image = {
  __typename?: 'LandingTumblerFields_meta_image';
  create?: Maybe<LandingTumblerFields_Meta_Image_Create>;
  delete?: Maybe<LandingTumblerFields_Meta_Image_Delete>;
  read?: Maybe<LandingTumblerFields_Meta_Image_Read>;
  update?: Maybe<LandingTumblerFields_Meta_Image_Update>;
};

export type LandingTumblerFields_Meta_Image_Create = {
  __typename?: 'LandingTumblerFields_meta_image_Create';
  permission: Scalars['Boolean'];
};

export type LandingTumblerFields_Meta_Image_Delete = {
  __typename?: 'LandingTumblerFields_meta_image_Delete';
  permission: Scalars['Boolean'];
};

export type LandingTumblerFields_Meta_Image_Read = {
  __typename?: 'LandingTumblerFields_meta_image_Read';
  permission: Scalars['Boolean'];
};

export type LandingTumblerFields_Meta_Image_Update = {
  __typename?: 'LandingTumblerFields_meta_image_Update';
  permission: Scalars['Boolean'];
};

export type LandingTumblerFields_Meta_NoIndex = {
  __typename?: 'LandingTumblerFields_meta_noIndex';
  create?: Maybe<LandingTumblerFields_Meta_NoIndex_Create>;
  delete?: Maybe<LandingTumblerFields_Meta_NoIndex_Delete>;
  read?: Maybe<LandingTumblerFields_Meta_NoIndex_Read>;
  update?: Maybe<LandingTumblerFields_Meta_NoIndex_Update>;
};

export type LandingTumblerFields_Meta_NoIndex_Create = {
  __typename?: 'LandingTumblerFields_meta_noIndex_Create';
  permission: Scalars['Boolean'];
};

export type LandingTumblerFields_Meta_NoIndex_Delete = {
  __typename?: 'LandingTumblerFields_meta_noIndex_Delete';
  permission: Scalars['Boolean'];
};

export type LandingTumblerFields_Meta_NoIndex_Read = {
  __typename?: 'LandingTumblerFields_meta_noIndex_Read';
  permission: Scalars['Boolean'];
};

export type LandingTumblerFields_Meta_NoIndex_Update = {
  __typename?: 'LandingTumblerFields_meta_noIndex_Update';
  permission: Scalars['Boolean'];
};

export type LandingTumblerFields_Meta_Title = {
  __typename?: 'LandingTumblerFields_meta_title';
  create?: Maybe<LandingTumblerFields_Meta_Title_Create>;
  delete?: Maybe<LandingTumblerFields_Meta_Title_Delete>;
  read?: Maybe<LandingTumblerFields_Meta_Title_Read>;
  update?: Maybe<LandingTumblerFields_Meta_Title_Update>;
};

export type LandingTumblerFields_Meta_Title_Create = {
  __typename?: 'LandingTumblerFields_meta_title_Create';
  permission: Scalars['Boolean'];
};

export type LandingTumblerFields_Meta_Title_Delete = {
  __typename?: 'LandingTumblerFields_meta_title_Delete';
  permission: Scalars['Boolean'];
};

export type LandingTumblerFields_Meta_Title_Read = {
  __typename?: 'LandingTumblerFields_meta_title_Read';
  permission: Scalars['Boolean'];
};

export type LandingTumblerFields_Meta_Title_Update = {
  __typename?: 'LandingTumblerFields_meta_title_Update';
  permission: Scalars['Boolean'];
};

export type LandingTumblerFields_SelectedLandingPageSlug = {
  __typename?: 'LandingTumblerFields_selectedLandingPageSlug';
  create?: Maybe<LandingTumblerFields_SelectedLandingPageSlug_Create>;
  delete?: Maybe<LandingTumblerFields_SelectedLandingPageSlug_Delete>;
  read?: Maybe<LandingTumblerFields_SelectedLandingPageSlug_Read>;
  update?: Maybe<LandingTumblerFields_SelectedLandingPageSlug_Update>;
};

export type LandingTumblerFields_SelectedLandingPageSlug_Create = {
  __typename?: 'LandingTumblerFields_selectedLandingPageSlug_Create';
  permission: Scalars['Boolean'];
};

export type LandingTumblerFields_SelectedLandingPageSlug_Delete = {
  __typename?: 'LandingTumblerFields_selectedLandingPageSlug_Delete';
  permission: Scalars['Boolean'];
};

export type LandingTumblerFields_SelectedLandingPageSlug_Read = {
  __typename?: 'LandingTumblerFields_selectedLandingPageSlug_Read';
  permission: Scalars['Boolean'];
};

export type LandingTumblerFields_SelectedLandingPageSlug_Update = {
  __typename?: 'LandingTumblerFields_selectedLandingPageSlug_Update';
  permission: Scalars['Boolean'];
};

export type LandingTumblerFields_Slug = {
  __typename?: 'LandingTumblerFields_slug';
  create?: Maybe<LandingTumblerFields_Slug_Create>;
  delete?: Maybe<LandingTumblerFields_Slug_Delete>;
  read?: Maybe<LandingTumblerFields_Slug_Read>;
  update?: Maybe<LandingTumblerFields_Slug_Update>;
};

export type LandingTumblerFields_Slug_Create = {
  __typename?: 'LandingTumblerFields_slug_Create';
  permission: Scalars['Boolean'];
};

export type LandingTumblerFields_Slug_Delete = {
  __typename?: 'LandingTumblerFields_slug_Delete';
  permission: Scalars['Boolean'];
};

export type LandingTumblerFields_Slug_Read = {
  __typename?: 'LandingTumblerFields_slug_Read';
  permission: Scalars['Boolean'];
};

export type LandingTumblerFields_Slug_Update = {
  __typename?: 'LandingTumblerFields_slug_Update';
  permission: Scalars['Boolean'];
};

export type LandingTumblerFields_Title = {
  __typename?: 'LandingTumblerFields_title';
  create?: Maybe<LandingTumblerFields_Title_Create>;
  delete?: Maybe<LandingTumblerFields_Title_Delete>;
  read?: Maybe<LandingTumblerFields_Title_Read>;
  update?: Maybe<LandingTumblerFields_Title_Update>;
};

export type LandingTumblerFields_Title_Create = {
  __typename?: 'LandingTumblerFields_title_Create';
  permission: Scalars['Boolean'];
};

export type LandingTumblerFields_Title_Delete = {
  __typename?: 'LandingTumblerFields_title_Delete';
  permission: Scalars['Boolean'];
};

export type LandingTumblerFields_Title_Read = {
  __typename?: 'LandingTumblerFields_title_Read';
  permission: Scalars['Boolean'];
};

export type LandingTumblerFields_Title_Update = {
  __typename?: 'LandingTumblerFields_title_Update';
  permission: Scalars['Boolean'];
};

export type LandingTumblerFields_UpdatedAt = {
  __typename?: 'LandingTumblerFields_updatedAt';
  create?: Maybe<LandingTumblerFields_UpdatedAt_Create>;
  delete?: Maybe<LandingTumblerFields_UpdatedAt_Delete>;
  read?: Maybe<LandingTumblerFields_UpdatedAt_Read>;
  update?: Maybe<LandingTumblerFields_UpdatedAt_Update>;
};

export type LandingTumblerFields_UpdatedAt_Create = {
  __typename?: 'LandingTumblerFields_updatedAt_Create';
  permission: Scalars['Boolean'];
};

export type LandingTumblerFields_UpdatedAt_Delete = {
  __typename?: 'LandingTumblerFields_updatedAt_Delete';
  permission: Scalars['Boolean'];
};

export type LandingTumblerFields_UpdatedAt_Read = {
  __typename?: 'LandingTumblerFields_updatedAt_Read';
  permission: Scalars['Boolean'];
};

export type LandingTumblerFields_UpdatedAt_Update = {
  __typename?: 'LandingTumblerFields_updatedAt_Update';
  permission: Scalars['Boolean'];
};

export type LandingTumblerReadAccess = {
  __typename?: 'LandingTumblerReadAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type LandingTumblerReadDocAccess = {
  __typename?: 'LandingTumblerReadDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type LandingTumblerUpdateAccess = {
  __typename?: 'LandingTumblerUpdateAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type LandingTumblerUpdateDocAccess = {
  __typename?: 'LandingTumblerUpdateDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type LandingTumbler_LandingPages = {
  __typename?: 'LandingTumbler_LandingPages';
  id?: Maybe<Scalars['String']>;
  landingPage?: Maybe<LandingPage>;
  weight?: Maybe<Scalars['Float']>;
};


export type LandingTumbler_LandingPagesLandingPageArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
};

export type LandingTumbler_Meta = {
  __typename?: 'LandingTumbler_Meta';
  description?: Maybe<Scalars['String']>;
  image?: Maybe<Media>;
  noIndex?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
};

export type LandingTumbler_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type LandingTumbler_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LandingTumbler_LandingPages__Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LandingTumbler_LandingPages__LandingPage_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  equals?: InputMaybe<Scalars['JSON']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  not_equals?: InputMaybe<Scalars['JSON']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type LandingTumbler_LandingPages__Weight_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type LandingTumbler_Meta__Description_Operator = {
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
};

export type LandingTumbler_Meta__Image_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  equals?: InputMaybe<Scalars['JSON']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  not_equals?: InputMaybe<Scalars['JSON']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type LandingTumbler_Meta__NoIndex_Operator = {
  equals?: InputMaybe<Scalars['Boolean']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  not_equals?: InputMaybe<Scalars['Boolean']>;
};

export type LandingTumbler_Meta__Title_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LandingTumbler_SelectedLandingPageSlug_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LandingTumbler_Slug_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LandingTumbler_Title_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LandingTumbler_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type LandingTumbler_Where = {
  AND?: InputMaybe<Array<InputMaybe<LandingTumbler_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<LandingTumbler_Where_Or>>>;
  createdAt?: InputMaybe<LandingTumbler_CreatedAt_Operator>;
  id?: InputMaybe<LandingTumbler_Id_Operator>;
  landingPages__id?: InputMaybe<LandingTumbler_LandingPages__Id_Operator>;
  landingPages__landingPage?: InputMaybe<LandingTumbler_LandingPages__LandingPage_Operator>;
  landingPages__weight?: InputMaybe<LandingTumbler_LandingPages__Weight_Operator>;
  meta__description?: InputMaybe<LandingTumbler_Meta__Description_Operator>;
  meta__image?: InputMaybe<LandingTumbler_Meta__Image_Operator>;
  meta__noIndex?: InputMaybe<LandingTumbler_Meta__NoIndex_Operator>;
  meta__title?: InputMaybe<LandingTumbler_Meta__Title_Operator>;
  selectedLandingPageSlug?: InputMaybe<LandingTumbler_SelectedLandingPageSlug_Operator>;
  slug?: InputMaybe<LandingTumbler_Slug_Operator>;
  title?: InputMaybe<LandingTumbler_Title_Operator>;
  updatedAt?: InputMaybe<LandingTumbler_UpdatedAt_Operator>;
};

export type LandingTumbler_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<LandingTumbler_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<LandingTumbler_Where_Or>>>;
  createdAt?: InputMaybe<LandingTumbler_CreatedAt_Operator>;
  id?: InputMaybe<LandingTumbler_Id_Operator>;
  landingPages__id?: InputMaybe<LandingTumbler_LandingPages__Id_Operator>;
  landingPages__landingPage?: InputMaybe<LandingTumbler_LandingPages__LandingPage_Operator>;
  landingPages__weight?: InputMaybe<LandingTumbler_LandingPages__Weight_Operator>;
  meta__description?: InputMaybe<LandingTumbler_Meta__Description_Operator>;
  meta__image?: InputMaybe<LandingTumbler_Meta__Image_Operator>;
  meta__noIndex?: InputMaybe<LandingTumbler_Meta__NoIndex_Operator>;
  meta__title?: InputMaybe<LandingTumbler_Meta__Title_Operator>;
  selectedLandingPageSlug?: InputMaybe<LandingTumbler_SelectedLandingPageSlug_Operator>;
  slug?: InputMaybe<LandingTumbler_Slug_Operator>;
  title?: InputMaybe<LandingTumbler_Title_Operator>;
  updatedAt?: InputMaybe<LandingTumbler_UpdatedAt_Operator>;
};

export type LandingTumbler_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<LandingTumbler_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<LandingTumbler_Where_Or>>>;
  createdAt?: InputMaybe<LandingTumbler_CreatedAt_Operator>;
  id?: InputMaybe<LandingTumbler_Id_Operator>;
  landingPages__id?: InputMaybe<LandingTumbler_LandingPages__Id_Operator>;
  landingPages__landingPage?: InputMaybe<LandingTumbler_LandingPages__LandingPage_Operator>;
  landingPages__weight?: InputMaybe<LandingTumbler_LandingPages__Weight_Operator>;
  meta__description?: InputMaybe<LandingTumbler_Meta__Description_Operator>;
  meta__image?: InputMaybe<LandingTumbler_Meta__Image_Operator>;
  meta__noIndex?: InputMaybe<LandingTumbler_Meta__NoIndex_Operator>;
  meta__title?: InputMaybe<LandingTumbler_Meta__Title_Operator>;
  selectedLandingPageSlug?: InputMaybe<LandingTumbler_SelectedLandingPageSlug_Operator>;
  slug?: InputMaybe<LandingTumbler_Slug_Operator>;
  title?: InputMaybe<LandingTumbler_Title_Operator>;
  updatedAt?: InputMaybe<LandingTumbler_UpdatedAt_Operator>;
};

export type LandingTumblers = {
  __typename?: 'LandingTumblers';
  docs?: Maybe<Array<Maybe<LandingTumbler>>>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPrevPage?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  nextPage?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  pagingCounter?: Maybe<Scalars['Int']>;
  prevPage?: Maybe<Scalars['Int']>;
  totalDocs?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
};

export type LeadForm = {
  __typename?: 'LeadForm';
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  meta?: Maybe<LeadForm_Meta>;
  slug?: Maybe<Scalars['String']>;
  sourceToken?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LeadFormBlock = {
  __typename?: 'LeadFormBlock';
  blockName?: Maybe<Scalars['String']>;
  blockType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  leadForm?: Maybe<LeadForm>;
};

export type LeadFormCreateAccess = {
  __typename?: 'LeadFormCreateAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type LeadFormCreateDocAccess = {
  __typename?: 'LeadFormCreateDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type LeadFormDeleteAccess = {
  __typename?: 'LeadFormDeleteAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type LeadFormDeleteDocAccess = {
  __typename?: 'LeadFormDeleteDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type LeadFormDocAccessFields = {
  __typename?: 'LeadFormDocAccessFields';
  createdAt?: Maybe<LeadFormDocAccessFields_CreatedAt>;
  meta?: Maybe<LeadFormDocAccessFields_Meta>;
  slug?: Maybe<LeadFormDocAccessFields_Slug>;
  sourceToken?: Maybe<LeadFormDocAccessFields_SourceToken>;
  title?: Maybe<LeadFormDocAccessFields_Title>;
  updatedAt?: Maybe<LeadFormDocAccessFields_UpdatedAt>;
};

export type LeadFormDocAccessFields_CreatedAt = {
  __typename?: 'LeadFormDocAccessFields_createdAt';
  create?: Maybe<LeadFormDocAccessFields_CreatedAt_Create>;
  delete?: Maybe<LeadFormDocAccessFields_CreatedAt_Delete>;
  read?: Maybe<LeadFormDocAccessFields_CreatedAt_Read>;
  update?: Maybe<LeadFormDocAccessFields_CreatedAt_Update>;
};

export type LeadFormDocAccessFields_CreatedAt_Create = {
  __typename?: 'LeadFormDocAccessFields_createdAt_Create';
  permission: Scalars['Boolean'];
};

export type LeadFormDocAccessFields_CreatedAt_Delete = {
  __typename?: 'LeadFormDocAccessFields_createdAt_Delete';
  permission: Scalars['Boolean'];
};

export type LeadFormDocAccessFields_CreatedAt_Read = {
  __typename?: 'LeadFormDocAccessFields_createdAt_Read';
  permission: Scalars['Boolean'];
};

export type LeadFormDocAccessFields_CreatedAt_Update = {
  __typename?: 'LeadFormDocAccessFields_createdAt_Update';
  permission: Scalars['Boolean'];
};

export type LeadFormDocAccessFields_Meta = {
  __typename?: 'LeadFormDocAccessFields_meta';
  create?: Maybe<LeadFormDocAccessFields_Meta_Create>;
  delete?: Maybe<LeadFormDocAccessFields_Meta_Delete>;
  fields?: Maybe<LeadFormDocAccessFields_Meta_Fields>;
  read?: Maybe<LeadFormDocAccessFields_Meta_Read>;
  update?: Maybe<LeadFormDocAccessFields_Meta_Update>;
};

export type LeadFormDocAccessFields_Meta_Create = {
  __typename?: 'LeadFormDocAccessFields_meta_Create';
  permission: Scalars['Boolean'];
};

export type LeadFormDocAccessFields_Meta_Delete = {
  __typename?: 'LeadFormDocAccessFields_meta_Delete';
  permission: Scalars['Boolean'];
};

export type LeadFormDocAccessFields_Meta_Fields = {
  __typename?: 'LeadFormDocAccessFields_meta_Fields';
  description?: Maybe<LeadFormDocAccessFields_Meta_Description>;
  image?: Maybe<LeadFormDocAccessFields_Meta_Image>;
  noIndex?: Maybe<LeadFormDocAccessFields_Meta_NoIndex>;
  title?: Maybe<LeadFormDocAccessFields_Meta_Title>;
};

export type LeadFormDocAccessFields_Meta_Read = {
  __typename?: 'LeadFormDocAccessFields_meta_Read';
  permission: Scalars['Boolean'];
};

export type LeadFormDocAccessFields_Meta_Update = {
  __typename?: 'LeadFormDocAccessFields_meta_Update';
  permission: Scalars['Boolean'];
};

export type LeadFormDocAccessFields_Meta_Description = {
  __typename?: 'LeadFormDocAccessFields_meta_description';
  create?: Maybe<LeadFormDocAccessFields_Meta_Description_Create>;
  delete?: Maybe<LeadFormDocAccessFields_Meta_Description_Delete>;
  read?: Maybe<LeadFormDocAccessFields_Meta_Description_Read>;
  update?: Maybe<LeadFormDocAccessFields_Meta_Description_Update>;
};

export type LeadFormDocAccessFields_Meta_Description_Create = {
  __typename?: 'LeadFormDocAccessFields_meta_description_Create';
  permission: Scalars['Boolean'];
};

export type LeadFormDocAccessFields_Meta_Description_Delete = {
  __typename?: 'LeadFormDocAccessFields_meta_description_Delete';
  permission: Scalars['Boolean'];
};

export type LeadFormDocAccessFields_Meta_Description_Read = {
  __typename?: 'LeadFormDocAccessFields_meta_description_Read';
  permission: Scalars['Boolean'];
};

export type LeadFormDocAccessFields_Meta_Description_Update = {
  __typename?: 'LeadFormDocAccessFields_meta_description_Update';
  permission: Scalars['Boolean'];
};

export type LeadFormDocAccessFields_Meta_Image = {
  __typename?: 'LeadFormDocAccessFields_meta_image';
  create?: Maybe<LeadFormDocAccessFields_Meta_Image_Create>;
  delete?: Maybe<LeadFormDocAccessFields_Meta_Image_Delete>;
  read?: Maybe<LeadFormDocAccessFields_Meta_Image_Read>;
  update?: Maybe<LeadFormDocAccessFields_Meta_Image_Update>;
};

export type LeadFormDocAccessFields_Meta_Image_Create = {
  __typename?: 'LeadFormDocAccessFields_meta_image_Create';
  permission: Scalars['Boolean'];
};

export type LeadFormDocAccessFields_Meta_Image_Delete = {
  __typename?: 'LeadFormDocAccessFields_meta_image_Delete';
  permission: Scalars['Boolean'];
};

export type LeadFormDocAccessFields_Meta_Image_Read = {
  __typename?: 'LeadFormDocAccessFields_meta_image_Read';
  permission: Scalars['Boolean'];
};

export type LeadFormDocAccessFields_Meta_Image_Update = {
  __typename?: 'LeadFormDocAccessFields_meta_image_Update';
  permission: Scalars['Boolean'];
};

export type LeadFormDocAccessFields_Meta_NoIndex = {
  __typename?: 'LeadFormDocAccessFields_meta_noIndex';
  create?: Maybe<LeadFormDocAccessFields_Meta_NoIndex_Create>;
  delete?: Maybe<LeadFormDocAccessFields_Meta_NoIndex_Delete>;
  read?: Maybe<LeadFormDocAccessFields_Meta_NoIndex_Read>;
  update?: Maybe<LeadFormDocAccessFields_Meta_NoIndex_Update>;
};

export type LeadFormDocAccessFields_Meta_NoIndex_Create = {
  __typename?: 'LeadFormDocAccessFields_meta_noIndex_Create';
  permission: Scalars['Boolean'];
};

export type LeadFormDocAccessFields_Meta_NoIndex_Delete = {
  __typename?: 'LeadFormDocAccessFields_meta_noIndex_Delete';
  permission: Scalars['Boolean'];
};

export type LeadFormDocAccessFields_Meta_NoIndex_Read = {
  __typename?: 'LeadFormDocAccessFields_meta_noIndex_Read';
  permission: Scalars['Boolean'];
};

export type LeadFormDocAccessFields_Meta_NoIndex_Update = {
  __typename?: 'LeadFormDocAccessFields_meta_noIndex_Update';
  permission: Scalars['Boolean'];
};

export type LeadFormDocAccessFields_Meta_Title = {
  __typename?: 'LeadFormDocAccessFields_meta_title';
  create?: Maybe<LeadFormDocAccessFields_Meta_Title_Create>;
  delete?: Maybe<LeadFormDocAccessFields_Meta_Title_Delete>;
  read?: Maybe<LeadFormDocAccessFields_Meta_Title_Read>;
  update?: Maybe<LeadFormDocAccessFields_Meta_Title_Update>;
};

export type LeadFormDocAccessFields_Meta_Title_Create = {
  __typename?: 'LeadFormDocAccessFields_meta_title_Create';
  permission: Scalars['Boolean'];
};

export type LeadFormDocAccessFields_Meta_Title_Delete = {
  __typename?: 'LeadFormDocAccessFields_meta_title_Delete';
  permission: Scalars['Boolean'];
};

export type LeadFormDocAccessFields_Meta_Title_Read = {
  __typename?: 'LeadFormDocAccessFields_meta_title_Read';
  permission: Scalars['Boolean'];
};

export type LeadFormDocAccessFields_Meta_Title_Update = {
  __typename?: 'LeadFormDocAccessFields_meta_title_Update';
  permission: Scalars['Boolean'];
};

export type LeadFormDocAccessFields_Slug = {
  __typename?: 'LeadFormDocAccessFields_slug';
  create?: Maybe<LeadFormDocAccessFields_Slug_Create>;
  delete?: Maybe<LeadFormDocAccessFields_Slug_Delete>;
  read?: Maybe<LeadFormDocAccessFields_Slug_Read>;
  update?: Maybe<LeadFormDocAccessFields_Slug_Update>;
};

export type LeadFormDocAccessFields_Slug_Create = {
  __typename?: 'LeadFormDocAccessFields_slug_Create';
  permission: Scalars['Boolean'];
};

export type LeadFormDocAccessFields_Slug_Delete = {
  __typename?: 'LeadFormDocAccessFields_slug_Delete';
  permission: Scalars['Boolean'];
};

export type LeadFormDocAccessFields_Slug_Read = {
  __typename?: 'LeadFormDocAccessFields_slug_Read';
  permission: Scalars['Boolean'];
};

export type LeadFormDocAccessFields_Slug_Update = {
  __typename?: 'LeadFormDocAccessFields_slug_Update';
  permission: Scalars['Boolean'];
};

export type LeadFormDocAccessFields_SourceToken = {
  __typename?: 'LeadFormDocAccessFields_sourceToken';
  create?: Maybe<LeadFormDocAccessFields_SourceToken_Create>;
  delete?: Maybe<LeadFormDocAccessFields_SourceToken_Delete>;
  read?: Maybe<LeadFormDocAccessFields_SourceToken_Read>;
  update?: Maybe<LeadFormDocAccessFields_SourceToken_Update>;
};

export type LeadFormDocAccessFields_SourceToken_Create = {
  __typename?: 'LeadFormDocAccessFields_sourceToken_Create';
  permission: Scalars['Boolean'];
};

export type LeadFormDocAccessFields_SourceToken_Delete = {
  __typename?: 'LeadFormDocAccessFields_sourceToken_Delete';
  permission: Scalars['Boolean'];
};

export type LeadFormDocAccessFields_SourceToken_Read = {
  __typename?: 'LeadFormDocAccessFields_sourceToken_Read';
  permission: Scalars['Boolean'];
};

export type LeadFormDocAccessFields_SourceToken_Update = {
  __typename?: 'LeadFormDocAccessFields_sourceToken_Update';
  permission: Scalars['Boolean'];
};

export type LeadFormDocAccessFields_Title = {
  __typename?: 'LeadFormDocAccessFields_title';
  create?: Maybe<LeadFormDocAccessFields_Title_Create>;
  delete?: Maybe<LeadFormDocAccessFields_Title_Delete>;
  read?: Maybe<LeadFormDocAccessFields_Title_Read>;
  update?: Maybe<LeadFormDocAccessFields_Title_Update>;
};

export type LeadFormDocAccessFields_Title_Create = {
  __typename?: 'LeadFormDocAccessFields_title_Create';
  permission: Scalars['Boolean'];
};

export type LeadFormDocAccessFields_Title_Delete = {
  __typename?: 'LeadFormDocAccessFields_title_Delete';
  permission: Scalars['Boolean'];
};

export type LeadFormDocAccessFields_Title_Read = {
  __typename?: 'LeadFormDocAccessFields_title_Read';
  permission: Scalars['Boolean'];
};

export type LeadFormDocAccessFields_Title_Update = {
  __typename?: 'LeadFormDocAccessFields_title_Update';
  permission: Scalars['Boolean'];
};

export type LeadFormDocAccessFields_UpdatedAt = {
  __typename?: 'LeadFormDocAccessFields_updatedAt';
  create?: Maybe<LeadFormDocAccessFields_UpdatedAt_Create>;
  delete?: Maybe<LeadFormDocAccessFields_UpdatedAt_Delete>;
  read?: Maybe<LeadFormDocAccessFields_UpdatedAt_Read>;
  update?: Maybe<LeadFormDocAccessFields_UpdatedAt_Update>;
};

export type LeadFormDocAccessFields_UpdatedAt_Create = {
  __typename?: 'LeadFormDocAccessFields_updatedAt_Create';
  permission: Scalars['Boolean'];
};

export type LeadFormDocAccessFields_UpdatedAt_Delete = {
  __typename?: 'LeadFormDocAccessFields_updatedAt_Delete';
  permission: Scalars['Boolean'];
};

export type LeadFormDocAccessFields_UpdatedAt_Read = {
  __typename?: 'LeadFormDocAccessFields_updatedAt_Read';
  permission: Scalars['Boolean'];
};

export type LeadFormDocAccessFields_UpdatedAt_Update = {
  __typename?: 'LeadFormDocAccessFields_updatedAt_Update';
  permission: Scalars['Boolean'];
};

export type LeadFormFields = {
  __typename?: 'LeadFormFields';
  createdAt?: Maybe<LeadFormFields_CreatedAt>;
  meta?: Maybe<LeadFormFields_Meta>;
  slug?: Maybe<LeadFormFields_Slug>;
  sourceToken?: Maybe<LeadFormFields_SourceToken>;
  title?: Maybe<LeadFormFields_Title>;
  updatedAt?: Maybe<LeadFormFields_UpdatedAt>;
};

export type LeadFormFields_CreatedAt = {
  __typename?: 'LeadFormFields_createdAt';
  create?: Maybe<LeadFormFields_CreatedAt_Create>;
  delete?: Maybe<LeadFormFields_CreatedAt_Delete>;
  read?: Maybe<LeadFormFields_CreatedAt_Read>;
  update?: Maybe<LeadFormFields_CreatedAt_Update>;
};

export type LeadFormFields_CreatedAt_Create = {
  __typename?: 'LeadFormFields_createdAt_Create';
  permission: Scalars['Boolean'];
};

export type LeadFormFields_CreatedAt_Delete = {
  __typename?: 'LeadFormFields_createdAt_Delete';
  permission: Scalars['Boolean'];
};

export type LeadFormFields_CreatedAt_Read = {
  __typename?: 'LeadFormFields_createdAt_Read';
  permission: Scalars['Boolean'];
};

export type LeadFormFields_CreatedAt_Update = {
  __typename?: 'LeadFormFields_createdAt_Update';
  permission: Scalars['Boolean'];
};

export type LeadFormFields_Meta = {
  __typename?: 'LeadFormFields_meta';
  create?: Maybe<LeadFormFields_Meta_Create>;
  delete?: Maybe<LeadFormFields_Meta_Delete>;
  fields?: Maybe<LeadFormFields_Meta_Fields>;
  read?: Maybe<LeadFormFields_Meta_Read>;
  update?: Maybe<LeadFormFields_Meta_Update>;
};

export type LeadFormFields_Meta_Create = {
  __typename?: 'LeadFormFields_meta_Create';
  permission: Scalars['Boolean'];
};

export type LeadFormFields_Meta_Delete = {
  __typename?: 'LeadFormFields_meta_Delete';
  permission: Scalars['Boolean'];
};

export type LeadFormFields_Meta_Fields = {
  __typename?: 'LeadFormFields_meta_Fields';
  description?: Maybe<LeadFormFields_Meta_Description>;
  image?: Maybe<LeadFormFields_Meta_Image>;
  noIndex?: Maybe<LeadFormFields_Meta_NoIndex>;
  title?: Maybe<LeadFormFields_Meta_Title>;
};

export type LeadFormFields_Meta_Read = {
  __typename?: 'LeadFormFields_meta_Read';
  permission: Scalars['Boolean'];
};

export type LeadFormFields_Meta_Update = {
  __typename?: 'LeadFormFields_meta_Update';
  permission: Scalars['Boolean'];
};

export type LeadFormFields_Meta_Description = {
  __typename?: 'LeadFormFields_meta_description';
  create?: Maybe<LeadFormFields_Meta_Description_Create>;
  delete?: Maybe<LeadFormFields_Meta_Description_Delete>;
  read?: Maybe<LeadFormFields_Meta_Description_Read>;
  update?: Maybe<LeadFormFields_Meta_Description_Update>;
};

export type LeadFormFields_Meta_Description_Create = {
  __typename?: 'LeadFormFields_meta_description_Create';
  permission: Scalars['Boolean'];
};

export type LeadFormFields_Meta_Description_Delete = {
  __typename?: 'LeadFormFields_meta_description_Delete';
  permission: Scalars['Boolean'];
};

export type LeadFormFields_Meta_Description_Read = {
  __typename?: 'LeadFormFields_meta_description_Read';
  permission: Scalars['Boolean'];
};

export type LeadFormFields_Meta_Description_Update = {
  __typename?: 'LeadFormFields_meta_description_Update';
  permission: Scalars['Boolean'];
};

export type LeadFormFields_Meta_Image = {
  __typename?: 'LeadFormFields_meta_image';
  create?: Maybe<LeadFormFields_Meta_Image_Create>;
  delete?: Maybe<LeadFormFields_Meta_Image_Delete>;
  read?: Maybe<LeadFormFields_Meta_Image_Read>;
  update?: Maybe<LeadFormFields_Meta_Image_Update>;
};

export type LeadFormFields_Meta_Image_Create = {
  __typename?: 'LeadFormFields_meta_image_Create';
  permission: Scalars['Boolean'];
};

export type LeadFormFields_Meta_Image_Delete = {
  __typename?: 'LeadFormFields_meta_image_Delete';
  permission: Scalars['Boolean'];
};

export type LeadFormFields_Meta_Image_Read = {
  __typename?: 'LeadFormFields_meta_image_Read';
  permission: Scalars['Boolean'];
};

export type LeadFormFields_Meta_Image_Update = {
  __typename?: 'LeadFormFields_meta_image_Update';
  permission: Scalars['Boolean'];
};

export type LeadFormFields_Meta_NoIndex = {
  __typename?: 'LeadFormFields_meta_noIndex';
  create?: Maybe<LeadFormFields_Meta_NoIndex_Create>;
  delete?: Maybe<LeadFormFields_Meta_NoIndex_Delete>;
  read?: Maybe<LeadFormFields_Meta_NoIndex_Read>;
  update?: Maybe<LeadFormFields_Meta_NoIndex_Update>;
};

export type LeadFormFields_Meta_NoIndex_Create = {
  __typename?: 'LeadFormFields_meta_noIndex_Create';
  permission: Scalars['Boolean'];
};

export type LeadFormFields_Meta_NoIndex_Delete = {
  __typename?: 'LeadFormFields_meta_noIndex_Delete';
  permission: Scalars['Boolean'];
};

export type LeadFormFields_Meta_NoIndex_Read = {
  __typename?: 'LeadFormFields_meta_noIndex_Read';
  permission: Scalars['Boolean'];
};

export type LeadFormFields_Meta_NoIndex_Update = {
  __typename?: 'LeadFormFields_meta_noIndex_Update';
  permission: Scalars['Boolean'];
};

export type LeadFormFields_Meta_Title = {
  __typename?: 'LeadFormFields_meta_title';
  create?: Maybe<LeadFormFields_Meta_Title_Create>;
  delete?: Maybe<LeadFormFields_Meta_Title_Delete>;
  read?: Maybe<LeadFormFields_Meta_Title_Read>;
  update?: Maybe<LeadFormFields_Meta_Title_Update>;
};

export type LeadFormFields_Meta_Title_Create = {
  __typename?: 'LeadFormFields_meta_title_Create';
  permission: Scalars['Boolean'];
};

export type LeadFormFields_Meta_Title_Delete = {
  __typename?: 'LeadFormFields_meta_title_Delete';
  permission: Scalars['Boolean'];
};

export type LeadFormFields_Meta_Title_Read = {
  __typename?: 'LeadFormFields_meta_title_Read';
  permission: Scalars['Boolean'];
};

export type LeadFormFields_Meta_Title_Update = {
  __typename?: 'LeadFormFields_meta_title_Update';
  permission: Scalars['Boolean'];
};

export type LeadFormFields_Slug = {
  __typename?: 'LeadFormFields_slug';
  create?: Maybe<LeadFormFields_Slug_Create>;
  delete?: Maybe<LeadFormFields_Slug_Delete>;
  read?: Maybe<LeadFormFields_Slug_Read>;
  update?: Maybe<LeadFormFields_Slug_Update>;
};

export type LeadFormFields_Slug_Create = {
  __typename?: 'LeadFormFields_slug_Create';
  permission: Scalars['Boolean'];
};

export type LeadFormFields_Slug_Delete = {
  __typename?: 'LeadFormFields_slug_Delete';
  permission: Scalars['Boolean'];
};

export type LeadFormFields_Slug_Read = {
  __typename?: 'LeadFormFields_slug_Read';
  permission: Scalars['Boolean'];
};

export type LeadFormFields_Slug_Update = {
  __typename?: 'LeadFormFields_slug_Update';
  permission: Scalars['Boolean'];
};

export type LeadFormFields_SourceToken = {
  __typename?: 'LeadFormFields_sourceToken';
  create?: Maybe<LeadFormFields_SourceToken_Create>;
  delete?: Maybe<LeadFormFields_SourceToken_Delete>;
  read?: Maybe<LeadFormFields_SourceToken_Read>;
  update?: Maybe<LeadFormFields_SourceToken_Update>;
};

export type LeadFormFields_SourceToken_Create = {
  __typename?: 'LeadFormFields_sourceToken_Create';
  permission: Scalars['Boolean'];
};

export type LeadFormFields_SourceToken_Delete = {
  __typename?: 'LeadFormFields_sourceToken_Delete';
  permission: Scalars['Boolean'];
};

export type LeadFormFields_SourceToken_Read = {
  __typename?: 'LeadFormFields_sourceToken_Read';
  permission: Scalars['Boolean'];
};

export type LeadFormFields_SourceToken_Update = {
  __typename?: 'LeadFormFields_sourceToken_Update';
  permission: Scalars['Boolean'];
};

export type LeadFormFields_Title = {
  __typename?: 'LeadFormFields_title';
  create?: Maybe<LeadFormFields_Title_Create>;
  delete?: Maybe<LeadFormFields_Title_Delete>;
  read?: Maybe<LeadFormFields_Title_Read>;
  update?: Maybe<LeadFormFields_Title_Update>;
};

export type LeadFormFields_Title_Create = {
  __typename?: 'LeadFormFields_title_Create';
  permission: Scalars['Boolean'];
};

export type LeadFormFields_Title_Delete = {
  __typename?: 'LeadFormFields_title_Delete';
  permission: Scalars['Boolean'];
};

export type LeadFormFields_Title_Read = {
  __typename?: 'LeadFormFields_title_Read';
  permission: Scalars['Boolean'];
};

export type LeadFormFields_Title_Update = {
  __typename?: 'LeadFormFields_title_Update';
  permission: Scalars['Boolean'];
};

export type LeadFormFields_UpdatedAt = {
  __typename?: 'LeadFormFields_updatedAt';
  create?: Maybe<LeadFormFields_UpdatedAt_Create>;
  delete?: Maybe<LeadFormFields_UpdatedAt_Delete>;
  read?: Maybe<LeadFormFields_UpdatedAt_Read>;
  update?: Maybe<LeadFormFields_UpdatedAt_Update>;
};

export type LeadFormFields_UpdatedAt_Create = {
  __typename?: 'LeadFormFields_updatedAt_Create';
  permission: Scalars['Boolean'];
};

export type LeadFormFields_UpdatedAt_Delete = {
  __typename?: 'LeadFormFields_updatedAt_Delete';
  permission: Scalars['Boolean'];
};

export type LeadFormFields_UpdatedAt_Read = {
  __typename?: 'LeadFormFields_updatedAt_Read';
  permission: Scalars['Boolean'];
};

export type LeadFormFields_UpdatedAt_Update = {
  __typename?: 'LeadFormFields_updatedAt_Update';
  permission: Scalars['Boolean'];
};

export type LeadFormReadAccess = {
  __typename?: 'LeadFormReadAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type LeadFormReadDocAccess = {
  __typename?: 'LeadFormReadDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type LeadFormUpdateAccess = {
  __typename?: 'LeadFormUpdateAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type LeadFormUpdateDocAccess = {
  __typename?: 'LeadFormUpdateDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type LeadForm_Meta = {
  __typename?: 'LeadForm_Meta';
  description?: Maybe<Scalars['String']>;
  image?: Maybe<Media>;
  noIndex?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
};

export type LeadForm_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type LeadForm_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LeadForm_Meta__Description_Operator = {
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
};

export type LeadForm_Meta__Image_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  equals?: InputMaybe<Scalars['JSON']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  not_equals?: InputMaybe<Scalars['JSON']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type LeadForm_Meta__NoIndex_Operator = {
  equals?: InputMaybe<Scalars['Boolean']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  not_equals?: InputMaybe<Scalars['Boolean']>;
};

export type LeadForm_Meta__Title_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LeadForm_Slug_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LeadForm_SourceToken_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LeadForm_Title_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LeadForm_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type LeadForm_Where = {
  AND?: InputMaybe<Array<InputMaybe<LeadForm_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<LeadForm_Where_Or>>>;
  createdAt?: InputMaybe<LeadForm_CreatedAt_Operator>;
  id?: InputMaybe<LeadForm_Id_Operator>;
  meta__description?: InputMaybe<LeadForm_Meta__Description_Operator>;
  meta__image?: InputMaybe<LeadForm_Meta__Image_Operator>;
  meta__noIndex?: InputMaybe<LeadForm_Meta__NoIndex_Operator>;
  meta__title?: InputMaybe<LeadForm_Meta__Title_Operator>;
  slug?: InputMaybe<LeadForm_Slug_Operator>;
  sourceToken?: InputMaybe<LeadForm_SourceToken_Operator>;
  title?: InputMaybe<LeadForm_Title_Operator>;
  updatedAt?: InputMaybe<LeadForm_UpdatedAt_Operator>;
};

export type LeadForm_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<LeadForm_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<LeadForm_Where_Or>>>;
  createdAt?: InputMaybe<LeadForm_CreatedAt_Operator>;
  id?: InputMaybe<LeadForm_Id_Operator>;
  meta__description?: InputMaybe<LeadForm_Meta__Description_Operator>;
  meta__image?: InputMaybe<LeadForm_Meta__Image_Operator>;
  meta__noIndex?: InputMaybe<LeadForm_Meta__NoIndex_Operator>;
  meta__title?: InputMaybe<LeadForm_Meta__Title_Operator>;
  slug?: InputMaybe<LeadForm_Slug_Operator>;
  sourceToken?: InputMaybe<LeadForm_SourceToken_Operator>;
  title?: InputMaybe<LeadForm_Title_Operator>;
  updatedAt?: InputMaybe<LeadForm_UpdatedAt_Operator>;
};

export type LeadForm_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<LeadForm_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<LeadForm_Where_Or>>>;
  createdAt?: InputMaybe<LeadForm_CreatedAt_Operator>;
  id?: InputMaybe<LeadForm_Id_Operator>;
  meta__description?: InputMaybe<LeadForm_Meta__Description_Operator>;
  meta__image?: InputMaybe<LeadForm_Meta__Image_Operator>;
  meta__noIndex?: InputMaybe<LeadForm_Meta__NoIndex_Operator>;
  meta__title?: InputMaybe<LeadForm_Meta__Title_Operator>;
  slug?: InputMaybe<LeadForm_Slug_Operator>;
  sourceToken?: InputMaybe<LeadForm_SourceToken_Operator>;
  title?: InputMaybe<LeadForm_Title_Operator>;
  updatedAt?: InputMaybe<LeadForm_UpdatedAt_Operator>;
};

export type LeadForms = {
  __typename?: 'LeadForms';
  docs?: Maybe<Array<Maybe<LeadForm>>>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPrevPage?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  nextPage?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  pagingCounter?: Maybe<Scalars['Int']>;
  prevPage?: Maybe<Scalars['Int']>;
  totalDocs?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
};

export type Link = {
  __typename?: 'Link';
  label?: Maybe<Scalars['String']>;
  reference?: Maybe<Link_Reference_Relationship>;
  type?: Maybe<Link_Type>;
  url?: Maybe<Scalars['String']>;
};


export type LinkReferenceArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
};

export type Link_Reference = Article | LeadForm | Page | Service;

export enum Link_Reference_RelationTo {
  Article = 'article',
  LeadForm = 'lead_form',
  Page = 'page',
  Service = 'service'
}

export type Link_Reference_Relationship = {
  __typename?: 'Link_Reference_Relationship';
  relationTo?: Maybe<Link_Reference_RelationTo>;
  value?: Maybe<Link_Reference>;
};

export enum Link_Type {
  External = 'external',
  Internal = 'internal'
}

export type ListWithIcon = {
  __typename?: 'ListWithIcon';
  blockName?: Maybe<Scalars['String']>;
  blockType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isHorizontal?: Maybe<Scalars['Boolean']>;
  items?: Maybe<Array<ListWithIcon_Items>>;
};

export type ListWithIcon_Items = {
  __typename?: 'ListWithIcon_Items';
  icon?: Maybe<Scalars['String']>;
  iconColor?: Maybe<ListWithIcon_Items_IconColor>;
  id?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

export enum ListWithIcon_Items_IconColor {
  Primary = 'primary',
  Secondary = 'secondary'
}

export type Lists = {
  __typename?: 'Lists';
  blockName?: Maybe<Scalars['String']>;
  blockSettings?: Maybe<BlockSettings>;
  blockType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  list?: Maybe<Array<Lists_List>>;
};

export type Lists_List = {
  __typename?: 'Lists_List';
  color?: Maybe<Lists_List_Color>;
  id?: Maybe<Scalars['String']>;
  items?: Maybe<Array<Lists_List_Items>>;
  title?: Maybe<Scalars['String']>;
};

export type Lists_List_Items = {
  __typename?: 'Lists_List_Items';
  content?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

export enum Lists_List_Color {
  Primary = 'primary',
  Secondary = 'secondary'
}

export type Media = {
  __typename?: 'Media';
  alt: Scalars['String'];
  createdAt?: Maybe<Scalars['DateTime']>;
  filename?: Maybe<Scalars['String']>;
  filesize?: Maybe<Scalars['Float']>;
  focalX?: Maybe<Scalars['Float']>;
  focalY?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  mimeType?: Maybe<Scalars['String']>;
  sizes?: Maybe<Media_Sizes>;
  thumbnailURL?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  url?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Float']>;
};

export type MediaCreateAccess = {
  __typename?: 'MediaCreateAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type MediaCreateDocAccess = {
  __typename?: 'MediaCreateDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type MediaDeleteAccess = {
  __typename?: 'MediaDeleteAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type MediaDeleteDocAccess = {
  __typename?: 'MediaDeleteDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type MediaDocAccessFields = {
  __typename?: 'MediaDocAccessFields';
  alt?: Maybe<MediaDocAccessFields_Alt>;
  createdAt?: Maybe<MediaDocAccessFields_CreatedAt>;
  filename?: Maybe<MediaDocAccessFields_Filename>;
  filesize?: Maybe<MediaDocAccessFields_Filesize>;
  focalX?: Maybe<MediaDocAccessFields_FocalX>;
  focalY?: Maybe<MediaDocAccessFields_FocalY>;
  height?: Maybe<MediaDocAccessFields_Height>;
  mimeType?: Maybe<MediaDocAccessFields_MimeType>;
  sizes?: Maybe<MediaDocAccessFields_Sizes>;
  thumbnailURL?: Maybe<MediaDocAccessFields_ThumbnailUrl>;
  updatedAt?: Maybe<MediaDocAccessFields_UpdatedAt>;
  url?: Maybe<MediaDocAccessFields_Url>;
  width?: Maybe<MediaDocAccessFields_Width>;
};

export type MediaDocAccessFields_Alt = {
  __typename?: 'MediaDocAccessFields_alt';
  create?: Maybe<MediaDocAccessFields_Alt_Create>;
  delete?: Maybe<MediaDocAccessFields_Alt_Delete>;
  read?: Maybe<MediaDocAccessFields_Alt_Read>;
  update?: Maybe<MediaDocAccessFields_Alt_Update>;
};

export type MediaDocAccessFields_Alt_Create = {
  __typename?: 'MediaDocAccessFields_alt_Create';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Alt_Delete = {
  __typename?: 'MediaDocAccessFields_alt_Delete';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Alt_Read = {
  __typename?: 'MediaDocAccessFields_alt_Read';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Alt_Update = {
  __typename?: 'MediaDocAccessFields_alt_Update';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_CreatedAt = {
  __typename?: 'MediaDocAccessFields_createdAt';
  create?: Maybe<MediaDocAccessFields_CreatedAt_Create>;
  delete?: Maybe<MediaDocAccessFields_CreatedAt_Delete>;
  read?: Maybe<MediaDocAccessFields_CreatedAt_Read>;
  update?: Maybe<MediaDocAccessFields_CreatedAt_Update>;
};

export type MediaDocAccessFields_CreatedAt_Create = {
  __typename?: 'MediaDocAccessFields_createdAt_Create';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_CreatedAt_Delete = {
  __typename?: 'MediaDocAccessFields_createdAt_Delete';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_CreatedAt_Read = {
  __typename?: 'MediaDocAccessFields_createdAt_Read';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_CreatedAt_Update = {
  __typename?: 'MediaDocAccessFields_createdAt_Update';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Filename = {
  __typename?: 'MediaDocAccessFields_filename';
  create?: Maybe<MediaDocAccessFields_Filename_Create>;
  delete?: Maybe<MediaDocAccessFields_Filename_Delete>;
  read?: Maybe<MediaDocAccessFields_Filename_Read>;
  update?: Maybe<MediaDocAccessFields_Filename_Update>;
};

export type MediaDocAccessFields_Filename_Create = {
  __typename?: 'MediaDocAccessFields_filename_Create';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Filename_Delete = {
  __typename?: 'MediaDocAccessFields_filename_Delete';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Filename_Read = {
  __typename?: 'MediaDocAccessFields_filename_Read';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Filename_Update = {
  __typename?: 'MediaDocAccessFields_filename_Update';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Filesize = {
  __typename?: 'MediaDocAccessFields_filesize';
  create?: Maybe<MediaDocAccessFields_Filesize_Create>;
  delete?: Maybe<MediaDocAccessFields_Filesize_Delete>;
  read?: Maybe<MediaDocAccessFields_Filesize_Read>;
  update?: Maybe<MediaDocAccessFields_Filesize_Update>;
};

export type MediaDocAccessFields_Filesize_Create = {
  __typename?: 'MediaDocAccessFields_filesize_Create';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Filesize_Delete = {
  __typename?: 'MediaDocAccessFields_filesize_Delete';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Filesize_Read = {
  __typename?: 'MediaDocAccessFields_filesize_Read';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Filesize_Update = {
  __typename?: 'MediaDocAccessFields_filesize_Update';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_FocalX = {
  __typename?: 'MediaDocAccessFields_focalX';
  create?: Maybe<MediaDocAccessFields_FocalX_Create>;
  delete?: Maybe<MediaDocAccessFields_FocalX_Delete>;
  read?: Maybe<MediaDocAccessFields_FocalX_Read>;
  update?: Maybe<MediaDocAccessFields_FocalX_Update>;
};

export type MediaDocAccessFields_FocalX_Create = {
  __typename?: 'MediaDocAccessFields_focalX_Create';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_FocalX_Delete = {
  __typename?: 'MediaDocAccessFields_focalX_Delete';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_FocalX_Read = {
  __typename?: 'MediaDocAccessFields_focalX_Read';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_FocalX_Update = {
  __typename?: 'MediaDocAccessFields_focalX_Update';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_FocalY = {
  __typename?: 'MediaDocAccessFields_focalY';
  create?: Maybe<MediaDocAccessFields_FocalY_Create>;
  delete?: Maybe<MediaDocAccessFields_FocalY_Delete>;
  read?: Maybe<MediaDocAccessFields_FocalY_Read>;
  update?: Maybe<MediaDocAccessFields_FocalY_Update>;
};

export type MediaDocAccessFields_FocalY_Create = {
  __typename?: 'MediaDocAccessFields_focalY_Create';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_FocalY_Delete = {
  __typename?: 'MediaDocAccessFields_focalY_Delete';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_FocalY_Read = {
  __typename?: 'MediaDocAccessFields_focalY_Read';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_FocalY_Update = {
  __typename?: 'MediaDocAccessFields_focalY_Update';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Height = {
  __typename?: 'MediaDocAccessFields_height';
  create?: Maybe<MediaDocAccessFields_Height_Create>;
  delete?: Maybe<MediaDocAccessFields_Height_Delete>;
  read?: Maybe<MediaDocAccessFields_Height_Read>;
  update?: Maybe<MediaDocAccessFields_Height_Update>;
};

export type MediaDocAccessFields_Height_Create = {
  __typename?: 'MediaDocAccessFields_height_Create';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Height_Delete = {
  __typename?: 'MediaDocAccessFields_height_Delete';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Height_Read = {
  __typename?: 'MediaDocAccessFields_height_Read';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Height_Update = {
  __typename?: 'MediaDocAccessFields_height_Update';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_MimeType = {
  __typename?: 'MediaDocAccessFields_mimeType';
  create?: Maybe<MediaDocAccessFields_MimeType_Create>;
  delete?: Maybe<MediaDocAccessFields_MimeType_Delete>;
  read?: Maybe<MediaDocAccessFields_MimeType_Read>;
  update?: Maybe<MediaDocAccessFields_MimeType_Update>;
};

export type MediaDocAccessFields_MimeType_Create = {
  __typename?: 'MediaDocAccessFields_mimeType_Create';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_MimeType_Delete = {
  __typename?: 'MediaDocAccessFields_mimeType_Delete';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_MimeType_Read = {
  __typename?: 'MediaDocAccessFields_mimeType_Read';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_MimeType_Update = {
  __typename?: 'MediaDocAccessFields_mimeType_Update';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Sizes = {
  __typename?: 'MediaDocAccessFields_sizes';
  create?: Maybe<MediaDocAccessFields_Sizes_Create>;
  delete?: Maybe<MediaDocAccessFields_Sizes_Delete>;
  fields?: Maybe<MediaDocAccessFields_Sizes_Fields>;
  read?: Maybe<MediaDocAccessFields_Sizes_Read>;
  update?: Maybe<MediaDocAccessFields_Sizes_Update>;
};

export type MediaDocAccessFields_Sizes_Create = {
  __typename?: 'MediaDocAccessFields_sizes_Create';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Sizes_Delete = {
  __typename?: 'MediaDocAccessFields_sizes_Delete';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Sizes_Fields = {
  __typename?: 'MediaDocAccessFields_sizes_Fields';
  card?: Maybe<MediaDocAccessFields_Sizes_Card>;
  feature?: Maybe<MediaDocAccessFields_Sizes_Feature>;
};

export type MediaDocAccessFields_Sizes_Read = {
  __typename?: 'MediaDocAccessFields_sizes_Read';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Sizes_Update = {
  __typename?: 'MediaDocAccessFields_sizes_Update';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Sizes_Card = {
  __typename?: 'MediaDocAccessFields_sizes_card';
  create?: Maybe<MediaDocAccessFields_Sizes_Card_Create>;
  delete?: Maybe<MediaDocAccessFields_Sizes_Card_Delete>;
  fields?: Maybe<MediaDocAccessFields_Sizes_Card_Fields>;
  read?: Maybe<MediaDocAccessFields_Sizes_Card_Read>;
  update?: Maybe<MediaDocAccessFields_Sizes_Card_Update>;
};

export type MediaDocAccessFields_Sizes_Card_Create = {
  __typename?: 'MediaDocAccessFields_sizes_card_Create';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Sizes_Card_Delete = {
  __typename?: 'MediaDocAccessFields_sizes_card_Delete';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Sizes_Card_Fields = {
  __typename?: 'MediaDocAccessFields_sizes_card_Fields';
  filename?: Maybe<MediaDocAccessFields_Sizes_Card_Filename>;
  filesize?: Maybe<MediaDocAccessFields_Sizes_Card_Filesize>;
  height?: Maybe<MediaDocAccessFields_Sizes_Card_Height>;
  mimeType?: Maybe<MediaDocAccessFields_Sizes_Card_MimeType>;
  url?: Maybe<MediaDocAccessFields_Sizes_Card_Url>;
  width?: Maybe<MediaDocAccessFields_Sizes_Card_Width>;
};

export type MediaDocAccessFields_Sizes_Card_Read = {
  __typename?: 'MediaDocAccessFields_sizes_card_Read';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Sizes_Card_Update = {
  __typename?: 'MediaDocAccessFields_sizes_card_Update';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Sizes_Card_Filename = {
  __typename?: 'MediaDocAccessFields_sizes_card_filename';
  create?: Maybe<MediaDocAccessFields_Sizes_Card_Filename_Create>;
  delete?: Maybe<MediaDocAccessFields_Sizes_Card_Filename_Delete>;
  read?: Maybe<MediaDocAccessFields_Sizes_Card_Filename_Read>;
  update?: Maybe<MediaDocAccessFields_Sizes_Card_Filename_Update>;
};

export type MediaDocAccessFields_Sizes_Card_Filename_Create = {
  __typename?: 'MediaDocAccessFields_sizes_card_filename_Create';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Sizes_Card_Filename_Delete = {
  __typename?: 'MediaDocAccessFields_sizes_card_filename_Delete';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Sizes_Card_Filename_Read = {
  __typename?: 'MediaDocAccessFields_sizes_card_filename_Read';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Sizes_Card_Filename_Update = {
  __typename?: 'MediaDocAccessFields_sizes_card_filename_Update';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Sizes_Card_Filesize = {
  __typename?: 'MediaDocAccessFields_sizes_card_filesize';
  create?: Maybe<MediaDocAccessFields_Sizes_Card_Filesize_Create>;
  delete?: Maybe<MediaDocAccessFields_Sizes_Card_Filesize_Delete>;
  read?: Maybe<MediaDocAccessFields_Sizes_Card_Filesize_Read>;
  update?: Maybe<MediaDocAccessFields_Sizes_Card_Filesize_Update>;
};

export type MediaDocAccessFields_Sizes_Card_Filesize_Create = {
  __typename?: 'MediaDocAccessFields_sizes_card_filesize_Create';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Sizes_Card_Filesize_Delete = {
  __typename?: 'MediaDocAccessFields_sizes_card_filesize_Delete';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Sizes_Card_Filesize_Read = {
  __typename?: 'MediaDocAccessFields_sizes_card_filesize_Read';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Sizes_Card_Filesize_Update = {
  __typename?: 'MediaDocAccessFields_sizes_card_filesize_Update';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Sizes_Card_Height = {
  __typename?: 'MediaDocAccessFields_sizes_card_height';
  create?: Maybe<MediaDocAccessFields_Sizes_Card_Height_Create>;
  delete?: Maybe<MediaDocAccessFields_Sizes_Card_Height_Delete>;
  read?: Maybe<MediaDocAccessFields_Sizes_Card_Height_Read>;
  update?: Maybe<MediaDocAccessFields_Sizes_Card_Height_Update>;
};

export type MediaDocAccessFields_Sizes_Card_Height_Create = {
  __typename?: 'MediaDocAccessFields_sizes_card_height_Create';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Sizes_Card_Height_Delete = {
  __typename?: 'MediaDocAccessFields_sizes_card_height_Delete';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Sizes_Card_Height_Read = {
  __typename?: 'MediaDocAccessFields_sizes_card_height_Read';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Sizes_Card_Height_Update = {
  __typename?: 'MediaDocAccessFields_sizes_card_height_Update';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Sizes_Card_MimeType = {
  __typename?: 'MediaDocAccessFields_sizes_card_mimeType';
  create?: Maybe<MediaDocAccessFields_Sizes_Card_MimeType_Create>;
  delete?: Maybe<MediaDocAccessFields_Sizes_Card_MimeType_Delete>;
  read?: Maybe<MediaDocAccessFields_Sizes_Card_MimeType_Read>;
  update?: Maybe<MediaDocAccessFields_Sizes_Card_MimeType_Update>;
};

export type MediaDocAccessFields_Sizes_Card_MimeType_Create = {
  __typename?: 'MediaDocAccessFields_sizes_card_mimeType_Create';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Sizes_Card_MimeType_Delete = {
  __typename?: 'MediaDocAccessFields_sizes_card_mimeType_Delete';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Sizes_Card_MimeType_Read = {
  __typename?: 'MediaDocAccessFields_sizes_card_mimeType_Read';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Sizes_Card_MimeType_Update = {
  __typename?: 'MediaDocAccessFields_sizes_card_mimeType_Update';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Sizes_Card_Url = {
  __typename?: 'MediaDocAccessFields_sizes_card_url';
  create?: Maybe<MediaDocAccessFields_Sizes_Card_Url_Create>;
  delete?: Maybe<MediaDocAccessFields_Sizes_Card_Url_Delete>;
  read?: Maybe<MediaDocAccessFields_Sizes_Card_Url_Read>;
  update?: Maybe<MediaDocAccessFields_Sizes_Card_Url_Update>;
};

export type MediaDocAccessFields_Sizes_Card_Url_Create = {
  __typename?: 'MediaDocAccessFields_sizes_card_url_Create';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Sizes_Card_Url_Delete = {
  __typename?: 'MediaDocAccessFields_sizes_card_url_Delete';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Sizes_Card_Url_Read = {
  __typename?: 'MediaDocAccessFields_sizes_card_url_Read';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Sizes_Card_Url_Update = {
  __typename?: 'MediaDocAccessFields_sizes_card_url_Update';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Sizes_Card_Width = {
  __typename?: 'MediaDocAccessFields_sizes_card_width';
  create?: Maybe<MediaDocAccessFields_Sizes_Card_Width_Create>;
  delete?: Maybe<MediaDocAccessFields_Sizes_Card_Width_Delete>;
  read?: Maybe<MediaDocAccessFields_Sizes_Card_Width_Read>;
  update?: Maybe<MediaDocAccessFields_Sizes_Card_Width_Update>;
};

export type MediaDocAccessFields_Sizes_Card_Width_Create = {
  __typename?: 'MediaDocAccessFields_sizes_card_width_Create';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Sizes_Card_Width_Delete = {
  __typename?: 'MediaDocAccessFields_sizes_card_width_Delete';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Sizes_Card_Width_Read = {
  __typename?: 'MediaDocAccessFields_sizes_card_width_Read';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Sizes_Card_Width_Update = {
  __typename?: 'MediaDocAccessFields_sizes_card_width_Update';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Sizes_Feature = {
  __typename?: 'MediaDocAccessFields_sizes_feature';
  create?: Maybe<MediaDocAccessFields_Sizes_Feature_Create>;
  delete?: Maybe<MediaDocAccessFields_Sizes_Feature_Delete>;
  fields?: Maybe<MediaDocAccessFields_Sizes_Feature_Fields>;
  read?: Maybe<MediaDocAccessFields_Sizes_Feature_Read>;
  update?: Maybe<MediaDocAccessFields_Sizes_Feature_Update>;
};

export type MediaDocAccessFields_Sizes_Feature_Create = {
  __typename?: 'MediaDocAccessFields_sizes_feature_Create';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Sizes_Feature_Delete = {
  __typename?: 'MediaDocAccessFields_sizes_feature_Delete';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Sizes_Feature_Fields = {
  __typename?: 'MediaDocAccessFields_sizes_feature_Fields';
  filename?: Maybe<MediaDocAccessFields_Sizes_Feature_Filename>;
  filesize?: Maybe<MediaDocAccessFields_Sizes_Feature_Filesize>;
  height?: Maybe<MediaDocAccessFields_Sizes_Feature_Height>;
  mimeType?: Maybe<MediaDocAccessFields_Sizes_Feature_MimeType>;
  url?: Maybe<MediaDocAccessFields_Sizes_Feature_Url>;
  width?: Maybe<MediaDocAccessFields_Sizes_Feature_Width>;
};

export type MediaDocAccessFields_Sizes_Feature_Read = {
  __typename?: 'MediaDocAccessFields_sizes_feature_Read';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Sizes_Feature_Update = {
  __typename?: 'MediaDocAccessFields_sizes_feature_Update';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Sizes_Feature_Filename = {
  __typename?: 'MediaDocAccessFields_sizes_feature_filename';
  create?: Maybe<MediaDocAccessFields_Sizes_Feature_Filename_Create>;
  delete?: Maybe<MediaDocAccessFields_Sizes_Feature_Filename_Delete>;
  read?: Maybe<MediaDocAccessFields_Sizes_Feature_Filename_Read>;
  update?: Maybe<MediaDocAccessFields_Sizes_Feature_Filename_Update>;
};

export type MediaDocAccessFields_Sizes_Feature_Filename_Create = {
  __typename?: 'MediaDocAccessFields_sizes_feature_filename_Create';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Sizes_Feature_Filename_Delete = {
  __typename?: 'MediaDocAccessFields_sizes_feature_filename_Delete';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Sizes_Feature_Filename_Read = {
  __typename?: 'MediaDocAccessFields_sizes_feature_filename_Read';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Sizes_Feature_Filename_Update = {
  __typename?: 'MediaDocAccessFields_sizes_feature_filename_Update';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Sizes_Feature_Filesize = {
  __typename?: 'MediaDocAccessFields_sizes_feature_filesize';
  create?: Maybe<MediaDocAccessFields_Sizes_Feature_Filesize_Create>;
  delete?: Maybe<MediaDocAccessFields_Sizes_Feature_Filesize_Delete>;
  read?: Maybe<MediaDocAccessFields_Sizes_Feature_Filesize_Read>;
  update?: Maybe<MediaDocAccessFields_Sizes_Feature_Filesize_Update>;
};

export type MediaDocAccessFields_Sizes_Feature_Filesize_Create = {
  __typename?: 'MediaDocAccessFields_sizes_feature_filesize_Create';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Sizes_Feature_Filesize_Delete = {
  __typename?: 'MediaDocAccessFields_sizes_feature_filesize_Delete';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Sizes_Feature_Filesize_Read = {
  __typename?: 'MediaDocAccessFields_sizes_feature_filesize_Read';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Sizes_Feature_Filesize_Update = {
  __typename?: 'MediaDocAccessFields_sizes_feature_filesize_Update';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Sizes_Feature_Height = {
  __typename?: 'MediaDocAccessFields_sizes_feature_height';
  create?: Maybe<MediaDocAccessFields_Sizes_Feature_Height_Create>;
  delete?: Maybe<MediaDocAccessFields_Sizes_Feature_Height_Delete>;
  read?: Maybe<MediaDocAccessFields_Sizes_Feature_Height_Read>;
  update?: Maybe<MediaDocAccessFields_Sizes_Feature_Height_Update>;
};

export type MediaDocAccessFields_Sizes_Feature_Height_Create = {
  __typename?: 'MediaDocAccessFields_sizes_feature_height_Create';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Sizes_Feature_Height_Delete = {
  __typename?: 'MediaDocAccessFields_sizes_feature_height_Delete';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Sizes_Feature_Height_Read = {
  __typename?: 'MediaDocAccessFields_sizes_feature_height_Read';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Sizes_Feature_Height_Update = {
  __typename?: 'MediaDocAccessFields_sizes_feature_height_Update';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Sizes_Feature_MimeType = {
  __typename?: 'MediaDocAccessFields_sizes_feature_mimeType';
  create?: Maybe<MediaDocAccessFields_Sizes_Feature_MimeType_Create>;
  delete?: Maybe<MediaDocAccessFields_Sizes_Feature_MimeType_Delete>;
  read?: Maybe<MediaDocAccessFields_Sizes_Feature_MimeType_Read>;
  update?: Maybe<MediaDocAccessFields_Sizes_Feature_MimeType_Update>;
};

export type MediaDocAccessFields_Sizes_Feature_MimeType_Create = {
  __typename?: 'MediaDocAccessFields_sizes_feature_mimeType_Create';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Sizes_Feature_MimeType_Delete = {
  __typename?: 'MediaDocAccessFields_sizes_feature_mimeType_Delete';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Sizes_Feature_MimeType_Read = {
  __typename?: 'MediaDocAccessFields_sizes_feature_mimeType_Read';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Sizes_Feature_MimeType_Update = {
  __typename?: 'MediaDocAccessFields_sizes_feature_mimeType_Update';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Sizes_Feature_Url = {
  __typename?: 'MediaDocAccessFields_sizes_feature_url';
  create?: Maybe<MediaDocAccessFields_Sizes_Feature_Url_Create>;
  delete?: Maybe<MediaDocAccessFields_Sizes_Feature_Url_Delete>;
  read?: Maybe<MediaDocAccessFields_Sizes_Feature_Url_Read>;
  update?: Maybe<MediaDocAccessFields_Sizes_Feature_Url_Update>;
};

export type MediaDocAccessFields_Sizes_Feature_Url_Create = {
  __typename?: 'MediaDocAccessFields_sizes_feature_url_Create';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Sizes_Feature_Url_Delete = {
  __typename?: 'MediaDocAccessFields_sizes_feature_url_Delete';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Sizes_Feature_Url_Read = {
  __typename?: 'MediaDocAccessFields_sizes_feature_url_Read';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Sizes_Feature_Url_Update = {
  __typename?: 'MediaDocAccessFields_sizes_feature_url_Update';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Sizes_Feature_Width = {
  __typename?: 'MediaDocAccessFields_sizes_feature_width';
  create?: Maybe<MediaDocAccessFields_Sizes_Feature_Width_Create>;
  delete?: Maybe<MediaDocAccessFields_Sizes_Feature_Width_Delete>;
  read?: Maybe<MediaDocAccessFields_Sizes_Feature_Width_Read>;
  update?: Maybe<MediaDocAccessFields_Sizes_Feature_Width_Update>;
};

export type MediaDocAccessFields_Sizes_Feature_Width_Create = {
  __typename?: 'MediaDocAccessFields_sizes_feature_width_Create';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Sizes_Feature_Width_Delete = {
  __typename?: 'MediaDocAccessFields_sizes_feature_width_Delete';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Sizes_Feature_Width_Read = {
  __typename?: 'MediaDocAccessFields_sizes_feature_width_Read';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Sizes_Feature_Width_Update = {
  __typename?: 'MediaDocAccessFields_sizes_feature_width_Update';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_ThumbnailUrl = {
  __typename?: 'MediaDocAccessFields_thumbnailURL';
  create?: Maybe<MediaDocAccessFields_ThumbnailUrl_Create>;
  delete?: Maybe<MediaDocAccessFields_ThumbnailUrl_Delete>;
  read?: Maybe<MediaDocAccessFields_ThumbnailUrl_Read>;
  update?: Maybe<MediaDocAccessFields_ThumbnailUrl_Update>;
};

export type MediaDocAccessFields_ThumbnailUrl_Create = {
  __typename?: 'MediaDocAccessFields_thumbnailURL_Create';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_ThumbnailUrl_Delete = {
  __typename?: 'MediaDocAccessFields_thumbnailURL_Delete';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_ThumbnailUrl_Read = {
  __typename?: 'MediaDocAccessFields_thumbnailURL_Read';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_ThumbnailUrl_Update = {
  __typename?: 'MediaDocAccessFields_thumbnailURL_Update';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_UpdatedAt = {
  __typename?: 'MediaDocAccessFields_updatedAt';
  create?: Maybe<MediaDocAccessFields_UpdatedAt_Create>;
  delete?: Maybe<MediaDocAccessFields_UpdatedAt_Delete>;
  read?: Maybe<MediaDocAccessFields_UpdatedAt_Read>;
  update?: Maybe<MediaDocAccessFields_UpdatedAt_Update>;
};

export type MediaDocAccessFields_UpdatedAt_Create = {
  __typename?: 'MediaDocAccessFields_updatedAt_Create';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_UpdatedAt_Delete = {
  __typename?: 'MediaDocAccessFields_updatedAt_Delete';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_UpdatedAt_Read = {
  __typename?: 'MediaDocAccessFields_updatedAt_Read';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_UpdatedAt_Update = {
  __typename?: 'MediaDocAccessFields_updatedAt_Update';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Url = {
  __typename?: 'MediaDocAccessFields_url';
  create?: Maybe<MediaDocAccessFields_Url_Create>;
  delete?: Maybe<MediaDocAccessFields_Url_Delete>;
  read?: Maybe<MediaDocAccessFields_Url_Read>;
  update?: Maybe<MediaDocAccessFields_Url_Update>;
};

export type MediaDocAccessFields_Url_Create = {
  __typename?: 'MediaDocAccessFields_url_Create';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Url_Delete = {
  __typename?: 'MediaDocAccessFields_url_Delete';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Url_Read = {
  __typename?: 'MediaDocAccessFields_url_Read';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Url_Update = {
  __typename?: 'MediaDocAccessFields_url_Update';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Width = {
  __typename?: 'MediaDocAccessFields_width';
  create?: Maybe<MediaDocAccessFields_Width_Create>;
  delete?: Maybe<MediaDocAccessFields_Width_Delete>;
  read?: Maybe<MediaDocAccessFields_Width_Read>;
  update?: Maybe<MediaDocAccessFields_Width_Update>;
};

export type MediaDocAccessFields_Width_Create = {
  __typename?: 'MediaDocAccessFields_width_Create';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Width_Delete = {
  __typename?: 'MediaDocAccessFields_width_Delete';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Width_Read = {
  __typename?: 'MediaDocAccessFields_width_Read';
  permission: Scalars['Boolean'];
};

export type MediaDocAccessFields_Width_Update = {
  __typename?: 'MediaDocAccessFields_width_Update';
  permission: Scalars['Boolean'];
};

export type MediaFields = {
  __typename?: 'MediaFields';
  alt?: Maybe<MediaFields_Alt>;
  createdAt?: Maybe<MediaFields_CreatedAt>;
  filename?: Maybe<MediaFields_Filename>;
  filesize?: Maybe<MediaFields_Filesize>;
  focalX?: Maybe<MediaFields_FocalX>;
  focalY?: Maybe<MediaFields_FocalY>;
  height?: Maybe<MediaFields_Height>;
  mimeType?: Maybe<MediaFields_MimeType>;
  sizes?: Maybe<MediaFields_Sizes>;
  thumbnailURL?: Maybe<MediaFields_ThumbnailUrl>;
  updatedAt?: Maybe<MediaFields_UpdatedAt>;
  url?: Maybe<MediaFields_Url>;
  width?: Maybe<MediaFields_Width>;
};

export type MediaFields_Alt = {
  __typename?: 'MediaFields_alt';
  create?: Maybe<MediaFields_Alt_Create>;
  delete?: Maybe<MediaFields_Alt_Delete>;
  read?: Maybe<MediaFields_Alt_Read>;
  update?: Maybe<MediaFields_Alt_Update>;
};

export type MediaFields_Alt_Create = {
  __typename?: 'MediaFields_alt_Create';
  permission: Scalars['Boolean'];
};

export type MediaFields_Alt_Delete = {
  __typename?: 'MediaFields_alt_Delete';
  permission: Scalars['Boolean'];
};

export type MediaFields_Alt_Read = {
  __typename?: 'MediaFields_alt_Read';
  permission: Scalars['Boolean'];
};

export type MediaFields_Alt_Update = {
  __typename?: 'MediaFields_alt_Update';
  permission: Scalars['Boolean'];
};

export type MediaFields_CreatedAt = {
  __typename?: 'MediaFields_createdAt';
  create?: Maybe<MediaFields_CreatedAt_Create>;
  delete?: Maybe<MediaFields_CreatedAt_Delete>;
  read?: Maybe<MediaFields_CreatedAt_Read>;
  update?: Maybe<MediaFields_CreatedAt_Update>;
};

export type MediaFields_CreatedAt_Create = {
  __typename?: 'MediaFields_createdAt_Create';
  permission: Scalars['Boolean'];
};

export type MediaFields_CreatedAt_Delete = {
  __typename?: 'MediaFields_createdAt_Delete';
  permission: Scalars['Boolean'];
};

export type MediaFields_CreatedAt_Read = {
  __typename?: 'MediaFields_createdAt_Read';
  permission: Scalars['Boolean'];
};

export type MediaFields_CreatedAt_Update = {
  __typename?: 'MediaFields_createdAt_Update';
  permission: Scalars['Boolean'];
};

export type MediaFields_Filename = {
  __typename?: 'MediaFields_filename';
  create?: Maybe<MediaFields_Filename_Create>;
  delete?: Maybe<MediaFields_Filename_Delete>;
  read?: Maybe<MediaFields_Filename_Read>;
  update?: Maybe<MediaFields_Filename_Update>;
};

export type MediaFields_Filename_Create = {
  __typename?: 'MediaFields_filename_Create';
  permission: Scalars['Boolean'];
};

export type MediaFields_Filename_Delete = {
  __typename?: 'MediaFields_filename_Delete';
  permission: Scalars['Boolean'];
};

export type MediaFields_Filename_Read = {
  __typename?: 'MediaFields_filename_Read';
  permission: Scalars['Boolean'];
};

export type MediaFields_Filename_Update = {
  __typename?: 'MediaFields_filename_Update';
  permission: Scalars['Boolean'];
};

export type MediaFields_Filesize = {
  __typename?: 'MediaFields_filesize';
  create?: Maybe<MediaFields_Filesize_Create>;
  delete?: Maybe<MediaFields_Filesize_Delete>;
  read?: Maybe<MediaFields_Filesize_Read>;
  update?: Maybe<MediaFields_Filesize_Update>;
};

export type MediaFields_Filesize_Create = {
  __typename?: 'MediaFields_filesize_Create';
  permission: Scalars['Boolean'];
};

export type MediaFields_Filesize_Delete = {
  __typename?: 'MediaFields_filesize_Delete';
  permission: Scalars['Boolean'];
};

export type MediaFields_Filesize_Read = {
  __typename?: 'MediaFields_filesize_Read';
  permission: Scalars['Boolean'];
};

export type MediaFields_Filesize_Update = {
  __typename?: 'MediaFields_filesize_Update';
  permission: Scalars['Boolean'];
};

export type MediaFields_FocalX = {
  __typename?: 'MediaFields_focalX';
  create?: Maybe<MediaFields_FocalX_Create>;
  delete?: Maybe<MediaFields_FocalX_Delete>;
  read?: Maybe<MediaFields_FocalX_Read>;
  update?: Maybe<MediaFields_FocalX_Update>;
};

export type MediaFields_FocalX_Create = {
  __typename?: 'MediaFields_focalX_Create';
  permission: Scalars['Boolean'];
};

export type MediaFields_FocalX_Delete = {
  __typename?: 'MediaFields_focalX_Delete';
  permission: Scalars['Boolean'];
};

export type MediaFields_FocalX_Read = {
  __typename?: 'MediaFields_focalX_Read';
  permission: Scalars['Boolean'];
};

export type MediaFields_FocalX_Update = {
  __typename?: 'MediaFields_focalX_Update';
  permission: Scalars['Boolean'];
};

export type MediaFields_FocalY = {
  __typename?: 'MediaFields_focalY';
  create?: Maybe<MediaFields_FocalY_Create>;
  delete?: Maybe<MediaFields_FocalY_Delete>;
  read?: Maybe<MediaFields_FocalY_Read>;
  update?: Maybe<MediaFields_FocalY_Update>;
};

export type MediaFields_FocalY_Create = {
  __typename?: 'MediaFields_focalY_Create';
  permission: Scalars['Boolean'];
};

export type MediaFields_FocalY_Delete = {
  __typename?: 'MediaFields_focalY_Delete';
  permission: Scalars['Boolean'];
};

export type MediaFields_FocalY_Read = {
  __typename?: 'MediaFields_focalY_Read';
  permission: Scalars['Boolean'];
};

export type MediaFields_FocalY_Update = {
  __typename?: 'MediaFields_focalY_Update';
  permission: Scalars['Boolean'];
};

export type MediaFields_Height = {
  __typename?: 'MediaFields_height';
  create?: Maybe<MediaFields_Height_Create>;
  delete?: Maybe<MediaFields_Height_Delete>;
  read?: Maybe<MediaFields_Height_Read>;
  update?: Maybe<MediaFields_Height_Update>;
};

export type MediaFields_Height_Create = {
  __typename?: 'MediaFields_height_Create';
  permission: Scalars['Boolean'];
};

export type MediaFields_Height_Delete = {
  __typename?: 'MediaFields_height_Delete';
  permission: Scalars['Boolean'];
};

export type MediaFields_Height_Read = {
  __typename?: 'MediaFields_height_Read';
  permission: Scalars['Boolean'];
};

export type MediaFields_Height_Update = {
  __typename?: 'MediaFields_height_Update';
  permission: Scalars['Boolean'];
};

export type MediaFields_MimeType = {
  __typename?: 'MediaFields_mimeType';
  create?: Maybe<MediaFields_MimeType_Create>;
  delete?: Maybe<MediaFields_MimeType_Delete>;
  read?: Maybe<MediaFields_MimeType_Read>;
  update?: Maybe<MediaFields_MimeType_Update>;
};

export type MediaFields_MimeType_Create = {
  __typename?: 'MediaFields_mimeType_Create';
  permission: Scalars['Boolean'];
};

export type MediaFields_MimeType_Delete = {
  __typename?: 'MediaFields_mimeType_Delete';
  permission: Scalars['Boolean'];
};

export type MediaFields_MimeType_Read = {
  __typename?: 'MediaFields_mimeType_Read';
  permission: Scalars['Boolean'];
};

export type MediaFields_MimeType_Update = {
  __typename?: 'MediaFields_mimeType_Update';
  permission: Scalars['Boolean'];
};

export type MediaFields_Sizes = {
  __typename?: 'MediaFields_sizes';
  create?: Maybe<MediaFields_Sizes_Create>;
  delete?: Maybe<MediaFields_Sizes_Delete>;
  fields?: Maybe<MediaFields_Sizes_Fields>;
  read?: Maybe<MediaFields_Sizes_Read>;
  update?: Maybe<MediaFields_Sizes_Update>;
};

export type MediaFields_Sizes_Create = {
  __typename?: 'MediaFields_sizes_Create';
  permission: Scalars['Boolean'];
};

export type MediaFields_Sizes_Delete = {
  __typename?: 'MediaFields_sizes_Delete';
  permission: Scalars['Boolean'];
};

export type MediaFields_Sizes_Fields = {
  __typename?: 'MediaFields_sizes_Fields';
  card?: Maybe<MediaFields_Sizes_Card>;
  feature?: Maybe<MediaFields_Sizes_Feature>;
};

export type MediaFields_Sizes_Read = {
  __typename?: 'MediaFields_sizes_Read';
  permission: Scalars['Boolean'];
};

export type MediaFields_Sizes_Update = {
  __typename?: 'MediaFields_sizes_Update';
  permission: Scalars['Boolean'];
};

export type MediaFields_Sizes_Card = {
  __typename?: 'MediaFields_sizes_card';
  create?: Maybe<MediaFields_Sizes_Card_Create>;
  delete?: Maybe<MediaFields_Sizes_Card_Delete>;
  fields?: Maybe<MediaFields_Sizes_Card_Fields>;
  read?: Maybe<MediaFields_Sizes_Card_Read>;
  update?: Maybe<MediaFields_Sizes_Card_Update>;
};

export type MediaFields_Sizes_Card_Create = {
  __typename?: 'MediaFields_sizes_card_Create';
  permission: Scalars['Boolean'];
};

export type MediaFields_Sizes_Card_Delete = {
  __typename?: 'MediaFields_sizes_card_Delete';
  permission: Scalars['Boolean'];
};

export type MediaFields_Sizes_Card_Fields = {
  __typename?: 'MediaFields_sizes_card_Fields';
  filename?: Maybe<MediaFields_Sizes_Card_Filename>;
  filesize?: Maybe<MediaFields_Sizes_Card_Filesize>;
  height?: Maybe<MediaFields_Sizes_Card_Height>;
  mimeType?: Maybe<MediaFields_Sizes_Card_MimeType>;
  url?: Maybe<MediaFields_Sizes_Card_Url>;
  width?: Maybe<MediaFields_Sizes_Card_Width>;
};

export type MediaFields_Sizes_Card_Read = {
  __typename?: 'MediaFields_sizes_card_Read';
  permission: Scalars['Boolean'];
};

export type MediaFields_Sizes_Card_Update = {
  __typename?: 'MediaFields_sizes_card_Update';
  permission: Scalars['Boolean'];
};

export type MediaFields_Sizes_Card_Filename = {
  __typename?: 'MediaFields_sizes_card_filename';
  create?: Maybe<MediaFields_Sizes_Card_Filename_Create>;
  delete?: Maybe<MediaFields_Sizes_Card_Filename_Delete>;
  read?: Maybe<MediaFields_Sizes_Card_Filename_Read>;
  update?: Maybe<MediaFields_Sizes_Card_Filename_Update>;
};

export type MediaFields_Sizes_Card_Filename_Create = {
  __typename?: 'MediaFields_sizes_card_filename_Create';
  permission: Scalars['Boolean'];
};

export type MediaFields_Sizes_Card_Filename_Delete = {
  __typename?: 'MediaFields_sizes_card_filename_Delete';
  permission: Scalars['Boolean'];
};

export type MediaFields_Sizes_Card_Filename_Read = {
  __typename?: 'MediaFields_sizes_card_filename_Read';
  permission: Scalars['Boolean'];
};

export type MediaFields_Sizes_Card_Filename_Update = {
  __typename?: 'MediaFields_sizes_card_filename_Update';
  permission: Scalars['Boolean'];
};

export type MediaFields_Sizes_Card_Filesize = {
  __typename?: 'MediaFields_sizes_card_filesize';
  create?: Maybe<MediaFields_Sizes_Card_Filesize_Create>;
  delete?: Maybe<MediaFields_Sizes_Card_Filesize_Delete>;
  read?: Maybe<MediaFields_Sizes_Card_Filesize_Read>;
  update?: Maybe<MediaFields_Sizes_Card_Filesize_Update>;
};

export type MediaFields_Sizes_Card_Filesize_Create = {
  __typename?: 'MediaFields_sizes_card_filesize_Create';
  permission: Scalars['Boolean'];
};

export type MediaFields_Sizes_Card_Filesize_Delete = {
  __typename?: 'MediaFields_sizes_card_filesize_Delete';
  permission: Scalars['Boolean'];
};

export type MediaFields_Sizes_Card_Filesize_Read = {
  __typename?: 'MediaFields_sizes_card_filesize_Read';
  permission: Scalars['Boolean'];
};

export type MediaFields_Sizes_Card_Filesize_Update = {
  __typename?: 'MediaFields_sizes_card_filesize_Update';
  permission: Scalars['Boolean'];
};

export type MediaFields_Sizes_Card_Height = {
  __typename?: 'MediaFields_sizes_card_height';
  create?: Maybe<MediaFields_Sizes_Card_Height_Create>;
  delete?: Maybe<MediaFields_Sizes_Card_Height_Delete>;
  read?: Maybe<MediaFields_Sizes_Card_Height_Read>;
  update?: Maybe<MediaFields_Sizes_Card_Height_Update>;
};

export type MediaFields_Sizes_Card_Height_Create = {
  __typename?: 'MediaFields_sizes_card_height_Create';
  permission: Scalars['Boolean'];
};

export type MediaFields_Sizes_Card_Height_Delete = {
  __typename?: 'MediaFields_sizes_card_height_Delete';
  permission: Scalars['Boolean'];
};

export type MediaFields_Sizes_Card_Height_Read = {
  __typename?: 'MediaFields_sizes_card_height_Read';
  permission: Scalars['Boolean'];
};

export type MediaFields_Sizes_Card_Height_Update = {
  __typename?: 'MediaFields_sizes_card_height_Update';
  permission: Scalars['Boolean'];
};

export type MediaFields_Sizes_Card_MimeType = {
  __typename?: 'MediaFields_sizes_card_mimeType';
  create?: Maybe<MediaFields_Sizes_Card_MimeType_Create>;
  delete?: Maybe<MediaFields_Sizes_Card_MimeType_Delete>;
  read?: Maybe<MediaFields_Sizes_Card_MimeType_Read>;
  update?: Maybe<MediaFields_Sizes_Card_MimeType_Update>;
};

export type MediaFields_Sizes_Card_MimeType_Create = {
  __typename?: 'MediaFields_sizes_card_mimeType_Create';
  permission: Scalars['Boolean'];
};

export type MediaFields_Sizes_Card_MimeType_Delete = {
  __typename?: 'MediaFields_sizes_card_mimeType_Delete';
  permission: Scalars['Boolean'];
};

export type MediaFields_Sizes_Card_MimeType_Read = {
  __typename?: 'MediaFields_sizes_card_mimeType_Read';
  permission: Scalars['Boolean'];
};

export type MediaFields_Sizes_Card_MimeType_Update = {
  __typename?: 'MediaFields_sizes_card_mimeType_Update';
  permission: Scalars['Boolean'];
};

export type MediaFields_Sizes_Card_Url = {
  __typename?: 'MediaFields_sizes_card_url';
  create?: Maybe<MediaFields_Sizes_Card_Url_Create>;
  delete?: Maybe<MediaFields_Sizes_Card_Url_Delete>;
  read?: Maybe<MediaFields_Sizes_Card_Url_Read>;
  update?: Maybe<MediaFields_Sizes_Card_Url_Update>;
};

export type MediaFields_Sizes_Card_Url_Create = {
  __typename?: 'MediaFields_sizes_card_url_Create';
  permission: Scalars['Boolean'];
};

export type MediaFields_Sizes_Card_Url_Delete = {
  __typename?: 'MediaFields_sizes_card_url_Delete';
  permission: Scalars['Boolean'];
};

export type MediaFields_Sizes_Card_Url_Read = {
  __typename?: 'MediaFields_sizes_card_url_Read';
  permission: Scalars['Boolean'];
};

export type MediaFields_Sizes_Card_Url_Update = {
  __typename?: 'MediaFields_sizes_card_url_Update';
  permission: Scalars['Boolean'];
};

export type MediaFields_Sizes_Card_Width = {
  __typename?: 'MediaFields_sizes_card_width';
  create?: Maybe<MediaFields_Sizes_Card_Width_Create>;
  delete?: Maybe<MediaFields_Sizes_Card_Width_Delete>;
  read?: Maybe<MediaFields_Sizes_Card_Width_Read>;
  update?: Maybe<MediaFields_Sizes_Card_Width_Update>;
};

export type MediaFields_Sizes_Card_Width_Create = {
  __typename?: 'MediaFields_sizes_card_width_Create';
  permission: Scalars['Boolean'];
};

export type MediaFields_Sizes_Card_Width_Delete = {
  __typename?: 'MediaFields_sizes_card_width_Delete';
  permission: Scalars['Boolean'];
};

export type MediaFields_Sizes_Card_Width_Read = {
  __typename?: 'MediaFields_sizes_card_width_Read';
  permission: Scalars['Boolean'];
};

export type MediaFields_Sizes_Card_Width_Update = {
  __typename?: 'MediaFields_sizes_card_width_Update';
  permission: Scalars['Boolean'];
};

export type MediaFields_Sizes_Feature = {
  __typename?: 'MediaFields_sizes_feature';
  create?: Maybe<MediaFields_Sizes_Feature_Create>;
  delete?: Maybe<MediaFields_Sizes_Feature_Delete>;
  fields?: Maybe<MediaFields_Sizes_Feature_Fields>;
  read?: Maybe<MediaFields_Sizes_Feature_Read>;
  update?: Maybe<MediaFields_Sizes_Feature_Update>;
};

export type MediaFields_Sizes_Feature_Create = {
  __typename?: 'MediaFields_sizes_feature_Create';
  permission: Scalars['Boolean'];
};

export type MediaFields_Sizes_Feature_Delete = {
  __typename?: 'MediaFields_sizes_feature_Delete';
  permission: Scalars['Boolean'];
};

export type MediaFields_Sizes_Feature_Fields = {
  __typename?: 'MediaFields_sizes_feature_Fields';
  filename?: Maybe<MediaFields_Sizes_Feature_Filename>;
  filesize?: Maybe<MediaFields_Sizes_Feature_Filesize>;
  height?: Maybe<MediaFields_Sizes_Feature_Height>;
  mimeType?: Maybe<MediaFields_Sizes_Feature_MimeType>;
  url?: Maybe<MediaFields_Sizes_Feature_Url>;
  width?: Maybe<MediaFields_Sizes_Feature_Width>;
};

export type MediaFields_Sizes_Feature_Read = {
  __typename?: 'MediaFields_sizes_feature_Read';
  permission: Scalars['Boolean'];
};

export type MediaFields_Sizes_Feature_Update = {
  __typename?: 'MediaFields_sizes_feature_Update';
  permission: Scalars['Boolean'];
};

export type MediaFields_Sizes_Feature_Filename = {
  __typename?: 'MediaFields_sizes_feature_filename';
  create?: Maybe<MediaFields_Sizes_Feature_Filename_Create>;
  delete?: Maybe<MediaFields_Sizes_Feature_Filename_Delete>;
  read?: Maybe<MediaFields_Sizes_Feature_Filename_Read>;
  update?: Maybe<MediaFields_Sizes_Feature_Filename_Update>;
};

export type MediaFields_Sizes_Feature_Filename_Create = {
  __typename?: 'MediaFields_sizes_feature_filename_Create';
  permission: Scalars['Boolean'];
};

export type MediaFields_Sizes_Feature_Filename_Delete = {
  __typename?: 'MediaFields_sizes_feature_filename_Delete';
  permission: Scalars['Boolean'];
};

export type MediaFields_Sizes_Feature_Filename_Read = {
  __typename?: 'MediaFields_sizes_feature_filename_Read';
  permission: Scalars['Boolean'];
};

export type MediaFields_Sizes_Feature_Filename_Update = {
  __typename?: 'MediaFields_sizes_feature_filename_Update';
  permission: Scalars['Boolean'];
};

export type MediaFields_Sizes_Feature_Filesize = {
  __typename?: 'MediaFields_sizes_feature_filesize';
  create?: Maybe<MediaFields_Sizes_Feature_Filesize_Create>;
  delete?: Maybe<MediaFields_Sizes_Feature_Filesize_Delete>;
  read?: Maybe<MediaFields_Sizes_Feature_Filesize_Read>;
  update?: Maybe<MediaFields_Sizes_Feature_Filesize_Update>;
};

export type MediaFields_Sizes_Feature_Filesize_Create = {
  __typename?: 'MediaFields_sizes_feature_filesize_Create';
  permission: Scalars['Boolean'];
};

export type MediaFields_Sizes_Feature_Filesize_Delete = {
  __typename?: 'MediaFields_sizes_feature_filesize_Delete';
  permission: Scalars['Boolean'];
};

export type MediaFields_Sizes_Feature_Filesize_Read = {
  __typename?: 'MediaFields_sizes_feature_filesize_Read';
  permission: Scalars['Boolean'];
};

export type MediaFields_Sizes_Feature_Filesize_Update = {
  __typename?: 'MediaFields_sizes_feature_filesize_Update';
  permission: Scalars['Boolean'];
};

export type MediaFields_Sizes_Feature_Height = {
  __typename?: 'MediaFields_sizes_feature_height';
  create?: Maybe<MediaFields_Sizes_Feature_Height_Create>;
  delete?: Maybe<MediaFields_Sizes_Feature_Height_Delete>;
  read?: Maybe<MediaFields_Sizes_Feature_Height_Read>;
  update?: Maybe<MediaFields_Sizes_Feature_Height_Update>;
};

export type MediaFields_Sizes_Feature_Height_Create = {
  __typename?: 'MediaFields_sizes_feature_height_Create';
  permission: Scalars['Boolean'];
};

export type MediaFields_Sizes_Feature_Height_Delete = {
  __typename?: 'MediaFields_sizes_feature_height_Delete';
  permission: Scalars['Boolean'];
};

export type MediaFields_Sizes_Feature_Height_Read = {
  __typename?: 'MediaFields_sizes_feature_height_Read';
  permission: Scalars['Boolean'];
};

export type MediaFields_Sizes_Feature_Height_Update = {
  __typename?: 'MediaFields_sizes_feature_height_Update';
  permission: Scalars['Boolean'];
};

export type MediaFields_Sizes_Feature_MimeType = {
  __typename?: 'MediaFields_sizes_feature_mimeType';
  create?: Maybe<MediaFields_Sizes_Feature_MimeType_Create>;
  delete?: Maybe<MediaFields_Sizes_Feature_MimeType_Delete>;
  read?: Maybe<MediaFields_Sizes_Feature_MimeType_Read>;
  update?: Maybe<MediaFields_Sizes_Feature_MimeType_Update>;
};

export type MediaFields_Sizes_Feature_MimeType_Create = {
  __typename?: 'MediaFields_sizes_feature_mimeType_Create';
  permission: Scalars['Boolean'];
};

export type MediaFields_Sizes_Feature_MimeType_Delete = {
  __typename?: 'MediaFields_sizes_feature_mimeType_Delete';
  permission: Scalars['Boolean'];
};

export type MediaFields_Sizes_Feature_MimeType_Read = {
  __typename?: 'MediaFields_sizes_feature_mimeType_Read';
  permission: Scalars['Boolean'];
};

export type MediaFields_Sizes_Feature_MimeType_Update = {
  __typename?: 'MediaFields_sizes_feature_mimeType_Update';
  permission: Scalars['Boolean'];
};

export type MediaFields_Sizes_Feature_Url = {
  __typename?: 'MediaFields_sizes_feature_url';
  create?: Maybe<MediaFields_Sizes_Feature_Url_Create>;
  delete?: Maybe<MediaFields_Sizes_Feature_Url_Delete>;
  read?: Maybe<MediaFields_Sizes_Feature_Url_Read>;
  update?: Maybe<MediaFields_Sizes_Feature_Url_Update>;
};

export type MediaFields_Sizes_Feature_Url_Create = {
  __typename?: 'MediaFields_sizes_feature_url_Create';
  permission: Scalars['Boolean'];
};

export type MediaFields_Sizes_Feature_Url_Delete = {
  __typename?: 'MediaFields_sizes_feature_url_Delete';
  permission: Scalars['Boolean'];
};

export type MediaFields_Sizes_Feature_Url_Read = {
  __typename?: 'MediaFields_sizes_feature_url_Read';
  permission: Scalars['Boolean'];
};

export type MediaFields_Sizes_Feature_Url_Update = {
  __typename?: 'MediaFields_sizes_feature_url_Update';
  permission: Scalars['Boolean'];
};

export type MediaFields_Sizes_Feature_Width = {
  __typename?: 'MediaFields_sizes_feature_width';
  create?: Maybe<MediaFields_Sizes_Feature_Width_Create>;
  delete?: Maybe<MediaFields_Sizes_Feature_Width_Delete>;
  read?: Maybe<MediaFields_Sizes_Feature_Width_Read>;
  update?: Maybe<MediaFields_Sizes_Feature_Width_Update>;
};

export type MediaFields_Sizes_Feature_Width_Create = {
  __typename?: 'MediaFields_sizes_feature_width_Create';
  permission: Scalars['Boolean'];
};

export type MediaFields_Sizes_Feature_Width_Delete = {
  __typename?: 'MediaFields_sizes_feature_width_Delete';
  permission: Scalars['Boolean'];
};

export type MediaFields_Sizes_Feature_Width_Read = {
  __typename?: 'MediaFields_sizes_feature_width_Read';
  permission: Scalars['Boolean'];
};

export type MediaFields_Sizes_Feature_Width_Update = {
  __typename?: 'MediaFields_sizes_feature_width_Update';
  permission: Scalars['Boolean'];
};

export type MediaFields_ThumbnailUrl = {
  __typename?: 'MediaFields_thumbnailURL';
  create?: Maybe<MediaFields_ThumbnailUrl_Create>;
  delete?: Maybe<MediaFields_ThumbnailUrl_Delete>;
  read?: Maybe<MediaFields_ThumbnailUrl_Read>;
  update?: Maybe<MediaFields_ThumbnailUrl_Update>;
};

export type MediaFields_ThumbnailUrl_Create = {
  __typename?: 'MediaFields_thumbnailURL_Create';
  permission: Scalars['Boolean'];
};

export type MediaFields_ThumbnailUrl_Delete = {
  __typename?: 'MediaFields_thumbnailURL_Delete';
  permission: Scalars['Boolean'];
};

export type MediaFields_ThumbnailUrl_Read = {
  __typename?: 'MediaFields_thumbnailURL_Read';
  permission: Scalars['Boolean'];
};

export type MediaFields_ThumbnailUrl_Update = {
  __typename?: 'MediaFields_thumbnailURL_Update';
  permission: Scalars['Boolean'];
};

export type MediaFields_UpdatedAt = {
  __typename?: 'MediaFields_updatedAt';
  create?: Maybe<MediaFields_UpdatedAt_Create>;
  delete?: Maybe<MediaFields_UpdatedAt_Delete>;
  read?: Maybe<MediaFields_UpdatedAt_Read>;
  update?: Maybe<MediaFields_UpdatedAt_Update>;
};

export type MediaFields_UpdatedAt_Create = {
  __typename?: 'MediaFields_updatedAt_Create';
  permission: Scalars['Boolean'];
};

export type MediaFields_UpdatedAt_Delete = {
  __typename?: 'MediaFields_updatedAt_Delete';
  permission: Scalars['Boolean'];
};

export type MediaFields_UpdatedAt_Read = {
  __typename?: 'MediaFields_updatedAt_Read';
  permission: Scalars['Boolean'];
};

export type MediaFields_UpdatedAt_Update = {
  __typename?: 'MediaFields_updatedAt_Update';
  permission: Scalars['Boolean'];
};

export type MediaFields_Url = {
  __typename?: 'MediaFields_url';
  create?: Maybe<MediaFields_Url_Create>;
  delete?: Maybe<MediaFields_Url_Delete>;
  read?: Maybe<MediaFields_Url_Read>;
  update?: Maybe<MediaFields_Url_Update>;
};

export type MediaFields_Url_Create = {
  __typename?: 'MediaFields_url_Create';
  permission: Scalars['Boolean'];
};

export type MediaFields_Url_Delete = {
  __typename?: 'MediaFields_url_Delete';
  permission: Scalars['Boolean'];
};

export type MediaFields_Url_Read = {
  __typename?: 'MediaFields_url_Read';
  permission: Scalars['Boolean'];
};

export type MediaFields_Url_Update = {
  __typename?: 'MediaFields_url_Update';
  permission: Scalars['Boolean'];
};

export type MediaFields_Width = {
  __typename?: 'MediaFields_width';
  create?: Maybe<MediaFields_Width_Create>;
  delete?: Maybe<MediaFields_Width_Delete>;
  read?: Maybe<MediaFields_Width_Read>;
  update?: Maybe<MediaFields_Width_Update>;
};

export type MediaFields_Width_Create = {
  __typename?: 'MediaFields_width_Create';
  permission: Scalars['Boolean'];
};

export type MediaFields_Width_Delete = {
  __typename?: 'MediaFields_width_Delete';
  permission: Scalars['Boolean'];
};

export type MediaFields_Width_Read = {
  __typename?: 'MediaFields_width_Read';
  permission: Scalars['Boolean'];
};

export type MediaFields_Width_Update = {
  __typename?: 'MediaFields_width_Update';
  permission: Scalars['Boolean'];
};

export type MediaReadAccess = {
  __typename?: 'MediaReadAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type MediaReadDocAccess = {
  __typename?: 'MediaReadDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type MediaUpdateAccess = {
  __typename?: 'MediaUpdateAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type MediaUpdateDocAccess = {
  __typename?: 'MediaUpdateDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type Media_Sizes = {
  __typename?: 'Media_Sizes';
  card?: Maybe<Media_Sizes_Card>;
  feature?: Maybe<Media_Sizes_Feature>;
};

export type Media_Sizes_Card = {
  __typename?: 'Media_Sizes_Card';
  filename?: Maybe<Scalars['String']>;
  filesize?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  mimeType?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Float']>;
};

export type Media_Sizes_Feature = {
  __typename?: 'Media_Sizes_Feature';
  filename?: Maybe<Scalars['String']>;
  filesize?: Maybe<Scalars['Float']>;
  height?: Maybe<Scalars['Float']>;
  mimeType?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
  width?: Maybe<Scalars['Float']>;
};

export type Media_Alt_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Media_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type Media_Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Media_Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Media_FocalX_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Media_FocalY_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Media_Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Media_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Media_MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Media_Sizes__Card__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Media_Sizes__Card__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Media_Sizes__Card__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Media_Sizes__Card__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Media_Sizes__Card__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Media_Sizes__Card__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Media_Sizes__Feature__Filename_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Media_Sizes__Feature__Filesize_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Media_Sizes__Feature__Height_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Media_Sizes__Feature__MimeType_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Media_Sizes__Feature__Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Media_Sizes__Feature__Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Media_ThumbnailUrl_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Media_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type Media_Url_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Media_Where = {
  AND?: InputMaybe<Array<InputMaybe<Media_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Media_Where_Or>>>;
  alt?: InputMaybe<Media_Alt_Operator>;
  createdAt?: InputMaybe<Media_CreatedAt_Operator>;
  filename?: InputMaybe<Media_Filename_Operator>;
  filesize?: InputMaybe<Media_Filesize_Operator>;
  focalX?: InputMaybe<Media_FocalX_Operator>;
  focalY?: InputMaybe<Media_FocalY_Operator>;
  height?: InputMaybe<Media_Height_Operator>;
  id?: InputMaybe<Media_Id_Operator>;
  mimeType?: InputMaybe<Media_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Media_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Media_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Media_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Media_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Media_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Media_Sizes__Card__Width_Operator>;
  sizes__feature__filename?: InputMaybe<Media_Sizes__Feature__Filename_Operator>;
  sizes__feature__filesize?: InputMaybe<Media_Sizes__Feature__Filesize_Operator>;
  sizes__feature__height?: InputMaybe<Media_Sizes__Feature__Height_Operator>;
  sizes__feature__mimeType?: InputMaybe<Media_Sizes__Feature__MimeType_Operator>;
  sizes__feature__url?: InputMaybe<Media_Sizes__Feature__Url_Operator>;
  sizes__feature__width?: InputMaybe<Media_Sizes__Feature__Width_Operator>;
  thumbnailURL?: InputMaybe<Media_ThumbnailUrl_Operator>;
  updatedAt?: InputMaybe<Media_UpdatedAt_Operator>;
  url?: InputMaybe<Media_Url_Operator>;
  width?: InputMaybe<Media_Width_Operator>;
};

export type Media_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<Media_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Media_Where_Or>>>;
  alt?: InputMaybe<Media_Alt_Operator>;
  createdAt?: InputMaybe<Media_CreatedAt_Operator>;
  filename?: InputMaybe<Media_Filename_Operator>;
  filesize?: InputMaybe<Media_Filesize_Operator>;
  focalX?: InputMaybe<Media_FocalX_Operator>;
  focalY?: InputMaybe<Media_FocalY_Operator>;
  height?: InputMaybe<Media_Height_Operator>;
  id?: InputMaybe<Media_Id_Operator>;
  mimeType?: InputMaybe<Media_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Media_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Media_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Media_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Media_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Media_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Media_Sizes__Card__Width_Operator>;
  sizes__feature__filename?: InputMaybe<Media_Sizes__Feature__Filename_Operator>;
  sizes__feature__filesize?: InputMaybe<Media_Sizes__Feature__Filesize_Operator>;
  sizes__feature__height?: InputMaybe<Media_Sizes__Feature__Height_Operator>;
  sizes__feature__mimeType?: InputMaybe<Media_Sizes__Feature__MimeType_Operator>;
  sizes__feature__url?: InputMaybe<Media_Sizes__Feature__Url_Operator>;
  sizes__feature__width?: InputMaybe<Media_Sizes__Feature__Width_Operator>;
  thumbnailURL?: InputMaybe<Media_ThumbnailUrl_Operator>;
  updatedAt?: InputMaybe<Media_UpdatedAt_Operator>;
  url?: InputMaybe<Media_Url_Operator>;
  width?: InputMaybe<Media_Width_Operator>;
};

export type Media_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<Media_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Media_Where_Or>>>;
  alt?: InputMaybe<Media_Alt_Operator>;
  createdAt?: InputMaybe<Media_CreatedAt_Operator>;
  filename?: InputMaybe<Media_Filename_Operator>;
  filesize?: InputMaybe<Media_Filesize_Operator>;
  focalX?: InputMaybe<Media_FocalX_Operator>;
  focalY?: InputMaybe<Media_FocalY_Operator>;
  height?: InputMaybe<Media_Height_Operator>;
  id?: InputMaybe<Media_Id_Operator>;
  mimeType?: InputMaybe<Media_MimeType_Operator>;
  sizes__card__filename?: InputMaybe<Media_Sizes__Card__Filename_Operator>;
  sizes__card__filesize?: InputMaybe<Media_Sizes__Card__Filesize_Operator>;
  sizes__card__height?: InputMaybe<Media_Sizes__Card__Height_Operator>;
  sizes__card__mimeType?: InputMaybe<Media_Sizes__Card__MimeType_Operator>;
  sizes__card__url?: InputMaybe<Media_Sizes__Card__Url_Operator>;
  sizes__card__width?: InputMaybe<Media_Sizes__Card__Width_Operator>;
  sizes__feature__filename?: InputMaybe<Media_Sizes__Feature__Filename_Operator>;
  sizes__feature__filesize?: InputMaybe<Media_Sizes__Feature__Filesize_Operator>;
  sizes__feature__height?: InputMaybe<Media_Sizes__Feature__Height_Operator>;
  sizes__feature__mimeType?: InputMaybe<Media_Sizes__Feature__MimeType_Operator>;
  sizes__feature__url?: InputMaybe<Media_Sizes__Feature__Url_Operator>;
  sizes__feature__width?: InputMaybe<Media_Sizes__Feature__Width_Operator>;
  thumbnailURL?: InputMaybe<Media_ThumbnailUrl_Operator>;
  updatedAt?: InputMaybe<Media_UpdatedAt_Operator>;
  url?: InputMaybe<Media_Url_Operator>;
  width?: InputMaybe<Media_Width_Operator>;
};

export type Media_Width_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Message = {
  __typename?: 'Message';
  blockName?: Maybe<Scalars['String']>;
  blockType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['JSON']>;
};


export type MessageMessageArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  createArticle?: Maybe<Article>;
  createCategory?: Maybe<Category>;
  createEpcCheckFormSubmission?: Maybe<EpcCheckFormSubmission>;
  createForm?: Maybe<Form>;
  createFormSubmission?: Maybe<FormSubmission>;
  createLandingPage?: Maybe<LandingPage>;
  createLandingTumbler?: Maybe<LandingTumbler>;
  createLeadForm?: Maybe<LeadForm>;
  createMedia?: Maybe<Media>;
  createNewsletterSubscriber?: Maybe<NewsletterSubscriber>;
  createPage?: Maybe<Page>;
  createPayloadLockedDocument?: Maybe<PayloadLockedDocument>;
  createPayloadPreference?: Maybe<PayloadPreference>;
  createService?: Maybe<Service>;
  createTag?: Maybe<Tag>;
  createUser?: Maybe<User>;
  deleteArticle?: Maybe<Article>;
  deleteCategory?: Maybe<Category>;
  deleteEpcCheckFormSubmission?: Maybe<EpcCheckFormSubmission>;
  deleteForm?: Maybe<Form>;
  deleteFormSubmission?: Maybe<FormSubmission>;
  deleteLandingPage?: Maybe<LandingPage>;
  deleteLandingTumbler?: Maybe<LandingTumbler>;
  deleteLeadForm?: Maybe<LeadForm>;
  deleteMedia?: Maybe<Media>;
  deleteNewsletterSubscriber?: Maybe<NewsletterSubscriber>;
  deletePage?: Maybe<Page>;
  deletePayloadLockedDocument?: Maybe<PayloadLockedDocument>;
  deletePayloadPreference?: Maybe<PayloadPreference>;
  deleteService?: Maybe<Service>;
  deleteTag?: Maybe<Tag>;
  deleteUser?: Maybe<User>;
  duplicateArticle?: Maybe<Article>;
  duplicateCategory?: Maybe<Category>;
  duplicateEpcCheckFormSubmission?: Maybe<EpcCheckFormSubmission>;
  duplicateForm?: Maybe<Form>;
  duplicateFormSubmission?: Maybe<FormSubmission>;
  duplicateLandingPage?: Maybe<LandingPage>;
  duplicateLandingTumbler?: Maybe<LandingTumbler>;
  duplicateLeadForm?: Maybe<LeadForm>;
  duplicateMedia?: Maybe<Media>;
  duplicateNewsletterSubscriber?: Maybe<NewsletterSubscriber>;
  duplicatePage?: Maybe<Page>;
  duplicatePayloadLockedDocument?: Maybe<PayloadLockedDocument>;
  duplicatePayloadPreference?: Maybe<PayloadPreference>;
  duplicateService?: Maybe<Service>;
  duplicateTag?: Maybe<Tag>;
  forgotPasswordUser: Scalars['Boolean'];
  loginUser?: Maybe<UserLoginResult>;
  logoutUser?: Maybe<Scalars['String']>;
  refreshTokenUser?: Maybe<UserRefreshedUser>;
  resetPasswordUser?: Maybe<UserResetPassword>;
  restoreVersionArticle?: Maybe<Article>;
  restoreVersionLandingPage?: Maybe<LandingPage>;
  restoreVersionPage?: Maybe<Page>;
  restoreVersionService?: Maybe<Service>;
  unlockUser: Scalars['Boolean'];
  updateArticle?: Maybe<Article>;
  updateCategory?: Maybe<Category>;
  updateCtaBanner?: Maybe<CtaBanner>;
  updateEpcCheckFormSubmission?: Maybe<EpcCheckFormSubmission>;
  updateFooterMenu?: Maybe<FooterMenu>;
  updateForm?: Maybe<Form>;
  updateFormSubmission?: Maybe<FormSubmission>;
  updateHeaderMenu?: Maybe<HeaderMenu>;
  updateHiddenBlock?: Maybe<HiddenBlock>;
  updateLandingPage?: Maybe<LandingPage>;
  updateLandingTumbler?: Maybe<LandingTumbler>;
  updateLeadForm?: Maybe<LeadForm>;
  updateMedia?: Maybe<Media>;
  updateNewsletterSubscriber?: Maybe<NewsletterSubscriber>;
  updatePage?: Maybe<Page>;
  updatePayloadLockedDocument?: Maybe<PayloadLockedDocument>;
  updatePayloadPreference?: Maybe<PayloadPreference>;
  updateService?: Maybe<Service>;
  updateSocialMedia?: Maybe<SocialMedia>;
  updateTag?: Maybe<Tag>;
  updateUser?: Maybe<User>;
  verifyEmailUser?: Maybe<Scalars['Boolean']>;
};


export type MutationCreateArticleArgs = {
  data: MutationArticleInput;
  draft?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateCategoryArgs = {
  data: MutationCategoryInput;
  draft?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateEpcCheckFormSubmissionArgs = {
  data: MutationEpcCheckFormSubmissionInput;
  draft?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateFormArgs = {
  data: MutationFormInput;
  draft?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateFormSubmissionArgs = {
  data: MutationFormSubmissionInput;
  draft?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateLandingPageArgs = {
  data: MutationLandingPageInput;
  draft?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateLandingTumblerArgs = {
  data: MutationLandingTumblerInput;
  draft?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateLeadFormArgs = {
  data: MutationLeadFormInput;
  draft?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateMediaArgs = {
  data: MutationMediaInput;
  draft?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateNewsletterSubscriberArgs = {
  data: MutationNewsletterSubscriberInput;
  draft?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreatePageArgs = {
  data: MutationPageInput;
  draft?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreatePayloadLockedDocumentArgs = {
  data: MutationPayloadLockedDocumentInput;
  draft?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreatePayloadPreferenceArgs = {
  data: MutationPayloadPreferenceInput;
  draft?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateServiceArgs = {
  data: MutationServiceInput;
  draft?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateTagArgs = {
  data: MutationTagInput;
  draft?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateUserArgs = {
  data: MutationUserInput;
  draft?: InputMaybe<Scalars['Boolean']>;
};


export type MutationDeleteArticleArgs = {
  id: Scalars['String'];
};


export type MutationDeleteCategoryArgs = {
  id: Scalars['String'];
};


export type MutationDeleteEpcCheckFormSubmissionArgs = {
  id: Scalars['String'];
};


export type MutationDeleteFormArgs = {
  id: Scalars['String'];
};


export type MutationDeleteFormSubmissionArgs = {
  id: Scalars['String'];
};


export type MutationDeleteLandingPageArgs = {
  id: Scalars['String'];
};


export type MutationDeleteLandingTumblerArgs = {
  id: Scalars['String'];
};


export type MutationDeleteLeadFormArgs = {
  id: Scalars['String'];
};


export type MutationDeleteMediaArgs = {
  id: Scalars['String'];
};


export type MutationDeleteNewsletterSubscriberArgs = {
  id: Scalars['String'];
};


export type MutationDeletePageArgs = {
  id: Scalars['String'];
};


export type MutationDeletePayloadLockedDocumentArgs = {
  id: Scalars['String'];
};


export type MutationDeletePayloadPreferenceArgs = {
  id: Scalars['String'];
};


export type MutationDeleteServiceArgs = {
  id: Scalars['String'];
};


export type MutationDeleteTagArgs = {
  id: Scalars['String'];
};


export type MutationDeleteUserArgs = {
  id: Scalars['String'];
};


export type MutationDuplicateArticleArgs = {
  data: MutationArticleInput;
  id: Scalars['String'];
};


export type MutationDuplicateCategoryArgs = {
  data: MutationCategoryInput;
  id: Scalars['String'];
};


export type MutationDuplicateEpcCheckFormSubmissionArgs = {
  data: MutationEpcCheckFormSubmissionInput;
  id: Scalars['String'];
};


export type MutationDuplicateFormArgs = {
  data: MutationFormInput;
  id: Scalars['String'];
};


export type MutationDuplicateFormSubmissionArgs = {
  data: MutationFormSubmissionInput;
  id: Scalars['String'];
};


export type MutationDuplicateLandingPageArgs = {
  data: MutationLandingPageInput;
  id: Scalars['String'];
};


export type MutationDuplicateLandingTumblerArgs = {
  data: MutationLandingTumblerInput;
  id: Scalars['String'];
};


export type MutationDuplicateLeadFormArgs = {
  data: MutationLeadFormInput;
  id: Scalars['String'];
};


export type MutationDuplicateMediaArgs = {
  data: MutationMediaInput;
  id: Scalars['String'];
};


export type MutationDuplicateNewsletterSubscriberArgs = {
  data: MutationNewsletterSubscriberInput;
  id: Scalars['String'];
};


export type MutationDuplicatePageArgs = {
  data: MutationPageInput;
  id: Scalars['String'];
};


export type MutationDuplicatePayloadLockedDocumentArgs = {
  data: MutationPayloadLockedDocumentInput;
  id: Scalars['String'];
};


export type MutationDuplicatePayloadPreferenceArgs = {
  data: MutationPayloadPreferenceInput;
  id: Scalars['String'];
};


export type MutationDuplicateServiceArgs = {
  data: MutationServiceInput;
  id: Scalars['String'];
};


export type MutationDuplicateTagArgs = {
  data: MutationTagInput;
  id: Scalars['String'];
};


export type MutationForgotPasswordUserArgs = {
  disableEmail?: InputMaybe<Scalars['Boolean']>;
  email: Scalars['String'];
  expiration?: InputMaybe<Scalars['Int']>;
};


export type MutationLoginUserArgs = {
  email: Scalars['String'];
  password?: InputMaybe<Scalars['String']>;
};


export type MutationResetPasswordUserArgs = {
  password?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
};


export type MutationRestoreVersionArticleArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
};


export type MutationRestoreVersionLandingPageArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
};


export type MutationRestoreVersionPageArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
};


export type MutationRestoreVersionServiceArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
};


export type MutationUnlockUserArgs = {
  email: Scalars['String'];
};


export type MutationUpdateArticleArgs = {
  autosave?: InputMaybe<Scalars['Boolean']>;
  data: MutationArticleUpdateInput;
  draft?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
};


export type MutationUpdateCategoryArgs = {
  autosave?: InputMaybe<Scalars['Boolean']>;
  data: MutationCategoryUpdateInput;
  draft?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
};


export type MutationUpdateCtaBannerArgs = {
  data: MutationCtaBannerInput;
  draft?: InputMaybe<Scalars['Boolean']>;
};


export type MutationUpdateEpcCheckFormSubmissionArgs = {
  autosave?: InputMaybe<Scalars['Boolean']>;
  data: MutationEpcCheckFormSubmissionUpdateInput;
  draft?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
};


export type MutationUpdateFooterMenuArgs = {
  data: MutationFooterMenuInput;
  draft?: InputMaybe<Scalars['Boolean']>;
};


export type MutationUpdateFormArgs = {
  autosave?: InputMaybe<Scalars['Boolean']>;
  data: MutationFormUpdateInput;
  draft?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
};


export type MutationUpdateFormSubmissionArgs = {
  autosave?: InputMaybe<Scalars['Boolean']>;
  data: MutationFormSubmissionUpdateInput;
  draft?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
};


export type MutationUpdateHeaderMenuArgs = {
  data: MutationHeaderMenuInput;
  draft?: InputMaybe<Scalars['Boolean']>;
};


export type MutationUpdateHiddenBlockArgs = {
  data: MutationHiddenBlockInput;
  draft?: InputMaybe<Scalars['Boolean']>;
};


export type MutationUpdateLandingPageArgs = {
  autosave?: InputMaybe<Scalars['Boolean']>;
  data: MutationLandingPageUpdateInput;
  draft?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
};


export type MutationUpdateLandingTumblerArgs = {
  autosave?: InputMaybe<Scalars['Boolean']>;
  data: MutationLandingTumblerUpdateInput;
  draft?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
};


export type MutationUpdateLeadFormArgs = {
  autosave?: InputMaybe<Scalars['Boolean']>;
  data: MutationLeadFormUpdateInput;
  draft?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
};


export type MutationUpdateMediaArgs = {
  autosave?: InputMaybe<Scalars['Boolean']>;
  data: MutationMediaUpdateInput;
  draft?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
};


export type MutationUpdateNewsletterSubscriberArgs = {
  autosave?: InputMaybe<Scalars['Boolean']>;
  data: MutationNewsletterSubscriberUpdateInput;
  draft?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
};


export type MutationUpdatePageArgs = {
  autosave?: InputMaybe<Scalars['Boolean']>;
  data: MutationPageUpdateInput;
  draft?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
};


export type MutationUpdatePayloadLockedDocumentArgs = {
  autosave?: InputMaybe<Scalars['Boolean']>;
  data: MutationPayloadLockedDocumentUpdateInput;
  draft?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
};


export type MutationUpdatePayloadPreferenceArgs = {
  autosave?: InputMaybe<Scalars['Boolean']>;
  data: MutationPayloadPreferenceUpdateInput;
  draft?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
};


export type MutationUpdateServiceArgs = {
  autosave?: InputMaybe<Scalars['Boolean']>;
  data: MutationServiceUpdateInput;
  draft?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
};


export type MutationUpdateSocialMediaArgs = {
  data: MutationSocialMediaInput;
  draft?: InputMaybe<Scalars['Boolean']>;
};


export type MutationUpdateTagArgs = {
  autosave?: InputMaybe<Scalars['Boolean']>;
  data: MutationTagUpdateInput;
  draft?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
};


export type MutationUpdateUserArgs = {
  autosave?: InputMaybe<Scalars['Boolean']>;
  data: MutationUserUpdateInput;
  draft?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
};


export type MutationVerifyEmailUserArgs = {
  token?: InputMaybe<Scalars['String']>;
};

export type NewsletterSubscriber = {
  __typename?: 'NewsletterSubscriber';
  createdAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['EmailAddress'];
  id: Scalars['String'];
  syncedAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type NewsletterSubscriberCreateAccess = {
  __typename?: 'NewsletterSubscriberCreateAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type NewsletterSubscriberCreateDocAccess = {
  __typename?: 'NewsletterSubscriberCreateDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type NewsletterSubscriberDeleteAccess = {
  __typename?: 'NewsletterSubscriberDeleteAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type NewsletterSubscriberDeleteDocAccess = {
  __typename?: 'NewsletterSubscriberDeleteDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type NewsletterSubscriberDocAccessFields = {
  __typename?: 'NewsletterSubscriberDocAccessFields';
  createdAt?: Maybe<NewsletterSubscriberDocAccessFields_CreatedAt>;
  email?: Maybe<NewsletterSubscriberDocAccessFields_Email>;
  syncedAt?: Maybe<NewsletterSubscriberDocAccessFields_SyncedAt>;
  updatedAt?: Maybe<NewsletterSubscriberDocAccessFields_UpdatedAt>;
};

export type NewsletterSubscriberDocAccessFields_CreatedAt = {
  __typename?: 'NewsletterSubscriberDocAccessFields_createdAt';
  create?: Maybe<NewsletterSubscriberDocAccessFields_CreatedAt_Create>;
  delete?: Maybe<NewsletterSubscriberDocAccessFields_CreatedAt_Delete>;
  read?: Maybe<NewsletterSubscriberDocAccessFields_CreatedAt_Read>;
  update?: Maybe<NewsletterSubscriberDocAccessFields_CreatedAt_Update>;
};

export type NewsletterSubscriberDocAccessFields_CreatedAt_Create = {
  __typename?: 'NewsletterSubscriberDocAccessFields_createdAt_Create';
  permission: Scalars['Boolean'];
};

export type NewsletterSubscriberDocAccessFields_CreatedAt_Delete = {
  __typename?: 'NewsletterSubscriberDocAccessFields_createdAt_Delete';
  permission: Scalars['Boolean'];
};

export type NewsletterSubscriberDocAccessFields_CreatedAt_Read = {
  __typename?: 'NewsletterSubscriberDocAccessFields_createdAt_Read';
  permission: Scalars['Boolean'];
};

export type NewsletterSubscriberDocAccessFields_CreatedAt_Update = {
  __typename?: 'NewsletterSubscriberDocAccessFields_createdAt_Update';
  permission: Scalars['Boolean'];
};

export type NewsletterSubscriberDocAccessFields_Email = {
  __typename?: 'NewsletterSubscriberDocAccessFields_email';
  create?: Maybe<NewsletterSubscriberDocAccessFields_Email_Create>;
  delete?: Maybe<NewsletterSubscriberDocAccessFields_Email_Delete>;
  read?: Maybe<NewsletterSubscriberDocAccessFields_Email_Read>;
  update?: Maybe<NewsletterSubscriberDocAccessFields_Email_Update>;
};

export type NewsletterSubscriberDocAccessFields_Email_Create = {
  __typename?: 'NewsletterSubscriberDocAccessFields_email_Create';
  permission: Scalars['Boolean'];
};

export type NewsletterSubscriberDocAccessFields_Email_Delete = {
  __typename?: 'NewsletterSubscriberDocAccessFields_email_Delete';
  permission: Scalars['Boolean'];
};

export type NewsletterSubscriberDocAccessFields_Email_Read = {
  __typename?: 'NewsletterSubscriberDocAccessFields_email_Read';
  permission: Scalars['Boolean'];
};

export type NewsletterSubscriberDocAccessFields_Email_Update = {
  __typename?: 'NewsletterSubscriberDocAccessFields_email_Update';
  permission: Scalars['Boolean'];
};

export type NewsletterSubscriberDocAccessFields_SyncedAt = {
  __typename?: 'NewsletterSubscriberDocAccessFields_syncedAt';
  create?: Maybe<NewsletterSubscriberDocAccessFields_SyncedAt_Create>;
  delete?: Maybe<NewsletterSubscriberDocAccessFields_SyncedAt_Delete>;
  read?: Maybe<NewsletterSubscriberDocAccessFields_SyncedAt_Read>;
  update?: Maybe<NewsletterSubscriberDocAccessFields_SyncedAt_Update>;
};

export type NewsletterSubscriberDocAccessFields_SyncedAt_Create = {
  __typename?: 'NewsletterSubscriberDocAccessFields_syncedAt_Create';
  permission: Scalars['Boolean'];
};

export type NewsletterSubscriberDocAccessFields_SyncedAt_Delete = {
  __typename?: 'NewsletterSubscriberDocAccessFields_syncedAt_Delete';
  permission: Scalars['Boolean'];
};

export type NewsletterSubscriberDocAccessFields_SyncedAt_Read = {
  __typename?: 'NewsletterSubscriberDocAccessFields_syncedAt_Read';
  permission: Scalars['Boolean'];
};

export type NewsletterSubscriberDocAccessFields_SyncedAt_Update = {
  __typename?: 'NewsletterSubscriberDocAccessFields_syncedAt_Update';
  permission: Scalars['Boolean'];
};

export type NewsletterSubscriberDocAccessFields_UpdatedAt = {
  __typename?: 'NewsletterSubscriberDocAccessFields_updatedAt';
  create?: Maybe<NewsletterSubscriberDocAccessFields_UpdatedAt_Create>;
  delete?: Maybe<NewsletterSubscriberDocAccessFields_UpdatedAt_Delete>;
  read?: Maybe<NewsletterSubscriberDocAccessFields_UpdatedAt_Read>;
  update?: Maybe<NewsletterSubscriberDocAccessFields_UpdatedAt_Update>;
};

export type NewsletterSubscriberDocAccessFields_UpdatedAt_Create = {
  __typename?: 'NewsletterSubscriberDocAccessFields_updatedAt_Create';
  permission: Scalars['Boolean'];
};

export type NewsletterSubscriberDocAccessFields_UpdatedAt_Delete = {
  __typename?: 'NewsletterSubscriberDocAccessFields_updatedAt_Delete';
  permission: Scalars['Boolean'];
};

export type NewsletterSubscriberDocAccessFields_UpdatedAt_Read = {
  __typename?: 'NewsletterSubscriberDocAccessFields_updatedAt_Read';
  permission: Scalars['Boolean'];
};

export type NewsletterSubscriberDocAccessFields_UpdatedAt_Update = {
  __typename?: 'NewsletterSubscriberDocAccessFields_updatedAt_Update';
  permission: Scalars['Boolean'];
};

export type NewsletterSubscriberFields = {
  __typename?: 'NewsletterSubscriberFields';
  createdAt?: Maybe<NewsletterSubscriberFields_CreatedAt>;
  email?: Maybe<NewsletterSubscriberFields_Email>;
  syncedAt?: Maybe<NewsletterSubscriberFields_SyncedAt>;
  updatedAt?: Maybe<NewsletterSubscriberFields_UpdatedAt>;
};

export type NewsletterSubscriberFields_CreatedAt = {
  __typename?: 'NewsletterSubscriberFields_createdAt';
  create?: Maybe<NewsletterSubscriberFields_CreatedAt_Create>;
  delete?: Maybe<NewsletterSubscriberFields_CreatedAt_Delete>;
  read?: Maybe<NewsletterSubscriberFields_CreatedAt_Read>;
  update?: Maybe<NewsletterSubscriberFields_CreatedAt_Update>;
};

export type NewsletterSubscriberFields_CreatedAt_Create = {
  __typename?: 'NewsletterSubscriberFields_createdAt_Create';
  permission: Scalars['Boolean'];
};

export type NewsletterSubscriberFields_CreatedAt_Delete = {
  __typename?: 'NewsletterSubscriberFields_createdAt_Delete';
  permission: Scalars['Boolean'];
};

export type NewsletterSubscriberFields_CreatedAt_Read = {
  __typename?: 'NewsletterSubscriberFields_createdAt_Read';
  permission: Scalars['Boolean'];
};

export type NewsletterSubscriberFields_CreatedAt_Update = {
  __typename?: 'NewsletterSubscriberFields_createdAt_Update';
  permission: Scalars['Boolean'];
};

export type NewsletterSubscriberFields_Email = {
  __typename?: 'NewsletterSubscriberFields_email';
  create?: Maybe<NewsletterSubscriberFields_Email_Create>;
  delete?: Maybe<NewsletterSubscriberFields_Email_Delete>;
  read?: Maybe<NewsletterSubscriberFields_Email_Read>;
  update?: Maybe<NewsletterSubscriberFields_Email_Update>;
};

export type NewsletterSubscriberFields_Email_Create = {
  __typename?: 'NewsletterSubscriberFields_email_Create';
  permission: Scalars['Boolean'];
};

export type NewsletterSubscriberFields_Email_Delete = {
  __typename?: 'NewsletterSubscriberFields_email_Delete';
  permission: Scalars['Boolean'];
};

export type NewsletterSubscriberFields_Email_Read = {
  __typename?: 'NewsletterSubscriberFields_email_Read';
  permission: Scalars['Boolean'];
};

export type NewsletterSubscriberFields_Email_Update = {
  __typename?: 'NewsletterSubscriberFields_email_Update';
  permission: Scalars['Boolean'];
};

export type NewsletterSubscriberFields_SyncedAt = {
  __typename?: 'NewsletterSubscriberFields_syncedAt';
  create?: Maybe<NewsletterSubscriberFields_SyncedAt_Create>;
  delete?: Maybe<NewsletterSubscriberFields_SyncedAt_Delete>;
  read?: Maybe<NewsletterSubscriberFields_SyncedAt_Read>;
  update?: Maybe<NewsletterSubscriberFields_SyncedAt_Update>;
};

export type NewsletterSubscriberFields_SyncedAt_Create = {
  __typename?: 'NewsletterSubscriberFields_syncedAt_Create';
  permission: Scalars['Boolean'];
};

export type NewsletterSubscriberFields_SyncedAt_Delete = {
  __typename?: 'NewsletterSubscriberFields_syncedAt_Delete';
  permission: Scalars['Boolean'];
};

export type NewsletterSubscriberFields_SyncedAt_Read = {
  __typename?: 'NewsletterSubscriberFields_syncedAt_Read';
  permission: Scalars['Boolean'];
};

export type NewsletterSubscriberFields_SyncedAt_Update = {
  __typename?: 'NewsletterSubscriberFields_syncedAt_Update';
  permission: Scalars['Boolean'];
};

export type NewsletterSubscriberFields_UpdatedAt = {
  __typename?: 'NewsletterSubscriberFields_updatedAt';
  create?: Maybe<NewsletterSubscriberFields_UpdatedAt_Create>;
  delete?: Maybe<NewsletterSubscriberFields_UpdatedAt_Delete>;
  read?: Maybe<NewsletterSubscriberFields_UpdatedAt_Read>;
  update?: Maybe<NewsletterSubscriberFields_UpdatedAt_Update>;
};

export type NewsletterSubscriberFields_UpdatedAt_Create = {
  __typename?: 'NewsletterSubscriberFields_updatedAt_Create';
  permission: Scalars['Boolean'];
};

export type NewsletterSubscriberFields_UpdatedAt_Delete = {
  __typename?: 'NewsletterSubscriberFields_updatedAt_Delete';
  permission: Scalars['Boolean'];
};

export type NewsletterSubscriberFields_UpdatedAt_Read = {
  __typename?: 'NewsletterSubscriberFields_updatedAt_Read';
  permission: Scalars['Boolean'];
};

export type NewsletterSubscriberFields_UpdatedAt_Update = {
  __typename?: 'NewsletterSubscriberFields_updatedAt_Update';
  permission: Scalars['Boolean'];
};

export type NewsletterSubscriberReadAccess = {
  __typename?: 'NewsletterSubscriberReadAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type NewsletterSubscriberReadDocAccess = {
  __typename?: 'NewsletterSubscriberReadDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type NewsletterSubscriberUpdateAccess = {
  __typename?: 'NewsletterSubscriberUpdateAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type NewsletterSubscriberUpdateDocAccess = {
  __typename?: 'NewsletterSubscriberUpdateDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type NewsletterSubscriber_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type NewsletterSubscriber_Email_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['EmailAddress']>>>;
  contains?: InputMaybe<Scalars['EmailAddress']>;
  equals?: InputMaybe<Scalars['EmailAddress']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['EmailAddress']>>>;
  like?: InputMaybe<Scalars['EmailAddress']>;
  not_equals?: InputMaybe<Scalars['EmailAddress']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['EmailAddress']>>>;
};

export type NewsletterSubscriber_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type NewsletterSubscriber_SyncedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type NewsletterSubscriber_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type NewsletterSubscriber_Where = {
  AND?: InputMaybe<Array<InputMaybe<NewsletterSubscriber_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<NewsletterSubscriber_Where_Or>>>;
  createdAt?: InputMaybe<NewsletterSubscriber_CreatedAt_Operator>;
  email?: InputMaybe<NewsletterSubscriber_Email_Operator>;
  id?: InputMaybe<NewsletterSubscriber_Id_Operator>;
  syncedAt?: InputMaybe<NewsletterSubscriber_SyncedAt_Operator>;
  updatedAt?: InputMaybe<NewsletterSubscriber_UpdatedAt_Operator>;
};

export type NewsletterSubscriber_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<NewsletterSubscriber_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<NewsletterSubscriber_Where_Or>>>;
  createdAt?: InputMaybe<NewsletterSubscriber_CreatedAt_Operator>;
  email?: InputMaybe<NewsletterSubscriber_Email_Operator>;
  id?: InputMaybe<NewsletterSubscriber_Id_Operator>;
  syncedAt?: InputMaybe<NewsletterSubscriber_SyncedAt_Operator>;
  updatedAt?: InputMaybe<NewsletterSubscriber_UpdatedAt_Operator>;
};

export type NewsletterSubscriber_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<NewsletterSubscriber_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<NewsletterSubscriber_Where_Or>>>;
  createdAt?: InputMaybe<NewsletterSubscriber_CreatedAt_Operator>;
  email?: InputMaybe<NewsletterSubscriber_Email_Operator>;
  id?: InputMaybe<NewsletterSubscriber_Id_Operator>;
  syncedAt?: InputMaybe<NewsletterSubscriber_SyncedAt_Operator>;
  updatedAt?: InputMaybe<NewsletterSubscriber_UpdatedAt_Operator>;
};

export type NewsletterSubscribers = {
  __typename?: 'NewsletterSubscribers';
  docs?: Maybe<Array<Maybe<NewsletterSubscriber>>>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPrevPage?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  nextPage?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  pagingCounter?: Maybe<Scalars['Int']>;
  prevPage?: Maybe<Scalars['Int']>;
  totalDocs?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
};

export type Number = {
  __typename?: 'Number';
  blockName?: Maybe<Scalars['String']>;
  blockType?: Maybe<Scalars['String']>;
  defaultValue?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  required?: Maybe<Scalars['Boolean']>;
  width?: Maybe<Scalars['Float']>;
};

export type Page = {
  __typename?: 'Page';
  _status?: Maybe<Page__Status>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['JSON']>;
  header?: Maybe<Page_Header>;
  id: Scalars['String'];
  isArticle?: Maybe<Scalars['Boolean']>;
  isPlaceholder?: Maybe<Scalars['Boolean']>;
  layout?: Maybe<Page_Layout>;
  meta?: Maybe<Page_Meta>;
  slug?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  titleSettings?: Maybe<Page_TitleSettings>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type PageDescriptionArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};

export type PageCreateAccess = {
  __typename?: 'PageCreateAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type PageCreateDocAccess = {
  __typename?: 'PageCreateDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type PageDeleteAccess = {
  __typename?: 'PageDeleteAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type PageDeleteDocAccess = {
  __typename?: 'PageDeleteDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type PageDocAccessFields = {
  __typename?: 'PageDocAccessFields';
  _status?: Maybe<PageDocAccessFields__Status>;
  beforeFeaturedFormContent?: Maybe<PageDocAccessFields_BeforeFeaturedFormContent>;
  blocks?: Maybe<PageDocAccessFields_Blocks>;
  createdAt?: Maybe<PageDocAccessFields_CreatedAt>;
  description?: Maybe<PageDocAccessFields_Description>;
  featuredForm?: Maybe<PageDocAccessFields_FeaturedForm>;
  image?: Maybe<PageDocAccessFields_Image>;
  isArticle?: Maybe<PageDocAccessFields_IsArticle>;
  isPlaceholder?: Maybe<PageDocAccessFields_IsPlaceholder>;
  meta?: Maybe<PageDocAccessFields_Meta>;
  showLookingForForm?: Maybe<PageDocAccessFields_ShowLookingForForm>;
  showRatingWidget?: Maybe<PageDocAccessFields_ShowRatingWidget>;
  slug?: Maybe<PageDocAccessFields_Slug>;
  title?: Maybe<PageDocAccessFields_Title>;
  titleSettings?: Maybe<PageDocAccessFields_TitleSettings>;
  type?: Maybe<PageDocAccessFields_Type>;
  updatedAt?: Maybe<PageDocAccessFields_UpdatedAt>;
  wrapInBackground?: Maybe<PageDocAccessFields_WrapInBackground>;
};

export type PageDocAccessFields__Status = {
  __typename?: 'PageDocAccessFields__status';
  create?: Maybe<PageDocAccessFields__Status_Create>;
  delete?: Maybe<PageDocAccessFields__Status_Delete>;
  read?: Maybe<PageDocAccessFields__Status_Read>;
  update?: Maybe<PageDocAccessFields__Status_Update>;
};

export type PageDocAccessFields__Status_Create = {
  __typename?: 'PageDocAccessFields__status_Create';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields__Status_Delete = {
  __typename?: 'PageDocAccessFields__status_Delete';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields__Status_Read = {
  __typename?: 'PageDocAccessFields__status_Read';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields__Status_Update = {
  __typename?: 'PageDocAccessFields__status_Update';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_BeforeFeaturedFormContent = {
  __typename?: 'PageDocAccessFields_beforeFeaturedFormContent';
  create?: Maybe<PageDocAccessFields_BeforeFeaturedFormContent_Create>;
  delete?: Maybe<PageDocAccessFields_BeforeFeaturedFormContent_Delete>;
  read?: Maybe<PageDocAccessFields_BeforeFeaturedFormContent_Read>;
  update?: Maybe<PageDocAccessFields_BeforeFeaturedFormContent_Update>;
};

export type PageDocAccessFields_BeforeFeaturedFormContent_Create = {
  __typename?: 'PageDocAccessFields_beforeFeaturedFormContent_Create';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_BeforeFeaturedFormContent_Delete = {
  __typename?: 'PageDocAccessFields_beforeFeaturedFormContent_Delete';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_BeforeFeaturedFormContent_Read = {
  __typename?: 'PageDocAccessFields_beforeFeaturedFormContent_Read';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_BeforeFeaturedFormContent_Update = {
  __typename?: 'PageDocAccessFields_beforeFeaturedFormContent_Update';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_Blocks = {
  __typename?: 'PageDocAccessFields_blocks';
  create?: Maybe<PageDocAccessFields_Blocks_Create>;
  delete?: Maybe<PageDocAccessFields_Blocks_Delete>;
  read?: Maybe<PageDocAccessFields_Blocks_Read>;
  update?: Maybe<PageDocAccessFields_Blocks_Update>;
};

export type PageDocAccessFields_Blocks_Create = {
  __typename?: 'PageDocAccessFields_blocks_Create';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_Blocks_Delete = {
  __typename?: 'PageDocAccessFields_blocks_Delete';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_Blocks_Read = {
  __typename?: 'PageDocAccessFields_blocks_Read';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_Blocks_Update = {
  __typename?: 'PageDocAccessFields_blocks_Update';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_CreatedAt = {
  __typename?: 'PageDocAccessFields_createdAt';
  create?: Maybe<PageDocAccessFields_CreatedAt_Create>;
  delete?: Maybe<PageDocAccessFields_CreatedAt_Delete>;
  read?: Maybe<PageDocAccessFields_CreatedAt_Read>;
  update?: Maybe<PageDocAccessFields_CreatedAt_Update>;
};

export type PageDocAccessFields_CreatedAt_Create = {
  __typename?: 'PageDocAccessFields_createdAt_Create';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_CreatedAt_Delete = {
  __typename?: 'PageDocAccessFields_createdAt_Delete';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_CreatedAt_Read = {
  __typename?: 'PageDocAccessFields_createdAt_Read';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_CreatedAt_Update = {
  __typename?: 'PageDocAccessFields_createdAt_Update';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_Description = {
  __typename?: 'PageDocAccessFields_description';
  create?: Maybe<PageDocAccessFields_Description_Create>;
  delete?: Maybe<PageDocAccessFields_Description_Delete>;
  read?: Maybe<PageDocAccessFields_Description_Read>;
  update?: Maybe<PageDocAccessFields_Description_Update>;
};

export type PageDocAccessFields_Description_Create = {
  __typename?: 'PageDocAccessFields_description_Create';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_Description_Delete = {
  __typename?: 'PageDocAccessFields_description_Delete';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_Description_Read = {
  __typename?: 'PageDocAccessFields_description_Read';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_Description_Update = {
  __typename?: 'PageDocAccessFields_description_Update';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_FeaturedForm = {
  __typename?: 'PageDocAccessFields_featuredForm';
  create?: Maybe<PageDocAccessFields_FeaturedForm_Create>;
  delete?: Maybe<PageDocAccessFields_FeaturedForm_Delete>;
  read?: Maybe<PageDocAccessFields_FeaturedForm_Read>;
  update?: Maybe<PageDocAccessFields_FeaturedForm_Update>;
};

export type PageDocAccessFields_FeaturedForm_Create = {
  __typename?: 'PageDocAccessFields_featuredForm_Create';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_FeaturedForm_Delete = {
  __typename?: 'PageDocAccessFields_featuredForm_Delete';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_FeaturedForm_Read = {
  __typename?: 'PageDocAccessFields_featuredForm_Read';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_FeaturedForm_Update = {
  __typename?: 'PageDocAccessFields_featuredForm_Update';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_Image = {
  __typename?: 'PageDocAccessFields_image';
  create?: Maybe<PageDocAccessFields_Image_Create>;
  delete?: Maybe<PageDocAccessFields_Image_Delete>;
  read?: Maybe<PageDocAccessFields_Image_Read>;
  update?: Maybe<PageDocAccessFields_Image_Update>;
};

export type PageDocAccessFields_Image_Create = {
  __typename?: 'PageDocAccessFields_image_Create';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_Image_Delete = {
  __typename?: 'PageDocAccessFields_image_Delete';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_Image_Read = {
  __typename?: 'PageDocAccessFields_image_Read';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_Image_Update = {
  __typename?: 'PageDocAccessFields_image_Update';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_IsArticle = {
  __typename?: 'PageDocAccessFields_isArticle';
  create?: Maybe<PageDocAccessFields_IsArticle_Create>;
  delete?: Maybe<PageDocAccessFields_IsArticle_Delete>;
  read?: Maybe<PageDocAccessFields_IsArticle_Read>;
  update?: Maybe<PageDocAccessFields_IsArticle_Update>;
};

export type PageDocAccessFields_IsArticle_Create = {
  __typename?: 'PageDocAccessFields_isArticle_Create';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_IsArticle_Delete = {
  __typename?: 'PageDocAccessFields_isArticle_Delete';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_IsArticle_Read = {
  __typename?: 'PageDocAccessFields_isArticle_Read';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_IsArticle_Update = {
  __typename?: 'PageDocAccessFields_isArticle_Update';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_IsPlaceholder = {
  __typename?: 'PageDocAccessFields_isPlaceholder';
  create?: Maybe<PageDocAccessFields_IsPlaceholder_Create>;
  delete?: Maybe<PageDocAccessFields_IsPlaceholder_Delete>;
  read?: Maybe<PageDocAccessFields_IsPlaceholder_Read>;
  update?: Maybe<PageDocAccessFields_IsPlaceholder_Update>;
};

export type PageDocAccessFields_IsPlaceholder_Create = {
  __typename?: 'PageDocAccessFields_isPlaceholder_Create';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_IsPlaceholder_Delete = {
  __typename?: 'PageDocAccessFields_isPlaceholder_Delete';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_IsPlaceholder_Read = {
  __typename?: 'PageDocAccessFields_isPlaceholder_Read';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_IsPlaceholder_Update = {
  __typename?: 'PageDocAccessFields_isPlaceholder_Update';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_Meta = {
  __typename?: 'PageDocAccessFields_meta';
  create?: Maybe<PageDocAccessFields_Meta_Create>;
  delete?: Maybe<PageDocAccessFields_Meta_Delete>;
  fields?: Maybe<PageDocAccessFields_Meta_Fields>;
  read?: Maybe<PageDocAccessFields_Meta_Read>;
  update?: Maybe<PageDocAccessFields_Meta_Update>;
};

export type PageDocAccessFields_Meta_Create = {
  __typename?: 'PageDocAccessFields_meta_Create';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_Meta_Delete = {
  __typename?: 'PageDocAccessFields_meta_Delete';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_Meta_Fields = {
  __typename?: 'PageDocAccessFields_meta_Fields';
  description?: Maybe<PageDocAccessFields_Meta_Description>;
  image?: Maybe<PageDocAccessFields_Meta_Image>;
  noIndex?: Maybe<PageDocAccessFields_Meta_NoIndex>;
  title?: Maybe<PageDocAccessFields_Meta_Title>;
};

export type PageDocAccessFields_Meta_Read = {
  __typename?: 'PageDocAccessFields_meta_Read';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_Meta_Update = {
  __typename?: 'PageDocAccessFields_meta_Update';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_Meta_Description = {
  __typename?: 'PageDocAccessFields_meta_description';
  create?: Maybe<PageDocAccessFields_Meta_Description_Create>;
  delete?: Maybe<PageDocAccessFields_Meta_Description_Delete>;
  read?: Maybe<PageDocAccessFields_Meta_Description_Read>;
  update?: Maybe<PageDocAccessFields_Meta_Description_Update>;
};

export type PageDocAccessFields_Meta_Description_Create = {
  __typename?: 'PageDocAccessFields_meta_description_Create';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_Meta_Description_Delete = {
  __typename?: 'PageDocAccessFields_meta_description_Delete';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_Meta_Description_Read = {
  __typename?: 'PageDocAccessFields_meta_description_Read';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_Meta_Description_Update = {
  __typename?: 'PageDocAccessFields_meta_description_Update';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_Meta_Image = {
  __typename?: 'PageDocAccessFields_meta_image';
  create?: Maybe<PageDocAccessFields_Meta_Image_Create>;
  delete?: Maybe<PageDocAccessFields_Meta_Image_Delete>;
  read?: Maybe<PageDocAccessFields_Meta_Image_Read>;
  update?: Maybe<PageDocAccessFields_Meta_Image_Update>;
};

export type PageDocAccessFields_Meta_Image_Create = {
  __typename?: 'PageDocAccessFields_meta_image_Create';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_Meta_Image_Delete = {
  __typename?: 'PageDocAccessFields_meta_image_Delete';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_Meta_Image_Read = {
  __typename?: 'PageDocAccessFields_meta_image_Read';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_Meta_Image_Update = {
  __typename?: 'PageDocAccessFields_meta_image_Update';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_Meta_NoIndex = {
  __typename?: 'PageDocAccessFields_meta_noIndex';
  create?: Maybe<PageDocAccessFields_Meta_NoIndex_Create>;
  delete?: Maybe<PageDocAccessFields_Meta_NoIndex_Delete>;
  read?: Maybe<PageDocAccessFields_Meta_NoIndex_Read>;
  update?: Maybe<PageDocAccessFields_Meta_NoIndex_Update>;
};

export type PageDocAccessFields_Meta_NoIndex_Create = {
  __typename?: 'PageDocAccessFields_meta_noIndex_Create';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_Meta_NoIndex_Delete = {
  __typename?: 'PageDocAccessFields_meta_noIndex_Delete';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_Meta_NoIndex_Read = {
  __typename?: 'PageDocAccessFields_meta_noIndex_Read';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_Meta_NoIndex_Update = {
  __typename?: 'PageDocAccessFields_meta_noIndex_Update';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_Meta_Title = {
  __typename?: 'PageDocAccessFields_meta_title';
  create?: Maybe<PageDocAccessFields_Meta_Title_Create>;
  delete?: Maybe<PageDocAccessFields_Meta_Title_Delete>;
  read?: Maybe<PageDocAccessFields_Meta_Title_Read>;
  update?: Maybe<PageDocAccessFields_Meta_Title_Update>;
};

export type PageDocAccessFields_Meta_Title_Create = {
  __typename?: 'PageDocAccessFields_meta_title_Create';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_Meta_Title_Delete = {
  __typename?: 'PageDocAccessFields_meta_title_Delete';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_Meta_Title_Read = {
  __typename?: 'PageDocAccessFields_meta_title_Read';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_Meta_Title_Update = {
  __typename?: 'PageDocAccessFields_meta_title_Update';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_ShowLookingForForm = {
  __typename?: 'PageDocAccessFields_showLookingForForm';
  create?: Maybe<PageDocAccessFields_ShowLookingForForm_Create>;
  delete?: Maybe<PageDocAccessFields_ShowLookingForForm_Delete>;
  read?: Maybe<PageDocAccessFields_ShowLookingForForm_Read>;
  update?: Maybe<PageDocAccessFields_ShowLookingForForm_Update>;
};

export type PageDocAccessFields_ShowLookingForForm_Create = {
  __typename?: 'PageDocAccessFields_showLookingForForm_Create';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_ShowLookingForForm_Delete = {
  __typename?: 'PageDocAccessFields_showLookingForForm_Delete';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_ShowLookingForForm_Read = {
  __typename?: 'PageDocAccessFields_showLookingForForm_Read';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_ShowLookingForForm_Update = {
  __typename?: 'PageDocAccessFields_showLookingForForm_Update';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_ShowRatingWidget = {
  __typename?: 'PageDocAccessFields_showRatingWidget';
  create?: Maybe<PageDocAccessFields_ShowRatingWidget_Create>;
  delete?: Maybe<PageDocAccessFields_ShowRatingWidget_Delete>;
  read?: Maybe<PageDocAccessFields_ShowRatingWidget_Read>;
  update?: Maybe<PageDocAccessFields_ShowRatingWidget_Update>;
};

export type PageDocAccessFields_ShowRatingWidget_Create = {
  __typename?: 'PageDocAccessFields_showRatingWidget_Create';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_ShowRatingWidget_Delete = {
  __typename?: 'PageDocAccessFields_showRatingWidget_Delete';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_ShowRatingWidget_Read = {
  __typename?: 'PageDocAccessFields_showRatingWidget_Read';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_ShowRatingWidget_Update = {
  __typename?: 'PageDocAccessFields_showRatingWidget_Update';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_Slug = {
  __typename?: 'PageDocAccessFields_slug';
  create?: Maybe<PageDocAccessFields_Slug_Create>;
  delete?: Maybe<PageDocAccessFields_Slug_Delete>;
  read?: Maybe<PageDocAccessFields_Slug_Read>;
  update?: Maybe<PageDocAccessFields_Slug_Update>;
};

export type PageDocAccessFields_Slug_Create = {
  __typename?: 'PageDocAccessFields_slug_Create';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_Slug_Delete = {
  __typename?: 'PageDocAccessFields_slug_Delete';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_Slug_Read = {
  __typename?: 'PageDocAccessFields_slug_Read';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_Slug_Update = {
  __typename?: 'PageDocAccessFields_slug_Update';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_Title = {
  __typename?: 'PageDocAccessFields_title';
  create?: Maybe<PageDocAccessFields_Title_Create>;
  delete?: Maybe<PageDocAccessFields_Title_Delete>;
  read?: Maybe<PageDocAccessFields_Title_Read>;
  update?: Maybe<PageDocAccessFields_Title_Update>;
};

export type PageDocAccessFields_TitleSettings = {
  __typename?: 'PageDocAccessFields_titleSettings';
  create?: Maybe<PageDocAccessFields_TitleSettings_Create>;
  delete?: Maybe<PageDocAccessFields_TitleSettings_Delete>;
  fields?: Maybe<PageDocAccessFields_TitleSettings_Fields>;
  read?: Maybe<PageDocAccessFields_TitleSettings_Read>;
  update?: Maybe<PageDocAccessFields_TitleSettings_Update>;
};

export type PageDocAccessFields_TitleSettings_Create = {
  __typename?: 'PageDocAccessFields_titleSettings_Create';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_TitleSettings_Delete = {
  __typename?: 'PageDocAccessFields_titleSettings_Delete';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_TitleSettings_Fields = {
  __typename?: 'PageDocAccessFields_titleSettings_Fields';
  boldEndIndex?: Maybe<PageDocAccessFields_TitleSettings_BoldEndIndex>;
  boldStartIndex?: Maybe<PageDocAccessFields_TitleSettings_BoldStartIndex>;
};

export type PageDocAccessFields_TitleSettings_Read = {
  __typename?: 'PageDocAccessFields_titleSettings_Read';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_TitleSettings_Update = {
  __typename?: 'PageDocAccessFields_titleSettings_Update';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_TitleSettings_BoldEndIndex = {
  __typename?: 'PageDocAccessFields_titleSettings_boldEndIndex';
  create?: Maybe<PageDocAccessFields_TitleSettings_BoldEndIndex_Create>;
  delete?: Maybe<PageDocAccessFields_TitleSettings_BoldEndIndex_Delete>;
  read?: Maybe<PageDocAccessFields_TitleSettings_BoldEndIndex_Read>;
  update?: Maybe<PageDocAccessFields_TitleSettings_BoldEndIndex_Update>;
};

export type PageDocAccessFields_TitleSettings_BoldEndIndex_Create = {
  __typename?: 'PageDocAccessFields_titleSettings_boldEndIndex_Create';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_TitleSettings_BoldEndIndex_Delete = {
  __typename?: 'PageDocAccessFields_titleSettings_boldEndIndex_Delete';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_TitleSettings_BoldEndIndex_Read = {
  __typename?: 'PageDocAccessFields_titleSettings_boldEndIndex_Read';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_TitleSettings_BoldEndIndex_Update = {
  __typename?: 'PageDocAccessFields_titleSettings_boldEndIndex_Update';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_TitleSettings_BoldStartIndex = {
  __typename?: 'PageDocAccessFields_titleSettings_boldStartIndex';
  create?: Maybe<PageDocAccessFields_TitleSettings_BoldStartIndex_Create>;
  delete?: Maybe<PageDocAccessFields_TitleSettings_BoldStartIndex_Delete>;
  read?: Maybe<PageDocAccessFields_TitleSettings_BoldStartIndex_Read>;
  update?: Maybe<PageDocAccessFields_TitleSettings_BoldStartIndex_Update>;
};

export type PageDocAccessFields_TitleSettings_BoldStartIndex_Create = {
  __typename?: 'PageDocAccessFields_titleSettings_boldStartIndex_Create';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_TitleSettings_BoldStartIndex_Delete = {
  __typename?: 'PageDocAccessFields_titleSettings_boldStartIndex_Delete';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_TitleSettings_BoldStartIndex_Read = {
  __typename?: 'PageDocAccessFields_titleSettings_boldStartIndex_Read';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_TitleSettings_BoldStartIndex_Update = {
  __typename?: 'PageDocAccessFields_titleSettings_boldStartIndex_Update';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_Title_Create = {
  __typename?: 'PageDocAccessFields_title_Create';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_Title_Delete = {
  __typename?: 'PageDocAccessFields_title_Delete';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_Title_Read = {
  __typename?: 'PageDocAccessFields_title_Read';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_Title_Update = {
  __typename?: 'PageDocAccessFields_title_Update';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_Type = {
  __typename?: 'PageDocAccessFields_type';
  create?: Maybe<PageDocAccessFields_Type_Create>;
  delete?: Maybe<PageDocAccessFields_Type_Delete>;
  read?: Maybe<PageDocAccessFields_Type_Read>;
  update?: Maybe<PageDocAccessFields_Type_Update>;
};

export type PageDocAccessFields_Type_Create = {
  __typename?: 'PageDocAccessFields_type_Create';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_Type_Delete = {
  __typename?: 'PageDocAccessFields_type_Delete';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_Type_Read = {
  __typename?: 'PageDocAccessFields_type_Read';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_Type_Update = {
  __typename?: 'PageDocAccessFields_type_Update';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_UpdatedAt = {
  __typename?: 'PageDocAccessFields_updatedAt';
  create?: Maybe<PageDocAccessFields_UpdatedAt_Create>;
  delete?: Maybe<PageDocAccessFields_UpdatedAt_Delete>;
  read?: Maybe<PageDocAccessFields_UpdatedAt_Read>;
  update?: Maybe<PageDocAccessFields_UpdatedAt_Update>;
};

export type PageDocAccessFields_UpdatedAt_Create = {
  __typename?: 'PageDocAccessFields_updatedAt_Create';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_UpdatedAt_Delete = {
  __typename?: 'PageDocAccessFields_updatedAt_Delete';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_UpdatedAt_Read = {
  __typename?: 'PageDocAccessFields_updatedAt_Read';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_UpdatedAt_Update = {
  __typename?: 'PageDocAccessFields_updatedAt_Update';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_WrapInBackground = {
  __typename?: 'PageDocAccessFields_wrapInBackground';
  create?: Maybe<PageDocAccessFields_WrapInBackground_Create>;
  delete?: Maybe<PageDocAccessFields_WrapInBackground_Delete>;
  read?: Maybe<PageDocAccessFields_WrapInBackground_Read>;
  update?: Maybe<PageDocAccessFields_WrapInBackground_Update>;
};

export type PageDocAccessFields_WrapInBackground_Create = {
  __typename?: 'PageDocAccessFields_wrapInBackground_Create';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_WrapInBackground_Delete = {
  __typename?: 'PageDocAccessFields_wrapInBackground_Delete';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_WrapInBackground_Read = {
  __typename?: 'PageDocAccessFields_wrapInBackground_Read';
  permission: Scalars['Boolean'];
};

export type PageDocAccessFields_WrapInBackground_Update = {
  __typename?: 'PageDocAccessFields_wrapInBackground_Update';
  permission: Scalars['Boolean'];
};

export type PageFields = {
  __typename?: 'PageFields';
  _status?: Maybe<PageFields__Status>;
  beforeFeaturedFormContent?: Maybe<PageFields_BeforeFeaturedFormContent>;
  blocks?: Maybe<PageFields_Blocks>;
  createdAt?: Maybe<PageFields_CreatedAt>;
  description?: Maybe<PageFields_Description>;
  featuredForm?: Maybe<PageFields_FeaturedForm>;
  image?: Maybe<PageFields_Image>;
  isArticle?: Maybe<PageFields_IsArticle>;
  isPlaceholder?: Maybe<PageFields_IsPlaceholder>;
  meta?: Maybe<PageFields_Meta>;
  showLookingForForm?: Maybe<PageFields_ShowLookingForForm>;
  showRatingWidget?: Maybe<PageFields_ShowRatingWidget>;
  slug?: Maybe<PageFields_Slug>;
  title?: Maybe<PageFields_Title>;
  titleSettings?: Maybe<PageFields_TitleSettings>;
  type?: Maybe<PageFields_Type>;
  updatedAt?: Maybe<PageFields_UpdatedAt>;
  wrapInBackground?: Maybe<PageFields_WrapInBackground>;
};

export type PageFields__Status = {
  __typename?: 'PageFields__status';
  create?: Maybe<PageFields__Status_Create>;
  delete?: Maybe<PageFields__Status_Delete>;
  read?: Maybe<PageFields__Status_Read>;
  update?: Maybe<PageFields__Status_Update>;
};

export type PageFields__Status_Create = {
  __typename?: 'PageFields__status_Create';
  permission: Scalars['Boolean'];
};

export type PageFields__Status_Delete = {
  __typename?: 'PageFields__status_Delete';
  permission: Scalars['Boolean'];
};

export type PageFields__Status_Read = {
  __typename?: 'PageFields__status_Read';
  permission: Scalars['Boolean'];
};

export type PageFields__Status_Update = {
  __typename?: 'PageFields__status_Update';
  permission: Scalars['Boolean'];
};

export type PageFields_BeforeFeaturedFormContent = {
  __typename?: 'PageFields_beforeFeaturedFormContent';
  create?: Maybe<PageFields_BeforeFeaturedFormContent_Create>;
  delete?: Maybe<PageFields_BeforeFeaturedFormContent_Delete>;
  read?: Maybe<PageFields_BeforeFeaturedFormContent_Read>;
  update?: Maybe<PageFields_BeforeFeaturedFormContent_Update>;
};

export type PageFields_BeforeFeaturedFormContent_Create = {
  __typename?: 'PageFields_beforeFeaturedFormContent_Create';
  permission: Scalars['Boolean'];
};

export type PageFields_BeforeFeaturedFormContent_Delete = {
  __typename?: 'PageFields_beforeFeaturedFormContent_Delete';
  permission: Scalars['Boolean'];
};

export type PageFields_BeforeFeaturedFormContent_Read = {
  __typename?: 'PageFields_beforeFeaturedFormContent_Read';
  permission: Scalars['Boolean'];
};

export type PageFields_BeforeFeaturedFormContent_Update = {
  __typename?: 'PageFields_beforeFeaturedFormContent_Update';
  permission: Scalars['Boolean'];
};

export type PageFields_Blocks = {
  __typename?: 'PageFields_blocks';
  create?: Maybe<PageFields_Blocks_Create>;
  delete?: Maybe<PageFields_Blocks_Delete>;
  read?: Maybe<PageFields_Blocks_Read>;
  update?: Maybe<PageFields_Blocks_Update>;
};

export type PageFields_Blocks_Create = {
  __typename?: 'PageFields_blocks_Create';
  permission: Scalars['Boolean'];
};

export type PageFields_Blocks_Delete = {
  __typename?: 'PageFields_blocks_Delete';
  permission: Scalars['Boolean'];
};

export type PageFields_Blocks_Read = {
  __typename?: 'PageFields_blocks_Read';
  permission: Scalars['Boolean'];
};

export type PageFields_Blocks_Update = {
  __typename?: 'PageFields_blocks_Update';
  permission: Scalars['Boolean'];
};

export type PageFields_CreatedAt = {
  __typename?: 'PageFields_createdAt';
  create?: Maybe<PageFields_CreatedAt_Create>;
  delete?: Maybe<PageFields_CreatedAt_Delete>;
  read?: Maybe<PageFields_CreatedAt_Read>;
  update?: Maybe<PageFields_CreatedAt_Update>;
};

export type PageFields_CreatedAt_Create = {
  __typename?: 'PageFields_createdAt_Create';
  permission: Scalars['Boolean'];
};

export type PageFields_CreatedAt_Delete = {
  __typename?: 'PageFields_createdAt_Delete';
  permission: Scalars['Boolean'];
};

export type PageFields_CreatedAt_Read = {
  __typename?: 'PageFields_createdAt_Read';
  permission: Scalars['Boolean'];
};

export type PageFields_CreatedAt_Update = {
  __typename?: 'PageFields_createdAt_Update';
  permission: Scalars['Boolean'];
};

export type PageFields_Description = {
  __typename?: 'PageFields_description';
  create?: Maybe<PageFields_Description_Create>;
  delete?: Maybe<PageFields_Description_Delete>;
  read?: Maybe<PageFields_Description_Read>;
  update?: Maybe<PageFields_Description_Update>;
};

export type PageFields_Description_Create = {
  __typename?: 'PageFields_description_Create';
  permission: Scalars['Boolean'];
};

export type PageFields_Description_Delete = {
  __typename?: 'PageFields_description_Delete';
  permission: Scalars['Boolean'];
};

export type PageFields_Description_Read = {
  __typename?: 'PageFields_description_Read';
  permission: Scalars['Boolean'];
};

export type PageFields_Description_Update = {
  __typename?: 'PageFields_description_Update';
  permission: Scalars['Boolean'];
};

export type PageFields_FeaturedForm = {
  __typename?: 'PageFields_featuredForm';
  create?: Maybe<PageFields_FeaturedForm_Create>;
  delete?: Maybe<PageFields_FeaturedForm_Delete>;
  read?: Maybe<PageFields_FeaturedForm_Read>;
  update?: Maybe<PageFields_FeaturedForm_Update>;
};

export type PageFields_FeaturedForm_Create = {
  __typename?: 'PageFields_featuredForm_Create';
  permission: Scalars['Boolean'];
};

export type PageFields_FeaturedForm_Delete = {
  __typename?: 'PageFields_featuredForm_Delete';
  permission: Scalars['Boolean'];
};

export type PageFields_FeaturedForm_Read = {
  __typename?: 'PageFields_featuredForm_Read';
  permission: Scalars['Boolean'];
};

export type PageFields_FeaturedForm_Update = {
  __typename?: 'PageFields_featuredForm_Update';
  permission: Scalars['Boolean'];
};

export type PageFields_Image = {
  __typename?: 'PageFields_image';
  create?: Maybe<PageFields_Image_Create>;
  delete?: Maybe<PageFields_Image_Delete>;
  read?: Maybe<PageFields_Image_Read>;
  update?: Maybe<PageFields_Image_Update>;
};

export type PageFields_Image_Create = {
  __typename?: 'PageFields_image_Create';
  permission: Scalars['Boolean'];
};

export type PageFields_Image_Delete = {
  __typename?: 'PageFields_image_Delete';
  permission: Scalars['Boolean'];
};

export type PageFields_Image_Read = {
  __typename?: 'PageFields_image_Read';
  permission: Scalars['Boolean'];
};

export type PageFields_Image_Update = {
  __typename?: 'PageFields_image_Update';
  permission: Scalars['Boolean'];
};

export type PageFields_IsArticle = {
  __typename?: 'PageFields_isArticle';
  create?: Maybe<PageFields_IsArticle_Create>;
  delete?: Maybe<PageFields_IsArticle_Delete>;
  read?: Maybe<PageFields_IsArticle_Read>;
  update?: Maybe<PageFields_IsArticle_Update>;
};

export type PageFields_IsArticle_Create = {
  __typename?: 'PageFields_isArticle_Create';
  permission: Scalars['Boolean'];
};

export type PageFields_IsArticle_Delete = {
  __typename?: 'PageFields_isArticle_Delete';
  permission: Scalars['Boolean'];
};

export type PageFields_IsArticle_Read = {
  __typename?: 'PageFields_isArticle_Read';
  permission: Scalars['Boolean'];
};

export type PageFields_IsArticle_Update = {
  __typename?: 'PageFields_isArticle_Update';
  permission: Scalars['Boolean'];
};

export type PageFields_IsPlaceholder = {
  __typename?: 'PageFields_isPlaceholder';
  create?: Maybe<PageFields_IsPlaceholder_Create>;
  delete?: Maybe<PageFields_IsPlaceholder_Delete>;
  read?: Maybe<PageFields_IsPlaceholder_Read>;
  update?: Maybe<PageFields_IsPlaceholder_Update>;
};

export type PageFields_IsPlaceholder_Create = {
  __typename?: 'PageFields_isPlaceholder_Create';
  permission: Scalars['Boolean'];
};

export type PageFields_IsPlaceholder_Delete = {
  __typename?: 'PageFields_isPlaceholder_Delete';
  permission: Scalars['Boolean'];
};

export type PageFields_IsPlaceholder_Read = {
  __typename?: 'PageFields_isPlaceholder_Read';
  permission: Scalars['Boolean'];
};

export type PageFields_IsPlaceholder_Update = {
  __typename?: 'PageFields_isPlaceholder_Update';
  permission: Scalars['Boolean'];
};

export type PageFields_Meta = {
  __typename?: 'PageFields_meta';
  create?: Maybe<PageFields_Meta_Create>;
  delete?: Maybe<PageFields_Meta_Delete>;
  fields?: Maybe<PageFields_Meta_Fields>;
  read?: Maybe<PageFields_Meta_Read>;
  update?: Maybe<PageFields_Meta_Update>;
};

export type PageFields_Meta_Create = {
  __typename?: 'PageFields_meta_Create';
  permission: Scalars['Boolean'];
};

export type PageFields_Meta_Delete = {
  __typename?: 'PageFields_meta_Delete';
  permission: Scalars['Boolean'];
};

export type PageFields_Meta_Fields = {
  __typename?: 'PageFields_meta_Fields';
  description?: Maybe<PageFields_Meta_Description>;
  image?: Maybe<PageFields_Meta_Image>;
  noIndex?: Maybe<PageFields_Meta_NoIndex>;
  title?: Maybe<PageFields_Meta_Title>;
};

export type PageFields_Meta_Read = {
  __typename?: 'PageFields_meta_Read';
  permission: Scalars['Boolean'];
};

export type PageFields_Meta_Update = {
  __typename?: 'PageFields_meta_Update';
  permission: Scalars['Boolean'];
};

export type PageFields_Meta_Description = {
  __typename?: 'PageFields_meta_description';
  create?: Maybe<PageFields_Meta_Description_Create>;
  delete?: Maybe<PageFields_Meta_Description_Delete>;
  read?: Maybe<PageFields_Meta_Description_Read>;
  update?: Maybe<PageFields_Meta_Description_Update>;
};

export type PageFields_Meta_Description_Create = {
  __typename?: 'PageFields_meta_description_Create';
  permission: Scalars['Boolean'];
};

export type PageFields_Meta_Description_Delete = {
  __typename?: 'PageFields_meta_description_Delete';
  permission: Scalars['Boolean'];
};

export type PageFields_Meta_Description_Read = {
  __typename?: 'PageFields_meta_description_Read';
  permission: Scalars['Boolean'];
};

export type PageFields_Meta_Description_Update = {
  __typename?: 'PageFields_meta_description_Update';
  permission: Scalars['Boolean'];
};

export type PageFields_Meta_Image = {
  __typename?: 'PageFields_meta_image';
  create?: Maybe<PageFields_Meta_Image_Create>;
  delete?: Maybe<PageFields_Meta_Image_Delete>;
  read?: Maybe<PageFields_Meta_Image_Read>;
  update?: Maybe<PageFields_Meta_Image_Update>;
};

export type PageFields_Meta_Image_Create = {
  __typename?: 'PageFields_meta_image_Create';
  permission: Scalars['Boolean'];
};

export type PageFields_Meta_Image_Delete = {
  __typename?: 'PageFields_meta_image_Delete';
  permission: Scalars['Boolean'];
};

export type PageFields_Meta_Image_Read = {
  __typename?: 'PageFields_meta_image_Read';
  permission: Scalars['Boolean'];
};

export type PageFields_Meta_Image_Update = {
  __typename?: 'PageFields_meta_image_Update';
  permission: Scalars['Boolean'];
};

export type PageFields_Meta_NoIndex = {
  __typename?: 'PageFields_meta_noIndex';
  create?: Maybe<PageFields_Meta_NoIndex_Create>;
  delete?: Maybe<PageFields_Meta_NoIndex_Delete>;
  read?: Maybe<PageFields_Meta_NoIndex_Read>;
  update?: Maybe<PageFields_Meta_NoIndex_Update>;
};

export type PageFields_Meta_NoIndex_Create = {
  __typename?: 'PageFields_meta_noIndex_Create';
  permission: Scalars['Boolean'];
};

export type PageFields_Meta_NoIndex_Delete = {
  __typename?: 'PageFields_meta_noIndex_Delete';
  permission: Scalars['Boolean'];
};

export type PageFields_Meta_NoIndex_Read = {
  __typename?: 'PageFields_meta_noIndex_Read';
  permission: Scalars['Boolean'];
};

export type PageFields_Meta_NoIndex_Update = {
  __typename?: 'PageFields_meta_noIndex_Update';
  permission: Scalars['Boolean'];
};

export type PageFields_Meta_Title = {
  __typename?: 'PageFields_meta_title';
  create?: Maybe<PageFields_Meta_Title_Create>;
  delete?: Maybe<PageFields_Meta_Title_Delete>;
  read?: Maybe<PageFields_Meta_Title_Read>;
  update?: Maybe<PageFields_Meta_Title_Update>;
};

export type PageFields_Meta_Title_Create = {
  __typename?: 'PageFields_meta_title_Create';
  permission: Scalars['Boolean'];
};

export type PageFields_Meta_Title_Delete = {
  __typename?: 'PageFields_meta_title_Delete';
  permission: Scalars['Boolean'];
};

export type PageFields_Meta_Title_Read = {
  __typename?: 'PageFields_meta_title_Read';
  permission: Scalars['Boolean'];
};

export type PageFields_Meta_Title_Update = {
  __typename?: 'PageFields_meta_title_Update';
  permission: Scalars['Boolean'];
};

export type PageFields_ShowLookingForForm = {
  __typename?: 'PageFields_showLookingForForm';
  create?: Maybe<PageFields_ShowLookingForForm_Create>;
  delete?: Maybe<PageFields_ShowLookingForForm_Delete>;
  read?: Maybe<PageFields_ShowLookingForForm_Read>;
  update?: Maybe<PageFields_ShowLookingForForm_Update>;
};

export type PageFields_ShowLookingForForm_Create = {
  __typename?: 'PageFields_showLookingForForm_Create';
  permission: Scalars['Boolean'];
};

export type PageFields_ShowLookingForForm_Delete = {
  __typename?: 'PageFields_showLookingForForm_Delete';
  permission: Scalars['Boolean'];
};

export type PageFields_ShowLookingForForm_Read = {
  __typename?: 'PageFields_showLookingForForm_Read';
  permission: Scalars['Boolean'];
};

export type PageFields_ShowLookingForForm_Update = {
  __typename?: 'PageFields_showLookingForForm_Update';
  permission: Scalars['Boolean'];
};

export type PageFields_ShowRatingWidget = {
  __typename?: 'PageFields_showRatingWidget';
  create?: Maybe<PageFields_ShowRatingWidget_Create>;
  delete?: Maybe<PageFields_ShowRatingWidget_Delete>;
  read?: Maybe<PageFields_ShowRatingWidget_Read>;
  update?: Maybe<PageFields_ShowRatingWidget_Update>;
};

export type PageFields_ShowRatingWidget_Create = {
  __typename?: 'PageFields_showRatingWidget_Create';
  permission: Scalars['Boolean'];
};

export type PageFields_ShowRatingWidget_Delete = {
  __typename?: 'PageFields_showRatingWidget_Delete';
  permission: Scalars['Boolean'];
};

export type PageFields_ShowRatingWidget_Read = {
  __typename?: 'PageFields_showRatingWidget_Read';
  permission: Scalars['Boolean'];
};

export type PageFields_ShowRatingWidget_Update = {
  __typename?: 'PageFields_showRatingWidget_Update';
  permission: Scalars['Boolean'];
};

export type PageFields_Slug = {
  __typename?: 'PageFields_slug';
  create?: Maybe<PageFields_Slug_Create>;
  delete?: Maybe<PageFields_Slug_Delete>;
  read?: Maybe<PageFields_Slug_Read>;
  update?: Maybe<PageFields_Slug_Update>;
};

export type PageFields_Slug_Create = {
  __typename?: 'PageFields_slug_Create';
  permission: Scalars['Boolean'];
};

export type PageFields_Slug_Delete = {
  __typename?: 'PageFields_slug_Delete';
  permission: Scalars['Boolean'];
};

export type PageFields_Slug_Read = {
  __typename?: 'PageFields_slug_Read';
  permission: Scalars['Boolean'];
};

export type PageFields_Slug_Update = {
  __typename?: 'PageFields_slug_Update';
  permission: Scalars['Boolean'];
};

export type PageFields_Title = {
  __typename?: 'PageFields_title';
  create?: Maybe<PageFields_Title_Create>;
  delete?: Maybe<PageFields_Title_Delete>;
  read?: Maybe<PageFields_Title_Read>;
  update?: Maybe<PageFields_Title_Update>;
};

export type PageFields_TitleSettings = {
  __typename?: 'PageFields_titleSettings';
  create?: Maybe<PageFields_TitleSettings_Create>;
  delete?: Maybe<PageFields_TitleSettings_Delete>;
  fields?: Maybe<PageFields_TitleSettings_Fields>;
  read?: Maybe<PageFields_TitleSettings_Read>;
  update?: Maybe<PageFields_TitleSettings_Update>;
};

export type PageFields_TitleSettings_Create = {
  __typename?: 'PageFields_titleSettings_Create';
  permission: Scalars['Boolean'];
};

export type PageFields_TitleSettings_Delete = {
  __typename?: 'PageFields_titleSettings_Delete';
  permission: Scalars['Boolean'];
};

export type PageFields_TitleSettings_Fields = {
  __typename?: 'PageFields_titleSettings_Fields';
  boldEndIndex?: Maybe<PageFields_TitleSettings_BoldEndIndex>;
  boldStartIndex?: Maybe<PageFields_TitleSettings_BoldStartIndex>;
};

export type PageFields_TitleSettings_Read = {
  __typename?: 'PageFields_titleSettings_Read';
  permission: Scalars['Boolean'];
};

export type PageFields_TitleSettings_Update = {
  __typename?: 'PageFields_titleSettings_Update';
  permission: Scalars['Boolean'];
};

export type PageFields_TitleSettings_BoldEndIndex = {
  __typename?: 'PageFields_titleSettings_boldEndIndex';
  create?: Maybe<PageFields_TitleSettings_BoldEndIndex_Create>;
  delete?: Maybe<PageFields_TitleSettings_BoldEndIndex_Delete>;
  read?: Maybe<PageFields_TitleSettings_BoldEndIndex_Read>;
  update?: Maybe<PageFields_TitleSettings_BoldEndIndex_Update>;
};

export type PageFields_TitleSettings_BoldEndIndex_Create = {
  __typename?: 'PageFields_titleSettings_boldEndIndex_Create';
  permission: Scalars['Boolean'];
};

export type PageFields_TitleSettings_BoldEndIndex_Delete = {
  __typename?: 'PageFields_titleSettings_boldEndIndex_Delete';
  permission: Scalars['Boolean'];
};

export type PageFields_TitleSettings_BoldEndIndex_Read = {
  __typename?: 'PageFields_titleSettings_boldEndIndex_Read';
  permission: Scalars['Boolean'];
};

export type PageFields_TitleSettings_BoldEndIndex_Update = {
  __typename?: 'PageFields_titleSettings_boldEndIndex_Update';
  permission: Scalars['Boolean'];
};

export type PageFields_TitleSettings_BoldStartIndex = {
  __typename?: 'PageFields_titleSettings_boldStartIndex';
  create?: Maybe<PageFields_TitleSettings_BoldStartIndex_Create>;
  delete?: Maybe<PageFields_TitleSettings_BoldStartIndex_Delete>;
  read?: Maybe<PageFields_TitleSettings_BoldStartIndex_Read>;
  update?: Maybe<PageFields_TitleSettings_BoldStartIndex_Update>;
};

export type PageFields_TitleSettings_BoldStartIndex_Create = {
  __typename?: 'PageFields_titleSettings_boldStartIndex_Create';
  permission: Scalars['Boolean'];
};

export type PageFields_TitleSettings_BoldStartIndex_Delete = {
  __typename?: 'PageFields_titleSettings_boldStartIndex_Delete';
  permission: Scalars['Boolean'];
};

export type PageFields_TitleSettings_BoldStartIndex_Read = {
  __typename?: 'PageFields_titleSettings_boldStartIndex_Read';
  permission: Scalars['Boolean'];
};

export type PageFields_TitleSettings_BoldStartIndex_Update = {
  __typename?: 'PageFields_titleSettings_boldStartIndex_Update';
  permission: Scalars['Boolean'];
};

export type PageFields_Title_Create = {
  __typename?: 'PageFields_title_Create';
  permission: Scalars['Boolean'];
};

export type PageFields_Title_Delete = {
  __typename?: 'PageFields_title_Delete';
  permission: Scalars['Boolean'];
};

export type PageFields_Title_Read = {
  __typename?: 'PageFields_title_Read';
  permission: Scalars['Boolean'];
};

export type PageFields_Title_Update = {
  __typename?: 'PageFields_title_Update';
  permission: Scalars['Boolean'];
};

export type PageFields_Type = {
  __typename?: 'PageFields_type';
  create?: Maybe<PageFields_Type_Create>;
  delete?: Maybe<PageFields_Type_Delete>;
  read?: Maybe<PageFields_Type_Read>;
  update?: Maybe<PageFields_Type_Update>;
};

export type PageFields_Type_Create = {
  __typename?: 'PageFields_type_Create';
  permission: Scalars['Boolean'];
};

export type PageFields_Type_Delete = {
  __typename?: 'PageFields_type_Delete';
  permission: Scalars['Boolean'];
};

export type PageFields_Type_Read = {
  __typename?: 'PageFields_type_Read';
  permission: Scalars['Boolean'];
};

export type PageFields_Type_Update = {
  __typename?: 'PageFields_type_Update';
  permission: Scalars['Boolean'];
};

export type PageFields_UpdatedAt = {
  __typename?: 'PageFields_updatedAt';
  create?: Maybe<PageFields_UpdatedAt_Create>;
  delete?: Maybe<PageFields_UpdatedAt_Delete>;
  read?: Maybe<PageFields_UpdatedAt_Read>;
  update?: Maybe<PageFields_UpdatedAt_Update>;
};

export type PageFields_UpdatedAt_Create = {
  __typename?: 'PageFields_updatedAt_Create';
  permission: Scalars['Boolean'];
};

export type PageFields_UpdatedAt_Delete = {
  __typename?: 'PageFields_updatedAt_Delete';
  permission: Scalars['Boolean'];
};

export type PageFields_UpdatedAt_Read = {
  __typename?: 'PageFields_updatedAt_Read';
  permission: Scalars['Boolean'];
};

export type PageFields_UpdatedAt_Update = {
  __typename?: 'PageFields_updatedAt_Update';
  permission: Scalars['Boolean'];
};

export type PageFields_WrapInBackground = {
  __typename?: 'PageFields_wrapInBackground';
  create?: Maybe<PageFields_WrapInBackground_Create>;
  delete?: Maybe<PageFields_WrapInBackground_Delete>;
  read?: Maybe<PageFields_WrapInBackground_Read>;
  update?: Maybe<PageFields_WrapInBackground_Update>;
};

export type PageFields_WrapInBackground_Create = {
  __typename?: 'PageFields_wrapInBackground_Create';
  permission: Scalars['Boolean'];
};

export type PageFields_WrapInBackground_Delete = {
  __typename?: 'PageFields_wrapInBackground_Delete';
  permission: Scalars['Boolean'];
};

export type PageFields_WrapInBackground_Read = {
  __typename?: 'PageFields_wrapInBackground_Read';
  permission: Scalars['Boolean'];
};

export type PageFields_WrapInBackground_Update = {
  __typename?: 'PageFields_wrapInBackground_Update';
  permission: Scalars['Boolean'];
};

export type PageReadAccess = {
  __typename?: 'PageReadAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type PageReadDocAccess = {
  __typename?: 'PageReadDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type PageReadVersionsAccess = {
  __typename?: 'PageReadVersionsAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type PageReadVersionsDocAccess = {
  __typename?: 'PageReadVersionsDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type PageUpdateAccess = {
  __typename?: 'PageUpdateAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type PageUpdateDocAccess = {
  __typename?: 'PageUpdateDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export enum PageUpdate_Header_Type_MutationInput {
  Default = 'default',
  FeaturedForm = 'featuredForm',
  FeaturedImage = 'featuredImage',
  HomeAnimated = 'homeAnimated'
}

export enum PageUpdate__Status_MutationInput {
  Draft = 'draft',
  Published = 'published'
}

export type PageVersion = {
  __typename?: 'PageVersion';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  latest?: Maybe<Scalars['Boolean']>;
  parent?: Maybe<Page>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  version?: Maybe<PageVersion_Version>;
};


export type PageVersionParentArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
};

export type PageVersion_Version = {
  __typename?: 'PageVersion_Version';
  _status?: Maybe<PageVersion_Version__Status>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['JSON']>;
  header?: Maybe<PageVersion_Version_Header>;
  isArticle?: Maybe<Scalars['Boolean']>;
  isPlaceholder?: Maybe<Scalars['Boolean']>;
  layout?: Maybe<PageVersion_Version_Layout>;
  meta?: Maybe<PageVersion_Version_Meta>;
  slug?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  titleSettings?: Maybe<Page_TitleSettings>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type PageVersion_VersionDescriptionArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};

export type PageVersion_Version_Header = {
  __typename?: 'PageVersion_Version_Header';
  beforeFeaturedFormContent?: Maybe<Scalars['JSON']>;
  featuredForm?: Maybe<Form>;
  image?: Maybe<Media>;
  showLookingForForm?: Maybe<Scalars['Boolean']>;
  showRatingWidget?: Maybe<Scalars['Boolean']>;
  type?: Maybe<PageVersion_Version_Header_Type>;
  wrapInBackground?: Maybe<Scalars['Boolean']>;
};


export type PageVersion_Version_HeaderBeforeFeaturedFormContentArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};

export enum PageVersion_Version_Header_Type {
  Default = 'default',
  FeaturedForm = 'featuredForm',
  FeaturedImage = 'featuredImage',
  HomeAnimated = 'homeAnimated'
}

export type PageVersion_Version_Layout = {
  __typename?: 'PageVersion_Version_Layout';
  blocks?: Maybe<Array<PageVersion_Version_Layout_Blocks>>;
};

export type PageVersion_Version_Layout_Blocks = AnimatedTextBlock | ArticlesScroller | BackgroundWithBlock | CardWithBlocks | Columns | Comparisons | Content | Cta | CtaButton | Faq | FormBlock | Image | LeadFormBlock | Lists | ServicesScroller | SliderWithBlocks | Spacer | StickyImageScroll | VerticalSlider;

export type PageVersion_Version_Meta = {
  __typename?: 'PageVersion_Version_Meta';
  description?: Maybe<Scalars['String']>;
  image?: Maybe<Media>;
  noIndex?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
};

export enum PageVersion_Version__Status {
  Draft = 'draft',
  Published = 'published'
}

export type Page_Header = {
  __typename?: 'Page_Header';
  beforeFeaturedFormContent?: Maybe<Scalars['JSON']>;
  featuredForm?: Maybe<Form>;
  image?: Maybe<Media>;
  showLookingForForm?: Maybe<Scalars['Boolean']>;
  showRatingWidget?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Page_Header_Type>;
  wrapInBackground?: Maybe<Scalars['Boolean']>;
};


export type Page_HeaderBeforeFeaturedFormContentArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};

export enum Page_Header_Type {
  Default = 'default',
  FeaturedForm = 'featuredForm',
  FeaturedImage = 'featuredImage',
  HomeAnimated = 'homeAnimated'
}

export enum Page_Header_Type_MutationInput {
  Default = 'default',
  FeaturedForm = 'featuredForm',
  FeaturedImage = 'featuredImage',
  HomeAnimated = 'homeAnimated'
}

export type Page_Layout = {
  __typename?: 'Page_Layout';
  blocks?: Maybe<Array<Page_Layout_Blocks>>;
};

export type Page_Layout_Blocks = AnimatedTextBlock | ArticlesScroller | BackgroundWithBlock | CardWithBlocks | Columns | Comparisons | Content | Cta | CtaButton | Faq | FormBlock | Image | LeadFormBlock | Lists | ServicesScroller | SliderWithBlocks | Spacer | StickyImageScroll | VerticalSlider;

export type Page_Meta = {
  __typename?: 'Page_Meta';
  description?: Maybe<Scalars['String']>;
  image?: Maybe<Media>;
  noIndex?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
};

export type Page_TitleSettings = {
  __typename?: 'Page_TitleSettings';
  boldEndIndex?: Maybe<Scalars['Float']>;
  boldStartIndex?: Maybe<Scalars['Float']>;
};

export enum Page__Status {
  Draft = 'draft',
  Published = 'published'
}

export enum Page__Status_Input {
  Draft = 'draft',
  Published = 'published'
}

export enum Page__Status_MutationInput {
  Draft = 'draft',
  Published = 'published'
}

export type Page__Status_Operator = {
  all?: InputMaybe<Array<InputMaybe<Page__Status_Input>>>;
  equals?: InputMaybe<Page__Status_Input>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Page__Status_Input>>>;
  not_equals?: InputMaybe<Page__Status_Input>;
  not_in?: InputMaybe<Array<InputMaybe<Page__Status_Input>>>;
};

export type Page_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type Page_Description_Operator = {
  contains?: InputMaybe<Scalars['JSON']>;
  equals?: InputMaybe<Scalars['JSON']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  like?: InputMaybe<Scalars['JSON']>;
  not_equals?: InputMaybe<Scalars['JSON']>;
};

export type Page_Header__BeforeFeaturedFormContent_Operator = {
  contains?: InputMaybe<Scalars['JSON']>;
  equals?: InputMaybe<Scalars['JSON']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  like?: InputMaybe<Scalars['JSON']>;
  not_equals?: InputMaybe<Scalars['JSON']>;
};

export type Page_Header__FeaturedForm_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  equals?: InputMaybe<Scalars['JSON']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  not_equals?: InputMaybe<Scalars['JSON']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type Page_Header__Image_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  equals?: InputMaybe<Scalars['JSON']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  not_equals?: InputMaybe<Scalars['JSON']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type Page_Header__ShowLookingForForm_Operator = {
  equals?: InputMaybe<Scalars['Boolean']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  not_equals?: InputMaybe<Scalars['Boolean']>;
};

export type Page_Header__ShowRatingWidget_Operator = {
  equals?: InputMaybe<Scalars['Boolean']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  not_equals?: InputMaybe<Scalars['Boolean']>;
};

export enum Page_Header__Type_Input {
  Default = 'default',
  FeaturedForm = 'featuredForm',
  FeaturedImage = 'featuredImage',
  HomeAnimated = 'homeAnimated'
}

export type Page_Header__Type_Operator = {
  all?: InputMaybe<Array<InputMaybe<Page_Header__Type_Input>>>;
  equals?: InputMaybe<Page_Header__Type_Input>;
  in?: InputMaybe<Array<InputMaybe<Page_Header__Type_Input>>>;
  not_equals?: InputMaybe<Page_Header__Type_Input>;
  not_in?: InputMaybe<Array<InputMaybe<Page_Header__Type_Input>>>;
};

export type Page_Header__WrapInBackground_Operator = {
  equals?: InputMaybe<Scalars['Boolean']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  not_equals?: InputMaybe<Scalars['Boolean']>;
};

export type Page_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Page_IsArticle_Operator = {
  equals?: InputMaybe<Scalars['Boolean']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  not_equals?: InputMaybe<Scalars['Boolean']>;
};

export type Page_IsPlaceholder_Operator = {
  equals?: InputMaybe<Scalars['Boolean']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  not_equals?: InputMaybe<Scalars['Boolean']>;
};

export type Page_Meta__Description_Operator = {
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
};

export type Page_Meta__Image_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  equals?: InputMaybe<Scalars['JSON']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  not_equals?: InputMaybe<Scalars['JSON']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type Page_Meta__NoIndex_Operator = {
  equals?: InputMaybe<Scalars['Boolean']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  not_equals?: InputMaybe<Scalars['Boolean']>;
};

export type Page_Meta__Title_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Page_Slug_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Page_TitleSettings__BoldEndIndex_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Page_TitleSettings__BoldStartIndex_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Page_Title_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Page_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type Page_Where = {
  AND?: InputMaybe<Array<InputMaybe<Page_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Page_Where_Or>>>;
  _status?: InputMaybe<Page__Status_Operator>;
  createdAt?: InputMaybe<Page_CreatedAt_Operator>;
  description?: InputMaybe<Page_Description_Operator>;
  header__beforeFeaturedFormContent?: InputMaybe<Page_Header__BeforeFeaturedFormContent_Operator>;
  header__featuredForm?: InputMaybe<Page_Header__FeaturedForm_Operator>;
  header__image?: InputMaybe<Page_Header__Image_Operator>;
  header__showLookingForForm?: InputMaybe<Page_Header__ShowLookingForForm_Operator>;
  header__showRatingWidget?: InputMaybe<Page_Header__ShowRatingWidget_Operator>;
  header__type?: InputMaybe<Page_Header__Type_Operator>;
  header__wrapInBackground?: InputMaybe<Page_Header__WrapInBackground_Operator>;
  id?: InputMaybe<Page_Id_Operator>;
  isArticle?: InputMaybe<Page_IsArticle_Operator>;
  isPlaceholder?: InputMaybe<Page_IsPlaceholder_Operator>;
  meta__description?: InputMaybe<Page_Meta__Description_Operator>;
  meta__image?: InputMaybe<Page_Meta__Image_Operator>;
  meta__noIndex?: InputMaybe<Page_Meta__NoIndex_Operator>;
  meta__title?: InputMaybe<Page_Meta__Title_Operator>;
  slug?: InputMaybe<Page_Slug_Operator>;
  title?: InputMaybe<Page_Title_Operator>;
  titleSettings__boldEndIndex?: InputMaybe<Page_TitleSettings__BoldEndIndex_Operator>;
  titleSettings__boldStartIndex?: InputMaybe<Page_TitleSettings__BoldStartIndex_Operator>;
  updatedAt?: InputMaybe<Page_UpdatedAt_Operator>;
};

export type Page_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<Page_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Page_Where_Or>>>;
  _status?: InputMaybe<Page__Status_Operator>;
  createdAt?: InputMaybe<Page_CreatedAt_Operator>;
  description?: InputMaybe<Page_Description_Operator>;
  header__beforeFeaturedFormContent?: InputMaybe<Page_Header__BeforeFeaturedFormContent_Operator>;
  header__featuredForm?: InputMaybe<Page_Header__FeaturedForm_Operator>;
  header__image?: InputMaybe<Page_Header__Image_Operator>;
  header__showLookingForForm?: InputMaybe<Page_Header__ShowLookingForForm_Operator>;
  header__showRatingWidget?: InputMaybe<Page_Header__ShowRatingWidget_Operator>;
  header__type?: InputMaybe<Page_Header__Type_Operator>;
  header__wrapInBackground?: InputMaybe<Page_Header__WrapInBackground_Operator>;
  id?: InputMaybe<Page_Id_Operator>;
  isArticle?: InputMaybe<Page_IsArticle_Operator>;
  isPlaceholder?: InputMaybe<Page_IsPlaceholder_Operator>;
  meta__description?: InputMaybe<Page_Meta__Description_Operator>;
  meta__image?: InputMaybe<Page_Meta__Image_Operator>;
  meta__noIndex?: InputMaybe<Page_Meta__NoIndex_Operator>;
  meta__title?: InputMaybe<Page_Meta__Title_Operator>;
  slug?: InputMaybe<Page_Slug_Operator>;
  title?: InputMaybe<Page_Title_Operator>;
  titleSettings__boldEndIndex?: InputMaybe<Page_TitleSettings__BoldEndIndex_Operator>;
  titleSettings__boldStartIndex?: InputMaybe<Page_TitleSettings__BoldStartIndex_Operator>;
  updatedAt?: InputMaybe<Page_UpdatedAt_Operator>;
};

export type Page_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<Page_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Page_Where_Or>>>;
  _status?: InputMaybe<Page__Status_Operator>;
  createdAt?: InputMaybe<Page_CreatedAt_Operator>;
  description?: InputMaybe<Page_Description_Operator>;
  header__beforeFeaturedFormContent?: InputMaybe<Page_Header__BeforeFeaturedFormContent_Operator>;
  header__featuredForm?: InputMaybe<Page_Header__FeaturedForm_Operator>;
  header__image?: InputMaybe<Page_Header__Image_Operator>;
  header__showLookingForForm?: InputMaybe<Page_Header__ShowLookingForForm_Operator>;
  header__showRatingWidget?: InputMaybe<Page_Header__ShowRatingWidget_Operator>;
  header__type?: InputMaybe<Page_Header__Type_Operator>;
  header__wrapInBackground?: InputMaybe<Page_Header__WrapInBackground_Operator>;
  id?: InputMaybe<Page_Id_Operator>;
  isArticle?: InputMaybe<Page_IsArticle_Operator>;
  isPlaceholder?: InputMaybe<Page_IsPlaceholder_Operator>;
  meta__description?: InputMaybe<Page_Meta__Description_Operator>;
  meta__image?: InputMaybe<Page_Meta__Image_Operator>;
  meta__noIndex?: InputMaybe<Page_Meta__NoIndex_Operator>;
  meta__title?: InputMaybe<Page_Meta__Title_Operator>;
  slug?: InputMaybe<Page_Slug_Operator>;
  title?: InputMaybe<Page_Title_Operator>;
  titleSettings__boldEndIndex?: InputMaybe<Page_TitleSettings__BoldEndIndex_Operator>;
  titleSettings__boldStartIndex?: InputMaybe<Page_TitleSettings__BoldStartIndex_Operator>;
  updatedAt?: InputMaybe<Page_UpdatedAt_Operator>;
};

export type Pages = {
  __typename?: 'Pages';
  docs?: Maybe<Array<Maybe<Page>>>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPrevPage?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  nextPage?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  pagingCounter?: Maybe<Scalars['Int']>;
  prevPage?: Maybe<Scalars['Int']>;
  totalDocs?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
};

export type PayloadLockedDocument = {
  __typename?: 'PayloadLockedDocument';
  createdAt?: Maybe<Scalars['DateTime']>;
  document?: Maybe<PayloadLockedDocument_Document_Relationship>;
  globalSlug?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  user: PayloadLockedDocument_User_Relationship;
};


export type PayloadLockedDocumentDocumentArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
};

export type PayloadLockedDocumentUpdate_DocumentRelationshipInput = {
  relationTo?: InputMaybe<PayloadLockedDocumentUpdate_DocumentRelationshipInputRelationTo>;
  value?: InputMaybe<Scalars['JSON']>;
};

export enum PayloadLockedDocumentUpdate_DocumentRelationshipInputRelationTo {
  Article = 'article',
  Category = 'category',
  EpcCheckFormSubmission = 'epc_check_form_submission',
  FormSubmissions = 'form_submissions',
  Forms = 'forms',
  LandingPage = 'landing_page',
  LandingTumbler = 'landing_tumbler',
  LeadForm = 'lead_form',
  Media = 'media',
  NewsletterSubscriber = 'newsletter_subscriber',
  Page = 'page',
  Service = 'service',
  Tag = 'tag',
  User = 'user'
}

export type PayloadLockedDocumentUpdate_UserRelationshipInput = {
  relationTo?: InputMaybe<PayloadLockedDocumentUpdate_UserRelationshipInputRelationTo>;
  value?: InputMaybe<Scalars['JSON']>;
};

export enum PayloadLockedDocumentUpdate_UserRelationshipInputRelationTo {
  User = 'user'
}

export type PayloadLockedDocument_Document = Article | Category | EpcCheckFormSubmission | Form | FormSubmission | LandingPage | LandingTumbler | LeadForm | Media | NewsletterSubscriber | Page | Service | Tag | User;

export type PayloadLockedDocument_DocumentRelationshipInput = {
  relationTo?: InputMaybe<PayloadLockedDocument_DocumentRelationshipInputRelationTo>;
  value?: InputMaybe<Scalars['JSON']>;
};

export enum PayloadLockedDocument_DocumentRelationshipInputRelationTo {
  Article = 'article',
  Category = 'category',
  EpcCheckFormSubmission = 'epc_check_form_submission',
  FormSubmissions = 'form_submissions',
  Forms = 'forms',
  LandingPage = 'landing_page',
  LandingTumbler = 'landing_tumbler',
  LeadForm = 'lead_form',
  Media = 'media',
  NewsletterSubscriber = 'newsletter_subscriber',
  Page = 'page',
  Service = 'service',
  Tag = 'tag',
  User = 'user'
}

export enum PayloadLockedDocument_Document_RelationTo {
  Article = 'article',
  Category = 'category',
  EpcCheckFormSubmission = 'epc_check_form_submission',
  FormSubmissions = 'form_submissions',
  Forms = 'forms',
  LandingPage = 'landing_page',
  LandingTumbler = 'landing_tumbler',
  LeadForm = 'lead_form',
  Media = 'media',
  NewsletterSubscriber = 'newsletter_subscriber',
  Page = 'page',
  Service = 'service',
  Tag = 'tag',
  User = 'user'
}

export type PayloadLockedDocument_Document_Relationship = {
  __typename?: 'PayloadLockedDocument_Document_Relationship';
  relationTo?: Maybe<PayloadLockedDocument_Document_RelationTo>;
  value?: Maybe<PayloadLockedDocument_Document>;
};

export type PayloadLockedDocument_User = User;

export type PayloadLockedDocument_UserRelationshipInput = {
  relationTo?: InputMaybe<PayloadLockedDocument_UserRelationshipInputRelationTo>;
  value?: InputMaybe<Scalars['JSON']>;
};

export enum PayloadLockedDocument_UserRelationshipInputRelationTo {
  User = 'user'
}

export enum PayloadLockedDocument_User_RelationTo {
  User = 'user'
}

export type PayloadLockedDocument_User_Relationship = {
  __typename?: 'PayloadLockedDocument_User_Relationship';
  relationTo?: Maybe<PayloadLockedDocument_User_RelationTo>;
  value?: Maybe<PayloadLockedDocument_User>;
};

export type PayloadLockedDocument_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type PayloadLockedDocument_Document_Relation = {
  relationTo?: InputMaybe<PayloadLockedDocument_Document_Relation_RelationTo>;
  value?: InputMaybe<Scalars['JSON']>;
};

export enum PayloadLockedDocument_Document_Relation_RelationTo {
  Article = 'article',
  Category = 'category',
  EpcCheckFormSubmission = 'epc_check_form_submission',
  FormSubmissions = 'form_submissions',
  Forms = 'forms',
  LandingPage = 'landing_page',
  LandingTumbler = 'landing_tumbler',
  LeadForm = 'lead_form',
  Media = 'media',
  NewsletterSubscriber = 'newsletter_subscriber',
  Page = 'page',
  Service = 'service',
  Tag = 'tag',
  User = 'user'
}

export type PayloadLockedDocument_GlobalSlug_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PayloadLockedDocument_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PayloadLockedDocument_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type PayloadLockedDocument_User_Relation = {
  relationTo?: InputMaybe<PayloadLockedDocument_User_Relation_RelationTo>;
  value?: InputMaybe<Scalars['JSON']>;
};

export enum PayloadLockedDocument_User_Relation_RelationTo {
  User = 'user'
}

export type PayloadLockedDocument_Where = {
  AND?: InputMaybe<Array<InputMaybe<PayloadLockedDocument_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<PayloadLockedDocument_Where_Or>>>;
  createdAt?: InputMaybe<PayloadLockedDocument_CreatedAt_Operator>;
  document?: InputMaybe<PayloadLockedDocument_Document_Relation>;
  globalSlug?: InputMaybe<PayloadLockedDocument_GlobalSlug_Operator>;
  id?: InputMaybe<PayloadLockedDocument_Id_Operator>;
  updatedAt?: InputMaybe<PayloadLockedDocument_UpdatedAt_Operator>;
  user?: InputMaybe<PayloadLockedDocument_User_Relation>;
};

export type PayloadLockedDocument_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<PayloadLockedDocument_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<PayloadLockedDocument_Where_Or>>>;
  createdAt?: InputMaybe<PayloadLockedDocument_CreatedAt_Operator>;
  document?: InputMaybe<PayloadLockedDocument_Document_Relation>;
  globalSlug?: InputMaybe<PayloadLockedDocument_GlobalSlug_Operator>;
  id?: InputMaybe<PayloadLockedDocument_Id_Operator>;
  updatedAt?: InputMaybe<PayloadLockedDocument_UpdatedAt_Operator>;
  user?: InputMaybe<PayloadLockedDocument_User_Relation>;
};

export type PayloadLockedDocument_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<PayloadLockedDocument_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<PayloadLockedDocument_Where_Or>>>;
  createdAt?: InputMaybe<PayloadLockedDocument_CreatedAt_Operator>;
  document?: InputMaybe<PayloadLockedDocument_Document_Relation>;
  globalSlug?: InputMaybe<PayloadLockedDocument_GlobalSlug_Operator>;
  id?: InputMaybe<PayloadLockedDocument_Id_Operator>;
  updatedAt?: InputMaybe<PayloadLockedDocument_UpdatedAt_Operator>;
  user?: InputMaybe<PayloadLockedDocument_User_Relation>;
};

export type PayloadLockedDocuments = {
  __typename?: 'PayloadLockedDocuments';
  docs?: Maybe<Array<Maybe<PayloadLockedDocument>>>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPrevPage?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  nextPage?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  pagingCounter?: Maybe<Scalars['Int']>;
  prevPage?: Maybe<Scalars['Int']>;
  totalDocs?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
};

export type PayloadLockedDocumentsCreateAccess = {
  __typename?: 'PayloadLockedDocumentsCreateAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type PayloadLockedDocumentsCreateDocAccess = {
  __typename?: 'PayloadLockedDocumentsCreateDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type PayloadLockedDocumentsDeleteAccess = {
  __typename?: 'PayloadLockedDocumentsDeleteAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type PayloadLockedDocumentsDeleteDocAccess = {
  __typename?: 'PayloadLockedDocumentsDeleteDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type PayloadLockedDocumentsDocAccessFields = {
  __typename?: 'PayloadLockedDocumentsDocAccessFields';
  createdAt?: Maybe<PayloadLockedDocumentsDocAccessFields_CreatedAt>;
  document?: Maybe<PayloadLockedDocumentsDocAccessFields_Document>;
  globalSlug?: Maybe<PayloadLockedDocumentsDocAccessFields_GlobalSlug>;
  updatedAt?: Maybe<PayloadLockedDocumentsDocAccessFields_UpdatedAt>;
  user?: Maybe<PayloadLockedDocumentsDocAccessFields_User>;
};

export type PayloadLockedDocumentsDocAccessFields_CreatedAt = {
  __typename?: 'PayloadLockedDocumentsDocAccessFields_createdAt';
  create?: Maybe<PayloadLockedDocumentsDocAccessFields_CreatedAt_Create>;
  delete?: Maybe<PayloadLockedDocumentsDocAccessFields_CreatedAt_Delete>;
  read?: Maybe<PayloadLockedDocumentsDocAccessFields_CreatedAt_Read>;
  update?: Maybe<PayloadLockedDocumentsDocAccessFields_CreatedAt_Update>;
};

export type PayloadLockedDocumentsDocAccessFields_CreatedAt_Create = {
  __typename?: 'PayloadLockedDocumentsDocAccessFields_createdAt_Create';
  permission: Scalars['Boolean'];
};

export type PayloadLockedDocumentsDocAccessFields_CreatedAt_Delete = {
  __typename?: 'PayloadLockedDocumentsDocAccessFields_createdAt_Delete';
  permission: Scalars['Boolean'];
};

export type PayloadLockedDocumentsDocAccessFields_CreatedAt_Read = {
  __typename?: 'PayloadLockedDocumentsDocAccessFields_createdAt_Read';
  permission: Scalars['Boolean'];
};

export type PayloadLockedDocumentsDocAccessFields_CreatedAt_Update = {
  __typename?: 'PayloadLockedDocumentsDocAccessFields_createdAt_Update';
  permission: Scalars['Boolean'];
};

export type PayloadLockedDocumentsDocAccessFields_Document = {
  __typename?: 'PayloadLockedDocumentsDocAccessFields_document';
  create?: Maybe<PayloadLockedDocumentsDocAccessFields_Document_Create>;
  delete?: Maybe<PayloadLockedDocumentsDocAccessFields_Document_Delete>;
  read?: Maybe<PayloadLockedDocumentsDocAccessFields_Document_Read>;
  update?: Maybe<PayloadLockedDocumentsDocAccessFields_Document_Update>;
};

export type PayloadLockedDocumentsDocAccessFields_Document_Create = {
  __typename?: 'PayloadLockedDocumentsDocAccessFields_document_Create';
  permission: Scalars['Boolean'];
};

export type PayloadLockedDocumentsDocAccessFields_Document_Delete = {
  __typename?: 'PayloadLockedDocumentsDocAccessFields_document_Delete';
  permission: Scalars['Boolean'];
};

export type PayloadLockedDocumentsDocAccessFields_Document_Read = {
  __typename?: 'PayloadLockedDocumentsDocAccessFields_document_Read';
  permission: Scalars['Boolean'];
};

export type PayloadLockedDocumentsDocAccessFields_Document_Update = {
  __typename?: 'PayloadLockedDocumentsDocAccessFields_document_Update';
  permission: Scalars['Boolean'];
};

export type PayloadLockedDocumentsDocAccessFields_GlobalSlug = {
  __typename?: 'PayloadLockedDocumentsDocAccessFields_globalSlug';
  create?: Maybe<PayloadLockedDocumentsDocAccessFields_GlobalSlug_Create>;
  delete?: Maybe<PayloadLockedDocumentsDocAccessFields_GlobalSlug_Delete>;
  read?: Maybe<PayloadLockedDocumentsDocAccessFields_GlobalSlug_Read>;
  update?: Maybe<PayloadLockedDocumentsDocAccessFields_GlobalSlug_Update>;
};

export type PayloadLockedDocumentsDocAccessFields_GlobalSlug_Create = {
  __typename?: 'PayloadLockedDocumentsDocAccessFields_globalSlug_Create';
  permission: Scalars['Boolean'];
};

export type PayloadLockedDocumentsDocAccessFields_GlobalSlug_Delete = {
  __typename?: 'PayloadLockedDocumentsDocAccessFields_globalSlug_Delete';
  permission: Scalars['Boolean'];
};

export type PayloadLockedDocumentsDocAccessFields_GlobalSlug_Read = {
  __typename?: 'PayloadLockedDocumentsDocAccessFields_globalSlug_Read';
  permission: Scalars['Boolean'];
};

export type PayloadLockedDocumentsDocAccessFields_GlobalSlug_Update = {
  __typename?: 'PayloadLockedDocumentsDocAccessFields_globalSlug_Update';
  permission: Scalars['Boolean'];
};

export type PayloadLockedDocumentsDocAccessFields_UpdatedAt = {
  __typename?: 'PayloadLockedDocumentsDocAccessFields_updatedAt';
  create?: Maybe<PayloadLockedDocumentsDocAccessFields_UpdatedAt_Create>;
  delete?: Maybe<PayloadLockedDocumentsDocAccessFields_UpdatedAt_Delete>;
  read?: Maybe<PayloadLockedDocumentsDocAccessFields_UpdatedAt_Read>;
  update?: Maybe<PayloadLockedDocumentsDocAccessFields_UpdatedAt_Update>;
};

export type PayloadLockedDocumentsDocAccessFields_UpdatedAt_Create = {
  __typename?: 'PayloadLockedDocumentsDocAccessFields_updatedAt_Create';
  permission: Scalars['Boolean'];
};

export type PayloadLockedDocumentsDocAccessFields_UpdatedAt_Delete = {
  __typename?: 'PayloadLockedDocumentsDocAccessFields_updatedAt_Delete';
  permission: Scalars['Boolean'];
};

export type PayloadLockedDocumentsDocAccessFields_UpdatedAt_Read = {
  __typename?: 'PayloadLockedDocumentsDocAccessFields_updatedAt_Read';
  permission: Scalars['Boolean'];
};

export type PayloadLockedDocumentsDocAccessFields_UpdatedAt_Update = {
  __typename?: 'PayloadLockedDocumentsDocAccessFields_updatedAt_Update';
  permission: Scalars['Boolean'];
};

export type PayloadLockedDocumentsDocAccessFields_User = {
  __typename?: 'PayloadLockedDocumentsDocAccessFields_user';
  create?: Maybe<PayloadLockedDocumentsDocAccessFields_User_Create>;
  delete?: Maybe<PayloadLockedDocumentsDocAccessFields_User_Delete>;
  read?: Maybe<PayloadLockedDocumentsDocAccessFields_User_Read>;
  update?: Maybe<PayloadLockedDocumentsDocAccessFields_User_Update>;
};

export type PayloadLockedDocumentsDocAccessFields_User_Create = {
  __typename?: 'PayloadLockedDocumentsDocAccessFields_user_Create';
  permission: Scalars['Boolean'];
};

export type PayloadLockedDocumentsDocAccessFields_User_Delete = {
  __typename?: 'PayloadLockedDocumentsDocAccessFields_user_Delete';
  permission: Scalars['Boolean'];
};

export type PayloadLockedDocumentsDocAccessFields_User_Read = {
  __typename?: 'PayloadLockedDocumentsDocAccessFields_user_Read';
  permission: Scalars['Boolean'];
};

export type PayloadLockedDocumentsDocAccessFields_User_Update = {
  __typename?: 'PayloadLockedDocumentsDocAccessFields_user_Update';
  permission: Scalars['Boolean'];
};

export type PayloadLockedDocumentsFields = {
  __typename?: 'PayloadLockedDocumentsFields';
  createdAt?: Maybe<PayloadLockedDocumentsFields_CreatedAt>;
  document?: Maybe<PayloadLockedDocumentsFields_Document>;
  globalSlug?: Maybe<PayloadLockedDocumentsFields_GlobalSlug>;
  updatedAt?: Maybe<PayloadLockedDocumentsFields_UpdatedAt>;
  user?: Maybe<PayloadLockedDocumentsFields_User>;
};

export type PayloadLockedDocumentsFields_CreatedAt = {
  __typename?: 'PayloadLockedDocumentsFields_createdAt';
  create?: Maybe<PayloadLockedDocumentsFields_CreatedAt_Create>;
  delete?: Maybe<PayloadLockedDocumentsFields_CreatedAt_Delete>;
  read?: Maybe<PayloadLockedDocumentsFields_CreatedAt_Read>;
  update?: Maybe<PayloadLockedDocumentsFields_CreatedAt_Update>;
};

export type PayloadLockedDocumentsFields_CreatedAt_Create = {
  __typename?: 'PayloadLockedDocumentsFields_createdAt_Create';
  permission: Scalars['Boolean'];
};

export type PayloadLockedDocumentsFields_CreatedAt_Delete = {
  __typename?: 'PayloadLockedDocumentsFields_createdAt_Delete';
  permission: Scalars['Boolean'];
};

export type PayloadLockedDocumentsFields_CreatedAt_Read = {
  __typename?: 'PayloadLockedDocumentsFields_createdAt_Read';
  permission: Scalars['Boolean'];
};

export type PayloadLockedDocumentsFields_CreatedAt_Update = {
  __typename?: 'PayloadLockedDocumentsFields_createdAt_Update';
  permission: Scalars['Boolean'];
};

export type PayloadLockedDocumentsFields_Document = {
  __typename?: 'PayloadLockedDocumentsFields_document';
  create?: Maybe<PayloadLockedDocumentsFields_Document_Create>;
  delete?: Maybe<PayloadLockedDocumentsFields_Document_Delete>;
  read?: Maybe<PayloadLockedDocumentsFields_Document_Read>;
  update?: Maybe<PayloadLockedDocumentsFields_Document_Update>;
};

export type PayloadLockedDocumentsFields_Document_Create = {
  __typename?: 'PayloadLockedDocumentsFields_document_Create';
  permission: Scalars['Boolean'];
};

export type PayloadLockedDocumentsFields_Document_Delete = {
  __typename?: 'PayloadLockedDocumentsFields_document_Delete';
  permission: Scalars['Boolean'];
};

export type PayloadLockedDocumentsFields_Document_Read = {
  __typename?: 'PayloadLockedDocumentsFields_document_Read';
  permission: Scalars['Boolean'];
};

export type PayloadLockedDocumentsFields_Document_Update = {
  __typename?: 'PayloadLockedDocumentsFields_document_Update';
  permission: Scalars['Boolean'];
};

export type PayloadLockedDocumentsFields_GlobalSlug = {
  __typename?: 'PayloadLockedDocumentsFields_globalSlug';
  create?: Maybe<PayloadLockedDocumentsFields_GlobalSlug_Create>;
  delete?: Maybe<PayloadLockedDocumentsFields_GlobalSlug_Delete>;
  read?: Maybe<PayloadLockedDocumentsFields_GlobalSlug_Read>;
  update?: Maybe<PayloadLockedDocumentsFields_GlobalSlug_Update>;
};

export type PayloadLockedDocumentsFields_GlobalSlug_Create = {
  __typename?: 'PayloadLockedDocumentsFields_globalSlug_Create';
  permission: Scalars['Boolean'];
};

export type PayloadLockedDocumentsFields_GlobalSlug_Delete = {
  __typename?: 'PayloadLockedDocumentsFields_globalSlug_Delete';
  permission: Scalars['Boolean'];
};

export type PayloadLockedDocumentsFields_GlobalSlug_Read = {
  __typename?: 'PayloadLockedDocumentsFields_globalSlug_Read';
  permission: Scalars['Boolean'];
};

export type PayloadLockedDocumentsFields_GlobalSlug_Update = {
  __typename?: 'PayloadLockedDocumentsFields_globalSlug_Update';
  permission: Scalars['Boolean'];
};

export type PayloadLockedDocumentsFields_UpdatedAt = {
  __typename?: 'PayloadLockedDocumentsFields_updatedAt';
  create?: Maybe<PayloadLockedDocumentsFields_UpdatedAt_Create>;
  delete?: Maybe<PayloadLockedDocumentsFields_UpdatedAt_Delete>;
  read?: Maybe<PayloadLockedDocumentsFields_UpdatedAt_Read>;
  update?: Maybe<PayloadLockedDocumentsFields_UpdatedAt_Update>;
};

export type PayloadLockedDocumentsFields_UpdatedAt_Create = {
  __typename?: 'PayloadLockedDocumentsFields_updatedAt_Create';
  permission: Scalars['Boolean'];
};

export type PayloadLockedDocumentsFields_UpdatedAt_Delete = {
  __typename?: 'PayloadLockedDocumentsFields_updatedAt_Delete';
  permission: Scalars['Boolean'];
};

export type PayloadLockedDocumentsFields_UpdatedAt_Read = {
  __typename?: 'PayloadLockedDocumentsFields_updatedAt_Read';
  permission: Scalars['Boolean'];
};

export type PayloadLockedDocumentsFields_UpdatedAt_Update = {
  __typename?: 'PayloadLockedDocumentsFields_updatedAt_Update';
  permission: Scalars['Boolean'];
};

export type PayloadLockedDocumentsFields_User = {
  __typename?: 'PayloadLockedDocumentsFields_user';
  create?: Maybe<PayloadLockedDocumentsFields_User_Create>;
  delete?: Maybe<PayloadLockedDocumentsFields_User_Delete>;
  read?: Maybe<PayloadLockedDocumentsFields_User_Read>;
  update?: Maybe<PayloadLockedDocumentsFields_User_Update>;
};

export type PayloadLockedDocumentsFields_User_Create = {
  __typename?: 'PayloadLockedDocumentsFields_user_Create';
  permission: Scalars['Boolean'];
};

export type PayloadLockedDocumentsFields_User_Delete = {
  __typename?: 'PayloadLockedDocumentsFields_user_Delete';
  permission: Scalars['Boolean'];
};

export type PayloadLockedDocumentsFields_User_Read = {
  __typename?: 'PayloadLockedDocumentsFields_user_Read';
  permission: Scalars['Boolean'];
};

export type PayloadLockedDocumentsFields_User_Update = {
  __typename?: 'PayloadLockedDocumentsFields_user_Update';
  permission: Scalars['Boolean'];
};

export type PayloadLockedDocumentsReadAccess = {
  __typename?: 'PayloadLockedDocumentsReadAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type PayloadLockedDocumentsReadDocAccess = {
  __typename?: 'PayloadLockedDocumentsReadDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type PayloadLockedDocumentsUpdateAccess = {
  __typename?: 'PayloadLockedDocumentsUpdateAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type PayloadLockedDocumentsUpdateDocAccess = {
  __typename?: 'PayloadLockedDocumentsUpdateDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type PayloadPreference = {
  __typename?: 'PayloadPreference';
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  key?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  user: PayloadPreference_User_Relationship;
  value?: Maybe<Scalars['JSON']>;
};

export type PayloadPreferenceUpdate_UserRelationshipInput = {
  relationTo?: InputMaybe<PayloadPreferenceUpdate_UserRelationshipInputRelationTo>;
  value?: InputMaybe<Scalars['JSON']>;
};

export enum PayloadPreferenceUpdate_UserRelationshipInputRelationTo {
  User = 'user'
}

export type PayloadPreference_User = User;

export type PayloadPreference_UserRelationshipInput = {
  relationTo?: InputMaybe<PayloadPreference_UserRelationshipInputRelationTo>;
  value?: InputMaybe<Scalars['JSON']>;
};

export enum PayloadPreference_UserRelationshipInputRelationTo {
  User = 'user'
}

export enum PayloadPreference_User_RelationTo {
  User = 'user'
}

export type PayloadPreference_User_Relationship = {
  __typename?: 'PayloadPreference_User_Relationship';
  relationTo?: Maybe<PayloadPreference_User_RelationTo>;
  value?: Maybe<PayloadPreference_User>;
};

export type PayloadPreference_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type PayloadPreference_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PayloadPreference_Key_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type PayloadPreference_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type PayloadPreference_User_Relation = {
  relationTo?: InputMaybe<PayloadPreference_User_Relation_RelationTo>;
  value?: InputMaybe<Scalars['JSON']>;
};

export enum PayloadPreference_User_Relation_RelationTo {
  User = 'user'
}

export type PayloadPreference_Value_Operator = {
  contains?: InputMaybe<Scalars['JSON']>;
  equals?: InputMaybe<Scalars['JSON']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  intersects?: InputMaybe<Scalars['JSON']>;
  like?: InputMaybe<Scalars['JSON']>;
  not_equals?: InputMaybe<Scalars['JSON']>;
  within?: InputMaybe<Scalars['JSON']>;
};

export type PayloadPreference_Where = {
  AND?: InputMaybe<Array<InputMaybe<PayloadPreference_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<PayloadPreference_Where_Or>>>;
  createdAt?: InputMaybe<PayloadPreference_CreatedAt_Operator>;
  id?: InputMaybe<PayloadPreference_Id_Operator>;
  key?: InputMaybe<PayloadPreference_Key_Operator>;
  updatedAt?: InputMaybe<PayloadPreference_UpdatedAt_Operator>;
  user?: InputMaybe<PayloadPreference_User_Relation>;
  value?: InputMaybe<PayloadPreference_Value_Operator>;
};

export type PayloadPreference_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<PayloadPreference_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<PayloadPreference_Where_Or>>>;
  createdAt?: InputMaybe<PayloadPreference_CreatedAt_Operator>;
  id?: InputMaybe<PayloadPreference_Id_Operator>;
  key?: InputMaybe<PayloadPreference_Key_Operator>;
  updatedAt?: InputMaybe<PayloadPreference_UpdatedAt_Operator>;
  user?: InputMaybe<PayloadPreference_User_Relation>;
  value?: InputMaybe<PayloadPreference_Value_Operator>;
};

export type PayloadPreference_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<PayloadPreference_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<PayloadPreference_Where_Or>>>;
  createdAt?: InputMaybe<PayloadPreference_CreatedAt_Operator>;
  id?: InputMaybe<PayloadPreference_Id_Operator>;
  key?: InputMaybe<PayloadPreference_Key_Operator>;
  updatedAt?: InputMaybe<PayloadPreference_UpdatedAt_Operator>;
  user?: InputMaybe<PayloadPreference_User_Relation>;
  value?: InputMaybe<PayloadPreference_Value_Operator>;
};

export type PayloadPreferences = {
  __typename?: 'PayloadPreferences';
  docs?: Maybe<Array<Maybe<PayloadPreference>>>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPrevPage?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  nextPage?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  pagingCounter?: Maybe<Scalars['Int']>;
  prevPage?: Maybe<Scalars['Int']>;
  totalDocs?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
};

export type PayloadPreferencesCreateAccess = {
  __typename?: 'PayloadPreferencesCreateAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type PayloadPreferencesCreateDocAccess = {
  __typename?: 'PayloadPreferencesCreateDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type PayloadPreferencesDeleteAccess = {
  __typename?: 'PayloadPreferencesDeleteAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type PayloadPreferencesDeleteDocAccess = {
  __typename?: 'PayloadPreferencesDeleteDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type PayloadPreferencesDocAccessFields = {
  __typename?: 'PayloadPreferencesDocAccessFields';
  createdAt?: Maybe<PayloadPreferencesDocAccessFields_CreatedAt>;
  key?: Maybe<PayloadPreferencesDocAccessFields_Key>;
  updatedAt?: Maybe<PayloadPreferencesDocAccessFields_UpdatedAt>;
  user?: Maybe<PayloadPreferencesDocAccessFields_User>;
  value?: Maybe<PayloadPreferencesDocAccessFields_Value>;
};

export type PayloadPreferencesDocAccessFields_CreatedAt = {
  __typename?: 'PayloadPreferencesDocAccessFields_createdAt';
  create?: Maybe<PayloadPreferencesDocAccessFields_CreatedAt_Create>;
  delete?: Maybe<PayloadPreferencesDocAccessFields_CreatedAt_Delete>;
  read?: Maybe<PayloadPreferencesDocAccessFields_CreatedAt_Read>;
  update?: Maybe<PayloadPreferencesDocAccessFields_CreatedAt_Update>;
};

export type PayloadPreferencesDocAccessFields_CreatedAt_Create = {
  __typename?: 'PayloadPreferencesDocAccessFields_createdAt_Create';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesDocAccessFields_CreatedAt_Delete = {
  __typename?: 'PayloadPreferencesDocAccessFields_createdAt_Delete';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesDocAccessFields_CreatedAt_Read = {
  __typename?: 'PayloadPreferencesDocAccessFields_createdAt_Read';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesDocAccessFields_CreatedAt_Update = {
  __typename?: 'PayloadPreferencesDocAccessFields_createdAt_Update';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesDocAccessFields_Key = {
  __typename?: 'PayloadPreferencesDocAccessFields_key';
  create?: Maybe<PayloadPreferencesDocAccessFields_Key_Create>;
  delete?: Maybe<PayloadPreferencesDocAccessFields_Key_Delete>;
  read?: Maybe<PayloadPreferencesDocAccessFields_Key_Read>;
  update?: Maybe<PayloadPreferencesDocAccessFields_Key_Update>;
};

export type PayloadPreferencesDocAccessFields_Key_Create = {
  __typename?: 'PayloadPreferencesDocAccessFields_key_Create';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesDocAccessFields_Key_Delete = {
  __typename?: 'PayloadPreferencesDocAccessFields_key_Delete';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesDocAccessFields_Key_Read = {
  __typename?: 'PayloadPreferencesDocAccessFields_key_Read';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesDocAccessFields_Key_Update = {
  __typename?: 'PayloadPreferencesDocAccessFields_key_Update';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesDocAccessFields_UpdatedAt = {
  __typename?: 'PayloadPreferencesDocAccessFields_updatedAt';
  create?: Maybe<PayloadPreferencesDocAccessFields_UpdatedAt_Create>;
  delete?: Maybe<PayloadPreferencesDocAccessFields_UpdatedAt_Delete>;
  read?: Maybe<PayloadPreferencesDocAccessFields_UpdatedAt_Read>;
  update?: Maybe<PayloadPreferencesDocAccessFields_UpdatedAt_Update>;
};

export type PayloadPreferencesDocAccessFields_UpdatedAt_Create = {
  __typename?: 'PayloadPreferencesDocAccessFields_updatedAt_Create';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesDocAccessFields_UpdatedAt_Delete = {
  __typename?: 'PayloadPreferencesDocAccessFields_updatedAt_Delete';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesDocAccessFields_UpdatedAt_Read = {
  __typename?: 'PayloadPreferencesDocAccessFields_updatedAt_Read';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesDocAccessFields_UpdatedAt_Update = {
  __typename?: 'PayloadPreferencesDocAccessFields_updatedAt_Update';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesDocAccessFields_User = {
  __typename?: 'PayloadPreferencesDocAccessFields_user';
  create?: Maybe<PayloadPreferencesDocAccessFields_User_Create>;
  delete?: Maybe<PayloadPreferencesDocAccessFields_User_Delete>;
  read?: Maybe<PayloadPreferencesDocAccessFields_User_Read>;
  update?: Maybe<PayloadPreferencesDocAccessFields_User_Update>;
};

export type PayloadPreferencesDocAccessFields_User_Create = {
  __typename?: 'PayloadPreferencesDocAccessFields_user_Create';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesDocAccessFields_User_Delete = {
  __typename?: 'PayloadPreferencesDocAccessFields_user_Delete';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesDocAccessFields_User_Read = {
  __typename?: 'PayloadPreferencesDocAccessFields_user_Read';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesDocAccessFields_User_Update = {
  __typename?: 'PayloadPreferencesDocAccessFields_user_Update';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesDocAccessFields_Value = {
  __typename?: 'PayloadPreferencesDocAccessFields_value';
  create?: Maybe<PayloadPreferencesDocAccessFields_Value_Create>;
  delete?: Maybe<PayloadPreferencesDocAccessFields_Value_Delete>;
  read?: Maybe<PayloadPreferencesDocAccessFields_Value_Read>;
  update?: Maybe<PayloadPreferencesDocAccessFields_Value_Update>;
};

export type PayloadPreferencesDocAccessFields_Value_Create = {
  __typename?: 'PayloadPreferencesDocAccessFields_value_Create';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesDocAccessFields_Value_Delete = {
  __typename?: 'PayloadPreferencesDocAccessFields_value_Delete';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesDocAccessFields_Value_Read = {
  __typename?: 'PayloadPreferencesDocAccessFields_value_Read';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesDocAccessFields_Value_Update = {
  __typename?: 'PayloadPreferencesDocAccessFields_value_Update';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesFields = {
  __typename?: 'PayloadPreferencesFields';
  createdAt?: Maybe<PayloadPreferencesFields_CreatedAt>;
  key?: Maybe<PayloadPreferencesFields_Key>;
  updatedAt?: Maybe<PayloadPreferencesFields_UpdatedAt>;
  user?: Maybe<PayloadPreferencesFields_User>;
  value?: Maybe<PayloadPreferencesFields_Value>;
};

export type PayloadPreferencesFields_CreatedAt = {
  __typename?: 'PayloadPreferencesFields_createdAt';
  create?: Maybe<PayloadPreferencesFields_CreatedAt_Create>;
  delete?: Maybe<PayloadPreferencesFields_CreatedAt_Delete>;
  read?: Maybe<PayloadPreferencesFields_CreatedAt_Read>;
  update?: Maybe<PayloadPreferencesFields_CreatedAt_Update>;
};

export type PayloadPreferencesFields_CreatedAt_Create = {
  __typename?: 'PayloadPreferencesFields_createdAt_Create';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesFields_CreatedAt_Delete = {
  __typename?: 'PayloadPreferencesFields_createdAt_Delete';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesFields_CreatedAt_Read = {
  __typename?: 'PayloadPreferencesFields_createdAt_Read';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesFields_CreatedAt_Update = {
  __typename?: 'PayloadPreferencesFields_createdAt_Update';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesFields_Key = {
  __typename?: 'PayloadPreferencesFields_key';
  create?: Maybe<PayloadPreferencesFields_Key_Create>;
  delete?: Maybe<PayloadPreferencesFields_Key_Delete>;
  read?: Maybe<PayloadPreferencesFields_Key_Read>;
  update?: Maybe<PayloadPreferencesFields_Key_Update>;
};

export type PayloadPreferencesFields_Key_Create = {
  __typename?: 'PayloadPreferencesFields_key_Create';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesFields_Key_Delete = {
  __typename?: 'PayloadPreferencesFields_key_Delete';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesFields_Key_Read = {
  __typename?: 'PayloadPreferencesFields_key_Read';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesFields_Key_Update = {
  __typename?: 'PayloadPreferencesFields_key_Update';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesFields_UpdatedAt = {
  __typename?: 'PayloadPreferencesFields_updatedAt';
  create?: Maybe<PayloadPreferencesFields_UpdatedAt_Create>;
  delete?: Maybe<PayloadPreferencesFields_UpdatedAt_Delete>;
  read?: Maybe<PayloadPreferencesFields_UpdatedAt_Read>;
  update?: Maybe<PayloadPreferencesFields_UpdatedAt_Update>;
};

export type PayloadPreferencesFields_UpdatedAt_Create = {
  __typename?: 'PayloadPreferencesFields_updatedAt_Create';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesFields_UpdatedAt_Delete = {
  __typename?: 'PayloadPreferencesFields_updatedAt_Delete';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesFields_UpdatedAt_Read = {
  __typename?: 'PayloadPreferencesFields_updatedAt_Read';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesFields_UpdatedAt_Update = {
  __typename?: 'PayloadPreferencesFields_updatedAt_Update';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesFields_User = {
  __typename?: 'PayloadPreferencesFields_user';
  create?: Maybe<PayloadPreferencesFields_User_Create>;
  delete?: Maybe<PayloadPreferencesFields_User_Delete>;
  read?: Maybe<PayloadPreferencesFields_User_Read>;
  update?: Maybe<PayloadPreferencesFields_User_Update>;
};

export type PayloadPreferencesFields_User_Create = {
  __typename?: 'PayloadPreferencesFields_user_Create';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesFields_User_Delete = {
  __typename?: 'PayloadPreferencesFields_user_Delete';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesFields_User_Read = {
  __typename?: 'PayloadPreferencesFields_user_Read';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesFields_User_Update = {
  __typename?: 'PayloadPreferencesFields_user_Update';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesFields_Value = {
  __typename?: 'PayloadPreferencesFields_value';
  create?: Maybe<PayloadPreferencesFields_Value_Create>;
  delete?: Maybe<PayloadPreferencesFields_Value_Delete>;
  read?: Maybe<PayloadPreferencesFields_Value_Read>;
  update?: Maybe<PayloadPreferencesFields_Value_Update>;
};

export type PayloadPreferencesFields_Value_Create = {
  __typename?: 'PayloadPreferencesFields_value_Create';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesFields_Value_Delete = {
  __typename?: 'PayloadPreferencesFields_value_Delete';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesFields_Value_Read = {
  __typename?: 'PayloadPreferencesFields_value_Read';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesFields_Value_Update = {
  __typename?: 'PayloadPreferencesFields_value_Update';
  permission: Scalars['Boolean'];
};

export type PayloadPreferencesReadAccess = {
  __typename?: 'PayloadPreferencesReadAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type PayloadPreferencesReadDocAccess = {
  __typename?: 'PayloadPreferencesReadDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type PayloadPreferencesUpdateAccess = {
  __typename?: 'PayloadPreferencesUpdateAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type PayloadPreferencesUpdateDocAccess = {
  __typename?: 'PayloadPreferencesUpdateDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type Query = {
  __typename?: 'Query';
  Access?: Maybe<Access>;
  Article?: Maybe<Article>;
  Articles?: Maybe<Articles>;
  Categories?: Maybe<Categories>;
  Category?: Maybe<Category>;
  CtaBanner?: Maybe<CtaBanner>;
  EpcCheckFormSubmission?: Maybe<EpcCheckFormSubmission>;
  EpcCheckFormSubmissions?: Maybe<EpcCheckFormSubmissions>;
  FooterMenu?: Maybe<FooterMenu>;
  Form?: Maybe<Form>;
  FormSubmission?: Maybe<FormSubmission>;
  FormSubmissions?: Maybe<FormSubmissions>;
  Forms?: Maybe<Forms>;
  HeaderMenu?: Maybe<HeaderMenu>;
  HiddenBlock?: Maybe<HiddenBlock>;
  LandingPage?: Maybe<LandingPage>;
  LandingPages?: Maybe<LandingPages>;
  LandingTumbler?: Maybe<LandingTumbler>;
  LandingTumblers?: Maybe<LandingTumblers>;
  LeadForm?: Maybe<LeadForm>;
  LeadForms?: Maybe<LeadForms>;
  Media?: Maybe<Media>;
  NewsletterSubscriber?: Maybe<NewsletterSubscriber>;
  NewsletterSubscribers?: Maybe<NewsletterSubscribers>;
  Page?: Maybe<Page>;
  Pages?: Maybe<Pages>;
  PayloadLockedDocument?: Maybe<PayloadLockedDocument>;
  PayloadLockedDocuments?: Maybe<PayloadLockedDocuments>;
  PayloadPreference?: Maybe<PayloadPreference>;
  PayloadPreferences?: Maybe<PayloadPreferences>;
  Service?: Maybe<Service>;
  Services?: Maybe<Services>;
  SocialMedia?: Maybe<SocialMedia>;
  Tag?: Maybe<Tag>;
  Tags?: Maybe<Tags>;
  User?: Maybe<User>;
  Users?: Maybe<Users>;
  allMedia?: Maybe<AllMedia>;
  countArticles?: Maybe<CountArticles>;
  countCategories?: Maybe<CountCategories>;
  countEpcCheckFormSubmissions?: Maybe<CountEpcCheckFormSubmissions>;
  countFormSubmissions?: Maybe<CountFormSubmissions>;
  countForms?: Maybe<CountForms>;
  countLandingPages?: Maybe<CountLandingPages>;
  countLandingTumblers?: Maybe<CountLandingTumblers>;
  countLeadForms?: Maybe<CountLeadForms>;
  countNewsletterSubscribers?: Maybe<CountNewsletterSubscribers>;
  countPages?: Maybe<CountPages>;
  countPayloadLockedDocuments?: Maybe<CountPayloadLockedDocuments>;
  countPayloadPreferences?: Maybe<CountPayloadPreferences>;
  countServices?: Maybe<CountServices>;
  countTags?: Maybe<CountTags>;
  countUsers?: Maybe<CountUsers>;
  countallMedia?: Maybe<CountallMedia>;
  docAccessArticle?: Maybe<ArticleDocAccess>;
  docAccessCategory?: Maybe<CategoryDocAccess>;
  docAccessCtaBanner?: Maybe<Cta_BannerDocAccess>;
  docAccessEpcCheckFormSubmission?: Maybe<Epc_Check_Form_SubmissionDocAccess>;
  docAccessFooterMenu?: Maybe<Footer_MenuDocAccess>;
  docAccessForm?: Maybe<FormsDocAccess>;
  docAccessFormSubmission?: Maybe<Form_SubmissionsDocAccess>;
  docAccessHeaderMenu?: Maybe<Header_MenuDocAccess>;
  docAccessHiddenBlock?: Maybe<Hidden_BlocksDocAccess>;
  docAccessLandingPage?: Maybe<Landing_PageDocAccess>;
  docAccessLandingTumbler?: Maybe<Landing_TumblerDocAccess>;
  docAccessLeadForm?: Maybe<Lead_FormDocAccess>;
  docAccessMedia?: Maybe<MediaDocAccess>;
  docAccessNewsletterSubscriber?: Maybe<Newsletter_SubscriberDocAccess>;
  docAccessPage?: Maybe<PageDocAccess>;
  docAccessPayloadLockedDocument?: Maybe<Payload_Locked_DocumentsDocAccess>;
  docAccessPayloadPreference?: Maybe<Payload_PreferencesDocAccess>;
  docAccessService?: Maybe<ServiceDocAccess>;
  docAccessSocialMedia?: Maybe<Social_MediaDocAccess>;
  docAccessTag?: Maybe<TagDocAccess>;
  docAccessUser?: Maybe<UserDocAccess>;
  initializedUser?: Maybe<Scalars['Boolean']>;
  meUser?: Maybe<UserMe>;
  versionArticle?: Maybe<ArticleVersion>;
  versionLandingPage?: Maybe<LandingPageVersion>;
  versionPage?: Maybe<PageVersion>;
  versionService?: Maybe<ServiceVersion>;
  versionsArticles?: Maybe<VersionsArticles>;
  versionsLandingPages?: Maybe<VersionsLandingPages>;
  versionsPages?: Maybe<VersionsPages>;
  versionsServices?: Maybe<VersionsServices>;
};


export type QueryArticleArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
};


export type QueryArticlesArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  pagination?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<Article_Where>;
};


export type QueryCategoriesArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  pagination?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<Category_Where>;
};


export type QueryCategoryArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
};


export type QueryCtaBannerArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
};


export type QueryEpcCheckFormSubmissionArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
};


export type QueryEpcCheckFormSubmissionsArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  pagination?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<EpcCheckFormSubmission_Where>;
};


export type QueryFooterMenuArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
};


export type QueryFormArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
};


export type QueryFormSubmissionArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
};


export type QueryFormSubmissionsArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  pagination?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<FormSubmission_Where>;
};


export type QueryFormsArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  pagination?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<Form_Where>;
};


export type QueryHeaderMenuArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
};


export type QueryHiddenBlockArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
};


export type QueryLandingPageArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
};


export type QueryLandingPagesArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  pagination?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<LandingPage_Where>;
};


export type QueryLandingTumblerArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
};


export type QueryLandingTumblersArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  pagination?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<LandingTumbler_Where>;
};


export type QueryLeadFormArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
};


export type QueryLeadFormsArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  pagination?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<LeadForm_Where>;
};


export type QueryMediaArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
};


export type QueryNewsletterSubscriberArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
};


export type QueryNewsletterSubscribersArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  pagination?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<NewsletterSubscriber_Where>;
};


export type QueryPageArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
};


export type QueryPagesArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  pagination?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<Page_Where>;
};


export type QueryPayloadLockedDocumentArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
};


export type QueryPayloadLockedDocumentsArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  pagination?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<PayloadLockedDocument_Where>;
};


export type QueryPayloadPreferenceArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
};


export type QueryPayloadPreferencesArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  pagination?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<PayloadPreference_Where>;
};


export type QueryServiceArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
};


export type QueryServicesArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  pagination?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<Service_Where>;
};


export type QuerySocialMediaArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
};


export type QueryTagArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
};


export type QueryTagsArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  pagination?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<Tag_Where>;
};


export type QueryUserArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['String'];
};


export type QueryUsersArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  pagination?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<User_Where>;
};


export type QueryAllMediaArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  pagination?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<Media_Where>;
};


export type QueryCountArticlesArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<Article_Where>;
};


export type QueryCountCategoriesArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<Category_Where>;
};


export type QueryCountEpcCheckFormSubmissionsArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<EpcCheckFormSubmission_Where>;
};


export type QueryCountFormSubmissionsArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<FormSubmission_Where>;
};


export type QueryCountFormsArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<Form_Where>;
};


export type QueryCountLandingPagesArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<LandingPage_Where>;
};


export type QueryCountLandingTumblersArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<LandingTumbler_Where>;
};


export type QueryCountLeadFormsArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<LeadForm_Where>;
};


export type QueryCountNewsletterSubscribersArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<NewsletterSubscriber_Where>;
};


export type QueryCountPagesArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<Page_Where>;
};


export type QueryCountPayloadLockedDocumentsArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<PayloadLockedDocument_Where>;
};


export type QueryCountPayloadPreferencesArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<PayloadPreference_Where>;
};


export type QueryCountServicesArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<Service_Where>;
};


export type QueryCountTagsArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<Tag_Where>;
};


export type QueryCountUsersArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<User_Where>;
};


export type QueryCountallMediaArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
  where?: InputMaybe<Media_Where>;
};


export type QueryDocAccessArticleArgs = {
  id: Scalars['String'];
};


export type QueryDocAccessCategoryArgs = {
  id: Scalars['String'];
};


export type QueryDocAccessEpcCheckFormSubmissionArgs = {
  id: Scalars['String'];
};


export type QueryDocAccessFormArgs = {
  id: Scalars['String'];
};


export type QueryDocAccessFormSubmissionArgs = {
  id: Scalars['String'];
};


export type QueryDocAccessLandingPageArgs = {
  id: Scalars['String'];
};


export type QueryDocAccessLandingTumblerArgs = {
  id: Scalars['String'];
};


export type QueryDocAccessLeadFormArgs = {
  id: Scalars['String'];
};


export type QueryDocAccessMediaArgs = {
  id: Scalars['String'];
};


export type QueryDocAccessNewsletterSubscriberArgs = {
  id: Scalars['String'];
};


export type QueryDocAccessPageArgs = {
  id: Scalars['String'];
};


export type QueryDocAccessPayloadLockedDocumentArgs = {
  id: Scalars['String'];
};


export type QueryDocAccessPayloadPreferenceArgs = {
  id: Scalars['String'];
};


export type QueryDocAccessServiceArgs = {
  id: Scalars['String'];
};


export type QueryDocAccessTagArgs = {
  id: Scalars['String'];
};


export type QueryDocAccessUserArgs = {
  id: Scalars['String'];
};


export type QueryVersionArticleArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryVersionLandingPageArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryVersionPageArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryVersionServiceArgs = {
  id?: InputMaybe<Scalars['String']>;
};


export type QueryVersionsArticlesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  pagination?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<VersionsArticle_Where>;
};


export type QueryVersionsLandingPagesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  pagination?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<VersionsLandingPage_Where>;
};


export type QueryVersionsPagesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  pagination?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<VersionsPage_Where>;
};


export type QueryVersionsServicesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  pagination?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<Scalars['String']>;
  where?: InputMaybe<VersionsService_Where>;
};

export type RatingWidget = {
  __typename?: 'RatingWidget';
  alignment?: Maybe<RatingWidget_Alignment>;
  blockName?: Maybe<Scalars['String']>;
  blockType?: Maybe<Scalars['String']>;
  customIcon?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  rating?: Maybe<Scalars['Float']>;
  showProfileImages?: Maybe<Scalars['Boolean']>;
};

export enum RatingWidget_Alignment {
  Center = 'center',
  Left = 'left',
  Right = 'right'
}

export type Select = {
  __typename?: 'Select';
  blockName?: Maybe<Scalars['String']>;
  blockType?: Maybe<Scalars['String']>;
  defaultValue?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  options?: Maybe<Array<Select_Options>>;
  required?: Maybe<Scalars['Boolean']>;
  width?: Maybe<Scalars['Float']>;
};

export type Select_Options = {
  __typename?: 'Select_Options';
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type Service = {
  __typename?: 'Service';
  _status?: Maybe<Service__Status>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['JSON']>;
  excerpt?: Maybe<Scalars['String']>;
  featuredImage?: Maybe<Media>;
  header?: Maybe<Service_Header>;
  id: Scalars['String'];
  isPlaceholder?: Maybe<Scalars['Boolean']>;
  layout?: Maybe<Service_Layout>;
  meta?: Maybe<Service_Meta>;
  shortTitle?: Maybe<Scalars['String']>;
  showGetAQuoteSideDrawer?: Maybe<Scalars['Boolean']>;
  slug?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  titleSettings?: Maybe<Page_TitleSettings>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type ServiceDescriptionArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};

export type ServiceCreateAccess = {
  __typename?: 'ServiceCreateAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type ServiceCreateDocAccess = {
  __typename?: 'ServiceCreateDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type ServiceDeleteAccess = {
  __typename?: 'ServiceDeleteAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type ServiceDeleteDocAccess = {
  __typename?: 'ServiceDeleteDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type ServiceDocAccessFields = {
  __typename?: 'ServiceDocAccessFields';
  _status?: Maybe<ServiceDocAccessFields__Status>;
  beforeFeaturedFormContent?: Maybe<ServiceDocAccessFields_BeforeFeaturedFormContent>;
  blocks?: Maybe<ServiceDocAccessFields_Blocks>;
  createdAt?: Maybe<ServiceDocAccessFields_CreatedAt>;
  description?: Maybe<ServiceDocAccessFields_Description>;
  excerpt?: Maybe<ServiceDocAccessFields_Excerpt>;
  featuredForm?: Maybe<ServiceDocAccessFields_FeaturedForm>;
  featuredImage?: Maybe<ServiceDocAccessFields_FeaturedImage>;
  image?: Maybe<ServiceDocAccessFields_Image>;
  isPlaceholder?: Maybe<ServiceDocAccessFields_IsPlaceholder>;
  meta?: Maybe<ServiceDocAccessFields_Meta>;
  shortTitle?: Maybe<ServiceDocAccessFields_ShortTitle>;
  showGetAQuoteSideDrawer?: Maybe<ServiceDocAccessFields_ShowGetAQuoteSideDrawer>;
  showLookingForForm?: Maybe<ServiceDocAccessFields_ShowLookingForForm>;
  showRatingWidget?: Maybe<ServiceDocAccessFields_ShowRatingWidget>;
  slug?: Maybe<ServiceDocAccessFields_Slug>;
  title?: Maybe<ServiceDocAccessFields_Title>;
  titleSettings?: Maybe<ServiceDocAccessFields_TitleSettings>;
  type?: Maybe<ServiceDocAccessFields_Type>;
  updatedAt?: Maybe<ServiceDocAccessFields_UpdatedAt>;
};

export type ServiceDocAccessFields__Status = {
  __typename?: 'ServiceDocAccessFields__status';
  create?: Maybe<ServiceDocAccessFields__Status_Create>;
  delete?: Maybe<ServiceDocAccessFields__Status_Delete>;
  read?: Maybe<ServiceDocAccessFields__Status_Read>;
  update?: Maybe<ServiceDocAccessFields__Status_Update>;
};

export type ServiceDocAccessFields__Status_Create = {
  __typename?: 'ServiceDocAccessFields__status_Create';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields__Status_Delete = {
  __typename?: 'ServiceDocAccessFields__status_Delete';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields__Status_Read = {
  __typename?: 'ServiceDocAccessFields__status_Read';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields__Status_Update = {
  __typename?: 'ServiceDocAccessFields__status_Update';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_BeforeFeaturedFormContent = {
  __typename?: 'ServiceDocAccessFields_beforeFeaturedFormContent';
  create?: Maybe<ServiceDocAccessFields_BeforeFeaturedFormContent_Create>;
  delete?: Maybe<ServiceDocAccessFields_BeforeFeaturedFormContent_Delete>;
  read?: Maybe<ServiceDocAccessFields_BeforeFeaturedFormContent_Read>;
  update?: Maybe<ServiceDocAccessFields_BeforeFeaturedFormContent_Update>;
};

export type ServiceDocAccessFields_BeforeFeaturedFormContent_Create = {
  __typename?: 'ServiceDocAccessFields_beforeFeaturedFormContent_Create';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_BeforeFeaturedFormContent_Delete = {
  __typename?: 'ServiceDocAccessFields_beforeFeaturedFormContent_Delete';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_BeforeFeaturedFormContent_Read = {
  __typename?: 'ServiceDocAccessFields_beforeFeaturedFormContent_Read';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_BeforeFeaturedFormContent_Update = {
  __typename?: 'ServiceDocAccessFields_beforeFeaturedFormContent_Update';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_Blocks = {
  __typename?: 'ServiceDocAccessFields_blocks';
  create?: Maybe<ServiceDocAccessFields_Blocks_Create>;
  delete?: Maybe<ServiceDocAccessFields_Blocks_Delete>;
  read?: Maybe<ServiceDocAccessFields_Blocks_Read>;
  update?: Maybe<ServiceDocAccessFields_Blocks_Update>;
};

export type ServiceDocAccessFields_Blocks_Create = {
  __typename?: 'ServiceDocAccessFields_blocks_Create';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_Blocks_Delete = {
  __typename?: 'ServiceDocAccessFields_blocks_Delete';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_Blocks_Read = {
  __typename?: 'ServiceDocAccessFields_blocks_Read';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_Blocks_Update = {
  __typename?: 'ServiceDocAccessFields_blocks_Update';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_CreatedAt = {
  __typename?: 'ServiceDocAccessFields_createdAt';
  create?: Maybe<ServiceDocAccessFields_CreatedAt_Create>;
  delete?: Maybe<ServiceDocAccessFields_CreatedAt_Delete>;
  read?: Maybe<ServiceDocAccessFields_CreatedAt_Read>;
  update?: Maybe<ServiceDocAccessFields_CreatedAt_Update>;
};

export type ServiceDocAccessFields_CreatedAt_Create = {
  __typename?: 'ServiceDocAccessFields_createdAt_Create';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_CreatedAt_Delete = {
  __typename?: 'ServiceDocAccessFields_createdAt_Delete';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_CreatedAt_Read = {
  __typename?: 'ServiceDocAccessFields_createdAt_Read';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_CreatedAt_Update = {
  __typename?: 'ServiceDocAccessFields_createdAt_Update';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_Description = {
  __typename?: 'ServiceDocAccessFields_description';
  create?: Maybe<ServiceDocAccessFields_Description_Create>;
  delete?: Maybe<ServiceDocAccessFields_Description_Delete>;
  read?: Maybe<ServiceDocAccessFields_Description_Read>;
  update?: Maybe<ServiceDocAccessFields_Description_Update>;
};

export type ServiceDocAccessFields_Description_Create = {
  __typename?: 'ServiceDocAccessFields_description_Create';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_Description_Delete = {
  __typename?: 'ServiceDocAccessFields_description_Delete';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_Description_Read = {
  __typename?: 'ServiceDocAccessFields_description_Read';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_Description_Update = {
  __typename?: 'ServiceDocAccessFields_description_Update';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_Excerpt = {
  __typename?: 'ServiceDocAccessFields_excerpt';
  create?: Maybe<ServiceDocAccessFields_Excerpt_Create>;
  delete?: Maybe<ServiceDocAccessFields_Excerpt_Delete>;
  read?: Maybe<ServiceDocAccessFields_Excerpt_Read>;
  update?: Maybe<ServiceDocAccessFields_Excerpt_Update>;
};

export type ServiceDocAccessFields_Excerpt_Create = {
  __typename?: 'ServiceDocAccessFields_excerpt_Create';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_Excerpt_Delete = {
  __typename?: 'ServiceDocAccessFields_excerpt_Delete';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_Excerpt_Read = {
  __typename?: 'ServiceDocAccessFields_excerpt_Read';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_Excerpt_Update = {
  __typename?: 'ServiceDocAccessFields_excerpt_Update';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_FeaturedForm = {
  __typename?: 'ServiceDocAccessFields_featuredForm';
  create?: Maybe<ServiceDocAccessFields_FeaturedForm_Create>;
  delete?: Maybe<ServiceDocAccessFields_FeaturedForm_Delete>;
  read?: Maybe<ServiceDocAccessFields_FeaturedForm_Read>;
  update?: Maybe<ServiceDocAccessFields_FeaturedForm_Update>;
};

export type ServiceDocAccessFields_FeaturedForm_Create = {
  __typename?: 'ServiceDocAccessFields_featuredForm_Create';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_FeaturedForm_Delete = {
  __typename?: 'ServiceDocAccessFields_featuredForm_Delete';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_FeaturedForm_Read = {
  __typename?: 'ServiceDocAccessFields_featuredForm_Read';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_FeaturedForm_Update = {
  __typename?: 'ServiceDocAccessFields_featuredForm_Update';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_FeaturedImage = {
  __typename?: 'ServiceDocAccessFields_featuredImage';
  create?: Maybe<ServiceDocAccessFields_FeaturedImage_Create>;
  delete?: Maybe<ServiceDocAccessFields_FeaturedImage_Delete>;
  read?: Maybe<ServiceDocAccessFields_FeaturedImage_Read>;
  update?: Maybe<ServiceDocAccessFields_FeaturedImage_Update>;
};

export type ServiceDocAccessFields_FeaturedImage_Create = {
  __typename?: 'ServiceDocAccessFields_featuredImage_Create';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_FeaturedImage_Delete = {
  __typename?: 'ServiceDocAccessFields_featuredImage_Delete';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_FeaturedImage_Read = {
  __typename?: 'ServiceDocAccessFields_featuredImage_Read';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_FeaturedImage_Update = {
  __typename?: 'ServiceDocAccessFields_featuredImage_Update';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_Image = {
  __typename?: 'ServiceDocAccessFields_image';
  create?: Maybe<ServiceDocAccessFields_Image_Create>;
  delete?: Maybe<ServiceDocAccessFields_Image_Delete>;
  read?: Maybe<ServiceDocAccessFields_Image_Read>;
  update?: Maybe<ServiceDocAccessFields_Image_Update>;
};

export type ServiceDocAccessFields_Image_Create = {
  __typename?: 'ServiceDocAccessFields_image_Create';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_Image_Delete = {
  __typename?: 'ServiceDocAccessFields_image_Delete';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_Image_Read = {
  __typename?: 'ServiceDocAccessFields_image_Read';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_Image_Update = {
  __typename?: 'ServiceDocAccessFields_image_Update';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_IsPlaceholder = {
  __typename?: 'ServiceDocAccessFields_isPlaceholder';
  create?: Maybe<ServiceDocAccessFields_IsPlaceholder_Create>;
  delete?: Maybe<ServiceDocAccessFields_IsPlaceholder_Delete>;
  read?: Maybe<ServiceDocAccessFields_IsPlaceholder_Read>;
  update?: Maybe<ServiceDocAccessFields_IsPlaceholder_Update>;
};

export type ServiceDocAccessFields_IsPlaceholder_Create = {
  __typename?: 'ServiceDocAccessFields_isPlaceholder_Create';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_IsPlaceholder_Delete = {
  __typename?: 'ServiceDocAccessFields_isPlaceholder_Delete';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_IsPlaceholder_Read = {
  __typename?: 'ServiceDocAccessFields_isPlaceholder_Read';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_IsPlaceholder_Update = {
  __typename?: 'ServiceDocAccessFields_isPlaceholder_Update';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_Meta = {
  __typename?: 'ServiceDocAccessFields_meta';
  create?: Maybe<ServiceDocAccessFields_Meta_Create>;
  delete?: Maybe<ServiceDocAccessFields_Meta_Delete>;
  fields?: Maybe<ServiceDocAccessFields_Meta_Fields>;
  read?: Maybe<ServiceDocAccessFields_Meta_Read>;
  update?: Maybe<ServiceDocAccessFields_Meta_Update>;
};

export type ServiceDocAccessFields_Meta_Create = {
  __typename?: 'ServiceDocAccessFields_meta_Create';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_Meta_Delete = {
  __typename?: 'ServiceDocAccessFields_meta_Delete';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_Meta_Fields = {
  __typename?: 'ServiceDocAccessFields_meta_Fields';
  description?: Maybe<ServiceDocAccessFields_Meta_Description>;
  image?: Maybe<ServiceDocAccessFields_Meta_Image>;
  noIndex?: Maybe<ServiceDocAccessFields_Meta_NoIndex>;
  title?: Maybe<ServiceDocAccessFields_Meta_Title>;
};

export type ServiceDocAccessFields_Meta_Read = {
  __typename?: 'ServiceDocAccessFields_meta_Read';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_Meta_Update = {
  __typename?: 'ServiceDocAccessFields_meta_Update';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_Meta_Description = {
  __typename?: 'ServiceDocAccessFields_meta_description';
  create?: Maybe<ServiceDocAccessFields_Meta_Description_Create>;
  delete?: Maybe<ServiceDocAccessFields_Meta_Description_Delete>;
  read?: Maybe<ServiceDocAccessFields_Meta_Description_Read>;
  update?: Maybe<ServiceDocAccessFields_Meta_Description_Update>;
};

export type ServiceDocAccessFields_Meta_Description_Create = {
  __typename?: 'ServiceDocAccessFields_meta_description_Create';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_Meta_Description_Delete = {
  __typename?: 'ServiceDocAccessFields_meta_description_Delete';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_Meta_Description_Read = {
  __typename?: 'ServiceDocAccessFields_meta_description_Read';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_Meta_Description_Update = {
  __typename?: 'ServiceDocAccessFields_meta_description_Update';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_Meta_Image = {
  __typename?: 'ServiceDocAccessFields_meta_image';
  create?: Maybe<ServiceDocAccessFields_Meta_Image_Create>;
  delete?: Maybe<ServiceDocAccessFields_Meta_Image_Delete>;
  read?: Maybe<ServiceDocAccessFields_Meta_Image_Read>;
  update?: Maybe<ServiceDocAccessFields_Meta_Image_Update>;
};

export type ServiceDocAccessFields_Meta_Image_Create = {
  __typename?: 'ServiceDocAccessFields_meta_image_Create';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_Meta_Image_Delete = {
  __typename?: 'ServiceDocAccessFields_meta_image_Delete';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_Meta_Image_Read = {
  __typename?: 'ServiceDocAccessFields_meta_image_Read';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_Meta_Image_Update = {
  __typename?: 'ServiceDocAccessFields_meta_image_Update';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_Meta_NoIndex = {
  __typename?: 'ServiceDocAccessFields_meta_noIndex';
  create?: Maybe<ServiceDocAccessFields_Meta_NoIndex_Create>;
  delete?: Maybe<ServiceDocAccessFields_Meta_NoIndex_Delete>;
  read?: Maybe<ServiceDocAccessFields_Meta_NoIndex_Read>;
  update?: Maybe<ServiceDocAccessFields_Meta_NoIndex_Update>;
};

export type ServiceDocAccessFields_Meta_NoIndex_Create = {
  __typename?: 'ServiceDocAccessFields_meta_noIndex_Create';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_Meta_NoIndex_Delete = {
  __typename?: 'ServiceDocAccessFields_meta_noIndex_Delete';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_Meta_NoIndex_Read = {
  __typename?: 'ServiceDocAccessFields_meta_noIndex_Read';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_Meta_NoIndex_Update = {
  __typename?: 'ServiceDocAccessFields_meta_noIndex_Update';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_Meta_Title = {
  __typename?: 'ServiceDocAccessFields_meta_title';
  create?: Maybe<ServiceDocAccessFields_Meta_Title_Create>;
  delete?: Maybe<ServiceDocAccessFields_Meta_Title_Delete>;
  read?: Maybe<ServiceDocAccessFields_Meta_Title_Read>;
  update?: Maybe<ServiceDocAccessFields_Meta_Title_Update>;
};

export type ServiceDocAccessFields_Meta_Title_Create = {
  __typename?: 'ServiceDocAccessFields_meta_title_Create';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_Meta_Title_Delete = {
  __typename?: 'ServiceDocAccessFields_meta_title_Delete';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_Meta_Title_Read = {
  __typename?: 'ServiceDocAccessFields_meta_title_Read';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_Meta_Title_Update = {
  __typename?: 'ServiceDocAccessFields_meta_title_Update';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_ShortTitle = {
  __typename?: 'ServiceDocAccessFields_shortTitle';
  create?: Maybe<ServiceDocAccessFields_ShortTitle_Create>;
  delete?: Maybe<ServiceDocAccessFields_ShortTitle_Delete>;
  read?: Maybe<ServiceDocAccessFields_ShortTitle_Read>;
  update?: Maybe<ServiceDocAccessFields_ShortTitle_Update>;
};

export type ServiceDocAccessFields_ShortTitle_Create = {
  __typename?: 'ServiceDocAccessFields_shortTitle_Create';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_ShortTitle_Delete = {
  __typename?: 'ServiceDocAccessFields_shortTitle_Delete';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_ShortTitle_Read = {
  __typename?: 'ServiceDocAccessFields_shortTitle_Read';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_ShortTitle_Update = {
  __typename?: 'ServiceDocAccessFields_shortTitle_Update';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_ShowGetAQuoteSideDrawer = {
  __typename?: 'ServiceDocAccessFields_showGetAQuoteSideDrawer';
  create?: Maybe<ServiceDocAccessFields_ShowGetAQuoteSideDrawer_Create>;
  delete?: Maybe<ServiceDocAccessFields_ShowGetAQuoteSideDrawer_Delete>;
  read?: Maybe<ServiceDocAccessFields_ShowGetAQuoteSideDrawer_Read>;
  update?: Maybe<ServiceDocAccessFields_ShowGetAQuoteSideDrawer_Update>;
};

export type ServiceDocAccessFields_ShowGetAQuoteSideDrawer_Create = {
  __typename?: 'ServiceDocAccessFields_showGetAQuoteSideDrawer_Create';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_ShowGetAQuoteSideDrawer_Delete = {
  __typename?: 'ServiceDocAccessFields_showGetAQuoteSideDrawer_Delete';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_ShowGetAQuoteSideDrawer_Read = {
  __typename?: 'ServiceDocAccessFields_showGetAQuoteSideDrawer_Read';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_ShowGetAQuoteSideDrawer_Update = {
  __typename?: 'ServiceDocAccessFields_showGetAQuoteSideDrawer_Update';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_ShowLookingForForm = {
  __typename?: 'ServiceDocAccessFields_showLookingForForm';
  create?: Maybe<ServiceDocAccessFields_ShowLookingForForm_Create>;
  delete?: Maybe<ServiceDocAccessFields_ShowLookingForForm_Delete>;
  read?: Maybe<ServiceDocAccessFields_ShowLookingForForm_Read>;
  update?: Maybe<ServiceDocAccessFields_ShowLookingForForm_Update>;
};

export type ServiceDocAccessFields_ShowLookingForForm_Create = {
  __typename?: 'ServiceDocAccessFields_showLookingForForm_Create';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_ShowLookingForForm_Delete = {
  __typename?: 'ServiceDocAccessFields_showLookingForForm_Delete';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_ShowLookingForForm_Read = {
  __typename?: 'ServiceDocAccessFields_showLookingForForm_Read';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_ShowLookingForForm_Update = {
  __typename?: 'ServiceDocAccessFields_showLookingForForm_Update';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_ShowRatingWidget = {
  __typename?: 'ServiceDocAccessFields_showRatingWidget';
  create?: Maybe<ServiceDocAccessFields_ShowRatingWidget_Create>;
  delete?: Maybe<ServiceDocAccessFields_ShowRatingWidget_Delete>;
  read?: Maybe<ServiceDocAccessFields_ShowRatingWidget_Read>;
  update?: Maybe<ServiceDocAccessFields_ShowRatingWidget_Update>;
};

export type ServiceDocAccessFields_ShowRatingWidget_Create = {
  __typename?: 'ServiceDocAccessFields_showRatingWidget_Create';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_ShowRatingWidget_Delete = {
  __typename?: 'ServiceDocAccessFields_showRatingWidget_Delete';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_ShowRatingWidget_Read = {
  __typename?: 'ServiceDocAccessFields_showRatingWidget_Read';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_ShowRatingWidget_Update = {
  __typename?: 'ServiceDocAccessFields_showRatingWidget_Update';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_Slug = {
  __typename?: 'ServiceDocAccessFields_slug';
  create?: Maybe<ServiceDocAccessFields_Slug_Create>;
  delete?: Maybe<ServiceDocAccessFields_Slug_Delete>;
  read?: Maybe<ServiceDocAccessFields_Slug_Read>;
  update?: Maybe<ServiceDocAccessFields_Slug_Update>;
};

export type ServiceDocAccessFields_Slug_Create = {
  __typename?: 'ServiceDocAccessFields_slug_Create';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_Slug_Delete = {
  __typename?: 'ServiceDocAccessFields_slug_Delete';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_Slug_Read = {
  __typename?: 'ServiceDocAccessFields_slug_Read';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_Slug_Update = {
  __typename?: 'ServiceDocAccessFields_slug_Update';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_Title = {
  __typename?: 'ServiceDocAccessFields_title';
  create?: Maybe<ServiceDocAccessFields_Title_Create>;
  delete?: Maybe<ServiceDocAccessFields_Title_Delete>;
  read?: Maybe<ServiceDocAccessFields_Title_Read>;
  update?: Maybe<ServiceDocAccessFields_Title_Update>;
};

export type ServiceDocAccessFields_TitleSettings = {
  __typename?: 'ServiceDocAccessFields_titleSettings';
  create?: Maybe<ServiceDocAccessFields_TitleSettings_Create>;
  delete?: Maybe<ServiceDocAccessFields_TitleSettings_Delete>;
  fields?: Maybe<ServiceDocAccessFields_TitleSettings_Fields>;
  read?: Maybe<ServiceDocAccessFields_TitleSettings_Read>;
  update?: Maybe<ServiceDocAccessFields_TitleSettings_Update>;
};

export type ServiceDocAccessFields_TitleSettings_Create = {
  __typename?: 'ServiceDocAccessFields_titleSettings_Create';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_TitleSettings_Delete = {
  __typename?: 'ServiceDocAccessFields_titleSettings_Delete';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_TitleSettings_Fields = {
  __typename?: 'ServiceDocAccessFields_titleSettings_Fields';
  boldEndIndex?: Maybe<ServiceDocAccessFields_TitleSettings_BoldEndIndex>;
  boldStartIndex?: Maybe<ServiceDocAccessFields_TitleSettings_BoldStartIndex>;
};

export type ServiceDocAccessFields_TitleSettings_Read = {
  __typename?: 'ServiceDocAccessFields_titleSettings_Read';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_TitleSettings_Update = {
  __typename?: 'ServiceDocAccessFields_titleSettings_Update';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_TitleSettings_BoldEndIndex = {
  __typename?: 'ServiceDocAccessFields_titleSettings_boldEndIndex';
  create?: Maybe<ServiceDocAccessFields_TitleSettings_BoldEndIndex_Create>;
  delete?: Maybe<ServiceDocAccessFields_TitleSettings_BoldEndIndex_Delete>;
  read?: Maybe<ServiceDocAccessFields_TitleSettings_BoldEndIndex_Read>;
  update?: Maybe<ServiceDocAccessFields_TitleSettings_BoldEndIndex_Update>;
};

export type ServiceDocAccessFields_TitleSettings_BoldEndIndex_Create = {
  __typename?: 'ServiceDocAccessFields_titleSettings_boldEndIndex_Create';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_TitleSettings_BoldEndIndex_Delete = {
  __typename?: 'ServiceDocAccessFields_titleSettings_boldEndIndex_Delete';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_TitleSettings_BoldEndIndex_Read = {
  __typename?: 'ServiceDocAccessFields_titleSettings_boldEndIndex_Read';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_TitleSettings_BoldEndIndex_Update = {
  __typename?: 'ServiceDocAccessFields_titleSettings_boldEndIndex_Update';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_TitleSettings_BoldStartIndex = {
  __typename?: 'ServiceDocAccessFields_titleSettings_boldStartIndex';
  create?: Maybe<ServiceDocAccessFields_TitleSettings_BoldStartIndex_Create>;
  delete?: Maybe<ServiceDocAccessFields_TitleSettings_BoldStartIndex_Delete>;
  read?: Maybe<ServiceDocAccessFields_TitleSettings_BoldStartIndex_Read>;
  update?: Maybe<ServiceDocAccessFields_TitleSettings_BoldStartIndex_Update>;
};

export type ServiceDocAccessFields_TitleSettings_BoldStartIndex_Create = {
  __typename?: 'ServiceDocAccessFields_titleSettings_boldStartIndex_Create';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_TitleSettings_BoldStartIndex_Delete = {
  __typename?: 'ServiceDocAccessFields_titleSettings_boldStartIndex_Delete';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_TitleSettings_BoldStartIndex_Read = {
  __typename?: 'ServiceDocAccessFields_titleSettings_boldStartIndex_Read';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_TitleSettings_BoldStartIndex_Update = {
  __typename?: 'ServiceDocAccessFields_titleSettings_boldStartIndex_Update';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_Title_Create = {
  __typename?: 'ServiceDocAccessFields_title_Create';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_Title_Delete = {
  __typename?: 'ServiceDocAccessFields_title_Delete';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_Title_Read = {
  __typename?: 'ServiceDocAccessFields_title_Read';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_Title_Update = {
  __typename?: 'ServiceDocAccessFields_title_Update';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_Type = {
  __typename?: 'ServiceDocAccessFields_type';
  create?: Maybe<ServiceDocAccessFields_Type_Create>;
  delete?: Maybe<ServiceDocAccessFields_Type_Delete>;
  read?: Maybe<ServiceDocAccessFields_Type_Read>;
  update?: Maybe<ServiceDocAccessFields_Type_Update>;
};

export type ServiceDocAccessFields_Type_Create = {
  __typename?: 'ServiceDocAccessFields_type_Create';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_Type_Delete = {
  __typename?: 'ServiceDocAccessFields_type_Delete';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_Type_Read = {
  __typename?: 'ServiceDocAccessFields_type_Read';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_Type_Update = {
  __typename?: 'ServiceDocAccessFields_type_Update';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_UpdatedAt = {
  __typename?: 'ServiceDocAccessFields_updatedAt';
  create?: Maybe<ServiceDocAccessFields_UpdatedAt_Create>;
  delete?: Maybe<ServiceDocAccessFields_UpdatedAt_Delete>;
  read?: Maybe<ServiceDocAccessFields_UpdatedAt_Read>;
  update?: Maybe<ServiceDocAccessFields_UpdatedAt_Update>;
};

export type ServiceDocAccessFields_UpdatedAt_Create = {
  __typename?: 'ServiceDocAccessFields_updatedAt_Create';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_UpdatedAt_Delete = {
  __typename?: 'ServiceDocAccessFields_updatedAt_Delete';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_UpdatedAt_Read = {
  __typename?: 'ServiceDocAccessFields_updatedAt_Read';
  permission: Scalars['Boolean'];
};

export type ServiceDocAccessFields_UpdatedAt_Update = {
  __typename?: 'ServiceDocAccessFields_updatedAt_Update';
  permission: Scalars['Boolean'];
};

export type ServiceFields = {
  __typename?: 'ServiceFields';
  _status?: Maybe<ServiceFields__Status>;
  beforeFeaturedFormContent?: Maybe<ServiceFields_BeforeFeaturedFormContent>;
  blocks?: Maybe<ServiceFields_Blocks>;
  createdAt?: Maybe<ServiceFields_CreatedAt>;
  description?: Maybe<ServiceFields_Description>;
  excerpt?: Maybe<ServiceFields_Excerpt>;
  featuredForm?: Maybe<ServiceFields_FeaturedForm>;
  featuredImage?: Maybe<ServiceFields_FeaturedImage>;
  image?: Maybe<ServiceFields_Image>;
  isPlaceholder?: Maybe<ServiceFields_IsPlaceholder>;
  meta?: Maybe<ServiceFields_Meta>;
  shortTitle?: Maybe<ServiceFields_ShortTitle>;
  showGetAQuoteSideDrawer?: Maybe<ServiceFields_ShowGetAQuoteSideDrawer>;
  showLookingForForm?: Maybe<ServiceFields_ShowLookingForForm>;
  showRatingWidget?: Maybe<ServiceFields_ShowRatingWidget>;
  slug?: Maybe<ServiceFields_Slug>;
  title?: Maybe<ServiceFields_Title>;
  titleSettings?: Maybe<ServiceFields_TitleSettings>;
  type?: Maybe<ServiceFields_Type>;
  updatedAt?: Maybe<ServiceFields_UpdatedAt>;
};

export type ServiceFields__Status = {
  __typename?: 'ServiceFields__status';
  create?: Maybe<ServiceFields__Status_Create>;
  delete?: Maybe<ServiceFields__Status_Delete>;
  read?: Maybe<ServiceFields__Status_Read>;
  update?: Maybe<ServiceFields__Status_Update>;
};

export type ServiceFields__Status_Create = {
  __typename?: 'ServiceFields__status_Create';
  permission: Scalars['Boolean'];
};

export type ServiceFields__Status_Delete = {
  __typename?: 'ServiceFields__status_Delete';
  permission: Scalars['Boolean'];
};

export type ServiceFields__Status_Read = {
  __typename?: 'ServiceFields__status_Read';
  permission: Scalars['Boolean'];
};

export type ServiceFields__Status_Update = {
  __typename?: 'ServiceFields__status_Update';
  permission: Scalars['Boolean'];
};

export type ServiceFields_BeforeFeaturedFormContent = {
  __typename?: 'ServiceFields_beforeFeaturedFormContent';
  create?: Maybe<ServiceFields_BeforeFeaturedFormContent_Create>;
  delete?: Maybe<ServiceFields_BeforeFeaturedFormContent_Delete>;
  read?: Maybe<ServiceFields_BeforeFeaturedFormContent_Read>;
  update?: Maybe<ServiceFields_BeforeFeaturedFormContent_Update>;
};

export type ServiceFields_BeforeFeaturedFormContent_Create = {
  __typename?: 'ServiceFields_beforeFeaturedFormContent_Create';
  permission: Scalars['Boolean'];
};

export type ServiceFields_BeforeFeaturedFormContent_Delete = {
  __typename?: 'ServiceFields_beforeFeaturedFormContent_Delete';
  permission: Scalars['Boolean'];
};

export type ServiceFields_BeforeFeaturedFormContent_Read = {
  __typename?: 'ServiceFields_beforeFeaturedFormContent_Read';
  permission: Scalars['Boolean'];
};

export type ServiceFields_BeforeFeaturedFormContent_Update = {
  __typename?: 'ServiceFields_beforeFeaturedFormContent_Update';
  permission: Scalars['Boolean'];
};

export type ServiceFields_Blocks = {
  __typename?: 'ServiceFields_blocks';
  create?: Maybe<ServiceFields_Blocks_Create>;
  delete?: Maybe<ServiceFields_Blocks_Delete>;
  read?: Maybe<ServiceFields_Blocks_Read>;
  update?: Maybe<ServiceFields_Blocks_Update>;
};

export type ServiceFields_Blocks_Create = {
  __typename?: 'ServiceFields_blocks_Create';
  permission: Scalars['Boolean'];
};

export type ServiceFields_Blocks_Delete = {
  __typename?: 'ServiceFields_blocks_Delete';
  permission: Scalars['Boolean'];
};

export type ServiceFields_Blocks_Read = {
  __typename?: 'ServiceFields_blocks_Read';
  permission: Scalars['Boolean'];
};

export type ServiceFields_Blocks_Update = {
  __typename?: 'ServiceFields_blocks_Update';
  permission: Scalars['Boolean'];
};

export type ServiceFields_CreatedAt = {
  __typename?: 'ServiceFields_createdAt';
  create?: Maybe<ServiceFields_CreatedAt_Create>;
  delete?: Maybe<ServiceFields_CreatedAt_Delete>;
  read?: Maybe<ServiceFields_CreatedAt_Read>;
  update?: Maybe<ServiceFields_CreatedAt_Update>;
};

export type ServiceFields_CreatedAt_Create = {
  __typename?: 'ServiceFields_createdAt_Create';
  permission: Scalars['Boolean'];
};

export type ServiceFields_CreatedAt_Delete = {
  __typename?: 'ServiceFields_createdAt_Delete';
  permission: Scalars['Boolean'];
};

export type ServiceFields_CreatedAt_Read = {
  __typename?: 'ServiceFields_createdAt_Read';
  permission: Scalars['Boolean'];
};

export type ServiceFields_CreatedAt_Update = {
  __typename?: 'ServiceFields_createdAt_Update';
  permission: Scalars['Boolean'];
};

export type ServiceFields_Description = {
  __typename?: 'ServiceFields_description';
  create?: Maybe<ServiceFields_Description_Create>;
  delete?: Maybe<ServiceFields_Description_Delete>;
  read?: Maybe<ServiceFields_Description_Read>;
  update?: Maybe<ServiceFields_Description_Update>;
};

export type ServiceFields_Description_Create = {
  __typename?: 'ServiceFields_description_Create';
  permission: Scalars['Boolean'];
};

export type ServiceFields_Description_Delete = {
  __typename?: 'ServiceFields_description_Delete';
  permission: Scalars['Boolean'];
};

export type ServiceFields_Description_Read = {
  __typename?: 'ServiceFields_description_Read';
  permission: Scalars['Boolean'];
};

export type ServiceFields_Description_Update = {
  __typename?: 'ServiceFields_description_Update';
  permission: Scalars['Boolean'];
};

export type ServiceFields_Excerpt = {
  __typename?: 'ServiceFields_excerpt';
  create?: Maybe<ServiceFields_Excerpt_Create>;
  delete?: Maybe<ServiceFields_Excerpt_Delete>;
  read?: Maybe<ServiceFields_Excerpt_Read>;
  update?: Maybe<ServiceFields_Excerpt_Update>;
};

export type ServiceFields_Excerpt_Create = {
  __typename?: 'ServiceFields_excerpt_Create';
  permission: Scalars['Boolean'];
};

export type ServiceFields_Excerpt_Delete = {
  __typename?: 'ServiceFields_excerpt_Delete';
  permission: Scalars['Boolean'];
};

export type ServiceFields_Excerpt_Read = {
  __typename?: 'ServiceFields_excerpt_Read';
  permission: Scalars['Boolean'];
};

export type ServiceFields_Excerpt_Update = {
  __typename?: 'ServiceFields_excerpt_Update';
  permission: Scalars['Boolean'];
};

export type ServiceFields_FeaturedForm = {
  __typename?: 'ServiceFields_featuredForm';
  create?: Maybe<ServiceFields_FeaturedForm_Create>;
  delete?: Maybe<ServiceFields_FeaturedForm_Delete>;
  read?: Maybe<ServiceFields_FeaturedForm_Read>;
  update?: Maybe<ServiceFields_FeaturedForm_Update>;
};

export type ServiceFields_FeaturedForm_Create = {
  __typename?: 'ServiceFields_featuredForm_Create';
  permission: Scalars['Boolean'];
};

export type ServiceFields_FeaturedForm_Delete = {
  __typename?: 'ServiceFields_featuredForm_Delete';
  permission: Scalars['Boolean'];
};

export type ServiceFields_FeaturedForm_Read = {
  __typename?: 'ServiceFields_featuredForm_Read';
  permission: Scalars['Boolean'];
};

export type ServiceFields_FeaturedForm_Update = {
  __typename?: 'ServiceFields_featuredForm_Update';
  permission: Scalars['Boolean'];
};

export type ServiceFields_FeaturedImage = {
  __typename?: 'ServiceFields_featuredImage';
  create?: Maybe<ServiceFields_FeaturedImage_Create>;
  delete?: Maybe<ServiceFields_FeaturedImage_Delete>;
  read?: Maybe<ServiceFields_FeaturedImage_Read>;
  update?: Maybe<ServiceFields_FeaturedImage_Update>;
};

export type ServiceFields_FeaturedImage_Create = {
  __typename?: 'ServiceFields_featuredImage_Create';
  permission: Scalars['Boolean'];
};

export type ServiceFields_FeaturedImage_Delete = {
  __typename?: 'ServiceFields_featuredImage_Delete';
  permission: Scalars['Boolean'];
};

export type ServiceFields_FeaturedImage_Read = {
  __typename?: 'ServiceFields_featuredImage_Read';
  permission: Scalars['Boolean'];
};

export type ServiceFields_FeaturedImage_Update = {
  __typename?: 'ServiceFields_featuredImage_Update';
  permission: Scalars['Boolean'];
};

export type ServiceFields_Image = {
  __typename?: 'ServiceFields_image';
  create?: Maybe<ServiceFields_Image_Create>;
  delete?: Maybe<ServiceFields_Image_Delete>;
  read?: Maybe<ServiceFields_Image_Read>;
  update?: Maybe<ServiceFields_Image_Update>;
};

export type ServiceFields_Image_Create = {
  __typename?: 'ServiceFields_image_Create';
  permission: Scalars['Boolean'];
};

export type ServiceFields_Image_Delete = {
  __typename?: 'ServiceFields_image_Delete';
  permission: Scalars['Boolean'];
};

export type ServiceFields_Image_Read = {
  __typename?: 'ServiceFields_image_Read';
  permission: Scalars['Boolean'];
};

export type ServiceFields_Image_Update = {
  __typename?: 'ServiceFields_image_Update';
  permission: Scalars['Boolean'];
};

export type ServiceFields_IsPlaceholder = {
  __typename?: 'ServiceFields_isPlaceholder';
  create?: Maybe<ServiceFields_IsPlaceholder_Create>;
  delete?: Maybe<ServiceFields_IsPlaceholder_Delete>;
  read?: Maybe<ServiceFields_IsPlaceholder_Read>;
  update?: Maybe<ServiceFields_IsPlaceholder_Update>;
};

export type ServiceFields_IsPlaceholder_Create = {
  __typename?: 'ServiceFields_isPlaceholder_Create';
  permission: Scalars['Boolean'];
};

export type ServiceFields_IsPlaceholder_Delete = {
  __typename?: 'ServiceFields_isPlaceholder_Delete';
  permission: Scalars['Boolean'];
};

export type ServiceFields_IsPlaceholder_Read = {
  __typename?: 'ServiceFields_isPlaceholder_Read';
  permission: Scalars['Boolean'];
};

export type ServiceFields_IsPlaceholder_Update = {
  __typename?: 'ServiceFields_isPlaceholder_Update';
  permission: Scalars['Boolean'];
};

export type ServiceFields_Meta = {
  __typename?: 'ServiceFields_meta';
  create?: Maybe<ServiceFields_Meta_Create>;
  delete?: Maybe<ServiceFields_Meta_Delete>;
  fields?: Maybe<ServiceFields_Meta_Fields>;
  read?: Maybe<ServiceFields_Meta_Read>;
  update?: Maybe<ServiceFields_Meta_Update>;
};

export type ServiceFields_Meta_Create = {
  __typename?: 'ServiceFields_meta_Create';
  permission: Scalars['Boolean'];
};

export type ServiceFields_Meta_Delete = {
  __typename?: 'ServiceFields_meta_Delete';
  permission: Scalars['Boolean'];
};

export type ServiceFields_Meta_Fields = {
  __typename?: 'ServiceFields_meta_Fields';
  description?: Maybe<ServiceFields_Meta_Description>;
  image?: Maybe<ServiceFields_Meta_Image>;
  noIndex?: Maybe<ServiceFields_Meta_NoIndex>;
  title?: Maybe<ServiceFields_Meta_Title>;
};

export type ServiceFields_Meta_Read = {
  __typename?: 'ServiceFields_meta_Read';
  permission: Scalars['Boolean'];
};

export type ServiceFields_Meta_Update = {
  __typename?: 'ServiceFields_meta_Update';
  permission: Scalars['Boolean'];
};

export type ServiceFields_Meta_Description = {
  __typename?: 'ServiceFields_meta_description';
  create?: Maybe<ServiceFields_Meta_Description_Create>;
  delete?: Maybe<ServiceFields_Meta_Description_Delete>;
  read?: Maybe<ServiceFields_Meta_Description_Read>;
  update?: Maybe<ServiceFields_Meta_Description_Update>;
};

export type ServiceFields_Meta_Description_Create = {
  __typename?: 'ServiceFields_meta_description_Create';
  permission: Scalars['Boolean'];
};

export type ServiceFields_Meta_Description_Delete = {
  __typename?: 'ServiceFields_meta_description_Delete';
  permission: Scalars['Boolean'];
};

export type ServiceFields_Meta_Description_Read = {
  __typename?: 'ServiceFields_meta_description_Read';
  permission: Scalars['Boolean'];
};

export type ServiceFields_Meta_Description_Update = {
  __typename?: 'ServiceFields_meta_description_Update';
  permission: Scalars['Boolean'];
};

export type ServiceFields_Meta_Image = {
  __typename?: 'ServiceFields_meta_image';
  create?: Maybe<ServiceFields_Meta_Image_Create>;
  delete?: Maybe<ServiceFields_Meta_Image_Delete>;
  read?: Maybe<ServiceFields_Meta_Image_Read>;
  update?: Maybe<ServiceFields_Meta_Image_Update>;
};

export type ServiceFields_Meta_Image_Create = {
  __typename?: 'ServiceFields_meta_image_Create';
  permission: Scalars['Boolean'];
};

export type ServiceFields_Meta_Image_Delete = {
  __typename?: 'ServiceFields_meta_image_Delete';
  permission: Scalars['Boolean'];
};

export type ServiceFields_Meta_Image_Read = {
  __typename?: 'ServiceFields_meta_image_Read';
  permission: Scalars['Boolean'];
};

export type ServiceFields_Meta_Image_Update = {
  __typename?: 'ServiceFields_meta_image_Update';
  permission: Scalars['Boolean'];
};

export type ServiceFields_Meta_NoIndex = {
  __typename?: 'ServiceFields_meta_noIndex';
  create?: Maybe<ServiceFields_Meta_NoIndex_Create>;
  delete?: Maybe<ServiceFields_Meta_NoIndex_Delete>;
  read?: Maybe<ServiceFields_Meta_NoIndex_Read>;
  update?: Maybe<ServiceFields_Meta_NoIndex_Update>;
};

export type ServiceFields_Meta_NoIndex_Create = {
  __typename?: 'ServiceFields_meta_noIndex_Create';
  permission: Scalars['Boolean'];
};

export type ServiceFields_Meta_NoIndex_Delete = {
  __typename?: 'ServiceFields_meta_noIndex_Delete';
  permission: Scalars['Boolean'];
};

export type ServiceFields_Meta_NoIndex_Read = {
  __typename?: 'ServiceFields_meta_noIndex_Read';
  permission: Scalars['Boolean'];
};

export type ServiceFields_Meta_NoIndex_Update = {
  __typename?: 'ServiceFields_meta_noIndex_Update';
  permission: Scalars['Boolean'];
};

export type ServiceFields_Meta_Title = {
  __typename?: 'ServiceFields_meta_title';
  create?: Maybe<ServiceFields_Meta_Title_Create>;
  delete?: Maybe<ServiceFields_Meta_Title_Delete>;
  read?: Maybe<ServiceFields_Meta_Title_Read>;
  update?: Maybe<ServiceFields_Meta_Title_Update>;
};

export type ServiceFields_Meta_Title_Create = {
  __typename?: 'ServiceFields_meta_title_Create';
  permission: Scalars['Boolean'];
};

export type ServiceFields_Meta_Title_Delete = {
  __typename?: 'ServiceFields_meta_title_Delete';
  permission: Scalars['Boolean'];
};

export type ServiceFields_Meta_Title_Read = {
  __typename?: 'ServiceFields_meta_title_Read';
  permission: Scalars['Boolean'];
};

export type ServiceFields_Meta_Title_Update = {
  __typename?: 'ServiceFields_meta_title_Update';
  permission: Scalars['Boolean'];
};

export type ServiceFields_ShortTitle = {
  __typename?: 'ServiceFields_shortTitle';
  create?: Maybe<ServiceFields_ShortTitle_Create>;
  delete?: Maybe<ServiceFields_ShortTitle_Delete>;
  read?: Maybe<ServiceFields_ShortTitle_Read>;
  update?: Maybe<ServiceFields_ShortTitle_Update>;
};

export type ServiceFields_ShortTitle_Create = {
  __typename?: 'ServiceFields_shortTitle_Create';
  permission: Scalars['Boolean'];
};

export type ServiceFields_ShortTitle_Delete = {
  __typename?: 'ServiceFields_shortTitle_Delete';
  permission: Scalars['Boolean'];
};

export type ServiceFields_ShortTitle_Read = {
  __typename?: 'ServiceFields_shortTitle_Read';
  permission: Scalars['Boolean'];
};

export type ServiceFields_ShortTitle_Update = {
  __typename?: 'ServiceFields_shortTitle_Update';
  permission: Scalars['Boolean'];
};

export type ServiceFields_ShowGetAQuoteSideDrawer = {
  __typename?: 'ServiceFields_showGetAQuoteSideDrawer';
  create?: Maybe<ServiceFields_ShowGetAQuoteSideDrawer_Create>;
  delete?: Maybe<ServiceFields_ShowGetAQuoteSideDrawer_Delete>;
  read?: Maybe<ServiceFields_ShowGetAQuoteSideDrawer_Read>;
  update?: Maybe<ServiceFields_ShowGetAQuoteSideDrawer_Update>;
};

export type ServiceFields_ShowGetAQuoteSideDrawer_Create = {
  __typename?: 'ServiceFields_showGetAQuoteSideDrawer_Create';
  permission: Scalars['Boolean'];
};

export type ServiceFields_ShowGetAQuoteSideDrawer_Delete = {
  __typename?: 'ServiceFields_showGetAQuoteSideDrawer_Delete';
  permission: Scalars['Boolean'];
};

export type ServiceFields_ShowGetAQuoteSideDrawer_Read = {
  __typename?: 'ServiceFields_showGetAQuoteSideDrawer_Read';
  permission: Scalars['Boolean'];
};

export type ServiceFields_ShowGetAQuoteSideDrawer_Update = {
  __typename?: 'ServiceFields_showGetAQuoteSideDrawer_Update';
  permission: Scalars['Boolean'];
};

export type ServiceFields_ShowLookingForForm = {
  __typename?: 'ServiceFields_showLookingForForm';
  create?: Maybe<ServiceFields_ShowLookingForForm_Create>;
  delete?: Maybe<ServiceFields_ShowLookingForForm_Delete>;
  read?: Maybe<ServiceFields_ShowLookingForForm_Read>;
  update?: Maybe<ServiceFields_ShowLookingForForm_Update>;
};

export type ServiceFields_ShowLookingForForm_Create = {
  __typename?: 'ServiceFields_showLookingForForm_Create';
  permission: Scalars['Boolean'];
};

export type ServiceFields_ShowLookingForForm_Delete = {
  __typename?: 'ServiceFields_showLookingForForm_Delete';
  permission: Scalars['Boolean'];
};

export type ServiceFields_ShowLookingForForm_Read = {
  __typename?: 'ServiceFields_showLookingForForm_Read';
  permission: Scalars['Boolean'];
};

export type ServiceFields_ShowLookingForForm_Update = {
  __typename?: 'ServiceFields_showLookingForForm_Update';
  permission: Scalars['Boolean'];
};

export type ServiceFields_ShowRatingWidget = {
  __typename?: 'ServiceFields_showRatingWidget';
  create?: Maybe<ServiceFields_ShowRatingWidget_Create>;
  delete?: Maybe<ServiceFields_ShowRatingWidget_Delete>;
  read?: Maybe<ServiceFields_ShowRatingWidget_Read>;
  update?: Maybe<ServiceFields_ShowRatingWidget_Update>;
};

export type ServiceFields_ShowRatingWidget_Create = {
  __typename?: 'ServiceFields_showRatingWidget_Create';
  permission: Scalars['Boolean'];
};

export type ServiceFields_ShowRatingWidget_Delete = {
  __typename?: 'ServiceFields_showRatingWidget_Delete';
  permission: Scalars['Boolean'];
};

export type ServiceFields_ShowRatingWidget_Read = {
  __typename?: 'ServiceFields_showRatingWidget_Read';
  permission: Scalars['Boolean'];
};

export type ServiceFields_ShowRatingWidget_Update = {
  __typename?: 'ServiceFields_showRatingWidget_Update';
  permission: Scalars['Boolean'];
};

export type ServiceFields_Slug = {
  __typename?: 'ServiceFields_slug';
  create?: Maybe<ServiceFields_Slug_Create>;
  delete?: Maybe<ServiceFields_Slug_Delete>;
  read?: Maybe<ServiceFields_Slug_Read>;
  update?: Maybe<ServiceFields_Slug_Update>;
};

export type ServiceFields_Slug_Create = {
  __typename?: 'ServiceFields_slug_Create';
  permission: Scalars['Boolean'];
};

export type ServiceFields_Slug_Delete = {
  __typename?: 'ServiceFields_slug_Delete';
  permission: Scalars['Boolean'];
};

export type ServiceFields_Slug_Read = {
  __typename?: 'ServiceFields_slug_Read';
  permission: Scalars['Boolean'];
};

export type ServiceFields_Slug_Update = {
  __typename?: 'ServiceFields_slug_Update';
  permission: Scalars['Boolean'];
};

export type ServiceFields_Title = {
  __typename?: 'ServiceFields_title';
  create?: Maybe<ServiceFields_Title_Create>;
  delete?: Maybe<ServiceFields_Title_Delete>;
  read?: Maybe<ServiceFields_Title_Read>;
  update?: Maybe<ServiceFields_Title_Update>;
};

export type ServiceFields_TitleSettings = {
  __typename?: 'ServiceFields_titleSettings';
  create?: Maybe<ServiceFields_TitleSettings_Create>;
  delete?: Maybe<ServiceFields_TitleSettings_Delete>;
  fields?: Maybe<ServiceFields_TitleSettings_Fields>;
  read?: Maybe<ServiceFields_TitleSettings_Read>;
  update?: Maybe<ServiceFields_TitleSettings_Update>;
};

export type ServiceFields_TitleSettings_Create = {
  __typename?: 'ServiceFields_titleSettings_Create';
  permission: Scalars['Boolean'];
};

export type ServiceFields_TitleSettings_Delete = {
  __typename?: 'ServiceFields_titleSettings_Delete';
  permission: Scalars['Boolean'];
};

export type ServiceFields_TitleSettings_Fields = {
  __typename?: 'ServiceFields_titleSettings_Fields';
  boldEndIndex?: Maybe<ServiceFields_TitleSettings_BoldEndIndex>;
  boldStartIndex?: Maybe<ServiceFields_TitleSettings_BoldStartIndex>;
};

export type ServiceFields_TitleSettings_Read = {
  __typename?: 'ServiceFields_titleSettings_Read';
  permission: Scalars['Boolean'];
};

export type ServiceFields_TitleSettings_Update = {
  __typename?: 'ServiceFields_titleSettings_Update';
  permission: Scalars['Boolean'];
};

export type ServiceFields_TitleSettings_BoldEndIndex = {
  __typename?: 'ServiceFields_titleSettings_boldEndIndex';
  create?: Maybe<ServiceFields_TitleSettings_BoldEndIndex_Create>;
  delete?: Maybe<ServiceFields_TitleSettings_BoldEndIndex_Delete>;
  read?: Maybe<ServiceFields_TitleSettings_BoldEndIndex_Read>;
  update?: Maybe<ServiceFields_TitleSettings_BoldEndIndex_Update>;
};

export type ServiceFields_TitleSettings_BoldEndIndex_Create = {
  __typename?: 'ServiceFields_titleSettings_boldEndIndex_Create';
  permission: Scalars['Boolean'];
};

export type ServiceFields_TitleSettings_BoldEndIndex_Delete = {
  __typename?: 'ServiceFields_titleSettings_boldEndIndex_Delete';
  permission: Scalars['Boolean'];
};

export type ServiceFields_TitleSettings_BoldEndIndex_Read = {
  __typename?: 'ServiceFields_titleSettings_boldEndIndex_Read';
  permission: Scalars['Boolean'];
};

export type ServiceFields_TitleSettings_BoldEndIndex_Update = {
  __typename?: 'ServiceFields_titleSettings_boldEndIndex_Update';
  permission: Scalars['Boolean'];
};

export type ServiceFields_TitleSettings_BoldStartIndex = {
  __typename?: 'ServiceFields_titleSettings_boldStartIndex';
  create?: Maybe<ServiceFields_TitleSettings_BoldStartIndex_Create>;
  delete?: Maybe<ServiceFields_TitleSettings_BoldStartIndex_Delete>;
  read?: Maybe<ServiceFields_TitleSettings_BoldStartIndex_Read>;
  update?: Maybe<ServiceFields_TitleSettings_BoldStartIndex_Update>;
};

export type ServiceFields_TitleSettings_BoldStartIndex_Create = {
  __typename?: 'ServiceFields_titleSettings_boldStartIndex_Create';
  permission: Scalars['Boolean'];
};

export type ServiceFields_TitleSettings_BoldStartIndex_Delete = {
  __typename?: 'ServiceFields_titleSettings_boldStartIndex_Delete';
  permission: Scalars['Boolean'];
};

export type ServiceFields_TitleSettings_BoldStartIndex_Read = {
  __typename?: 'ServiceFields_titleSettings_boldStartIndex_Read';
  permission: Scalars['Boolean'];
};

export type ServiceFields_TitleSettings_BoldStartIndex_Update = {
  __typename?: 'ServiceFields_titleSettings_boldStartIndex_Update';
  permission: Scalars['Boolean'];
};

export type ServiceFields_Title_Create = {
  __typename?: 'ServiceFields_title_Create';
  permission: Scalars['Boolean'];
};

export type ServiceFields_Title_Delete = {
  __typename?: 'ServiceFields_title_Delete';
  permission: Scalars['Boolean'];
};

export type ServiceFields_Title_Read = {
  __typename?: 'ServiceFields_title_Read';
  permission: Scalars['Boolean'];
};

export type ServiceFields_Title_Update = {
  __typename?: 'ServiceFields_title_Update';
  permission: Scalars['Boolean'];
};

export type ServiceFields_Type = {
  __typename?: 'ServiceFields_type';
  create?: Maybe<ServiceFields_Type_Create>;
  delete?: Maybe<ServiceFields_Type_Delete>;
  read?: Maybe<ServiceFields_Type_Read>;
  update?: Maybe<ServiceFields_Type_Update>;
};

export type ServiceFields_Type_Create = {
  __typename?: 'ServiceFields_type_Create';
  permission: Scalars['Boolean'];
};

export type ServiceFields_Type_Delete = {
  __typename?: 'ServiceFields_type_Delete';
  permission: Scalars['Boolean'];
};

export type ServiceFields_Type_Read = {
  __typename?: 'ServiceFields_type_Read';
  permission: Scalars['Boolean'];
};

export type ServiceFields_Type_Update = {
  __typename?: 'ServiceFields_type_Update';
  permission: Scalars['Boolean'];
};

export type ServiceFields_UpdatedAt = {
  __typename?: 'ServiceFields_updatedAt';
  create?: Maybe<ServiceFields_UpdatedAt_Create>;
  delete?: Maybe<ServiceFields_UpdatedAt_Delete>;
  read?: Maybe<ServiceFields_UpdatedAt_Read>;
  update?: Maybe<ServiceFields_UpdatedAt_Update>;
};

export type ServiceFields_UpdatedAt_Create = {
  __typename?: 'ServiceFields_updatedAt_Create';
  permission: Scalars['Boolean'];
};

export type ServiceFields_UpdatedAt_Delete = {
  __typename?: 'ServiceFields_updatedAt_Delete';
  permission: Scalars['Boolean'];
};

export type ServiceFields_UpdatedAt_Read = {
  __typename?: 'ServiceFields_updatedAt_Read';
  permission: Scalars['Boolean'];
};

export type ServiceFields_UpdatedAt_Update = {
  __typename?: 'ServiceFields_updatedAt_Update';
  permission: Scalars['Boolean'];
};

export type ServiceReadAccess = {
  __typename?: 'ServiceReadAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type ServiceReadDocAccess = {
  __typename?: 'ServiceReadDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type ServiceReadVersionsAccess = {
  __typename?: 'ServiceReadVersionsAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type ServiceReadVersionsDocAccess = {
  __typename?: 'ServiceReadVersionsDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type ServiceUpdateAccess = {
  __typename?: 'ServiceUpdateAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type ServiceUpdateDocAccess = {
  __typename?: 'ServiceUpdateDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export enum ServiceUpdate_Header_Type_MutationInput {
  Default = 'default',
  FeaturedForm = 'featuredForm',
  FeaturedImage = 'featuredImage'
}

export enum ServiceUpdate__Status_MutationInput {
  Draft = 'draft',
  Published = 'published'
}

export type ServiceVersion = {
  __typename?: 'ServiceVersion';
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  latest?: Maybe<Scalars['Boolean']>;
  parent?: Maybe<Service>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  version?: Maybe<ServiceVersion_Version>;
};


export type ServiceVersionParentArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
};

export type ServiceVersion_Version = {
  __typename?: 'ServiceVersion_Version';
  _status?: Maybe<ServiceVersion_Version__Status>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['JSON']>;
  excerpt?: Maybe<Scalars['String']>;
  featuredImage?: Maybe<Media>;
  header?: Maybe<ServiceVersion_Version_Header>;
  isPlaceholder?: Maybe<Scalars['Boolean']>;
  layout?: Maybe<ServiceVersion_Version_Layout>;
  meta?: Maybe<ServiceVersion_Version_Meta>;
  shortTitle?: Maybe<Scalars['String']>;
  showGetAQuoteSideDrawer?: Maybe<Scalars['Boolean']>;
  slug?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  titleSettings?: Maybe<Page_TitleSettings>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type ServiceVersion_VersionDescriptionArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};

export type ServiceVersion_Version_Header = {
  __typename?: 'ServiceVersion_Version_Header';
  beforeFeaturedFormContent?: Maybe<Scalars['JSON']>;
  featuredForm?: Maybe<Form>;
  image?: Maybe<Media>;
  showLookingForForm?: Maybe<Scalars['Boolean']>;
  showRatingWidget?: Maybe<Scalars['Boolean']>;
  type?: Maybe<ServiceVersion_Version_Header_Type>;
};


export type ServiceVersion_Version_HeaderBeforeFeaturedFormContentArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};

export enum ServiceVersion_Version_Header_Type {
  Default = 'default',
  FeaturedForm = 'featuredForm',
  FeaturedImage = 'featuredImage'
}

export type ServiceVersion_Version_Layout = {
  __typename?: 'ServiceVersion_Version_Layout';
  blocks?: Maybe<Array<ServiceVersion_Version_Layout_Blocks>>;
};

export type ServiceVersion_Version_Layout_Blocks = AnimatedTextBlock | ArticlesScroller | BackgroundWithBlock | CardWithBlocks | Columns | Comparisons | Content | Cta | CtaButton | Faq | FormBlock | Image | LeadFormBlock | Lists | SliderWithBlocks | Spacer | VerticalSlider;

export type ServiceVersion_Version_Meta = {
  __typename?: 'ServiceVersion_Version_Meta';
  description?: Maybe<Scalars['String']>;
  image?: Maybe<Media>;
  noIndex?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
};

export enum ServiceVersion_Version__Status {
  Draft = 'draft',
  Published = 'published'
}

export type Service_Header = {
  __typename?: 'Service_Header';
  beforeFeaturedFormContent?: Maybe<Scalars['JSON']>;
  featuredForm?: Maybe<Form>;
  image?: Maybe<Media>;
  showLookingForForm?: Maybe<Scalars['Boolean']>;
  showRatingWidget?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Service_Header_Type>;
};


export type Service_HeaderBeforeFeaturedFormContentArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};

export enum Service_Header_Type {
  Default = 'default',
  FeaturedForm = 'featuredForm',
  FeaturedImage = 'featuredImage'
}

export enum Service_Header_Type_MutationInput {
  Default = 'default',
  FeaturedForm = 'featuredForm',
  FeaturedImage = 'featuredImage'
}

export type Service_Layout = {
  __typename?: 'Service_Layout';
  blocks?: Maybe<Array<Service_Layout_Blocks>>;
};

export type Service_Layout_Blocks = AnimatedTextBlock | ArticlesScroller | BackgroundWithBlock | CardWithBlocks | Columns | Comparisons | Content | Cta | CtaButton | Faq | FormBlock | Image | LeadFormBlock | Lists | SliderWithBlocks | Spacer | VerticalSlider;

export type Service_Meta = {
  __typename?: 'Service_Meta';
  description?: Maybe<Scalars['String']>;
  image?: Maybe<Media>;
  noIndex?: Maybe<Scalars['Boolean']>;
  title?: Maybe<Scalars['String']>;
};

export enum Service__Status {
  Draft = 'draft',
  Published = 'published'
}

export enum Service__Status_Input {
  Draft = 'draft',
  Published = 'published'
}

export enum Service__Status_MutationInput {
  Draft = 'draft',
  Published = 'published'
}

export type Service__Status_Operator = {
  all?: InputMaybe<Array<InputMaybe<Service__Status_Input>>>;
  equals?: InputMaybe<Service__Status_Input>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Service__Status_Input>>>;
  not_equals?: InputMaybe<Service__Status_Input>;
  not_in?: InputMaybe<Array<InputMaybe<Service__Status_Input>>>;
};

export type Service_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type Service_Description_Operator = {
  contains?: InputMaybe<Scalars['JSON']>;
  equals?: InputMaybe<Scalars['JSON']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  like?: InputMaybe<Scalars['JSON']>;
  not_equals?: InputMaybe<Scalars['JSON']>;
};

export type Service_Excerpt_Operator = {
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
};

export type Service_FeaturedImage_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  equals?: InputMaybe<Scalars['JSON']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  not_equals?: InputMaybe<Scalars['JSON']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type Service_Header__BeforeFeaturedFormContent_Operator = {
  contains?: InputMaybe<Scalars['JSON']>;
  equals?: InputMaybe<Scalars['JSON']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  like?: InputMaybe<Scalars['JSON']>;
  not_equals?: InputMaybe<Scalars['JSON']>;
};

export type Service_Header__FeaturedForm_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  equals?: InputMaybe<Scalars['JSON']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  not_equals?: InputMaybe<Scalars['JSON']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type Service_Header__Image_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  equals?: InputMaybe<Scalars['JSON']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  not_equals?: InputMaybe<Scalars['JSON']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type Service_Header__ShowLookingForForm_Operator = {
  equals?: InputMaybe<Scalars['Boolean']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  not_equals?: InputMaybe<Scalars['Boolean']>;
};

export type Service_Header__ShowRatingWidget_Operator = {
  equals?: InputMaybe<Scalars['Boolean']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  not_equals?: InputMaybe<Scalars['Boolean']>;
};

export enum Service_Header__Type_Input {
  Default = 'default',
  FeaturedForm = 'featuredForm',
  FeaturedImage = 'featuredImage'
}

export type Service_Header__Type_Operator = {
  all?: InputMaybe<Array<InputMaybe<Service_Header__Type_Input>>>;
  equals?: InputMaybe<Service_Header__Type_Input>;
  in?: InputMaybe<Array<InputMaybe<Service_Header__Type_Input>>>;
  not_equals?: InputMaybe<Service_Header__Type_Input>;
  not_in?: InputMaybe<Array<InputMaybe<Service_Header__Type_Input>>>;
};

export type Service_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Service_IsPlaceholder_Operator = {
  equals?: InputMaybe<Scalars['Boolean']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  not_equals?: InputMaybe<Scalars['Boolean']>;
};

export type Service_Meta__Description_Operator = {
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
};

export type Service_Meta__Image_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  equals?: InputMaybe<Scalars['JSON']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  not_equals?: InputMaybe<Scalars['JSON']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type Service_Meta__NoIndex_Operator = {
  equals?: InputMaybe<Scalars['Boolean']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  not_equals?: InputMaybe<Scalars['Boolean']>;
};

export type Service_Meta__Title_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Service_ShortTitle_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Service_ShowGetAQuoteSideDrawer_Operator = {
  equals?: InputMaybe<Scalars['Boolean']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  not_equals?: InputMaybe<Scalars['Boolean']>;
};

export type Service_Slug_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Service_TitleSettings__BoldEndIndex_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Service_TitleSettings__BoldStartIndex_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type Service_Title_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Service_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type Service_Where = {
  AND?: InputMaybe<Array<InputMaybe<Service_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Service_Where_Or>>>;
  _status?: InputMaybe<Service__Status_Operator>;
  createdAt?: InputMaybe<Service_CreatedAt_Operator>;
  description?: InputMaybe<Service_Description_Operator>;
  excerpt?: InputMaybe<Service_Excerpt_Operator>;
  featuredImage?: InputMaybe<Service_FeaturedImage_Operator>;
  header__beforeFeaturedFormContent?: InputMaybe<Service_Header__BeforeFeaturedFormContent_Operator>;
  header__featuredForm?: InputMaybe<Service_Header__FeaturedForm_Operator>;
  header__image?: InputMaybe<Service_Header__Image_Operator>;
  header__showLookingForForm?: InputMaybe<Service_Header__ShowLookingForForm_Operator>;
  header__showRatingWidget?: InputMaybe<Service_Header__ShowRatingWidget_Operator>;
  header__type?: InputMaybe<Service_Header__Type_Operator>;
  id?: InputMaybe<Service_Id_Operator>;
  isPlaceholder?: InputMaybe<Service_IsPlaceholder_Operator>;
  meta__description?: InputMaybe<Service_Meta__Description_Operator>;
  meta__image?: InputMaybe<Service_Meta__Image_Operator>;
  meta__noIndex?: InputMaybe<Service_Meta__NoIndex_Operator>;
  meta__title?: InputMaybe<Service_Meta__Title_Operator>;
  shortTitle?: InputMaybe<Service_ShortTitle_Operator>;
  showGetAQuoteSideDrawer?: InputMaybe<Service_ShowGetAQuoteSideDrawer_Operator>;
  slug?: InputMaybe<Service_Slug_Operator>;
  title?: InputMaybe<Service_Title_Operator>;
  titleSettings__boldEndIndex?: InputMaybe<Service_TitleSettings__BoldEndIndex_Operator>;
  titleSettings__boldStartIndex?: InputMaybe<Service_TitleSettings__BoldStartIndex_Operator>;
  updatedAt?: InputMaybe<Service_UpdatedAt_Operator>;
};

export type Service_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<Service_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Service_Where_Or>>>;
  _status?: InputMaybe<Service__Status_Operator>;
  createdAt?: InputMaybe<Service_CreatedAt_Operator>;
  description?: InputMaybe<Service_Description_Operator>;
  excerpt?: InputMaybe<Service_Excerpt_Operator>;
  featuredImage?: InputMaybe<Service_FeaturedImage_Operator>;
  header__beforeFeaturedFormContent?: InputMaybe<Service_Header__BeforeFeaturedFormContent_Operator>;
  header__featuredForm?: InputMaybe<Service_Header__FeaturedForm_Operator>;
  header__image?: InputMaybe<Service_Header__Image_Operator>;
  header__showLookingForForm?: InputMaybe<Service_Header__ShowLookingForForm_Operator>;
  header__showRatingWidget?: InputMaybe<Service_Header__ShowRatingWidget_Operator>;
  header__type?: InputMaybe<Service_Header__Type_Operator>;
  id?: InputMaybe<Service_Id_Operator>;
  isPlaceholder?: InputMaybe<Service_IsPlaceholder_Operator>;
  meta__description?: InputMaybe<Service_Meta__Description_Operator>;
  meta__image?: InputMaybe<Service_Meta__Image_Operator>;
  meta__noIndex?: InputMaybe<Service_Meta__NoIndex_Operator>;
  meta__title?: InputMaybe<Service_Meta__Title_Operator>;
  shortTitle?: InputMaybe<Service_ShortTitle_Operator>;
  showGetAQuoteSideDrawer?: InputMaybe<Service_ShowGetAQuoteSideDrawer_Operator>;
  slug?: InputMaybe<Service_Slug_Operator>;
  title?: InputMaybe<Service_Title_Operator>;
  titleSettings__boldEndIndex?: InputMaybe<Service_TitleSettings__BoldEndIndex_Operator>;
  titleSettings__boldStartIndex?: InputMaybe<Service_TitleSettings__BoldStartIndex_Operator>;
  updatedAt?: InputMaybe<Service_UpdatedAt_Operator>;
};

export type Service_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<Service_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Service_Where_Or>>>;
  _status?: InputMaybe<Service__Status_Operator>;
  createdAt?: InputMaybe<Service_CreatedAt_Operator>;
  description?: InputMaybe<Service_Description_Operator>;
  excerpt?: InputMaybe<Service_Excerpt_Operator>;
  featuredImage?: InputMaybe<Service_FeaturedImage_Operator>;
  header__beforeFeaturedFormContent?: InputMaybe<Service_Header__BeforeFeaturedFormContent_Operator>;
  header__featuredForm?: InputMaybe<Service_Header__FeaturedForm_Operator>;
  header__image?: InputMaybe<Service_Header__Image_Operator>;
  header__showLookingForForm?: InputMaybe<Service_Header__ShowLookingForForm_Operator>;
  header__showRatingWidget?: InputMaybe<Service_Header__ShowRatingWidget_Operator>;
  header__type?: InputMaybe<Service_Header__Type_Operator>;
  id?: InputMaybe<Service_Id_Operator>;
  isPlaceholder?: InputMaybe<Service_IsPlaceholder_Operator>;
  meta__description?: InputMaybe<Service_Meta__Description_Operator>;
  meta__image?: InputMaybe<Service_Meta__Image_Operator>;
  meta__noIndex?: InputMaybe<Service_Meta__NoIndex_Operator>;
  meta__title?: InputMaybe<Service_Meta__Title_Operator>;
  shortTitle?: InputMaybe<Service_ShortTitle_Operator>;
  showGetAQuoteSideDrawer?: InputMaybe<Service_ShowGetAQuoteSideDrawer_Operator>;
  slug?: InputMaybe<Service_Slug_Operator>;
  title?: InputMaybe<Service_Title_Operator>;
  titleSettings__boldEndIndex?: InputMaybe<Service_TitleSettings__BoldEndIndex_Operator>;
  titleSettings__boldStartIndex?: InputMaybe<Service_TitleSettings__BoldStartIndex_Operator>;
  updatedAt?: InputMaybe<Service_UpdatedAt_Operator>;
};

export type Services = {
  __typename?: 'Services';
  docs?: Maybe<Array<Maybe<Service>>>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPrevPage?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  nextPage?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  pagingCounter?: Maybe<Scalars['Int']>;
  prevPage?: Maybe<Scalars['Int']>;
  totalDocs?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
};

export type ServicesScroller = {
  __typename?: 'ServicesScroller';
  blockName?: Maybe<Scalars['String']>;
  blockSettings?: Maybe<BlockSettings>;
  blockType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  method?: Maybe<ServicesScroller_Method>;
  services?: Maybe<Array<Service>>;
};


export type ServicesScrollerServicesArgs = {
  draft?: InputMaybe<Scalars['Boolean']>;
};

export enum ServicesScroller_Method {
  All = 'all',
  Manual = 'manual'
}

export type SliderWithBlocks = {
  __typename?: 'SliderWithBlocks';
  autoScrollEnabled?: Maybe<Scalars['Boolean']>;
  autoScrollSpeed?: Maybe<Scalars['Float']>;
  blockName?: Maybe<Scalars['String']>;
  blockType?: Maybe<Scalars['String']>;
  blocks: Array<SliderWithBlocks_Blocks>;
  id?: Maybe<Scalars['String']>;
  paginationType?: Maybe<SliderWithBlocks_PaginationType>;
  slidesToShow?: Maybe<SliderWithBlocks_SlidesToShow>;
  type?: Maybe<SliderWithBlocks_Type>;
};

export type SliderWithBlocks_Blocks = CardWithBlocks | Content | Image;

export type SliderWithBlocks_SlidesToShow = {
  __typename?: 'SliderWithBlocks_SlidesToShow';
  desktop?: Maybe<Scalars['Float']>;
  mobile?: Maybe<Scalars['Float']>;
  tablet?: Maybe<Scalars['Float']>;
};

export enum SliderWithBlocks_PaginationType {
  Arrows = 'arrows',
  BlockName = 'blockName',
  Dots = 'dots'
}

export enum SliderWithBlocks_Type {
  Carousel = 'carousel',
  Marquee = 'marquee',
  Slider = 'slider'
}

export type SocialMedia = {
  __typename?: 'SocialMedia';
  createdAt?: Maybe<Scalars['DateTime']>;
  facebook?: Maybe<Scalars['String']>;
  instagram?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SocialMediaDocAccessFields = {
  __typename?: 'SocialMediaDocAccessFields';
  createdAt?: Maybe<SocialMediaDocAccessFields_CreatedAt>;
  facebook?: Maybe<SocialMediaDocAccessFields_Facebook>;
  instagram?: Maybe<SocialMediaDocAccessFields_Instagram>;
  updatedAt?: Maybe<SocialMediaDocAccessFields_UpdatedAt>;
};

export type SocialMediaDocAccessFields_CreatedAt = {
  __typename?: 'SocialMediaDocAccessFields_createdAt';
  create?: Maybe<SocialMediaDocAccessFields_CreatedAt_Create>;
  delete?: Maybe<SocialMediaDocAccessFields_CreatedAt_Delete>;
  read?: Maybe<SocialMediaDocAccessFields_CreatedAt_Read>;
  update?: Maybe<SocialMediaDocAccessFields_CreatedAt_Update>;
};

export type SocialMediaDocAccessFields_CreatedAt_Create = {
  __typename?: 'SocialMediaDocAccessFields_createdAt_Create';
  permission: Scalars['Boolean'];
};

export type SocialMediaDocAccessFields_CreatedAt_Delete = {
  __typename?: 'SocialMediaDocAccessFields_createdAt_Delete';
  permission: Scalars['Boolean'];
};

export type SocialMediaDocAccessFields_CreatedAt_Read = {
  __typename?: 'SocialMediaDocAccessFields_createdAt_Read';
  permission: Scalars['Boolean'];
};

export type SocialMediaDocAccessFields_CreatedAt_Update = {
  __typename?: 'SocialMediaDocAccessFields_createdAt_Update';
  permission: Scalars['Boolean'];
};

export type SocialMediaDocAccessFields_Facebook = {
  __typename?: 'SocialMediaDocAccessFields_facebook';
  create?: Maybe<SocialMediaDocAccessFields_Facebook_Create>;
  delete?: Maybe<SocialMediaDocAccessFields_Facebook_Delete>;
  read?: Maybe<SocialMediaDocAccessFields_Facebook_Read>;
  update?: Maybe<SocialMediaDocAccessFields_Facebook_Update>;
};

export type SocialMediaDocAccessFields_Facebook_Create = {
  __typename?: 'SocialMediaDocAccessFields_facebook_Create';
  permission: Scalars['Boolean'];
};

export type SocialMediaDocAccessFields_Facebook_Delete = {
  __typename?: 'SocialMediaDocAccessFields_facebook_Delete';
  permission: Scalars['Boolean'];
};

export type SocialMediaDocAccessFields_Facebook_Read = {
  __typename?: 'SocialMediaDocAccessFields_facebook_Read';
  permission: Scalars['Boolean'];
};

export type SocialMediaDocAccessFields_Facebook_Update = {
  __typename?: 'SocialMediaDocAccessFields_facebook_Update';
  permission: Scalars['Boolean'];
};

export type SocialMediaDocAccessFields_Instagram = {
  __typename?: 'SocialMediaDocAccessFields_instagram';
  create?: Maybe<SocialMediaDocAccessFields_Instagram_Create>;
  delete?: Maybe<SocialMediaDocAccessFields_Instagram_Delete>;
  read?: Maybe<SocialMediaDocAccessFields_Instagram_Read>;
  update?: Maybe<SocialMediaDocAccessFields_Instagram_Update>;
};

export type SocialMediaDocAccessFields_Instagram_Create = {
  __typename?: 'SocialMediaDocAccessFields_instagram_Create';
  permission: Scalars['Boolean'];
};

export type SocialMediaDocAccessFields_Instagram_Delete = {
  __typename?: 'SocialMediaDocAccessFields_instagram_Delete';
  permission: Scalars['Boolean'];
};

export type SocialMediaDocAccessFields_Instagram_Read = {
  __typename?: 'SocialMediaDocAccessFields_instagram_Read';
  permission: Scalars['Boolean'];
};

export type SocialMediaDocAccessFields_Instagram_Update = {
  __typename?: 'SocialMediaDocAccessFields_instagram_Update';
  permission: Scalars['Boolean'];
};

export type SocialMediaDocAccessFields_UpdatedAt = {
  __typename?: 'SocialMediaDocAccessFields_updatedAt';
  create?: Maybe<SocialMediaDocAccessFields_UpdatedAt_Create>;
  delete?: Maybe<SocialMediaDocAccessFields_UpdatedAt_Delete>;
  read?: Maybe<SocialMediaDocAccessFields_UpdatedAt_Read>;
  update?: Maybe<SocialMediaDocAccessFields_UpdatedAt_Update>;
};

export type SocialMediaDocAccessFields_UpdatedAt_Create = {
  __typename?: 'SocialMediaDocAccessFields_updatedAt_Create';
  permission: Scalars['Boolean'];
};

export type SocialMediaDocAccessFields_UpdatedAt_Delete = {
  __typename?: 'SocialMediaDocAccessFields_updatedAt_Delete';
  permission: Scalars['Boolean'];
};

export type SocialMediaDocAccessFields_UpdatedAt_Read = {
  __typename?: 'SocialMediaDocAccessFields_updatedAt_Read';
  permission: Scalars['Boolean'];
};

export type SocialMediaDocAccessFields_UpdatedAt_Update = {
  __typename?: 'SocialMediaDocAccessFields_updatedAt_Update';
  permission: Scalars['Boolean'];
};

export type SocialMediaFields = {
  __typename?: 'SocialMediaFields';
  createdAt?: Maybe<SocialMediaFields_CreatedAt>;
  facebook?: Maybe<SocialMediaFields_Facebook>;
  instagram?: Maybe<SocialMediaFields_Instagram>;
  updatedAt?: Maybe<SocialMediaFields_UpdatedAt>;
};

export type SocialMediaFields_CreatedAt = {
  __typename?: 'SocialMediaFields_createdAt';
  create?: Maybe<SocialMediaFields_CreatedAt_Create>;
  delete?: Maybe<SocialMediaFields_CreatedAt_Delete>;
  read?: Maybe<SocialMediaFields_CreatedAt_Read>;
  update?: Maybe<SocialMediaFields_CreatedAt_Update>;
};

export type SocialMediaFields_CreatedAt_Create = {
  __typename?: 'SocialMediaFields_createdAt_Create';
  permission: Scalars['Boolean'];
};

export type SocialMediaFields_CreatedAt_Delete = {
  __typename?: 'SocialMediaFields_createdAt_Delete';
  permission: Scalars['Boolean'];
};

export type SocialMediaFields_CreatedAt_Read = {
  __typename?: 'SocialMediaFields_createdAt_Read';
  permission: Scalars['Boolean'];
};

export type SocialMediaFields_CreatedAt_Update = {
  __typename?: 'SocialMediaFields_createdAt_Update';
  permission: Scalars['Boolean'];
};

export type SocialMediaFields_Facebook = {
  __typename?: 'SocialMediaFields_facebook';
  create?: Maybe<SocialMediaFields_Facebook_Create>;
  delete?: Maybe<SocialMediaFields_Facebook_Delete>;
  read?: Maybe<SocialMediaFields_Facebook_Read>;
  update?: Maybe<SocialMediaFields_Facebook_Update>;
};

export type SocialMediaFields_Facebook_Create = {
  __typename?: 'SocialMediaFields_facebook_Create';
  permission: Scalars['Boolean'];
};

export type SocialMediaFields_Facebook_Delete = {
  __typename?: 'SocialMediaFields_facebook_Delete';
  permission: Scalars['Boolean'];
};

export type SocialMediaFields_Facebook_Read = {
  __typename?: 'SocialMediaFields_facebook_Read';
  permission: Scalars['Boolean'];
};

export type SocialMediaFields_Facebook_Update = {
  __typename?: 'SocialMediaFields_facebook_Update';
  permission: Scalars['Boolean'];
};

export type SocialMediaFields_Instagram = {
  __typename?: 'SocialMediaFields_instagram';
  create?: Maybe<SocialMediaFields_Instagram_Create>;
  delete?: Maybe<SocialMediaFields_Instagram_Delete>;
  read?: Maybe<SocialMediaFields_Instagram_Read>;
  update?: Maybe<SocialMediaFields_Instagram_Update>;
};

export type SocialMediaFields_Instagram_Create = {
  __typename?: 'SocialMediaFields_instagram_Create';
  permission: Scalars['Boolean'];
};

export type SocialMediaFields_Instagram_Delete = {
  __typename?: 'SocialMediaFields_instagram_Delete';
  permission: Scalars['Boolean'];
};

export type SocialMediaFields_Instagram_Read = {
  __typename?: 'SocialMediaFields_instagram_Read';
  permission: Scalars['Boolean'];
};

export type SocialMediaFields_Instagram_Update = {
  __typename?: 'SocialMediaFields_instagram_Update';
  permission: Scalars['Boolean'];
};

export type SocialMediaFields_UpdatedAt = {
  __typename?: 'SocialMediaFields_updatedAt';
  create?: Maybe<SocialMediaFields_UpdatedAt_Create>;
  delete?: Maybe<SocialMediaFields_UpdatedAt_Delete>;
  read?: Maybe<SocialMediaFields_UpdatedAt_Read>;
  update?: Maybe<SocialMediaFields_UpdatedAt_Update>;
};

export type SocialMediaFields_UpdatedAt_Create = {
  __typename?: 'SocialMediaFields_updatedAt_Create';
  permission: Scalars['Boolean'];
};

export type SocialMediaFields_UpdatedAt_Delete = {
  __typename?: 'SocialMediaFields_updatedAt_Delete';
  permission: Scalars['Boolean'];
};

export type SocialMediaFields_UpdatedAt_Read = {
  __typename?: 'SocialMediaFields_updatedAt_Read';
  permission: Scalars['Boolean'];
};

export type SocialMediaFields_UpdatedAt_Update = {
  __typename?: 'SocialMediaFields_updatedAt_Update';
  permission: Scalars['Boolean'];
};

export type SocialMediaReadAccess = {
  __typename?: 'SocialMediaReadAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type SocialMediaReadDocAccess = {
  __typename?: 'SocialMediaReadDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type SocialMediaUpdateAccess = {
  __typename?: 'SocialMediaUpdateAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type SocialMediaUpdateDocAccess = {
  __typename?: 'SocialMediaUpdateDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type Spacer = {
  __typename?: 'Spacer';
  blockName?: Maybe<Scalars['String']>;
  blockType?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['String']>;
};

export type StickyImageScroll = {
  __typename?: 'StickyImageScroll';
  blockName?: Maybe<Scalars['String']>;
  blockSettings?: Maybe<BlockSettings>;
  blockType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  image?: Maybe<Media>;
  items?: Maybe<Array<StickyImageScroll_Items>>;
};

export type StickyImageScroll_Items = {
  __typename?: 'StickyImageScroll_Items';
  content?: Maybe<Scalars['JSON']>;
  id?: Maybe<Scalars['String']>;
  imageNode?: Maybe<StickyImageScroll_Items_ImageNode>;
  showImageNode?: Maybe<Scalars['Boolean']>;
};


export type StickyImageScroll_ItemsContentArgs = {
  depth?: InputMaybe<Scalars['Int']>;
};

export type StickyImageScroll_Items_ImageNode = {
  __typename?: 'StickyImageScroll_Items_ImageNode';
  icon?: Maybe<Scalars['String']>;
  x?: Maybe<Scalars['Float']>;
  y?: Maybe<Scalars['Float']>;
};

export type Tag = {
  __typename?: 'Tag';
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  title: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TagCreateAccess = {
  __typename?: 'TagCreateAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type TagCreateDocAccess = {
  __typename?: 'TagCreateDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type TagDeleteAccess = {
  __typename?: 'TagDeleteAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type TagDeleteDocAccess = {
  __typename?: 'TagDeleteDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type TagDocAccessFields = {
  __typename?: 'TagDocAccessFields';
  createdAt?: Maybe<TagDocAccessFields_CreatedAt>;
  title?: Maybe<TagDocAccessFields_Title>;
  updatedAt?: Maybe<TagDocAccessFields_UpdatedAt>;
};

export type TagDocAccessFields_CreatedAt = {
  __typename?: 'TagDocAccessFields_createdAt';
  create?: Maybe<TagDocAccessFields_CreatedAt_Create>;
  delete?: Maybe<TagDocAccessFields_CreatedAt_Delete>;
  read?: Maybe<TagDocAccessFields_CreatedAt_Read>;
  update?: Maybe<TagDocAccessFields_CreatedAt_Update>;
};

export type TagDocAccessFields_CreatedAt_Create = {
  __typename?: 'TagDocAccessFields_createdAt_Create';
  permission: Scalars['Boolean'];
};

export type TagDocAccessFields_CreatedAt_Delete = {
  __typename?: 'TagDocAccessFields_createdAt_Delete';
  permission: Scalars['Boolean'];
};

export type TagDocAccessFields_CreatedAt_Read = {
  __typename?: 'TagDocAccessFields_createdAt_Read';
  permission: Scalars['Boolean'];
};

export type TagDocAccessFields_CreatedAt_Update = {
  __typename?: 'TagDocAccessFields_createdAt_Update';
  permission: Scalars['Boolean'];
};

export type TagDocAccessFields_Title = {
  __typename?: 'TagDocAccessFields_title';
  create?: Maybe<TagDocAccessFields_Title_Create>;
  delete?: Maybe<TagDocAccessFields_Title_Delete>;
  read?: Maybe<TagDocAccessFields_Title_Read>;
  update?: Maybe<TagDocAccessFields_Title_Update>;
};

export type TagDocAccessFields_Title_Create = {
  __typename?: 'TagDocAccessFields_title_Create';
  permission: Scalars['Boolean'];
};

export type TagDocAccessFields_Title_Delete = {
  __typename?: 'TagDocAccessFields_title_Delete';
  permission: Scalars['Boolean'];
};

export type TagDocAccessFields_Title_Read = {
  __typename?: 'TagDocAccessFields_title_Read';
  permission: Scalars['Boolean'];
};

export type TagDocAccessFields_Title_Update = {
  __typename?: 'TagDocAccessFields_title_Update';
  permission: Scalars['Boolean'];
};

export type TagDocAccessFields_UpdatedAt = {
  __typename?: 'TagDocAccessFields_updatedAt';
  create?: Maybe<TagDocAccessFields_UpdatedAt_Create>;
  delete?: Maybe<TagDocAccessFields_UpdatedAt_Delete>;
  read?: Maybe<TagDocAccessFields_UpdatedAt_Read>;
  update?: Maybe<TagDocAccessFields_UpdatedAt_Update>;
};

export type TagDocAccessFields_UpdatedAt_Create = {
  __typename?: 'TagDocAccessFields_updatedAt_Create';
  permission: Scalars['Boolean'];
};

export type TagDocAccessFields_UpdatedAt_Delete = {
  __typename?: 'TagDocAccessFields_updatedAt_Delete';
  permission: Scalars['Boolean'];
};

export type TagDocAccessFields_UpdatedAt_Read = {
  __typename?: 'TagDocAccessFields_updatedAt_Read';
  permission: Scalars['Boolean'];
};

export type TagDocAccessFields_UpdatedAt_Update = {
  __typename?: 'TagDocAccessFields_updatedAt_Update';
  permission: Scalars['Boolean'];
};

export type TagFields = {
  __typename?: 'TagFields';
  createdAt?: Maybe<TagFields_CreatedAt>;
  title?: Maybe<TagFields_Title>;
  updatedAt?: Maybe<TagFields_UpdatedAt>;
};

export type TagFields_CreatedAt = {
  __typename?: 'TagFields_createdAt';
  create?: Maybe<TagFields_CreatedAt_Create>;
  delete?: Maybe<TagFields_CreatedAt_Delete>;
  read?: Maybe<TagFields_CreatedAt_Read>;
  update?: Maybe<TagFields_CreatedAt_Update>;
};

export type TagFields_CreatedAt_Create = {
  __typename?: 'TagFields_createdAt_Create';
  permission: Scalars['Boolean'];
};

export type TagFields_CreatedAt_Delete = {
  __typename?: 'TagFields_createdAt_Delete';
  permission: Scalars['Boolean'];
};

export type TagFields_CreatedAt_Read = {
  __typename?: 'TagFields_createdAt_Read';
  permission: Scalars['Boolean'];
};

export type TagFields_CreatedAt_Update = {
  __typename?: 'TagFields_createdAt_Update';
  permission: Scalars['Boolean'];
};

export type TagFields_Title = {
  __typename?: 'TagFields_title';
  create?: Maybe<TagFields_Title_Create>;
  delete?: Maybe<TagFields_Title_Delete>;
  read?: Maybe<TagFields_Title_Read>;
  update?: Maybe<TagFields_Title_Update>;
};

export type TagFields_Title_Create = {
  __typename?: 'TagFields_title_Create';
  permission: Scalars['Boolean'];
};

export type TagFields_Title_Delete = {
  __typename?: 'TagFields_title_Delete';
  permission: Scalars['Boolean'];
};

export type TagFields_Title_Read = {
  __typename?: 'TagFields_title_Read';
  permission: Scalars['Boolean'];
};

export type TagFields_Title_Update = {
  __typename?: 'TagFields_title_Update';
  permission: Scalars['Boolean'];
};

export type TagFields_UpdatedAt = {
  __typename?: 'TagFields_updatedAt';
  create?: Maybe<TagFields_UpdatedAt_Create>;
  delete?: Maybe<TagFields_UpdatedAt_Delete>;
  read?: Maybe<TagFields_UpdatedAt_Read>;
  update?: Maybe<TagFields_UpdatedAt_Update>;
};

export type TagFields_UpdatedAt_Create = {
  __typename?: 'TagFields_updatedAt_Create';
  permission: Scalars['Boolean'];
};

export type TagFields_UpdatedAt_Delete = {
  __typename?: 'TagFields_updatedAt_Delete';
  permission: Scalars['Boolean'];
};

export type TagFields_UpdatedAt_Read = {
  __typename?: 'TagFields_updatedAt_Read';
  permission: Scalars['Boolean'];
};

export type TagFields_UpdatedAt_Update = {
  __typename?: 'TagFields_updatedAt_Update';
  permission: Scalars['Boolean'];
};

export type TagReadAccess = {
  __typename?: 'TagReadAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type TagReadDocAccess = {
  __typename?: 'TagReadDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type TagUpdateAccess = {
  __typename?: 'TagUpdateAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type TagUpdateDocAccess = {
  __typename?: 'TagUpdateDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type Tag_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type Tag_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Tag_Title_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type Tag_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type Tag_Where = {
  AND?: InputMaybe<Array<InputMaybe<Tag_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Tag_Where_Or>>>;
  createdAt?: InputMaybe<Tag_CreatedAt_Operator>;
  id?: InputMaybe<Tag_Id_Operator>;
  title?: InputMaybe<Tag_Title_Operator>;
  updatedAt?: InputMaybe<Tag_UpdatedAt_Operator>;
};

export type Tag_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<Tag_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Tag_Where_Or>>>;
  createdAt?: InputMaybe<Tag_CreatedAt_Operator>;
  id?: InputMaybe<Tag_Id_Operator>;
  title?: InputMaybe<Tag_Title_Operator>;
  updatedAt?: InputMaybe<Tag_UpdatedAt_Operator>;
};

export type Tag_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<Tag_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<Tag_Where_Or>>>;
  createdAt?: InputMaybe<Tag_CreatedAt_Operator>;
  id?: InputMaybe<Tag_Id_Operator>;
  title?: InputMaybe<Tag_Title_Operator>;
  updatedAt?: InputMaybe<Tag_UpdatedAt_Operator>;
};

export type Tags = {
  __typename?: 'Tags';
  docs?: Maybe<Array<Maybe<Tag>>>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPrevPage?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  nextPage?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  pagingCounter?: Maybe<Scalars['Int']>;
  prevPage?: Maybe<Scalars['Int']>;
  totalDocs?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
};

export type Text = {
  __typename?: 'Text';
  blockName?: Maybe<Scalars['String']>;
  blockType?: Maybe<Scalars['String']>;
  defaultValue?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  required?: Maybe<Scalars['Boolean']>;
  width?: Maybe<Scalars['Float']>;
};

export type Textarea = {
  __typename?: 'Textarea';
  blockName?: Maybe<Scalars['String']>;
  blockType?: Maybe<Scalars['String']>;
  defaultValue?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  required?: Maybe<Scalars['Boolean']>;
  width?: Maybe<Scalars['Float']>;
};

export type Toggle = {
  __typename?: 'Toggle';
  blockName?: Maybe<Scalars['String']>;
  blockType?: Maybe<Scalars['String']>;
  defaultValue?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  options?: Maybe<Array<Toggle_Options>>;
  required?: Maybe<Scalars['Boolean']>;
  width?: Maybe<Scalars['Float']>;
};

export type Toggle_Options = {
  __typename?: 'Toggle_Options';
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type User = {
  __typename?: 'User';
  createdAt?: Maybe<Scalars['DateTime']>;
  email: Scalars['EmailAddress'];
  firstName: Scalars['String'];
  fullName?: Maybe<Scalars['String']>;
  hash?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  lastName: Scalars['String'];
  lockUntil?: Maybe<Scalars['DateTime']>;
  loginAttempts?: Maybe<Scalars['Float']>;
  resetPasswordExpiration?: Maybe<Scalars['DateTime']>;
  resetPasswordToken?: Maybe<Scalars['String']>;
  salt?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type UserCreateAccess = {
  __typename?: 'UserCreateAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type UserCreateDocAccess = {
  __typename?: 'UserCreateDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type UserDeleteAccess = {
  __typename?: 'UserDeleteAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type UserDeleteDocAccess = {
  __typename?: 'UserDeleteDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type UserDocAccessFields = {
  __typename?: 'UserDocAccessFields';
  createdAt?: Maybe<UserDocAccessFields_CreatedAt>;
  email?: Maybe<UserDocAccessFields_Email>;
  firstName?: Maybe<UserDocAccessFields_FirstName>;
  fullName?: Maybe<UserDocAccessFields_FullName>;
  lastName?: Maybe<UserDocAccessFields_LastName>;
  updatedAt?: Maybe<UserDocAccessFields_UpdatedAt>;
};

export type UserDocAccessFields_CreatedAt = {
  __typename?: 'UserDocAccessFields_createdAt';
  create?: Maybe<UserDocAccessFields_CreatedAt_Create>;
  delete?: Maybe<UserDocAccessFields_CreatedAt_Delete>;
  read?: Maybe<UserDocAccessFields_CreatedAt_Read>;
  update?: Maybe<UserDocAccessFields_CreatedAt_Update>;
};

export type UserDocAccessFields_CreatedAt_Create = {
  __typename?: 'UserDocAccessFields_createdAt_Create';
  permission: Scalars['Boolean'];
};

export type UserDocAccessFields_CreatedAt_Delete = {
  __typename?: 'UserDocAccessFields_createdAt_Delete';
  permission: Scalars['Boolean'];
};

export type UserDocAccessFields_CreatedAt_Read = {
  __typename?: 'UserDocAccessFields_createdAt_Read';
  permission: Scalars['Boolean'];
};

export type UserDocAccessFields_CreatedAt_Update = {
  __typename?: 'UserDocAccessFields_createdAt_Update';
  permission: Scalars['Boolean'];
};

export type UserDocAccessFields_Email = {
  __typename?: 'UserDocAccessFields_email';
  create?: Maybe<UserDocAccessFields_Email_Create>;
  delete?: Maybe<UserDocAccessFields_Email_Delete>;
  read?: Maybe<UserDocAccessFields_Email_Read>;
  update?: Maybe<UserDocAccessFields_Email_Update>;
};

export type UserDocAccessFields_Email_Create = {
  __typename?: 'UserDocAccessFields_email_Create';
  permission: Scalars['Boolean'];
};

export type UserDocAccessFields_Email_Delete = {
  __typename?: 'UserDocAccessFields_email_Delete';
  permission: Scalars['Boolean'];
};

export type UserDocAccessFields_Email_Read = {
  __typename?: 'UserDocAccessFields_email_Read';
  permission: Scalars['Boolean'];
};

export type UserDocAccessFields_Email_Update = {
  __typename?: 'UserDocAccessFields_email_Update';
  permission: Scalars['Boolean'];
};

export type UserDocAccessFields_FirstName = {
  __typename?: 'UserDocAccessFields_firstName';
  create?: Maybe<UserDocAccessFields_FirstName_Create>;
  delete?: Maybe<UserDocAccessFields_FirstName_Delete>;
  read?: Maybe<UserDocAccessFields_FirstName_Read>;
  update?: Maybe<UserDocAccessFields_FirstName_Update>;
};

export type UserDocAccessFields_FirstName_Create = {
  __typename?: 'UserDocAccessFields_firstName_Create';
  permission: Scalars['Boolean'];
};

export type UserDocAccessFields_FirstName_Delete = {
  __typename?: 'UserDocAccessFields_firstName_Delete';
  permission: Scalars['Boolean'];
};

export type UserDocAccessFields_FirstName_Read = {
  __typename?: 'UserDocAccessFields_firstName_Read';
  permission: Scalars['Boolean'];
};

export type UserDocAccessFields_FirstName_Update = {
  __typename?: 'UserDocAccessFields_firstName_Update';
  permission: Scalars['Boolean'];
};

export type UserDocAccessFields_FullName = {
  __typename?: 'UserDocAccessFields_fullName';
  create?: Maybe<UserDocAccessFields_FullName_Create>;
  delete?: Maybe<UserDocAccessFields_FullName_Delete>;
  read?: Maybe<UserDocAccessFields_FullName_Read>;
  update?: Maybe<UserDocAccessFields_FullName_Update>;
};

export type UserDocAccessFields_FullName_Create = {
  __typename?: 'UserDocAccessFields_fullName_Create';
  permission: Scalars['Boolean'];
};

export type UserDocAccessFields_FullName_Delete = {
  __typename?: 'UserDocAccessFields_fullName_Delete';
  permission: Scalars['Boolean'];
};

export type UserDocAccessFields_FullName_Read = {
  __typename?: 'UserDocAccessFields_fullName_Read';
  permission: Scalars['Boolean'];
};

export type UserDocAccessFields_FullName_Update = {
  __typename?: 'UserDocAccessFields_fullName_Update';
  permission: Scalars['Boolean'];
};

export type UserDocAccessFields_LastName = {
  __typename?: 'UserDocAccessFields_lastName';
  create?: Maybe<UserDocAccessFields_LastName_Create>;
  delete?: Maybe<UserDocAccessFields_LastName_Delete>;
  read?: Maybe<UserDocAccessFields_LastName_Read>;
  update?: Maybe<UserDocAccessFields_LastName_Update>;
};

export type UserDocAccessFields_LastName_Create = {
  __typename?: 'UserDocAccessFields_lastName_Create';
  permission: Scalars['Boolean'];
};

export type UserDocAccessFields_LastName_Delete = {
  __typename?: 'UserDocAccessFields_lastName_Delete';
  permission: Scalars['Boolean'];
};

export type UserDocAccessFields_LastName_Read = {
  __typename?: 'UserDocAccessFields_lastName_Read';
  permission: Scalars['Boolean'];
};

export type UserDocAccessFields_LastName_Update = {
  __typename?: 'UserDocAccessFields_lastName_Update';
  permission: Scalars['Boolean'];
};

export type UserDocAccessFields_UpdatedAt = {
  __typename?: 'UserDocAccessFields_updatedAt';
  create?: Maybe<UserDocAccessFields_UpdatedAt_Create>;
  delete?: Maybe<UserDocAccessFields_UpdatedAt_Delete>;
  read?: Maybe<UserDocAccessFields_UpdatedAt_Read>;
  update?: Maybe<UserDocAccessFields_UpdatedAt_Update>;
};

export type UserDocAccessFields_UpdatedAt_Create = {
  __typename?: 'UserDocAccessFields_updatedAt_Create';
  permission: Scalars['Boolean'];
};

export type UserDocAccessFields_UpdatedAt_Delete = {
  __typename?: 'UserDocAccessFields_updatedAt_Delete';
  permission: Scalars['Boolean'];
};

export type UserDocAccessFields_UpdatedAt_Read = {
  __typename?: 'UserDocAccessFields_updatedAt_Read';
  permission: Scalars['Boolean'];
};

export type UserDocAccessFields_UpdatedAt_Update = {
  __typename?: 'UserDocAccessFields_updatedAt_Update';
  permission: Scalars['Boolean'];
};

export type UserFields = {
  __typename?: 'UserFields';
  createdAt?: Maybe<UserFields_CreatedAt>;
  email?: Maybe<UserFields_Email>;
  firstName?: Maybe<UserFields_FirstName>;
  fullName?: Maybe<UserFields_FullName>;
  lastName?: Maybe<UserFields_LastName>;
  updatedAt?: Maybe<UserFields_UpdatedAt>;
};

export type UserFields_CreatedAt = {
  __typename?: 'UserFields_createdAt';
  create?: Maybe<UserFields_CreatedAt_Create>;
  delete?: Maybe<UserFields_CreatedAt_Delete>;
  read?: Maybe<UserFields_CreatedAt_Read>;
  update?: Maybe<UserFields_CreatedAt_Update>;
};

export type UserFields_CreatedAt_Create = {
  __typename?: 'UserFields_createdAt_Create';
  permission: Scalars['Boolean'];
};

export type UserFields_CreatedAt_Delete = {
  __typename?: 'UserFields_createdAt_Delete';
  permission: Scalars['Boolean'];
};

export type UserFields_CreatedAt_Read = {
  __typename?: 'UserFields_createdAt_Read';
  permission: Scalars['Boolean'];
};

export type UserFields_CreatedAt_Update = {
  __typename?: 'UserFields_createdAt_Update';
  permission: Scalars['Boolean'];
};

export type UserFields_Email = {
  __typename?: 'UserFields_email';
  create?: Maybe<UserFields_Email_Create>;
  delete?: Maybe<UserFields_Email_Delete>;
  read?: Maybe<UserFields_Email_Read>;
  update?: Maybe<UserFields_Email_Update>;
};

export type UserFields_Email_Create = {
  __typename?: 'UserFields_email_Create';
  permission: Scalars['Boolean'];
};

export type UserFields_Email_Delete = {
  __typename?: 'UserFields_email_Delete';
  permission: Scalars['Boolean'];
};

export type UserFields_Email_Read = {
  __typename?: 'UserFields_email_Read';
  permission: Scalars['Boolean'];
};

export type UserFields_Email_Update = {
  __typename?: 'UserFields_email_Update';
  permission: Scalars['Boolean'];
};

export type UserFields_FirstName = {
  __typename?: 'UserFields_firstName';
  create?: Maybe<UserFields_FirstName_Create>;
  delete?: Maybe<UserFields_FirstName_Delete>;
  read?: Maybe<UserFields_FirstName_Read>;
  update?: Maybe<UserFields_FirstName_Update>;
};

export type UserFields_FirstName_Create = {
  __typename?: 'UserFields_firstName_Create';
  permission: Scalars['Boolean'];
};

export type UserFields_FirstName_Delete = {
  __typename?: 'UserFields_firstName_Delete';
  permission: Scalars['Boolean'];
};

export type UserFields_FirstName_Read = {
  __typename?: 'UserFields_firstName_Read';
  permission: Scalars['Boolean'];
};

export type UserFields_FirstName_Update = {
  __typename?: 'UserFields_firstName_Update';
  permission: Scalars['Boolean'];
};

export type UserFields_FullName = {
  __typename?: 'UserFields_fullName';
  create?: Maybe<UserFields_FullName_Create>;
  delete?: Maybe<UserFields_FullName_Delete>;
  read?: Maybe<UserFields_FullName_Read>;
  update?: Maybe<UserFields_FullName_Update>;
};

export type UserFields_FullName_Create = {
  __typename?: 'UserFields_fullName_Create';
  permission: Scalars['Boolean'];
};

export type UserFields_FullName_Delete = {
  __typename?: 'UserFields_fullName_Delete';
  permission: Scalars['Boolean'];
};

export type UserFields_FullName_Read = {
  __typename?: 'UserFields_fullName_Read';
  permission: Scalars['Boolean'];
};

export type UserFields_FullName_Update = {
  __typename?: 'UserFields_fullName_Update';
  permission: Scalars['Boolean'];
};

export type UserFields_LastName = {
  __typename?: 'UserFields_lastName';
  create?: Maybe<UserFields_LastName_Create>;
  delete?: Maybe<UserFields_LastName_Delete>;
  read?: Maybe<UserFields_LastName_Read>;
  update?: Maybe<UserFields_LastName_Update>;
};

export type UserFields_LastName_Create = {
  __typename?: 'UserFields_lastName_Create';
  permission: Scalars['Boolean'];
};

export type UserFields_LastName_Delete = {
  __typename?: 'UserFields_lastName_Delete';
  permission: Scalars['Boolean'];
};

export type UserFields_LastName_Read = {
  __typename?: 'UserFields_lastName_Read';
  permission: Scalars['Boolean'];
};

export type UserFields_LastName_Update = {
  __typename?: 'UserFields_lastName_Update';
  permission: Scalars['Boolean'];
};

export type UserFields_UpdatedAt = {
  __typename?: 'UserFields_updatedAt';
  create?: Maybe<UserFields_UpdatedAt_Create>;
  delete?: Maybe<UserFields_UpdatedAt_Delete>;
  read?: Maybe<UserFields_UpdatedAt_Read>;
  update?: Maybe<UserFields_UpdatedAt_Update>;
};

export type UserFields_UpdatedAt_Create = {
  __typename?: 'UserFields_updatedAt_Create';
  permission: Scalars['Boolean'];
};

export type UserFields_UpdatedAt_Delete = {
  __typename?: 'UserFields_updatedAt_Delete';
  permission: Scalars['Boolean'];
};

export type UserFields_UpdatedAt_Read = {
  __typename?: 'UserFields_updatedAt_Read';
  permission: Scalars['Boolean'];
};

export type UserFields_UpdatedAt_Update = {
  __typename?: 'UserFields_updatedAt_Update';
  permission: Scalars['Boolean'];
};

export type UserReadAccess = {
  __typename?: 'UserReadAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type UserReadDocAccess = {
  __typename?: 'UserReadDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type UserUnlockAccess = {
  __typename?: 'UserUnlockAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type UserUnlockDocAccess = {
  __typename?: 'UserUnlockDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type UserUpdateAccess = {
  __typename?: 'UserUpdateAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type UserUpdateDocAccess = {
  __typename?: 'UserUpdateDocAccess';
  permission: Scalars['Boolean'];
  where?: Maybe<Scalars['JSONObject']>;
};

export type User_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type User_Email_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['EmailAddress']>>>;
  contains?: InputMaybe<Scalars['EmailAddress']>;
  equals?: InputMaybe<Scalars['EmailAddress']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['EmailAddress']>>>;
  like?: InputMaybe<Scalars['EmailAddress']>;
  not_equals?: InputMaybe<Scalars['EmailAddress']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['EmailAddress']>>>;
};

export type User_FirstName_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type User_FullName_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type User_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type User_LastName_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type User_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type User_Where = {
  AND?: InputMaybe<Array<InputMaybe<User_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<User_Where_Or>>>;
  createdAt?: InputMaybe<User_CreatedAt_Operator>;
  email?: InputMaybe<User_Email_Operator>;
  firstName?: InputMaybe<User_FirstName_Operator>;
  fullName?: InputMaybe<User_FullName_Operator>;
  id?: InputMaybe<User_Id_Operator>;
  lastName?: InputMaybe<User_LastName_Operator>;
  updatedAt?: InputMaybe<User_UpdatedAt_Operator>;
};

export type User_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<User_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<User_Where_Or>>>;
  createdAt?: InputMaybe<User_CreatedAt_Operator>;
  email?: InputMaybe<User_Email_Operator>;
  firstName?: InputMaybe<User_FirstName_Operator>;
  fullName?: InputMaybe<User_FullName_Operator>;
  id?: InputMaybe<User_Id_Operator>;
  lastName?: InputMaybe<User_LastName_Operator>;
  updatedAt?: InputMaybe<User_UpdatedAt_Operator>;
};

export type User_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<User_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<User_Where_Or>>>;
  createdAt?: InputMaybe<User_CreatedAt_Operator>;
  email?: InputMaybe<User_Email_Operator>;
  firstName?: InputMaybe<User_FirstName_Operator>;
  fullName?: InputMaybe<User_FullName_Operator>;
  id?: InputMaybe<User_Id_Operator>;
  lastName?: InputMaybe<User_LastName_Operator>;
  updatedAt?: InputMaybe<User_UpdatedAt_Operator>;
};

export type Users = {
  __typename?: 'Users';
  docs?: Maybe<Array<Maybe<User>>>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPrevPage?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  nextPage?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  pagingCounter?: Maybe<Scalars['Int']>;
  prevPage?: Maybe<Scalars['Int']>;
  totalDocs?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
};

export type VerticalSlider = {
  __typename?: 'VerticalSlider';
  autoScrollEnabled?: Maybe<Scalars['Boolean']>;
  autoScrollSpeed?: Maybe<Scalars['Float']>;
  blockName?: Maybe<Scalars['String']>;
  blockSettings?: Maybe<BlockSettings>;
  blockType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  slides: Array<VerticalSlider_Slides>;
};

export type VerticalSlider_Slides = CardWithBlocks;

export type AllMedia = {
  __typename?: 'allMedia';
  docs?: Maybe<Array<Maybe<Media>>>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPrevPage?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  nextPage?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  pagingCounter?: Maybe<Scalars['Int']>;
  prevPage?: Maybe<Scalars['Int']>;
  totalDocs?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
};

export type ArticleAccess = {
  __typename?: 'articleAccess';
  create?: Maybe<ArticleCreateAccess>;
  delete?: Maybe<ArticleDeleteAccess>;
  fields?: Maybe<ArticleFields>;
  read?: Maybe<ArticleReadAccess>;
  readVersions?: Maybe<ArticleReadVersionsAccess>;
  update?: Maybe<ArticleUpdateAccess>;
};

export type ArticleDocAccess = {
  __typename?: 'articleDocAccess';
  create?: Maybe<ArticleCreateDocAccess>;
  delete?: Maybe<ArticleDeleteDocAccess>;
  fields?: Maybe<ArticleDocAccessFields>;
  read?: Maybe<ArticleReadDocAccess>;
  readVersions?: Maybe<ArticleReadVersionsDocAccess>;
  update?: Maybe<ArticleUpdateDocAccess>;
};

export type CategoryAccess = {
  __typename?: 'categoryAccess';
  create?: Maybe<CategoryCreateAccess>;
  delete?: Maybe<CategoryDeleteAccess>;
  fields?: Maybe<CategoryFields>;
  read?: Maybe<CategoryReadAccess>;
  update?: Maybe<CategoryUpdateAccess>;
};

export type CategoryDocAccess = {
  __typename?: 'categoryDocAccess';
  create?: Maybe<CategoryCreateDocAccess>;
  delete?: Maybe<CategoryDeleteDocAccess>;
  fields?: Maybe<CategoryDocAccessFields>;
  read?: Maybe<CategoryReadDocAccess>;
  update?: Maybe<CategoryUpdateDocAccess>;
};

export type CountArticles = {
  __typename?: 'countArticles';
  totalDocs?: Maybe<Scalars['Int']>;
};

export type CountCategories = {
  __typename?: 'countCategories';
  totalDocs?: Maybe<Scalars['Int']>;
};

export type CountEpcCheckFormSubmissions = {
  __typename?: 'countEpcCheckFormSubmissions';
  totalDocs?: Maybe<Scalars['Int']>;
};

export type CountFormSubmissions = {
  __typename?: 'countFormSubmissions';
  totalDocs?: Maybe<Scalars['Int']>;
};

export type CountForms = {
  __typename?: 'countForms';
  totalDocs?: Maybe<Scalars['Int']>;
};

export type CountLandingPages = {
  __typename?: 'countLandingPages';
  totalDocs?: Maybe<Scalars['Int']>;
};

export type CountLandingTumblers = {
  __typename?: 'countLandingTumblers';
  totalDocs?: Maybe<Scalars['Int']>;
};

export type CountLeadForms = {
  __typename?: 'countLeadForms';
  totalDocs?: Maybe<Scalars['Int']>;
};

export type CountNewsletterSubscribers = {
  __typename?: 'countNewsletterSubscribers';
  totalDocs?: Maybe<Scalars['Int']>;
};

export type CountPages = {
  __typename?: 'countPages';
  totalDocs?: Maybe<Scalars['Int']>;
};

export type CountPayloadLockedDocuments = {
  __typename?: 'countPayloadLockedDocuments';
  totalDocs?: Maybe<Scalars['Int']>;
};

export type CountPayloadPreferences = {
  __typename?: 'countPayloadPreferences';
  totalDocs?: Maybe<Scalars['Int']>;
};

export type CountServices = {
  __typename?: 'countServices';
  totalDocs?: Maybe<Scalars['Int']>;
};

export type CountTags = {
  __typename?: 'countTags';
  totalDocs?: Maybe<Scalars['Int']>;
};

export type CountUsers = {
  __typename?: 'countUsers';
  totalDocs?: Maybe<Scalars['Int']>;
};

export type CountallMedia = {
  __typename?: 'countallMedia';
  totalDocs?: Maybe<Scalars['Int']>;
};

export type Cta_BannerAccess = {
  __typename?: 'cta_bannerAccess';
  fields?: Maybe<CtaBannerFields>;
  read?: Maybe<CtaBannerReadAccess>;
  update?: Maybe<CtaBannerUpdateAccess>;
};

export type Cta_BannerDocAccess = {
  __typename?: 'cta_bannerDocAccess';
  fields?: Maybe<CtaBannerDocAccessFields>;
  read?: Maybe<CtaBannerReadDocAccess>;
  update?: Maybe<CtaBannerUpdateDocAccess>;
};

export type Epc_Check_Form_SubmissionAccess = {
  __typename?: 'epc_check_form_submissionAccess';
  create?: Maybe<EpcCheckFormSubmissionCreateAccess>;
  delete?: Maybe<EpcCheckFormSubmissionDeleteAccess>;
  fields?: Maybe<EpcCheckFormSubmissionFields>;
  read?: Maybe<EpcCheckFormSubmissionReadAccess>;
  update?: Maybe<EpcCheckFormSubmissionUpdateAccess>;
};

export type Epc_Check_Form_SubmissionDocAccess = {
  __typename?: 'epc_check_form_submissionDocAccess';
  create?: Maybe<EpcCheckFormSubmissionCreateDocAccess>;
  delete?: Maybe<EpcCheckFormSubmissionDeleteDocAccess>;
  fields?: Maybe<EpcCheckFormSubmissionDocAccessFields>;
  read?: Maybe<EpcCheckFormSubmissionReadDocAccess>;
  update?: Maybe<EpcCheckFormSubmissionUpdateDocAccess>;
};

export type Footer_MenuAccess = {
  __typename?: 'footer_menuAccess';
  fields?: Maybe<FooterMenuFields>;
  read?: Maybe<FooterMenuReadAccess>;
  update?: Maybe<FooterMenuUpdateAccess>;
};

export type Footer_MenuDocAccess = {
  __typename?: 'footer_menuDocAccess';
  fields?: Maybe<FooterMenuDocAccessFields>;
  read?: Maybe<FooterMenuReadDocAccess>;
  update?: Maybe<FooterMenuUpdateDocAccess>;
};

export type Form_SubmissionsAccess = {
  __typename?: 'form_submissionsAccess';
  create?: Maybe<FormSubmissionsCreateAccess>;
  delete?: Maybe<FormSubmissionsDeleteAccess>;
  fields?: Maybe<FormSubmissionsFields>;
  read?: Maybe<FormSubmissionsReadAccess>;
  update?: Maybe<FormSubmissionsUpdateAccess>;
};

export type Form_SubmissionsDocAccess = {
  __typename?: 'form_submissionsDocAccess';
  create?: Maybe<FormSubmissionsCreateDocAccess>;
  delete?: Maybe<FormSubmissionsDeleteDocAccess>;
  fields?: Maybe<FormSubmissionsDocAccessFields>;
  read?: Maybe<FormSubmissionsReadDocAccess>;
  update?: Maybe<FormSubmissionsUpdateDocAccess>;
};

export type FormsAccess = {
  __typename?: 'formsAccess';
  create?: Maybe<FormsCreateAccess>;
  delete?: Maybe<FormsDeleteAccess>;
  fields?: Maybe<FormsFields>;
  read?: Maybe<FormsReadAccess>;
  update?: Maybe<FormsUpdateAccess>;
};

export type FormsDocAccess = {
  __typename?: 'formsDocAccess';
  create?: Maybe<FormsCreateDocAccess>;
  delete?: Maybe<FormsDeleteDocAccess>;
  fields?: Maybe<FormsDocAccessFields>;
  read?: Maybe<FormsReadDocAccess>;
  update?: Maybe<FormsUpdateDocAccess>;
};

export type Header_MenuAccess = {
  __typename?: 'header_menuAccess';
  fields?: Maybe<HeaderMenuFields>;
  read?: Maybe<HeaderMenuReadAccess>;
  update?: Maybe<HeaderMenuUpdateAccess>;
};

export type Header_MenuDocAccess = {
  __typename?: 'header_menuDocAccess';
  fields?: Maybe<HeaderMenuDocAccessFields>;
  read?: Maybe<HeaderMenuReadDocAccess>;
  update?: Maybe<HeaderMenuUpdateDocAccess>;
};

export type Hidden_BlocksAccess = {
  __typename?: 'hidden_blocksAccess';
  fields?: Maybe<HiddenBlocksFields>;
  read?: Maybe<HiddenBlocksReadAccess>;
  update?: Maybe<HiddenBlocksUpdateAccess>;
};

export type Hidden_BlocksDocAccess = {
  __typename?: 'hidden_blocksDocAccess';
  fields?: Maybe<HiddenBlocksDocAccessFields>;
  read?: Maybe<HiddenBlocksReadDocAccess>;
  update?: Maybe<HiddenBlocksUpdateDocAccess>;
};

export type Landing_PageAccess = {
  __typename?: 'landing_pageAccess';
  create?: Maybe<LandingPageCreateAccess>;
  delete?: Maybe<LandingPageDeleteAccess>;
  fields?: Maybe<LandingPageFields>;
  read?: Maybe<LandingPageReadAccess>;
  readVersions?: Maybe<LandingPageReadVersionsAccess>;
  update?: Maybe<LandingPageUpdateAccess>;
};

export type Landing_PageDocAccess = {
  __typename?: 'landing_pageDocAccess';
  create?: Maybe<LandingPageCreateDocAccess>;
  delete?: Maybe<LandingPageDeleteDocAccess>;
  fields?: Maybe<LandingPageDocAccessFields>;
  read?: Maybe<LandingPageReadDocAccess>;
  readVersions?: Maybe<LandingPageReadVersionsDocAccess>;
  update?: Maybe<LandingPageUpdateDocAccess>;
};

export type Landing_TumblerAccess = {
  __typename?: 'landing_tumblerAccess';
  create?: Maybe<LandingTumblerCreateAccess>;
  delete?: Maybe<LandingTumblerDeleteAccess>;
  fields?: Maybe<LandingTumblerFields>;
  read?: Maybe<LandingTumblerReadAccess>;
  update?: Maybe<LandingTumblerUpdateAccess>;
};

export type Landing_TumblerDocAccess = {
  __typename?: 'landing_tumblerDocAccess';
  create?: Maybe<LandingTumblerCreateDocAccess>;
  delete?: Maybe<LandingTumblerDeleteDocAccess>;
  fields?: Maybe<LandingTumblerDocAccessFields>;
  read?: Maybe<LandingTumblerReadDocAccess>;
  update?: Maybe<LandingTumblerUpdateDocAccess>;
};

export type Lead_FormAccess = {
  __typename?: 'lead_formAccess';
  create?: Maybe<LeadFormCreateAccess>;
  delete?: Maybe<LeadFormDeleteAccess>;
  fields?: Maybe<LeadFormFields>;
  read?: Maybe<LeadFormReadAccess>;
  update?: Maybe<LeadFormUpdateAccess>;
};

export type Lead_FormDocAccess = {
  __typename?: 'lead_formDocAccess';
  create?: Maybe<LeadFormCreateDocAccess>;
  delete?: Maybe<LeadFormDeleteDocAccess>;
  fields?: Maybe<LeadFormDocAccessFields>;
  read?: Maybe<LeadFormReadDocAccess>;
  update?: Maybe<LeadFormUpdateDocAccess>;
};

export type MediaAccess = {
  __typename?: 'mediaAccess';
  create?: Maybe<MediaCreateAccess>;
  delete?: Maybe<MediaDeleteAccess>;
  fields?: Maybe<MediaFields>;
  read?: Maybe<MediaReadAccess>;
  update?: Maybe<MediaUpdateAccess>;
};

export type MediaDocAccess = {
  __typename?: 'mediaDocAccess';
  create?: Maybe<MediaCreateDocAccess>;
  delete?: Maybe<MediaDeleteDocAccess>;
  fields?: Maybe<MediaDocAccessFields>;
  read?: Maybe<MediaReadDocAccess>;
  update?: Maybe<MediaUpdateDocAccess>;
};

export type MutationArticleInput = {
  _status?: InputMaybe<Article__Status_MutationInput>;
  author?: InputMaybe<Scalars['String']>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  excerpt?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  layout?: InputMaybe<Scalars['JSON']>;
  meta?: InputMaybe<MutationArticle_MetaInput>;
  publishedAt?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  timeToRead?: InputMaybe<Scalars['Float']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['String']>;
};

export type MutationArticleUpdateInput = {
  _status?: InputMaybe<ArticleUpdate__Status_MutationInput>;
  author?: InputMaybe<Scalars['String']>;
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  excerpt?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  layout?: InputMaybe<Scalars['JSON']>;
  meta?: InputMaybe<MutationArticleUpdate_MetaInput>;
  publishedAt?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  timeToRead?: InputMaybe<Scalars['Float']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['String']>;
};

export type MutationArticleUpdate_MetaInput = {
  description?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  noIndex?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
};

export type MutationArticle_MetaInput = {
  description?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  noIndex?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
};

export type MutationCategoryInput = {
  createdAt?: InputMaybe<Scalars['String']>;
  description: Scalars['String'];
  featuredCategory?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['String']>;
};

export type MutationCategoryUpdateInput = {
  createdAt?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  featuredCategory?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['String']>;
};

export type MutationCtaBannerInput = {
  buttons?: InputMaybe<Array<InputMaybe<MutationCtaBanner_ButtonsInput>>>;
  createdAt?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  enableTrustWidget?: InputMaybe<Scalars['Boolean']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['String']>;
};

export type MutationCtaBanner_ButtonsInput = {
  buttonType: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  link?: InputMaybe<MutationCtaBanner_Buttons_LinkInput>;
};

export type MutationCtaBanner_Buttons_LinkInput = {
  label: Scalars['String'];
  reference?: InputMaybe<CtaBanner_Buttons_Link_ReferenceRelationshipInput>;
  type: Scalars['String'];
  url?: InputMaybe<Scalars['String']>;
};

export type MutationEpcCheckFormSubmissionInput = {
  address: MutationEpcCheckFormSubmission_AddressInput;
  converted?: InputMaybe<Scalars['Boolean']>;
  convertedLeadId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['String']>;
  currentEpcRating: Scalars['Float'];
  email: Scalars['String'];
  potentialEpcRating: Scalars['Float'];
  recommendations?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
};

export type MutationEpcCheckFormSubmissionUpdateInput = {
  address: MutationEpcCheckFormSubmissionUpdate_AddressInput;
  converted?: InputMaybe<Scalars['Boolean']>;
  convertedLeadId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['String']>;
  currentEpcRating?: InputMaybe<Scalars['Float']>;
  email?: InputMaybe<Scalars['String']>;
  potentialEpcRating?: InputMaybe<Scalars['Float']>;
  recommendations?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
};

export type MutationEpcCheckFormSubmissionUpdate_AddressInput = {
  address1: Scalars['String'];
  address2?: InputMaybe<Scalars['String']>;
  address3?: InputMaybe<Scalars['String']>;
  localAuthorityLabel?: InputMaybe<Scalars['String']>;
  postcode: Scalars['String'];
  posttown: Scalars['String'];
};

export type MutationEpcCheckFormSubmission_AddressInput = {
  address1: Scalars['String'];
  address2?: InputMaybe<Scalars['String']>;
  address3?: InputMaybe<Scalars['String']>;
  localAuthorityLabel?: InputMaybe<Scalars['String']>;
  postcode: Scalars['String'];
  posttown: Scalars['String'];
};

export type MutationFooterMenuInput = {
  createdAt?: InputMaybe<Scalars['String']>;
  menuGroups?: InputMaybe<Array<InputMaybe<MutationFooterMenu_MenuGroupsInput>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
};

export type MutationFooterMenu_MenuGroupsInput = {
  id?: InputMaybe<Scalars['String']>;
  links?: InputMaybe<Array<InputMaybe<MutationFooterMenu_MenuGroups_LinksInput>>>;
  title: Scalars['String'];
};

export type MutationFooterMenu_MenuGroups_LinksInput = {
  id?: InputMaybe<Scalars['String']>;
  link?: InputMaybe<MutationFooterMenu_MenuGroups_Links_LinkInput>;
};

export type MutationFooterMenu_MenuGroups_Links_LinkInput = {
  label: Scalars['String'];
  reference?: InputMaybe<FooterMenu_MenuGroups_Links_Link_ReferenceRelationshipInput>;
  type: Scalars['String'];
  url?: InputMaybe<Scalars['String']>;
};

export type MutationFormInput = {
  confirmationMessage?: InputMaybe<Scalars['JSON']>;
  confirmationType?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['String']>;
  emails?: InputMaybe<Array<InputMaybe<MutationForm_EmailsInput>>>;
  fields?: InputMaybe<Scalars['JSON']>;
  redirect: MutationForm_RedirectInput;
  submitButtonLabel?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['String']>;
};

export type MutationFormSubmissionInput = {
  createdAt?: InputMaybe<Scalars['String']>;
  form?: InputMaybe<Scalars['String']>;
  submissionData?: InputMaybe<Array<InputMaybe<MutationFormSubmission_SubmissionDataInput>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
};

export type MutationFormSubmissionUpdateInput = {
  createdAt?: InputMaybe<Scalars['String']>;
  form?: InputMaybe<Scalars['String']>;
  submissionData?: InputMaybe<Array<InputMaybe<MutationFormSubmissionUpdate_SubmissionDataInput>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
};

export type MutationFormSubmissionUpdate_SubmissionDataInput = {
  field: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  value: Scalars['String'];
};

export type MutationFormSubmission_SubmissionDataInput = {
  field: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  value: Scalars['String'];
};

export type MutationFormUpdateInput = {
  confirmationMessage?: InputMaybe<Scalars['JSON']>;
  confirmationType?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['String']>;
  emails?: InputMaybe<Array<InputMaybe<MutationFormUpdate_EmailsInput>>>;
  fields?: InputMaybe<Scalars['JSON']>;
  redirect: MutationFormUpdate_RedirectInput;
  submitButtonLabel?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['String']>;
};

export type MutationFormUpdate_EmailsInput = {
  bcc?: InputMaybe<Scalars['String']>;
  cc?: InputMaybe<Scalars['String']>;
  emailFrom?: InputMaybe<Scalars['String']>;
  emailTo?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['JSON']>;
  replyTo?: InputMaybe<Scalars['String']>;
  subject: Scalars['String'];
};

export type MutationFormUpdate_RedirectInput = {
  url: Scalars['String'];
};

export type MutationForm_EmailsInput = {
  bcc?: InputMaybe<Scalars['String']>;
  cc?: InputMaybe<Scalars['String']>;
  emailFrom?: InputMaybe<Scalars['String']>;
  emailTo?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['JSON']>;
  replyTo?: InputMaybe<Scalars['String']>;
  subject: Scalars['String'];
};

export type MutationForm_RedirectInput = {
  url: Scalars['String'];
};

export type MutationHeaderMenuInput = {
  createdAt?: InputMaybe<Scalars['String']>;
  links?: InputMaybe<Array<InputMaybe<MutationHeaderMenu_LinksInput>>>;
  updatedAt?: InputMaybe<Scalars['String']>;
};

export type MutationHeaderMenu_LinksInput = {
  id?: InputMaybe<Scalars['String']>;
  link?: InputMaybe<MutationHeaderMenu_Links_LinkInput>;
  subMenu: MutationHeaderMenu_Links_SubMenuInput;
  subMenuEnabled?: InputMaybe<Scalars['Boolean']>;
};

export type MutationHeaderMenu_Links_LinkInput = {
  label: Scalars['String'];
  reference?: InputMaybe<HeaderMenu_Links_Link_ReferenceRelationshipInput>;
  type: Scalars['String'];
  url?: InputMaybe<Scalars['String']>;
};

export type MutationHeaderMenu_Links_SubMenuInput = {
  cta: MutationHeaderMenu_Links_SubMenu_CtaInput;
  ctaEnabled?: InputMaybe<Scalars['Boolean']>;
  links?: InputMaybe<Array<InputMaybe<MutationHeaderMenu_Links_SubMenu_LinksInput>>>;
  title: Scalars['String'];
};

export type MutationHeaderMenu_Links_SubMenu_CtaInput = {
  description?: InputMaybe<Scalars['String']>;
  link?: InputMaybe<MutationHeaderMenu_Links_SubMenu_Cta_LinkInput>;
  tagColor: Scalars['String'];
  tagText: Scalars['String'];
  title: Scalars['String'];
};

export type MutationHeaderMenu_Links_SubMenu_Cta_LinkInput = {
  reference?: InputMaybe<HeaderMenu_Links_SubMenu_Cta_Link_ReferenceRelationshipInput>;
  type: Scalars['String'];
  url?: InputMaybe<Scalars['String']>;
};

export type MutationHeaderMenu_Links_SubMenu_LinksInput = {
  excerpt: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  link?: InputMaybe<MutationHeaderMenu_Links_SubMenu_Links_LinkInput>;
};

export type MutationHeaderMenu_Links_SubMenu_Links_LinkInput = {
  label: Scalars['String'];
  reference?: InputMaybe<HeaderMenu_Links_SubMenu_Links_Link_ReferenceRelationshipInput>;
  type: Scalars['String'];
  url?: InputMaybe<Scalars['String']>;
};

export type MutationHiddenBlockInput = {
  createdAt?: InputMaybe<Scalars['String']>;
  layout?: InputMaybe<MutationHiddenBlock_LayoutInput>;
  updatedAt?: InputMaybe<Scalars['String']>;
};

export type MutationHiddenBlock_LayoutInput = {
  blocks?: InputMaybe<Scalars['JSON']>;
};

export type MutationLandingPageInput = {
  _status?: InputMaybe<LandingPage__Status_MutationInput>;
  createdAt?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['JSON']>;
  header?: InputMaybe<MutationLandingPage_HeaderInput>;
  layout?: InputMaybe<MutationLandingPage_LayoutInput>;
  meta?: InputMaybe<MutationLandingPage_MetaInput>;
  slug?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  titleSettings?: InputMaybe<MutationLandingPage_TitleSettingsInput>;
  updatedAt?: InputMaybe<Scalars['String']>;
};

export type MutationLandingPageUpdateInput = {
  _status?: InputMaybe<LandingPageUpdate__Status_MutationInput>;
  createdAt?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['JSON']>;
  header?: InputMaybe<MutationLandingPageUpdate_HeaderInput>;
  layout?: InputMaybe<MutationLandingPageUpdate_LayoutInput>;
  meta?: InputMaybe<MutationLandingPageUpdate_MetaInput>;
  slug?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  titleSettings?: InputMaybe<MutationLandingPageUpdate_TitleSettingsInput>;
  updatedAt?: InputMaybe<Scalars['String']>;
};

export type MutationLandingPageUpdate_HeaderInput = {
  beforeFeaturedFormContent?: InputMaybe<Scalars['JSON']>;
  featuredForm?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  showRatingWidget?: InputMaybe<Scalars['Boolean']>;
  type: LandingPageUpdate_Header_Type_MutationInput;
  wrapInBackground?: InputMaybe<Scalars['Boolean']>;
};

export type MutationLandingPageUpdate_LayoutInput = {
  blocks?: InputMaybe<Scalars['JSON']>;
};

export type MutationLandingPageUpdate_MetaInput = {
  description?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  noIndex?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
};

export type MutationLandingPageUpdate_TitleSettingsInput = {
  boldEndIndex?: InputMaybe<Scalars['Float']>;
  boldStartIndex?: InputMaybe<Scalars['Float']>;
};

export type MutationLandingPage_HeaderInput = {
  beforeFeaturedFormContent?: InputMaybe<Scalars['JSON']>;
  featuredForm?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  showRatingWidget?: InputMaybe<Scalars['Boolean']>;
  type: LandingPage_Header_Type_MutationInput;
  wrapInBackground?: InputMaybe<Scalars['Boolean']>;
};

export type MutationLandingPage_LayoutInput = {
  blocks?: InputMaybe<Scalars['JSON']>;
};

export type MutationLandingPage_MetaInput = {
  description?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  noIndex?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
};

export type MutationLandingPage_TitleSettingsInput = {
  boldEndIndex?: InputMaybe<Scalars['Float']>;
  boldStartIndex?: InputMaybe<Scalars['Float']>;
};

export type MutationLandingTumblerInput = {
  createdAt?: InputMaybe<Scalars['String']>;
  landingPages?: InputMaybe<Array<InputMaybe<MutationLandingTumbler_LandingPagesInput>>>;
  meta?: InputMaybe<MutationLandingTumbler_MetaInput>;
  selectedLandingPageSlug?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['String']>;
};

export type MutationLandingTumblerUpdateInput = {
  createdAt?: InputMaybe<Scalars['String']>;
  landingPages?: InputMaybe<Array<InputMaybe<MutationLandingTumblerUpdate_LandingPagesInput>>>;
  meta?: InputMaybe<MutationLandingTumblerUpdate_MetaInput>;
  selectedLandingPageSlug?: InputMaybe<Scalars['String']>;
  slug?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['String']>;
};

export type MutationLandingTumblerUpdate_LandingPagesInput = {
  id?: InputMaybe<Scalars['String']>;
  landingPage?: InputMaybe<Scalars['String']>;
  weight: Scalars['Float'];
};

export type MutationLandingTumblerUpdate_MetaInput = {
  description?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  noIndex?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
};

export type MutationLandingTumbler_LandingPagesInput = {
  id?: InputMaybe<Scalars['String']>;
  landingPage?: InputMaybe<Scalars['String']>;
  weight: Scalars['Float'];
};

export type MutationLandingTumbler_MetaInput = {
  description?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  noIndex?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
};

export type MutationLeadFormInput = {
  createdAt?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<MutationLeadForm_MetaInput>;
  slug?: InputMaybe<Scalars['String']>;
  sourceToken?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['String']>;
};

export type MutationLeadFormUpdateInput = {
  createdAt?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<MutationLeadFormUpdate_MetaInput>;
  slug?: InputMaybe<Scalars['String']>;
  sourceToken?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['String']>;
};

export type MutationLeadFormUpdate_MetaInput = {
  description?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  noIndex?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
};

export type MutationLeadForm_MetaInput = {
  description?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  noIndex?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
};

export type MutationMediaInput = {
  alt: Scalars['String'];
  createdAt?: InputMaybe<Scalars['String']>;
  filename?: InputMaybe<Scalars['String']>;
  filesize?: InputMaybe<Scalars['Float']>;
  focalX?: InputMaybe<Scalars['Float']>;
  focalY?: InputMaybe<Scalars['Float']>;
  height?: InputMaybe<Scalars['Float']>;
  mimeType?: InputMaybe<Scalars['String']>;
  sizes?: InputMaybe<MutationMedia_SizesInput>;
  thumbnailURL?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Float']>;
};

export type MutationMediaUpdateInput = {
  alt?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['String']>;
  filename?: InputMaybe<Scalars['String']>;
  filesize?: InputMaybe<Scalars['Float']>;
  focalX?: InputMaybe<Scalars['Float']>;
  focalY?: InputMaybe<Scalars['Float']>;
  height?: InputMaybe<Scalars['Float']>;
  mimeType?: InputMaybe<Scalars['String']>;
  sizes?: InputMaybe<MutationMediaUpdate_SizesInput>;
  thumbnailURL?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Float']>;
};

export type MutationMediaUpdate_SizesInput = {
  card?: InputMaybe<MutationMediaUpdate_Sizes_CardInput>;
  feature?: InputMaybe<MutationMediaUpdate_Sizes_FeatureInput>;
};

export type MutationMediaUpdate_Sizes_CardInput = {
  filename?: InputMaybe<Scalars['String']>;
  filesize?: InputMaybe<Scalars['Float']>;
  height?: InputMaybe<Scalars['Float']>;
  mimeType?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Float']>;
};

export type MutationMediaUpdate_Sizes_FeatureInput = {
  filename?: InputMaybe<Scalars['String']>;
  filesize?: InputMaybe<Scalars['Float']>;
  height?: InputMaybe<Scalars['Float']>;
  mimeType?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Float']>;
};

export type MutationMedia_SizesInput = {
  card?: InputMaybe<MutationMedia_Sizes_CardInput>;
  feature?: InputMaybe<MutationMedia_Sizes_FeatureInput>;
};

export type MutationMedia_Sizes_CardInput = {
  filename?: InputMaybe<Scalars['String']>;
  filesize?: InputMaybe<Scalars['Float']>;
  height?: InputMaybe<Scalars['Float']>;
  mimeType?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Float']>;
};

export type MutationMedia_Sizes_FeatureInput = {
  filename?: InputMaybe<Scalars['String']>;
  filesize?: InputMaybe<Scalars['Float']>;
  height?: InputMaybe<Scalars['Float']>;
  mimeType?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
  width?: InputMaybe<Scalars['Float']>;
};

export type MutationNewsletterSubscriberInput = {
  createdAt?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  syncedAt?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['String']>;
};

export type MutationNewsletterSubscriberUpdateInput = {
  createdAt?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  syncedAt?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['String']>;
};

export type MutationPageInput = {
  _status?: InputMaybe<Page__Status_MutationInput>;
  createdAt?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['JSON']>;
  header?: InputMaybe<MutationPage_HeaderInput>;
  isArticle?: InputMaybe<Scalars['Boolean']>;
  isPlaceholder?: InputMaybe<Scalars['Boolean']>;
  layout?: InputMaybe<MutationPage_LayoutInput>;
  meta?: InputMaybe<MutationPage_MetaInput>;
  slug?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  titleSettings?: InputMaybe<MutationPage_TitleSettingsInput>;
  updatedAt?: InputMaybe<Scalars['String']>;
};

export type MutationPageUpdateInput = {
  _status?: InputMaybe<PageUpdate__Status_MutationInput>;
  createdAt?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['JSON']>;
  header?: InputMaybe<MutationPageUpdate_HeaderInput>;
  isArticle?: InputMaybe<Scalars['Boolean']>;
  isPlaceholder?: InputMaybe<Scalars['Boolean']>;
  layout?: InputMaybe<MutationPageUpdate_LayoutInput>;
  meta?: InputMaybe<MutationPageUpdate_MetaInput>;
  slug?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  titleSettings?: InputMaybe<MutationPageUpdate_TitleSettingsInput>;
  updatedAt?: InputMaybe<Scalars['String']>;
};

export type MutationPageUpdate_HeaderInput = {
  beforeFeaturedFormContent?: InputMaybe<Scalars['JSON']>;
  featuredForm?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  showLookingForForm?: InputMaybe<Scalars['Boolean']>;
  showRatingWidget?: InputMaybe<Scalars['Boolean']>;
  type: PageUpdate_Header_Type_MutationInput;
  wrapInBackground?: InputMaybe<Scalars['Boolean']>;
};

export type MutationPageUpdate_LayoutInput = {
  blocks?: InputMaybe<Scalars['JSON']>;
};

export type MutationPageUpdate_MetaInput = {
  description?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  noIndex?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
};

export type MutationPageUpdate_TitleSettingsInput = {
  boldEndIndex?: InputMaybe<Scalars['Float']>;
  boldStartIndex?: InputMaybe<Scalars['Float']>;
};

export type MutationPage_HeaderInput = {
  beforeFeaturedFormContent?: InputMaybe<Scalars['JSON']>;
  featuredForm?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  showLookingForForm?: InputMaybe<Scalars['Boolean']>;
  showRatingWidget?: InputMaybe<Scalars['Boolean']>;
  type: Page_Header_Type_MutationInput;
  wrapInBackground?: InputMaybe<Scalars['Boolean']>;
};

export type MutationPage_LayoutInput = {
  blocks?: InputMaybe<Scalars['JSON']>;
};

export type MutationPage_MetaInput = {
  description?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  noIndex?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
};

export type MutationPage_TitleSettingsInput = {
  boldEndIndex?: InputMaybe<Scalars['Float']>;
  boldStartIndex?: InputMaybe<Scalars['Float']>;
};

export type MutationPayloadLockedDocumentInput = {
  createdAt?: InputMaybe<Scalars['String']>;
  document?: InputMaybe<PayloadLockedDocument_DocumentRelationshipInput>;
  globalSlug?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<PayloadLockedDocument_UserRelationshipInput>;
};

export type MutationPayloadLockedDocumentUpdateInput = {
  createdAt?: InputMaybe<Scalars['String']>;
  document?: InputMaybe<PayloadLockedDocumentUpdate_DocumentRelationshipInput>;
  globalSlug?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<PayloadLockedDocumentUpdate_UserRelationshipInput>;
};

export type MutationPayloadPreferenceInput = {
  createdAt?: InputMaybe<Scalars['String']>;
  key?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<PayloadPreference_UserRelationshipInput>;
  value?: InputMaybe<Scalars['JSON']>;
};

export type MutationPayloadPreferenceUpdateInput = {
  createdAt?: InputMaybe<Scalars['String']>;
  key?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<PayloadPreferenceUpdate_UserRelationshipInput>;
  value?: InputMaybe<Scalars['JSON']>;
};

export type MutationServiceInput = {
  _status?: InputMaybe<Service__Status_MutationInput>;
  createdAt?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['JSON']>;
  excerpt?: InputMaybe<Scalars['String']>;
  featuredImage?: InputMaybe<Scalars['String']>;
  header?: InputMaybe<MutationService_HeaderInput>;
  isPlaceholder?: InputMaybe<Scalars['Boolean']>;
  layout?: InputMaybe<MutationService_LayoutInput>;
  meta?: InputMaybe<MutationService_MetaInput>;
  shortTitle?: InputMaybe<Scalars['String']>;
  showGetAQuoteSideDrawer?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  titleSettings?: InputMaybe<MutationService_TitleSettingsInput>;
  updatedAt?: InputMaybe<Scalars['String']>;
};

export type MutationServiceUpdateInput = {
  _status?: InputMaybe<ServiceUpdate__Status_MutationInput>;
  createdAt?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['JSON']>;
  excerpt?: InputMaybe<Scalars['String']>;
  featuredImage?: InputMaybe<Scalars['String']>;
  header?: InputMaybe<MutationServiceUpdate_HeaderInput>;
  isPlaceholder?: InputMaybe<Scalars['Boolean']>;
  layout?: InputMaybe<MutationServiceUpdate_LayoutInput>;
  meta?: InputMaybe<MutationServiceUpdate_MetaInput>;
  shortTitle?: InputMaybe<Scalars['String']>;
  showGetAQuoteSideDrawer?: InputMaybe<Scalars['Boolean']>;
  slug?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  titleSettings?: InputMaybe<MutationServiceUpdate_TitleSettingsInput>;
  updatedAt?: InputMaybe<Scalars['String']>;
};

export type MutationServiceUpdate_HeaderInput = {
  beforeFeaturedFormContent?: InputMaybe<Scalars['JSON']>;
  featuredForm?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  showLookingForForm?: InputMaybe<Scalars['Boolean']>;
  showRatingWidget?: InputMaybe<Scalars['Boolean']>;
  type: ServiceUpdate_Header_Type_MutationInput;
};

export type MutationServiceUpdate_LayoutInput = {
  blocks?: InputMaybe<Scalars['JSON']>;
};

export type MutationServiceUpdate_MetaInput = {
  description?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  noIndex?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
};

export type MutationServiceUpdate_TitleSettingsInput = {
  boldEndIndex?: InputMaybe<Scalars['Float']>;
  boldStartIndex?: InputMaybe<Scalars['Float']>;
};

export type MutationService_HeaderInput = {
  beforeFeaturedFormContent?: InputMaybe<Scalars['JSON']>;
  featuredForm?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  showLookingForForm?: InputMaybe<Scalars['Boolean']>;
  showRatingWidget?: InputMaybe<Scalars['Boolean']>;
  type: Service_Header_Type_MutationInput;
};

export type MutationService_LayoutInput = {
  blocks?: InputMaybe<Scalars['JSON']>;
};

export type MutationService_MetaInput = {
  description?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<Scalars['String']>;
  noIndex?: InputMaybe<Scalars['Boolean']>;
  title?: InputMaybe<Scalars['String']>;
};

export type MutationService_TitleSettingsInput = {
  boldEndIndex?: InputMaybe<Scalars['Float']>;
  boldStartIndex?: InputMaybe<Scalars['Float']>;
};

export type MutationSocialMediaInput = {
  createdAt?: InputMaybe<Scalars['String']>;
  facebook?: InputMaybe<Scalars['String']>;
  instagram?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['String']>;
};

export type MutationTagInput = {
  createdAt?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['String']>;
};

export type MutationTagUpdateInput = {
  createdAt?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['String']>;
};

export type MutationUserInput = {
  createdAt?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  fullName?: InputMaybe<Scalars['String']>;
  hash?: InputMaybe<Scalars['String']>;
  lastName: Scalars['String'];
  lockUntil?: InputMaybe<Scalars['String']>;
  loginAttempts?: InputMaybe<Scalars['Float']>;
  password: Scalars['String'];
  resetPasswordExpiration?: InputMaybe<Scalars['String']>;
  resetPasswordToken?: InputMaybe<Scalars['String']>;
  salt?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['String']>;
};

export type MutationUserUpdateInput = {
  createdAt?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  fullName?: InputMaybe<Scalars['String']>;
  hash?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  lockUntil?: InputMaybe<Scalars['String']>;
  loginAttempts?: InputMaybe<Scalars['Float']>;
  password?: InputMaybe<Scalars['String']>;
  resetPasswordExpiration?: InputMaybe<Scalars['String']>;
  resetPasswordToken?: InputMaybe<Scalars['String']>;
  salt?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['String']>;
};

export type Newsletter_SubscriberAccess = {
  __typename?: 'newsletter_subscriberAccess';
  create?: Maybe<NewsletterSubscriberCreateAccess>;
  delete?: Maybe<NewsletterSubscriberDeleteAccess>;
  fields?: Maybe<NewsletterSubscriberFields>;
  read?: Maybe<NewsletterSubscriberReadAccess>;
  update?: Maybe<NewsletterSubscriberUpdateAccess>;
};

export type Newsletter_SubscriberDocAccess = {
  __typename?: 'newsletter_subscriberDocAccess';
  create?: Maybe<NewsletterSubscriberCreateDocAccess>;
  delete?: Maybe<NewsletterSubscriberDeleteDocAccess>;
  fields?: Maybe<NewsletterSubscriberDocAccessFields>;
  read?: Maybe<NewsletterSubscriberReadDocAccess>;
  update?: Maybe<NewsletterSubscriberUpdateDocAccess>;
};

export type PageAccess = {
  __typename?: 'pageAccess';
  create?: Maybe<PageCreateAccess>;
  delete?: Maybe<PageDeleteAccess>;
  fields?: Maybe<PageFields>;
  read?: Maybe<PageReadAccess>;
  readVersions?: Maybe<PageReadVersionsAccess>;
  update?: Maybe<PageUpdateAccess>;
};

export type PageDocAccess = {
  __typename?: 'pageDocAccess';
  create?: Maybe<PageCreateDocAccess>;
  delete?: Maybe<PageDeleteDocAccess>;
  fields?: Maybe<PageDocAccessFields>;
  read?: Maybe<PageReadDocAccess>;
  readVersions?: Maybe<PageReadVersionsDocAccess>;
  update?: Maybe<PageUpdateDocAccess>;
};

export type Payload_Locked_DocumentsAccess = {
  __typename?: 'payload_locked_documentsAccess';
  create?: Maybe<PayloadLockedDocumentsCreateAccess>;
  delete?: Maybe<PayloadLockedDocumentsDeleteAccess>;
  fields?: Maybe<PayloadLockedDocumentsFields>;
  read?: Maybe<PayloadLockedDocumentsReadAccess>;
  update?: Maybe<PayloadLockedDocumentsUpdateAccess>;
};

export type Payload_Locked_DocumentsDocAccess = {
  __typename?: 'payload_locked_documentsDocAccess';
  create?: Maybe<PayloadLockedDocumentsCreateDocAccess>;
  delete?: Maybe<PayloadLockedDocumentsDeleteDocAccess>;
  fields?: Maybe<PayloadLockedDocumentsDocAccessFields>;
  read?: Maybe<PayloadLockedDocumentsReadDocAccess>;
  update?: Maybe<PayloadLockedDocumentsUpdateDocAccess>;
};

export type Payload_PreferencesAccess = {
  __typename?: 'payload_preferencesAccess';
  create?: Maybe<PayloadPreferencesCreateAccess>;
  delete?: Maybe<PayloadPreferencesDeleteAccess>;
  fields?: Maybe<PayloadPreferencesFields>;
  read?: Maybe<PayloadPreferencesReadAccess>;
  update?: Maybe<PayloadPreferencesUpdateAccess>;
};

export type Payload_PreferencesDocAccess = {
  __typename?: 'payload_preferencesDocAccess';
  create?: Maybe<PayloadPreferencesCreateDocAccess>;
  delete?: Maybe<PayloadPreferencesDeleteDocAccess>;
  fields?: Maybe<PayloadPreferencesDocAccessFields>;
  read?: Maybe<PayloadPreferencesReadDocAccess>;
  update?: Maybe<PayloadPreferencesUpdateDocAccess>;
};

export type ServiceAccess = {
  __typename?: 'serviceAccess';
  create?: Maybe<ServiceCreateAccess>;
  delete?: Maybe<ServiceDeleteAccess>;
  fields?: Maybe<ServiceFields>;
  read?: Maybe<ServiceReadAccess>;
  readVersions?: Maybe<ServiceReadVersionsAccess>;
  update?: Maybe<ServiceUpdateAccess>;
};

export type ServiceDocAccess = {
  __typename?: 'serviceDocAccess';
  create?: Maybe<ServiceCreateDocAccess>;
  delete?: Maybe<ServiceDeleteDocAccess>;
  fields?: Maybe<ServiceDocAccessFields>;
  read?: Maybe<ServiceReadDocAccess>;
  readVersions?: Maybe<ServiceReadVersionsDocAccess>;
  update?: Maybe<ServiceUpdateDocAccess>;
};

export type Social_MediaAccess = {
  __typename?: 'social_mediaAccess';
  fields?: Maybe<SocialMediaFields>;
  read?: Maybe<SocialMediaReadAccess>;
  update?: Maybe<SocialMediaUpdateAccess>;
};

export type Social_MediaDocAccess = {
  __typename?: 'social_mediaDocAccess';
  fields?: Maybe<SocialMediaDocAccessFields>;
  read?: Maybe<SocialMediaReadDocAccess>;
  update?: Maybe<SocialMediaUpdateDocAccess>;
};

export type TagAccess = {
  __typename?: 'tagAccess';
  create?: Maybe<TagCreateAccess>;
  delete?: Maybe<TagDeleteAccess>;
  fields?: Maybe<TagFields>;
  read?: Maybe<TagReadAccess>;
  update?: Maybe<TagUpdateAccess>;
};

export type TagDocAccess = {
  __typename?: 'tagDocAccess';
  create?: Maybe<TagCreateDocAccess>;
  delete?: Maybe<TagDeleteDocAccess>;
  fields?: Maybe<TagDocAccessFields>;
  read?: Maybe<TagReadDocAccess>;
  update?: Maybe<TagUpdateDocAccess>;
};

export type UserAccess = {
  __typename?: 'userAccess';
  create?: Maybe<UserCreateAccess>;
  delete?: Maybe<UserDeleteAccess>;
  fields?: Maybe<UserFields>;
  read?: Maybe<UserReadAccess>;
  unlock?: Maybe<UserUnlockAccess>;
  update?: Maybe<UserUpdateAccess>;
};

export type UserDocAccess = {
  __typename?: 'userDocAccess';
  create?: Maybe<UserCreateDocAccess>;
  delete?: Maybe<UserDeleteDocAccess>;
  fields?: Maybe<UserDocAccessFields>;
  read?: Maybe<UserReadDocAccess>;
  unlock?: Maybe<UserUnlockDocAccess>;
  update?: Maybe<UserUpdateDocAccess>;
};

export type UserJwt = {
  __typename?: 'userJWT';
  collection: Scalars['String'];
  email: Scalars['EmailAddress'];
};

export type UserLoginResult = {
  __typename?: 'userLoginResult';
  exp?: Maybe<Scalars['Int']>;
  token?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export type UserMe = {
  __typename?: 'userMe';
  collection?: Maybe<Scalars['String']>;
  exp?: Maybe<Scalars['Int']>;
  strategy?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export type UserRefreshedUser = {
  __typename?: 'userRefreshedUser';
  exp?: Maybe<Scalars['Int']>;
  refreshedToken?: Maybe<Scalars['String']>;
  strategy?: Maybe<Scalars['String']>;
  user?: Maybe<UserJwt>;
};

export type UserResetPassword = {
  __typename?: 'userResetPassword';
  token?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
};

export type VersionsArticle_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type VersionsArticle_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type VersionsArticle_Latest_Operator = {
  equals?: InputMaybe<Scalars['Boolean']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  not_equals?: InputMaybe<Scalars['Boolean']>;
};

export type VersionsArticle_Parent_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  equals?: InputMaybe<Scalars['JSON']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  not_equals?: InputMaybe<Scalars['JSON']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type VersionsArticle_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export enum VersionsArticle_Version___Status_Input {
  Draft = 'draft',
  Published = 'published'
}

export type VersionsArticle_Version___Status_Operator = {
  all?: InputMaybe<Array<InputMaybe<VersionsArticle_Version___Status_Input>>>;
  equals?: InputMaybe<VersionsArticle_Version___Status_Input>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<VersionsArticle_Version___Status_Input>>>;
  not_equals?: InputMaybe<VersionsArticle_Version___Status_Input>;
  not_in?: InputMaybe<Array<InputMaybe<VersionsArticle_Version___Status_Input>>>;
};

export type VersionsArticle_Version__Author_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  equals?: InputMaybe<Scalars['JSON']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  not_equals?: InputMaybe<Scalars['JSON']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type VersionsArticle_Version__Categories_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  equals?: InputMaybe<Scalars['JSON']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  not_equals?: InputMaybe<Scalars['JSON']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type VersionsArticle_Version__CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type VersionsArticle_Version__Excerpt_Operator = {
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
};

export type VersionsArticle_Version__Image_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  equals?: InputMaybe<Scalars['JSON']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  not_equals?: InputMaybe<Scalars['JSON']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type VersionsArticle_Version__Meta__Description_Operator = {
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
};

export type VersionsArticle_Version__Meta__Image_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  equals?: InputMaybe<Scalars['JSON']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  not_equals?: InputMaybe<Scalars['JSON']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type VersionsArticle_Version__Meta__NoIndex_Operator = {
  equals?: InputMaybe<Scalars['Boolean']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  not_equals?: InputMaybe<Scalars['Boolean']>;
};

export type VersionsArticle_Version__Meta__Title_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type VersionsArticle_Version__PublishedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type VersionsArticle_Version__Slug_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type VersionsArticle_Version__Tags_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  equals?: InputMaybe<Scalars['JSON']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  not_equals?: InputMaybe<Scalars['JSON']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type VersionsArticle_Version__TimeToRead_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type VersionsArticle_Version__Title_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type VersionsArticle_Version__UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type VersionsArticle_Where = {
  AND?: InputMaybe<Array<InputMaybe<VersionsArticle_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<VersionsArticle_Where_Or>>>;
  createdAt?: InputMaybe<VersionsArticle_CreatedAt_Operator>;
  id?: InputMaybe<VersionsArticle_Id_Operator>;
  latest?: InputMaybe<VersionsArticle_Latest_Operator>;
  parent?: InputMaybe<VersionsArticle_Parent_Operator>;
  updatedAt?: InputMaybe<VersionsArticle_UpdatedAt_Operator>;
  version___status?: InputMaybe<VersionsArticle_Version___Status_Operator>;
  version__author?: InputMaybe<VersionsArticle_Version__Author_Operator>;
  version__categories?: InputMaybe<VersionsArticle_Version__Categories_Operator>;
  version__createdAt?: InputMaybe<VersionsArticle_Version__CreatedAt_Operator>;
  version__excerpt?: InputMaybe<VersionsArticle_Version__Excerpt_Operator>;
  version__image?: InputMaybe<VersionsArticle_Version__Image_Operator>;
  version__meta__description?: InputMaybe<VersionsArticle_Version__Meta__Description_Operator>;
  version__meta__image?: InputMaybe<VersionsArticle_Version__Meta__Image_Operator>;
  version__meta__noIndex?: InputMaybe<VersionsArticle_Version__Meta__NoIndex_Operator>;
  version__meta__title?: InputMaybe<VersionsArticle_Version__Meta__Title_Operator>;
  version__publishedAt?: InputMaybe<VersionsArticle_Version__PublishedAt_Operator>;
  version__slug?: InputMaybe<VersionsArticle_Version__Slug_Operator>;
  version__tags?: InputMaybe<VersionsArticle_Version__Tags_Operator>;
  version__timeToRead?: InputMaybe<VersionsArticle_Version__TimeToRead_Operator>;
  version__title?: InputMaybe<VersionsArticle_Version__Title_Operator>;
  version__updatedAt?: InputMaybe<VersionsArticle_Version__UpdatedAt_Operator>;
};

export type VersionsArticle_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<VersionsArticle_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<VersionsArticle_Where_Or>>>;
  createdAt?: InputMaybe<VersionsArticle_CreatedAt_Operator>;
  id?: InputMaybe<VersionsArticle_Id_Operator>;
  latest?: InputMaybe<VersionsArticle_Latest_Operator>;
  parent?: InputMaybe<VersionsArticle_Parent_Operator>;
  updatedAt?: InputMaybe<VersionsArticle_UpdatedAt_Operator>;
  version___status?: InputMaybe<VersionsArticle_Version___Status_Operator>;
  version__author?: InputMaybe<VersionsArticle_Version__Author_Operator>;
  version__categories?: InputMaybe<VersionsArticle_Version__Categories_Operator>;
  version__createdAt?: InputMaybe<VersionsArticle_Version__CreatedAt_Operator>;
  version__excerpt?: InputMaybe<VersionsArticle_Version__Excerpt_Operator>;
  version__image?: InputMaybe<VersionsArticle_Version__Image_Operator>;
  version__meta__description?: InputMaybe<VersionsArticle_Version__Meta__Description_Operator>;
  version__meta__image?: InputMaybe<VersionsArticle_Version__Meta__Image_Operator>;
  version__meta__noIndex?: InputMaybe<VersionsArticle_Version__Meta__NoIndex_Operator>;
  version__meta__title?: InputMaybe<VersionsArticle_Version__Meta__Title_Operator>;
  version__publishedAt?: InputMaybe<VersionsArticle_Version__PublishedAt_Operator>;
  version__slug?: InputMaybe<VersionsArticle_Version__Slug_Operator>;
  version__tags?: InputMaybe<VersionsArticle_Version__Tags_Operator>;
  version__timeToRead?: InputMaybe<VersionsArticle_Version__TimeToRead_Operator>;
  version__title?: InputMaybe<VersionsArticle_Version__Title_Operator>;
  version__updatedAt?: InputMaybe<VersionsArticle_Version__UpdatedAt_Operator>;
};

export type VersionsArticle_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<VersionsArticle_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<VersionsArticle_Where_Or>>>;
  createdAt?: InputMaybe<VersionsArticle_CreatedAt_Operator>;
  id?: InputMaybe<VersionsArticle_Id_Operator>;
  latest?: InputMaybe<VersionsArticle_Latest_Operator>;
  parent?: InputMaybe<VersionsArticle_Parent_Operator>;
  updatedAt?: InputMaybe<VersionsArticle_UpdatedAt_Operator>;
  version___status?: InputMaybe<VersionsArticle_Version___Status_Operator>;
  version__author?: InputMaybe<VersionsArticle_Version__Author_Operator>;
  version__categories?: InputMaybe<VersionsArticle_Version__Categories_Operator>;
  version__createdAt?: InputMaybe<VersionsArticle_Version__CreatedAt_Operator>;
  version__excerpt?: InputMaybe<VersionsArticle_Version__Excerpt_Operator>;
  version__image?: InputMaybe<VersionsArticle_Version__Image_Operator>;
  version__meta__description?: InputMaybe<VersionsArticle_Version__Meta__Description_Operator>;
  version__meta__image?: InputMaybe<VersionsArticle_Version__Meta__Image_Operator>;
  version__meta__noIndex?: InputMaybe<VersionsArticle_Version__Meta__NoIndex_Operator>;
  version__meta__title?: InputMaybe<VersionsArticle_Version__Meta__Title_Operator>;
  version__publishedAt?: InputMaybe<VersionsArticle_Version__PublishedAt_Operator>;
  version__slug?: InputMaybe<VersionsArticle_Version__Slug_Operator>;
  version__tags?: InputMaybe<VersionsArticle_Version__Tags_Operator>;
  version__timeToRead?: InputMaybe<VersionsArticle_Version__TimeToRead_Operator>;
  version__title?: InputMaybe<VersionsArticle_Version__Title_Operator>;
  version__updatedAt?: InputMaybe<VersionsArticle_Version__UpdatedAt_Operator>;
};

export type VersionsArticles = {
  __typename?: 'versionsArticles';
  docs?: Maybe<Array<Maybe<ArticleVersion>>>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPrevPage?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  nextPage?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  pagingCounter?: Maybe<Scalars['Int']>;
  prevPage?: Maybe<Scalars['Int']>;
  totalDocs?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
};

export type VersionsLandingPage_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type VersionsLandingPage_Header__BeforeFeaturedFormContent_Operator = {
  contains?: InputMaybe<Scalars['JSON']>;
  equals?: InputMaybe<Scalars['JSON']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  like?: InputMaybe<Scalars['JSON']>;
  not_equals?: InputMaybe<Scalars['JSON']>;
};

export type VersionsLandingPage_Header__FeaturedForm_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  equals?: InputMaybe<Scalars['JSON']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  not_equals?: InputMaybe<Scalars['JSON']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type VersionsLandingPage_Header__Image_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  equals?: InputMaybe<Scalars['JSON']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  not_equals?: InputMaybe<Scalars['JSON']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type VersionsLandingPage_Header__ShowRatingWidget_Operator = {
  equals?: InputMaybe<Scalars['Boolean']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  not_equals?: InputMaybe<Scalars['Boolean']>;
};

export enum VersionsLandingPage_Header__Type_Input {
  Default = 'default',
  FeaturedForm = 'featuredForm',
  FeaturedImage = 'featuredImage'
}

export type VersionsLandingPage_Header__Type_Operator = {
  all?: InputMaybe<Array<InputMaybe<VersionsLandingPage_Header__Type_Input>>>;
  equals?: InputMaybe<VersionsLandingPage_Header__Type_Input>;
  in?: InputMaybe<Array<InputMaybe<VersionsLandingPage_Header__Type_Input>>>;
  not_equals?: InputMaybe<VersionsLandingPage_Header__Type_Input>;
  not_in?: InputMaybe<Array<InputMaybe<VersionsLandingPage_Header__Type_Input>>>;
};

export type VersionsLandingPage_Header__WrapInBackground_Operator = {
  equals?: InputMaybe<Scalars['Boolean']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  not_equals?: InputMaybe<Scalars['Boolean']>;
};

export type VersionsLandingPage_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type VersionsLandingPage_Latest_Operator = {
  equals?: InputMaybe<Scalars['Boolean']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  not_equals?: InputMaybe<Scalars['Boolean']>;
};

export type VersionsLandingPage_Parent_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  equals?: InputMaybe<Scalars['JSON']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  not_equals?: InputMaybe<Scalars['JSON']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type VersionsLandingPage_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export enum VersionsLandingPage_Version___Status_Input {
  Draft = 'draft',
  Published = 'published'
}

export type VersionsLandingPage_Version___Status_Operator = {
  all?: InputMaybe<Array<InputMaybe<VersionsLandingPage_Version___Status_Input>>>;
  equals?: InputMaybe<VersionsLandingPage_Version___Status_Input>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<VersionsLandingPage_Version___Status_Input>>>;
  not_equals?: InputMaybe<VersionsLandingPage_Version___Status_Input>;
  not_in?: InputMaybe<Array<InputMaybe<VersionsLandingPage_Version___Status_Input>>>;
};

export type VersionsLandingPage_Version__CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type VersionsLandingPage_Version__Description_Operator = {
  contains?: InputMaybe<Scalars['JSON']>;
  equals?: InputMaybe<Scalars['JSON']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  like?: InputMaybe<Scalars['JSON']>;
  not_equals?: InputMaybe<Scalars['JSON']>;
};

export type VersionsLandingPage_Version__Meta__Description_Operator = {
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
};

export type VersionsLandingPage_Version__Meta__Image_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  equals?: InputMaybe<Scalars['JSON']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  not_equals?: InputMaybe<Scalars['JSON']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type VersionsLandingPage_Version__Meta__NoIndex_Operator = {
  equals?: InputMaybe<Scalars['Boolean']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  not_equals?: InputMaybe<Scalars['Boolean']>;
};

export type VersionsLandingPage_Version__Meta__Title_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type VersionsLandingPage_Version__Slug_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type VersionsLandingPage_Version__TitleSettings__BoldEndIndex_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type VersionsLandingPage_Version__TitleSettings__BoldStartIndex_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type VersionsLandingPage_Version__Title_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type VersionsLandingPage_Version__UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type VersionsLandingPage_Where = {
  AND?: InputMaybe<Array<InputMaybe<VersionsLandingPage_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<VersionsLandingPage_Where_Or>>>;
  createdAt?: InputMaybe<VersionsLandingPage_CreatedAt_Operator>;
  header__beforeFeaturedFormContent?: InputMaybe<VersionsLandingPage_Header__BeforeFeaturedFormContent_Operator>;
  header__featuredForm?: InputMaybe<VersionsLandingPage_Header__FeaturedForm_Operator>;
  header__image?: InputMaybe<VersionsLandingPage_Header__Image_Operator>;
  header__showRatingWidget?: InputMaybe<VersionsLandingPage_Header__ShowRatingWidget_Operator>;
  header__type?: InputMaybe<VersionsLandingPage_Header__Type_Operator>;
  header__wrapInBackground?: InputMaybe<VersionsLandingPage_Header__WrapInBackground_Operator>;
  id?: InputMaybe<VersionsLandingPage_Id_Operator>;
  latest?: InputMaybe<VersionsLandingPage_Latest_Operator>;
  parent?: InputMaybe<VersionsLandingPage_Parent_Operator>;
  updatedAt?: InputMaybe<VersionsLandingPage_UpdatedAt_Operator>;
  version___status?: InputMaybe<VersionsLandingPage_Version___Status_Operator>;
  version__createdAt?: InputMaybe<VersionsLandingPage_Version__CreatedAt_Operator>;
  version__description?: InputMaybe<VersionsLandingPage_Version__Description_Operator>;
  version__meta__description?: InputMaybe<VersionsLandingPage_Version__Meta__Description_Operator>;
  version__meta__image?: InputMaybe<VersionsLandingPage_Version__Meta__Image_Operator>;
  version__meta__noIndex?: InputMaybe<VersionsLandingPage_Version__Meta__NoIndex_Operator>;
  version__meta__title?: InputMaybe<VersionsLandingPage_Version__Meta__Title_Operator>;
  version__slug?: InputMaybe<VersionsLandingPage_Version__Slug_Operator>;
  version__title?: InputMaybe<VersionsLandingPage_Version__Title_Operator>;
  version__titleSettings__boldEndIndex?: InputMaybe<VersionsLandingPage_Version__TitleSettings__BoldEndIndex_Operator>;
  version__titleSettings__boldStartIndex?: InputMaybe<VersionsLandingPage_Version__TitleSettings__BoldStartIndex_Operator>;
  version__updatedAt?: InputMaybe<VersionsLandingPage_Version__UpdatedAt_Operator>;
};

export type VersionsLandingPage_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<VersionsLandingPage_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<VersionsLandingPage_Where_Or>>>;
  createdAt?: InputMaybe<VersionsLandingPage_CreatedAt_Operator>;
  header__beforeFeaturedFormContent?: InputMaybe<VersionsLandingPage_Header__BeforeFeaturedFormContent_Operator>;
  header__featuredForm?: InputMaybe<VersionsLandingPage_Header__FeaturedForm_Operator>;
  header__image?: InputMaybe<VersionsLandingPage_Header__Image_Operator>;
  header__showRatingWidget?: InputMaybe<VersionsLandingPage_Header__ShowRatingWidget_Operator>;
  header__type?: InputMaybe<VersionsLandingPage_Header__Type_Operator>;
  header__wrapInBackground?: InputMaybe<VersionsLandingPage_Header__WrapInBackground_Operator>;
  id?: InputMaybe<VersionsLandingPage_Id_Operator>;
  latest?: InputMaybe<VersionsLandingPage_Latest_Operator>;
  parent?: InputMaybe<VersionsLandingPage_Parent_Operator>;
  updatedAt?: InputMaybe<VersionsLandingPage_UpdatedAt_Operator>;
  version___status?: InputMaybe<VersionsLandingPage_Version___Status_Operator>;
  version__createdAt?: InputMaybe<VersionsLandingPage_Version__CreatedAt_Operator>;
  version__description?: InputMaybe<VersionsLandingPage_Version__Description_Operator>;
  version__meta__description?: InputMaybe<VersionsLandingPage_Version__Meta__Description_Operator>;
  version__meta__image?: InputMaybe<VersionsLandingPage_Version__Meta__Image_Operator>;
  version__meta__noIndex?: InputMaybe<VersionsLandingPage_Version__Meta__NoIndex_Operator>;
  version__meta__title?: InputMaybe<VersionsLandingPage_Version__Meta__Title_Operator>;
  version__slug?: InputMaybe<VersionsLandingPage_Version__Slug_Operator>;
  version__title?: InputMaybe<VersionsLandingPage_Version__Title_Operator>;
  version__titleSettings__boldEndIndex?: InputMaybe<VersionsLandingPage_Version__TitleSettings__BoldEndIndex_Operator>;
  version__titleSettings__boldStartIndex?: InputMaybe<VersionsLandingPage_Version__TitleSettings__BoldStartIndex_Operator>;
  version__updatedAt?: InputMaybe<VersionsLandingPage_Version__UpdatedAt_Operator>;
};

export type VersionsLandingPage_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<VersionsLandingPage_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<VersionsLandingPage_Where_Or>>>;
  createdAt?: InputMaybe<VersionsLandingPage_CreatedAt_Operator>;
  header__beforeFeaturedFormContent?: InputMaybe<VersionsLandingPage_Header__BeforeFeaturedFormContent_Operator>;
  header__featuredForm?: InputMaybe<VersionsLandingPage_Header__FeaturedForm_Operator>;
  header__image?: InputMaybe<VersionsLandingPage_Header__Image_Operator>;
  header__showRatingWidget?: InputMaybe<VersionsLandingPage_Header__ShowRatingWidget_Operator>;
  header__type?: InputMaybe<VersionsLandingPage_Header__Type_Operator>;
  header__wrapInBackground?: InputMaybe<VersionsLandingPage_Header__WrapInBackground_Operator>;
  id?: InputMaybe<VersionsLandingPage_Id_Operator>;
  latest?: InputMaybe<VersionsLandingPage_Latest_Operator>;
  parent?: InputMaybe<VersionsLandingPage_Parent_Operator>;
  updatedAt?: InputMaybe<VersionsLandingPage_UpdatedAt_Operator>;
  version___status?: InputMaybe<VersionsLandingPage_Version___Status_Operator>;
  version__createdAt?: InputMaybe<VersionsLandingPage_Version__CreatedAt_Operator>;
  version__description?: InputMaybe<VersionsLandingPage_Version__Description_Operator>;
  version__meta__description?: InputMaybe<VersionsLandingPage_Version__Meta__Description_Operator>;
  version__meta__image?: InputMaybe<VersionsLandingPage_Version__Meta__Image_Operator>;
  version__meta__noIndex?: InputMaybe<VersionsLandingPage_Version__Meta__NoIndex_Operator>;
  version__meta__title?: InputMaybe<VersionsLandingPage_Version__Meta__Title_Operator>;
  version__slug?: InputMaybe<VersionsLandingPage_Version__Slug_Operator>;
  version__title?: InputMaybe<VersionsLandingPage_Version__Title_Operator>;
  version__titleSettings__boldEndIndex?: InputMaybe<VersionsLandingPage_Version__TitleSettings__BoldEndIndex_Operator>;
  version__titleSettings__boldStartIndex?: InputMaybe<VersionsLandingPage_Version__TitleSettings__BoldStartIndex_Operator>;
  version__updatedAt?: InputMaybe<VersionsLandingPage_Version__UpdatedAt_Operator>;
};

export type VersionsLandingPages = {
  __typename?: 'versionsLandingPages';
  docs?: Maybe<Array<Maybe<LandingPageVersion>>>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPrevPage?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  nextPage?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  pagingCounter?: Maybe<Scalars['Int']>;
  prevPage?: Maybe<Scalars['Int']>;
  totalDocs?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
};

export type VersionsPage_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type VersionsPage_Header__BeforeFeaturedFormContent_Operator = {
  contains?: InputMaybe<Scalars['JSON']>;
  equals?: InputMaybe<Scalars['JSON']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  like?: InputMaybe<Scalars['JSON']>;
  not_equals?: InputMaybe<Scalars['JSON']>;
};

export type VersionsPage_Header__FeaturedForm_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  equals?: InputMaybe<Scalars['JSON']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  not_equals?: InputMaybe<Scalars['JSON']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type VersionsPage_Header__Image_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  equals?: InputMaybe<Scalars['JSON']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  not_equals?: InputMaybe<Scalars['JSON']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type VersionsPage_Header__ShowLookingForForm_Operator = {
  equals?: InputMaybe<Scalars['Boolean']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  not_equals?: InputMaybe<Scalars['Boolean']>;
};

export type VersionsPage_Header__ShowRatingWidget_Operator = {
  equals?: InputMaybe<Scalars['Boolean']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  not_equals?: InputMaybe<Scalars['Boolean']>;
};

export enum VersionsPage_Header__Type_Input {
  Default = 'default',
  FeaturedForm = 'featuredForm',
  FeaturedImage = 'featuredImage',
  HomeAnimated = 'homeAnimated'
}

export type VersionsPage_Header__Type_Operator = {
  all?: InputMaybe<Array<InputMaybe<VersionsPage_Header__Type_Input>>>;
  equals?: InputMaybe<VersionsPage_Header__Type_Input>;
  in?: InputMaybe<Array<InputMaybe<VersionsPage_Header__Type_Input>>>;
  not_equals?: InputMaybe<VersionsPage_Header__Type_Input>;
  not_in?: InputMaybe<Array<InputMaybe<VersionsPage_Header__Type_Input>>>;
};

export type VersionsPage_Header__WrapInBackground_Operator = {
  equals?: InputMaybe<Scalars['Boolean']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  not_equals?: InputMaybe<Scalars['Boolean']>;
};

export type VersionsPage_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type VersionsPage_Latest_Operator = {
  equals?: InputMaybe<Scalars['Boolean']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  not_equals?: InputMaybe<Scalars['Boolean']>;
};

export type VersionsPage_Parent_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  equals?: InputMaybe<Scalars['JSON']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  not_equals?: InputMaybe<Scalars['JSON']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type VersionsPage_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export enum VersionsPage_Version___Status_Input {
  Draft = 'draft',
  Published = 'published'
}

export type VersionsPage_Version___Status_Operator = {
  all?: InputMaybe<Array<InputMaybe<VersionsPage_Version___Status_Input>>>;
  equals?: InputMaybe<VersionsPage_Version___Status_Input>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<VersionsPage_Version___Status_Input>>>;
  not_equals?: InputMaybe<VersionsPage_Version___Status_Input>;
  not_in?: InputMaybe<Array<InputMaybe<VersionsPage_Version___Status_Input>>>;
};

export type VersionsPage_Version__CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type VersionsPage_Version__Description_Operator = {
  contains?: InputMaybe<Scalars['JSON']>;
  equals?: InputMaybe<Scalars['JSON']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  like?: InputMaybe<Scalars['JSON']>;
  not_equals?: InputMaybe<Scalars['JSON']>;
};

export type VersionsPage_Version__IsArticle_Operator = {
  equals?: InputMaybe<Scalars['Boolean']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  not_equals?: InputMaybe<Scalars['Boolean']>;
};

export type VersionsPage_Version__IsPlaceholder_Operator = {
  equals?: InputMaybe<Scalars['Boolean']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  not_equals?: InputMaybe<Scalars['Boolean']>;
};

export type VersionsPage_Version__Meta__Description_Operator = {
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
};

export type VersionsPage_Version__Meta__Image_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  equals?: InputMaybe<Scalars['JSON']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  not_equals?: InputMaybe<Scalars['JSON']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type VersionsPage_Version__Meta__NoIndex_Operator = {
  equals?: InputMaybe<Scalars['Boolean']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  not_equals?: InputMaybe<Scalars['Boolean']>;
};

export type VersionsPage_Version__Meta__Title_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type VersionsPage_Version__Slug_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type VersionsPage_Version__TitleSettings__BoldEndIndex_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type VersionsPage_Version__TitleSettings__BoldStartIndex_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type VersionsPage_Version__Title_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type VersionsPage_Version__UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type VersionsPage_Where = {
  AND?: InputMaybe<Array<InputMaybe<VersionsPage_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<VersionsPage_Where_Or>>>;
  createdAt?: InputMaybe<VersionsPage_CreatedAt_Operator>;
  header__beforeFeaturedFormContent?: InputMaybe<VersionsPage_Header__BeforeFeaturedFormContent_Operator>;
  header__featuredForm?: InputMaybe<VersionsPage_Header__FeaturedForm_Operator>;
  header__image?: InputMaybe<VersionsPage_Header__Image_Operator>;
  header__showLookingForForm?: InputMaybe<VersionsPage_Header__ShowLookingForForm_Operator>;
  header__showRatingWidget?: InputMaybe<VersionsPage_Header__ShowRatingWidget_Operator>;
  header__type?: InputMaybe<VersionsPage_Header__Type_Operator>;
  header__wrapInBackground?: InputMaybe<VersionsPage_Header__WrapInBackground_Operator>;
  id?: InputMaybe<VersionsPage_Id_Operator>;
  latest?: InputMaybe<VersionsPage_Latest_Operator>;
  parent?: InputMaybe<VersionsPage_Parent_Operator>;
  updatedAt?: InputMaybe<VersionsPage_UpdatedAt_Operator>;
  version___status?: InputMaybe<VersionsPage_Version___Status_Operator>;
  version__createdAt?: InputMaybe<VersionsPage_Version__CreatedAt_Operator>;
  version__description?: InputMaybe<VersionsPage_Version__Description_Operator>;
  version__isArticle?: InputMaybe<VersionsPage_Version__IsArticle_Operator>;
  version__isPlaceholder?: InputMaybe<VersionsPage_Version__IsPlaceholder_Operator>;
  version__meta__description?: InputMaybe<VersionsPage_Version__Meta__Description_Operator>;
  version__meta__image?: InputMaybe<VersionsPage_Version__Meta__Image_Operator>;
  version__meta__noIndex?: InputMaybe<VersionsPage_Version__Meta__NoIndex_Operator>;
  version__meta__title?: InputMaybe<VersionsPage_Version__Meta__Title_Operator>;
  version__slug?: InputMaybe<VersionsPage_Version__Slug_Operator>;
  version__title?: InputMaybe<VersionsPage_Version__Title_Operator>;
  version__titleSettings__boldEndIndex?: InputMaybe<VersionsPage_Version__TitleSettings__BoldEndIndex_Operator>;
  version__titleSettings__boldStartIndex?: InputMaybe<VersionsPage_Version__TitleSettings__BoldStartIndex_Operator>;
  version__updatedAt?: InputMaybe<VersionsPage_Version__UpdatedAt_Operator>;
};

export type VersionsPage_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<VersionsPage_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<VersionsPage_Where_Or>>>;
  createdAt?: InputMaybe<VersionsPage_CreatedAt_Operator>;
  header__beforeFeaturedFormContent?: InputMaybe<VersionsPage_Header__BeforeFeaturedFormContent_Operator>;
  header__featuredForm?: InputMaybe<VersionsPage_Header__FeaturedForm_Operator>;
  header__image?: InputMaybe<VersionsPage_Header__Image_Operator>;
  header__showLookingForForm?: InputMaybe<VersionsPage_Header__ShowLookingForForm_Operator>;
  header__showRatingWidget?: InputMaybe<VersionsPage_Header__ShowRatingWidget_Operator>;
  header__type?: InputMaybe<VersionsPage_Header__Type_Operator>;
  header__wrapInBackground?: InputMaybe<VersionsPage_Header__WrapInBackground_Operator>;
  id?: InputMaybe<VersionsPage_Id_Operator>;
  latest?: InputMaybe<VersionsPage_Latest_Operator>;
  parent?: InputMaybe<VersionsPage_Parent_Operator>;
  updatedAt?: InputMaybe<VersionsPage_UpdatedAt_Operator>;
  version___status?: InputMaybe<VersionsPage_Version___Status_Operator>;
  version__createdAt?: InputMaybe<VersionsPage_Version__CreatedAt_Operator>;
  version__description?: InputMaybe<VersionsPage_Version__Description_Operator>;
  version__isArticle?: InputMaybe<VersionsPage_Version__IsArticle_Operator>;
  version__isPlaceholder?: InputMaybe<VersionsPage_Version__IsPlaceholder_Operator>;
  version__meta__description?: InputMaybe<VersionsPage_Version__Meta__Description_Operator>;
  version__meta__image?: InputMaybe<VersionsPage_Version__Meta__Image_Operator>;
  version__meta__noIndex?: InputMaybe<VersionsPage_Version__Meta__NoIndex_Operator>;
  version__meta__title?: InputMaybe<VersionsPage_Version__Meta__Title_Operator>;
  version__slug?: InputMaybe<VersionsPage_Version__Slug_Operator>;
  version__title?: InputMaybe<VersionsPage_Version__Title_Operator>;
  version__titleSettings__boldEndIndex?: InputMaybe<VersionsPage_Version__TitleSettings__BoldEndIndex_Operator>;
  version__titleSettings__boldStartIndex?: InputMaybe<VersionsPage_Version__TitleSettings__BoldStartIndex_Operator>;
  version__updatedAt?: InputMaybe<VersionsPage_Version__UpdatedAt_Operator>;
};

export type VersionsPage_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<VersionsPage_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<VersionsPage_Where_Or>>>;
  createdAt?: InputMaybe<VersionsPage_CreatedAt_Operator>;
  header__beforeFeaturedFormContent?: InputMaybe<VersionsPage_Header__BeforeFeaturedFormContent_Operator>;
  header__featuredForm?: InputMaybe<VersionsPage_Header__FeaturedForm_Operator>;
  header__image?: InputMaybe<VersionsPage_Header__Image_Operator>;
  header__showLookingForForm?: InputMaybe<VersionsPage_Header__ShowLookingForForm_Operator>;
  header__showRatingWidget?: InputMaybe<VersionsPage_Header__ShowRatingWidget_Operator>;
  header__type?: InputMaybe<VersionsPage_Header__Type_Operator>;
  header__wrapInBackground?: InputMaybe<VersionsPage_Header__WrapInBackground_Operator>;
  id?: InputMaybe<VersionsPage_Id_Operator>;
  latest?: InputMaybe<VersionsPage_Latest_Operator>;
  parent?: InputMaybe<VersionsPage_Parent_Operator>;
  updatedAt?: InputMaybe<VersionsPage_UpdatedAt_Operator>;
  version___status?: InputMaybe<VersionsPage_Version___Status_Operator>;
  version__createdAt?: InputMaybe<VersionsPage_Version__CreatedAt_Operator>;
  version__description?: InputMaybe<VersionsPage_Version__Description_Operator>;
  version__isArticle?: InputMaybe<VersionsPage_Version__IsArticle_Operator>;
  version__isPlaceholder?: InputMaybe<VersionsPage_Version__IsPlaceholder_Operator>;
  version__meta__description?: InputMaybe<VersionsPage_Version__Meta__Description_Operator>;
  version__meta__image?: InputMaybe<VersionsPage_Version__Meta__Image_Operator>;
  version__meta__noIndex?: InputMaybe<VersionsPage_Version__Meta__NoIndex_Operator>;
  version__meta__title?: InputMaybe<VersionsPage_Version__Meta__Title_Operator>;
  version__slug?: InputMaybe<VersionsPage_Version__Slug_Operator>;
  version__title?: InputMaybe<VersionsPage_Version__Title_Operator>;
  version__titleSettings__boldEndIndex?: InputMaybe<VersionsPage_Version__TitleSettings__BoldEndIndex_Operator>;
  version__titleSettings__boldStartIndex?: InputMaybe<VersionsPage_Version__TitleSettings__BoldStartIndex_Operator>;
  version__updatedAt?: InputMaybe<VersionsPage_Version__UpdatedAt_Operator>;
};

export type VersionsPages = {
  __typename?: 'versionsPages';
  docs?: Maybe<Array<Maybe<PageVersion>>>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPrevPage?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  nextPage?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  pagingCounter?: Maybe<Scalars['Int']>;
  prevPage?: Maybe<Scalars['Int']>;
  totalDocs?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
};

export type VersionsService_CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type VersionsService_Header__BeforeFeaturedFormContent_Operator = {
  contains?: InputMaybe<Scalars['JSON']>;
  equals?: InputMaybe<Scalars['JSON']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  like?: InputMaybe<Scalars['JSON']>;
  not_equals?: InputMaybe<Scalars['JSON']>;
};

export type VersionsService_Header__FeaturedForm_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  equals?: InputMaybe<Scalars['JSON']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  not_equals?: InputMaybe<Scalars['JSON']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type VersionsService_Header__Image_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  equals?: InputMaybe<Scalars['JSON']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  not_equals?: InputMaybe<Scalars['JSON']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type VersionsService_Header__ShowLookingForForm_Operator = {
  equals?: InputMaybe<Scalars['Boolean']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  not_equals?: InputMaybe<Scalars['Boolean']>;
};

export type VersionsService_Header__ShowRatingWidget_Operator = {
  equals?: InputMaybe<Scalars['Boolean']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  not_equals?: InputMaybe<Scalars['Boolean']>;
};

export enum VersionsService_Header__Type_Input {
  Default = 'default',
  FeaturedForm = 'featuredForm',
  FeaturedImage = 'featuredImage'
}

export type VersionsService_Header__Type_Operator = {
  all?: InputMaybe<Array<InputMaybe<VersionsService_Header__Type_Input>>>;
  equals?: InputMaybe<VersionsService_Header__Type_Input>;
  in?: InputMaybe<Array<InputMaybe<VersionsService_Header__Type_Input>>>;
  not_equals?: InputMaybe<VersionsService_Header__Type_Input>;
  not_in?: InputMaybe<Array<InputMaybe<VersionsService_Header__Type_Input>>>;
};

export type VersionsService_Id_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type VersionsService_Latest_Operator = {
  equals?: InputMaybe<Scalars['Boolean']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  not_equals?: InputMaybe<Scalars['Boolean']>;
};

export type VersionsService_Parent_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  equals?: InputMaybe<Scalars['JSON']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  not_equals?: InputMaybe<Scalars['JSON']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type VersionsService_UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export enum VersionsService_Version___Status_Input {
  Draft = 'draft',
  Published = 'published'
}

export type VersionsService_Version___Status_Operator = {
  all?: InputMaybe<Array<InputMaybe<VersionsService_Version___Status_Input>>>;
  equals?: InputMaybe<VersionsService_Version___Status_Input>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<VersionsService_Version___Status_Input>>>;
  not_equals?: InputMaybe<VersionsService_Version___Status_Input>;
  not_in?: InputMaybe<Array<InputMaybe<VersionsService_Version___Status_Input>>>;
};

export type VersionsService_Version__CreatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type VersionsService_Version__Description_Operator = {
  contains?: InputMaybe<Scalars['JSON']>;
  equals?: InputMaybe<Scalars['JSON']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  like?: InputMaybe<Scalars['JSON']>;
  not_equals?: InputMaybe<Scalars['JSON']>;
};

export type VersionsService_Version__Excerpt_Operator = {
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
};

export type VersionsService_Version__FeaturedImage_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  equals?: InputMaybe<Scalars['JSON']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  not_equals?: InputMaybe<Scalars['JSON']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type VersionsService_Version__IsPlaceholder_Operator = {
  equals?: InputMaybe<Scalars['Boolean']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  not_equals?: InputMaybe<Scalars['Boolean']>;
};

export type VersionsService_Version__Meta__Description_Operator = {
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
};

export type VersionsService_Version__Meta__Image_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  equals?: InputMaybe<Scalars['JSON']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
  not_equals?: InputMaybe<Scalars['JSON']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['JSON']>>>;
};

export type VersionsService_Version__Meta__NoIndex_Operator = {
  equals?: InputMaybe<Scalars['Boolean']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  not_equals?: InputMaybe<Scalars['Boolean']>;
};

export type VersionsService_Version__Meta__Title_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type VersionsService_Version__ShortTitle_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type VersionsService_Version__ShowGetAQuoteSideDrawer_Operator = {
  equals?: InputMaybe<Scalars['Boolean']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  not_equals?: InputMaybe<Scalars['Boolean']>;
};

export type VersionsService_Version__Slug_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type VersionsService_Version__TitleSettings__BoldEndIndex_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type VersionsService_Version__TitleSettings__BoldStartIndex_Operator = {
  equals?: InputMaybe<Scalars['Float']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['Float']>;
  greater_than_equal?: InputMaybe<Scalars['Float']>;
  less_than?: InputMaybe<Scalars['Float']>;
  less_than_equal?: InputMaybe<Scalars['Float']>;
  not_equals?: InputMaybe<Scalars['Float']>;
};

export type VersionsService_Version__Title_Operator = {
  all?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  contains?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  like?: InputMaybe<Scalars['String']>;
  not_equals?: InputMaybe<Scalars['String']>;
  not_in?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type VersionsService_Version__UpdatedAt_Operator = {
  equals?: InputMaybe<Scalars['DateTime']>;
  exists?: InputMaybe<Scalars['Boolean']>;
  greater_than?: InputMaybe<Scalars['DateTime']>;
  greater_than_equal?: InputMaybe<Scalars['DateTime']>;
  less_than?: InputMaybe<Scalars['DateTime']>;
  less_than_equal?: InputMaybe<Scalars['DateTime']>;
  like?: InputMaybe<Scalars['DateTime']>;
  not_equals?: InputMaybe<Scalars['DateTime']>;
};

export type VersionsService_Where = {
  AND?: InputMaybe<Array<InputMaybe<VersionsService_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<VersionsService_Where_Or>>>;
  createdAt?: InputMaybe<VersionsService_CreatedAt_Operator>;
  header__beforeFeaturedFormContent?: InputMaybe<VersionsService_Header__BeforeFeaturedFormContent_Operator>;
  header__featuredForm?: InputMaybe<VersionsService_Header__FeaturedForm_Operator>;
  header__image?: InputMaybe<VersionsService_Header__Image_Operator>;
  header__showLookingForForm?: InputMaybe<VersionsService_Header__ShowLookingForForm_Operator>;
  header__showRatingWidget?: InputMaybe<VersionsService_Header__ShowRatingWidget_Operator>;
  header__type?: InputMaybe<VersionsService_Header__Type_Operator>;
  id?: InputMaybe<VersionsService_Id_Operator>;
  latest?: InputMaybe<VersionsService_Latest_Operator>;
  parent?: InputMaybe<VersionsService_Parent_Operator>;
  updatedAt?: InputMaybe<VersionsService_UpdatedAt_Operator>;
  version___status?: InputMaybe<VersionsService_Version___Status_Operator>;
  version__createdAt?: InputMaybe<VersionsService_Version__CreatedAt_Operator>;
  version__description?: InputMaybe<VersionsService_Version__Description_Operator>;
  version__excerpt?: InputMaybe<VersionsService_Version__Excerpt_Operator>;
  version__featuredImage?: InputMaybe<VersionsService_Version__FeaturedImage_Operator>;
  version__isPlaceholder?: InputMaybe<VersionsService_Version__IsPlaceholder_Operator>;
  version__meta__description?: InputMaybe<VersionsService_Version__Meta__Description_Operator>;
  version__meta__image?: InputMaybe<VersionsService_Version__Meta__Image_Operator>;
  version__meta__noIndex?: InputMaybe<VersionsService_Version__Meta__NoIndex_Operator>;
  version__meta__title?: InputMaybe<VersionsService_Version__Meta__Title_Operator>;
  version__shortTitle?: InputMaybe<VersionsService_Version__ShortTitle_Operator>;
  version__showGetAQuoteSideDrawer?: InputMaybe<VersionsService_Version__ShowGetAQuoteSideDrawer_Operator>;
  version__slug?: InputMaybe<VersionsService_Version__Slug_Operator>;
  version__title?: InputMaybe<VersionsService_Version__Title_Operator>;
  version__titleSettings__boldEndIndex?: InputMaybe<VersionsService_Version__TitleSettings__BoldEndIndex_Operator>;
  version__titleSettings__boldStartIndex?: InputMaybe<VersionsService_Version__TitleSettings__BoldStartIndex_Operator>;
  version__updatedAt?: InputMaybe<VersionsService_Version__UpdatedAt_Operator>;
};

export type VersionsService_Where_And = {
  AND?: InputMaybe<Array<InputMaybe<VersionsService_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<VersionsService_Where_Or>>>;
  createdAt?: InputMaybe<VersionsService_CreatedAt_Operator>;
  header__beforeFeaturedFormContent?: InputMaybe<VersionsService_Header__BeforeFeaturedFormContent_Operator>;
  header__featuredForm?: InputMaybe<VersionsService_Header__FeaturedForm_Operator>;
  header__image?: InputMaybe<VersionsService_Header__Image_Operator>;
  header__showLookingForForm?: InputMaybe<VersionsService_Header__ShowLookingForForm_Operator>;
  header__showRatingWidget?: InputMaybe<VersionsService_Header__ShowRatingWidget_Operator>;
  header__type?: InputMaybe<VersionsService_Header__Type_Operator>;
  id?: InputMaybe<VersionsService_Id_Operator>;
  latest?: InputMaybe<VersionsService_Latest_Operator>;
  parent?: InputMaybe<VersionsService_Parent_Operator>;
  updatedAt?: InputMaybe<VersionsService_UpdatedAt_Operator>;
  version___status?: InputMaybe<VersionsService_Version___Status_Operator>;
  version__createdAt?: InputMaybe<VersionsService_Version__CreatedAt_Operator>;
  version__description?: InputMaybe<VersionsService_Version__Description_Operator>;
  version__excerpt?: InputMaybe<VersionsService_Version__Excerpt_Operator>;
  version__featuredImage?: InputMaybe<VersionsService_Version__FeaturedImage_Operator>;
  version__isPlaceholder?: InputMaybe<VersionsService_Version__IsPlaceholder_Operator>;
  version__meta__description?: InputMaybe<VersionsService_Version__Meta__Description_Operator>;
  version__meta__image?: InputMaybe<VersionsService_Version__Meta__Image_Operator>;
  version__meta__noIndex?: InputMaybe<VersionsService_Version__Meta__NoIndex_Operator>;
  version__meta__title?: InputMaybe<VersionsService_Version__Meta__Title_Operator>;
  version__shortTitle?: InputMaybe<VersionsService_Version__ShortTitle_Operator>;
  version__showGetAQuoteSideDrawer?: InputMaybe<VersionsService_Version__ShowGetAQuoteSideDrawer_Operator>;
  version__slug?: InputMaybe<VersionsService_Version__Slug_Operator>;
  version__title?: InputMaybe<VersionsService_Version__Title_Operator>;
  version__titleSettings__boldEndIndex?: InputMaybe<VersionsService_Version__TitleSettings__BoldEndIndex_Operator>;
  version__titleSettings__boldStartIndex?: InputMaybe<VersionsService_Version__TitleSettings__BoldStartIndex_Operator>;
  version__updatedAt?: InputMaybe<VersionsService_Version__UpdatedAt_Operator>;
};

export type VersionsService_Where_Or = {
  AND?: InputMaybe<Array<InputMaybe<VersionsService_Where_And>>>;
  OR?: InputMaybe<Array<InputMaybe<VersionsService_Where_Or>>>;
  createdAt?: InputMaybe<VersionsService_CreatedAt_Operator>;
  header__beforeFeaturedFormContent?: InputMaybe<VersionsService_Header__BeforeFeaturedFormContent_Operator>;
  header__featuredForm?: InputMaybe<VersionsService_Header__FeaturedForm_Operator>;
  header__image?: InputMaybe<VersionsService_Header__Image_Operator>;
  header__showLookingForForm?: InputMaybe<VersionsService_Header__ShowLookingForForm_Operator>;
  header__showRatingWidget?: InputMaybe<VersionsService_Header__ShowRatingWidget_Operator>;
  header__type?: InputMaybe<VersionsService_Header__Type_Operator>;
  id?: InputMaybe<VersionsService_Id_Operator>;
  latest?: InputMaybe<VersionsService_Latest_Operator>;
  parent?: InputMaybe<VersionsService_Parent_Operator>;
  updatedAt?: InputMaybe<VersionsService_UpdatedAt_Operator>;
  version___status?: InputMaybe<VersionsService_Version___Status_Operator>;
  version__createdAt?: InputMaybe<VersionsService_Version__CreatedAt_Operator>;
  version__description?: InputMaybe<VersionsService_Version__Description_Operator>;
  version__excerpt?: InputMaybe<VersionsService_Version__Excerpt_Operator>;
  version__featuredImage?: InputMaybe<VersionsService_Version__FeaturedImage_Operator>;
  version__isPlaceholder?: InputMaybe<VersionsService_Version__IsPlaceholder_Operator>;
  version__meta__description?: InputMaybe<VersionsService_Version__Meta__Description_Operator>;
  version__meta__image?: InputMaybe<VersionsService_Version__Meta__Image_Operator>;
  version__meta__noIndex?: InputMaybe<VersionsService_Version__Meta__NoIndex_Operator>;
  version__meta__title?: InputMaybe<VersionsService_Version__Meta__Title_Operator>;
  version__shortTitle?: InputMaybe<VersionsService_Version__ShortTitle_Operator>;
  version__showGetAQuoteSideDrawer?: InputMaybe<VersionsService_Version__ShowGetAQuoteSideDrawer_Operator>;
  version__slug?: InputMaybe<VersionsService_Version__Slug_Operator>;
  version__title?: InputMaybe<VersionsService_Version__Title_Operator>;
  version__titleSettings__boldEndIndex?: InputMaybe<VersionsService_Version__TitleSettings__BoldEndIndex_Operator>;
  version__titleSettings__boldStartIndex?: InputMaybe<VersionsService_Version__TitleSettings__BoldStartIndex_Operator>;
  version__updatedAt?: InputMaybe<VersionsService_Version__UpdatedAt_Operator>;
};

export type VersionsServices = {
  __typename?: 'versionsServices';
  docs?: Maybe<Array<Maybe<ServiceVersion>>>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPrevPage?: Maybe<Scalars['Boolean']>;
  limit?: Maybe<Scalars['Int']>;
  nextPage?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  page?: Maybe<Scalars['Int']>;
  pagingCounter?: Maybe<Scalars['Int']>;
  prevPage?: Maybe<Scalars['Int']>;
  totalDocs?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
};
